import * as React from 'react';
import React__default, { useReducer, useRef, useEffect, useCallback, createContext, useContext, useState, forwardRef, Children, useMemo, useLayoutEffect as useLayoutEffect$1, useImperativeHandle, Component, Fragment as Fragment$1 } from 'react';
import PropTypes from 'prop-types';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { flushSync, createPortal } from 'react-dom';
import { jsx as jsx$1, jsxs, Fragment } from 'react/jsx-runtime';
import { Button as Button$1, Tooltip as Tooltip$1, Overlay as Overlay$1, Container, Row, Col, Collapse, Accordion as Accordion$1, Alert, Modal as Modal$1, Spinner, Card, Carousel as Carousel$1, Form, InputGroup, ButtonGroup, ToggleButton, Toast, CloseButton, ListGroup, ProgressBar, Table, Breadcrumb, OverlayTrigger } from 'react-bootstrap';
import styled, { css as css$3 } from 'styled-components';
import i18next from 'i18next';
import axios from 'axios';
import { useSelector, useDispatch, useStore, connect } from 'react-redux';
import { useLocation, useNavigate, Routes, Route } from 'react-router-dom';
import Sticky from 'react-sticky-el';

function _extends$G() {
  return _extends$G = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$G.apply(null, arguments);
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty$3(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function _objectWithoutPropertiesLoose$1(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties$1(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

var lodash_debounce;
var hasRequiredLodash_debounce;

function requireLodash_debounce () {
	if (hasRequiredLodash_debounce) return lodash_debounce;
	hasRequiredLodash_debounce = 1;
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};

	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;

	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }

	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;

	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }

	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }

	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;

	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }

	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;

	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }

	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }

	  function trailingEdge(time) {
	    timerId = undefined;

	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }

	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }

	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }

	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);

	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;

	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}

	lodash_debounce = debounce;
	return lodash_debounce;
}

var lodash_debounceExports = requireLodash_debounce();
var debounce$1 = /*@__PURE__*/getDefaultExportFromCjs(lodash_debounceExports);

/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */
function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are strictly equal to the last state value
  const [, dispatch] = useReducer(state => !state, false);
  return dispatch;
}

/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */
function usePrevious(value) {
  const ref = useRef(null);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

var ALIGN_VALUES = ['justify', 'left', 'right'];
var DEFAULT_LABELKEY = 'label';
var SIZES = ['lg', 'sm'];

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var invariant_1;
var hasRequiredInvariant;

function requireInvariant () {
	if (hasRequiredInvariant) return invariant_1;
	hasRequiredInvariant = 1;

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var NODE_ENV = process.env.NODE_ENV;

	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};

	invariant_1 = invariant;
	return invariant_1;
}

var invariantExports = requireInvariant();
var invariant = /*@__PURE__*/getDefaultExportFromCjs(invariantExports);

function getStringLabelKey(labelKey) {
  return typeof labelKey === 'string' ? labelKey : DEFAULT_LABELKEY;
}

/**
 * Check if an object has the given property in a type-safe way.
 */
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var idCounter = 0;

// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(value) {
  return typeof value === 'function';
}
function isString(value) {
  return typeof value === 'string';
}
function noop$4() {}
function pick(obj, keys) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var result = {};
  keys.forEach(function (key) {
    result[key] = obj[key];
  });
  return result;
}
function uniqueId(prefix) {
  idCounter += 1;
  return (String(prefix)) + idCounter;
}

/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */
function getOptionLabel$2(option, labelKey) {
  // Handle internally created options first.
  if (!isString(option) && (hasOwnProperty(option, 'paginationOption') || hasOwnProperty(option, 'customOption'))) {
    return option[getStringLabelKey(labelKey)];
  }
  var optionLabel;
  if (isFunction(labelKey)) {
    optionLabel = labelKey(option);
  } else if (isString(option)) {
    optionLabel = option;
  } else {
    // `option` is an object and `labelKey` is a string.
    optionLabel = option[labelKey];
  }
  !isString(optionLabel) ? process.env.NODE_ENV !== "production" ? invariant(false, 'One or more options does not have a valid label string. Check the ' + '`labelKey` prop to ensure that it matches the correct option key and ' + 'provides a string for filtering and display.') : invariant(false) : void 0;
  return optionLabel;
}

function addCustomOption(results, props) {
  var allowNew = props.allowNew,
    labelKey = props.labelKey,
    text = props.text;
  if (!allowNew || !text.trim()) {
    return false;
  }

  // If the consumer has provided a callback, use that to determine whether or
  // not to add the custom option.
  if (isFunction(allowNew)) {
    return allowNew(results, props);
  }

  // By default, don't add the custom option if there is an exact text match
  // with an existing option.
  return !results.some(function (o) {
    return getOptionLabel$2(o, labelKey) === text;
  });
}

var fastDeepEqual;
var hasRequiredFastDeepEqual;

function requireFastDeepEqual () {
	if (hasRequiredFastDeepEqual) return fastDeepEqual;
	hasRequiredFastDeepEqual = 1;

	// do not edit .js files directly - edit src/index.jst



	fastDeepEqual = function equal(a, b) {
	  if (a === b) return true;

	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;

	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }



	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;

	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

	    for (i = length; i-- !== 0;) {
	      var key = keys[i];

	      if (!equal(a[key], b[key])) return false;
	    }

	    return true;
	  }

	  // true if both NaN, false otherwise
	  return a!==a && b!==b;
	};
	return fastDeepEqual;
}

var fastDeepEqualExports = requireFastDeepEqual();
var isEqual$3 = /*@__PURE__*/getDefaultExportFromCjs(fastDeepEqualExports);

function getOptionProperty(option, key) {
  if (isString(option)) {
    return undefined;
  }
  return option[key];
}

// prettier-ignore

var map = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'OE',
  letters: "\x8C\u0152"
}, {
  base: 'oe',
  letters: "\x9C\u0153"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}].reduce(function (acc, _ref) {
  var base = _ref.base,
    letters = _ref.letters;
  letters.split('').forEach(function (letter) {
    acc[letter] = base;
  });
  return acc;
}, {});

// Combining marks
var latin = "\u0300-\u036F";
var japanese = "\u3099\u309A";
function stripDiacritics$1(str) {
  return str.normalize('NFD')
  // Remove combining diacritics
  .replace(new RegExp("[".concat(latin).concat(japanese, "]"), 'g'), '')
  /* eslint-disable-next-line no-control-regex */.replace(/[^\u0000-\u007E]/g, function (a) {
    return map[a] || a;
  });
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var warning_1;
var hasRequiredWarning;

function requireWarning () {
	if (hasRequiredWarning) return warning_1;
	hasRequiredWarning = 1;

	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */

	var __DEV__ = process.env.NODE_ENV !== 'production';

	var warning = function() {};

	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };

	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}

	warning_1 = warning;
	return warning_1;
}

var warningExports = requireWarning();
var warning$2 = /*@__PURE__*/getDefaultExportFromCjs(warningExports);

var warned$1 = {};

/**
 * Copied from: https://github.com/ReactTraining/react-router/blob/master/modules/routerWarning.js
 */
function warn(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (!falseToWarn && message.indexOf('deprecated') !== -1) {
    if (warned$1[message]) {
      return;
    }
    warned$1[message] = true;
  }
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  warning$2.apply(void 0, [falseToWarn, "[react-bootstrap-typeahead] ".concat(message)].concat(args));
}

function isMatch(input, string, props) {
  var searchStr = input;
  var str = string;
  if (!props.caseSensitive) {
    searchStr = searchStr.toLowerCase();
    str = str.toLowerCase();
  }
  if (props.ignoreDiacritics) {
    searchStr = stripDiacritics$1(searchStr);
    str = stripDiacritics$1(str);
  }
  return str.indexOf(searchStr) !== -1;
}

/**
 * Default algorithm for filtering results.
 */
function defaultFilterBy(option, props) {
  var filterBy = props.filterBy,
    labelKey = props.labelKey,
    multiple = props.multiple,
    selected = props.selected,
    text = props.text;

  // Don't show selected options in the menu for the multi-select case.
  if (multiple && selected.some(function (o) {
    return isEqual$3(o, option);
  })) {
    return false;
  }
  if (isFunction(labelKey)) {
    return isMatch(text, labelKey(option), props);
  }
  var fields = filterBy.slice();
  if (isString(labelKey)) {
    // Add the `labelKey` field to the list of fields if it isn't already there.
    if (fields.indexOf(labelKey) === -1) {
      fields.unshift(labelKey);
    }
  }
  if (isString(option)) {
    warn(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');
    return isMatch(text, option, props);
  }
  return fields.some(function (field) {
    var value = getOptionProperty(option, field);
    if (!isString(value)) {
      warn(false, 'Fields passed to `filterBy` should have string values. Value will ' + 'be converted to a string; results may be unexpected.');
      value = String(value);
    }
    return isMatch(text, value, props);
  });
}

/**
 * Check if an input type is selectable, based on WHATWG spec.
 *
 * See:
 *  - https://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome/24175357
 *  - https://html.spec.whatwg.org/multipage/input.html#do-not-apply
 */
function isSelectable(inputNode) {
  return inputNode.selectionStart != null;
}

function defaultSelectHint(e, selectHint) {
  var shouldSelectHint = false;
  if (e.key === 'ArrowRight') {
    // For selectable input types ("text", "search"), only select the hint if
    // it's at the end of the input value. For non-selectable types ("email",
    // "number"), always select the hint.
    shouldSelectHint = isSelectable(e.currentTarget) ? e.currentTarget.selectionStart === e.currentTarget.value.length : true;
  }
  if (e.key === 'Tab') {
    // Prevent input from blurring on TAB.
    e.preventDefault();
    shouldSelectHint = true;
  }
  return selectHint ? selectHint(shouldSelectHint, e) : shouldSelectHint;
}

var CASE_INSENSITIVE = 'i';
var COMBINING_MARKS = /[\u0300-\u036F]/;
// Export for testing.
function escapeStringRegexp(str) {
  !(typeof str === 'string') ? process.env.NODE_ENV !== "production" ? invariant(false, '`escapeStringRegexp` expected a string.') : invariant(false) : void 0;

  // Escape characters with special meaning either inside or outside character
  // sets. Use a simple backslash escape when it’s always valid, and a \unnnn
  // escape when the simpler form would be disallowed by Unicode patterns’
  // stricter grammar.
  return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
function getMatchBounds(subject, str) {
  var search = new RegExp(escapeStringRegexp(stripDiacritics$1(str)), CASE_INSENSITIVE);
  var matches = search.exec(stripDiacritics$1(subject));
  if (!matches) {
    return null;
  }
  var start = matches.index;
  var matchLength = matches[0].length;

  // Account for combining marks, which changes the indices.
  if (COMBINING_MARKS.test(subject)) {
    // Starting at the beginning of the subject string, check for the number of
    // combining marks and increment the start index whenever one is found.
    for (var ii = 0; ii <= start; ii++) {
      if (COMBINING_MARKS.test(subject[ii])) {
        start += 1;
      }
    }

    // Similarly, increment the length of the match string if it contains a
    // combining mark.
    for (var _ii = start; _ii <= start + matchLength; _ii++) {
      if (COMBINING_MARKS.test(subject[_ii])) {
        matchLength += 1;
      }
    }
  }
  return {
    end: start + matchLength,
    start: start
  };
}

function getHintText(_ref) {
  var activeIndex = _ref.activeIndex,
    initialItem = _ref.initialItem,
    isFocused = _ref.isFocused,
    isMenuShown = _ref.isMenuShown,
    labelKey = _ref.labelKey,
    multiple = _ref.multiple,
    selected = _ref.selected,
    text = _ref.text;
  // Don't display a hint under the following conditions:
  if (
  // No text entered.
  !text ||
  // The input is not focused.
  !isFocused ||
  // The menu is hidden.
  !isMenuShown ||
  // No item in the menu.
  !initialItem ||
  // The initial item is a custom option.
  !isString(initialItem) && hasOwnProperty(initialItem, 'customOption') ||
  // One of the menu items is active.
  activeIndex > -1 ||
  // There's already a selection in single-select mode.
  !!selected.length && !multiple) {
    return '';
  }
  var initialItemStr = getOptionLabel$2(initialItem, labelKey);
  var bounds = getMatchBounds(initialItemStr.toLowerCase(), text.toLowerCase());
  if (!(bounds && bounds.start === 0)) {
    return '';
  }

  // Text matching is case- and accent-insensitive, so to display the hint
  // correctly, splice the input string with the hint string.
  return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

var hasRequiredClassnames;

function requireClassnames () {
	if (hasRequiredClassnames) return classnames.exports;
	hasRequiredClassnames = 1;
	(function (module) {
		/* global define */

		(function () {

			var hasOwn = {}.hasOwnProperty;

			function classNames () {
				var classes = '';

				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (arg) {
						classes = appendClass(classes, parseValue(arg));
					}
				}

				return classes;
			}

			function parseValue (arg) {
				if (typeof arg === 'string' || typeof arg === 'number') {
					return arg;
				}

				if (typeof arg !== 'object') {
					return '';
				}

				if (Array.isArray(arg)) {
					return classNames.apply(null, arg);
				}

				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					return arg.toString();
				}

				var classes = '';

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes = appendClass(classes, key);
					}
				}

				return classes;
			}

			function appendClass (value, newClass) {
				if (!newClass) {
					return value;
				}
			
				if (value) {
					return value + ' ' + newClass;
				}
			
				return value + newClass;
			}

			if (module.exports) {
				classNames.default = classNames;
				module.exports = classNames;
			} else {
				window.classNames = classNames;
			}
		}()); 
	} (classnames));
	return classnames.exports;
}

var classnamesExports = requireClassnames();
var cls = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

function getMenuItemId() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var position = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(id, "-item-").concat(position);
}

var _excluded$m = ["activeIndex", "id", "isFocused", "isMenuShown", "multiple", "onClick", "onFocus", "placeholder"];
function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getInputProps = function getInputProps(_ref) {
  var activeIndex = _ref.activeIndex,
    id = _ref.id,
    isFocused = _ref.isFocused,
    isMenuShown = _ref.isMenuShown,
    multiple = _ref.multiple,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    placeholder = _ref.placeholder,
    props = _objectWithoutProperties$1(_ref, _excluded$m);
  return function () {
    var _cx;
    var inputProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var className = hasOwnProperty(inputProps, 'className') ? String(inputProps.className) : undefined;
    return _objectSpread$d(_objectSpread$d(_objectSpread$d(_objectSpread$d({
      // These props can be overridden by values in `inputProps`.
      autoComplete: 'off',
      placeholder: placeholder,
      type: 'text'
    }, inputProps), props), {}, {
      'aria-activedescendant': activeIndex >= 0 ? getMenuItemId(id, activeIndex) : undefined,
      'aria-autocomplete': 'both',
      'aria-expanded': isMenuShown,
      'aria-haspopup': 'listbox',
      'aria-multiselectable': multiple || undefined,
      'aria-owns': isMenuShown ? id : undefined,
      className: cls((_cx = {}, _defineProperty$3(_cx, className || '', !multiple), _defineProperty$3(_cx, "focus", isFocused), _cx))
    }, multiple && {
      inputClassName: className
    }), {}, {
      onClick: onClick,
      onFocus: onFocus,
      role: 'combobox'
    });
  };
};

function getInputText(props) {
  var activeItem = props.activeItem,
    labelKey = props.labelKey,
    multiple = props.multiple,
    selected = props.selected,
    text = props.text;
  if (activeItem) {
    // Display the input value if the pagination item is active.
    return getOptionLabel$2(activeItem, labelKey);
  }
  if (!multiple && selected.length && selected[0]) {
    return getOptionLabel$2(selected[0], labelKey);
  }
  return text;
}

function getIsOnlyResult(props) {
  var allowNew = props.allowNew,
    highlightOnlyResult = props.highlightOnlyResult,
    results = props.results;
  if (!highlightOnlyResult || allowNew) {
    return false;
  }
  return results.length === 1 && !getOptionProperty(results[0], 'disabled');
}

/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }
  return options.slice(0, maxResults);
}

function isDisabledOption(index, items) {
  var option = items[index];
  return !!option && !!getOptionProperty(option, 'disabled');
}
function skipDisabledOptions(currentIndex, key, items) {
  var newIndex = currentIndex;
  while (isDisabledOption(newIndex, items)) {
    newIndex += key === 'ArrowUp' ? -1 : 1;
  }
  return newIndex;
}
function getUpdatedActiveIndex(currentIndex, key, items) {
  var newIndex = currentIndex;

  // Increment or decrement index based on user keystroke.
  newIndex += key === 'ArrowUp' ? -1 : 1;

  // Skip over any disabled options.
  newIndex = skipDisabledOptions(newIndex, key, items);

  // If we've reached the end, go back to the beginning or vice-versa.
  if (newIndex === items.length) {
    newIndex = -1;
  } else if (newIndex === -2) {
    newIndex = items.length - 1;

    // Skip over any disabled options.
    newIndex = skipDisabledOptions(newIndex, key, items);
  }
  return newIndex;
}

function isShown(_ref) {
  var open = _ref.open,
    minLength = _ref.minLength,
    showMenu = _ref.showMenu,
    text = _ref.text;
  // If menu visibility is controlled via props, that value takes precedence.
  if (open || open === false) {
    return open;
  }
  if (text.length < minLength) {
    return false;
  }
  return showMenu;
}

/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */
function preventInputBlur(e) {
  e.preventDefault();
}

function isSizeLarge(size) {
  return size === 'lg';
}
function isSizeSmall(size) {
  return size === 'sm';
}

var _excluded$l = ["className", "isInvalid", "isValid", "size"];
function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Returns Bootstrap classnames from `size` and validation props, along
 * with pass-through props.
 */
function propsWithBsClassName(_ref) {
  var className = _ref.className,
    isInvalid = _ref.isInvalid,
    isValid = _ref.isValid,
    size = _ref.size,
    props = _objectWithoutProperties$1(_ref, _excluded$l);
  return _objectSpread$c(_objectSpread$c({}, props), {}, {
    className: cls('form-control', 'rbt-input', {
      'form-control-lg': isSizeLarge(size),
      'form-control-sm': isSizeSmall(size),
      'is-invalid': isInvalid,
      'is-valid': isValid
    }, className)
  });
}

function validateSelectedPropChange(prevSelected, selected) {
  var uncontrolledToControlled = !prevSelected && selected;
  var controlledToUncontrolled = prevSelected && !selected;
  var from, to, precedent;
  if (uncontrolledToControlled) {
    from = 'uncontrolled';
    to = 'controlled';
    precedent = 'an';
  } else {
    from = 'controlled';
    to = 'uncontrolled';
    precedent = 'a';
  }
  var message = "You are changing ".concat(precedent, " ").concat(from, " typeahead to be ").concat(to, ". ") + "Input elements should not switch from ".concat(from, " to ").concat(to, " (or vice versa). ") + 'Decide between using a controlled or uncontrolled element for the ' + 'lifetime of the component.';
  warn(!(uncontrolledToControlled || controlledToUncontrolled), message);
}

var INPUT_PROPS_BLACKLIST = [{
  alt: 'onBlur',
  prop: 'onBlur'
}, {
  alt: 'onInputChange',
  prop: 'onChange'
}, {
  alt: 'onFocus',
  prop: 'onFocus'
}, {
  alt: 'onKeyDown',
  prop: 'onKeyDown'
}];
var sizeType = PropTypes.oneOf(SIZES);
/**
 * Allows additional warnings or messaging related to prop validation.
 */
function checkPropType(validator, callback) {
  return function (props, propName, componentName) {
    PropTypes.checkPropTypes(_defineProperty$3({}, propName, validator), props, 'prop', componentName);
    isFunction(callback) && callback(props, propName, componentName);
  };
}
function caseSensitiveType(props) {
  var caseSensitive = props.caseSensitive,
    filterBy = props.filterBy;
  warn(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}
function defaultInputValueType(props) {
  var defaultInputValue = props.defaultInputValue,
    defaultSelected = props.defaultSelected,
    multiple = props.multiple,
    selected = props.selected;
  var name = defaultSelected.length ? 'defaultSelected' : 'selected';
  warn(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), "`defaultInputValue` will be overridden by the value from `".concat(name, "`."));
}
function defaultSelectedType(props) {
  var defaultSelected = props.defaultSelected,
    multiple = props.multiple;
  warn(multiple || defaultSelected.length <= 1, 'You are passing multiple options to the `defaultSelected` prop of a ' + 'Typeahead in single-select mode. The selections will be truncated to a ' + 'single selection.');
}
function highlightOnlyResultType(_ref) {
  var allowNew = _ref.allowNew,
    highlightOnlyResult = _ref.highlightOnlyResult;
  warn(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}
function ignoreDiacriticsType(props) {
  var filterBy = props.filterBy,
    ignoreDiacritics = props.ignoreDiacritics;
  warn(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}
function inputPropsType(_ref2) {
  var inputProps = _ref2.inputProps;
  if (!(inputProps && Object.prototype.toString.call(inputProps) === '[object Object]')) {
    return;
  }

  // Blacklisted properties.
  INPUT_PROPS_BLACKLIST.forEach(function (_ref3) {
    var alt = _ref3.alt,
      prop = _ref3.prop;
    var msg = alt ? " Use the top-level `".concat(alt, "` prop instead.") : null;
    warn(!inputProps[prop], "The `".concat(prop, "` property of `inputProps` will be ignored.").concat(msg));
  });
}
function isRequiredForA11y(props, propName, componentName) {
  warn(props[propName] != null, "The prop `".concat(propName, "` is required to make `").concat(componentName, "` ") + 'accessible for users of assistive technologies such as screen readers.');
}
function labelKeyType(_ref4) {
  var allowNew = _ref4.allowNew,
    labelKey = _ref4.labelKey;
  warn(!(isFunction(labelKey) && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}
var optionType = PropTypes.oneOfType([PropTypes.object, PropTypes.string]);
function selectedType(_ref5) {
  var multiple = _ref5.multiple,
    onChange = _ref5.onChange,
    selected = _ref5.selected;
  warn(multiple || !selected || selected.length <= 1, 'You are passing multiple options to the `selected` prop of a Typeahead ' + 'in single-select mode. This may lead to unexpected behaviors or errors.');
  warn(!selected || selected && isFunction(onChange), 'You provided a `selected` prop without an `onChange` handler. If you ' + 'want the typeahead to be uncontrolled, use `defaultSelected`. ' + 'Otherwise, set `onChange`.');
}

var _excluded$k = ["allowNew", "delay", "emptyLabel", "isLoading", "minLength", "onInputChange", "onSearch", "options", "promptText", "searchText", "useCache"];
function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
({
  /**
   * Delay, in milliseconds, before performing search.
   */
  delay: PropTypes.number,
  /**
   * Whether or not a request is currently pending. Necessary for the
   * container to know when new results are available.
   */
  isLoading: PropTypes.bool.isRequired,
  /**
   * Number of input characters that must be entered before showing results.
   */
  minLength: PropTypes.number,
  /**
   * Callback to perform when the search is executed.
   */
  onSearch: PropTypes.func.isRequired,
  /**
   * Options to be passed to the typeahead. Will typically be the query
   * results, but can also be initial default options.
   */
  options: PropTypes.arrayOf(optionType),
  /**
   * Message displayed in the menu when there is no user input.
   */
  promptText: PropTypes.node,
  /**
   * Message displayed in the menu while the request is pending.
   */
  searchText: PropTypes.node,
  /**
   * Whether or not the component should cache query results.
   */
  useCache: PropTypes.bool
});
/**
 * Logic that encapsulates common behavior and functionality around
 * asynchronous searches, including:
 *
 *  - Debouncing user input
 *  - Optional query caching
 *  - Search prompt and empty results behaviors
 */
function useAsync(props) {
  var allowNew = props.allowNew,
    _props$delay = props.delay,
    delay = _props$delay === void 0 ? 200 : _props$delay,
    emptyLabel = props.emptyLabel,
    isLoading = props.isLoading,
    _props$minLength = props.minLength,
    minLength = _props$minLength === void 0 ? 2 : _props$minLength,
    onInputChange = props.onInputChange,
    onSearch = props.onSearch,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    _props$promptText = props.promptText,
    promptText = _props$promptText === void 0 ? 'Type to search...' : _props$promptText,
    _props$searchText = props.searchText,
    searchText = _props$searchText === void 0 ? 'Searching...' : _props$searchText,
    _props$useCache = props.useCache,
    useCache = _props$useCache === void 0 ? true : _props$useCache,
    otherProps = _objectWithoutProperties$1(props, _excluded$k);
  var cacheRef = useRef({});
  var handleSearchDebouncedRef = useRef(null);
  var queryRef = useRef(props.defaultInputValue || '');
  var forceUpdate = useForceUpdate();
  var prevProps = usePrevious(props);
  var handleSearch = useCallback(function (query) {
    queryRef.current = query;
    if (!query || minLength && query.length < minLength) {
      return;
    }

    // Use cached results, if applicable.
    if (useCache && cacheRef.current[query]) {
      // Re-render the component with the cached results.
      forceUpdate();
      return;
    }

    // Perform the search.
    onSearch(query);
  }, [forceUpdate, minLength, onSearch, useCache]);

  // Set the debounced search function.
  useEffect(function () {
    handleSearchDebouncedRef.current = debounce$1(handleSearch, delay);
    return function () {
      handleSearchDebouncedRef.current && handleSearchDebouncedRef.current.cancel();
    };
  }, [delay, handleSearch]);
  useEffect(function () {
    // Ensure that we've gone from a loading to a completed state. Otherwise
    // an empty response could get cached if the component updates during the
    // request (eg: if the parent re-renders for some reason).
    if (!isLoading && prevProps && prevProps.isLoading && useCache) {
      cacheRef.current[queryRef.current] = options;
    }
  });
  var getEmptyLabel = function getEmptyLabel() {
    if (!queryRef.current.length) {
      return promptText;
    }
    if (isLoading) {
      return searchText;
    }
    return emptyLabel;
  };
  var handleInputChange = useCallback(function (query, e) {
    onInputChange && onInputChange(query, e);
    handleSearchDebouncedRef.current && handleSearchDebouncedRef.current(query);
  }, [onInputChange]);
  var cachedQuery = cacheRef.current[queryRef.current];
  return _objectSpread$b(_objectSpread$b({}, otherProps), {}, {
    // Disable custom selections during a search if `allowNew` isn't a function.
    allowNew: isFunction(allowNew) ? allowNew : allowNew && !isLoading,
    emptyLabel: getEmptyLabel(),
    isLoading: isLoading,
    minLength: minLength,
    onInputChange: handleInputChange,
    options: useCache && cachedQuery ? cachedQuery : options
  });
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

var defaultContext = {
  activeIndex: -1,
  hintText: '',
  id: '',
  initialItem: null,
  inputNode: null,
  isOnlyResult: false,
  onActiveItemChange: noop$4,
  onAdd: noop$4,
  onInitialItemChange: noop$4,
  onMenuItemClick: noop$4,
  setItem: noop$4
};
var TypeaheadContext = /*#__PURE__*/createContext(defaultContext);
var useTypeaheadContext = function useTypeaheadContext() {
  return useContext(TypeaheadContext);
};

function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var inputPropKeys = ['activeIndex', 'disabled', 'id', 'inputRef', 'isFocused', 'isMenuShown', 'multiple', 'onBlur', 'onChange', 'onClick', 'onFocus', 'onKeyDown', 'placeholder'];
var propKeys = ['activeIndex', 'hideMenu', 'isMenuShown', 'labelKey', 'onClear', 'onHide', 'onRemove', 'results', 'selected', 'text', 'toggleMenu'];
var contextKeys = ['activeIndex', 'id', 'initialItem', 'inputNode', 'onActiveItemChange', 'onAdd', 'onInitialItemChange', 'onMenuItemClick', 'setItem'];
var TypeaheadManager = function TypeaheadManager(props) {
  var allowNew = props.allowNew,
    children = props.children,
    initialItem = props.initialItem,
    isMenuShown = props.isMenuShown,
    onAdd = props.onAdd,
    onInitialItemChange = props.onInitialItemChange,
    onKeyDown = props.onKeyDown,
    onMenuToggle = props.onMenuToggle,
    results = props.results,
    selectHint = props.selectHint;
  var hintText = getHintText(props);
  useEffect(function () {
    // Clear the initial item when there are no results.
    if (!(allowNew || results.length)) {
      onInitialItemChange();
    }
  });
  var isInitialRender = useRef(true);
  useEffect(function () {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    onMenuToggle(isMenuShown);
  }, [isMenuShown, onMenuToggle]);
  var handleKeyDown = function handleKeyDown(e) {
    onKeyDown(e);
    if (!initialItem) {
      return;
    }
    var addOnlyResult = e.key === 'Enter' && getIsOnlyResult(props);
    var shouldSelectHint = hintText && defaultSelectHint(e, selectHint);
    if (addOnlyResult || shouldSelectHint) {
      onAdd(initialItem);
    }
  };
  var childProps = _objectSpread$a(_objectSpread$a({}, pick(props, propKeys)), {}, {
    getInputProps: getInputProps(_objectSpread$a(_objectSpread$a({}, pick(props, inputPropKeys)), {}, {
      onKeyDown: handleKeyDown,
      value: getInputText(props)
    }))
  });
  var contextValue = _objectSpread$a(_objectSpread$a({}, pick(props, contextKeys)), {}, {
    hintText: hintText,
    isOnlyResult: getIsOnlyResult(props)
  });
  return /*#__PURE__*/React__default.createElement(TypeaheadContext.Provider, {
    value: contextValue
  }, isFunction(children) ? children(childProps) : children);
};

function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getInitialState(props) {
  var defaultInputValue = props.defaultInputValue,
    defaultOpen = props.defaultOpen,
    defaultSelected = props.defaultSelected,
    maxResults = props.maxResults,
    multiple = props.multiple;
  var selected = props.selected ? props.selected.slice() : defaultSelected.slice();
  var text = defaultInputValue;
  if (!multiple && selected.length) {
    // Set the text if an initial selection is passed in.
    text = getOptionLabel$2(selected[0], props.labelKey);
    if (selected.length > 1) {
      // Limit to 1 selection in single-select mode.
      selected = selected.slice(0, 1);
    }
  }
  return {
    activeIndex: -1,
    activeItem: undefined,
    initialItem: undefined,
    isFocused: false,
    selected: selected,
    showMenu: defaultOpen,
    shownResults: maxResults,
    text: text
  };
}
function clearTypeahead(state, props) {
  return _objectSpread$9(_objectSpread$9({}, getInitialState(props)), {}, {
    isFocused: state.isFocused,
    selected: [],
    text: ''
  });
}
function clickOrFocusInput(state) {
  return _objectSpread$9(_objectSpread$9({}, state), {}, {
    isFocused: true,
    showMenu: true
  });
}
function hideMenu(state, props) {
  var _getInitialState = getInitialState(props),
    activeIndex = _getInitialState.activeIndex,
    activeItem = _getInitialState.activeItem,
    initialItem = _getInitialState.initialItem,
    shownResults = _getInitialState.shownResults;
  return _objectSpread$9(_objectSpread$9({}, state), {}, {
    activeIndex: activeIndex,
    activeItem: activeItem,
    initialItem: initialItem,
    showMenu: false,
    shownResults: shownResults
  });
}
function toggleMenu(state, props) {
  return state.showMenu ? hideMenu(state, props) : _objectSpread$9(_objectSpread$9({}, state), {}, {
    showMenu: true
  });
}

var _excluded$j = ["onChange"];
function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var propTypes$7 = {
  /**
   * Allows the creation of new selections on the fly. Note that any new items
   * will be added to the list of selections, but not the list of original
   * options unless handled as such by `Typeahead`'s parent.
   *
   * If a function is specified, it will be used to determine whether a custom
   * option should be included. The return value should be true or false.
   */
  allowNew: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  /**
   * Autofocus the input when the component initially mounts.
   */
  autoFocus: PropTypes.bool,
  /**
   * Whether or not filtering should be case-sensitive.
   */
  caseSensitive: checkPropType(PropTypes.bool, caseSensitiveType),
  /**
   * The initial value displayed in the text input.
   */
  defaultInputValue: checkPropType(PropTypes.string, defaultInputValueType),
  /**
   * Whether or not the menu is displayed upon initial render.
   */
  defaultOpen: PropTypes.bool,
  /**
   * Specify any pre-selected options. Use only if you want the component to
   * be uncontrolled.
   */
  defaultSelected: checkPropType(PropTypes.arrayOf(optionType), defaultSelectedType),
  /**
   * Either an array of fields in `option` to search, or a custom filtering
   * callback.
   */
  filterBy: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string.isRequired), PropTypes.func]),
  /**
   * Highlights the menu item if there is only one result and allows selecting
   * that item by hitting enter. Does not work with `allowNew`.
   */
  highlightOnlyResult: checkPropType(PropTypes.bool, highlightOnlyResultType),
  /**
   * An html id attribute, required for assistive technologies such as screen
   * readers.
   */
  id: checkPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), isRequiredForA11y),
  /**
   * Whether the filter should ignore accents and other diacritical marks.
   */
  ignoreDiacritics: checkPropType(PropTypes.bool, ignoreDiacriticsType),
  /**
   * Specify the option key to use for display or a function returning the
   * display string. By default, the selector will use the `label` key.
   */
  labelKey: checkPropType(PropTypes.oneOfType([PropTypes.string, PropTypes.func]), labelKeyType),
  /**
   * Maximum number of results to display by default. Mostly done for
   * performance reasons so as not to render too many DOM nodes in the case of
   * large data sets.
   */
  maxResults: PropTypes.number,
  /**
   * Number of input characters that must be entered before showing results.
   */
  minLength: PropTypes.number,
  /**
   * Whether or not multiple selections are allowed.
   */
  multiple: PropTypes.bool,
  /**
   * Invoked when the input is blurred. Receives an event.
   */
  onBlur: PropTypes.func,
  /**
   * Invoked whenever items are added or removed. Receives an array of the
   * selected options.
   */
  onChange: PropTypes.func,
  /**
   * Invoked when the input is focused. Receives an event.
   */
  onFocus: PropTypes.func,
  /**
   * Invoked when the input value changes. Receives the string value of the
   * input.
   */
  onInputChange: PropTypes.func,
  /**
   * Invoked when a key is pressed. Receives an event.
   */
  onKeyDown: PropTypes.func,
  /**
   * Invoked when menu visibility changes.
   */
  onMenuToggle: PropTypes.func,
  /**
   * Invoked when the pagination menu item is clicked. Receives an event.
   */
  onPaginate: PropTypes.func,
  /**
   * Whether or not the menu should be displayed. `undefined` allows the
   * component to control visibility, while `true` and `false` show and hide
   * the menu, respectively.
   */
  open: PropTypes.bool,
  /**
   * Full set of options, including pre-selected options. Must either be an
   * array of objects (recommended) or strings.
   */
  options: PropTypes.arrayOf(optionType).isRequired,
  /**
   * Give user the ability to display additional results if the number of
   * results exceeds `maxResults`.
   */
  paginate: PropTypes.bool,
  /**
   * The selected option(s) displayed in the input. Use this prop if you want
   * to control the component via its parent.
   */
  selected: checkPropType(PropTypes.arrayOf(optionType), selectedType)
};
var defaultProps$3 = {
  allowNew: false,
  autoFocus: false,
  caseSensitive: false,
  defaultInputValue: '',
  defaultOpen: false,
  defaultSelected: [],
  filterBy: [],
  highlightOnlyResult: false,
  ignoreDiacritics: true,
  labelKey: DEFAULT_LABELKEY,
  maxResults: 100,
  minLength: 0,
  multiple: false,
  onBlur: noop$4,
  onFocus: noop$4,
  onInputChange: noop$4,
  onKeyDown: noop$4,
  onMenuToggle: noop$4,
  onPaginate: noop$4,
  paginate: true
};
/**
 * Manually trigger the input's change event.
 * https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js/46012210#46012210
 */
function triggerInputChange(input, value) {
  var inputValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
  inputValue && inputValue.set && inputValue.set.call(input, value);
  var e = new Event('input', {
    bubbles: true
  });
  input.dispatchEvent(e);
}
var Typeahead = /*#__PURE__*/function (_React$Component) {
  _inherits(Typeahead, _React$Component);
  var _super = _createSuper$2(Typeahead);
  function Typeahead() {
    var _this;
    _classCallCheck(this, Typeahead);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$3(_assertThisInitialized(_this), "state", getInitialState(_this.props));
    _defineProperty$3(_assertThisInitialized(_this), "inputNode", null);
    _defineProperty$3(_assertThisInitialized(_this), "isMenuShown", false);
    // Keeps track of actual items displayed in the menu, after sorting,
    // truncating, grouping, etc.
    _defineProperty$3(_assertThisInitialized(_this), "items", []);
    _defineProperty$3(_assertThisInitialized(_this), "blur", function () {
      _this.inputNode && _this.inputNode.blur();
      _this.hideMenu();
    });
    _defineProperty$3(_assertThisInitialized(_this), "clear", function () {
      _this.setState(clearTypeahead);
    });
    _defineProperty$3(_assertThisInitialized(_this), "focus", function () {
      _this.inputNode && _this.inputNode.focus();
    });
    _defineProperty$3(_assertThisInitialized(_this), "getInput", function () {
      return _this.inputNode;
    });
    _defineProperty$3(_assertThisInitialized(_this), "inputRef", function (inputNode) {
      _this.inputNode = inputNode;
    });
    _defineProperty$3(_assertThisInitialized(_this), "setItem", function (item, position) {
      _this.items[position] = item;
    });
    _defineProperty$3(_assertThisInitialized(_this), "hideMenu", function () {
      _this.setState(hideMenu);
    });
    _defineProperty$3(_assertThisInitialized(_this), "toggleMenu", function () {
      _this.setState(toggleMenu);
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleActiveIndexChange", function (activeIndex) {
      _this.setState(function (state) {
        return {
          activeIndex: activeIndex,
          activeItem: activeIndex >= 0 ? state.activeItem : undefined
        };
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleActiveItemChange", function (activeItem) {
      // Don't update the active item if it hasn't changed.
      if (!isEqual$3(activeItem, _this.state.activeItem)) {
        _this.setState({
          activeItem: activeItem
        });
      }
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleBlur", function (e) {
      e.persist();
      _this.setState({
        isFocused: false
      }, function () {
        return _this.props.onBlur(e);
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleChange", function (selected) {
      _this.props.onChange && _this.props.onChange(selected);
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleClear", function () {
      _this.inputNode && triggerInputChange(_this.inputNode, '');
      _this.setState(clearTypeahead, function () {
        // Change handler is automatically triggered for single selections but
        // not multi-selections.
        if (_this.props.multiple) {
          _this._handleChange([]);
        }
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleClick", function (e) {
      var _this$props$inputProp;
      e.persist();
      var onClick = (_this$props$inputProp = _this.props.inputProps) === null || _this$props$inputProp === void 0 ? void 0 : _this$props$inputProp.onClick;
      _this.setState(clickOrFocusInput, function () {
        return isFunction(onClick) && onClick(e);
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleFocus", function (e) {
      e.persist();
      _this.setState(clickOrFocusInput, function () {
        return _this.props.onFocus(e);
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleInitialItemChange", function (initialItem) {
      // Don't update the initial item if it hasn't changed.
      if (!isEqual$3(initialItem, _this.state.initialItem)) {
        _this.setState({
          initialItem: initialItem
        });
      }
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleInputChange", function (e) {
      e.persist();
      var text = e.currentTarget.value;
      var _this$props = _this.props,
        multiple = _this$props.multiple,
        onInputChange = _this$props.onInputChange;

      // Clear selections when the input value changes in single-select mode.
      var shouldClearSelections = _this.state.selected.length && !multiple;
      _this.setState(function (state, props) {
        var _getInitialState = getInitialState(props),
          activeIndex = _getInitialState.activeIndex,
          activeItem = _getInitialState.activeItem,
          shownResults = _getInitialState.shownResults;
        return {
          activeIndex: activeIndex,
          activeItem: activeItem,
          selected: shouldClearSelections ? [] : state.selected,
          showMenu: true,
          shownResults: shownResults,
          text: text
        };
      }, function () {
        onInputChange(text, e);
        shouldClearSelections && _this._handleChange([]);
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleKeyDown", function (e) {
      var activeItem = _this.state.activeItem;

      // Skip most actions when the menu is hidden.
      if (!_this.isMenuShown) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          _this.setState({
            showMenu: true
          });
        }
        _this.props.onKeyDown(e);
        return;
      }
      switch (e.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          // Prevent input cursor from going to the beginning when pressing up.
          e.preventDefault();
          _this._handleActiveIndexChange(getUpdatedActiveIndex(_this.state.activeIndex, e.key, _this.items));
          break;
        case 'Enter':
          // Prevent form submission while menu is open.
          e.preventDefault();
          activeItem && _this._handleMenuItemSelect(activeItem, e);
          break;
        case 'Escape':
        case 'Tab':
          // ESC simply hides the menu. TAB will blur the input and move focus to
          // the next item; hide the menu so it doesn't gain focus.
          _this.hideMenu();
          break;
      }
      _this.props.onKeyDown(e);
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleMenuItemSelect", function (option, e) {
      if (getOptionProperty(option, 'paginationOption')) {
        _this._handlePaginate(e);
      } else {
        _this._handleSelectionAdd(option);
      }
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handlePaginate", function (e) {
      e.persist();
      _this.setState(function (state, props) {
        return {
          shownResults: state.shownResults + props.maxResults
        };
      }, function () {
        return _this.props.onPaginate(e, _this.state.shownResults);
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleSelectionAdd", function (option) {
      var _this$props2 = _this.props,
        multiple = _this$props2.multiple,
        labelKey = _this$props2.labelKey;
      var selected;
      var selection = option;
      var text;

      // Add a unique id to the custom selection. Avoid doing this in `render` so
      // the id doesn't increment every time.
      if (!isString(selection) && selection.customOption) {
        selection = _objectSpread$8(_objectSpread$8({}, selection), {}, {
          id: uniqueId('new-id-')
        });
      }
      if (multiple) {
        // If multiple selections are allowed, add the new selection to the
        // existing selections.
        selected = _this.state.selected.concat(selection);
        text = '';
      } else {
        // If only a single selection is allowed, replace the existing selection
        // with the new one.
        selected = [selection];
        text = getOptionLabel$2(selection, labelKey);
      }
      _this.setState(function (state, props) {
        return _objectSpread$8(_objectSpread$8({}, hideMenu(state, props)), {}, {
          initialItem: selection,
          selected: selected,
          text: text
        });
      }, function () {
        return _this._handleChange(selected);
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "_handleSelectionRemove", function (selection) {
      var selected = _this.state.selected.filter(function (option) {
        return !isEqual$3(option, selection);
      });

      // Make sure the input stays focused after the item is removed.
      _this.focus();
      _this.setState(function (state, props) {
        return _objectSpread$8(_objectSpread$8({}, hideMenu(state, props)), {}, {
          selected: selected
        });
      }, function () {
        return _this._handleChange(selected);
      });
    });
    return _this;
  }
  _createClass(Typeahead, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.autoFocus && this.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props3 = this.props,
        labelKey = _this$props3.labelKey,
        multiple = _this$props3.multiple,
        selected = _this$props3.selected;
      validateSelectedPropChange(selected, prevProps.selected);

      // Sync selections in state with those in props.
      if (selected && !isEqual$3(selected, prevState.selected)) {
        this.setState({
          selected: selected
        });
        if (!multiple) {
          this.setState({
            text: selected.length ? getOptionLabel$2(selected[0], labelKey) : ''
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props;
        _this$props4.onChange;
        var props = _objectWithoutProperties$1(_this$props4, _excluded$j);
      var mergedPropsAndState = _objectSpread$8(_objectSpread$8({}, props), this.state);
      var filterBy = mergedPropsAndState.filterBy,
        labelKey = mergedPropsAndState.labelKey,
        options = mergedPropsAndState.options,
        paginate = mergedPropsAndState.paginate,
        shownResults = mergedPropsAndState.shownResults,
        text = mergedPropsAndState.text;
      this.isMenuShown = isShown(mergedPropsAndState);
      this.items = []; // Reset items on re-render.

      var results = [];
      if (this.isMenuShown) {
        var cb = isFunction(filterBy) ? filterBy : defaultFilterBy;
        results = options.filter(function (option) {
          return cb(option, mergedPropsAndState);
        });

        // This must come before results are truncated.
        var shouldPaginate = paginate && results.length > shownResults;

        // Truncate results if necessary.
        results = getTruncatedOptions(results, shownResults);

        // Add the custom option if necessary.
        if (addCustomOption(results, mergedPropsAndState)) {
          results.push(_defineProperty$3({
            customOption: true
          }, getStringLabelKey(labelKey), text));
        }

        // Add the pagination item if necessary.
        if (shouldPaginate) {
          var _results$push2;
          results.push((_results$push2 = {}, _defineProperty$3(_results$push2, getStringLabelKey(labelKey), ''), _defineProperty$3(_results$push2, "paginationOption", true), _results$push2));
        }
      }
      return /*#__PURE__*/React__default.createElement(TypeaheadManager, _extends$G({}, mergedPropsAndState, {
        hideMenu: this.hideMenu,
        inputNode: this.inputNode,
        inputRef: this.inputRef,
        isMenuShown: this.isMenuShown,
        onActiveItemChange: this._handleActiveItemChange,
        onAdd: this._handleSelectionAdd,
        onBlur: this._handleBlur,
        onChange: this._handleInputChange,
        onClear: this._handleClear,
        onClick: this._handleClick,
        onFocus: this._handleFocus,
        onHide: this.hideMenu,
        onInitialItemChange: this._handleInitialItemChange,
        onKeyDown: this._handleKeyDown,
        onMenuItemClick: this._handleMenuItemSelect,
        onRemove: this._handleSelectionRemove,
        results: results,
        setItem: this.setItem,
        toggleMenu: this.toggleMenu
      }));
    }
  }]);
  return Typeahead;
}(React__default.Component);
_defineProperty$3(Typeahead, "propTypes", propTypes$7);
_defineProperty$3(Typeahead, "defaultProps", defaultProps$3);

var _excluded$i = ["className", "label", "onClick", "onKeyDown", "size"];
var propTypes$6 = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  size: sizeType
};
/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */
var ClearButton = function ClearButton(_ref) {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Clear' : _ref$label,
    _onClick = _ref.onClick,
    _onKeyDown = _ref.onKeyDown,
    size = _ref.size,
    props = _objectWithoutProperties$1(_ref, _excluded$i);
  return /*#__PURE__*/React__default.createElement("button", _extends$G({}, props, {
    "aria-label": label,
    className: cls('close', 'btn-close', 'rbt-close', {
      'rbt-close-lg': isSizeLarge(size),
      'rbt-close-sm': isSizeSmall(size)
    }, className),
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick && _onClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      // Prevent browser from navigating back.
      if (e.key === 'Backspace') {
        e.preventDefault();
      }
      _onKeyDown && _onKeyDown(e);
    },
    type: "button"
  }), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "rbt-close-content"
  }, "\xD7"), /*#__PURE__*/React__default.createElement("span", {
    className: "sr-only visually-hidden"
  }, label));
};
ClearButton.propTypes = propTypes$6;

var propTypes$5 = {
  label: PropTypes.string
};
var Loader = function Loader(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loading...' : _ref$label;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "rbt-loader spinner-border spinner-border-sm",
    role: "status"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "sr-only visually-hidden"
  }, label));
};
Loader.propTypes = propTypes$5;

function _arrayWithHoles$2(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit$2(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray$2(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray$2(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$2(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0;
  }
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$2(r, e) {
  return _arrayWithHoles$2(r) || _iterableToArrayLimit$2(r, e) || _unsupportedIterableToArray$2(r, e) || _nonIterableRest$2();
}

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName$1(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow$1(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$1(node) {
  var OwnElement = getWindow$1(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement$1(node) {
  var OwnElement = getWindow$1(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot$1(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow$1(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement$1(element) || !getNodeName$1(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement$1(element) || !getNodeName$1(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max$2 = Math.max;
var min$2 = Math.min;
var round$1 = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect$1(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement$1(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement$1(element) ? getWindow$1(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect$1(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains$1(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot$1(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$2(element) {
  return getWindow$1(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName$1(element)) >= 0;
}

function getDocumentElement$1(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode$1(element) {
  if (getNodeName$1(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot$1(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement$1(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$2(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement$1(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$2(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode$1(element);

  if (isShadowRoot$1(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement$1(currentNode) && ['html', 'body'].indexOf(getNodeName$1(currentNode)) < 0) {
    var css = getComputedStyle$2(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow$1(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$2(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName$1(offsetParent) === 'html' || getNodeName$1(offsetParent) === 'body' && getComputedStyle$2(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return max$2(min, min$2(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains$1(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x * dpr) / dpr || 0,
    y: round$1(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow$1(popper)) {
      offsetParent = getDocumentElement$1(popper);

      if (getComputedStyle$2(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow$1(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$2 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$2[matched];
  });
}

var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow$1(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect$1(getDocumentElement$1(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow$1(element);
  var html = getDocumentElement$1(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement$1(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$2(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$2(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$2(body || html).direction === 'rtl') {
    x += max$2(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$2(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent$1(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName$1(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement$1(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent$1(getParentNode$1(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent$1(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$1(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode$1(target)));
}

function rectToClientRect$1(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect$1(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect$1(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect$1(getDocumentRect(getDocumentElement$1(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$2(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;

  if (!isElement$1(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$1(clippingParent) && contains$1(clippingParent, clipperElement) && getNodeName$1(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$2(rect.top, accRect.top);
    accRect.right = min$2(rect.right, accRect.right);
    accRect.bottom = min$2(rect.bottom, accRect.bottom);
    accRect.left = max$2(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement$1(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect$1(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect$1(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$2(min, tetherMin) : min, offset, tether ? max$2(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow$1(node) || !isHTMLElement$1(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement$1(offsetParent);
  var rect = getBoundingClientRect$1(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName$1(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement$1(offsetParent)) {
      offsets = getBoundingClientRect$1(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var reactFastCompare;
var hasRequiredReactFastCompare;

function requireReactFastCompare () {
	if (hasRequiredReactFastCompare) return reactFastCompare;
	hasRequiredReactFastCompare = 1;
	var hasElementType = typeof Element !== 'undefined';
	var hasMap = typeof Map === 'function';
	var hasSet = typeof Set === 'function';
	var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

	// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

	function equal(a, b) {
	  // START: fast-deep-equal es6/index.js 3.1.3
	  if (a === b) return true;

	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;

	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }

	    // START: Modifications:
	    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
	    //    to co-exist with es5.
	    // 2. Replace `for of` with es5 compliant iteration using `for`.
	    //    Basically, take:
	    //
	    //    ```js
	    //    for (i of a.entries())
	    //      if (!b.has(i[0])) return false;
	    //    ```
	    //
	    //    ... and convert to:
	    //
	    //    ```js
	    //    it = a.entries();
	    //    while (!(i = it.next()).done)
	    //      if (!b.has(i.value[0])) return false;
	    //    ```
	    //
	    //    **Note**: `i` access switches to `i.value`.
	    var it;
	    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!equal(i.value[1], b.get(i.value[0]))) return false;
	      return true;
	    }

	    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      return true;
	    }
	    // END: Modifications

	    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (a[i] !== b[i]) return false;
	      return true;
	    }

	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    // START: Modifications:
	    // Apply guards for `Object.create(null)` handling. See:
	    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
	    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
	    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
	    // END: Modifications

	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;

	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
	    // END: fast-deep-equal

	    // START: react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element) return false;

	    // custom handling for React/Preact
	    for (i = length; i-- !== 0;) {
	      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner
	        // Preact-specific: avoid traversing Preact elements' __v and __o
	        //    __v = $_original / $_vnode
	        //    __o = $_owner
	        // These properties contain circular references and are not needed when
	        // comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of elements

	        continue;
	      }

	      // all other properties should be traversed as usual
	      if (!equal(a[keys[i]], b[keys[i]])) return false;
	    }
	    // END: react-fast-compare

	    // START: fast-deep-equal
	    return true;
	  }

	  return a !== a && b !== b;
	}
	// end fast-deep-equal

	reactFastCompare = function isEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (((error.message || '').match(/stack|recursion/i))) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('react-fast-compare cannot handle circular refs');
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};
	return reactFastCompare;
}

var reactFastCompareExports = requireReactFastCompare();
var isEqual$2 = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompareExports);

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (isEqual$2(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var setPopperWidth = {
  enabled: true,
  fn: function fn(data) {
    // eslint-disable-next-line no-param-reassign
    data.state.styles.popper.width = "".concat(data.state.rects.reference.width, "px");
  },
  name: 'setPopperWidth',
  phase: 'write'
};
function getModifiers(props) {
  var modifiers = [{
    enabled: !!props.flip,
    name: 'flip'
  }];
  if (props.align !== 'right' && props.align !== 'left') {
    modifiers.push(setPopperWidth);
  }
  return modifiers;
}
function getPlacement(props) {
  var x = props.align === 'right' ? 'end' : 'start';
  var y = props.dropup ? 'top' : 'bottom';
  return "".concat(y, "-").concat(x);
}
function useOverlay(referenceElement, options) {
  var _useState = useState(null),
    _useState2 = _slicedToArray$2(_useState, 2),
    popperElement = _useState2[0],
    attachRef = _useState2[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      modifiers: getModifiers(options),
      placement: getPlacement(options),
      strategy: options.positionFixed ? 'fixed' : 'absolute'
    }),
    attributes = _usePopper.attributes,
    styles = _usePopper.styles,
    forceUpdate = _usePopper.forceUpdate;
  var refElementHeight = referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.offsetHeight;

  // Re-position the popper if the height of the reference element changes.
  // Exclude `forceUpdate` from dependencies since it changes with each render.
  useEffect(function () {
    forceUpdate && forceUpdate();
  }, [refElementHeight]); // eslint-disable-line

  return _objectSpread$7(_objectSpread$7({}, attributes.popper), {}, {
    innerRef: attachRef,
    style: styles.popper
  });
}

var _excluded$h = ["referenceElement", "isMenuShown"];

// `Element` is not defined during server-side rendering, so shim it here.
/* istanbul ignore next */
var SafeElement = typeof Element === 'undefined' ? noop$4 : Element;
var propTypes$4 = {
  /**
   * Specify menu alignment. The default value is `justify`, which makes the
   * menu as wide as the input and truncates long values. Specifying `left`
   * or `right` will align the menu to that side and the width will be
   * determined by the length of menu item values.
   */
  align: PropTypes.oneOf(ALIGN_VALUES),
  children: PropTypes.func.isRequired,
  /**
   * Specify whether the menu should appear above the input.
   */
  dropup: PropTypes.bool,
  /**
   * Whether or not to automatically adjust the position of the menu when it
   * reaches the viewport boundaries.
   */
  flip: PropTypes.bool,
  isMenuShown: PropTypes.bool,
  positionFixed: PropTypes.bool,
  // @ts-ignore
  referenceElement: PropTypes.instanceOf(SafeElement)
};
var Overlay = function Overlay(_ref) {
  var referenceElement = _ref.referenceElement,
    isMenuShown = _ref.isMenuShown,
    props = _objectWithoutProperties$1(_ref, _excluded$h);
  var overlayProps = useOverlay(referenceElement, props);
  if (!isMenuShown) {
    return null;
  }
  return props.children(overlayProps);
};
Overlay.propTypes = propTypes$4;

/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/* eslint-disable no-return-assign */
var optionsSupported = false;
var onceSupported = false;

try {
  var options$1 = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (canUseDOM$1) {
    window.addEventListener('test', options$1, options$1);
    window.removeEventListener('test', options$1, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener$1(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

function listen(node, eventName, handler, options) {
  addEventListener$1(node, eventName, handler, options);
  return function () {
    removeEventListener(node, eventName, handler, options);
  };
}

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function useCommittedRef(value) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}

function useEventCallback(fn) {
  const ref = useCommittedRef(fn);
  return useCallback(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}

/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument$1(node) {
  return node && node.ownerDocument || document;
}

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    return ReactDOM__default.findDOMNode(componentOrElement);
  }

  return componentOrElement != null ? componentOrElement : null;
}

var ownerDocument = (function (componentOrElement) {
  return ownerDocument$1(safeFindDOMNode(componentOrElement));
});

var escapeKeyCode = 27;

var noop$3 = function noop() {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var getRefTarget = function getRefTarget(ref) {
  return ref && ('current' in ref ? ref.current : ref);
};

/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose$1(ref, onRootClose, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      disabled = _ref.disabled,
      _ref$clickTrigger = _ref.clickTrigger,
      clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;

  var preventMouseRootCloseRef = useRef(false);
  var onClose = onRootClose || noop$3;
  var handleMouseCapture = useCallback(function (e) {
    var _e$composedPath$;

    var currentTarget = getRefTarget(ref);
    warning$2(!!currentTarget, 'RootClose captured a close event but does not have a ref to compare it to. ' + 'useRootClose(), should be passed a ref that resolves to a DOM node');
    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!contains(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
  }, [ref]);
  var handleMouse = useEventCallback(function (e) {
    if (!preventMouseRootCloseRef.current) {
      onClose(e);
    }
  });
  var handleKeyUp = useEventCallback(function (e) {
    if (e.keyCode === escapeKeyCode) {
      onClose(e);
    }
  });
  useEffect(function () {
    if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074

    var currentEvent = window.event;
    var doc = ownerDocument(getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.

    var removeMouseCaptureListener = listen(doc, clickTrigger, handleMouseCapture, true);
    var removeMouseListener = listen(doc, clickTrigger, function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleMouse(e);
    });
    var removeKeyupListener = listen(doc, 'keyup', function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleKeyUp(e);
    });
    var mobileSafariHackListeners = [];

    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function (el) {
        return listen(el, 'mousemove', noop$3);
      });
    }

    return function () {
      removeMouseCaptureListener();
      removeMouseListener();
      removeKeyupListener();
      mobileSafariHackListeners.forEach(function (remove) {
        return remove();
      });
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
}

function useRootClose(onRootClose, options) {
  var rootElementRef = useRef(null);
  useRootClose$1(rootElementRef.current, onRootClose, options);
  return rootElementRef;
}

var _excluded$g = ["children", "onRootClose"];
function RootClose(_ref) {
  var children = _ref.children,
    onRootClose = _ref.onRootClose,
    props = _objectWithoutProperties$1(_ref, _excluded$g);
  var rootRef = useRootClose(onRootClose, props);
  return children(rootRef);
}

var _excluded$f = ["onBlur", "onClick", "onFocus", "onRemove", "option"];
function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
({
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onRemove: PropTypes.func,
  option: optionType.isRequired
});
function useToken(_ref) {
  var onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onRemove = _ref.onRemove,
    option = _ref.option,
    props = _objectWithoutProperties$1(_ref, _excluded$f);
  var _useState = useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray$2(_useState3, 2),
    rootElement = _useState4[0],
    attachRef = _useState4[1];
  var handleBlur = function handleBlur(e) {
    setActive(false);
    onBlur && onBlur(e);
  };
  var handleClick = function handleClick(e) {
    setActive(true);
    onClick && onClick(e);
  };
  var handleFocus = function handleFocus(e) {
    setActive(true);
    onFocus && onFocus(e);
  };
  var handleRemove = function handleRemove() {
    onRemove && onRemove(option);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Backspace' && active) {
      // Prevent browser from going back.
      e.preventDefault();
      handleRemove();
    }
  };
  useRootClose$1(rootElement, handleBlur, _objectSpread$6(_objectSpread$6({}, props), {}, {
    disabled: !active
  }));
  return {
    active: active,
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onRemove: isFunction(onRemove) ? handleRemove : undefined,
    ref: attachRef
  };
}

var _excluded$e = ["active", "children", "className", "onRemove", "tabIndex"],
  _excluded2$3 = ["children", "option", "readOnly"],
  _excluded3$1 = ["ref"];
function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InteractiveToken = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var active = _ref.active,
    children = _ref.children,
    className = _ref.className,
    onRemove = _ref.onRemove,
    tabIndex = _ref.tabIndex,
    props = _objectWithoutProperties$1(_ref, _excluded$e);
  return /*#__PURE__*/React__default.createElement("div", _extends$G({}, props, {
    className: cls('rbt-token', 'rbt-token-removeable', {
      'rbt-token-active': !!active
    }, className),
    ref: ref,
    tabIndex: tabIndex || 0
  }), children, /*#__PURE__*/React__default.createElement(ClearButton, {
    className: "rbt-token-remove-button",
    label: "Remove",
    onClick: onRemove,
    tabIndex: -1
  }));
});
var StaticToken = function StaticToken(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    disabled = _ref2.disabled,
    href = _ref2.href;
  var classnames = cls('rbt-token', {
    'rbt-token-disabled': disabled
  }, className);
  if (href && !disabled) {
    return /*#__PURE__*/React__default.createElement("a", {
      className: classnames,
      href: href
    }, children);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames
  }, children);
};
/**
 * Individual token component, generally displayed within the
 * `TypeaheadInputMulti` component, but can also be rendered on its own.
 */
var Token = function Token(_ref3) {
  var children = _ref3.children,
    option = _ref3.option,
    readOnly = _ref3.readOnly,
    props = _objectWithoutProperties$1(_ref3, _excluded2$3);
  var _useToken = useToken(_objectSpread$5(_objectSpread$5({}, props), {}, {
      option: option
    })),
    ref = _useToken.ref,
    tokenProps = _objectWithoutProperties$1(_useToken, _excluded3$1);
  var child = /*#__PURE__*/React__default.createElement("div", {
    className: "rbt-token-label"
  }, children);
  return !props.disabled && !readOnly && isFunction(tokenProps.onRemove) ? /*#__PURE__*/React__default.createElement(InteractiveToken, _extends$G({}, props, tokenProps, {
    ref: ref
  }), child) : /*#__PURE__*/React__default.createElement(StaticToken, props, child);
};

// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function interpolateStyle(styles, attr) {
  var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  // Title-case the sub-attribute.
  if (subattr) {
    /* eslint-disable-next-line no-param-reassign */
    subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
  }
  return ['Top', 'Right', 'Bottom', 'Left'].map(function (dir) {
    return styles["".concat(attr).concat(dir).concat(subattr)];
  }).join(' ');
}
function copyStyles(inputNode, hintNode) {
  var inputStyle = window.getComputedStyle(inputNode);

  /* eslint-disable no-param-reassign */
  hintNode.style.borderStyle = interpolateStyle(inputStyle, 'border', 'style');
  hintNode.style.borderWidth = interpolateStyle(inputStyle, 'border', 'width');
  hintNode.style.fontSize = inputStyle.fontSize;
  hintNode.style.fontWeight = inputStyle.fontWeight;
  hintNode.style.height = inputStyle.height;
  hintNode.style.lineHeight = inputStyle.lineHeight;
  hintNode.style.margin = interpolateStyle(inputStyle, 'margin');
  hintNode.style.padding = interpolateStyle(inputStyle, 'padding');
  /* eslint-enable no-param-reassign */
}

var useHint = function useHint() {
  var _useTypeaheadContext = useTypeaheadContext(),
    hintText = _useTypeaheadContext.hintText,
    inputNode = _useTypeaheadContext.inputNode;
  var hintRef = useRef(null);
  useEffect(function () {
    if (inputNode && hintRef.current) {
      copyStyles(inputNode, hintRef.current);
    }
  });
  return {
    hintRef: hintRef,
    hintText: hintText
  };
};
var Hint = function Hint(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var _useHint = useHint(),
    hintRef = _useHint.hintRef,
    hintText = _useHint.hintText;
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    style: {
      display: 'flex',
      flex: 1,
      height: '100%',
      position: 'relative'
    }
  }, children, /*#__PURE__*/React__default.createElement("input", {
    "aria-hidden": true,
    className: "rbt-input-hint",
    ref: hintRef,
    readOnly: true,
    style: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      boxShadow: 'none',
      color: 'rgba(0, 0, 0, 0.54)',
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      width: '100%'
    },
    tabIndex: -1,
    value: hintText
  }));
};

var Input$3 = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement("input", _extends$G({}, props, {
    className: cls('rbt-input-main', props.className),
    ref: ref
  }));
});

var _excluded$d = ["children", "className", "inputClassName", "inputRef", "referenceElementRef", "selected"];
function TypeaheadInputMulti(props) {
  var wrapperRef = React__default.useRef(null);
  var inputElem = React__default.useRef(null);
  var _propsWithBsClassName = propsWithBsClassName(props),
    children = _propsWithBsClassName.children,
    className = _propsWithBsClassName.className,
    inputClassName = _propsWithBsClassName.inputClassName;
    _propsWithBsClassName.inputRef;
    var referenceElementRef = _propsWithBsClassName.referenceElementRef,
    selected = _propsWithBsClassName.selected,
    rest = _objectWithoutProperties$1(_propsWithBsClassName, _excluded$d);
  function getInputRef(input) {
    inputElem.current = input;
    props.inputRef(input);
  }

  /**
   * Forward click or focus events on the container element to the input.
   */
  function handleContainerClickOrFocus(e) {
    // Don't focus the input if it's disabled.
    if (props.disabled) {
      e.currentTarget.blur();
      return;
    }
    var inputNode = inputElem.current;
    if (!inputNode ||
    // Ignore if the clicked element is a child of the container, ie: a token
    // or the input itself.
    e.currentTarget.contains(e.target) && e.currentTarget !== e.target) {
      return;
    }
    if (isSelectable(inputNode)) {
      // Move cursor to the end if the user clicks outside the actual input.
      inputNode.selectionStart = inputNode.value.length;
    }
    inputNode.focus();
  }
  function handleKeyDown(e) {
    if (e.key === 'Backspace' && selected.length && !props.value) {
      var _wrapperRef$current;
      // Prevent browser from going back.
      e.preventDefault();

      // If the input is selected and there is no text, focus the last
      // token when the user hits backspace.

      var wrapperChildren = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.children;
      if (wrapperChildren !== null && wrapperChildren !== void 0 && wrapperChildren.length) {
        var lastToken = wrapperChildren[wrapperChildren.length - 2];
        lastToken === null || lastToken === void 0 || lastToken.focus();
      }
    }
    props.onKeyDown && props.onKeyDown(e);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cls('rbt-input-multi', {
      disabled: props.disabled
    }, className),
    onClick: handleContainerClickOrFocus,
    onFocus: handleContainerClickOrFocus,
    ref: referenceElementRef,
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "rbt-input-wrapper",
    ref: wrapperRef
  }, children, /*#__PURE__*/React__default.createElement(Hint, null, /*#__PURE__*/React__default.createElement(Input$3, _extends$G({}, rest, {
    className: inputClassName,
    onKeyDown: handleKeyDown,
    ref: getInputRef,
    style: {
      backgroundColor: 'transparent',
      border: 0,
      boxShadow: 'none',
      cursor: 'inherit',
      outline: 'none',
      padding: 0,
      width: '100%',
      zIndex: 1
    }
  })))));
}

var _excluded$c = ["inputRef", "referenceElementRef"];
var TypeaheadInputSingle = function TypeaheadInputSingle(_ref) {
  var inputRef = _ref.inputRef,
    referenceElementRef = _ref.referenceElementRef,
    props = _objectWithoutProperties$1(_ref, _excluded$c);
  return /*#__PURE__*/React__default.createElement(Hint, null, /*#__PURE__*/React__default.createElement(Input$3, _extends$G({}, propsWithBsClassName(props), {
    ref: function ref(node) {
      inputRef(node);
      referenceElementRef(node);
    }
  })));
};

var propTypes$3 = {
  children: PropTypes.string.isRequired,
  highlightClassName: PropTypes.string,
  search: PropTypes.string.isRequired
};
/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */
var Highlighter = function Highlighter(_ref) {
  var children = _ref.children,
    _ref$highlightClassNa = _ref.highlightClassName,
    highlightClassName = _ref$highlightClassNa === void 0 ? 'rbt-highlight-text' : _ref$highlightClassNa,
    search = _ref.search;
  if (!search || !children) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }
  var matchCount = 0;
  var remaining = children;
  var highlighterChildren = [];
  while (remaining) {
    var bounds = getMatchBounds(remaining, search);

    // No match anywhere in the remaining string, stop.
    if (!bounds) {
      highlighterChildren.push(remaining);
      break;
    }

    // Capture the string that leads up to a match.
    var nonMatch = remaining.slice(0, bounds.start);
    if (nonMatch) {
      highlighterChildren.push(nonMatch);
    }

    // Capture the matching string.
    var match = remaining.slice(bounds.start, bounds.end);
    highlighterChildren.push( /*#__PURE__*/React__default.createElement("mark", {
      className: highlightClassName,
      key: matchCount
    }, match));
    matchCount += 1;

    // And if there's anything left over, continue the loop.
    remaining = remaining.slice(bounds.end);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, highlighterChildren);
};
Highlighter.propTypes = propTypes$3;

const t=t=>"object"==typeof t&&null!=t&&1===t.nodeType,e$1=(t,e)=>(!e||"hidden"!==t)&&("visible"!==t&&"clip"!==t),n=(t,n)=>{if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){const o=getComputedStyle(t,null);return e$1(o.overflowY,n)||e$1(o.overflowX,n)||(t=>{const e=(t=>{if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}})(t);return !!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)})(t)}return !1},o$1=(t,e,n,o,l,r,i,s)=>r<t&&i>e||r>t&&i<e?0:r<=t&&s<=n||i>=e&&s>=n?r-t-o:i>e&&s<n||r<t&&s>n?i-e+l:0,l=t=>{const e=t.parentElement;return null==e?t.getRootNode().host||null:e},r=(e,r)=>{var i,s,d,h;if("undefined"==typeof document)return [];const{scrollMode:c,block:f,inline:u,boundary:a,skipOverflowHiddenElements:g}=r,p="function"==typeof a?a:t=>t!==a;if(!t(e))throw new TypeError("Invalid target");const m=document.scrollingElement||document.documentElement,w=[];let W=e;for(;t(W)&&p(W);){if(W=l(W),W===m){w.push(W);break}null!=W&&W===document.body&&n(W)&&!n(document.documentElement)||null!=W&&n(W,g)&&w.push(W);}const b=null!=(s=null==(i=window.visualViewport)?void 0:i.width)?s:innerWidth,H=null!=(h=null==(d=window.visualViewport)?void 0:d.height)?h:innerHeight,{scrollX:y,scrollY:M}=window,{height:v,width:E,top:x,right:C,bottom:I,left:R}=e.getBoundingClientRect(),{top:T,right:B,bottom:F,left:V}=(t=>{const e=window.getComputedStyle(t);return {top:parseFloat(e.scrollMarginTop)||0,right:parseFloat(e.scrollMarginRight)||0,bottom:parseFloat(e.scrollMarginBottom)||0,left:parseFloat(e.scrollMarginLeft)||0}})(e);let k="start"===f||"nearest"===f?x-T:"end"===f?I+F:x+v/2-T+F,D="center"===u?R+E/2-V+B:"end"===u?C+B:R-V;const L=[];for(let t=0;t<w.length;t++){const e=w[t],{height:n,width:l,top:r,right:i,bottom:s,left:d}=e.getBoundingClientRect();if("if-needed"===c&&x>=0&&R>=0&&I<=H&&C<=b&&x>=r&&I<=s&&R>=d&&C<=i)return L;const h=getComputedStyle(e),a=parseInt(h.borderLeftWidth,10),g=parseInt(h.borderTopWidth,10),p=parseInt(h.borderRightWidth,10),W=parseInt(h.borderBottomWidth,10);let T=0,B=0;const F="offsetWidth"in e?e.offsetWidth-e.clientWidth-a-p:0,V="offsetHeight"in e?e.offsetHeight-e.clientHeight-g-W:0,S="offsetWidth"in e?0===e.offsetWidth?0:l/e.offsetWidth:0,X="offsetHeight"in e?0===e.offsetHeight?0:n/e.offsetHeight:0;if(m===e)T="start"===f?k:"end"===f?k-H:"nearest"===f?o$1(M,M+H,H,g,W,M+k,M+k+v,v):k-H/2,B="start"===u?D:"center"===u?D-b/2:"end"===u?D-b:o$1(y,y+b,b,a,p,y+D,y+D+E,E),T=Math.max(0,T+M),B=Math.max(0,B+y);else {T="start"===f?k-r-g:"end"===f?k-s+W+V:"nearest"===f?o$1(r,s,n,g,W+V,k,k+v,v):k-(r+n/2)+V/2,B="start"===u?D-d-a:"center"===u?D-(d+l/2)+F/2:"end"===u?D-i+p+F:o$1(d,i,l,a,p+F,D,D+E,E);const{scrollLeft:t,scrollTop:h}=e;T=0===X?0:Math.max(0,Math.min(h+T/X,e.scrollHeight-n/X+V)),B=0===S?0:Math.max(0,Math.min(t+B/S,e.scrollWidth-l/S+F)),k+=h-T,D+=t-B;}L.push({el:e,top:T,left:B});}return L};

const o=t=>!1===t?{block:"end",inline:"nearest"}:(t=>t===Object(t)&&0!==Object.keys(t).length)(t)?t:{block:"start",inline:"nearest"};function e(e,r$1){if(!e.isConnected||!(t=>{let o=t;for(;o&&o.parentNode;){if(o.parentNode===document)return !0;o=o.parentNode instanceof ShadowRoot?o.parentNode.host:o.parentNode;}return !1})(e))return;const n=(t=>{const o=window.getComputedStyle(t);return {top:parseFloat(o.scrollMarginTop)||0,right:parseFloat(o.scrollMarginRight)||0,bottom:parseFloat(o.scrollMarginBottom)||0,left:parseFloat(o.scrollMarginLeft)||0}})(e);if((t=>"object"==typeof t&&"function"==typeof t.behavior)(r$1))return r$1.behavior(r(e,r$1));const l="boolean"==typeof r$1||null==r$1?void 0:r$1.behavior;for(const{el:a,top:i,left:s}of r(e,o(r$1))){const t=i-n.top+n.bottom,o=s-n.left+n.right;a.scroll({top:t,left:o,behavior:l});}}

var _excluded$b = ["label", "onClick", "option", "position"];
function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
({
  option: optionType.isRequired,
  position: PropTypes.number
});
function useItem(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    option = _ref.option,
    position = _ref.position,
    props = _objectWithoutProperties$1(_ref, _excluded$b);
  var _useTypeaheadContext = useTypeaheadContext(),
    activeIndex = _useTypeaheadContext.activeIndex,
    id = _useTypeaheadContext.id,
    isOnlyResult = _useTypeaheadContext.isOnlyResult,
    onActiveItemChange = _useTypeaheadContext.onActiveItemChange,
    onInitialItemChange = _useTypeaheadContext.onInitialItemChange,
    onMenuItemClick = _useTypeaheadContext.onMenuItemClick,
    setItem = _useTypeaheadContext.setItem;
  var itemRef = useRef(null);
  useEffect(function () {
    if (position === 0) {
      onInitialItemChange(option);
    }
  });
  useEffect(function () {
    if (position === activeIndex) {
      onActiveItemChange(option);

      // Automatically scroll the menu as the user keys through it.
      var node = itemRef.current;
      node && e(node, {
        boundary: node.parentNode,
        scrollMode: 'if-needed'
      });
    }
  }, [activeIndex, onActiveItemChange, option, position]);
  var handleClick = useCallback(function (e) {
    onMenuItemClick(option, e);
    onClick && onClick(e);
  }, [onClick, onMenuItemClick, option]);
  var active = isOnlyResult || activeIndex === position;

  // Update the item's position in the item stack.
  setItem(option, position);
  return _objectSpread$4(_objectSpread$4({}, props), {}, {
    active: active,
    'aria-label': label,
    'aria-selected': active,
    id: getMenuItemId(id, position),
    onClick: handleClick,
    onMouseDown: preventInputBlur,
    ref: itemRef,
    role: 'option'
  });
}

var _excluded$a = ["active", "children", "className", "disabled", "onClick"];
var BaseMenuItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var active = _ref.active,
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    _onClick = _ref.onClick,
    props = _objectWithoutProperties$1(_ref, _excluded$a);
  return /*#__PURE__*/React__default.createElement("a", _extends$G({}, props, {
    className: cls('dropdown-item', {
      active: active,
      disabled: disabled
    }, className),
    href: props.href || '#',
    onClick: function onClick(e) {
      e.preventDefault();
      !disabled && _onClick && _onClick(e);
    },
    ref: ref
  }), children);
});
function MenuItem(props) {
  return /*#__PURE__*/React__default.createElement(BaseMenuItem, useItem(props));
}

var _excluded$9 = ["emptyLabel", "innerRef", "maxHeight", "style"];
function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MenuDivider = function MenuDivider() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "dropdown-divider",
    role: "separator"
  });
};
var MenuHeader = function MenuHeader(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    React__default.createElement("div", _extends$G({}, props, {
      className: "dropdown-header",
      role: "heading"
    }))
  );
};
var propTypes$2 = {
  'aria-label': PropTypes.string,
  /**
   * Message to display in the menu if there are no valid results.
   */
  emptyLabel: PropTypes.node,
  /**
   * Needed for accessibility.
   */
  id: checkPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), isRequiredForA11y),
  /**
   * Maximum height of the dropdown menu.
   */
  maxHeight: PropTypes.string
};
/**
 * Menu component that handles empty state when passed a set of results.
 */
var Menu$2 = function Menu(_ref) {
  var _ref$emptyLabel = _ref.emptyLabel,
    emptyLabel = _ref$emptyLabel === void 0 ? 'No matches found.' : _ref$emptyLabel,
    innerRef = _ref.innerRef,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? '300px' : _ref$maxHeight,
    style = _ref.style,
    props = _objectWithoutProperties$1(_ref, _excluded$9);
  var children = Children.count(props.children) === 0 ? /*#__PURE__*/React__default.createElement(BaseMenuItem, {
    disabled: true,
    role: "option"
  }, emptyLabel) : props.children;
  return (
    /*#__PURE__*/
    /* eslint-disable jsx-a11y/interactive-supports-focus */
    React__default.createElement("div", _extends$G({}, props, {
      "aria-label": props['aria-label'] || 'menu-options',
      className: cls('rbt-menu', 'dropdown-menu', 'show', props.className),
      onMouseDown:
      // Prevent input from blurring when clicking on the menu scrollbar.
      preventInputBlur,
      ref: innerRef,
      role: "listbox",
      style: _objectSpread$3(_objectSpread$3({}, style), {}, {
        display: 'block',
        maxHeight: maxHeight,
        overflow: 'auto'
      })
    }), children)
    /* eslint-enable jsx-a11y/interactive-supports-focus */
  );
};

Menu$2.propTypes = propTypes$2;
Menu$2.Divider = MenuDivider;
Menu$2.Header = MenuHeader;

var _excluded$8 = ["labelKey", "newSelectionPrefix", "options", "paginationText", "renderMenuItemChildren", "text"];
var propTypes$1 = {
  /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */
  newSelectionPrefix: PropTypes.node,
  /**
   * Prompt displayed when large data sets are paginated.
   */
  paginationText: PropTypes.node,
  /**
   * Provides a hook for customized rendering of menu item contents.
   */
  renderMenuItemChildren: PropTypes.func
};
function renderMenuItemChildrenFn(option, props) {
  return /*#__PURE__*/React__default.createElement(Highlighter, {
    search: props.text
  }, getOptionLabel$2(option, props.labelKey));
}
var TypeaheadMenu = function TypeaheadMenu(props) {
  var labelKey = props.labelKey,
    _props$newSelectionPr = props.newSelectionPrefix,
    newSelectionPrefix = _props$newSelectionPr === void 0 ? 'New selection: ' : _props$newSelectionPr,
    options = props.options,
    _props$paginationText = props.paginationText,
    paginationText = _props$paginationText === void 0 ? 'Display additional results...' : _props$paginationText,
    _props$renderMenuItem = props.renderMenuItemChildren,
    renderMenuItemChildren = _props$renderMenuItem === void 0 ? renderMenuItemChildrenFn : _props$renderMenuItem,
    text = props.text,
    menuProps = _objectWithoutProperties$1(props, _excluded$8);
  var renderMenuItem = function renderMenuItem(option, position) {
    var label = getOptionLabel$2(option, labelKey);
    var menuItemProps = {
      disabled: !!getOptionProperty(option, 'disabled'),
      label: label,
      option: option,
      position: position
    };
    if (getOptionProperty(option, 'customOption')) {
      return /*#__PURE__*/React__default.createElement(MenuItem, _extends$G({}, menuItemProps, {
        className: "rbt-menu-custom-option",
        key: position,
        label: label
      }), newSelectionPrefix, /*#__PURE__*/React__default.createElement(Highlighter, {
        search: text
      }, label));
    }
    if (getOptionProperty(option, 'paginationOption')) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: "pagination-option-divider"
      }, /*#__PURE__*/React__default.createElement(Menu$2.Divider, null), /*#__PURE__*/React__default.createElement(MenuItem, _extends$G({}, menuItemProps, {
        className: "rbt-menu-pagination-option",
        label:
        // TODO: Fix how (aria-)labels are passed to `MenuItem`.
        // `paginationText` can be a ReactNode.
        isString(paginationText) ? paginationText : ''
      }), paginationText));
    }
    return /*#__PURE__*/React__default.createElement(MenuItem, _extends$G({}, menuItemProps, {
      key: position
    }), renderMenuItemChildren(option, props, position));
  };
  return /*#__PURE__*/React__default.createElement(Menu$2, _extends$G({}, menuProps, {
    key:
    // Force a re-render if the text changes to ensure that menu
    // positioning updates correctly.
    text
  }), options.map(renderMenuItem));
};
TypeaheadMenu.propTypes = propTypes$1;

function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var propTypes = {
  /**
   * Displays a button to clear the input when there are selections.
   */
  clearButton: PropTypes.bool,
  /**
   * Props to be applied directly to the input. `onBlur`, `onChange`,
   * `onFocus`, and `onKeyDown` are ignored.
   */
  inputProps: checkPropType(PropTypes.object, inputPropsType),
  /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */
  isInvalid: PropTypes.bool,
  /**
   * Indicate whether an asynchronous data fetch is happening.
   */
  isLoading: PropTypes.bool,
  /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */
  isValid: PropTypes.bool,
  /**
   * Callback for custom input rendering.
   */
  renderInput: PropTypes.func,
  /**
   * Callback for custom menu rendering.
   */
  renderMenu: PropTypes.func,
  /**
   * Callback for custom menu rendering.
   */
  renderToken: PropTypes.func,
  /**
   * Specifies the size of the input.
   */
  size: sizeType
};
var defaultProps$2 = {
  isLoading: false
};
var defaultRenderMenu = function defaultRenderMenu(results, menuProps, props) {
  return /*#__PURE__*/React__default.createElement(TypeaheadMenu, _extends$G({}, menuProps, {
    labelKey: props.labelKey,
    options: results,
    text: props.text
  }));
};
var defaultRenderToken = function defaultRenderToken(option, props, idx) {
  return /*#__PURE__*/React__default.createElement(Token, {
    disabled: props.disabled,
    key: idx,
    onRemove: props.onRemove,
    option: option,
    tabIndex: props.tabIndex
  }, getOptionLabel$2(option, props.labelKey));
};
var overlayPropKeys = ['align', 'dropup', 'flip', 'positionFixed'];
function getOverlayProps(props) {
  return pick(props, overlayPropKeys);
}
var TypeaheadComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(TypeaheadComponent, _React$Component);
  var _super = _createSuper$1(TypeaheadComponent);
  function TypeaheadComponent() {
    var _this;
    _classCallCheck(this, TypeaheadComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$3(_assertThisInitialized(_this), "_referenceElement", null);
    _defineProperty$3(_assertThisInitialized(_this), "referenceElementRef", function (referenceElement) {
      _this._referenceElement = referenceElement;
    });
    _defineProperty$3(_assertThisInitialized(_this), "_renderInput", function (inputProps, props) {
      var _this$props = _this.props,
        isInvalid = _this$props.isInvalid,
        isValid = _this$props.isValid,
        multiple = _this$props.multiple,
        renderInput = _this$props.renderInput,
        renderToken = _this$props.renderToken,
        size = _this$props.size;
      if (isFunction(renderInput)) {
        return renderInput(inputProps, props);
      }
      var commonProps = _objectSpread$2(_objectSpread$2({}, inputProps), {}, {
        isInvalid: isInvalid,
        isValid: isValid,
        size: size
      });
      if (!multiple) {
        return /*#__PURE__*/React__default.createElement(TypeaheadInputSingle, commonProps);
      }
      var labelKey = props.labelKey,
        onRemove = props.onRemove,
        selected = props.selected;
      return /*#__PURE__*/React__default.createElement(TypeaheadInputMulti, _extends$G({}, commonProps, {
        placeholder: selected.length ? '' : inputProps.placeholder,
        selected: selected
      }), selected.map(function (option, idx) {
        return (renderToken || defaultRenderToken)(option, _objectSpread$2(_objectSpread$2({}, commonProps), {}, {
          labelKey: labelKey,
          onRemove: onRemove
        }), idx);
      }));
    });
    _defineProperty$3(_assertThisInitialized(_this), "_renderMenu", function (results, menuProps, props) {
      var _this$props2 = _this.props,
        emptyLabel = _this$props2.emptyLabel,
        id = _this$props2.id,
        maxHeight = _this$props2.maxHeight,
        newSelectionPrefix = _this$props2.newSelectionPrefix,
        paginationText = _this$props2.paginationText,
        renderMenu = _this$props2.renderMenu,
        renderMenuItemChildren = _this$props2.renderMenuItemChildren;
      return (renderMenu || defaultRenderMenu)(results, _objectSpread$2(_objectSpread$2({}, menuProps), {}, {
        emptyLabel: emptyLabel,
        id: id,
        maxHeight: maxHeight,
        newSelectionPrefix: newSelectionPrefix,
        paginationText: paginationText,
        renderMenuItemChildren: renderMenuItemChildren
      }), props);
    });
    _defineProperty$3(_assertThisInitialized(_this), "_renderAux", function (_ref) {
      var onClear = _ref.onClear,
        selected = _ref.selected;
      var _this$props3 = _this.props,
        clearButton = _this$props3.clearButton,
        disabled = _this$props3.disabled,
        isLoading = _this$props3.isLoading,
        size = _this$props3.size;
      var content;
      if (isLoading) {
        content = /*#__PURE__*/React__default.createElement(Loader, null);
      } else if (clearButton && !disabled && selected.length) {
        content = /*#__PURE__*/React__default.createElement(ClearButton, {
          onClick: onClear,
          onMouseDown: preventInputBlur,
          size: size
        });
      }
      return content ? /*#__PURE__*/React__default.createElement("div", {
        className: cls('rbt-aux', {
          'rbt-aux-lg': isSizeLarge(size)
        })
      }, content) : null;
    });
    return _this;
  }
  _createClass(TypeaheadComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        children = _this$props4.children,
        className = _this$props4.className,
        instanceRef = _this$props4.instanceRef,
        open = _this$props4.open,
        options = _this$props4.options,
        style = _this$props4.style;
      return /*#__PURE__*/React__default.createElement(Typeahead, _extends$G({}, this.props, {
        options: options,
        ref: instanceRef
      }), function (props) {
        var hideMenu = props.hideMenu,
          isMenuShown = props.isMenuShown,
          results = props.results;
        var auxContent = _this2._renderAux(props);
        return /*#__PURE__*/React__default.createElement(RootClose, {
          disabled: open || !isMenuShown,
          onRootClose: hideMenu
        }, function (ref) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: cls('rbt', {
              'has-aux': !!auxContent,
              'is-invalid': _this2.props.isInvalid,
              'is-valid': _this2.props.isValid
            }, className),
            ref: ref,
            style: _objectSpread$2(_objectSpread$2({}, style), {}, {
              outline: 'none',
              position: 'relative'
            }),
            tabIndex: -1
          }, _this2._renderInput(_objectSpread$2(_objectSpread$2({}, props.getInputProps(_this2.props.inputProps)), {}, {
            referenceElementRef: _this2.referenceElementRef
          }), props), /*#__PURE__*/React__default.createElement(Overlay, _extends$G({}, getOverlayProps(_this2.props), {
            isMenuShown: isMenuShown,
            referenceElement: _this2._referenceElement
          }), function (menuProps) {
            return _this2._renderMenu(results, menuProps, props);
          }), auxContent, isFunction(children) ? children(props) : children);
        });
      });
    }
  }]);
  return TypeaheadComponent;
}(React__default.Component);
_defineProperty$3(TypeaheadComponent, "propTypes", propTypes);
_defineProperty$3(TypeaheadComponent, "defaultProps", defaultProps$2);
var TypeaheadComponent$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(TypeaheadComponent, _extends$G({}, props, {
    instanceRef: ref
  }));
});

var AsyncTypeahead = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(TypeaheadComponent$1, _extends$G({}, useAsync(props), {
    ref: ref
  }));
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray$1(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var reactInputMask = {exports: {}};

var reactInputMask_production_min = {exports: {}};

var hasRequiredReactInputMask_production_min;

function requireReactInputMask_production_min () {
	if (hasRequiredReactInputMask_production_min) return reactInputMask_production_min.exports;
	hasRequiredReactInputMask_production_min = 1;
var e=React__default;var t=requireInvariant();function n(){return n=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i]);}return e},n.apply(this,arguments)}function i(e){return requestAnimationFrame(e)}function r(e){cancelAnimationFrame(e);}function a(e){var t=e.ownerDocument;return t.hasFocus()&&t.activeElement===e}function l(e){return null==e?void 0:e.ownerDocument}function o(e){var t=function(e){var t;return null==(t=l(e))?void 0:t.defaultView}(e);return !!t&&e instanceof t.HTMLElement}function u(t){return e.useCallback((function(){var e=t.current,n="undefined"!=typeof window&&o(e);if(!e||!n)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e}),[t])}function s(t,n){var l,o,s,c,f=e.useRef({start:null,end:null}),h=u(t),g=e.useCallback((function(){return function(e){var t=e.selectionStart,n=e.selectionEnd;return {start:t,end:n,length:n-t}}(h())}),[h]),v=e.useCallback((function(){return f.current}),[]),d=e.useCallback((function(e){var t=h();t&&a(t)&&(!function(e,t,n){void 0===n&&(n=t),e.setSelectionRange(t,n);}(t,e.start,e.end),f.current=g());}),[h,g]),m=e.useCallback((function(){f.current=g();}),[g]),p=(l=m,o=e.useRef(null),s=e.useCallback((function(){null===o.current&&function e(){l(),o.current=i(e);}();}),[l]),c=e.useCallback((function(){r(o.current),o.current=null;}),[]),e.useEffect((function(){o.current&&(c(),s());}),[s,c]),e.useEffect(r,[]),[s,c]),k=p[0],P=p[1];return e.useLayoutEffect((function(){if(n){var e=h();return e.addEventListener("focus",k),e.addEventListener("blur",P),a(e)&&k(),function(){e.removeEventListener("focus",k),e.removeEventListener("blur",P),P();}}})),{getSelection:g,getLastSelection:v,setSelection:d}}function c(t,n){var i=e.useRef(),r=s(i,n),a=r.getSelection,l=r.getLastSelection,o=r.setSelection,c=function(t,n){var i=u(t),r=e.useRef(n);return {getValue:e.useCallback((function(){return i().value}),[i]),getLastValue:e.useCallback((function(){return r.current}),[]),setValue:e.useCallback((function(e){r.current=e;var t=i();t&&(t.value=e);}),[i])}}(i,t),f=c.getValue,h=c.getLastValue,g=c.setValue;return {inputRef:i,getInputState:function(){return {value:f(),selection:a()}},getLastInputState:function(){return {value:h(),selection:l()}},setInputState:function(e){var t=e.value,n=e.selection;g(t),o(n);}}}requireWarning();var f=["disabled","onBlur","onChange","onFocus","onMouseDown","readOnly","value"],h={9:/[0-9]/,a:/[A-Za-z]/,"*":/[A-Za-z0-9]/};var g=function(e){var t=this;this.isCharacterAllowedAtPosition=function(e,n){var i=t.maskOptions.maskPlaceholder;return !!t.isCharacterFillingPosition(e,n)||!!i&&i[n]===e},this.isCharacterFillingPosition=function(e,n){var i=t.maskOptions.mask;if(!e||n>=i.length)return !1;if(!t.isPositionEditable(n))return i[n]===e;var r=i[n];return new RegExp(r).test(e)},this.isPositionEditable=function(e){var n=t.maskOptions,i=n.mask,r=n.permanents;return e<i.length&&-1===r.indexOf(e)},this.isValueEmpty=function(e){return e.split("").every((function(e,n){return !t.isPositionEditable(n)||!t.isCharacterFillingPosition(e,n)}))},this.isValueFilled=function(e){return t.getFilledLength(e)===t.maskOptions.lastEditablePosition+1},this.getDefaultSelectionForValue=function(e){var n=t.getFilledLength(e),i=t.getRightEditablePosition(n);return {start:i,end:i}},this.getFilledLength=function(e){return function(e,t){for(var n=e.length-1;n>=0;n--)if(t(e[n],n))return n;return -1}(e.split(""),(function(e,n){return t.isPositionEditable(n)&&t.isCharacterFillingPosition(e,n)}))+1},this.getStringFillingLengthAtPosition=function(e,n){return e.split("").reduce((function(e,n){return t.insertCharacterAtPosition(e,n,e.length)}),function(e,t){void 0===t&&(t=1);for(var n="",i=0;i<t;i++)n+=e;return n}(" ",n)).length-n},this.getLeftEditablePosition=function(e){for(var n=e;n>=0;n--)if(t.isPositionEditable(n))return n;return null},this.getRightEditablePosition=function(e){for(var n=t.maskOptions.mask,i=e;i<n.length;i++)if(t.isPositionEditable(i))return i;return null},this.formatValue=function(e){var n=t.maskOptions,i=n.maskPlaceholder,r=n.mask;if(!i){for(e=t.insertStringAtPosition("",e,0);e.length<r.length&&!t.isPositionEditable(e.length);)e+=r[e.length];return e}return t.insertStringAtPosition(i,e,0)},this.clearRange=function(e,n,i){if(!i)return e;var r=n+i,a=t.maskOptions,l=a.maskPlaceholder,o=a.mask,u=e.split("").map((function(e,i){var a=t.isPositionEditable(i);return !l&&i>=r&&!a?"":i<n||i>=r?e:a?l?l[i]:"":o[i]})).join("");return t.formatValue(u)},this.insertCharacterAtPosition=function(e,n,i){var r=t.maskOptions,a=r.mask,l=r.maskPlaceholder;if(i>=a.length)return e;var o=t.isCharacterAllowedAtPosition(n,i),u=t.isPositionEditable(i),s=t.getRightEditablePosition(i),c=l&&s?n===l[s]:null,f=e.slice(0,i);!o&&u||(e=f+(o?n:a[i]));return o||u||c||(e=t.insertCharacterAtPosition(e,n,i+1)),e},this.insertStringAtPosition=function(e,n,i){var r=t.maskOptions,a=r.mask,l=r.maskPlaceholder;if(!n||i>=a.length)return e;var o=n.split(""),u=t.isValueFilled(e)||!!l,s=e.slice(i);if(e=o.reduce((function(e,n){return t.insertCharacterAtPosition(e,n,e.length)}),e.slice(0,i)),u)e+=s.slice(e.length-i);else if(t.isValueFilled(e))e+=a.slice(e.length).join("");else {e=s.split("").filter((function(e,n){return t.isPositionEditable(i+n)})).reduce((function(e,n){var i=t.getRightEditablePosition(e.length);return null===i?e:(t.isPositionEditable(e.length)||(e+=a.slice(e.length,i).join("")),t.insertCharacterAtPosition(e,n,e.length))}),e);}return e},this.processChange=function(e,n){var i=t.maskOptions,r=i.mask,a=i.prefix,l=i.lastEditablePosition,o=e.value,u=e.selection,s=n.value,c=n.selection,f=o,h="",g=0,v=0,d=Math.min(c.start,u.start);if(u.end>c.start?(h=f.slice(c.start,u.end),v=(g=t.getStringFillingLengthAtPosition(h,d))?c.length:0):f.length<s.length&&(v=s.length-f.length),f=s,v){if(1===v&&!c.length)d=c.start===u.start?t.getRightEditablePosition(u.start):t.getLeftEditablePosition(u.start);f=t.clearRange(f,d,v);}return f=t.insertStringAtPosition(f,h,d),(d+=g)>=r.length?d=r.length:d<a.length&&!g?d=a.length:d>=a.length&&d<l&&g&&(d=t.getRightEditablePosition(d)),{value:f=t.formatValue(f),enteredString:h,selection:{start:d,end:d}}},this.maskOptions=function(e){var t=e.mask,n=e.maskPlaceholder,i=[];if(!t)return {maskPlaceholder:null,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};if("string"==typeof t){var r=!1,a="";t.split("").forEach((function(e){r||"\\"!==e?(!r&&h[e]||i.push(a.length),a+=e,r=!1):r=!0;})),t=a.split("").map((function(e,t){return -1===i.indexOf(t)?h[e]:e}));}else t.forEach((function(e,t){"string"==typeof e&&i.push(t);}));n&&(n=1===n.length?t.map((function(e,t){return -1!==i.indexOf(t)?e:n})):n.split(""),i.forEach((function(e){n[e]=t[e];})),n=n.join(""));for(var l=i.filter((function(e,t){return e===t})).map((function(e){return t[e]})).join(""),o=t.length-1;-1!==i.indexOf(o);)o--;return {maskPlaceholder:n,prefix:l,mask:t,lastEditablePosition:o,permanents:i}}(e);},v=["alwaysShowMask","children","mask","maskPlaceholder","beforeMaskedStateChange"],d=e.forwardRef((function(r,o){var s=r.alwaysShowMask,h=r.children,d=r.mask,m=r.maskPlaceholder,p=r.beforeMaskedStateChange,k=function(e,t){if(null==e)return {};var n,i,r={},a=Object.keys(e);for(i=0;i<a.length;i++)n=a[i],t.indexOf(n)>=0||(r[n]=e[n]);return r}(r,v);!function(e){var n=e.mask,i=e.maskPlaceholder;n&&i&&1!==i.length&&i.length!==n.length&&t(!1);}(r);var P,b,E=new g({mask:d,maskPlaceholder:m}),S=!!d,C=!k.disabled&&!k.readOnly,w=null!==r.value&&void 0!==r.value,V=(P=S,b=e.useRef(),e.useEffect((function(){b.current=P;})),b.current),F=function(e){return ""+e}((w?r.value:r.defaultValue)||""),y=c(F,S),O=y.inputRef,L=y.getInputState,A=y.setInputState,R=y.getLastInputState,x=u(O);if(S&&w){var M=x(),D=M&&a(M)||s||r.value?E.formatValue(r.value):r.value;p&&(D=p({nextState:{value:D,selection:{start:null,end:null}}}).value),A(n({},R(),{value:D}));}var j=R(),I=j.selection,q=j.value;e.useLayoutEffect((function(){if(S){var e=x();if(e){var t=a(e),i=I,r=L(),l=n({},r);if(!w){var o=r.value,u=E.formatValue(o),c=E.isValueEmpty(u);!c||t||s?l.value=u:c&&!t&&(l.value="");}t&&!V?l.selection=E.getDefaultSelectionForValue(l.value):w&&t&&i&&null!==i.start&&null!==i.end&&(l.selection=i),p&&(l=p({currentState:r,nextState:l})),A(l);}}}));var B=function(e){O.current=e,!function(e){return "function"==typeof e}(o)?null!==o&&"object"==typeof o&&(o.current=e):o(e);},T=n({},k,{onFocus:function(e){O.current=e.target;var t=L().value;if(S&&!E.isValueFilled(t)){var n=E.formatValue(t),a=E.getDefaultSelectionForValue(n),l={value:n,selection:a};p&&(n=(l=p({currentState:L(),nextState:l})).value,a=l.selection),A(l),n!==t&&r.onChange&&r.onChange(e),i((function(){A(R());}));}r.onFocus&&r.onFocus(e);},onBlur:function(e){var t=L().value,n=R().value;if(S&&!s&&E.isValueEmpty(n)){var i="",a={value:i,selection:{start:null,end:null}};p&&(i=(a=p({currentState:L(),nextState:a})).value),A(a),i!==t&&r.onChange&&r.onChange(e);}r.onBlur&&r.onBlur(e);},onChange:S&&C?function(e){var t=L(),n=R(),i=E.processChange(t,n);p&&(i=p({currentState:t,previousState:n,nextState:i})),A(i),r.onChange&&r.onChange(e);}:r.onChange,onMouseDown:S&&C?function(e){var t=x();if(t){var i=L().value,o=l(t);if(!a(t)&&!E.isValueFilled(i)){var u=e.clientX,s=e.clientY,c=(new Date).getTime();o.addEventListener("mouseup",(function e(i){if(o.removeEventListener("mouseup",e),a(t)){var r=Math.abs(i.clientX-u),l=Math.abs(i.clientY-s),f=Math.max(r,l),h=(new Date).getTime()-c;if(f<=10&&h<=200||f<=5&&h<=300){var g=R(),v=n({},g,{selection:E.getDefaultSelectionForValue(g.value)});A(v);}}}));}r.onMouseDown&&r.onMouseDown(e);}}:r.onMouseDown,value:S&&w?q:r.value});if(h){!function(e,n){f.filter((function(t){return null!=n.props[t]&&n.props[t]!==e[t]})).length&&t(!1);}(r,h);var N=e.Children.only(h);return e.cloneElement(N,n({},T,{ref:B}))}return e.createElement("input",n({ref:B},T))}));d.displayName="InputMask",d.defaultProps={alwaysShowMask:!1,maskPlaceholder:"_"},reactInputMask_production_min.exports=d;
	return reactInputMask_production_min.exports;
}

var reactInputMask_development;
var hasRequiredReactInputMask_development;

function requireReactInputMask_development () {
	if (hasRequiredReactInputMask_development) return reactInputMask_development;
	hasRequiredReactInputMask_development = 1;

	var React = React__default;
	var PropTypes$1 = PropTypes;
	var invariant = requireInvariant();
	var warning = requireWarning();

	function _extends() {
	  _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  };
	  return _extends.apply(this, arguments);
	}
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}

	function defer(fn) {
	  return requestAnimationFrame(fn);
	}
	function cancelDefer(deferId) {
	  cancelAnimationFrame(deferId);
	}

	function setInputSelection(input, start, end) {
	  if (end === undefined) {
	    end = start;
	  }
	  input.setSelectionRange(start, end);
	}
	function getInputSelection(input) {
	  var start = input.selectionStart;
	  var end = input.selectionEnd;
	  return {
	    start: start,
	    end: end,
	    length: end - start
	  };
	}
	function isInputFocused(input) {
	  var inputDocument = input.ownerDocument;
	  return inputDocument.hasFocus() && inputDocument.activeElement === input;
	}

	// Element's window may differ from the one within React instance
	// if element rendered within iframe.
	// See https://github.com/sanniassin/react-input-mask/issues/182
	function getElementDocument(element) {
	  return element == null ? void 0 : element.ownerDocument;
	}
	function getElementWindow(element) {
	  var _getElementDocument;
	  return (_getElementDocument = getElementDocument(element)) == null ? void 0 : _getElementDocument.defaultView;
	}
	function isDOMElement(element) {
	  var elementWindow = getElementWindow(element);
	  return !!elementWindow && element instanceof elementWindow.HTMLElement;
	}
	function isFunction(value) {
	  return typeof value === "function";
	}
	function findLastIndex(array, predicate) {
	  for (var i = array.length - 1; i >= 0; i--) {
	    var x = array[i];
	    if (predicate(x, i)) {
	      return i;
	    }
	  }
	  return -1;
	}
	function repeat(string, n) {
	  if (n === void 0) {
	    n = 1;
	  }
	  var result = "";
	  for (var i = 0; i < n; i++) {
	    result += string;
	  }
	  return result;
	}
	function toString(value) {
	  return "" + value;
	}

	function useInputElement(inputRef) {
	  return React.useCallback(function () {
	    var input = inputRef.current;
	    var isDOMNode = typeof window !== "undefined" && isDOMElement(input);

	    // workaround for react-test-renderer
	    // https://github.com/sanniassin/react-input-mask/issues/147
	    if (!input || !isDOMNode) {
	      return null;
	    }
	    if (input.nodeName !== "INPUT") {
	      input = input.querySelector("input");
	    }
	    if (!input) {
	      throw new Error("react-input-mask: inputComponent doesn't contain input node");
	    }
	    return input;
	  }, [inputRef]);
	}
	function useDeferLoop(callback) {
	  var deferIdRef = React.useRef(null);
	  var runLoop = React.useCallback(function () {
	    // If there are simulated focus events, runLoop could be
	    // called multiple times without blur or re-render
	    if (deferIdRef.current !== null) {
	      return;
	    }
	    function loop() {
	      callback();
	      deferIdRef.current = defer(loop);
	    }
	    loop();
	  }, [callback]);
	  var stopLoop = React.useCallback(function () {
	    cancelDefer(deferIdRef.current);
	    deferIdRef.current = null;
	  }, []);
	  React.useEffect(function () {
	    if (deferIdRef.current) {
	      stopLoop();
	      runLoop();
	    }
	  }, [runLoop, stopLoop]);
	  React.useEffect(cancelDefer, []);
	  return [runLoop, stopLoop];
	}
	function useSelection(inputRef, isMasked) {
	  var selectionRef = React.useRef({
	    start: null,
	    end: null
	  });
	  var getInputElement = useInputElement(inputRef);
	  var getSelection = React.useCallback(function () {
	    var input = getInputElement();
	    return getInputSelection(input);
	  }, [getInputElement]);
	  var getLastSelection = React.useCallback(function () {
	    return selectionRef.current;
	  }, []);
	  var setSelection = React.useCallback(function (selection) {
	    var input = getInputElement();

	    // Don't change selection on unfocused input
	    // because Safari sets focus on selection change (#154)
	    if (!input || !isInputFocused(input)) {
	      return;
	    }
	    setInputSelection(input, selection.start, selection.end);

	    // Use actual selection in case the requested one was out of range
	    selectionRef.current = getSelection();
	  }, [getInputElement, getSelection]);
	  var selectionLoop = React.useCallback(function () {
	    selectionRef.current = getSelection();
	  }, [getSelection]);
	  var _useDeferLoop = useDeferLoop(selectionLoop),
	    runSelectionLoop = _useDeferLoop[0],
	    stopSelectionLoop = _useDeferLoop[1];
	  React.useLayoutEffect(function () {
	    if (!isMasked) {
	      return;
	    }
	    var input = getInputElement();
	    input.addEventListener("focus", runSelectionLoop);
	    input.addEventListener("blur", stopSelectionLoop);
	    if (isInputFocused(input)) {
	      runSelectionLoop();
	    }
	    return function () {
	      input.removeEventListener("focus", runSelectionLoop);
	      input.removeEventListener("blur", stopSelectionLoop);
	      stopSelectionLoop();
	    };
	  });
	  return {
	    getSelection: getSelection,
	    getLastSelection: getLastSelection,
	    setSelection: setSelection
	  };
	}
	function useValue(inputRef, initialValue) {
	  var getInputElement = useInputElement(inputRef);
	  var valueRef = React.useRef(initialValue);
	  var getValue = React.useCallback(function () {
	    var input = getInputElement();
	    return input.value;
	  }, [getInputElement]);
	  var getLastValue = React.useCallback(function () {
	    return valueRef.current;
	  }, []);
	  var setValue = React.useCallback(function (newValue) {
	    valueRef.current = newValue;
	    var input = getInputElement();
	    if (input) {
	      input.value = newValue;
	    }
	  }, [getInputElement]);
	  return {
	    getValue: getValue,
	    getLastValue: getLastValue,
	    setValue: setValue
	  };
	}
	function useInputState(initialValue, isMasked) {
	  var inputRef = React.useRef();
	  var _useSelection = useSelection(inputRef, isMasked),
	    getSelection = _useSelection.getSelection,
	    getLastSelection = _useSelection.getLastSelection,
	    setSelection = _useSelection.setSelection;
	  var _useValue = useValue(inputRef, initialValue),
	    getValue = _useValue.getValue,
	    getLastValue = _useValue.getLastValue,
	    setValue = _useValue.setValue;
	  function getLastInputState() {
	    return {
	      value: getLastValue(),
	      selection: getLastSelection()
	    };
	  }
	  function getInputState() {
	    return {
	      value: getValue(),
	      selection: getSelection()
	    };
	  }
	  function setInputState(_ref) {
	    var value = _ref.value,
	      selection = _ref.selection;
	    setValue(value);
	    setSelection(selection);
	  }
	  return {
	    inputRef: inputRef,
	    getInputState: getInputState,
	    getLastInputState: getLastInputState,
	    setInputState: setInputState
	  };
	}
	function usePrevious(value) {
	  var ref = React.useRef();
	  React.useEffect(function () {
	    ref.current = value;
	  });
	  return ref.current;
	}

	var CONTROLLED_PROPS = ["disabled", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"];
	var defaultFormatChars = {
	  9: /[0-9]/,
	  a: /[A-Za-z]/,
	  "*": /[A-Za-z0-9]/
	};

	function validateMaxLength(props) {
	  process.env.NODE_ENV !== "production" ? warning(!props.maxLength || !props.mask, "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.") : void 0;
	}
	function validateMaskPlaceholder(props) {
	  var mask = props.mask,
	    maskPlaceholder = props.maskPlaceholder;
	  !(!mask || !maskPlaceholder || maskPlaceholder.length === 1 || maskPlaceholder.length === mask.length) ? process.env.NODE_ENV !== "production" ? invariant(false, "react-input-mask: maskPlaceholder should either be a single character or have the same length as the mask:\n" + ("mask: " + mask + "\n") + ("maskPlaceholder: " + maskPlaceholder)) : invariant(false) : void 0;
	}
	function validateChildren(props, inputElement) {
	  var conflictProps = CONTROLLED_PROPS.filter(function (propId) {
	    return inputElement.props[propId] != null && inputElement.props[propId] !== props[propId];
	  });
	  !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant(false, "react-input-mask: the following props should be passed to the InputMask component, not to children: " + conflictProps.join(",")) : invariant(false) : void 0;
	}

	var parseMask = function parseMask(_ref) {
	  var mask = _ref.mask,
	    maskPlaceholder = _ref.maskPlaceholder;
	  var permanents = [];
	  if (!mask) {
	    return {
	      maskPlaceholder: null,
	      mask: null,
	      prefix: null,
	      lastEditablePosition: null,
	      permanents: []
	    };
	  }
	  if (typeof mask === "string") {
	    var isPermanent = false;
	    var parsedMaskString = "";
	    mask.split("").forEach(function (character) {
	      if (!isPermanent && character === "\\") {
	        isPermanent = true;
	      } else {
	        if (isPermanent || !defaultFormatChars[character]) {
	          permanents.push(parsedMaskString.length);
	        }
	        parsedMaskString += character;
	        isPermanent = false;
	      }
	    });
	    mask = parsedMaskString.split("").map(function (character, index) {
	      if (permanents.indexOf(index) === -1) {
	        return defaultFormatChars[character];
	      }
	      return character;
	    });
	  } else {
	    mask.forEach(function (character, index) {
	      if (typeof character === "string") {
	        permanents.push(index);
	      }
	    });
	  }
	  if (maskPlaceholder) {
	    if (maskPlaceholder.length === 1) {
	      maskPlaceholder = mask.map(function (character, index) {
	        if (permanents.indexOf(index) !== -1) {
	          return character;
	        }
	        return maskPlaceholder;
	      });
	    } else {
	      maskPlaceholder = maskPlaceholder.split("");
	    }
	    permanents.forEach(function (position) {
	      maskPlaceholder[position] = mask[position];
	    });
	    maskPlaceholder = maskPlaceholder.join("");
	  }
	  var prefix = permanents.filter(function (position, index) {
	    return position === index;
	  }).map(function (position) {
	    return mask[position];
	  }).join("");
	  var lastEditablePosition = mask.length - 1;
	  while (permanents.indexOf(lastEditablePosition) !== -1) {
	    lastEditablePosition--;
	  }
	  return {
	    maskPlaceholder: maskPlaceholder,
	    prefix: prefix,
	    mask: mask,
	    lastEditablePosition: lastEditablePosition,
	    permanents: permanents
	  };
	};

	/* eslint no-use-before-define: ["error", { functions: false }] */
	var MaskUtils = function MaskUtils(options) {
	  var _this = this;
	  this.isCharacterAllowedAtPosition = function (character, position) {
	    var maskPlaceholder = _this.maskOptions.maskPlaceholder;
	    if (_this.isCharacterFillingPosition(character, position)) {
	      return true;
	    }
	    if (!maskPlaceholder) {
	      return false;
	    }
	    return maskPlaceholder[position] === character;
	  };
	  this.isCharacterFillingPosition = function (character, position) {
	    var mask = _this.maskOptions.mask;
	    if (!character || position >= mask.length) {
	      return false;
	    }
	    if (!_this.isPositionEditable(position)) {
	      return mask[position] === character;
	    }
	    var charRule = mask[position];
	    return new RegExp(charRule).test(character);
	  };
	  this.isPositionEditable = function (position) {
	    var _this$maskOptions = _this.maskOptions,
	      mask = _this$maskOptions.mask,
	      permanents = _this$maskOptions.permanents;
	    return position < mask.length && permanents.indexOf(position) === -1;
	  };
	  this.isValueEmpty = function (value) {
	    return value.split("").every(function (character, position) {
	      return !_this.isPositionEditable(position) || !_this.isCharacterFillingPosition(character, position);
	    });
	  };
	  this.isValueFilled = function (value) {
	    return _this.getFilledLength(value) === _this.maskOptions.lastEditablePosition + 1;
	  };
	  this.getDefaultSelectionForValue = function (value) {
	    var filledLength = _this.getFilledLength(value);
	    var cursorPosition = _this.getRightEditablePosition(filledLength);
	    return {
	      start: cursorPosition,
	      end: cursorPosition
	    };
	  };
	  this.getFilledLength = function (value) {
	    var characters = value.split("");
	    var lastFilledIndex = findLastIndex(characters, function (character, position) {
	      return _this.isPositionEditable(position) && _this.isCharacterFillingPosition(character, position);
	    });
	    return lastFilledIndex + 1;
	  };
	  this.getStringFillingLengthAtPosition = function (string, position) {
	    var characters = string.split("");
	    var insertedValue = characters.reduce(function (value, character) {
	      return _this.insertCharacterAtPosition(value, character, value.length);
	    }, repeat(" ", position));
	    return insertedValue.length - position;
	  };
	  this.getLeftEditablePosition = function (position) {
	    for (var i = position; i >= 0; i--) {
	      if (_this.isPositionEditable(i)) {
	        return i;
	      }
	    }
	    return null;
	  };
	  this.getRightEditablePosition = function (position) {
	    var mask = _this.maskOptions.mask;
	    for (var i = position; i < mask.length; i++) {
	      if (_this.isPositionEditable(i)) {
	        return i;
	      }
	    }
	    return null;
	  };
	  this.formatValue = function (value) {
	    var _this$maskOptions2 = _this.maskOptions,
	      maskPlaceholder = _this$maskOptions2.maskPlaceholder,
	      mask = _this$maskOptions2.mask;
	    if (!maskPlaceholder) {
	      value = _this.insertStringAtPosition("", value, 0);
	      while (value.length < mask.length && !_this.isPositionEditable(value.length)) {
	        value += mask[value.length];
	      }
	      return value;
	    }
	    return _this.insertStringAtPosition(maskPlaceholder, value, 0);
	  };
	  this.clearRange = function (value, start, len) {
	    if (!len) {
	      return value;
	    }
	    var end = start + len;
	    var _this$maskOptions3 = _this.maskOptions,
	      maskPlaceholder = _this$maskOptions3.maskPlaceholder,
	      mask = _this$maskOptions3.mask;
	    var clearedValue = value.split("").map(function (character, i) {
	      var isEditable = _this.isPositionEditable(i);
	      if (!maskPlaceholder && i >= end && !isEditable) {
	        return "";
	      }
	      if (i < start || i >= end) {
	        return character;
	      }
	      if (!isEditable) {
	        return mask[i];
	      }
	      if (maskPlaceholder) {
	        return maskPlaceholder[i];
	      }
	      return "";
	    }).join("");
	    return _this.formatValue(clearedValue);
	  };
	  this.insertCharacterAtPosition = function (value, character, position) {
	    var _this$maskOptions4 = _this.maskOptions,
	      mask = _this$maskOptions4.mask,
	      maskPlaceholder = _this$maskOptions4.maskPlaceholder;
	    if (position >= mask.length) {
	      return value;
	    }
	    var isAllowed = _this.isCharacterAllowedAtPosition(character, position);
	    var isEditable = _this.isPositionEditable(position);
	    var nextEditablePosition = _this.getRightEditablePosition(position);
	    var isNextPlaceholder = maskPlaceholder && nextEditablePosition ? character === maskPlaceholder[nextEditablePosition] : null;
	    var valueBefore = value.slice(0, position);
	    if (isAllowed || !isEditable) {
	      var insertedCharacter = isAllowed ? character : mask[position];
	      value = valueBefore + insertedCharacter;
	    }
	    if (!isAllowed && !isEditable && !isNextPlaceholder) {
	      value = _this.insertCharacterAtPosition(value, character, position + 1);
	    }
	    return value;
	  };
	  this.insertStringAtPosition = function (value, string, position) {
	    var _this$maskOptions5 = _this.maskOptions,
	      mask = _this$maskOptions5.mask,
	      maskPlaceholder = _this$maskOptions5.maskPlaceholder;
	    if (!string || position >= mask.length) {
	      return value;
	    }
	    var characters = string.split("");
	    var isFixedLength = _this.isValueFilled(value) || !!maskPlaceholder;
	    var valueAfter = value.slice(position);
	    value = characters.reduce(function (value, character) {
	      return _this.insertCharacterAtPosition(value, character, value.length);
	    }, value.slice(0, position));
	    if (isFixedLength) {
	      value += valueAfter.slice(value.length - position);
	    } else if (_this.isValueFilled(value)) {
	      value += mask.slice(value.length).join("");
	    } else {
	      var editableCharactersAfter = valueAfter.split("").filter(function (character, i) {
	        return _this.isPositionEditable(position + i);
	      });
	      value = editableCharactersAfter.reduce(function (value, character) {
	        var nextEditablePosition = _this.getRightEditablePosition(value.length);
	        if (nextEditablePosition === null) {
	          return value;
	        }
	        if (!_this.isPositionEditable(value.length)) {
	          value += mask.slice(value.length, nextEditablePosition).join("");
	        }
	        return _this.insertCharacterAtPosition(value, character, value.length);
	      }, value);
	    }
	    return value;
	  };
	  this.processChange = function (currentState, previousState) {
	    var _this$maskOptions6 = _this.maskOptions,
	      mask = _this$maskOptions6.mask,
	      prefix = _this$maskOptions6.prefix,
	      lastEditablePosition = _this$maskOptions6.lastEditablePosition;
	    var value = currentState.value,
	      selection = currentState.selection;
	    var previousValue = previousState.value;
	    var previousSelection = previousState.selection;
	    var newValue = value;
	    var enteredString = "";
	    var formattedEnteredStringLength = 0;
	    var removedLength = 0;
	    var cursorPosition = Math.min(previousSelection.start, selection.start);
	    if (selection.end > previousSelection.start) {
	      enteredString = newValue.slice(previousSelection.start, selection.end);
	      formattedEnteredStringLength = _this.getStringFillingLengthAtPosition(enteredString, cursorPosition);
	      if (!formattedEnteredStringLength) {
	        removedLength = 0;
	      } else {
	        removedLength = previousSelection.length;
	      }
	    } else if (newValue.length < previousValue.length) {
	      removedLength = previousValue.length - newValue.length;
	    }
	    newValue = previousValue;
	    if (removedLength) {
	      if (removedLength === 1 && !previousSelection.length) {
	        var deleteFromRight = previousSelection.start === selection.start;
	        cursorPosition = deleteFromRight ? _this.getRightEditablePosition(selection.start) : _this.getLeftEditablePosition(selection.start);
	      }
	      newValue = _this.clearRange(newValue, cursorPosition, removedLength);
	    }
	    newValue = _this.insertStringAtPosition(newValue, enteredString, cursorPosition);
	    cursorPosition += formattedEnteredStringLength;
	    if (cursorPosition >= mask.length) {
	      cursorPosition = mask.length;
	    } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
	      cursorPosition = prefix.length;
	    } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
	      cursorPosition = _this.getRightEditablePosition(cursorPosition);
	    }
	    newValue = _this.formatValue(newValue);
	    return {
	      value: newValue,
	      enteredString: enteredString,
	      selection: {
	        start: cursorPosition,
	        end: cursorPosition
	      }
	    };
	  };
	  this.maskOptions = parseMask(options);
	};

	var _excluded = ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"];

	// eslint-disable-next-line prefer-arrow-callback
	var InputMask = /*#__PURE__*/React.forwardRef(function InputMask(props, forwardedRef) {
	  var alwaysShowMask = props.alwaysShowMask,
	    children = props.children,
	    mask = props.mask,
	    maskPlaceholder = props.maskPlaceholder,
	    beforeMaskedStateChange = props.beforeMaskedStateChange,
	    restProps = _objectWithoutPropertiesLoose(props, _excluded);
	  validateMaxLength(props);
	  validateMaskPlaceholder(props);
	  var maskUtils = new MaskUtils({
	    mask: mask,
	    maskPlaceholder: maskPlaceholder
	  });
	  var isMasked = !!mask;
	  var isEditable = !restProps.disabled && !restProps.readOnly;
	  var isControlled = props.value !== null && props.value !== undefined;
	  var previousIsMasked = usePrevious(isMasked);
	  var initialValue = toString((isControlled ? props.value : props.defaultValue) || "");
	  var _useInputState = useInputState(initialValue, isMasked),
	    inputRef = _useInputState.inputRef,
	    getInputState = _useInputState.getInputState,
	    setInputState = _useInputState.setInputState,
	    getLastInputState = _useInputState.getLastInputState;
	  var getInputElement = useInputElement(inputRef);
	  function onChange(event) {
	    var currentState = getInputState();
	    var previousState = getLastInputState();
	    var newInputState = maskUtils.processChange(currentState, previousState);
	    if (beforeMaskedStateChange) {
	      newInputState = beforeMaskedStateChange({
	        currentState: currentState,
	        previousState: previousState,
	        nextState: newInputState
	      });
	    }
	    setInputState(newInputState);
	    if (props.onChange) {
	      props.onChange(event);
	    }
	  }
	  function onFocus(event) {
	    // If autoFocus property is set, focus event fires before the ref handler gets called
	    inputRef.current = event.target;
	    var currentValue = getInputState().value;
	    if (isMasked && !maskUtils.isValueFilled(currentValue)) {
	      var newValue = maskUtils.formatValue(currentValue);
	      var newSelection = maskUtils.getDefaultSelectionForValue(newValue);
	      var newInputState = {
	        value: newValue,
	        selection: newSelection
	      };
	      if (beforeMaskedStateChange) {
	        newInputState = beforeMaskedStateChange({
	          currentState: getInputState(),
	          nextState: newInputState
	        });
	        newValue = newInputState.value;
	        newSelection = newInputState.selection;
	      }
	      setInputState(newInputState);
	      if (newValue !== currentValue && props.onChange) {
	        props.onChange(event);
	      }

	      // Chrome resets selection after focus event,
	      // so we want to restore it later
	      defer(function () {
	        setInputState(getLastInputState());
	      });
	    }
	    if (props.onFocus) {
	      props.onFocus(event);
	    }
	  }
	  function onBlur(event) {
	    var currentValue = getInputState().value;
	    var lastValue = getLastInputState().value;
	    if (isMasked && !alwaysShowMask && maskUtils.isValueEmpty(lastValue)) {
	      var newValue = "";
	      var newInputState = {
	        value: newValue,
	        selection: {
	          start: null,
	          end: null
	        }
	      };
	      if (beforeMaskedStateChange) {
	        newInputState = beforeMaskedStateChange({
	          currentState: getInputState(),
	          nextState: newInputState
	        });
	        newValue = newInputState.value;
	      }
	      setInputState(newInputState);
	      if (newValue !== currentValue && props.onChange) {
	        props.onChange(event);
	      }
	    }
	    if (props.onBlur) {
	      props.onBlur(event);
	    }
	  }

	  // Tiny unintentional mouse movements can break cursor
	  // position on focus, so we have to restore it in that case
	  //
	  // https://github.com/sanniassin/react-input-mask/issues/108
	  function onMouseDown(event) {
	    var input = getInputElement();
	    if (!input) {
	      return;
	    }
	    var _getInputState = getInputState(),
	      value = _getInputState.value;
	    var inputDocument = getElementDocument(input);
	    if (!isInputFocused(input) && !maskUtils.isValueFilled(value)) {
	      var mouseDownX = event.clientX;
	      var mouseDownY = event.clientY;
	      var mouseDownTime = new Date().getTime();
	      var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
	        inputDocument.removeEventListener("mouseup", mouseUpHandler);
	        if (!isInputFocused(input)) {
	          return;
	        }
	        var deltaX = Math.abs(mouseUpEvent.clientX - mouseDownX);
	        var deltaY = Math.abs(mouseUpEvent.clientY - mouseDownY);
	        var axisDelta = Math.max(deltaX, deltaY);
	        var timeDelta = new Date().getTime() - mouseDownTime;
	        if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
	          var _lastState = getLastInputState();
	          var newSelection = maskUtils.getDefaultSelectionForValue(_lastState.value);
	          var newState = _extends({}, _lastState, {
	            selection: newSelection
	          });
	          setInputState(newState);
	        }
	      };
	      inputDocument.addEventListener("mouseup", mouseUpHandler);
	    }
	    if (props.onMouseDown) {
	      props.onMouseDown(event);
	    }
	  }

	  // For controlled inputs we want to provide properly formatted
	  // value prop
	  if (isMasked && isControlled) {
	    var input = getInputElement();
	    var isFocused = input && isInputFocused(input);
	    var newValue = isFocused || alwaysShowMask || props.value ? maskUtils.formatValue(props.value) : props.value;
	    if (beforeMaskedStateChange) {
	      newValue = beforeMaskedStateChange({
	        nextState: {
	          value: newValue,
	          selection: {
	            start: null,
	            end: null
	          }
	        }
	      }).value;
	    }
	    setInputState(_extends({}, getLastInputState(), {
	      value: newValue
	    }));
	  }
	  var lastState = getLastInputState();
	  var lastSelection = lastState.selection;
	  var lastValue = lastState.value;
	  React.useLayoutEffect(function () {
	    if (!isMasked) {
	      return;
	    }
	    var input = getInputElement();
	    if (!input) {
	      return;
	    }
	    var isFocused = isInputFocused(input);
	    var previousSelection = lastSelection;
	    var currentState = getInputState();
	    var newInputState = _extends({}, currentState);

	    // Update value for uncontrolled inputs to make sure
	    // it's always in sync with mask props
	    if (!isControlled) {
	      var currentValue = currentState.value;
	      var formattedValue = maskUtils.formatValue(currentValue);
	      var isValueEmpty = maskUtils.isValueEmpty(formattedValue);
	      var shouldFormatValue = !isValueEmpty || isFocused || alwaysShowMask;
	      if (shouldFormatValue) {
	        newInputState.value = formattedValue;
	      } else if (isValueEmpty && !isFocused) {
	        newInputState.value = "";
	      }
	    }
	    if (isFocused && !previousIsMasked) {
	      // Adjust selection if input got masked while being focused
	      newInputState.selection = maskUtils.getDefaultSelectionForValue(newInputState.value);
	    } else if (isControlled && isFocused && previousSelection) {
	      // Restore cursor position if value has changed outside change event
	      if (previousSelection.start !== null && previousSelection.end !== null) {
	        newInputState.selection = previousSelection;
	      }
	    }
	    if (beforeMaskedStateChange) {
	      newInputState = beforeMaskedStateChange({
	        currentState: currentState,
	        nextState: newInputState
	      });
	    }
	    setInputState(newInputState);
	  });
	  var refCallback = function refCallback(node) {
	    inputRef.current = node;

	    // if a ref callback is passed to InputMask
	    if (isFunction(forwardedRef)) {
	      forwardedRef(node);
	    } else if (forwardedRef !== null && typeof forwardedRef === "object") {
	      forwardedRef.current = node;
	    }
	  };
	  var inputProps = _extends({}, restProps, {
	    onFocus: onFocus,
	    onBlur: onBlur,
	    onChange: isMasked && isEditable ? onChange : props.onChange,
	    onMouseDown: isMasked && isEditable ? onMouseDown : props.onMouseDown,
	    value: isMasked && isControlled ? lastValue : props.value
	  });
	  if (children) {
	    validateChildren(props, children);

	    // {@link https://stackoverflow.com/q/63149840/327074}
	    var onlyChild = React.Children.only(children);
	    return /*#__PURE__*/React.cloneElement(onlyChild, _extends({}, inputProps, {
	      ref: refCallback
	    }));
	  }
	  return /*#__PURE__*/React.createElement("input", _extends({
	    ref: refCallback
	  }, inputProps));
	});
	InputMask.displayName = "InputMask";
	InputMask.defaultProps = {
	  alwaysShowMask: false,
	  maskPlaceholder: "_"
	};
	InputMask.propTypes = {
	  alwaysShowMask: PropTypes$1.bool,
	  beforeMaskedStateChange: PropTypes$1.func,
	  children: PropTypes$1.element,
	  mask: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.instanceOf(RegExp)]))]),
	  maskPlaceholder: PropTypes$1.string,
	  onFocus: PropTypes$1.func,
	  onBlur: PropTypes$1.func,
	  onChange: PropTypes$1.func,
	  onMouseDown: PropTypes$1.func
	};

	reactInputMask_development = InputMask;
	return reactInputMask_development;
}

/* eslint-disable import/no-unresolved */

var hasRequiredReactInputMask;

function requireReactInputMask () {
	if (hasRequiredReactInputMask) return reactInputMask.exports;
	hasRequiredReactInputMask = 1;
	if (process.env.NODE_ENV === "production") {
	  reactInputMask.exports = requireReactInputMask_production_min();
	} else {
	  reactInputMask.exports = requireReactInputMask_development();
	}
	return reactInputMask.exports;
}

var reactInputMaskExports = requireReactInputMask();
var Input$2 = /*@__PURE__*/getDefaultExportFromCjs(reactInputMaskExports);

var InputMask = function (_a) {
    var _b = _a.mask, mask = _b === void 0 ? '99.99.9999' : _b, _c = _a.className, className = _c === void 0 ? 'form-control' : _c, _d = _a.maskChar, maskChar = _d === void 0 ? '_' : _d, rest = __rest$1(_a, ["mask", "className", "maskChar"]);
    return (jsx$1(Input$2, __assign$1({ mask: mask, className: className, maskPlaceholder: maskChar }, rest)));
};

/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */


/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = 604800000;

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = 86400000;

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
const millisecondsInMinute = 60000;

/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */
const millisecondsInHour = 3600000;

/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */
const millisecondsInSecond = 1000;

/**
 * @constant
 * @name constructFromSymbol
 * @summary Symbol enabling Date extensions to inherit properties from the reference date.
 *
 * The symbol is used to enable the `constructFrom` function to construct a date
 * using a reference date and a value. It allows to transfer extra properties
 * from the reference date to the new date. It's useful for extensions like
 * [`TZDate`](https://github.com/date-fns/tz) that accept a time zone as
 * a constructor argument.
 */
const constructFromSymbol = Symbol.for("constructDateFrom");

/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * Starting from v3.7.0, it allows to construct a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from "./constructFrom/date-fns";
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date>(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use constructor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   );
 * }
 */
function constructFrom(date, value) {
  if (typeof date === "function") return date(value);

  if (date && typeof date === "object" && constructFromSymbol in date)
    return date[constructFromSymbol](value);

  if (date instanceof Date) return new date.constructor(value);

  return new Date(value);
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * Starting from v3.7.0, it clones a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument, context) {
  // [TODO] Get rid of `toDate` or `constructFrom`?
  return constructFrom(context || argument, argument);
}

/**
 * The {@link addDays} function options.
 */

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 * @param options - An object with options
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(date, amount, options) {
  const _date = toDate(date, options?.in);
  if (isNaN(amount)) return constructFrom(options?.in || date, NaN);

  // If 0 days, no-op to avoid changing times in the hour before end of DST
  if (!amount) return _date;

  _date.setDate(_date.getDate() + amount);
  return _date;
}

/**
 * The {@link addMonths} function options.
 */

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 * @param options - The options object
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */
function addMonths(date, amount, options) {
  const _date = toDate(date, options?.in);
  if (isNaN(amount)) return constructFrom(options?.in || date, NaN);
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  const dayOfMonth = _date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  const endOfDesiredMonth = constructFrom(options?.in || date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}

let defaultOptions = {};

function getDefaultOptions$1() {
  return defaultOptions;
}

/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = getDefaultOptions$1();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date, options?.in);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * The {@link startOfISOWeek} function options.
 */

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date, options) {
  return startOfWeek(date, { ...options, weekStartsOn: 1 });
}

/**
 * The {@link getISOWeekYear} function options.
 */

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = constructFrom(_date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);

  const fourthOfJanuaryOfThisYear = constructFrom(_date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

function normalizeDates(context, ...dates) {
  const normalize = constructFrom.bind(
    null,
    context || dates.find((date) => typeof date === "object"),
  );
  return dates.map(normalize);
}

/**
 * The {@link startOfDay} function options.
 */

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date, options) {
  const _date = toDate(date, options?.in);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * The {@link differenceInCalendarDays} function options.
 */

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - The options object
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options?.in,
    laterDate,
    earlierDate,
  );

  const laterStartOfDay = startOfDay(laterDate_);
  const earlierStartOfDay = startOfDay(earlierDate_);

  const laterTimestamp =
    +laterStartOfDay - getTimezoneOffsetInMilliseconds(laterStartOfDay);
  const earlierTimestamp =
    +earlierStartOfDay - getTimezoneOffsetInMilliseconds(earlierStartOfDay);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((laterTimestamp - earlierTimestamp) / millisecondsInDay);
}

/**
 * The {@link startOfISOWeekYear} function options.
 */

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date, options) {
  const year = getISOWeekYear(date, options);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

/**
 * The {@link addWeeks} function options.
 */

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of weeks to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 * @param options - An object with options
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(date, amount, options) {
  return addDays(date, amount * 7, options);
}

/**
 * The {@link addYears} function options.
 */

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 * @param options - The options
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(date, amount, options) {
  return addMonths(date, amount * 12, options);
}

/**
 * The {@link max} function options.
 */

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max$1(dates, options) {
  let result;
  let context = options?.in;

  dates.forEach((date) => {
    // Use the first date object as the context function
    if (!context && typeof date === "object")
      context = constructFrom.bind(null, date);

    const date_ = toDate(date, context);
    if (!result || result < date_ || isNaN(+date_)) result = date_;
  });

  return constructFrom(context, result || NaN);
}

/**
 * The {@link min} function options.
 */

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min$1(dates, options) {
  let result;
  let context = options?.in;

  dates.forEach((date) => {
    // Use the first date object as the context function
    if (!context && typeof date === "object")
      context = constructFrom.bind(null, date);

    const date_ = toDate(date, context);
    if (!result || result > date_ || isNaN(+date_)) result = date_;
  });

  return constructFrom(context, result || NaN);
}

/**
 * The {@link isSameDay} function options.
 */

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(laterDate, earlierDate, options) {
  const [dateLeft_, dateRight_] = normalizeDates(
    options?.in,
    laterDate,
    earlierDate,
  );
  return +startOfDay(dateLeft_) === +startOfDay(dateRight_);
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate$1(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertible into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(date) {
  return !((!isDate$1(date) && typeof date !== "number") || isNaN(+toDate(date)));
}

/**
 * The {@link differenceInCalendarMonths} function options.
 */

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - An object with options
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options?.in,
    laterDate,
    earlierDate,
  );

  const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
  const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();

  return yearsDiff * 12 + monthsDiff;
}

/**
 * The {@link endOfMonth} function options.
 */

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

/**
 * The {@link startOfMonth} function options.
 */

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date. The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments.
 * Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed,
 * or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * The {@link endOfYear} function options.
 */

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

/**
 * The {@link startOfYear} function options.
 */

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date, options) {
  const date_ = toDate(date, options?.in);
  date_.setFullYear(date_.getFullYear(), 0, 1);
  date_.setHours(0, 0, 0, 0);
  return date_;
}

/**
 * The {@link endOfWeek} function options.
 */

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(date, options) {
  const defaultOptions = getDefaultOptions$1();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date, options?.in);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

/**
 * The {@link endOfISOWeek} function options.
 */

/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek(date, options) {
  return endOfWeek(date, { ...options, weekStartsOn: 1 });
}

const formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance$1 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

const dateFormats$1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full",
  }),

  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full",
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full",
  }),
};

const formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative$1 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$1[token];

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

const eraValues$1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues$1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber$1 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

const localize$1 = {
  ordinalNumber: ordinalNumber$1,

  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: "wide",
  }),

  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide",
  }),

  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide",
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide",
  }),
};

function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex$1(parsePatterns, (pattern) => pattern.test(matchedString))
      : // [TODO] -- I challenge you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // [TODO] -- I challenge you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex$1(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // [TODO] I challenge you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

const matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$1 = /\d+/i;

const matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns$1 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

const match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any",
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any",
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any",
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any",
  }),
};

/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$2,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

/**
 * The {@link getDayOfYear} function options.
 */

/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date, options) {
  const _date = toDate(date, options?.in);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

/**
 * The {@link getISOWeek} function options.
 */

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date, options) {
  const _date = toDate(date, options?.in);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();

  const defaultOptions = getDefaultOptions$1();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = constructFrom(options?.in || date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);

  const firstWeekOfThisYear = constructFrom(options?.in || date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);

  if (+_date >= +startOfNextYear) {
    return year + 1;
  } else if (+_date >= +startOfThisYear) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = getDefaultOptions$1();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(options?.in || date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */
function getWeek(date, options) {
  const _date = toDate(date, options?.in);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },

  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  },
};

const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = getWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = getISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = getWeek(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return addLeadingZeros(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = getISOWeek(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return addLeadingZeros(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = getDayOfYear(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(+date / 1000);
    return addLeadingZeros(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    return addLeadingZeros(+date, token.length);
  },
};

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
};

const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp$1 =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp$1 = /^'([^]*?)'?$/;
const doubleQuoteRegExp$1 = /''/g;
const unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;

/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format$1(date, formatStr, options) {
  const defaultOptions = getDefaultOptions$1();
  const locale = options?.locale ?? defaultOptions.locale ?? enUS;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = toDate(date, options?.in);

  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp$1)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp$1)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString$1(substring) };
      }

      if (formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (!options?.useAdditionalWeekYearTokens &&
          isProtectedWeekYearToken(token)) ||
        (!options?.useAdditionalDayOfYearTokens &&
          isProtectedDayOfYearToken(token))
      ) {
        warnOrThrowProtectedError(token, formatStr, String(date));
      }

      const formatter = formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString$1(input) {
  const matched = input.match(escapedStringRegExp$1);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp$1, "'");
}

/**
 * The {@link getDaysInMonth} function options.
 */

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date, considering the context if provided.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(_date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */
function getDefaultOptions() {
  return Object.assign({}, getDefaultOptions$1());
}

/**
 * The {@link getISODay} function options.
 */

/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay(date, options) {
  const day = toDate(date, options?.in).getDay();
  return day === 0 ? 7 : day;
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(date, dateToCompare) {
  return +toDate(date) > +toDate(dateToCompare);
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(date, dateToCompare) {
  return +toDate(date) < +toDate(dateToCompare);
}

/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam InputDate - The input `Date` type derived from the passed argument.
 * @typeParam ResultDate - The result `Date` type derived from the passed constructor.
 *
 * @param date - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */
function transpose(date, constructor) {
  const date_ = isConstructor(constructor)
    ? new constructor(0)
    : constructFrom(constructor, 0);
  date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
  date_.setHours(
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds(),
  );
  return date_;
}

function isConstructor(constructor) {
  return (
    typeof constructor === "function" &&
    constructor.prototype?.constructor === constructor
  );
}

const TIMEZONE_UNIT_PRIORITY = 10;

class Setter {
  subPriority = 0;

  validate(_utcDate, _options) {
    return true;
  }
}

class ValueSetter extends Setter {
  constructor(
    value,

    validateValue,

    setValue,

    priority,
    subPriority,
  ) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }

  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }

  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
}

class DateTimezoneSetter extends Setter {
  priority = TIMEZONE_UNIT_PRIORITY;
  subPriority = -1;

  constructor(context, reference) {
    super();
    this.context = context || ((date) => constructFrom(reference, date));
  }

  set(date, flags) {
    if (flags.timestampIsSet) return date;
    return constructFrom(date, transpose(date, this.context));
  }
}

class Parser {
  run(dateString, token, match, options) {
    const result = this.parse(dateString, token, match, options);
    if (!result) {
      return null;
    }

    return {
      setter: new ValueSetter(
        result.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority,
      ),
      rest: result.rest,
    };
  }

  validate(_utcDate, _value, _options) {
    return true;
  }
}

class EraParser extends Parser {
  priority = 140;

  parse(dateString, token, match) {
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return (
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );

      // A, B
      case "GGGGG":
        return match.era(dateString, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return (
          match.era(dateString, { width: "wide" }) ||
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );
    }
  }

  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["R", "u", "t", "T"];
}

const numericPatterns = {
  month: /^(1[0-2]|0?\d)/, // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/, // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/, // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/, // 0 to 12
  minute: /^[0-5]?\d/, // 0 to 59
  second: /^[0-5]?\d/, // 0 to 59

  singleDigit: /^\d/, // 0 to 9
  twoDigits: /^\d{1,2}/, // 0 to 99
  threeDigits: /^\d{1,3}/, // 0 to 999
  fourDigits: /^\d{1,4}/, // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/, // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/, // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/, // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/, // 0 to 9999, -0 to -9999
};

const timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/,
};

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest,
  };
}

function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1),
    };
  }

  const sign = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;

  return {
    value:
      sign *
      (hours * millisecondsInHour +
        minutes * millisecondsInMinute +
        seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}

function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}

function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}

function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;

  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class YearParser extends Parser {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "yy",
    });

    switch (token) {
      case "y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "yo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value) {
    const currentYear = date.getFullYear();

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear,
      );
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

// Local week-numbering year
class LocalWeekYearParser extends Parser {
  priority = 130;

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "YY",
    });

    switch (token) {
      case "Y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "Yo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value, options) {
    const currentYear = getWeekYear(date, options);

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear,
      );
      date.setFullYear(
        normalizedTwoDigitYear,
        0,
        options.firstWeekContainsDate,
      );
      date.setHours(0, 0, 0, 0);
      return startOfWeek(date, options);
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return startOfWeek(date, options);
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}

// ISO week-numbering year
class ISOWeekYearParser extends Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "R") {
      return parseNDigitsSigned(4, dateString);
    }

    return parseNDigitsSigned(token.length, dateString);
  }

  set(date, _flags, value) {
    const firstWeekOfYear = constructFrom(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return startOfISOWeek(firstWeekOfYear);
  }

  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}

class ExtendedYearParser extends Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "u") {
      return parseNDigitsSigned(4, dateString);
    }

    return parseNDigitsSigned(token.length, dateString);
  }

  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}

class QuarterParser extends Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ": // 01, 02, 03, 04
        return parseNDigits(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return match.quarter(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

class StandAloneQuarterParser extends Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "q":
      case "qq": // 01, 02, 03, 04
        return parseNDigits(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return match.quarter(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

class MonthParser extends Parser {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];

  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "M":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "MM":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );

      // J, F, ..., D
      case "MMMMM":
        return match.month(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return (
          match.month(dateString, { width: "wide", context: "formatting" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

class StandAloneMonthParser extends Parser {
  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "LL":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );

      // J, F, ..., D
      case "LLLLL":
        return match.month(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return (
          match.month(dateString, { width: "wide", context: "standalone" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

/**
 * The {@link setWeek} function options.
 */

/**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */
function setWeek(date, week, options) {
  const date_ = toDate(date, options?.in);
  const diff = getWeek(date_, options) - week;
  date_.setDate(date_.getDate() - diff * 7);
  return toDate(date_, options?.in);
}

// Local week of year
class LocalWeekParser extends Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "w":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "wo":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value, options) {
    return startOfWeek(setWeek(date, value, options), options);
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}

/**
 * The {@link setISOWeek} function options.
 */

/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The `Date` type of the context function.
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek(date, week, options) {
  const _date = toDate(date, options?.in);
  const diff = getISOWeek(_date, options) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}

// ISO week of year
class ISOWeekParser extends Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "I":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "Io":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value) {
    return startOfISOWeek(setISOWeek(date, value));
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}

const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR = [
  31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
];

// Day of the month
class DateParser extends Parser {
  priority = 90;
  subPriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "d":
        return parseNumericPattern(numericPatterns.date, dateString);
      case "do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = isLeapYearIndex(year);
    const month = date.getMonth();
    if (isLeapYear) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }

  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

class DayOfYearParser extends Parser {
  priority = 90;

  subpriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);
      case "Do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = isLeapYearIndex(year);
    if (isLeapYear) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }

  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

/**
 * The {@link setDay} function options.
 */

/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay(date, day, options) {
  const defaultOptions = getDefaultOptions$1();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const date_ = toDate(date, options?.in);
  const currentDay = date_.getDay();

  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;

  const delta = 7 - weekStartsOn;
  const diff =
    day < 0 || day > 6
      ? day - ((currentDay + delta) % 7)
      : ((dayIndex + delta) % 7) - ((currentDay + delta) % 7);
  return addDays(date_, diff, options);
}

// Day of week
class DayParser extends Parser {
  priority = 90;

  parse(dateString, token, match) {
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "EEEEE":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "EEEE":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}

// Local day of week
class LocalDayParser extends Parser {
  priority = 90;
  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "e":
      case "ee": // 03
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      // 3rd
      case "eo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "eee":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "eeeee":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "eeee":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T",
  ];
}

// Stand-alone local day of week
class StandAloneLocalDayParser extends Parser {
  priority = 90;

  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "c":
      case "cc": // 03
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      // 3rd
      case "co":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "ccc":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // T
      case "ccccc":
        return match.day(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return (
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // Tuesday
      case "cccc":
      default:
        return (
          match.day(dateString, { width: "wide", context: "standalone" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T",
  ];
}

/**
 * The {@link setISODay} function options.
 */

/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday, etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay(date, day, options) {
  const date_ = toDate(date, options?.in);
  const currentDay = getISODay(date_, options);
  const diff = day - currentDay;
  return addDays(date_, diff, options);
}

// ISO day of week
class ISODayParser extends Parser {
  priority = 90;

  parse(dateString, token, match) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };

    switch (token) {
      // 2
      case "i":
      case "ii": // 02
        return parseNDigits(token.length, dateString);
      // 2nd
      case "io":
        return match.ordinalNumber(dateString, { unit: "day" });
      // Tue
      case "iii":
        return mapValue(
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // T
      case "iiiii":
        return mapValue(
          match.day(dateString, {
            width: "narrow",
            context: "formatting",
          }),
          valueCallback,
        );
      // Tu
      case "iiiiii":
        return mapValue(
          match.day(dateString, {
            width: "short",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // Tuesday
      case "iiii":
      default:
        return mapValue(
          match.day(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "abbreviated",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 7;
  }

  set(date, _flags, value) {
    date = setISODay(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T",
  ];
}

class AMPMParser extends Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "aaaaa":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}

class AMPMMidnightParser extends Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "bbbbb":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}

// in the morning, in the afternoon, in the evening, at night
class DayPeriodParser extends Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "BBBBB":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "t", "T"];
}

class Hour1to12Parser extends Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, dateString);
      case "ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 12;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["H", "K", "k", "t", "T"];
}

class Hour0to23Parser extends Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, dateString);
      case "Ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 23;
  }

  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}

class Hour0To11Parser extends Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, dateString);
      case "Ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["h", "H", "k", "t", "T"];
}

class Hour1To24Parser extends Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, dateString);
      case "ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 24;
  }

  set(date, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date.setHours(hours, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}

class MinuteParser extends Parser {
  priority = 60;

  parse(dateString, token, match) {
    switch (token) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, dateString);
      case "mo":
        return match.ordinalNumber(dateString, { unit: "minute" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}

class SecondParser extends Parser {
  priority = 50;

  parse(dateString, token, match) {
    switch (token) {
      case "s":
        return parseNumericPattern(numericPatterns.second, dateString);
      case "so":
        return match.ordinalNumber(dateString, { unit: "second" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}

class FractionOfSecondParser extends Parser {
  priority = 30;

  parse(dateString, token) {
    const valueCallback = (value) =>
      Math.trunc(value * Math.pow(10, -token.length + 3));
    return mapValue(parseNDigits(token.length, dateString), valueCallback);
  }

  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}

// Timezone (ISO-8601. +00:00 is `'Z'`)
class ISOTimezoneWithZParser extends Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "X":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "XXXX":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "XXXXX":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds(date) - value,
    );
  }

  incompatibleTokens = ["t", "T", "x"];
}

// Timezone (ISO-8601)
class ISOTimezoneParser extends Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "x":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "xxxx":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "xxxxx":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds(date) - value,
    );
  }

  incompatibleTokens = ["t", "T", "X"];
}

class TimestampSecondsParser extends Parser {
  priority = 40;

  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }

  set(date, _flags, value) {
    return [constructFrom(date, value * 1000), { timestampIsSet: true }];
  }

  incompatibleTokens = "*";
}

class TimestampMillisecondsParser extends Parser {
  priority = 20;

  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }

  set(date, _flags, value) {
    return [constructFrom(date, value), { timestampIsSet: true }];
  }

  incompatibleTokens = "*";
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
const parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser(),
};

/**
 * The {@link parse} function options.
 */

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;

const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangeably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse$1(dateStr, formatStr, referenceDate, options) {
  const invalidDate = () => constructFrom(referenceDate, NaN);
  const defaultOptions = getDefaultOptions();
  const locale = defaultOptions.locale ?? enUS;

  const firstWeekContainsDate =
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  if (!formatStr)
    return dateStr ? invalidDate() : toDate(referenceDate, options?.in);

  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  // If timezone isn't specified, it will try to use the context or
  // the reference date and fallback to the system time zone.
  const setters = [new DateTimezoneSetter(options?.in, referenceDate)];

  const tokens = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter in longFormatters) {
        const longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp);

  const usedTokens = [];

  for (let token of tokens) {
    if (
      isProtectedWeekYearToken(token)
    ) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    if (
      isProtectedDayOfYearToken(token)
    ) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }

    const firstCharacter = token[0];
    const parser = parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find(
          (usedToken) =>
            incompatibleTokens.includes(usedToken.token) ||
            usedToken.token === firstCharacter,
        );
        if (incompatibleToken) {
          throw new RangeError(
            `The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`,
          );
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(
          `The format string mustn't contain \`${token}\` and any other token at the same time`,
        );
      }

      usedTokens.push({ token: firstCharacter, fullToken: token });

      const parseResult = parser.run(
        dateStr,
        token,
        locale.match,
        subFnOptions,
      );

      if (!parseResult) {
        return invalidDate();
      }

      setters.push(parseResult.setter);

      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      // Replace two single quote characters with one single quote character
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      }

      // Cut token from string, or, if string doesn't match the token, return Invalid Date
      if (dateStr.indexOf(token) === 0) {
        dateStr = dateStr.slice(token.length);
      } else {
        return invalidDate();
      }
    }
  }

  // Check if the remaining input contains something other than whitespace
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return invalidDate();
  }

  const uniquePrioritySetters = setters
    .map((setter) => setter.priority)
    .sort((a, b) => b - a)
    .filter((priority, index, array) => array.indexOf(priority) === index)
    .map((priority) =>
      setters
        .filter((setter) => setter.priority === priority)
        .sort((a, b) => b.subPriority - a.subPriority),
    )
    .map((setterArray) => setterArray[0]);

  let date = toDate(referenceDate, options?.in);

  if (isNaN(+date)) return invalidDate();

  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return invalidDate();
    }

    const result = setter.set(date, flags, subFnOptions);
    // Result is tuple (date, flags)
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
      // Result is date
    } else {
      date = result;
    }
  }

  return date;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * The {@link isSameMonth} function options.
 */

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options?.in,
    laterDate,
    earlierDate,
  );
  return (
    laterDate_.getFullYear() === earlierDate_.getFullYear() &&
    laterDate_.getMonth() === earlierDate_.getMonth()
  );
}

/**
 * The {@link isSameYear} function options.
 */

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options?.in,
    laterDate,
    earlierDate,
  );
  return laterDate_.getFullYear() === earlierDate_.getFullYear();
}

/**
 * The {@link setMonth} function options.
 */

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 * @param options - The options
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(date, month, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const day = _date.getDate();

  const midMonth = constructFrom(options?.in || date, 0);
  midMonth.setFullYear(year, month, 15);
  midMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(midMonth);

  // Set the earlier date, allows to wrap Jan 31 to Feb 28
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}

/**
 * The {@link setYear} function options.
 */

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(date, year, options) {
  const date_ = toDate(date, options?.in);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+date_)) return constructFrom(options?.in || date, NaN);

  date_.setFullYear(year);
  return date_;
}

const formatDistanceLocale = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden",
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden",
    },
  },

  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden",
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden",
    },
  },

  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute",
  },

  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten",
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten",
    },
  },

  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten",
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten",
    },
  },

  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden",
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden",
    },
  },

  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden",
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden",
    },
  },

  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage",
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen",
    },
  },

  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen",
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen",
    },
  },

  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen",
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen",
    },
  },

  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate",
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten",
    },
  },

  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate",
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten",
    },
  },

  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre",
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren",
    },
  },

  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre",
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren",
    },
  },

  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre",
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren",
    },
  },

  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre",
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren",
    },
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = options?.addSuffix
    ? formatDistanceLocale[token].withPreposition
    : formatDistanceLocale[token].standalone;
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return "vor " + result;
    }
  }

  return result;
};

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const dateFormats = {
  full: "EEEE, do MMMM y", // Montag, 7. Januar 2018
  long: "do MMMM y", // 7. Januar 2018
  medium: "do MMM y", // 7. Jan. 2018
  short: "dd.MM.y", // 07.01.2018
};

const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

const formatRelativeLocale = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];

const eraValues = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"],
};

// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ],

  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
};

// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
const formattingMonthValues = {
  narrow: monthValues.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez.",
  ],

  wide: monthValues.wide,
};

const dayValues = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ],
};

// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const dayPeriodValues = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht",
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht",
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht",
  },
};
const formattingDayPeriodValues = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts",
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts",
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts",
  },
};

const ordinalNumber = (dirtyNumber) => {
  const number = Number(dirtyNumber);

  return number + ".";
};

const localize = {
  ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: buildLocalizeFn({
    values: monthValues,
    formattingValues: formattingMonthValues,
    defaultWidth: "wide",
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

const matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i,
};
const parseEraPatterns = {
  any: [/^v/i, /^n/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated:
    /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i,
};
const parseDayPatterns = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated:
    /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i, // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i, // will never be matched. Night is matched by `pm`
  },
};

const match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value),
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

/**
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Asia [@asia-t](https://github.com/asia-t)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author RomanErnst [@pex](https://github.com/pex)
 * @author Philipp Keck [@Philipp91](https://github.com/Philipp91)
 */
const de = {
  code: "de",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match$1,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
};

/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches$1 = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches$1.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches$1.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};

/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */
var hasTabIndex = function hasTabIndex(node) {
  return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};

/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */
var getTabIndex = function getTabIndex(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};

/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */
var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches$1.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches$1.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches$1.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches$1.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');
var isFocusable$1 = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches$1.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};

var index_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  focusable: focusable,
  getTabIndex: getTabIndex,
  isFocusable: isFocusable$1,
  isTabbable: isTabbable,
  tabbable: tabbable
});

/*!
* focus-trap 7.6.0
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/

function _defineProperty$2(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys$3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) {
      _defineProperty$2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var activeFocusTraps = {
  activateTrap: function activateTrap(trapStack, trap) {
    if (trapStack.length > 0) {
      var activeTrap = trapStack[trapStack.length - 1];
      if (activeTrap !== trap) {
        activeTrap.pause();
      }
    }
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex === -1) {
      trapStack.push(trap);
    } else {
      // move this existing trap to the front of the queue
      trapStack.splice(trapIndex, 1);
      trapStack.push(trap);
    }
  },
  deactivateTrap: function deactivateTrap(trapStack, trap) {
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex !== -1) {
      trapStack.splice(trapIndex, 1);
    }
    if (trapStack.length > 0) {
      trapStack[trapStack.length - 1].unpause();
    }
  }
};
var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var isEscapeEvent = function isEscapeEvent(e) {
  return (e === null || e === void 0 ? void 0 : e.key) === 'Escape' || (e === null || e === void 0 ? void 0 : e.key) === 'Esc' || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var isTabEvent = function isTabEvent(e) {
  return (e === null || e === void 0 ? void 0 : e.key) === 'Tab' || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};

// checks for TAB by default
var isKeyForward = function isKeyForward(e) {
  return isTabEvent(e) && !e.shiftKey;
};

// checks for SHIFT+TAB by default
var isKeyBackward = function isKeyBackward(e) {
  return isTabEvent(e) && e.shiftKey;
};
var delay = function delay(fn) {
  return setTimeout(fn, 0);
};

// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }
    return true; // next
  });
  return idx;
};

/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */
var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var internalTrapStack = [];
var createFocusTrap = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
  var config = _objectSpread2$1({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true,
    isKeyForward: isKeyForward,
    isKeyBackward: isKeyBackward
  }, userOptions);
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list

    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */
  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */
  var findContainerIndex = function findContainerIndex(element, event) {
    var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === 'function' ? event.composedPath() : undefined;
    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
    //  and we still need to find the element in there
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
        tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || ( // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function (node) {
        return node === element;
      });
    });
  };

  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */
  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = undefined; // use default value
    }
    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      }
      // else, empty string (invalid), null (invalid), 0 (invalid)

      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus');

    // false explicitly indicates we want no initialFocus at all
    if (node === false) {
      return false;
    }
    if (node === undefined || !isFocusable$1(node, config.tabbableOptions)) {
      // option not specified nor focusable: use fallback options
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;

        // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }
    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);

      // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
      //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
      //  are focusable but not tabbable
      var focusableNodes = focusable(container, config.tabbableOptions);
      var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
      var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
      var firstDomTabbableNode = focusableNodes.find(function (node) {
        return isTabbable(node);
      });
      var lastDomTabbableNode = focusableNodes.slice().reverse().find(function (node) {
        return isTabbable(node);
      });
      var posTabIndexesFound = !!tabbableNodes.find(function (node) {
        return getTabIndex(node) > 0;
      });
      return {
        container: container,
        tabbableNodes: tabbableNodes,
        focusableNodes: focusableNodes,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: posTabIndexesFound,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: firstTabbableNode,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: lastTabbableNode,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: firstDomTabbableNode,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: lastDomTabbableNode,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          var nodeIdx = tabbableNodes.indexOf(node);
          if (nodeIdx < 0) {
            // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
            //  since `node` should at least have been focusable, we assume that's the case and mimic
            //  what browsers do, which is set focus to the next node in __document position order__,
            //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
            //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
            //  basic DOM order
            if (forward) {
              return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function (el) {
                return isTabbable(el);
              });
            }
            return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function (el) {
              return isTabbable(el);
            });
          }
          return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    });

    // throw if no groups have tabbable nodes and we don't have a fallback focus node either
    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }

    // NOTE: Positive tabindexes are only properly supported in single-container traps because
    //  doing it across multiple containers where tabindexes could be all over the place
    //  would require Tabbable to support multiple containers, would require additional
    //  specialized Shadow DOM support, and would require Tabbable's multi-container support
    //  to look at those containers in document position order rather than user-provided
    //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
    //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
    if (state.containerGroups.find(function (g) {
      return g.posTabIndexesFound;
    }) && state.containerGroups.length > 1) {
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    }
  };

  /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/
  var _getActiveElement = function getActiveElement(el) {
    var activeElement = el.activeElement;
    if (!activeElement) {
      return;
    }
    if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) {
      return _getActiveElement(activeElement.shadowRoot);
    }
    return activeElement;
  };
  var _tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }
    if (node === _getActiveElement(document)) {
      return;
    }
    if (!node || !node.focus) {
      _tryFocus(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    // NOTE: focus() API does not trigger focusIn event so set MRU node manually
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };

  /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */
  var findNextNavNode = function findNextNavNode(_ref2) {
    var target = _ref2.target,
      event = _ref2.event,
      _ref2$isBackward = _ref2.isBackward,
      isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
    target = target || getActualTarget(event);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findContainerIndex(target, event);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back into...
        if (isBackward) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (isBackward) {
        // REVERSE

        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var firstTabbableNode = _ref3.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable$1(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = getTabIndex(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
        } else if (!isTabEvent(event)) {
          // user must have customized the nav keys so we have to move focus manually _within_
          //  the active group: do this based on the order determined by tabbable()
          destinationNode = containerGroup.nextTabbableNode(target, false);
        }
      } else {
        // FORWARD

        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref4) {
          var lastTabbableNode = _ref4.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable$1(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = getTabIndex(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
        } else if (!isTabEvent(event)) {
          // user must have customized the nav keys so we have to move focus manually _within_
          //  the active group: do this based on the order determined by tabbable()
          destinationNode = containerGroup.nextTabbableNode(target);
        }
      }
    } else {
      // no groups available
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }
    return destinationNode;
  };

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      // allow the click since it ocurred inside the trap
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked (and if not focusable, to "nothing"); by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node), whether the
        //  outside click was on a focusable node or not
        returnFocus: config.returnFocusOnDeactivate
      });
      return;
    }

    // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)
    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    }

    // otherwise, prevent the click
    e.preventDefault();
  };

  // In case focus escapes the trap for some strange reason, pull it back in.
  // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
  //  scrolling if the node that got focused was out of view; there's nothing we can do to
  //  prevent that from happening by the time we discover that focus escaped
  var checkFocusIn = function checkFocusIn(event) {
    var target = getActualTarget(event);
    var targetContained = findContainerIndex(target, event) >= 0;

    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      event.stopImmediatePropagation();

      // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
      //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
      //  toward a node with a positive tab index
      var nextNode; // next node to focus, if we find one
      var navAcrossContainers = true;
      if (state.mostRecentlyFocusedNode) {
        if (getTabIndex(state.mostRecentlyFocusedNode) > 0) {
          // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
          var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
          // there MAY not be any tabbable nodes in the container if there are at least 2 containers
          //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
          //  with at least one tabbable node in order to function, so this could be the other container
          //  with nothing tabbable in it)
          var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
          if (tabbableNodes.length > 0) {
            // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
            var mruTabIdx = tabbableNodes.findIndex(function (node) {
              return node === state.mostRecentlyFocusedNode;
            });
            if (mruTabIdx >= 0) {
              if (config.isKeyForward(state.recentNavEvent)) {
                if (mruTabIdx + 1 < tabbableNodes.length) {
                  nextNode = tabbableNodes[mruTabIdx + 1];
                  navAcrossContainers = false;
                }
                // else, don't wrap within the container as focus should move to next/previous
                //  container
              } else {
                if (mruTabIdx - 1 >= 0) {
                  nextNode = tabbableNodes[mruTabIdx - 1];
                  navAcrossContainers = false;
                }
                // else, don't wrap within the container as focus should move to next/previous
                //  container
              }
              // else, don't find in container order without considering direction too
            }
          }
          // else, no tabbable nodes in that container (which means we must have at least one other
          //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
          //  an error the last time updateTabbableNodes() was run): find next node among all known
          //  containers
        } else {
          // check to see if there's at least one tabbable node with a positive tab index inside
          //  the trap because focus seems to escape when navigating backward from a tabbable node
          //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
          //  the greatest positive tab index like it should)
          if (!state.containerGroups.some(function (g) {
            return g.tabbableNodes.some(function (n) {
              return getTabIndex(n) > 0;
            });
          })) {
            // no containers with tabbable nodes with positive tab indexes which means the focus
            //  escaped for some other reason and we should just execute the fallback to the
            //  MRU node or initial focus node, if any
            navAcrossContainers = false;
          }
        }
      } else {
        // no MRU node means we're likely in some initial condition when the trap has just
        //  been activated and initial focus hasn't been given yet, in which case we should
        //  fall through to trying to focus the initial focus node, which is what should
        //  happen below at this point in the logic
        navAcrossContainers = false;
      }
      if (navAcrossContainers) {
        nextNode = findNextNavNode({
          // move FROM the MRU node, not event-related node (which will be the node that is
          //  outside the trap causing the focus escape we're trying to fix)
          target: state.mostRecentlyFocusedNode,
          isBackward: config.isKeyBackward(state.recentNavEvent)
        });
      }
      if (nextNode) {
        _tryFocus(nextNode);
      } else {
        _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    }
    state.recentNavEvent = undefined; // clear
  };

  // Hijack key nav events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  var checkKeyNav = function checkKeyNav(event) {
    var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    state.recentNavEvent = event;
    var destinationNode = findNextNavNode({
      event: event,
      isBackward: isBackward
    });
    if (destinationNode) {
      if (isTabEvent(event)) {
        // since tab natively moves focus, we wouldn't have a destination node unless we
        //  were on the edge of a container and had to move to the next/previous edge, in
        //  which case we want to prevent default to keep the browser from moving focus
        //  to where it normally would
        event.preventDefault();
      }
      _tryFocus(destinationNode);
    }
    // else, let the browser take care of [shift+]tab and move the focus
  };
  var checkTabKey = function checkTabKey(event) {
    if (config.isKeyForward(event) || config.isKeyBackward(event)) {
      checkKeyNav(event, config.isKeyBackward(event));
    }
  };

  // we use a different event phase for the Escape key to allow canceling the event and checking for this in escapeDeactivates
  var checkEscapeKey = function checkEscapeKey(event) {
    if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
      event.preventDefault();
      trap.deactivate();
    }
  };
  var checkClick = function checkClick(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };

  //
  // EVENT LISTENERS
  //

  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    }

    // There can be only one listening focus trap at a time
    activeFocusTraps.activateTrap(trapStack, trap);

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      _tryFocus(getInitialFocusNode());
    }) : _tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkTabKey, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkEscapeKey);
    return trap;
  };
  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkTabKey, true);
    doc.removeEventListener('keydown', checkEscapeKey);
    return trap;
  };

  //
  // MUTATION OBSERVER
  //

  var checkDomRemoval = function checkDomRemoval(mutations) {
    var isFocusedNodeRemoved = mutations.some(function (mutation) {
      var removedNodes = Array.from(mutation.removedNodes);
      return removedNodes.some(function (node) {
        return node === state.mostRecentlyFocusedNode;
      });
    });

    // If the currently focused is removed then browsers will move focus to the
    // <body> element. If this happens, try to move focus back into the trap.
    if (isFocusedNodeRemoved) {
      _tryFocus(getInitialFocusNode());
    }
  };

  // Use MutationObserver - if supported - to detect if focused node is removed
  // from the DOM.
  var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
  var updateObservedNodes = function updateObservedNodes() {
    if (!mutationObserver) {
      return;
    }
    mutationObserver.disconnect();
    if (state.active && !state.paused) {
      state.containers.map(function (container) {
        mutationObserver.observe(container, {
          subtree: true,
          childList: true
        });
      });
    }
  };

  //
  // TRAP DEFINITION
  //

  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      onActivate === null || onActivate === void 0 || onActivate();
      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        updateObservedNodes();
        onPostActivate === null || onPostActivate === void 0 || onPostActivate();
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2$1({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer); // noop if undefined
      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      updateObservedNodes();
      activeFocusTraps.deactivateTrap(trapStack, trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
      onDeactivate === null || onDeactivate === void 0 || onDeactivate();
      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause(pauseOptions) {
      if (state.paused || !state.active) {
        return this;
      }
      var onPause = getOption(pauseOptions, 'onPause');
      var onPostPause = getOption(pauseOptions, 'onPostPause');
      state.paused = true;
      onPause === null || onPause === void 0 || onPause();
      removeListeners();
      updateObservedNodes();
      onPostPause === null || onPostPause === void 0 || onPostPause();
      return this;
    },
    unpause: function unpause(unpauseOptions) {
      if (!state.paused || !state.active) {
        return this;
      }
      var onUnpause = getOption(unpauseOptions, 'onUnpause');
      var onPostUnpause = getOption(unpauseOptions, 'onPostUnpause');
      state.paused = false;
      onUnpause === null || onUnpause === void 0 || onUnpause();
      updateTabbableNodes();
      addListeners();
      updateObservedNodes();
      onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      updateObservedNodes();
      return this;
    }
  };

  // initialize container elements
  trap.updateContainerElements(elements);
  return trap;
};

var focusTrap_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createFocusTrap: createFocusTrap
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(focusTrap_esm);

var require$$3 = /*@__PURE__*/getAugmentedNamespace(index_esm);

var focusTrapReact;
var hasRequiredFocusTrapReact;

function requireFocusTrapReact () {
	if (hasRequiredFocusTrapReact) return focusTrapReact;
	hasRequiredFocusTrapReact = 1;

	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
	function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
	function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
	function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
	function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
	function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
	function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
	function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
	function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return (String )(t); }
	var React = React__default;
	var PropTypes$1 = PropTypes;
	var _require = require$$2,
	  createFocusTrap = _require.createFocusTrap;
	var _require2 = require$$3,
	  isFocusable = _require2.isFocusable;
	var FocusTrap = /*#__PURE__*/function (_React$Component) {
	  function FocusTrap(props) {
	    var _this;
	    _classCallCheck(this, FocusTrap);
	    _this = _callSuper(this, FocusTrap, [props]);
	    /**
	     * Gets the node for the given option, which is expected to be an option that
	     *  can be either a DOM node, a string that is a selector to get a node, `false`
	     *  (if a node is explicitly NOT given), or a function that returns any of these
	     *  values.
	     * @param {string} optionName
	     * @returns {undefined | false | HTMLElement | SVGElement} Returns
	     *  `undefined` if the option is not specified; `false` if the option
	     *  resolved to `false` (node explicitly not given); otherwise, the resolved
	     *  DOM node.
	     * @throws {Error} If the option is set, not `false`, and is not, or does not
	     *  resolve to a node.
	     */
	    _defineProperty(_this, "getNodeForOption", function (optionName) {
	      var _this$internalOptions;
	      // use internal options first, falling back to original options
	      var optionValue = (_this$internalOptions = this.internalOptions[optionName]) !== null && _this$internalOptions !== void 0 ? _this$internalOptions : this.originalOptions[optionName];
	      if (typeof optionValue === 'function') {
	        for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          params[_key - 1] = arguments[_key];
	        }
	        optionValue = optionValue.apply(void 0, params);
	      }
	      if (optionValue === true) {
	        optionValue = undefined; // use default value
	      }
	      if (!optionValue) {
	        if (optionValue === undefined || optionValue === false) {
	          return optionValue;
	        }
	        // else, empty string (invalid), null (invalid), 0 (invalid)

	        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
	      }
	      var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

	      if (typeof optionValue === 'string') {
	        var _this$getDocument;
	        node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue); // resolve to node, or null if fails
	        if (!node) {
	          throw new Error("`".concat(optionName, "` as selector refers to no known node"));
	        }
	      }
	      return node;
	    });
	    _this.handleDeactivate = _this.handleDeactivate.bind(_this);
	    _this.handlePostDeactivate = _this.handlePostDeactivate.bind(_this);
	    _this.handleClickOutsideDeactivates = _this.handleClickOutsideDeactivates.bind(_this);

	    // focus-trap options used internally when creating the trap
	    _this.internalOptions = {
	      // We need to hijack the returnFocusOnDeactivate option,
	      // because React can move focus into the element before we arrived at
	      // this lifecycle hook (e.g. with autoFocus inputs). So the component
	      // captures the previouslyFocusedElement in componentWillMount,
	      // then (optionally) returns focus to it in componentWillUnmount.
	      returnFocusOnDeactivate: false,
	      // the rest of these are also related to deactivation of the trap, and we
	      //  need to use them and control them as well
	      checkCanReturnFocus: null,
	      onDeactivate: _this.handleDeactivate,
	      onPostDeactivate: _this.handlePostDeactivate,
	      // we need to special-case this setting as well so that we can know if we should
	      //  NOT return focus if the trap gets auto-deactivated as the result of an
	      //  outside click (otherwise, we'll always think we should return focus because
	      //  of how we manage that flag internally here)
	      clickOutsideDeactivates: _this.handleClickOutsideDeactivates
	    };

	    // original options provided by the consumer
	    _this.originalOptions = {
	      // because of the above `internalOptions`, we maintain our own flag for
	      //  this option, and default it to `true` because that's focus-trap's default
	      returnFocusOnDeactivate: true,
	      // because of the above `internalOptions`, we keep these separate since
	      //  they're part of the deactivation process which we configure (internally) to
	      //  be shared between focus-trap and focus-trap-react
	      onDeactivate: null,
	      onPostDeactivate: null,
	      checkCanReturnFocus: null,
	      // the user's setting, defaulted to false since focus-trap defaults this to false
	      clickOutsideDeactivates: false
	    };
	    var focusTrapOptions = props.focusTrapOptions;
	    for (var optionName in focusTrapOptions) {
	      if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) {
	        continue;
	      }
	      if (optionName === 'returnFocusOnDeactivate' || optionName === 'onDeactivate' || optionName === 'onPostDeactivate' || optionName === 'checkCanReturnFocus' || optionName === 'clickOutsideDeactivates') {
	        _this.originalOptions[optionName] = focusTrapOptions[optionName];
	        continue; // exclude from internalOptions
	      }
	      _this.internalOptions[optionName] = focusTrapOptions[optionName];
	    }

	    // if set, `{ target: Node, allowDeactivation: boolean }` where `target` is the outside
	    //  node that was clicked, and `allowDeactivation` is the result of the consumer's
	    //  option (stored in `this.originalOptions.clickOutsideDeactivates`, which may be a
	    //  function) whether to allow or deny auto-deactivation on click on this outside node
	    _this.outsideClick = null;

	    // elements from which to create the focus trap on mount; if a child is used
	    //  instead of the `containerElements` prop, we'll get the child's related
	    //  element when the trap renders and then is declared 'mounted'
	    _this.focusTrapElements = props.containerElements || [];

	    // now we remember what the currently focused element is, not relying on focus-trap
	    _this.updatePreviousElement();
	    return _this;
	  }

	  /**
	   * Gets the configured document.
	   * @returns {Document|undefined} Configured document, falling back to the main
	   *  document, if it exists. During SSR, `undefined` is returned since the
	   *  document doesn't exist.
	   */
	  _inherits(FocusTrap, _React$Component);
	  return _createClass(FocusTrap, [{
	    key: "getDocument",
	    value: function getDocument() {
	      // SSR: careful to check if `document` exists before accessing it as a variable
	      return this.props.focusTrapOptions.document || (typeof document !== 'undefined' ? document : undefined);
	    }
	  }, {
	    key: "getReturnFocusNode",
	    value: function getReturnFocusNode() {
	      var node = this.getNodeForOption('setReturnFocus', this.previouslyFocusedElement);
	      return node ? node : node === false ? false : this.previouslyFocusedElement;
	    }

	    /** Update the previously focused element with the currently focused element. */
	  }, {
	    key: "updatePreviousElement",
	    value: function updatePreviousElement() {
	      var currentDocument = this.getDocument();
	      if (currentDocument) {
	        this.previouslyFocusedElement = currentDocument.activeElement;
	      }
	    }
	  }, {
	    key: "deactivateTrap",
	    value: function deactivateTrap() {
	      // NOTE: it's possible the focus trap has already been deactivated without our knowing it,
	      //  especially if the user set the `clickOutsideDeactivates: true` option on the trap,
	      //  and the mouse was clicked on some element outside the trap; at that point, focus-trap
	      //  will initiate its auto-deactivation process, which will call our own
	      //  handleDeactivate(), which will call into this method
	      if (!this.focusTrap || !this.focusTrap.active) {
	        return;
	      }
	      this.focusTrap.deactivate({
	        // NOTE: we never let the trap return the focus since we do that ourselves
	        returnFocus: false,
	        // we'll call this in our own post deactivate handler so make sure the trap doesn't
	        //  do it prematurely
	        checkCanReturnFocus: null,
	        // let it call the user's original deactivate handler, if any, instead of
	        //  our own which calls back into this function
	        onDeactivate: this.originalOptions.onDeactivate
	        // NOTE: for post deactivate, don't specify anything so that it calls the
	        //  onPostDeactivate handler specified on `this.internalOptions`
	        //  which will always be our own `handlePostDeactivate()` handler, which
	        //  will finish things off by calling the user's provided onPostDeactivate
	        //  handler, if any, at the right time
	        // onPostDeactivate: NOTHING
	      });
	    }
	  }, {
	    key: "handleClickOutsideDeactivates",
	    value: function handleClickOutsideDeactivates(event) {
	      // use consumer's option (or call their handler) as the permission or denial
	      var allowDeactivation = typeof this.originalOptions.clickOutsideDeactivates === 'function' ? this.originalOptions.clickOutsideDeactivates.call(null, event) // call out of context
	      : this.originalOptions.clickOutsideDeactivates; // boolean

	      if (allowDeactivation) {
	        // capture the outside target that was clicked so we can use it in the deactivation
	        //  process since the consumer allowed it to cause auto-deactivation
	        this.outsideClick = {
	          target: event.target,
	          allowDeactivation: allowDeactivation
	        };
	      }
	      return allowDeactivation;
	    }
	  }, {
	    key: "handleDeactivate",
	    value: function handleDeactivate() {
	      if (this.originalOptions.onDeactivate) {
	        this.originalOptions.onDeactivate.call(null); // call user's handler out of context
	      }
	      this.deactivateTrap();
	    }
	  }, {
	    key: "handlePostDeactivate",
	    value: function handlePostDeactivate() {
	      var _this2 = this;
	      var finishDeactivation = function finishDeactivation() {
	        var returnFocusNode = _this2.getReturnFocusNode();
	        var canReturnFocus = !!(
	        // did the consumer allow it?

	        _this2.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
	        returnFocusNode !== null && returnFocusNode !== void 0 && returnFocusNode.focus && (
	        // was there an outside click that allowed deactivation?
	        !_this2.outsideClick ||
	        // did the consumer allow deactivation when the outside node was clicked?
	        _this2.outsideClick.allowDeactivation &&
	        // is the outside node NOT focusable (implying that it did NOT receive focus
	        //  as a result of the click-through) -- in which case do NOT restore focus
	        //  to `returnFocusNode` because focus should remain on the outside node
	        !isFocusable(_this2.outsideClick.target, _this2.internalOptions.tabbableOptions))

	        // if no, the restore focus to `returnFocusNode` at this point
	        );
	        var _this2$internalOption = _this2.internalOptions.preventScroll,
	          preventScroll = _this2$internalOption === void 0 ? false : _this2$internalOption;
	        if (canReturnFocus) {
	          // return focus to the element that had focus when the trap was activated
	          returnFocusNode.focus({
	            preventScroll: preventScroll
	          });
	        }
	        if (_this2.originalOptions.onPostDeactivate) {
	          _this2.originalOptions.onPostDeactivate.call(null); // don't call it in context of "this"
	        }
	        _this2.outsideClick = null; // reset: no longer needed
	      };
	      if (this.originalOptions.checkCanReturnFocus) {
	        this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()) // call out of context
	        .then(finishDeactivation, finishDeactivation);
	      } else {
	        finishDeactivation();
	      }
	    }
	  }, {
	    key: "setupFocusTrap",
	    value: function setupFocusTrap() {
	      if (this.focusTrap) {
	        // trap already exists: it's possible we're in StrictMode and we're being remounted,
	        //  in which case, we will have deactivated the trap when we got unmounted (remember,
	        //  StrictMode, in development, purposely unmounts and remounts components after
	        //  mounting them the first time to make sure they have reusable state,
	        //  @see https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state) so now
	        //  we need to restore the state of the trap according to our component state
	        // NOTE: Strict mode __violates__ assumptions about the `componentWillUnmount()` API
	        //  which clearly states -- even for React 18 -- that, "Once a component instance is
	        //  unmounted, __it will never be mounted again.__" (emphasis ours). So when we get
	        //  unmounted, we assume we're gone forever and we deactivate the trap. But then
	        //  we get remounted and we're supposed to restore state. But if you had paused,
	        //  we've now deactivated (we don't know we're amount to get remounted again)
	        //  which means we need to reactivate and then pause. Otherwise, do nothing.
	        if (this.props.active && !this.focusTrap.active) {
	          this.focusTrap.activate();
	          if (this.props.paused) {
	            this.focusTrap.pause();
	          }
	        }
	      } else {
	        var nodesExist = this.focusTrapElements.some(Boolean);
	        if (nodesExist) {
	          // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
	          this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions);
	          if (this.props.active) {
	            this.focusTrap.activate();
	          }
	          if (this.props.paused) {
	            this.focusTrap.pause();
	          }
	        }
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.active) {
	        this.setupFocusTrap();
	      }
	      // else, wait for later activation in case the `focusTrapOptions` will be updated
	      //  again before the trap is activated (e.g. if waiting to know what the document
	      //  object will be, so the Trap must be rendered, but the consumer is waiting to
	      //  activate until they have obtained the document from a ref)
	      //  @see https://github.com/focus-trap/focus-trap-react/issues/539
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.focusTrap) {
	        if (prevProps.containerElements !== this.props.containerElements) {
	          this.focusTrap.updateContainerElements(this.props.containerElements);
	        }
	        var hasActivated = !prevProps.active && this.props.active;
	        var hasDeactivated = prevProps.active && !this.props.active;
	        var hasPaused = !prevProps.paused && this.props.paused;
	        var hasUnpaused = prevProps.paused && !this.props.paused;
	        if (hasActivated) {
	          this.updatePreviousElement();
	          this.focusTrap.activate();
	        }
	        if (hasDeactivated) {
	          this.deactivateTrap();
	          return; // un/pause does nothing on an inactive trap
	        }
	        if (hasPaused) {
	          this.focusTrap.pause();
	        }
	        if (hasUnpaused) {
	          this.focusTrap.unpause();
	        }
	      } else {
	        // NOTE: if we're in `componentDidUpdate` and we don't have a trap yet,
	        //  it either means it shouldn't be active, or it should be but none of
	        //  of given `containerElements` were present in the DOM the last time
	        //  we tried to create the trap

	        if (prevProps.containerElements !== this.props.containerElements) {
	          this.focusTrapElements = this.props.containerElements;
	        }

	        // don't create the trap unless it should be active in case the consumer
	        //  is still updating `focusTrapOptions`
	        //  @see https://github.com/focus-trap/focus-trap-react/issues/539
	        if (this.props.active) {
	          this.updatePreviousElement();
	          this.setupFocusTrap();
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.deactivateTrap();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	      var child = this.props.children ? React.Children.only(this.props.children) : undefined;
	      if (child) {
	        if (child.type && child.type === React.Fragment) {
	          throw new Error('A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.');
	        }
	        var callbackRef = function callbackRef(element) {
	          var containerElements = _this3.props.containerElements;
	          if (child) {
	            if (typeof child.ref === 'function') {
	              child.ref(element);
	            } else if (child.ref) {
	              child.ref.current = element;
	            }
	          }
	          _this3.focusTrapElements = containerElements ? containerElements : [element];
	        };
	        var childWithRef = React.cloneElement(child, {
	          ref: callbackRef
	        });
	        return childWithRef;
	      }
	      return null;
	    }
	  }]);
	}(React.Component); // support server-side rendering where `Element` will not be defined
	var ElementType = typeof Element === 'undefined' ? Function : Element;
	FocusTrap.propTypes = {
	  active: PropTypes$1.bool,
	  paused: PropTypes$1.bool,
	  focusTrapOptions: PropTypes$1.shape({
	    document: PropTypes$1.object,
	    onActivate: PropTypes$1.func,
	    onPostActivate: PropTypes$1.func,
	    checkCanFocusTrap: PropTypes$1.func,
	    onPause: PropTypes$1.func,
	    onPostPause: PropTypes$1.func,
	    onUnpause: PropTypes$1.func,
	    onPostUnpause: PropTypes$1.func,
	    onDeactivate: PropTypes$1.func,
	    onPostDeactivate: PropTypes$1.func,
	    checkCanReturnFocus: PropTypes$1.func,
	    initialFocus: PropTypes$1.oneOfType([PropTypes$1.instanceOf(ElementType), PropTypes$1.string, PropTypes$1.bool, PropTypes$1.func]),
	    fallbackFocus: PropTypes$1.oneOfType([PropTypes$1.instanceOf(ElementType), PropTypes$1.string,
	    // NOTE: does not support `false` as value (or return value from function)
	    PropTypes$1.func]),
	    escapeDeactivates: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.func]),
	    clickOutsideDeactivates: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.func]),
	    returnFocusOnDeactivate: PropTypes$1.bool,
	    setReturnFocus: PropTypes$1.oneOfType([PropTypes$1.instanceOf(ElementType), PropTypes$1.string, PropTypes$1.bool, PropTypes$1.func]),
	    allowOutsideClick: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.func]),
	    preventScroll: PropTypes$1.bool,
	    tabbableOptions: PropTypes$1.shape({
	      displayCheck: PropTypes$1.oneOf(['full', 'legacy-full', 'non-zero-area', 'none']),
	      getShadowRoot: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.func])
	    }),
	    trapStack: PropTypes$1.array,
	    isKeyForward: PropTypes$1.func,
	    isKeyBackward: PropTypes$1.func
	  }),
	  containerElements: PropTypes$1.arrayOf(PropTypes$1.instanceOf(ElementType)),
	  // DOM element ONLY
	  children: PropTypes$1.oneOfType([PropTypes$1.element,
	  // React element
	  PropTypes$1.instanceOf(ElementType) // DOM element
	  ])

	  // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
	  //  specify it here. It's expected to be set to the function returned from
	  //  require('focus-trap'), or one with a compatible interface.
	};
	FocusTrap.defaultProps = {
	  active: true,
	  paused: false,
	  focusTrapOptions: {},
	  _createFocusTrap: createFocusTrap
	};
	focusTrapReact = FocusTrap;
	return focusTrapReact;
}

var focusTrapReactExports = requireFocusTrapReact();
var FocusTrap = /*@__PURE__*/getDefaultExportFromCjs(focusTrapReactExports);

/**
 * The UI elements composing DayPicker. These elements are mapped to
 * {@link CustomComponents}, the {@link ClassNames} and the {@link Styles} used by
 * DayPicker.
 *
 * Some of these elements are extended by flags and modifiers.
 */
var UI;
(function (UI) {
    /** The root component displaying the months and the navigation bar. */
    UI["Root"] = "root";
    /** The Chevron SVG element used by navigation buttons and dropdowns. */
    UI["Chevron"] = "chevron";
    /**
     * The grid cell with the day's date. Extended by {@link DayFlag} and
     * {@link SelectionFlag}.
     */
    UI["Day"] = "day";
    /** The button containing the formatted day's date, inside the grid cell. */
    UI["DayButton"] = "day_button";
    /** The caption label of the month (when not showing the dropdown navigation). */
    UI["CaptionLabel"] = "caption_label";
    /** The container of the dropdown navigation (when enabled). */
    UI["Dropdowns"] = "dropdowns";
    /** The dropdown element to select for years and months. */
    UI["Dropdown"] = "dropdown";
    /** The container element of the dropdown. */
    UI["DropdownRoot"] = "dropdown_root";
    /** The root element of the footer. */
    UI["Footer"] = "footer";
    /** The month grid. */
    UI["MonthGrid"] = "month_grid";
    /** Contains the dropdown navigation or the caption label. */
    UI["MonthCaption"] = "month_caption";
    /** The dropdown with the months. */
    UI["MonthsDropdown"] = "months_dropdown";
    /** Wrapper of the month grid. */
    UI["Month"] = "month";
    /** The container of the displayed months. */
    UI["Months"] = "months";
    /** The navigation bar with the previous and next buttons. */
    UI["Nav"] = "nav";
    /**
     * The next month button in the navigation. *
     *
     * @since 9.1.0
     */
    UI["NextMonthButton"] = "button_next";
    /**
     * The previous month button in the navigation.
     *
     * @since 9.1.0
     */
    UI["PreviousMonthButton"] = "button_previous";
    /** The row containing the week. */
    UI["Week"] = "week";
    /** The group of row weeks in a month (`tbody`). */
    UI["Weeks"] = "weeks";
    /** The column header with the weekday. */
    UI["Weekday"] = "weekday";
    /** The row grouping the weekdays in the column headers. */
    UI["Weekdays"] = "weekdays";
    /** The cell containing the week number. */
    UI["WeekNumber"] = "week_number";
    /** The cell header of the week numbers column. */
    UI["WeekNumberHeader"] = "week_number_header";
    /** The dropdown with the years. */
    UI["YearsDropdown"] = "years_dropdown";
})(UI || (UI = {}));
/** The flags for the {@link UI.Day}. */
var DayFlag;
(function (DayFlag) {
    /** The day is disabled. */
    DayFlag["disabled"] = "disabled";
    /** The day is hidden. */
    DayFlag["hidden"] = "hidden";
    /** The day is outside the current month. */
    DayFlag["outside"] = "outside";
    /** The day is focused. */
    DayFlag["focused"] = "focused";
    /** The day is today. */
    DayFlag["today"] = "today";
})(DayFlag || (DayFlag = {}));
/**
 * The state that can be applied to the {@link UI.Day} element when in selection
 * mode.
 */
var SelectionState;
(function (SelectionState) {
    /** The day is at the end of a selected range. */
    SelectionState["range_end"] = "range_end";
    /** The day is at the middle of a selected range. */
    SelectionState["range_middle"] = "range_middle";
    /** The day is at the start of a selected range. */
    SelectionState["range_start"] = "range_start";
    /** The day is selected. */
    SelectionState["selected"] = "selected";
})(SelectionState || (SelectionState = {}));

function getClassNamesForModifiers(modifiers, classNames, modifiersClassNames = {}) {
    const modifierClassNames = Object.entries(modifiers)
        .filter(([, active]) => active === true)
        .reduce((previousValue, [key]) => {
        if (modifiersClassNames[key]) {
            previousValue.push(modifiersClassNames[key]);
        }
        else if (classNames[DayFlag[key]]) {
            previousValue.push(classNames[DayFlag[key]]);
        }
        else if (classNames[SelectionState[key]]) {
            previousValue.push(classNames[SelectionState[key]]);
        }
        return previousValue;
    }, [classNames[UI.Day]]);
    return modifierClassNames;
}

/**
 * Render the button elements in the calendar.
 *
 * @private
 * @deprecated Use `PreviousMonthButton` or `@link NextMonthButton` instead.
 */
function Button(props) {
    return React__default.createElement("button", { ...props });
}

/**
 * Render the label in the month caption.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function CaptionLabel(props) {
    return React__default.createElement("span", { ...props });
}

/**
 * Render the chevron icon used in the navigation buttons and dropdowns.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Chevron(props) {
    const { size = 24, orientation = "left", className } = props;
    return (React__default.createElement("svg", { className: className, width: size, height: size, viewBox: "0 0 24 24" },
        orientation === "up" && (React__default.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" })),
        orientation === "down" && (React__default.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" })),
        orientation === "left" && (React__default.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" })),
        orientation === "right" && (React__default.createElement("polygon", { points: "8 18.612 14.1888889 12.5 8 6.37733333 9.91111111 4.5 18 12.5 9.91111111 20.5" }))));
}

/**
 * Render the gridcell of a day in the calendar and handle the interaction and
 * the focus with they day.
 *
 * If you need to just change the content of the day cell, consider swapping the
 * `DayDate` component instead.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Day(props) {
    const { day, modifiers, ...tdProps } = props;
    return React__default.createElement("td", { ...tdProps });
}

/**
 * Render the button for a day in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function DayButton(props) {
    const { day, modifiers, ...buttonProps } = props;
    const ref = React__default.useRef(null);
    React__default.useEffect(() => {
        if (modifiers.focused)
            ref.current?.focus();
    }, [modifiers.focused]);
    return React__default.createElement("button", { ref: ref, ...buttonProps });
}

/**
 * Render a dropdown component to use in the navigation bar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Dropdown(props) {
    const { options, className, components, classNames, ...selectProps } = props;
    const cssClassSelect = [classNames[UI.Dropdown], className].join(" ");
    const selectedOption = options?.find(({ value }) => value === selectProps.value);
    return (React__default.createElement("span", { "data-disabled": selectProps.disabled, className: classNames[UI.DropdownRoot] },
        React__default.createElement(components.Select, { className: cssClassSelect, ...selectProps }, options?.map(({ value, label, disabled }) => (React__default.createElement(components.Option, { key: value, value: value, disabled: disabled }, label)))),
        React__default.createElement("span", { className: classNames[UI.CaptionLabel], "aria-hidden": true },
            selectedOption?.label,
            React__default.createElement(components.Chevron, { orientation: "down", size: 18, className: classNames[UI.Chevron] }))));
}

/**
 * Render the the navigation dropdowns.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function DropdownNav(props) {
    return React__default.createElement("div", { ...props });
}

/**
 * Component wrapping the footer.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Footer(props) {
    return React__default.createElement("div", { ...props });
}

/**
 * Render the grid with the weekday header row and the weeks for the given
 * month.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Month(props) {
    const { calendarMonth, displayIndex, ...divProps } = props;
    return React__default.createElement("div", { ...divProps }, props.children);
}

/**
 * Render the caption of a month in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function MonthCaption(props) {
    const { calendarMonth, displayIndex, ...divProps } = props;
    return React__default.createElement("div", { ...divProps });
}

/**
 * Render the grid of days in a month.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function MonthGrid(props) {
    return React__default.createElement("table", { ...props });
}

/**
 * Component wrapping the month grids.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Months(props) {
    return React__default.createElement("div", { ...props });
}

/** @private */
const dayPickerContext = createContext(undefined);
/**
 * Returns the context to work with `<DayPicker />` inside custom components.
 *
 * This hook provides access to the DayPicker context, which includes various
 * properties and methods to interact with the DayPicker component. It must be
 * used within a custom component.
 *
 * @template T - Use this type to refine the returned context type with a
 *   specific selection mode.
 * @returns {DayPickerContext<T>} The context to work with DayPicker.
 * @throws {Error} If the hook is used outside of a DayPicker provider.
 * @group Hooks
 * @see https://daypicker.dev/guides/custom-components
 */
function useDayPicker() {
    const context = useContext(dayPickerContext);
    if (context === undefined) {
        throw new Error("useDayPicker() must be used within a custom component.");
    }
    return context;
}

/**
 * Render the dropdown to navigate between months.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function MonthsDropdown(props) {
    const { components } = useDayPicker();
    return React__default.createElement(components.Dropdown, { ...props });
}

/**
 * Render the toolbar with the navigation button.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Nav(props) {
    const { onPreviousClick, onNextClick, previousMonth, nextMonth, ...navProps } = props;
    const { components, classNames, labels: { labelPrevious, labelNext } } = useDayPicker();
    return (React__default.createElement("nav", { ...navProps },
        React__default.createElement(components.PreviousMonthButton, { type: "button", className: classNames[UI.PreviousMonthButton], tabIndex: previousMonth ? undefined : -1, disabled: previousMonth ? undefined : true, "aria-label": labelPrevious(previousMonth), onClick: props.onPreviousClick },
            React__default.createElement(components.Chevron, { disabled: previousMonth ? undefined : true, className: classNames[UI.Chevron], orientation: "left" })),
        React__default.createElement(components.NextMonthButton, { type: "button", className: classNames[UI.NextMonthButton], tabIndex: nextMonth ? undefined : -1, disabled: nextMonth ? undefined : true, "aria-label": labelNext(nextMonth), onClick: props.onNextClick },
            React__default.createElement(components.Chevron, { disabled: nextMonth ? undefined : true, orientation: "right", className: classNames[UI.Chevron] }))));
}

/**
 * Render the next month button element in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function NextMonthButton(props) {
    const { components } = useDayPicker();
    return React__default.createElement(components.Button, { ...props });
}

/**
 * Render the `option` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Option$2(props) {
    return React__default.createElement("option", { ...props });
}

/**
 * Render the previous month button element in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function PreviousMonthButton(props) {
    const { components } = useDayPicker();
    return React__default.createElement(components.Button, { ...props });
}

/**
 * Render the root element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Root(props) {
    return React__default.createElement("div", { ...props });
}

/**
 * Render the `select` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Select$2(props) {
    return React__default.createElement("select", { ...props });
}

/**
 * Render a row in the calendar, with the days and the week number.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Week(props) {
    const { week, ...trProps } = props;
    return React__default.createElement("tr", { ...trProps });
}

/**
 * Render the column header with the weekday name (e.g. "Mo", "Tu", etc.).
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Weekday(props) {
    return React__default.createElement("th", { ...props });
}

/**
 * Render the row with the weekday names.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Weekdays(props) {
    return (React__default.createElement("thead", null,
        React__default.createElement("tr", { ...props })));
}

/**
 * Render the cell with the number of the week.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function WeekNumber(props) {
    const { week, ...thProps } = props;
    return React__default.createElement("th", { ...thProps });
}

/**
 * Render the column header for the week numbers.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function WeekNumberHeader(props) {
    return React__default.createElement("th", { ...props });
}

/**
 * Render the weeks in the month grid.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Weeks(props) {
    return React__default.createElement("tbody", { ...props });
}

/**
 * Render the dropdown to navigate between years.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function YearsDropdown(props) {
    const { components } = useDayPicker();
    return React__default.createElement(components.Dropdown, { ...props });
}

var components$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Button: Button,
  CaptionLabel: CaptionLabel,
  Chevron: Chevron,
  Day: Day,
  DayButton: DayButton,
  Dropdown: Dropdown,
  DropdownNav: DropdownNav,
  Footer: Footer,
  Month: Month,
  MonthCaption: MonthCaption,
  MonthGrid: MonthGrid,
  Months: Months,
  MonthsDropdown: MonthsDropdown,
  Nav: Nav,
  NextMonthButton: NextMonthButton,
  Option: Option$2,
  PreviousMonthButton: PreviousMonthButton,
  Root: Root,
  Select: Select$2,
  Week: Week,
  WeekNumber: WeekNumber,
  WeekNumberHeader: WeekNumberHeader,
  Weekday: Weekday,
  Weekdays: Weekdays,
  Weeks: Weeks,
  YearsDropdown: YearsDropdown
});

function getComponents(customComponents) {
    return {
        ...components$1,
        ...customComponents
    };
}

/** Return the `data-` attributes from the props. */
function getDataAttributes(props) {
    const dataAttributes = {
        "data-mode": props.mode ?? undefined,
        "data-required": "required" in props ? props.required : undefined,
        "data-multiple-months": (props.numberOfMonths && props.numberOfMonths > 1) || undefined,
        "data-week-numbers": props.showWeekNumber || undefined
    };
    Object.entries(props).forEach(([key, val]) => {
        if (key.startsWith("data-")) {
            dataAttributes[key] = val;
        }
    });
    return dataAttributes;
}

/**
 * The default date library to use with the date picker.
 *
 * @private
 * @internal
 */
const dateLib = {
    addDays,
    addMonths,
    addWeeks,
    addYears,
    differenceInCalendarDays,
    differenceInCalendarMonths,
    endOfISOWeek,
    endOfMonth,
    endOfWeek,
    endOfYear,
    format: format$1,
    getISOWeek,
    getWeek,
    isAfter,
    isBefore,
    isDate: isDate$1,
    isSameDay,
    isSameMonth,
    isSameYear,
    max: max$1,
    min: min$1,
    setMonth,
    setYear,
    startOfDay,
    startOfISOWeek,
    startOfMonth,
    startOfWeek,
    startOfYear
};

function getDateLib(customLib) {
    return {
        ...dateLib,
        ...customLib
    };
}

/**
 * Get the default class names for the UI elements.
 *
 * @group Utilities
 */
function getDefaultClassNames() {
    const classNames = {};
    for (const key in UI) {
        classNames[UI[key]] =
            `rdp-${UI[key]}`;
    }
    for (const key in DayFlag) {
        classNames[DayFlag[key]] =
            `rdp-${DayFlag[key]}`;
    }
    for (const key in SelectionState) {
        classNames[SelectionState[key]] =
            `rdp-${SelectionState[key]}`;
    }
    return classNames;
}

const offsetFormatCache = {};
const offsetCache = {};

/**
 * The function extracts UTC offset in minutes from the given date in specified
 * time zone.
 *
 * Unlike `Date.prototype.getTimezoneOffset`, this function returns the value
 * mirrored to the sign of the offset in the time zone. For Asia/Singapore
 * (UTC+8), `tzOffset` returns 480, while `getTimezoneOffset` returns -480.
 *
 * @param timeZone - Time zone name (IANA or UTC offset)
 * @param date - Date to check the offset for
 *
 * @returns UTC offset in minutes
 */
function tzOffset(timeZone, date) {
  try {
    const format = offsetFormatCache[timeZone] ||= new Intl.DateTimeFormat("en-GB", {
      timeZone,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format;
    const offsetStr = format(date).split('GMT')[1] || '';
    if (offsetStr in offsetCache) return offsetCache[offsetStr];
    return calcOffset(offsetStr, offsetStr.split(":"));
  } catch {
    // Fallback to manual parsing if the runtime doesn't support ±HH:MM/±HHMM/±HH
    // See: https://github.com/nodejs/node/issues/53419
    if (timeZone in offsetCache) return offsetCache[timeZone];
    const captures = timeZone?.match(offsetRe);
    if (captures) return calcOffset(timeZone, captures.slice(1));
    return NaN;
  }
}
const offsetRe = /([+-]\d\d):?(\d\d)?/;
function calcOffset(cacheStr, values) {
  const hours = +values[0];
  const minutes = +(values[1] || 0);
  return offsetCache[cacheStr] = hours > 0 ? hours * 60 + minutes : hours * 60 - minutes;
}

class TZDateMini extends Date {
  //#region static

  constructor(...args) {
    super();
    if (args.length > 1 && typeof args[args.length - 1] === "string") {
      this.timeZone = args.pop();
    }
    this.internal = new Date();
    if (isNaN(tzOffset(this.timeZone, this))) {
      this.setTime(NaN);
    } else {
      if (!args.length) {
        this.setTime(Date.now());
      } else if (typeof args[0] === "number" && (args.length === 1 || args.length === 2 && typeof args[1] !== "number")) {
        this.setTime(args[0]);
      } else if (typeof args[0] === "string") {
        this.setTime(+new Date(args[0]));
      } else if (args[0] instanceof Date) {
        this.setTime(+args[0]);
      } else {
        this.setTime(+new Date(...args));
        adjustToSystemTZ(this);
      }
    }
    syncToInternal(this);
  }
  static tz(tz, ...args) {
    return args.length ? new TZDateMini(...args, tz) : new TZDateMini(Date.now(), tz);
  }

  //#endregion

  //#region time zone

  withTimeZone(timeZone) {
    return new TZDateMini(+this, timeZone);
  }
  getTimezoneOffset() {
    return -tzOffset(this.timeZone, this);
  }

  //#endregion

  //#region date-fns integration

  [Symbol.for("constructDateFrom")](date) {
    return new TZDateMini(+new Date(date), this.timeZone);
  }

  //#endregion
}

// Assign getters and setters
const re = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach(method => {
  if (!re.test(method)) return;
  const utcMethod = method.replace(re, "$1UTC");
  // Filter out methods without UTC counterparts
  if (!TZDateMini.prototype[utcMethod]) return;
  if (method.startsWith("get")) {
    // Delegate to internal date's UTC method
    TZDateMini.prototype[method] = function () {
      return this.internal[utcMethod]();
    };
  } else {
    // Assign regular setter
    TZDateMini.prototype[method] = function () {
      Date.prototype[utcMethod].apply(this.internal, arguments);
      syncFromInternal(this);
      return +this;
    };

    // Assign UTC setter
    TZDateMini.prototype[utcMethod] = function () {
      Date.prototype[utcMethod].apply(this, arguments);
      syncToInternal(this);
      return +this;
    };
  }
});

/**
 * Function syncs time to internal date, applying the time zone offset.
 *
 * @param {Date} date - Date to sync
 */
function syncToInternal(date) {
  date.internal.setTime(+date);
  date.internal.setUTCMinutes(date.internal.getUTCMinutes() - date.getTimezoneOffset());
}

/**
 * Function syncs the internal date UTC values to the date. It allows to get
 * accurate timestamp value.
 *
 * @param {Date} date - The date to sync
 */
function syncFromInternal(date) {
  // First we transpose the internal values
  Date.prototype.setFullYear.call(date, date.internal.getUTCFullYear(), date.internal.getUTCMonth(), date.internal.getUTCDate());
  Date.prototype.setHours.call(date, date.internal.getUTCHours(), date.internal.getUTCMinutes(), date.internal.getUTCSeconds(), date.internal.getUTCMilliseconds());

  // Now we have to adjust the date to the system time zone
  adjustToSystemTZ(date);
}

/**
 * Function adjusts the date to the system time zone. It uses the time zone
 * differences to calculate the offset and adjust the date.
 *
 * @param {Date} date - Date to adjust
 */
function adjustToSystemTZ(date) {
  // Save the time zone offset before all the adjustments
  const offset = tzOffset(date.timeZone, date);

  //#region System DST adjustment

  // The biggest problem with using the system time zone is that when we create
  // a date from internal values stored in UTC, the system time zone might end
  // up on the DST hour:
  //
  //   $ TZ=America/New_York node
  //   > new Date(2020, 2, 8, 1).toString()
  //   'Sun Mar 08 2020 01:00:00 GMT-0500 (Eastern Standard Time)'
  //   > new Date(2020, 2, 8, 2).toString()
  //   'Sun Mar 08 2020 03:00:00 GMT-0400 (Eastern Daylight Time)'
  //   > new Date(2020, 2, 8, 3).toString()
  //   'Sun Mar 08 2020 03:00:00 GMT-0400 (Eastern Daylight Time)'
  //   > new Date(2020, 2, 8, 4).toString()
  //   'Sun Mar 08 2020 04:00:00 GMT-0400 (Eastern Daylight Time)'
  //
  // Here we get the same hour for both 2 and 3, because the system time zone
  // has DST beginning at 8 March 2020, 2 a.m. and jumps to 3 a.m. So we have
  // to adjust the internal date to reflect that.
  //
  // However we want to adjust only if that's the DST hour the change happenes,
  // not the hour where DST moves to.

  // We calculate the previous hour to see if the time zone offset has changed
  // and we have landed on the DST hour.
  const prevHour = new Date(+date);
  // We use UTC methods here as we don't want to land on the same hour again
  // in case of DST.
  prevHour.setUTCHours(prevHour.getUTCHours() - 1);

  // Calculate if we are on the system DST hour.
  const systemOffset = -new Date(+date).getTimezoneOffset();
  const prevHourSystemOffset = -new Date(+prevHour).getTimezoneOffset();
  const systemDSTChange = systemOffset - prevHourSystemOffset;
  // Detect the DST shift. System DST change will occur both on
  const dstShift = Date.prototype.getHours.apply(date) !== date.internal.getUTCHours();

  // Move the internal date when we are on the system DST hour.
  if (systemDSTChange && dstShift) date.internal.setUTCMinutes(date.internal.getUTCMinutes() + systemDSTChange);

  //#endregion

  //#region System diff adjustment

  // Now we need to adjust the date, since we just applied internal values.
  // We need to calculate the difference between the system and date time zones
  // and apply it to the date.

  const offsetDiff = systemOffset - offset;
  if (offsetDiff) Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetDiff);

  //#endregion

  //#region Post-adjustment DST fix

  const postOffset = tzOffset(date.timeZone, date);
  const postSystemOffset = -new Date(+date).getTimezoneOffset();
  const postOffsetDiff = postSystemOffset - postOffset;
  const offsetChanged = postOffset !== offset;
  const postDiff = postOffsetDiff - offsetDiff;
  if (offsetChanged && postDiff) {
    Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + postDiff);

    // Now we need to check if got offset change during the post-adjustment.
    // If so, we also need both dates to reflect that.

    const newOffset = tzOffset(date.timeZone, date);
    const offsetChange = postOffset - newOffset;
    if (offsetChange) {
      date.internal.setUTCMinutes(date.internal.getUTCMinutes() + offsetChange);
      Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetChange);
    }
  }

  //#endregion
}

/**
 * UTC date class. It maps getters and setters to corresponding UTC methods,
 * forcing all calculations in the UTC time zone.
 *
 * Combined with date-fns, it allows using the class the same way as
 * the original date class.
 *
 * This complete version provides not only getters, setters,
 * and `getTimezoneOffset`, but also the formatter functions, mirroring
 * all original `Date` functionality. Use this version when you need to format
 * a string or in an environment you don't fully control (a library).
 * For a minimal version, see `UTCDateMini`.
 */
class TZDate extends TZDateMini {
  //#region static

  static tz(tz, ...args) {
    return args.length ? new TZDate(...args, tz) : new TZDate(Date.now(), tz);
  }

  //#endregion

  //#region representation

  toISOString() {
    const [sign, hours, minutes] = this.tzComponents();
    const tz = `${sign}${hours}:${minutes}`;
    return this.internal.toISOString().slice(0, -1) + tz;
  }
  toString() {
    // "Tue Aug 13 2024 07:50:19 GMT+0800 (Singapore Standard Time)";
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
    const [day, date, month, year] = this.internal.toUTCString().split(" ");
    // "Tue Aug 13 2024"
    return `${day?.slice(0, -1) /* Remove "," */} ${month} ${date} ${year}`;
  }
  toTimeString() {
    // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
    const time = this.internal.toUTCString().split(" ")[4];
    const [sign, hours, minutes] = this.tzComponents();
    // "07:42:23 GMT+0800 (Singapore Standard Time)"
    return `${time} GMT${sign}${hours}${minutes} (${tzName(this.timeZone, this)})`;
  }
  toLocaleString(locales, options) {
    return Date.prototype.toLocaleString.call(this, locales, {
      ...options,
      timeZone: options?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(locales, options) {
    return Date.prototype.toLocaleDateString.call(this, locales, {
      ...options,
      timeZone: options?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(locales, options) {
    return Date.prototype.toLocaleTimeString.call(this, locales, {
      ...options,
      timeZone: options?.timeZone || this.timeZone
    });
  }

  //#endregion

  //#region private

  tzComponents() {
    const offset = this.getTimezoneOffset();
    const sign = offset > 0 ? "-" : "+";
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
    const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
    return [sign, hours, minutes];
  }

  //#endregion

  withTimeZone(timeZone) {
    return new TZDate(+this, timeZone);
  }

  //#region date-fns integration

  [Symbol.for("constructDateFrom")](date) {
    return new TZDate(+new Date(date), this.timeZone);
  }

  //#endregion
}
function tzName(tz, date) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: tz,
    timeZoneName: "long"
  }).format(date).slice(12);
}

/**
 * Format the caption of the month.
 *
 * @defaultValue `LLLL y` (e.g. "November 2022")
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
function formatCaption(month, options, 
/** @ignore */
dateLib$1 = dateLib) {
    return dateLib$1.format(month, "LLLL y", options);
}
/**
 * @private
 * @deprecated Use {@link formatCaption} instead.
 * @group Formatters
 */
const formatMonthCaption = formatCaption;

/**
 * Format the day date shown in the day cell.
 *
 * @defaultValue `d` (e.g. "1")
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
function formatDay(date, options, 
/** @ignore */
dateLib$1 = dateLib) {
    return dateLib$1.format(date, "d", options);
}

/**
 * Format the month number for the dropdown option label.
 *
 * @defaultValue The localized month name
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
function formatMonthDropdown(
/** The month number to format. */
monthNumber, 
/** The locale to use for formatting. */
locale = enUS) {
    return locale.localize?.month(monthNumber);
}

/**
 * Format the week number.
 *
 * @defaultValue `weekNumber.toLocaleString()` with a leading zero for single-digit numbers
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
function formatWeekNumber(weekNumber) {
    if (weekNumber < 10) {
        return `0${weekNumber.toLocaleString()}`;
    }
    return `${weekNumber.toLocaleString()}`;
}

/**
 * Format the week number header.
 *
 * @defaultValue `""`
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
function formatWeekNumberHeader() {
    return ``;
}

/**
 * Format the weekday name to be displayed in the weekdays header.
 *
 * @defaultValue `cccccc` (e.g. "Mo" for Monday)
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
function formatWeekdayName(weekday, options, 
/** @ignore */
dateLib$1 = dateLib) {
    return dateLib$1.format(weekday, "cccccc", options);
}

/**
 * Format the years for the dropdown option label.
 *
 * @defaultValue `year.toString()`
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
function formatYearDropdown(year) {
    return year.toString();
}
/**
 * @private
 * @deprecated Use `formatYearDropdown` instead.
 * @group Formatters
 */
const formatYearCaption = formatYearDropdown;

var defaultFormatters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  formatCaption: formatCaption,
  formatDay: formatDay,
  formatMonthCaption: formatMonthCaption,
  formatMonthDropdown: formatMonthDropdown,
  formatWeekNumber: formatWeekNumber,
  formatWeekNumberHeader: formatWeekNumberHeader,
  formatWeekdayName: formatWeekdayName,
  formatYearCaption: formatYearCaption,
  formatYearDropdown: formatYearDropdown
});

/** Return the formatters from the props merged with the default formatters. */
function getFormatters(customFormatters) {
    if (customFormatters?.formatMonthCaption && !customFormatters.formatCaption) {
        customFormatters.formatCaption = customFormatters.formatMonthCaption;
    }
    if (customFormatters?.formatYearCaption &&
        !customFormatters.formatYearDropdown) {
        customFormatters.formatYearDropdown = customFormatters.formatYearCaption;
    }
    return {
        ...defaultFormatters,
        ...customFormatters
    };
}

/** Return the months to show in the dropdown. */
function getMonthOptions(displayMonth, navStart, navEnd, formatters, locale, dateLib) {
    if (!navStart)
        return undefined;
    if (!navEnd)
        return undefined;
    const { addMonths, startOfMonth, isBefore } = dateLib;
    const year = displayMonth.getFullYear();
    const months = [];
    let month = navStart;
    while (months.length < 12 && isBefore(month, addMonths(navEnd, 1))) {
        months.push(month.getMonth());
        month = addMonths(month, 1);
    }
    const sortedMonths = months.sort((a, b) => {
        return a - b;
    });
    const options = sortedMonths.map((value) => {
        const label = formatters.formatMonthDropdown(value, locale);
        const month = dateLib.Date
            ? new dateLib.Date(year, value)
            : new Date(year, value);
        const disabled = (navStart && month < startOfMonth(navStart)) ||
            (navEnd && month > startOfMonth(navEnd)) ||
            false;
        return { value, label, disabled };
    });
    return options;
}

function getStyleForModifiers(dayModifiers, styles = {}, modifiersStyles = {}) {
    let style = { ...styles?.[UI.Day] };
    Object.entries(dayModifiers)
        .filter(([, active]) => active === true)
        .forEach(([modifier]) => {
        style = {
            ...style,
            ...modifiersStyles?.[modifier]
        };
    });
    return style;
}

/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */
function getWeekdays(locale, 
/** The index of the first day of the week (0 - Sunday). */
weekStartsOn, 
/** Use ISOWeek instead of locale/ */
ISOWeek, timeZone, 
/** @ignore */
dateLib$1 = dateLib) {
    const date = timeZone
        ? TZDate.tz(timeZone)
        : dateLib$1.Date
            ? new dateLib$1.Date()
            : new Date();
    const start = ISOWeek
        ? dateLib$1.startOfISOWeek(date)
        : dateLib$1.startOfWeek(date, { locale, weekStartsOn });
    const days = [];
    for (let i = 0; i < 7; i++) {
        const day = dateLib$1.addDays(start, i);
        days.push(day);
    }
    return days;
}

/** Return the years to show in the dropdown. */
function getYearOptions(displayMonth, calendarStart, calendarEnd, formatters, dateLib) {
    if (!calendarStart)
        return undefined;
    if (!calendarEnd)
        return undefined;
    const { startOfMonth, startOfYear, endOfYear, addYears, isBefore, isSameYear } = dateLib;
    const month = displayMonth.getMonth();
    const firstNavYear = startOfYear(calendarStart);
    const lastNavYear = endOfYear(calendarEnd);
    const years = [];
    let year = firstNavYear;
    while (isBefore(year, lastNavYear) || isSameYear(year, lastNavYear)) {
        years.push(year.getFullYear());
        year = addYears(year, 1);
    }
    return years.map((value) => {
        const year = dateLib.Date
            ? new dateLib.Date(value, month)
            : new Date(value, month);
        const disabled = (calendarStart && year < startOfMonth(calendarStart)) ||
            (month && calendarEnd && year > startOfMonth(calendarEnd)) ||
            false;
        const label = formatters.formatYearDropdown(value);
        return {
            value,
            label,
            disabled
        };
    });
}

/**
 * Return an ARIA label for the month grid, that will be announced when entering
 * the grid.
 *
 * @defaultValue `LLLL y` (e.g. "November 2022")
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelGrid(date, options, 
/** @ignore */
dateLib$1 = dateLib) {
    return dateLib$1.format(date, "LLLL y", options);
}
/**
 * @deprecated Use {@link labelGrid} instead.
 * @protected
 */
const labelCaption = labelGrid;

/**
 * The label for the day gridcell when the calendar is not interactive.
 *
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelGridcell(date, 
/** The modifiers for the day. */
modifiers, options, 
/** @ignore */
dateLib$1 = dateLib) {
    let label = dateLib$1.format(date, "PPPP", options);
    if (modifiers?.today) {
        label = `Today, ${label}`;
    }
    return label;
}

/**
 * The ARIA label for the day button.
 *
 * Use the `modifiers` argument to add additional context to the label, e.g.
 * when a day is selected or is today.
 *
 * @defaultValue The formatted date.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelDayButton(date, 
/** The modifiers for the day. */
modifiers, options, 
/** @ignore */
dateLib$1 = dateLib) {
    let label = dateLib$1.format(date, "PPPP", options);
    if (modifiers.today)
        label = `Today, ${label}`;
    if (modifiers.selected)
        label = `${label}, selected`;
    return label;
}
/** @deprecated Use `labelDayButton` instead. */
const labelDay = labelDayButton;

/**
 * The ARIA label for the navigation toolbar.
 *
 * @defaultValue `""`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelNav() {
    return "";
}

/**
 * The ARIA label for the months dropdown.
 *
 * @defaultValue `"Choose the Month"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelMonthDropdown(options) {
    return "Choose the Month";
}

/**
 * The ARIA label for next month button.
 *
 * @defaultValue `"Go to the Next Month"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelNext(
/** `undefined` where there's no next month to navigate to. */
month) {
    return "Go to the Next Month";
}

/**
 * The ARIA label for previous month button.
 *
 * @defaultValue `"Go to the Previous Month"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelPrevious(
/** Undefined where there's no previous month to navigate to. */
month) {
    return "Go to the Previous Month";
}

/**
 * The ARIA label for the Weekday column header.
 *
 * @defaultValue `"Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelWeekday(date, options, 
/** @ignore */
dateLib$1 = dateLib) {
    return dateLib$1.format(date, "cccc", options);
}

/**
 * The ARIA label for the week number cell (the first cell in the row).
 *
 * @defaultValue `Week ${weekNumber}`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelWeekNumber(weekNumber, options) {
    return `Week ${weekNumber}`;
}

/**
 * The ARIA label for the week number header element.
 *
 * @defaultValue `"Week Number"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelWeekNumberHeader(options) {
    return "Week Number";
}

/**
 * The ARIA label for the years dropdown.
 *
 * @defaultValue `"Choose the Year"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
function labelYearDropdown(options) {
    return "Choose the Year";
}

var defaultLabels = /*#__PURE__*/Object.freeze({
  __proto__: null,
  labelCaption: labelCaption,
  labelDay: labelDay,
  labelDayButton: labelDayButton,
  labelGrid: labelGrid,
  labelGridcell: labelGridcell,
  labelMonthDropdown: labelMonthDropdown,
  labelNav: labelNav,
  labelNext: labelNext,
  labelPrevious: labelPrevious,
  labelWeekNumber: labelWeekNumber,
  labelWeekNumberHeader: labelWeekNumberHeader,
  labelWeekday: labelWeekday,
  labelYearDropdown: labelYearDropdown
});

/** The number of days in a month when having 6 weeks. */
const NrOfDaysWithFixedWeeks = 42;
/** Return all the dates to display in the calendar. */
function getDates(displayMonths, maxDate, props, dateLib) {
    const firstMonth = displayMonths[0];
    const lastMonth = displayMonths[displayMonths.length - 1];
    const { ISOWeek, fixedWeeks, locale, weekStartsOn } = props ?? {};
    const { startOfWeek, endOfWeek, startOfISOWeek, endOfISOWeek, addDays, differenceInCalendarDays, differenceInCalendarMonths, isAfter, endOfMonth } = dateLib;
    const startWeekFirstDate = ISOWeek
        ? startOfISOWeek(firstMonth)
        : startOfWeek(firstMonth, {
            weekStartsOn,
            locale
        });
    const endWeekLastDate = ISOWeek
        ? endOfISOWeek(endOfMonth(lastMonth))
        : endOfWeek(endOfMonth(lastMonth), {
            weekStartsOn,
            locale
        });
    const nOfDays = differenceInCalendarDays(endWeekLastDate, startWeekFirstDate);
    const nOfMonths = differenceInCalendarMonths(lastMonth, firstMonth) + 1;
    const dates = [];
    for (let i = 0; i <= nOfDays; i++) {
        const date = addDays(startWeekFirstDate, i);
        if (maxDate && isAfter(date, maxDate)) {
            break;
        }
        dates.push(date);
    }
    // If fixed weeks is enabled, add the extra dates to the array
    const extraDates = NrOfDaysWithFixedWeeks * nOfMonths;
    if (fixedWeeks && dates.length < extraDates) {
        for (let i = 0; i < 7; i++) {
            const date = addDays(dates[dates.length - 1], 1);
            dates.push(date);
        }
    }
    return dates;
}

/**
 * Returns all the days belonging to the calendar by merging the days in the
 * weeks for each month.
 */
function getDays(calendarMonths) {
    const initialDays = [];
    return calendarMonths.reduce((days, month) => {
        const initialDays = [];
        const weekDays = month.weeks.reduce((weekDays, week) => {
            return [...weekDays, ...week.days];
        }, initialDays);
        return [...days, ...weekDays];
    }, initialDays);
}

function getDisplayMonths(firstDisplayedMonth, calendarEndMonth, props, dateLib) {
    const { numberOfMonths = 1 } = props;
    const months = [];
    for (let i = 0; i < numberOfMonths; i++) {
        const month = dateLib.addMonths(firstDisplayedMonth, i);
        if (calendarEndMonth && month > calendarEndMonth) {
            break;
        }
        months.push(month);
    }
    return months;
}

/** Return the start month based on the props passed to DayPicker. */
function getInitialMonth(props, dateLib) {
    const { month, defaultMonth, today = props.timeZone
        ? TZDate.tz(props.timeZone)
        : dateLib.Date
            ? new dateLib.Date()
            : new Date(), numberOfMonths = 1, endMonth, startMonth } = props;
    let initialMonth = month || defaultMonth || today;
    const { differenceInCalendarMonths, addMonths, startOfMonth } = dateLib;
    // Fix the initialMonth if is after the to-date
    if (endMonth && differenceInCalendarMonths(endMonth, initialMonth) < 0) {
        const offset = -1 * (numberOfMonths - 1);
        initialMonth = addMonths(endMonth, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (startMonth && differenceInCalendarMonths(initialMonth, startMonth) < 0) {
        initialMonth = startMonth;
    }
    return startOfMonth(initialMonth);
}

/**
 * Represent the day displayed in the calendar.
 *
 * In DayPicker, a `Day` is a `Date` that can be displayed in the calendar. It
 * is used as extension of the native `Date` object to provide additional
 * information about the day.
 */
class CalendarDay {
    constructor(date, displayMonth, 
    /** @ignore */
    dateLib$1 = dateLib) {
        this.date = date;
        this.displayMonth = displayMonth;
        this.outside = Boolean(displayMonth && !dateLib$1.isSameMonth(date, displayMonth));
        this.dateLib = dateLib$1;
    }
    /**
     * Check if the day is the same as the given day: considering if it is in the
     * same display month.
     */
    isEqualTo(day) {
        return (this.dateLib.isSameDay(day.date, this.date) &&
            this.dateLib.isSameMonth(day.displayMonth, this.displayMonth));
    }
}

/** Represent a month in a calendar year. Contains the weeks within the month. */
class CalendarMonth {
    constructor(month, weeks) {
        this.date = month;
        this.weeks = weeks;
    }
}

/** Represent a week in a calendar month. */
class CalendarWeek {
    constructor(weekNumber, days) {
        this.days = days;
        this.weekNumber = weekNumber;
    }
}

/** Return the months to display in the calendar. */
function getMonths(
/** The months (as dates) to display in the calendar. */
displayMonths, 
/** The dates to display in the calendar. */
dates, 
/** Options from the props context. */
props, dateLib) {
    const { startOfWeek, endOfWeek, startOfISOWeek, endOfISOWeek, endOfMonth, addDays, getWeek, getISOWeek } = dateLib;
    const dayPickerMonths = displayMonths.reduce((months, month) => {
        const firstDateOfFirstWeek = props.ISOWeek
            ? startOfISOWeek(month)
            : startOfWeek(month, {
                locale: props.locale,
                weekStartsOn: props.weekStartsOn
            });
        const lastDateOfLastWeek = props.ISOWeek
            ? endOfISOWeek(endOfMonth(month))
            : endOfWeek(endOfMonth(month), {
                locale: props.locale,
                weekStartsOn: props.weekStartsOn
            });
        /** The dates to display in the month. */
        const monthDates = dates.filter((date) => {
            return date >= firstDateOfFirstWeek && date <= lastDateOfLastWeek;
        });
        if (props.fixedWeeks && monthDates.length < 42) {
            const extraDates = dates.filter((date) => {
                return (date > lastDateOfLastWeek && date <= addDays(lastDateOfLastWeek, 7));
            });
            monthDates.push(...extraDates);
        }
        const weeks = monthDates.reduce((weeks, date) => {
            const weekNumber = props.ISOWeek
                ? getISOWeek(date)
                : getWeek(date, {
                    locale: props.locale,
                    weekStartsOn: props.weekStartsOn,
                    firstWeekContainsDate: props.firstWeekContainsDate
                });
            const week = weeks.find((week) => week.weekNumber === weekNumber);
            const day = new CalendarDay(date, month, dateLib);
            if (!week) {
                weeks.push(new CalendarWeek(weekNumber, [day]));
            }
            else {
                week.days.push(day);
            }
            return weeks;
        }, []);
        const dayPickerMonth = new CalendarMonth(month, weeks);
        months.push(dayPickerMonth);
        return months;
    }, []);
    if (!props.reverseMonths) {
        return dayPickerMonths;
    }
    else {
        return dayPickerMonths.reverse();
    }
}

/** Return the start and end months for the calendar navigation. */
function getNavMonths(props, dateLib) {
    let { startMonth, endMonth } = props;
    const { startOfYear, startOfDay, startOfMonth, endOfMonth, addYears, endOfYear } = dateLib;
    // Handle deprecated code
    const { fromYear, toYear, fromMonth, toMonth } = props;
    if (!startMonth && fromMonth) {
        startMonth = fromMonth;
    }
    if (!startMonth && fromYear) {
        startMonth = new Date(fromYear, 0, 1);
    }
    if (!endMonth && toMonth) {
        endMonth = toMonth;
    }
    if (!endMonth && toYear) {
        endMonth = new Date(toYear, 11, 31);
    }
    const hasDropdowns = props.captionLayout?.startsWith("dropdown");
    if (startMonth) {
        startMonth = startOfMonth(startMonth);
    }
    else if (fromYear) {
        startMonth = new Date(fromYear, 0, 1);
    }
    else if (!startMonth && hasDropdowns) {
        const today = props.today ??
            (props.timeZone
                ? TZDate.tz(props.timeZone)
                : dateLib.Date
                    ? new dateLib.Date()
                    : new Date());
        startMonth = startOfYear(addYears(today, -100));
    }
    if (endMonth) {
        endMonth = endOfMonth(endMonth);
    }
    else if (toYear) {
        endMonth = new Date(toYear, 11, 31);
    }
    else if (!endMonth && hasDropdowns) {
        const today = props.today ??
            (props.timeZone
                ? TZDate.tz(props.timeZone)
                : dateLib.Date
                    ? new dateLib.Date()
                    : new Date());
        endMonth = endOfYear(today);
    }
    return [
        startMonth ? startOfDay(startMonth) : startMonth,
        endMonth ? startOfDay(endMonth) : endMonth
    ];
}

/**
 * Return the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - If after the `calendarEndMonth` range, is `undefined`;
 * - If the navigation is paged , is the number of months displayed ahead.
 */
function getNextMonth(firstDisplayedMonth, calendarEndMonth, options, dateLib) {
    if (options.disableNavigation) {
        return undefined;
    }
    const { pagedNavigation, numberOfMonths = 1 } = options;
    const { startOfMonth, addMonths, differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? numberOfMonths : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarEndMonth) {
        return addMonths(month, offset);
    }
    const monthsDiff = differenceInCalendarMonths(calendarEndMonth, firstDisplayedMonth);
    if (monthsDiff < numberOfMonths) {
        return undefined;
    }
    // Jump forward as the number of months when paged navigation
    return addMonths(month, offset);
}

/**
 * Return the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - If before the `calendarStartMonth` date, is `undefined`;
 * - If the navigation is paged, is the number of months displayed before.
 */
function getPreviousMonth(firstDisplayedMonth, calendarStartMonth, options, dateLib) {
    if (options.disableNavigation) {
        return undefined;
    }
    const { pagedNavigation, numberOfMonths } = options;
    const { startOfMonth, addMonths, differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? (numberOfMonths ?? 1) : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarStartMonth) {
        return addMonths(month, -offset);
    }
    const monthsDiff = differenceInCalendarMonths(month, calendarStartMonth);
    if (monthsDiff <= 0) {
        return undefined;
    }
    return addMonths(month, -offset);
}

/** Returns an array of calendar weeks from an array of calendar months. */
function getWeeks(months) {
    const initialWeeks = [];
    return months.reduce((weeks, month) => {
        return [...weeks, ...month.weeks];
    }, initialWeeks);
}

/**
 * A custom hook for managing both controlled and uncontrolled component states.
 *
 * @example
 *   // Uncontrolled usage
 *   const [value, setValue] = useControlledValue(0, undefined);
 *
 *   // Controlled usage
 *   const [value, setValue] = useControlledValue(0, props.value);
 *
 * @template T - The type of the value.
 * @param {T} defaultValue - The initial value for the uncontrolled state.
 * @param {T | undefined} controlledValue - The value for the controlled state.
 *   If undefined, the component will use the uncontrolled state.
 * @returns {[T, DispatchStateAction<T>]} - Returns a tuple where the first
 *   element is the current value (either controlled or uncontrolled) and the
 *   second element is a setter function to update the value.
 */
function useControlledValue(defaultValue, controlledValue) {
    const [uncontrolledValue, setValue] = useState(defaultValue);
    const value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [value, setValue];
}

/** @private */
function useCalendar(props, dateLib) {
    const [navStart, navEnd] = getNavMonths(props, dateLib);
    const { startOfMonth, endOfMonth } = dateLib;
    const initialMonth = getInitialMonth(props, dateLib);
    const [firstMonth, setFirstMonth] = useControlledValue(initialMonth, props.month ? startOfMonth(props.month) : undefined);
    useEffect(() => {
        const newInitialMonth = getInitialMonth(props, dateLib);
        setFirstMonth(newInitialMonth);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.timeZone]);
    /** The months displayed in the calendar. */
    const displayMonths = getDisplayMonths(firstMonth, navEnd, props, dateLib);
    /** The dates displayed in the calendar. */
    const dates = getDates(displayMonths, props.endMonth ? endOfMonth(props.endMonth) : undefined, props, dateLib);
    /** The Months displayed in the calendar. */
    const months = getMonths(displayMonths, dates, props, dateLib);
    /** The Weeks displayed in the calendar. */
    const weeks = getWeeks(months);
    /** The Days displayed in the calendar. */
    const days = getDays(months);
    const previousMonth = getPreviousMonth(firstMonth, navStart, props, dateLib);
    const nextMonth = getNextMonth(firstMonth, navEnd, props, dateLib);
    const { disableNavigation, onMonthChange } = props;
    const isDayInCalendar = (day) => weeks.some((week) => week.days.some((d) => d.isEqualTo(day)));
    const goToMonth = (date) => {
        if (disableNavigation) {
            return;
        }
        let newMonth = startOfMonth(date);
        // if month is before start, use the first month instead
        if (navStart && newMonth < startOfMonth(navStart)) {
            newMonth = startOfMonth(navStart);
        }
        // if month is after endMonth, use the last month instead
        if (navEnd && newMonth > startOfMonth(navEnd)) {
            newMonth = startOfMonth(navEnd);
        }
        setFirstMonth(newMonth);
        onMonthChange?.(newMonth);
    };
    const goToDay = (day) => {
        // is this check necessary?
        if (isDayInCalendar(day)) {
            return;
        }
        goToMonth(day.date);
    };
    const calendar = {
        months,
        weeks,
        days,
        navStart,
        navEnd,
        previousMonth,
        nextMonth,
        goToMonth,
        goToDay
    };
    return calendar;
}

function calculateFocusTarget(days, getModifiers, isSelected, lastFocused) {
    let focusTarget;
    let index = 0;
    let found = false;
    while (index < days.length && !found) {
        const day = days[index];
        const modifiers = getModifiers(day);
        if (!modifiers[DayFlag.disabled] &&
            !modifiers[DayFlag.hidden] &&
            !modifiers[DayFlag.outside]) {
            if (modifiers[DayFlag.focused]) {
                focusTarget = day;
                found = true;
            }
            else if (lastFocused?.isEqualTo(day)) {
                focusTarget = day;
                found = true;
            }
            else if (isSelected(day.date)) {
                focusTarget = day;
                found = true;
            }
            else if (modifiers[DayFlag.today]) {
                focusTarget = day;
                found = true;
            }
        }
        index++;
    }
    if (!focusTarget) {
        // return the first day that is focusable
        focusTarget = days.find((day) => {
            const m = getModifiers(day);
            return !m[DayFlag.disabled] && !m[DayFlag.hidden] && !m[DayFlag.outside];
        });
    }
    return focusTarget;
}

/**
 * Determines whether a given date is inside a specified date range.
 *
 * @since 9.0.0
 * @group Utilities
 */
function rangeIncludesDate(range, date, 
/** If `true`, the ends of the range are excluded. */
excludeEnds = false, 
/** @ignore */
dateLib$1 = dateLib) {
    let { from, to } = range;
    const { differenceInCalendarDays, isSameDay } = dateLib$1;
    if (from && to) {
        const isRangeInverted = differenceInCalendarDays(to, from) < 0;
        if (isRangeInverted) {
            [from, to] = [to, from];
        }
        const isInRange = differenceInCalendarDays(date, from) >= (excludeEnds ? 1 : 0) &&
            differenceInCalendarDays(to, date) >= (excludeEnds ? 1 : 0);
        return isInRange;
    }
    if (!excludeEnds && to) {
        return isSameDay(to, date);
    }
    if (!excludeEnds && from) {
        return isSameDay(from, date);
    }
    return false;
}

/**
 * Returns true if `matcher` is of type {@link DateInterval}.
 *
 * @group Utilities
 */
function isDateInterval(matcher) {
    return Boolean(matcher &&
        typeof matcher === "object" &&
        "before" in matcher &&
        "after" in matcher);
}
/**
 * Returns true if `value` is a {@link DateRange} type.
 *
 * @group Utilities
 */
function isDateRange(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
/**
 * Returns true if `value` is of type {@link DateAfter}.
 *
 * @group Utilities
 */
function isDateAfterType(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
/**
 * Returns true if `value` is of type {@link DateBefore}.
 *
 * @group Utilities
 */
function isDateBeforeType(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
/**
 * Returns true if `value` is a {@link DayOfWeek} type.
 *
 * @group Utilities
 */
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
/**
 * Returns true if `value` is an array of valid dates.
 *
 * @private
 */
function isDatesArray(value, dateLib) {
    return Array.isArray(value) && value.every(dateLib.isDate);
}

/**
 * Returns whether a day matches against at least one of the given
 * {@link Matcher}.
 *
 * ```tsx
 * const date = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *  from: new Date(2021, 12, 21),
 *  to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *  from: new Date(2022, 5, 1),
 *  to: new Date(2022, 5, 23)
 * }
 * const dateMatchModifiers(date, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 *
 * @group Utilities
 */
function dateMatchModifiers(date, matchers, dateLib$1 = dateLib) {
    const matchersArr = !Array.isArray(matchers) ? [matchers] : matchers;
    const { isSameDay, differenceInCalendarDays, isAfter } = dateLib$1;
    return matchersArr.some((matcher) => {
        if (typeof matcher === "boolean") {
            return matcher;
        }
        if (dateLib$1.isDate(matcher)) {
            return isSameDay(date, matcher);
        }
        if (isDatesArray(matcher, dateLib$1)) {
            return matcher.includes(date);
        }
        if (isDateRange(matcher)) {
            return rangeIncludesDate(matcher, date, false, dateLib$1);
        }
        if (isDayOfWeekType(matcher)) {
            if (!Array.isArray(matcher.dayOfWeek)) {
                return matcher.dayOfWeek === date.getDay();
            }
            return matcher.dayOfWeek.includes(date.getDay());
        }
        if (isDateInterval(matcher)) {
            const diffBefore = differenceInCalendarDays(matcher.before, date);
            const diffAfter = differenceInCalendarDays(matcher.after, date);
            const isDayBefore = diffBefore > 0;
            const isDayAfter = diffAfter < 0;
            const isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) {
                return isDayAfter && isDayBefore;
            }
            else {
                return isDayBefore || isDayAfter;
            }
        }
        if (isDateAfterType(matcher)) {
            return differenceInCalendarDays(date, matcher.after) > 0;
        }
        if (isDateBeforeType(matcher)) {
            return differenceInCalendarDays(matcher.before, date) > 0;
        }
        if (typeof matcher === "function") {
            return matcher(date);
        }
        return false;
    });
}

/** Return the next date that should be focused. */
function getFocusableDate(moveBy, moveDir, refDate, navStart, navEnd, props, dateLib) {
    const { weekStartsOn, locale, ISOWeek } = props;
    const { addDays, addMonths, addYears, addWeeks, startOfISOWeek, endOfISOWeek, startOfWeek, endOfWeek, max, min } = dateLib;
    const moveFns = {
        day: addDays,
        week: addWeeks,
        month: addMonths,
        year: addYears,
        startOfWeek: (date) => ISOWeek
            ? startOfISOWeek(date)
            : startOfWeek(date, { locale, weekStartsOn }),
        endOfWeek: (date) => ISOWeek ? endOfISOWeek(date) : endOfWeek(date, { locale, weekStartsOn })
    };
    let focusableDate = moveFns[moveBy](refDate, moveDir === "after" ? 1 : -1);
    if (moveDir === "before" && navStart) {
        focusableDate = max([navStart, focusableDate]);
    }
    else if (moveDir === "after" && navEnd) {
        focusableDate = min([navEnd, focusableDate]);
    }
    return focusableDate;
}

function getNextFocus(moveBy, moveDir, 
/** The date that is currently focused. */
refDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt = 0) {
    if (attempt > 365) {
        // Limit the recursion to 365 attempts
        return undefined;
    }
    const focusableDate = getFocusableDate(moveBy, moveDir, refDay.date, // should be refDay? or refDay.date?
    calendarStartMonth, calendarEndMonth, props, dateLib);
    const isDisabled = Boolean(props.disabled && dateMatchModifiers(focusableDate, props.disabled, dateLib));
    const isHidden = Boolean(props.hidden && dateMatchModifiers(focusableDate, props.hidden, dateLib));
    const targetMonth = focusableDate;
    const focusDay = new CalendarDay(focusableDate, targetMonth, dateLib);
    if (!isDisabled && !isHidden) {
        return focusDay;
    }
    // Recursively attempt to find the next focusable date
    return getNextFocus(moveBy, moveDir, focusDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt + 1);
}

/** @private */
function useFocus(props, calendar, getModifiers, isSelected, dateLib) {
    const { autoFocus } = props;
    const [lastFocused, setLastFocused] = useState();
    const focusTarget = calculateFocusTarget(calendar.days, getModifiers, isSelected || (() => false), lastFocused);
    const [focusedDay, setFocused] = useState(autoFocus ? focusTarget : undefined);
    const blur = () => {
        setLastFocused(focusedDay);
        setFocused(undefined);
    };
    const moveFocus = (moveBy, moveDir) => {
        if (!focusedDay)
            return;
        const nextFocus = getNextFocus(moveBy, moveDir, focusedDay, calendar.navStart, calendar.navEnd, props, dateLib);
        if (!nextFocus)
            return;
        calendar.goToDay(nextFocus);
        setFocused(nextFocus);
    };
    const isFocusTarget = (day) => {
        return Boolean(focusTarget?.isEqualTo(day));
    };
    const useFocus = {
        isFocusTarget,
        setFocused,
        focused: focusedDay,
        blur,
        moveFocus
    };
    return useFocus;
}

/**
 * Return a function to get the modifiers for a given day.
 *
 * @private
 */
function useGetModifiers(days, props, dateLib) {
    const { disabled, hidden, modifiers, showOutsideDays, today } = props;
    const { isSameDay, isSameMonth } = dateLib;
    const internalModifiersMap = {
        [DayFlag.focused]: [],
        [DayFlag.outside]: [],
        [DayFlag.disabled]: [],
        [DayFlag.hidden]: [],
        [DayFlag.today]: []
    };
    const customModifiersMap = {};
    const selectionModifiersMap = {
        [SelectionState.range_end]: [],
        [SelectionState.range_middle]: [],
        [SelectionState.range_start]: [],
        [SelectionState.selected]: []
    };
    for (const day of days) {
        const { date, displayMonth } = day;
        const isOutside = Boolean(displayMonth && !isSameMonth(date, displayMonth));
        const isDisabled = Boolean(disabled && dateMatchModifiers(date, disabled, dateLib));
        const isHidden = Boolean(hidden && dateMatchModifiers(date, hidden, dateLib)) ||
            (!showOutsideDays && isOutside);
        const isToday = isSameDay(date, today ??
            (props.timeZone
                ? TZDate.tz(props.timeZone)
                : dateLib.Date
                    ? new dateLib.Date()
                    : new Date()));
        if (isOutside)
            internalModifiersMap.outside.push(day);
        if (isDisabled)
            internalModifiersMap.disabled.push(day);
        if (isHidden)
            internalModifiersMap.hidden.push(day);
        if (isToday)
            internalModifiersMap.today.push(day);
        // Add custom modifiers
        if (modifiers) {
            Object.keys(modifiers).forEach((name) => {
                const modifierValue = modifiers?.[name];
                const isMatch = modifierValue
                    ? dateMatchModifiers(date, modifierValue, dateLib)
                    : false;
                if (!isMatch)
                    return;
                if (customModifiersMap[name]) {
                    customModifiersMap[name].push(day);
                }
                else {
                    customModifiersMap[name] = [day];
                }
            });
        }
    }
    return (day) => {
        // Initialize all the modifiers to false
        const dayFlags = {
            [DayFlag.focused]: false,
            [DayFlag.disabled]: false,
            [DayFlag.hidden]: false,
            [DayFlag.outside]: false,
            [DayFlag.today]: false
        };
        const selectionStates = {
            [SelectionState.range_end]: false,
            [SelectionState.range_middle]: false,
            [SelectionState.range_start]: false,
            [SelectionState.selected]: false
        };
        const customModifiers = {};
        // Find the modifiers for the given day
        for (const name in internalModifiersMap) {
            const days = internalModifiersMap[name];
            dayFlags[name] = days.some((d) => d === day);
        }
        for (const name in selectionModifiersMap) {
            const days = selectionModifiersMap[name];
            selectionStates[name] = days.some((d) => d === day);
        }
        for (const name in customModifiersMap) {
            customModifiers[name] = customModifiersMap[name].some((d) => d === day);
        }
        return {
            ...selectionStates,
            ...dayFlags,
            // custom modifiers should override all the previous ones
            ...customModifiers
        };
    };
}

function useMulti(props, dateLib) {
    const { selected: initiallySelected, required, onSelect } = props;
    const [internallySelected, setSelected] = useControlledValue(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay } = dateLib;
    const isSelected = (date) => {
        return selected?.some((d) => isSameDay(d, date)) ?? false;
    };
    const { min, max } = props;
    const select = (triggerDate, modifiers, e) => {
        let newDates = [...(selected ?? [])];
        if (isSelected(triggerDate)) {
            if (selected?.length === min) {
                // Min value reached, do nothing
                return;
            }
            if (required && selected?.length === 1) {
                // Required value already selected do nothing
                return;
            }
            newDates = selected?.filter((d) => !isSameDay(d, triggerDate));
        }
        else {
            if (selected?.length === max) {
                // Max value reached, reset the selection to date
                newDates = [triggerDate];
            }
            else {
                // Add the date to the selection
                newDates = [...newDates, triggerDate];
            }
        }
        if (!onSelect) {
            setSelected(newDates);
        }
        onSelect?.(newDates, triggerDate, modifiers, e);
        return newDates;
    };
    return {
        selected,
        select,
        isSelected
    };
}

/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 *
 * @group Utilities
 */
function addToRange(
/** The date to add to the range. */
date, 
/** The range where to add `date`. */
initialRange, min = 0, max = 0, required = false, 
/** @ignore */
dateLib$1 = dateLib) {
    const { from, to } = initialRange || {};
    const { isSameDay, isAfter, isBefore } = dateLib$1;
    let range;
    if (!from && !to) {
        // the range is empty, add the date
        range = { from: date, to: min > 0 ? undefined : date };
    }
    else if (from && !to) {
        // adding date to an incomplete range
        if (isSameDay(from, date)) {
            // adding a date equal to the start of the range
            if (required) {
                range = { from, to: undefined };
            }
            else {
                range = undefined;
            }
        }
        else if (isBefore(date, from)) {
            // adding a date before the start of the range
            range = { from: date, to: from };
        }
        else {
            // adding a date after the start of the range
            range = { from, to: date };
        }
    }
    else if (from && to) {
        // adding date to a complete range
        if (isSameDay(from, date) && isSameDay(to, date)) {
            // adding a date that is equal to both start and end of the range
            if (required) {
                range = { from, to };
            }
            else {
                range = undefined;
            }
        }
        else if (isSameDay(from, date)) {
            // adding a date equal to the the start of the range
            range = { from, to: min > 0 ? undefined : date };
        }
        else if (isSameDay(to, date)) {
            // adding a dare equal to the end of the range
            range = { from: date, to: min > 0 ? undefined : date };
        }
        else if (isBefore(date, from)) {
            // adding a date before the start of the range
            range = { from: date, to: to };
        }
        else if (isAfter(date, from)) {
            // adding a date after the start of the range
            range = { from, to: date };
        }
        else if (isAfter(date, to)) {
            // adding a date after the end of the range
            range = { from, to: date };
        }
        else {
            throw new Error("Invalid range");
        }
    }
    // check for min / max
    if (range?.from && range?.to) {
        const diff = dateLib$1.differenceInCalendarDays(range.to, range.from);
        if (max > 0 && diff > max) {
            range = { from: date, to: undefined };
        }
        else if (min > 1 && diff < min) {
            range = { from: date, to: undefined };
        }
    }
    return range;
}

function useRange$1(props, dateLib) {
    const { disabled, excludeDisabled, selected: initiallySelected, required, onSelect } = props;
    const [internallySelected, setSelected] = useControlledValue(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const isSelected = (date) => selected && rangeIncludesDate(selected, date, false, dateLib);
    const select = (triggerDate, modifiers, e) => {
        const { min, max } = props;
        const newRange = triggerDate
            ? addToRange(triggerDate, selected, min, max, required, dateLib)
            : undefined;
        if (newRange?.from && newRange.to) {
            let newDate = newRange.from;
            while (dateLib.differenceInCalendarDays(newRange.to, newDate) > 0) {
                newDate = dateLib.addDays(newDate, 1);
                if (excludeDisabled &&
                    disabled &&
                    dateMatchModifiers(newDate, disabled, dateLib)) {
                    // if a disabled days is found, the range is reset
                    newRange.from = triggerDate;
                    newRange.to = undefined;
                    break;
                }
            }
        }
        if (!onSelect) {
            setSelected(newRange);
        }
        onSelect?.(newRange, triggerDate, modifiers, e);
        return newRange;
    };
    return {
        selected,
        select,
        isSelected
    };
}

function useSingle(props, dateLib) {
    const { selected: initiallySelected, required, onSelect } = props;
    const [internallySelected, setSelected] = useControlledValue(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay } = dateLib;
    const isSelected = (compareDate) => {
        return selected ? isSameDay(selected, compareDate) : false;
    };
    const select = (triggerDate, modifiers, e) => {
        let newDate = triggerDate;
        if (!required && selected && selected && isSameDay(triggerDate, selected)) {
            // If the date is the same, clear the selection.
            newDate = undefined;
        }
        if (!onSelect) {
            setSelected(newDate);
        }
        if (required) {
            onSelect?.(newDate, triggerDate, modifiers, e);
        }
        else {
            onSelect?.(newDate, triggerDate, modifiers, e);
        }
        return newDate;
    };
    return {
        selected,
        select,
        isSelected
    };
}

function useSelection(props, dateLib) {
    const single = useSingle(props, dateLib);
    const multi = useMulti(props, dateLib);
    const range = useRange$1(props, dateLib);
    switch (props.mode) {
        case "single":
            return single;
        case "multiple":
            return multi;
        case "range":
            return range;
        default:
            return undefined;
    }
}

/**
 * Render the date picker calendar.
 *
 * @group DayPicker
 * @see https://daypicker.dev
 */
function DayPicker(props) {
    const { components, formatters, labels, dateLib, locale, classNames } = useMemo(() => ({
        dateLib: getDateLib(props.dateLib),
        components: getComponents(props.components),
        formatters: getFormatters(props.formatters),
        labels: { ...defaultLabels, ...props.labels },
        locale: { ...enUS, ...props.locale },
        classNames: { ...getDefaultClassNames(), ...props.classNames }
    }), [
        props.classNames,
        props.components,
        props.dateLib,
        props.formatters,
        props.labels,
        props.locale
    ]);
    const { captionLayout, firstWeekContainsDate, mode, onDayBlur, onDayClick, onDayFocus, onDayKeyDown, onDayMouseEnter, onDayMouseLeave, onNextClick, onPrevClick, showWeekNumber, styles, useAdditionalDayOfYearTokens, useAdditionalWeekYearTokens, weekStartsOn } = props;
    const formatOptions = {
        locale,
        weekStartsOn,
        firstWeekContainsDate,
        useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens
    };
    const labelOptions = formatOptions;
    const { formatCaption, formatDay, formatMonthDropdown, formatWeekNumber, formatWeekNumberHeader, formatWeekdayName, formatYearDropdown } = formatters;
    const calendar = useCalendar(props, dateLib);
    const { days, months, navStart, navEnd, previousMonth, nextMonth, goToMonth } = calendar;
    const getModifiers = useGetModifiers(days, props, dateLib);
    const { isSelected, select, selected: selectedValue } = useSelection(props, dateLib) ?? {};
    const { blur, focused, isFocusTarget, moveFocus, setFocused } = useFocus(props, calendar, getModifiers, isSelected ?? (() => false), dateLib);
    const { labelDayButton, labelGridcell, labelGrid, labelMonthDropdown, labelNav, labelWeekday, labelWeekNumber, labelWeekNumberHeader, labelYearDropdown } = labels;
    const weekdays = useMemo(() => getWeekdays(locale, props.weekStartsOn, props.ISOWeek, props.timeZone, dateLib), [dateLib, locale, props.ISOWeek, props.timeZone, props.weekStartsOn]);
    const isInteractive = mode !== undefined || onDayClick !== undefined;
    const handlePreviousClick = useCallback(() => {
        if (!previousMonth)
            return;
        goToMonth(previousMonth);
        onPrevClick?.(previousMonth);
    }, [previousMonth, goToMonth, onPrevClick]);
    const handleNextClick = useCallback(() => {
        if (!nextMonth)
            return;
        goToMonth(nextMonth);
        onNextClick?.(nextMonth);
    }, [goToMonth, nextMonth, onNextClick]);
    const handleDayClick = useCallback((day, m) => (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFocused(day);
        select?.(day.date, m, e);
        onDayClick?.(day.date, m, e);
    }, [select, onDayClick, setFocused]);
    const handleDayFocus = useCallback((day, m) => (e) => {
        setFocused(day);
        onDayFocus?.(day.date, m, e);
    }, [onDayFocus, setFocused]);
    const handleDayBlur = useCallback((day, m) => (e) => {
        blur();
        onDayBlur?.(day.date, m, e);
    }, [blur, onDayBlur]);
    const handleDayKeyDown = useCallback((day, modifiers) => (e) => {
        const keyMap = {
            ArrowLeft: ["day", props.dir === "rtl" ? "after" : "before"],
            ArrowRight: ["day", props.dir === "rtl" ? "before" : "after"],
            ArrowDown: ["week", "after"],
            ArrowUp: ["week", "before"],
            PageUp: [e.shiftKey ? "year" : "month", "before"],
            PageDown: [e.shiftKey ? "year" : "month", "after"],
            Home: ["startOfWeek", "before"],
            End: ["endOfWeek", "after"]
        };
        if (keyMap[e.key]) {
            e.preventDefault();
            e.stopPropagation();
            const [moveBy, moveDir] = keyMap[e.key];
            moveFocus(moveBy, moveDir);
        }
        onDayKeyDown?.(day.date, modifiers, e);
    }, [moveFocus, onDayKeyDown, props.dir]);
    const handleDayMouseEnter = useCallback((day, modifiers) => (e) => {
        onDayMouseEnter?.(day.date, modifiers, e);
    }, [onDayMouseEnter]);
    const handleDayMouseLeave = useCallback((day, modifiers) => (e) => {
        onDayMouseLeave?.(day.date, modifiers, e);
    }, [onDayMouseLeave]);
    const { className, style } = useMemo(() => ({
        className: [classNames[UI.Root], props.className]
            .filter(Boolean)
            .join(" "),
        style: { ...styles?.[UI.Root], ...props.style }
    }), [classNames, props.className, props.style, styles]);
    const dataAttributes = getDataAttributes(props);
    const contextValue = {
        selected: selectedValue,
        select: select,
        isSelected,
        months,
        nextMonth,
        previousMonth,
        goToMonth,
        getModifiers,
        components,
        classNames,
        styles,
        labels,
        formatters
    };
    return (React__default.createElement(dayPickerContext.Provider, { value: contextValue },
        React__default.createElement(components.Root, { className: className, style: style, dir: props.dir, id: props.id, lang: props.lang, nonce: props.nonce, title: props.title, ...dataAttributes },
            React__default.createElement(components.Months, { className: classNames[UI.Months], style: styles?.[UI.Months] },
                !props.hideNavigation && (React__default.createElement(components.Nav, { className: classNames[UI.Nav], style: styles?.[UI.Nav], "aria-label": labelNav(), onPreviousClick: handlePreviousClick, onNextClick: handleNextClick, previousMonth: previousMonth, nextMonth: nextMonth })),
                months.map((calendarMonth, displayIndex) => {
                    const handleMonthChange = (e) => {
                        const selectedMonth = Number(e.target.value);
                        const month = dateLib.setMonth(dateLib.startOfMonth(calendarMonth.date), selectedMonth);
                        goToMonth(month);
                    };
                    const handleYearChange = (e) => {
                        const month = dateLib.setYear(dateLib.startOfMonth(calendarMonth.date), Number(e.target.value));
                        goToMonth(month);
                    };
                    const dropdownMonths = getMonthOptions(calendarMonth.date, navStart, navEnd, formatters, locale, dateLib);
                    const dropdownYears = getYearOptions(months[0].date, navStart, navEnd, formatters, dateLib);
                    return (React__default.createElement(components.Month, { className: classNames[UI.Month], style: styles?.[UI.Month], key: displayIndex, displayIndex: displayIndex, calendarMonth: calendarMonth },
                        React__default.createElement(components.MonthCaption, { className: classNames[UI.MonthCaption], style: styles?.[UI.MonthCaption], calendarMonth: calendarMonth, displayIndex: displayIndex }, captionLayout?.startsWith("dropdown") ? (React__default.createElement(components.DropdownNav, { className: classNames[UI.Dropdowns], style: styles?.[UI.Dropdowns] },
                            captionLayout === "dropdown" ||
                                captionLayout === "dropdown-months" ? (React__default.createElement(components.MonthsDropdown, { className: classNames[UI.MonthsDropdown], "aria-label": labelMonthDropdown(), classNames: classNames, components: components, disabled: Boolean(props.disableNavigation), onChange: handleMonthChange, options: dropdownMonths, style: styles?.[UI.Dropdown], value: calendarMonth.date.getMonth() })) : (React__default.createElement("span", { role: "status", "aria-live": "polite" }, formatMonthDropdown(calendarMonth.date.getMonth(), locale))),
                            captionLayout === "dropdown" ||
                                captionLayout === "dropdown-years" ? (React__default.createElement(components.YearsDropdown, { className: classNames[UI.YearsDropdown], "aria-label": labelYearDropdown(labelOptions), classNames: classNames, components: components, disabled: Boolean(props.disableNavigation), onChange: handleYearChange, options: dropdownYears, style: styles?.[UI.Dropdown], value: calendarMonth.date.getFullYear() })) : (React__default.createElement("span", { role: "status", "aria-live": "polite" }, formatYearDropdown(calendarMonth.date.getFullYear()))))) : (React__default.createElement(components.CaptionLabel, { className: classNames[UI.CaptionLabel], role: "status", "aria-live": "polite" }, formatCaption(calendarMonth.date, formatOptions, dateLib)))),
                        React__default.createElement(components.MonthGrid, { role: "grid", "aria-multiselectable": mode === "multiple" || mode === "range", "aria-label": labelGrid(calendarMonth.date, labelOptions, dateLib) ||
                                undefined, className: classNames[UI.MonthGrid], style: styles?.[UI.MonthGrid] },
                            !props.hideWeekdays && (React__default.createElement(components.Weekdays, { className: classNames[UI.Weekdays], style: styles?.[UI.Weekdays] },
                                showWeekNumber && (React__default.createElement(components.WeekNumberHeader, { "aria-label": labelWeekNumberHeader(labelOptions), className: classNames[UI.WeekNumberHeader], style: styles?.[UI.WeekNumberHeader], scope: "col" }, formatWeekNumberHeader())),
                                weekdays.map((weekday, i) => (React__default.createElement(components.Weekday, { "aria-label": labelWeekday(weekday, labelOptions, dateLib), className: classNames[UI.Weekday], key: i, style: styles?.[UI.Weekday], scope: "col" }, formatWeekdayName(weekday, formatOptions, dateLib)))))),
                            React__default.createElement(components.Weeks, { className: classNames[UI.Weeks], style: styles?.[UI.Weeks] }, calendarMonth.weeks.map((week, weekIndex) => {
                                return (React__default.createElement(components.Week, { className: classNames[UI.Week], key: week.weekNumber, style: styles?.[UI.Week], week: week },
                                    showWeekNumber && (React__default.createElement(components.WeekNumber, { week: week, style: styles?.[UI.WeekNumber], "aria-label": labelWeekNumber(week.weekNumber, {
                                            locale
                                        }), className: classNames[UI.WeekNumber], scope: "row" }, formatWeekNumber(week.weekNumber))),
                                    week.days.map((day) => {
                                        const { date } = day;
                                        const modifiers = getModifiers(day);
                                        modifiers[DayFlag.focused] =
                                            !modifiers.hidden &&
                                                Boolean(focused?.isEqualTo(day));
                                        modifiers[SelectionState.selected] =
                                            !modifiers.disabled &&
                                                (isSelected?.(date) || modifiers.selected);
                                        if (isDateRange(selectedValue)) {
                                            // add range modifiers
                                            const { from, to } = selectedValue;
                                            modifiers[SelectionState.range_start] = Boolean(from && to && dateLib.isSameDay(date, from));
                                            modifiers[SelectionState.range_end] = Boolean(from && to && dateLib.isSameDay(date, to));
                                            modifiers[SelectionState.range_middle] =
                                                rangeIncludesDate(selectedValue, date, true, dateLib);
                                        }
                                        const style = getStyleForModifiers(modifiers, styles, props.modifiersStyles);
                                        const className = getClassNamesForModifiers(modifiers, classNames, props.modifiersClassNames);
                                        const ariaLabel = !isInteractive
                                            ? labelGridcell(date, modifiers, labelOptions, dateLib)
                                            : undefined;
                                        return (React__default.createElement(components.Day, { key: `${dateLib.format(date, "yyyy-MM-dd")}_${dateLib.format(day.displayMonth, "yyyy-MM")}`, day: day, modifiers: modifiers, className: className.join(" "), style: style, "aria-hidden": modifiers.hidden || undefined, "aria-selected": modifiers.selected || undefined, "aria-label": ariaLabel, "data-day": dateLib.format(date, "yyyy-MM-dd"), "data-month": day.outside
                                                ? dateLib.format(date, "yyyy-MM")
                                                : undefined, "data-selected": modifiers.selected || undefined, "data-disabled": modifiers.disabled || undefined, "data-hidden": modifiers.hidden || undefined, "data-outside": day.outside || undefined, "data-focused": modifiers.focused || undefined, "data-today": modifiers.today || undefined }, isInteractive ? (React__default.createElement(components.DayButton, { className: classNames[UI.DayButton], style: styles?.[UI.DayButton], type: "button", day: day, modifiers: modifiers, disabled: modifiers.disabled || undefined, tabIndex: isFocusTarget(day) ? 0 : -1, "aria-label": labelDayButton(date, modifiers, labelOptions, dateLib), onClick: handleDayClick(day, modifiers), onBlur: handleDayBlur(day, modifiers), onFocus: handleDayFocus(day, modifiers), onKeyDown: handleDayKeyDown(day, modifiers), onMouseEnter: handleDayMouseEnter(day, modifiers), onMouseLeave: handleDayMouseLeave(day, modifiers) }, formatDay(date, formatOptions, dateLib))) : (formatDay(day.date, formatOptions, dateLib))));
                                    })));
                            })))));
                })),
            props.footer && (React__default.createElement(components.Footer, { className: classNames[UI.Footer], style: styles?.[UI.Footer], role: "status", "aria-live": "polite" }, props.footer)))));
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$3 = "/* Variables declaration */\n/* prettier-ignore */\n.rdp-root {\n  --rdp-accent-color: blue; /* The accent color used for selected days and UI elements. */\n  --rdp-accent-background-color: #f0f0ff; /* The accent background color used for selected days and UI elements. */\n  --rdp-font-family: system-ui; /* The font family used by the calendar. Note that `inherit`does not work here. */\n\n  --rdp-day-font: inherit; /* The font used for the day cells. */\n  --rdp-day-height: 2.75rem; /* The height of the day cells. */\n  --rdp-day-width: 2.75rem; /* The width of the day cells. */\n  \n  --rdp-day_button-border-radius: 100%; /* The border radius of the day cells. */\n  --rdp-day_button-border: 2px solid transparent; /* The border of the day cells. */\n  --rdp-day_button-height: var(--rdp-day-width); /* The height of the day cells. */\n  --rdp-day_button-width: var(--rdp-day-height); /* The width of the day cells. */\n  \n  --rdp-selected-border: 2px solid var(--rdp-accent-color); /* The border of the selected days. */\n  --rdp-selected-font: bold large var(--rdp-font-family); /* The font of the selected days. */\n  --rdp-disabled-opacity: 0.5; /* The opacity of the disabled days. */\n  --rdp-outside-opacity: 0.75; /* The opacity of the days outside the current month. */\n  --rdp-today-color: var(--rdp-accent-color); /* The color of the today's date. */\n  \n  --rdp-dropdown-gap: 0.5rem;/* The gap between the dropdowns used in the month captons. */\n  \n  --rdp-month_caption-font: bold larger var(--rdp-font-family); /* The font of the month caption. */\n  --rdp-months-gap: 2rem; /* The gap between the months in the multi-month view. */\n  \n  --rdp-nav_button-disabled-opacity: 0.5; /* The opacity of the disabled navigation buttons. */\n  --rdp-nav_button-height: 2.25rem; /* The height of the navigation buttons. */\n  --rdp-nav_button-width: 2.25rem; /* The width of the navigation buttons. */\n  --rdp-nav-height: 2.75rem; /* The height of the navigation bar. */\n  \n  --rdp-range_middle-background-color: var(--rdp-accent-background-color); /* The color of the background for days in the middle of a range. */\n  --rdp-range_middle-font: normal medium var(--rdp-font-family); /* The font for days in the middle of a range. */\n  --rdp-range_middle-foreground-color: white; /* The font for days in the middle of a range. */\n  --rdp-range_middle-color: inherit;/* The color of the range text. */\n  \n  --rdp-range_start-color: white; /* The color of the range text. */\n  --rdp-range_start-background: linear-gradient(var(--rdp-gradient-direction), transparent 50%, var(--rdp-range_middle-background-color) 50%); /* Used for the background of the start of the selected range. */\n  --rdp-range_start-date-background-color: var(--rdp-accent-color); /* The background color of the date when at the start of the selected range. */\n  \n  --rdp-range_end-background: linear-gradient(var(--rdp-gradient-direction), var(--rdp-range_middle-background-color) 50%, transparent 50%); /* Used for the background of the end of the selected range. */\n  --rdp-range_end-color: white;/* The color of the range text. */\n  --rdp-range_end-date-background-color: var(--rdp-accent-color); /* The background color of the date when at the end of the selected range. */\n  \n  --rdp-week_number-border-radius: 100%; /* The border radius of the week number. */\n  --rdp-week_number-border: 2px solid transparent; /* The border of the week number. */\n  --rdp-week_number-font: 400 small var(--rdp-font-family); /* The font of the week number cells. */\n  --rdp-week_number-height: var(--rdp-day-height); /* The height of the week number cells. */\n  --rdp-week_number-opacity: 0.75; /* The opacity of the week number. */\n  --rdp-week_number-width: var(--rdp-day-width); /* The width of the week number cells. */\n  --rdp-weeknumber-text-align: center; /* The text alignment of the weekday cells. */\n\n  --rdp-weekday-font: 500 smaller var(--rdp-font-family); /* The font of the weekday. */\n  --rdp-weekday-opacity: 0.75; /* The opacity of the weekday. */\n  --rdp-weekday-padding: 0.5rem 0rem; /* The padding of the weekday. */\n  --rdp-weekday-text-align: center; /* The text alignment of the weekday cells. */\n\n  --rdp-gradient-direction: 90deg;\n}\n\n.rdp-root[dir=\"rtl\"] {\n  --rdp-gradient-direction: -90deg;\n}\n\n/* Root of the component. */\n.rdp-root {\n  position: relative; /* Required to position the navigation toolbar. */\n  box-sizing: border-box;\n}\n\n.rdp-root * {\n  box-sizing: border-box;\n}\n\n.rdp-day {\n  width: var(--rdp-day-width);\n  height: var(--rdp-day-height);\n  font: var(--rdp-day-font);\n  text-align: center;\n}\n\n.rdp-day_button {\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n\n  width: var(--rdp-day_button-width);\n  height: var(--rdp-day_button-height);\n  border: var(--rdp-day_button-border);\n  border-radius: var(--rdp-day_button-border-radius);\n}\n\n.rdp-day_button:disabled {\n  cursor: revert;\n}\n\n.rdp-caption_label {\n  z-index: 1;\n\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n\n  white-space: nowrap;\n  border: 0;\n}\n\n.rdp-button_next,\n.rdp-button_previous {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  appearance: none;\n\n  width: var(--rdp-nav_button-width);\n  height: var(--rdp-nav_button-height);\n}\n\n.rdp-button_next:disabled,\n.rdp-button_previous:disabled {\n  cursor: revert;\n\n  opacity: var(--rdp-nav_button-disabled-opacity);\n}\n\n.rdp-chevron {\n  display: inline-block;\n  fill: var(--rdp-accent-color);\n}\n\n.rdp-root[dir=\"rtl\"] .rdp-nav .rdp-chevron {\n  transform: rotate(180deg);\n}\n\n.rdp-root[dir=\"rtl\"] .rdp-nav .rdp-chevron {\n  transform: rotate(180deg);\n  transform-origin: 50%;\n}\n\n.rdp-dropdowns {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--rdp-dropdown-gap);\n}\n.rdp-dropdown {\n  z-index: 2;\n\n  /* Reset */\n  opacity: 0;\n  appearance: none;\n  position: absolute;\n  inset-block-start: 0;\n  inset-block-end: 0;\n  inset-inline-start: 0;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  cursor: inherit;\n  border: none;\n  line-height: inherit;\n}\n\n.rdp-dropdown_root {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.rdp-dropdown_root[data-disabled=\"true\"] .rdp-chevron {\n  opacity: var(--rdp-disabled-opacity);\n}\n\n.rdp-month_caption {\n  display: flex;\n  align-content: center;\n  height: var(--rdp-nav-height);\n  font: var(--rdp-month_caption-font);\n}\n\n.rdp-months {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--rdp-months-gap);\n  max-width: fit-content;\n}\n\n.rdp-month_grid {\n  border-collapse: collapse;\n}\n\n.rdp-nav {\n  position: absolute;\n  inset-block-start: 0;\n  inset-inline-end: 0;\n\n  display: flex;\n  align-items: center;\n\n  height: var(--rdp-nav-height);\n}\n\n.rdp-weekday {\n  opacity: var(--rdp-weekday-opacity);\n  padding: var(--rdp-weekday-padding);\n  font: var(--rdp-weekday-font);\n  text-align: var(--rdp-weekday-text-align);\n  text-transform: var(--rdp-weekday-text-transform);\n}\n\n.rdp-week_number {\n  opacity: var(--rdp-week_number-opacity);\n  font: var(--rdp-week_number-font);\n  height: var(--rdp-week_number-height);\n  width: var(--rdp-week_number-width);\n  border: var(--rdp-week_number-border);\n  border-radius: var(--rdp-week_number-border-radius);\n  text-align: var(--rdp-weeknumber-text-align);\n}\n\n/* DAY MODIFIERS */\n.rdp-today:not(.rdp-outside) {\n  color: var(--rdp-today-color);\n}\n\n.rdp-selected {\n  font: var(--rdp-selected-font);\n}\n\n.rdp-selected .rdp-day_button {\n  border: var(--rdp-selected-border);\n}\n\n.rdp-outside {\n  opacity: var(--rdp-outside-opacity);\n}\n\n.rdp-disabled {\n  opacity: var(--rdp-disabled-opacity);\n}\n\n.rdp-hidden {\n  visibility: hidden;\n  color: var(--rdp-range_start-color);\n}\n\n.rdp-range_start {\n  background: var(--rdp-range_start-background);\n}\n\n.rdp-range_start .rdp-day_button {\n  background-color: var(--rdp-range_start-date-background-color);\n  color: var(--rdp-range_start-color);\n}\n\n.rdp-range_middle {\n  background-color: var(--rdp-range_middle-background-color);\n  font: var(--rdp-range_middle-font);\n}\n\n.rdp-range_middle .rdp-day_button {\n  border-color: transparent;\n  border: unset;\n  border-radius: unset;\n  color: var(--rdp-range_middle-color);\n}\n\n.rdp-range_end {\n  background: var(--rdp-range_end-background);\n  color: var(--rdp-range_end-color);\n}\n\n.rdp-range_end .rdp-day_button {\n  color: var(--rdp-range_start-color);\n  background-color: var(--rdp-range_end-date-background-color);\n}\n\n.rdp-range_start.rdp-range_end {\n  background: revert;\n}\n\n.rdp-focusable {\n  cursor: pointer;\n}\n";
styleInject(css_248z$3);

var _path$C;
function _extends$F() { return _extends$F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$F.apply(null, arguments); }
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends$F({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0,
  "aria-hidden": "true",
  viewBox: "0 0 512 512"
}, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M294.1 256 167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9z"
})));

var _path$B;
function _extends$E() { return _extends$E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$E.apply(null, arguments); }
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends$E({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  "aria-hidden": "true"
}, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
})));

var _path$A;
function _extends$D() { return _extends$D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$D.apply(null, arguments); }
const SvgBerater = props => /*#__PURE__*/React.createElement("svg", _extends$D({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 23.59 27.46"
}, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
  d: "M16.23 13.27a8.86 8.86 0 0 0 1.82-5.5 8.86 8.86 0 0 0-1.82-5.5A5.7 5.7 0 0 0 11.82 0c-3 0-5.54 2.66-6.12 6.2a10.3 10.3 0 0 0 0 3.14c.58 3.54 3.1 6.21 6.12 6.21a5 5 0 0 0 2-.45 5.5 5.5 0 0 0 1.11-.62 6.8 6.8 0 0 0 1.31-1.21m5.11 4.56a18.2 18.2 0 0 1-5.36-2.45l-2.23 7-.31.95-1-2.81c2.31-3.22-.21-3.35-.61-3.35h-.09c-.39 0-2.92.13-.61 3.35l-1 2.81-.3-.95-.35-1.11-1.87-5.89a18.3 18.3 0 0 1-5.36 2.45c-2.21.56-2.32 3.11-2.23 4.36 0 0 .13 1.71.26 2.46a22.54 22.54 0 0 0 11.52 2.8 22.6 22.6 0 0 0 11.51-2.8c.12-.75.25-2.46.25-2.46.08-1.25 0-3.8-2.23-4.36"
})));

var _path$z;
function _extends$C() { return _extends$C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$C.apply(null, arguments); }
const SvgBike = props => /*#__PURE__*/React.createElement("svg", _extends$C({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 640 512"
}, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996M186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48m162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a80 80 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885"
})));

var _path$y;
function _extends$B() { return _extends$B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$B.apply(null, arguments); }
const SvgBook = props => /*#__PURE__*/React.createElement("svg", _extends$B({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 448 512"
}, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6M128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64"
})));

var _path$x;
function _extends$A() { return _extends$A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$A.apply(null, arguments); }
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends$A({
  "aria-hidden": "true",
  viewBox: "0 0 14 16"
}, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 2h-1v1.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5V2H6v1.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5V2H2c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m0 12H2V5h11zM5 3H4V1h1zm6 0h-1V1h1zM6 7H5V6h1zm2 0H7V6h1zm2 0H9V6h1zm2 0h-1V6h1zM4 9H3V8h1zm2 0H5V8h1zm2 0H7V8h1zm2 0H9V8h1zm2 0h-1V8h1zm-8 2H3v-1h1zm2 0H5v-1h1zm2 0H7v-1h1zm2 0H9v-1h1zm2 0h-1v-1h1zm-8 2H3v-1h1zm2 0H5v-1h1zm2 0H7v-1h1zm2 0H9v-1h1z"
})));

var _style, _path$w, _path2$5;
function _extends$z() { return _extends$z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$z.apply(null, arguments); }
const SvgCookie = props => /*#__PURE__*/React.createElement("svg", _extends$z({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  "aria-hidden": "true",
  viewBox: "0 0 400 400"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cookie_svg__st0{fill:#484a4f}")), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
  d: "M378.85 160.74c-1.17-5.32-5.62-9.29-11.03-9.83-5.29-.53-10.57 2.45-12.77 7.44-3.39 7.7-10.99 12.67-19.37 12.67-9.9 0-18.38-6.74-20.61-16.39a12.6 12.6 0 0 0-5.98-8.07 12.57 12.57 0 0 0-9.99-1.11c-3.88 1.2-7.92 1.81-12.01 1.81-22.6 0-41-18.39-41-41 0-3.19.42-6.49 1.25-9.82 1.3-5.24-.88-10.72-5.42-13.63-9.24-5.92-14.75-15.95-14.75-26.85 0-6.42 1.91-12.62 5.52-17.92 2.46-3.61 2.87-8.24 1.08-12.23a12.58 12.58 0 0 0-9.85-7.33c-8.17-1.07-16.22-1.61-23.93-1.61C99.04 16.88 16.89 99.03 16.89 200s82.15 183.12 183.12 183.12c100.96 0 183.11-82.15 183.11-183.12-.01-13.15-1.44-26.35-4.27-39.26M200.01 357.96c-87.1 0-157.96-70.86-157.96-157.96S112.9 42.04 200.01 42.04c1.24 0 2.48.01 3.73.05-1.13 4.5-1.71 9.16-1.71 13.88 0 16.58 7.11 32.04 19.38 42.8-.3 2.52-.45 5.03-.45 7.51 0 36.48 29.68 66.16 66.15 66.16 2.63 0 5.25-.16 7.85-.47 7.91 14.7 23.32 24.23 40.74 24.23 7.84 0 15.36-1.99 21.99-5.57.19 3.13.28 6.25.28 9.38-.01 87.09-70.87 157.95-157.96 157.95",
  className: "cookie_svg__st0"
})), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
  d: "M154.89 82.97c-12.69 0-23 10.29-23 22.99 0 12.71 10.3 23 23 23s23-10.29 23-23c0-12.69-10.31-22.99-23-22.99m-45.99 96.9c-11.11 0-20.12 9.01-20.12 20.13s9 20.12 20.12 20.12c11.11 0 20.12-9 20.12-20.12s-9.01-20.13-20.12-20.13m114.09 84.48c-12.7 0-23 10.29-23 22.99 0 12.71 10.3 23 23 23s23-10.29 23-23c0-12.69-10.3-22.99-23-22.99m-11.1-44.23c6.35 0 11.5-5.15 11.5-11.5s-5.15-11.5-11.5-11.5-11.5 5.15-11.5 11.5 5.16 11.5 11.5 11.5m-65.62 49.98c-4.77 0-8.62 3.86-8.62 8.63 0 4.76 3.85 8.62 8.62 8.62s8.62-3.86 8.62-8.62c-.01-4.77-3.86-8.63-8.62-8.63m158.8-23c-4.77 0-8.62 3.86-8.62 8.63 0 4.76 3.85 8.62 8.62 8.62s8.62-3.86 8.62-8.62c0-4.77-3.85-8.63-8.62-8.63",
  className: "cookie_svg__st0"
})));

var _path$v;
function _extends$y() { return _extends$y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$y.apply(null, arguments); }
const SvgCar = props => /*#__PURE__*/React.createElement("svg", _extends$y({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  "data-prefix": "fas",
  viewBox: "0 0 640 512"
}, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M544 192h-16L419.22 56.02A64.03 64.03 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96M160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48m72-240H116.93l38.4-96H232zm48 0V96h89.24l76.8 96zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48"
})));

var _path$u;
function _extends$x() { return _extends$x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$x.apply(null, arguments); }
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends$x({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48"
}, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
  d: "M20.41 29v-1.71a8.3 8.3 0 0 1 .53-3.12 5.4 5.4 0 0 1 1.36-2.06 18 18 0 0 1 1.63-1.32 20 20 0 0 0 1.8-1.36 3.3 3.3 0 0 0 .87-1.17 3.6 3.6 0 0 0 .3-1.46 3.14 3.14 0 0 0-.54-1.88 2.86 2.86 0 0 0-1.51-1 6.9 6.9 0 0 0-2.07-.3 10 10 0 0 0-3.49.56 19 19 0 0 0-3.16 1.56v-4.4A19.5 19.5 0 0 1 19.89 10a16 16 0 0 1 3.51-.37 10.76 10.76 0 0 1 5 1.05 5.72 5.72 0 0 1 2.75 2.65 7.7 7.7 0 0 1 .72 3.19 7 7 0 0 1-.79 3.48 6.8 6.8 0 0 1-1.71 2.16q-.91.72-1.47 1.11a7.44 7.44 0 0 0-2.41 2.49 5.35 5.35 0 0 0-.44 2.16V29zm2.29 9.37a3.5 3.5 0 0 1-1.31-.24 3.2 3.2 0 0 1-1.05-.64 3 3 0 0 1-.68-1 2.7 2.7 0 0 1-.25-1.17 3 3 0 0 1 .5-1.66 2.8 2.8 0 0 1 1.27-1.06 3.7 3.7 0 0 1 1.46-.33 3.5 3.5 0 0 1 1.83.49A2.84 2.84 0 0 1 25.59 34a3 3 0 0 1 .34 1.33 2.9 2.9 0 0 1-.54 1.67 2.85 2.85 0 0 1-1.26 1 3.9 3.9 0 0 1-1.43.34z"
})));

var _path$t;
function _extends$w() { return _extends$w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$w.apply(null, arguments); }
const SvgInfoIconI = props => /*#__PURE__*/React.createElement("svg", _extends$w({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48"
}, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
  d: "M22.89 38.74v-17c-.92-.16-1.79-.27-2.6-.33v-3h7.34v20.33Zm1.9-24a3.1 3.1 0 0 1-1.67-.47 2.57 2.57 0 0 1-1-1.08 2.8 2.8 0 0 1-.3-1.19 2.64 2.64 0 0 1 .47-1.51 2.57 2.57 0 0 1 1.15-1 3.5 3.5 0 0 1 1.31-.29 3.1 3.1 0 0 1 1.62.45 2.46 2.46 0 0 1 1 1.09 2.84 2.84 0 0 1 .3 1.22 2.48 2.48 0 0 1-.51 1.51 2.7 2.7 0 0 1-1.17.94 3.2 3.2 0 0 1-1.2.33"
})));

var _path$s;
function _extends$v() { return _extends$v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$v.apply(null, arguments); }
const SvgPartner = props => /*#__PURE__*/React.createElement("svg", _extends$v({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 27.35 24.31"
}, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
  d: "M10.36 20.14a.53.53 0 0 0-.48-.31.53.53 0 0 0-.48.29l-.36.73a.76.76 0 0 1-1.4-.1l-.8-2.39-.51 1.51a2 2 0 0 1-1.94 1.4H3.8a.76.76 0 0 1 0-1.52h.59a.52.52 0 0 0 .5-.36l.87-2.6a1.14 1.14 0 0 1 2.16 0l.66 2a2.13 2.13 0 0 1 3.13.67.53.53 0 0 0 .45.3v-3.9l6.07-6V7.6h-6.45a1.15 1.15 0 0 1-1.14-1.14V-.02h-9.5A1.14 1.14 0 0 0 0 1.14v22a1.14 1.14 0 0 0 1.14 1.14h16a1.13 1.13 0 0 0 1.14-1.14v-1.9h-6.12a2 2 0 0 1-1.8-1.1m7.87-14.35a1.18 1.18 0 0 0-.33-.81L13.25.33a1.14 1.14 0 0 0-.81-.35h-.28v6.1h6.07Zm-4.56 10.68v3.28h3.28l7.68-7.77L21.4 8.8ZM27 7.98l-1.5-1.55a1.21 1.21 0 0 0-1.71 0l-1.29 1.3 3.2 3.25 1.3-1.3a1.21 1.21 0 0 0 0-1.71Z",
  className: "partner_svg__cls-1"
})));

var _path$r, _path2$4, _path3$3, _path4, _path5, _path6;
function _extends$u() { return _extends$u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$u.apply(null, arguments); }
const SvgPdf = props => /*#__PURE__*/React.createElement("svg", _extends$u({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "34.4 10.88 72.73 96.73"
}, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
  fill: "#313335",
  d: "M90.249 107.596H40.916a6.51 6.51 0 0 1-6.5-6.5V30.861c0-3.584 2.916-6.5 6.5-6.5h28.726c3.152 0 7.367 1.746 9.596 3.975l13.537 13.537c2.229 2.229 3.975 6.444 3.975 9.596v49.627a6.51 6.51 0 0 1-6.501 6.5M40.916 27.361c-1.93 0-3.5 1.57-3.5 3.5v70.235c0 1.93 1.57 3.5 3.5 3.5h49.333c1.93 0 3.5-1.57 3.5-3.5V51.469c0-2.333-1.446-5.826-3.096-7.475L77.116 30.457c-1.649-1.649-5.142-3.096-7.475-3.096z"
})), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
  fill: "#313335",
  d: "M90.249 47.969H79.642a6.51 6.51 0 0 1-6.5-6.5V30.861c0-3.013 1.617-4.082 3.003-4.082 1.02 0 2.06.524 3.093 1.557l13.537 13.537c1.886 1.886 1.657 3.398 1.354 4.132-.306.733-1.213 1.964-3.88 1.964M76.284 29.827c-.062.16-.143.476-.143 1.034v10.608c0 1.93 1.57 3.5 3.5 3.5h10.607c.558 0 .874-.081 1.034-.143-.069-.157-.235-.438-.63-.832L77.116 30.457c-.394-.394-.675-.561-.832-.63"
})), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ee3e36",
  d: "M95.249 36.905c-.43 0-.839-.184-1.123-.506l-10.367-11.72a1.499 1.499 0 1 1 1.123-2.494h3.714v-9.78a1.5 1.5 0 0 1 1.5-1.5H100.4a1.5 1.5 0 0 1 1.5 1.5v9.78h3.717a1.499 1.499 0 0 1 1.123 2.494l-10.367 11.72a1.5 1.5 0 0 1-1.124.506m-7.038-11.719 7.038 7.956 7.038-7.956h-1.888a1.5 1.5 0 0 1-1.5-1.5v-9.78h-7.304v9.78a1.5 1.5 0 0 1-1.5 1.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#313335",
  d: "M53.815 92.034H51.24v3.929q0 .843-.397 1.278-.398.436-1.003.436-.635 0-1.022-.431-.389-.431-.389-1.264V85.284q0-.928.426-1.326.426-.397 1.354-.397h3.606q1.6 0 2.462.246.851.237 1.472.786t.942 1.344q.322.795.322 1.79 0 2.12-1.307 3.214-1.305 1.093-3.891 1.093m-.681-6.362H51.24v4.241h1.894q.995 0 1.662-.208t1.018-.682q.35-.473.35-1.24 0-.918-.539-1.496-.607-.615-2.491-.615m9.97-2.111h3.664q1.43 0 2.452.265c1.022.265 1.3.508 1.855.994q2.168 1.856 2.168 5.642 0 1.25-.218 2.282a6.7 6.7 0 0 1-.673 1.86 5.8 5.8 0 0 1-1.164 1.481 4.8 4.8 0 0 1-1.222.805 5.5 5.5 0 0 1-1.425.426q-.761.123-1.718.123H63.16q-.767 0-1.155-.232c-.388-.232-.428-.373-.506-.653q-.118-.421-.118-1.093V85.284q0-.91.406-1.316t1.317-.407m1.088 2.224v9.42h2.13q.7 0 1.099-.038.397-.037.823-.189c.426-.152.53-.243.738-.426q1.41-1.193 1.411-4.108 0-2.055-.62-3.077-.621-1.022-1.529-1.302-.908-.279-2.196-.279h-1.856zm19.815-.056h-5.538v3.55h4.63q.643 0 .961.289.317.29.317.771 0 .483-.322.767c-.322.284-.533.284-.956.284h-4.63v4.573q0 .872-.393 1.292c-.393.42-.599.421-1.009.421q-.624 0-1.018-.426-.393-.426-.393-1.288V85.284q0-.606.18-.99.18-.382.563-.558.384-.175.979-.175h6.627q.672 0 .999.298t.327.781q0 .492-.327.791c-.327.299-.549.298-.997.298"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ee3e36",
  d: "M46.426 78.998c-1.465 0-2.644-.746-3.152-1.996-.847-2.078.374-4.936 3.35-7.842 2.33-2.276 5.584-4.149 9.677-5.573 2.177-4.04 4.18-8.366 5.585-12.064-3.111-4.839-3.685-10.813-2.597-14.151.704-2.159 1.923-2.971 2.82-3.272 1.252-.421 2.53-.106 3.421.852 1.343 1.444 1.835 4.352 1.506 8.89-.131 1.809-.732 4.238-1.79 7.231l.14.172c.706.863 1.459 1.812 2.248 2.807 1.684 2.123 3.576 4.508 5.5 6.646a52 52 0 0 1 1.646-.026c6.798 0 11.363 1.422 12.854 4.004.636 1.101.649 2.34.037 3.4-.826 1.431-2.613 2.285-4.781 2.285h-.001a9 9 0 0 1-1.613-.152c-2.732-.504-5.731-2.56-9.404-6.455-.939.051-1.922.125-2.93.223-2.165.208-6.343.753-10.573 2.086-1.82 3.287-5.737 9.926-8.658 11.835-1.105.72-2.239 1.1-3.285 1.1m7.462-11.184c-2.095 1.012-3.824 2.18-5.169 3.493-2.643 2.582-2.815 4.2-2.667 4.563.043.105.228.127.374.127.448 0 1.047-.223 1.642-.611 1.306-.853 3.462-3.684 5.82-7.572m22.165-4.123c2.264 2.099 4.164 3.272 5.766 3.568.366.067.726.102 1.068.102h.001c1.188 0 1.965-.407 2.184-.785.04-.071.097-.167-.038-.4-.504-.871-2.96-2.306-8.981-2.485m-12.044-9.375a110 110 0 0 1-3.708 8.093 59 59 0 0 1 8.352-1.418q.351-.033.698-.064c-1.431-1.686-2.807-3.42-4.068-5.01q-.655-.827-1.274-1.601m-.8-17.4a.5.5 0 0 0-.146.029c-.338.113-.683.621-.923 1.359-.72 2.208-.434 5.923 1.065 9.346.477-1.622.762-2.985.837-4.023.366-5.049-.451-6.352-.711-6.63-.073-.081-.1-.081-.122-.081"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M.5.5h128v128H.5z"
})));

var _path$q;
function _extends$t() { return _extends$t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$t.apply(null, arguments); }
const SvgPrint = props => /*#__PURE__*/React.createElement("svg", _extends$t({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 512 512"
}, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64m-64 256H128v-96h256zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24"
})));

var _path$p;
function _extends$s() { return _extends$s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$s.apply(null, arguments); }
const SvgSave = props => /*#__PURE__*/React.createElement("svg", _extends$s({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 24,
  "aria-hidden": "true"
}, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.414 13H16v3a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-3h3v1h2.586l1.707 1.707a1 1 0 0 0 1.414 0zH14v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3h1v-2H0V4h5a4 4 0 0 1 4 4v4.586l2.293-2.293a1 1 0 0 1 1.414 1.414zM7 12.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L5.586 14H3v-3H0V6h5a2 2 0 0 1 2 2z"
})));

var _path$o, _path2$3, _path3$2;
function _extends$r() { return _extends$r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$r.apply(null, arguments); }
const SvgSepaLogo = props => /*#__PURE__*/React.createElement("svg", _extends$r({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "-2.408 -2.408 196.951 85.082"
}, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
  fill: "#10298e",
  d: "M.225 78.256v-6.84h5.071v1.157h-3.69v1.516H5.04v1.153H1.606v1.861h3.821v1.153zm6.43-6.84h1.312v1.212H6.656zm0 1.885h1.312v4.955H6.656zm7.229 4.955h-1.311v-2.53q0-.801-.084-1.038-.083-.234-.273-.365c-.19-.131-.277-.131-.455-.131q-.34 0-.61.187a.94.94 0 0 0-.372.494q-.101.308-.1 1.138v2.245H9.368V73.3h1.217v.727q.65-.839 1.634-.839.433 0 .792.157.359.155.544.398t.256.55q.074.308.073.883zm2.703-6.84v2.515q.634-.743 1.516-.743.452 0 .816.17.364.166.549.428.183.261.251.579c.068.318.068.54.068.985v2.906h-1.31v-2.618q0-.779-.075-.99-.075-.208-.264-.332c-.189-.124-.284-.124-.474-.124q-.326 0-.582.158a.92.92 0 0 0-.377.478q-.117.322-.118.945v2.483h-1.312v-6.84zm7.466 5.263 1.306.22q-.252.717-.795 1.093-.543.375-1.36.375-1.293.001-1.914-.845-.49-.675-.49-1.706 0-1.232.645-1.93.645-.697 1.628-.697 1.106 0 1.745.73.64.73.611 2.237h-3.285q.014.583.318.908c.304.325.455.323.756.323q.308 0 .517-.167c.209-.167.247-.293.318-.541m.075-1.325q-.015-.57-.294-.865a.9.9 0 0 0-.681-.297.91.91 0 0 0-.71.313q-.28.311-.275.849zm2.436-3.938h1.312v1.212h-1.312zm0 1.885h1.312v4.955h-1.312zm4.994-.001v1.046h-.896v1.997q0 .606.026.706l.116.167.223.065q.181 0 .526-.127l.113 1.018a2.6 2.6 0 0 1-1.037.195 1.6 1.6 0 0 1-.638-.119q-.285-.118-.418-.307c-.133-.189-.15-.297-.185-.512q-.04-.227-.041-.923v-2.16h-.603V73.3h.603v-.985l1.315-.765v1.75zm.976-1.884h1.312v6.84h-1.312zm2.723 0h1.311v1.212h-1.311zm0 1.885h1.311v4.955h-1.311zm7.041 1.465L41.006 75q-.066-.389-.297-.584t-.598-.196q-.491 0-.783.338-.291.338-.291 1.132 0 .881.296 1.246c.296.365.463.362.795.362q.374 0 .611-.21c.237-.21.272-.386.337-.73l1.287.218q-.2.886-.77 1.339-.568.453-1.525.452-1.087 0-1.734-.685-.645-.685-.646-1.899 0-1.227.649-1.91.648-.684 1.755-.685.903 0 1.439.39c.536.39.612.655.767 1.188m2.367-3.35v2.515q.635-.743 1.516-.743.453 0 .817.17.363.166.548.428.185.261.252.579c.067.318.067.54.067.985v2.906h-1.31v-2.618q0-.779-.075-.99-.074-.208-.264-.332c-.19-.124-.283-.124-.473-.124q-.327 0-.583.158a.92.92 0 0 0-.376.478q-.119.322-.119.945v2.483h-1.311v-6.84zm7.466 5.263 1.307.22q-.253.717-.795 1.093-.545.375-1.36.375-1.294.001-1.914-.845-.489-.675-.489-1.706 0-1.232.644-1.93.643-.697 1.627-.697 1.107 0 1.745.73.64.73.612 2.237h-3.285q.014.583.317.908c.303.325.455.323.756.323q.308 0 .518-.167c.21-.167.246-.293.317-.541m.075-1.325q-.014-.57-.293-.865a.9.9 0 0 0-.682-.297.91.91 0 0 0-.71.313q-.279.311-.275.849zm3.692 2.902h-1.311V73.3h1.217v.705q.313-.5.563-.658a1.03 1.03 0 0 1 .567-.159q.448 0 .863.247l-.407 1.143q-.33-.215-.615-.215a.73.73 0 0 0-.467.153q-.192.151-.3.547-.11.397-.11 1.662zm5.262 0v-6.84h5.07v1.157h-3.69v1.516h3.434v1.153h-3.433v1.861h3.82v1.153zm9.691 0v-.742a1.9 1.9 0 0 1-.711.624 2 2 0 0 1-.932.23q-.498 0-.895-.22a1.3 1.3 0 0 1-.573-.615q-.178-.397-.178-1.097V73.3h1.311v2.277q0 1.044.072 1.28a.7.7 0 0 0 .264.374q.192.137.484.137.338 0 .603-.183a.94.94 0 0 0 .364-.458q.097-.272.097-1.337V73.3h1.311v4.955zm3.897 0h-1.311V73.3h1.218v.705q.313-.5.562-.658a1.03 1.03 0 0 1 .568-.159q.447 0 .862.247l-.406 1.143q-.33-.215-.615-.215a.73.73 0 0 0-.468.153q-.19.151-.3.547-.11.397-.11 1.662zm2.227-2.548q0-.652.323-1.265.32-.61.911-.932a2.7 2.7 0 0 1 1.319-.322q1.123 0 1.842.73t.719 1.845q0 1.125-.726 1.864c-.726.739-1.093.739-1.826.739q-.682 0-1.3-.308a2.1 2.1 0 0 1-.94-.902q-.322-.595-.322-1.449m1.344.07q0 .737.35 1.129c.35.392.521.392.863.392q.513 0 .86-.392.348-.391.348-1.139 0-.727-.347-1.119a1.1 1.1 0 0 0-.862-.392q-.51 0-.862.392c-.352.392-.35.638-.35 1.13m4.714-.659h2.575v1.312h-2.575zm2.814 3.136V77.01l3.593-4.438h-3.186v-1.157h5.006v1.073l-3.746 4.614h3.89v1.153zm7.467-3.443-1.19-.216q.2-.718.691-1.063.489-.345 1.455-.345.877 0 1.306.207c.429.207.488.315.604.528q.175.32.175 1.172l-.014 1.531q0 .655.064.963.062.31.235.666h-1.296a5 5 0 0 1-.126-.387l-.048-.154a2.4 2.4 0 0 1-.718.49 2.1 2.1 0 0 1-.816.163q-.766 0-1.206-.416a1.38 1.38 0 0 1-.441-1.05q0-.419.2-.748.2-.33.562-.504c.362-.174.589-.219 1.043-.305q.92-.174 1.274-.323v-.13q0-.378-.187-.54-.186-.16-.705-.16-.349 0-.545.138t-.317.482m1.754 1.064q-.252.085-.798.201c-.546.116-.601.154-.714.228a.55.55 0 0 0-.256.463.64.64 0 0 0 .205.475.71.71 0 0 0 .523.2q.354 0 .676-.233a.8.8 0 0 0 .312-.434q.052-.168.052-.638zm3.954-4.46v2.515q.633-.743 1.516-.743.452 0 .816.17.363.166.549.428.183.261.251.579c.068.318.068.54.068.985v2.906h-1.312v-2.618q0-.779-.074-.99-.075-.208-.263-.332c-.188-.124-.284-.124-.474-.124q-.327 0-.584.158a.92.92 0 0 0-.375.478q-.12.322-.119.945v2.483h-1.31v-6.84zm4.596 0h1.311v6.84h-1.311zm5.982 6.84v-.742a1.9 1.9 0 0 1-.71.624q-.441.23-.932.23-.498 0-.895-.22a1.3 1.3 0 0 1-.575-.615q-.176-.397-.176-1.097V73.3h1.31v2.277q0 1.044.073 1.28c.073.236.136.281.263.374q.192.137.485.137.336 0 .603-.183a.95.95 0 0 0 .364-.458q.097-.272.097-1.337V73.3h1.311v4.955zm7.15 0h-1.311v-2.53q0-.801-.084-1.038a.73.73 0 0 0-.274-.365.77.77 0 0 0-.453-.131q-.342 0-.613.187-.269.187-.37.494c-.101.307-.1.585-.1 1.138v2.245h-1.311V73.3h1.218v.727q.648-.839 1.632-.839.434 0 .794.157.358.155.543.398.184.243.257.55.071.308.072.883zm1.275.326 1.498.183q.038.26.172.358.186.14.588.14.514.001.77-.155a.63.63 0 0 0 .261-.33q.06-.163.06-.602v-.723q-.587.803-1.482.803-1 0-1.583-.845-.455-.666-.456-1.661 0-1.245.599-1.904.6-.657 1.491-.658.92 0 1.516.808V73.3h1.226v4.446q0 .876-.143 1.311-.147.435-.407.682c-.26.247-.407.293-.697.387q-.436.14-1.104.139-1.26 0-1.786-.431a1.35 1.35 0 0 1-.528-1.094zm1.172-2.907q0 .788.305 1.156a.95.95 0 0 0 .754.366q.48 0 .81-.376c.33-.376.332-.621.332-1.113q0-.769-.318-1.142a1 1 0 0 0-.802-.374q-.471 0-.776.366c-.305.366-.305.617-.305 1.117m4.391 1.167 1.316-.201q.083.383.34.581c.257.198.41.199.719.199q.508 0 .765-.186a.42.42 0 0 0 .172-.351l-.093-.247q-.098-.093-.439-.173-1.585-.349-2.01-.64a1.28 1.28 0 0 1-.589-1.114q0-.644.509-1.083.51-.438 1.577-.438 1.018 0 1.512.332.495.33.681.979l-1.236.229a.76.76 0 0 0-.301-.443q-.223-.155-.633-.155-.516 0-.741.145l-.149.266.13.238q.178.13 1.225.369 1.047.238 1.462.582.412.351.412.975 0 .682-.57 1.171-.569.491-1.684.49-1.013 0-1.602-.41c-.589-.41-.652-.645-.773-1.115m7.205 1.414-1.996-4.955h1.376l.932 2.528.272.845q.106-.322.135-.425.065-.21.14-.42l.942-2.528h1.349l-1.969 4.955zm6.887-1.577 1.307.22q-.252.717-.795 1.093-.543.375-1.36.375-1.293.001-1.914-.845-.488-.675-.488-1.706 0-1.232.642-1.93.645-.697 1.629-.697 1.106 0 1.745.73.64.73.611 2.237h-3.284q.014.583.317.908c.303.325.455.323.756.323q.307 0 .517-.167c.21-.167.247-.293.318-.541m.075-1.325q-.015-.57-.295-.865a.9.9 0 0 0-.68-.297.9.9 0 0 0-.709.313q-.28.311-.276.849zm3.691 2.902h-1.31V73.3h1.217v.705q.312-.5.562-.658a1.03 1.03 0 0 1 .566-.159q.45 0 .864.247l-.406 1.143q-.33-.215-.615-.215a.73.73 0 0 0-.468.153q-.19.151-.3.547-.11.397-.11 1.662zm2.483 0v-6.84h1.312v3.63l1.535-1.745h1.614l-1.693 1.81 1.815 3.145H147.1l-1.246-2.227-.611.64v1.587zm8.298-1.577 1.306.22q-.251.717-.795 1.093-.545.375-1.36.375-1.294.001-1.914-.845-.49-.675-.49-1.706 0-1.232.645-1.93.643-.697 1.628-.697 1.106 0 1.745.73.64.73.611 2.237h-3.285q.015.583.318.908a1 1 0 0 0 .756.323q.307 0 .517-.167c.21-.167.247-.293.318-.541m.075-1.325q-.015-.57-.294-.865c-.279-.295-.415-.297-.682-.297a.9.9 0 0 0-.71.313q-.278.311-.274.849zm3.743-3.938v2.515q.633-.743 1.516-.743.452 0 .816.17.364.166.55.428.183.261.25.579c.067.318.068.54.068.985v2.906h-1.311v-2.618q0-.779-.074-.99-.074-.208-.264-.332c-.19-.124-.283-.124-.473-.124q-.327 0-.584.158a.92.92 0 0 0-.375.478q-.12.322-.119.945v2.483h-1.311v-6.84zm5.852 6.84h-1.311V73.3h1.217v.705q.313-.5.563-.658a1.03 1.03 0 0 1 .567-.159q.446 0 .863.247l-.407 1.143q-.33-.215-.615-.215a.73.73 0 0 0-.467.153q-.192.151-.3.547-.11.397-.11 1.662zm2.068-1.414 1.315-.201q.084.383.341.581c.257.198.41.199.72.199q.507 0 .764-.186a.42.42 0 0 0 .173-.351l-.094-.247q-.097-.093-.439-.173-1.585-.349-2.01-.64a1.28 1.28 0 0 1-.589-1.114q0-.644.51-1.083.509-.438 1.577-.438 1.015 0 1.51.332.495.33.682.979l-1.236.229a.76.76 0 0 0-.301-.443q-.223-.155-.633-.155-.516 0-.741.145l-.149.266.13.238q.178.13 1.225.369 1.047.238 1.463.582.41.351.41.975 0 .682-.57 1.171-.568.491-1.683.49-1.013 0-1.602-.41c-.589-.41-.652-.645-.773-1.115m7.098 1.414h-1.311V73.3h1.217v.705q.313-.5.563-.658a1.03 1.03 0 0 1 .567-.159q.448 0 .863.247l-.407 1.143q-.33-.215-.615-.215a.73.73 0 0 0-.467.153q-.19.151-.3.547-.11.397-.11 1.662zm3.509-3.443-1.19-.216q.202-.718.692-1.063c.49-.345.811-.345 1.455-.345q.878 0 1.306.207.43.209.605.528.174.32.174 1.172l-.014 1.531q0 .655.064.963.063.31.235.666h-1.296a5 5 0 0 1-.127-.387l-.046-.154a2.4 2.4 0 0 1-.719.49 2.1 2.1 0 0 1-.816.163q-.765 0-1.206-.416a1.38 1.38 0 0 1-.441-1.05q0-.419.2-.748.2-.33.563-.504.36-.175 1.043-.305.918-.174 1.272-.323v-.13q0-.378-.186-.54-.186-.16-.704-.16-.35 0-.546.138t-.317.482m1.753 1.064q-.25.085-.797.201c-.547.116-.601.154-.714.228a.55.55 0 0 0-.256.463.64.64 0 0 0 .205.475.71.71 0 0 0 .522.2q.355 0 .678-.233a.83.83 0 0 0 .312-.434q.05-.168.05-.638zm5.909 2.38v-.742a1.9 1.9 0 0 1-.711.624 2 2 0 0 1-.932.23q-.498 0-.895-.22a1.3 1.3 0 0 1-.573-.615q-.179-.397-.179-1.097V73.3h1.311v2.277q0 1.044.073 1.28c.073.236.136.281.263.374q.192.137.485.137.337 0 .603-.183a.95.95 0 0 0 .364-.458q.097-.272.097-1.337V73.3h1.311v4.955zm2.544-4.956h1.208v.677q.65-.788 1.545-.789.476 0 .825.196.351.198.575.593.326-.395.705-.593.377-.195.806-.196.545 0 .924.223c.379.223.44.365.565.651q.135.317.135 1.026v3.168h-1.312v-2.831q0-.739-.135-.953-.18-.28-.56-.28a.9.9 0 0 0-.517.169q-.243.167-.35.491c-.107.324-.107.557-.107 1.024v2.38h-1.312V75.54q.001-.724-.07-.934a.6.6 0 0 0-.216-.313.7.7 0 0 0-.4-.102.95.95 0 0 0-.545.164q-.244.163-.347.471c-.103.308-.105.545-.105 1.021v2.408h-1.312zM.06 62.94l1.971-.192q.177.991.721 1.457.545.465 1.468.465.978 0 1.475-.413.495-.415.496-.97a.92.92 0 0 0-.209-.605q-.21-.248-.728-.434-.356-.124-1.623-.438-1.628-.405-2.285-.992-.924-.827-.924-2.019 0-.766.435-1.432.434-.669 1.253-1.018.816-.348 1.974-.349 1.888 0 2.842.83.955.826 1.002 2.21l-2.025.088q-.13-.773-.557-1.113-.428-.338-1.284-.338-.882 0-1.381.363a.73.73 0 0 0-.323.623q0 .355.302.609.383.322 1.861.67c1.478.348 1.714.473 2.186.722s.841.589 1.109 1.019q.4.648.4 1.599a2.96 2.96 0 0 1-.479 1.615q-.48.75-1.355 1.118-.876.367-2.182.367-1.903 0-2.923-.88c-1.02-.88-1.085-1.44-1.217-2.563m10.267-6.767h1.922v1.779h-1.922zm0 2.764h1.922v7.267h-1.922zm10.923 7.267h-1.922v-3.709q0-1.177-.124-1.522-.122-.346-.4-.538c-.278-.192-.407-.19-.667-.19q-.5 0-.897.273c-.397.273-.446.424-.543.725q-.148.451-.148 1.67v3.291h-1.922v-7.267h1.786v1.067q.951-1.231 2.395-1.231.636 0 1.163.229.526.23.797.585.27.356.376.807.107.452.107 1.294zm2.193.479 2.197.268q.054.382.253.526.274.205.863.205.751 0 1.129-.225a.93.93 0 0 0 .382-.486q.089-.24.089-.883v-1.061q-.862 1.177-2.175 1.177-1.464 0-2.32-1.238-.671-.979-.671-2.437 0-1.826.88-2.79a2.84 2.84 0 0 1 2.186-.966q1.348 0 2.224 1.184v-1.02h1.8v6.521q0 1.287-.213 1.923-.212.637-.595 1-.384.36-1.024.567-.64.204-1.617.205-1.849 0-2.621-.632-.773-.634-.773-1.605zm1.718-4.262q0 1.156.449 1.693.446.537 1.105.537.703 0 1.19-.55.485-.552.486-1.633 0-1.128-.465-1.676a1.48 1.48 0 0 0-1.178-.548q-.69 0-1.138.537-.45.537-.45 1.64m7.442-6.248h1.922v10.031h-1.922zm8.522 7.718 1.916.322q-.37 1.053-1.167 1.604c-.797.551-1.196.552-1.994.552q-1.896 0-2.806-1.239-.718-.992-.718-2.505 0-1.806.944-2.83.944-1.022 2.388-1.022 1.621 0 2.56 1.07c.939 1.07.923 1.808.896 3.282h-4.818q.021.855.465 1.331.446.475 1.109.475.452 0 .76-.246c.308-.246.36-.429.465-.794m.11-1.944q-.02-.835-.431-1.268a1.32 1.32 0 0 0-1-.435q-.629 0-1.04.458c-.411.458-.408.722-.404 1.245zm8.224 4.257V56.172h7.437v1.696h-5.412v2.225h5.036v1.69h-5.036v2.73h5.605v1.69zm14.536 0v-1.087q-.397.58-1.043.916c-.646.336-.887.335-1.365.335q-.734 0-1.314-.321c-.58-.321-.669-.515-.841-.904q-.26-.582-.26-1.608v-4.598h1.922v3.34q0 1.53.106 1.878.106.345.387.548.281.201.71.201.495 0 .885-.27c.39-.27.437-.405.533-.671q.143-.401.144-1.96v-3.066h1.923v7.267zm6.039 0H68.11v-7.267h1.786v1.033q.458-.732.824-.965c.366-.233.521-.232.831-.232q.658 0 1.267.362l-.595 1.677q-.487-.315-.904-.314-.404 0-.684.222-.281.223-.441.804-.162.582-.161 2.435zm3.588-3.736q0-.958.473-1.854a3.23 3.23 0 0 1 1.337-1.368 3.96 3.96 0 0 1 1.933-.473q1.65 0 2.704 1.071 1.053 1.07 1.054 2.707 0 1.648-1.066 2.732-1.061 1.085-2.678 1.085-.999 0-1.905-.451a3.1 3.1 0 0 1-1.379-1.324q-.472-.873-.472-2.125m1.97.102q0 1.082.513 1.657.514.574 1.267.575.751-.001 1.262-.575.51-.575.51-1.67 0-1.068-.51-1.643a1.62 1.62 0 0 0-1.262-.574q-.754 0-1.267.574-.513.575-.512 1.656m11.781 3.634V56.172h3.25q1.849 0 2.409.15.862.227 1.444.982c.582.755.581 1.155.581 1.954q0 .923-.335 1.553c-.335.63-.507.75-.851.99a3 3 0 0 1-1.051.475q-.725.143-2.1.143h-1.322v3.784zm2.025-8.335v2.848h1.109q1.199 0 1.601-.158c.402-.158.48-.27.633-.492a1.35 1.35 0 0 0 .23-.78q0-.548-.321-.904a1.4 1.4 0 0 0-.816-.445q-.361-.068-1.457-.069zm9.166 3.285-1.744-.315q.293-1.053 1.013-1.56c.72-.507 1.19-.506 2.135-.506q1.285 0 1.915.305.63.304.886.772c.256.468.256.887.256 1.722l-.02 2.243q0 .959.093 1.414a4 4 0 0 0 .346.975h-1.903a7 7 0 0 1-.186-.567 3 3 0 0 0-.067-.227q-.494.48-1.054.72c-.56.24-.773.238-1.198.238q-1.122 0-1.768-.609c-.646-.609-.647-.919-.647-1.54q0-.615.294-1.097.293-.482.825-.74.53-.255 1.529-.448 1.348-.253 1.867-.472v-.192q0-.554-.273-.79-.274-.236-1.033-.236-.514 0-.801.203-.287.2-.465.707m2.572 1.56q-.369.123-1.168.295-.802.17-1.048.335-.376.267-.376.678 0 .403.301.697.3.295.766.294.52 0 .992-.341.349-.261.46-.636.072-.248.073-.938zm3.295-3.777h2.046l1.74 5.16 1.695-5.16h1.992l-2.567 6.994-.458 1.265q-.255.637-.482.973-.229.334-.527.543c-.298.209-.443.248-.733.325s-.616.117-.982.117a5 5 0 0 1-1.086-.117l-.173-1.505a4.3 4.3 0 0 0 .815.089q.67 0 .991-.394.323-.393.494-1.002zm8.981 0h1.772v.993q.952-1.157 2.265-1.157.698 0 1.212.287.512.288.84.87.48-.582 1.035-.87a2.54 2.54 0 0 1 1.183-.286q.8 0 1.354.323.555.326.829.955.198.467.199 1.506v4.647h-1.924V62.05q0-1.081-.198-1.396-.268-.41-.82-.41-.405 0-.76.246-.356.247-.513.721-.16.476-.158 1.503v3.49h-1.924V62.22q0-1.06-.102-1.368-.102-.31-.318-.46c-.216-.15-.338-.15-.585-.15q-.445 0-.8.24a1.3 1.3 0 0 0-.51.69q-.155.453-.155 1.5v3.53h-1.922zm17.233 4.954 1.916.322q-.37 1.053-1.167 1.604c-.797.551-1.197.552-1.994.552q-1.896 0-2.806-1.239-.72-.992-.72-2.505 0-1.806.946-2.83.945-1.022 2.387-1.022 1.623 0 2.56 1.07.937 1.072.897 3.282h-4.818q.021.855.465 1.331a1.46 1.46 0 0 0 1.109.475q.452 0 .76-.246c.308-.246.36-.429.465-.794m.11-1.944q-.021-.835-.431-1.268a1.32 1.32 0 0 0-1-.435q-.63 0-1.04.458c-.41.458-.41.722-.404 1.245zm10.506 4.257h-1.923v-3.709q0-1.177-.123-1.522c-.123-.345-.215-.41-.4-.538s-.408-.19-.668-.19q-.498 0-.896.273c-.398.273-.446.424-.544.725s-.147.857-.147 1.67v3.291h-1.923v-7.267h1.786v1.067q.951-1.231 2.395-1.231.636 0 1.163.229.526.23.797.585.271.356.377.807t.106 1.294zm5.703-7.267v1.533h-1.314v2.928q0 .89.038 1.037l.171.244a.54.54 0 0 0 .325.095q.266 0 .772-.184l.164 1.491a3.8 3.8 0 0 1-1.519.287q-.519 0-.936-.173-.418-.176-.612-.453c-.194-.277-.222-.435-.272-.749q-.06-.335-.06-1.355V60.47h-.883v-1.533h.882v-1.444l1.93-1.122v2.566zm1.077 5.194 1.93-.294q.123.56.5.851c.377.291.602.291 1.053.291q.745 0 1.123-.273a.61.61 0 0 0 .253-.514.5.5 0 0 0-.137-.363q-.144-.136-.643-.252-2.328-.514-2.95-.938-.862-.588-.862-1.636 0-.944.746-1.587.745-.643 2.314-.643 1.49 0 2.216.485.724.487.999 1.438l-1.814.335a1.12 1.12 0 0 0-.441-.65q-.324-.225-.928-.225-.758 0-1.087.211a.45.45 0 0 0-.219.39q0 .207.193.349.258.192 1.794.541c1.536.349 1.74.517 2.147.855q.6.514.601 1.43 0 1-.834 1.718-.836.718-2.471.718-1.485 0-2.35-.602c-.865-.602-.955-.947-1.133-1.635m21.745 2.073h-2.204l-.875-2.279h-4.01l-.828 2.28h-2.148l3.906-10.032h2.143zm-3.729-3.969-1.382-3.722-1.355 3.722zm7.052 3.969h-1.923v-7.267h1.786v1.033q.458-.732.824-.965c.366-.233.52-.232.83-.232q.658 0 1.267.362l-.595 1.677q-.486-.315-.904-.314-.403 0-.683.222-.281.223-.443.804-.16.582-.16 2.435zm8.24-2.313 1.917.322q-.37 1.053-1.166 1.604-.8.552-1.995.552-1.896 0-2.806-1.239-.72-.992-.72-2.505 0-1.806.946-2.83.944-1.022 2.387-1.022 1.623 0 2.56 1.07c.937 1.07.924 1.808.897 3.282h-4.818q.021.855.465 1.331.444.475 1.109.475.452 0 .76-.246c.308-.246.36-.429.465-.794m.11-1.944q-.021-.835-.431-1.268a1.32 1.32 0 0 0-1-.435q-.63 0-1.04.458c-.41.458-.408.722-.404 1.245zm5.332-.793-1.744-.315q.293-1.053 1.013-1.56c.72-.507 1.19-.506 2.135-.506q1.284 0 1.916.305.629.304.885.772c.256.468.256.887.256 1.722l-.02 2.243q0 .959.093 1.414.091.455.346.975h-1.902a7 7 0 0 1-.185-.567 4 4 0 0 0-.069-.227q-.493.48-1.054.72c-.561.24-.772.238-1.197.238q-1.123 0-1.769-.609c-.646-.609-.648-.919-.648-1.54q.001-.615.295-1.097c.294-.482.47-.568.825-.74q.53-.255 1.53-.448 1.347-.253 1.867-.472v-.192q.001-.554-.274-.79-.274-.236-1.033-.236-.511 0-.8.203-.288.2-.466.707m2.573 1.56q-.37.123-1.169.295-.802.17-1.048.335-.375.267-.376.678 0 .403.301.697.3.295.767.294.52 0 .991-.341a1.2 1.2 0 0 0 .46-.636q.074-.248.074-.938zM42.688 16.748H29.54q0-3.236-.759-4.342-1.173-1.636-6.475-1.636c-3.432 0-5.707.313-6.817.942q-1.665.947-1.666 4.114 0 2.868 1.478 3.774 1.06.642 2.803.755l2.651.187q8.524.566 10.646.794 6.741.679 9.773 3.584 2.386 2.267 2.841 5.923.266 2.192.265 4.944 0 6.342-1.21 9.284-2.194 5.398-9.868 6.829-3.217.605-9.834.605-11.045.001-15.39-1.319Q2.645 49.567.944 44.63C.312 42.797 0 39.745 0 35.472h13.146l.001 1.093q0 3.42 1.964 4.398 1.358.674 3.286.715h4.834q3.7 0 4.719-.38 1.813-.712 2.381-2.298.301-.979.301-2.528 0-3.466-2.528-4.222c-.632-.199-3.562-.478-8.794-.829q-6.303-.45-8.755-.869-6.457-1.206-8.604-4.975-1.888-3.203-1.887-9.69 0-4.938 1.02-7.916t3.288-4.525q3.327-2.375 8.504-2.79C15.75.405 18.935.277 22.44.277q8.277.002 11.794.947 8.581 2.305 8.581 12.917 0 .869-.128 2.608m57.811 35.756V0h26.328q5.418 0 8.26.884 6.493 2.035 8.723 8.332 1.153 3.307 1.153 9.952c0 5.326-.426 9.152-1.27 11.483-1.689 4.608-5.164 7.263-10.413 7.95q-.925.157-7.88.27l-2.345.078h-8.425v13.556zM114.63 26.77h8.81q4.188-.149 5.103-.651 1.255-.689 1.675-2.758.268-1.376.268-4.095 0-3.33-.534-4.942c-.508-1.507-1.725-2.423-3.653-2.757q-.573-.076-2.741-.077h-8.927zm60.496 16.661h-18.894l-2.539 9.074h-14.62L154.85 0h21.316l15.969 52.505h-14.313zm-2.806-10.228-6.622-22.76-6.425 22.76z"
})), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbe00",
  d: "M80.994 7.387c5.828 0 11.03 2.685 14.449 6.89l3.046-6.531C93.725 3.242 87.242.465 80.09.465c-11.135 0-20.66 6.726-24.568 16.246h-5.94l-3.508 7.519h7.641a26 26 0 0 0-.095 2.107q.001 1.293.13 2.555h-3.84l-3.506 7.521h9.3c4.02 9.279 13.426 15.793 24.386 15.793 5.524 0 10.65-1.655 14.893-4.483v-9.217c-3.418 3.891-8.416 6.35-13.989 6.35-6.514 0-12.244-3.359-15.58-8.443h19.473l3.507-7.521H62.55a19 19 0 0 1-.11-4.663h28.129l3.506-7.518H64.87c3.23-5.574 9.24-9.325 16.124-9.325"
})), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
  fill: "#10298e",
  d: "M80.994 7.612c5.554 0 10.756 2.482 14.274 6.808l.227.28.154-.327 3.045-6.531.068-.149-.117-.112C93.638 2.848 87.048.242 80.09.242c-5.433 0-10.66 1.587-15.12 4.591-4.353 2.933-7.693 7.011-9.656 11.793l.208-.14h-6.085l-.06.13-3.507 7.52-.15.321h7.995l-.225-.245a26 26 0 0 0-.095 2.126c0 .844.044 1.713.13 2.578l.225-.248h-3.982l-.06.13-3.509 7.52-.149.321h9.654l-.207-.136c4.192 9.676 13.846 15.929 24.593 15.929 5.388 0 10.58-1.561 15.018-4.519l.099-.066v-9.939l-.394.45a18.4 18.4 0 0 1-13.819 6.272c-6.212 0-11.966-3.12-15.392-8.34l-.188.35h19.618l.06-.13 3.507-7.522.15-.32h-26.2l.224.193a18.7 18.7 0 0 1-.109-4.607l-.225.203h28.274l.06-.13 3.506-7.52.151-.321H64.87l.195.339c3.293-5.683 9.398-9.213 15.93-9.213M64.87 16.937h29.204l-.205-.321-3.505 7.52.204-.13H62.235l-.022.204a19.5 19.5 0 0 0 .112 4.717l.03.193h26.039l-.204-.322-3.506 7.52.203-.13H64.995l.23.348c3.51 5.352 9.405 8.543 15.77 8.543 5.41 0 10.57-2.34 14.158-6.423l-.396-.149v9.217l.1-.186c-4.364 2.907-9.47 4.443-14.767 4.443-10.568 0-20.058-6.147-24.178-15.658l-.06-.135h-9.448l.206.323 3.505-7.523-.205.132H54l-.025-.25a26 26 0 0 1-.13-2.532c0-.637.032-1.321.095-2.088l.02-.244h-7.885l.203.321 3.507-7.52-.203.13h6.09l.057-.14c1.931-4.699 5.214-8.706 9.494-11.59C69.605 2.256 74.748.695 80.09.695c6.843 0 13.32 2.56 18.244 7.215l-.05-.26-3.044 6.532.38-.048c-3.607-4.43-8.936-6.973-14.626-6.973-6.694 0-12.945 3.616-16.32 9.437l-.196.339z"
})));

var _path$n;
function _extends$q() { return _extends$q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$q.apply(null, arguments); }
const SvgShield = props => /*#__PURE__*/React.createElement("svg", _extends$q({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 512 512"
}, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m466.5 83.7-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3M256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7"
})));

var _path$m;
function _extends$p() { return _extends$p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$p.apply(null, arguments); }
const SvgShoppingCart = props => /*#__PURE__*/React.createElement("svg", _extends$p({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 576 512"
}, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m528.12 301.319 47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681"
})));

var _path$l;
function _extends$o() { return _extends$o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$o.apply(null, arguments); }
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends$o({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 576 512"
}, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M528.1 171.5 382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6M388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2z"
})));

var _path$k;
function _extends$n() { return _extends$n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$n.apply(null, arguments); }
const SvgTelefon = props => /*#__PURE__*/React.createElement("svg", _extends$n({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 27.03 27.03"
}, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
  d: "M27.03 21.34a1 1 0 0 0-.06-.41c-.13-.4-1.07-.82-1.46-1-1.09-.62-2.2-1.21-3.28-1.85-.5-.3-1.11-.88-1.71-.88-1.17 0-2.88 3.47-3.91 3.47a4.2 4.2 0 0 1-1.66-.74 19.1 19.1 0 0 1-7.85-7.86 4.1 4.1 0 0 1-.76-1.65c0-1 3.48-2.74 3.48-3.91 0-.6-.58-1.21-.89-1.71-.59-1.08-1.21-2.19-1.83-3.29-.19-.38-.61-1.32-1-1.45A.9.9 0 0 0 5.7 0a8.5 8.5 0 0 0-2.67.59 5.1 5.1 0 0 0-2 2.34 7.3 7.3 0 0 0-1 3.58 15 15 0 0 0 1.31 5.03 18 18 0 0 0 1.6 3.36 32.3 32.3 0 0 0 9.21 9.21 19 19 0 0 0 3.36 1.6 14.9 14.9 0 0 0 5 1.32 7.26 7.26 0 0 0 3.57-1 5.1 5.1 0 0 0 2.35-2 8.8 8.8 0 0 0 .6-2.69",
  className: "telefon_svg__cls-1"
})));

var _path$j;
function _extends$m() { return _extends$m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$m.apply(null, arguments); }
const SvgMapMarker = props => /*#__PURE__*/React.createElement("svg", _extends$m({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 384 512"
}, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0M192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80"
})));

var _path$i;
function _extends$l() { return _extends$l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$l.apply(null, arguments); }
const SvgSyncSolid = props => /*#__PURE__*/React.createElement("svg", _extends$l({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 512 512"
}, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m440.65 12.57 4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57M255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432"
})));

var _path$h;
function _extends$k() { return _extends$k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$k.apply(null, arguments); }
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends$k({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  className: "filter_svg__svg-inline--fa filter_svg__fa-filter filter_svg__fa-w-16 filter_svg__fa-9x",
  viewBox: "0 0 512 512"
}, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0"
})));

function _extends$j() { return _extends$j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$j.apply(null, arguments); }
const SvgExclamation = props => /*#__PURE__*/React.createElement("svg", _extends$j({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 576 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M569.52 440c18.45 32-4.71 72-41.58 72H48.05c-36.93 0-60-40.05-41.57-72L246.42 24c18.47-32 64.72-32 83.16 0zM288 354a46 46 0 1 0 46 46 46 46 0 0 0-46-46m-43.67-165.35 7.41 136a12 12 0 0 0 12 11.35h48.54a12 12 0 0 0 12-11.35l7.42-136a12 12 0 0 0-12-12.65h-63.39a12 12 0 0 0-12 12.65Z",
  style: {
    fill: "#484a4f"
  }
}));

var _path$g;
function _extends$i() { return _extends$i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$i.apply(null, arguments); }
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends$i({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 512 512"
}, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M505 442.7 405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34M208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128"
})));

var _path$f;
function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
const SvgBeispielrechnung = props => /*#__PURE__*/React.createElement("svg", _extends$h({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "41.78 -0.22 42.43 48.42"
}, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
  d: "M43.6 1.6c-2.4 2.3-2.4 42.5 0 44.8 2.3 2.4 36.5 2.4 38.8 0 2.4-2.3 2.4-42.5 0-44.8-2.3-2.4-36.5-2.4-38.8 0M78 12v6H48V6h30zM54 27c0 2.7-.3 3-3 3s-3-.3-3-3 .3-3 3-3 3 .3 3 3m12 0c0 2.7-.3 3-3 3s-3-.3-3-3 .3-3 3-3 3 .3 3 3m12 6v9h-6V24h6zm-24 6c0 2.7-.3 3-3 3s-3-.3-3-3 .3-3 3-3 3 .3 3 3m12 0c0 2.7-.3 3-3 3s-3-.3-3-3 .3-3 3-3 3 .3 3 3"
})));

var _path$e, _path2$2;
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
const SvgFondsinformation = props => /*#__PURE__*/React.createElement("svg", _extends$g({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "38 34.12 47.5 35.75"
}, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
  d: "M38.7 34.6c-.4.4-.7 8-.7 16.9 0 12.6.3 16.5 1.4 17.4.9.8 8.1 1.1 23.7.9l22.4-.3v-5l-20.7-.3-20.7-.2-.3-14.8c-.3-13.9-.4-14.7-2.3-15-1.2-.2-2.4 0-2.8.4"
})), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
  d: "M69.1 38.3c-.9 1.1-.8 1.7.4 2.7 2.2 1.8 1.9 3.3-1.5 6.5l-2.9 2.8-4.1-3.6c-2.2-2.1-4.5-3.7-5-3.7-.6 0-3 1.8-5.3 3.9l-4.2 4 2.2 2.2 2.3 2.3 2.4-2.3 2.5-2.4 4.1 3.7c2.2 2 4.5 3.6 5.1 3.6.5 0 3.4-2.2 6.3-5l5.2-4.9 2.2 2.1c3.2 3.2 4.4 1.3 4-6.3l-.3-6.4-6.1-.3c-4.3-.2-6.4.1-7.3 1.1"
})));

var _path$d;
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
const SvgAngebot = props => /*#__PURE__*/React.createElement("svg", _extends$f({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "220 220 400 400"
}, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
  d: "M542.58 257.42A24.08 24.08 0 0 0 525 250H325a25.34 25.34 0 0 0-25 25v300a25.34 25.34 0 0 0 25 25h200a25.34 25.34 0 0 0 25-25V275a24.06 24.06 0 0 0-7.42-17.58m-174.9 310.26A25 25 0 1 1 375 550a24.12 24.12 0 0 1-7.32 17.68m0-75A25 25 0 1 1 375 475a24.12 24.12 0 0 1-7.32 17.68m0-75A25 25 0 1 1 375 400a24.12 24.12 0 0 1-7.32 17.68m75 150A25 25 0 1 1 450 550a24.08 24.08 0 0 1-7.33 17.68Zm0-75A25 25 0 1 1 450 475a24.08 24.08 0 0 1-7.33 17.68Zm0-75A25 25 0 1 1 450 400a24.08 24.08 0 0 1-7.33 17.68ZM525 550a25 25 0 0 1-50 0v-75a25 25 0 0 1 50 0Zm-7.33-132.32A25 25 0 1 1 525 400a24.08 24.08 0 0 1-7.33 17.68M525 337.5a12.67 12.67 0 0 1-12.5 12.5h-175a12.67 12.67 0 0 1-12.5-12.5v-50a12.67 12.67 0 0 1 12.5-12.5h175a12.67 12.67 0 0 1 12.5 12.5Z",
  className: "angebot_svg__cls-1"
})));

var _path$c, _path2$1, _path3$1;
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
const SvgDokumentensuche = props => /*#__PURE__*/React.createElement("svg", _extends$e({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  "aria-hidden": "true",
  viewBox: "250 250 400 400"
}, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
  d: "m574.08 285.88-54.37-59.75c-10.93-12.01-30.64-20.72-46.88-20.72H319.66c-35.73 0-64.79 29.07-64.79 64.79V588c0 35.73 29.07 64.79 64.79 64.79h207.79c35.73 0 64.79-29.07 64.79-64.79V332.84c0-15.64-7.64-35.39-18.16-46.96m-46.63 329.67H319.66c-15.2 0-27.56-12.36-27.56-27.56V270.2c0-15.2 12.36-27.56 27.56-27.56h127.82v77.69c0 14.57 11.81 26.38 26.38 26.38H555V588c.01 15.19-12.35 27.55-27.55 27.55"
})), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
  d: "M527.45 657.04H319.66c-38.07 0-69.04-30.97-69.04-69.04V270.2c0-38.07 30.97-69.04 69.04-69.04h153.17c17.32 0 38.36 9.3 50.02 22.11l54.37 59.75c11.17 12.28 19.27 33.23 19.27 49.82V588c0 38.07-30.97 69.04-69.04 69.04M319.66 209.66c-33.38 0-60.54 27.16-60.54 60.54V588c0 33.38 27.16 60.54 60.54 60.54h207.79c33.38 0 60.54-27.16 60.54-60.54V332.84c0-14.68-7.17-33.23-17.06-44.1l-54.37-59.75c-10.2-11.2-28.59-19.33-43.73-19.33zm207.79 410.15H319.66c-17.54 0-31.81-14.27-31.81-31.81V270.2c0-17.54 14.27-31.81 31.81-31.81h132.08v81.94c0 12.2 9.93 22.13 22.13 22.13h85.39V588c0 17.54-14.27 31.81-31.81 31.81M319.66 246.89c-12.85 0-23.31 10.46-23.31 23.31V588c0 12.85 10.46 23.31 23.31 23.31h207.79c12.85 0 23.31-10.46 23.31-23.31V350.97h-76.88c-16.89 0-30.64-13.74-30.64-30.64v-73.44z"
})), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
  d: "M525.86 567.33c0-4.04-1.67-7.97-4.4-10.7l-40.79-40.79c9.63-13.91 14.75-30.56 14.75-47.45 0-46.26-37.46-83.72-83.72-83.72s-83.72 37.46-83.72 83.72 37.46 83.72 83.72 83.72c16.89 0 33.54-5.11 47.45-14.75l40.79 40.67c2.73 2.86 6.66 4.52 10.7 4.52 8.44 0 15.22-6.78 15.22-15.22m-60.89-98.95c0 29.37-23.9 53.28-53.28 53.28-29.37 0-53.28-23.9-53.28-53.28 0-29.37 23.9-53.28 53.28-53.28 29.38.01 53.28 23.91 53.28 53.28"
})));

var _path$b;
function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends$d({
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  "aria-hidden": "true",
  viewBox: "0 0 512 512"
}, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
  d: "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4l217.6 163.2c11.4 8.5 27 8.5 38.4 0l217.6-163.2c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48zM0 176v208c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V176L294.4 339.2a63.9 63.9 0 0 1-76.8 0z"
})));

var _path$a;
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
const SvgUserSolid = props => /*#__PURE__*/React.createElement("svg", _extends$c({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 640 512"
}, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
  d: "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256m-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3z"
})));

var _path$9;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
const SvgUserPlusSolid = props => /*#__PURE__*/React.createElement("svg", _extends$b({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 640 512"
}, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
  d: "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0M0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3M504 312v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24"
})));

var _path$8;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
const SvgUserMinusSolid = props => /*#__PURE__*/React.createElement("svg", _extends$a({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 640 512"
}, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
  d: "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0M0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3M472 200h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24"
})));

var _path$7;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
const SvgPenToSquareSolid = props => /*#__PURE__*/React.createElement("svg", _extends$9({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 512 512"
}, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
  d: "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0l-30.1 30 97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5l167.3-167.4-98-98zM96 64c-53 0-96 43-96 96v256c0 53 43 96 96 96h256c53 0 96-43 96-96v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32z"
})));

var _path$6;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
const SvgTrashSolid = props => /*#__PURE__*/React.createElement("svg", _extends$8({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 448 512"
}, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
  d: "M135.2 17.69C140.6 6.848 151.7 0 163.8 0h120.4c12.1 0 23.2 6.848 28.6 17.69L320 32h96c17.7 0 32 14.33 32 32s-14.3 32-32 32H32C14.33 96 0 81.67 0 64s14.33-32 32-32h96zM394.8 466.1c-1.6 26.2-22.5 45.9-47.9 45.9H101.1c-25.35 0-46.33-19.7-47.91-45.9L31.1 128H416z"
})));

var _path$5;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
const SvgAtSolid = props => /*#__PURE__*/React.createElement("svg", _extends$7({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 512 512"
}, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
  d: "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256v32c0 53-43 96-96 96-29.3 0-55.6-13.2-73.2-33.9-22.8 21-53.3 33.9-86.8 33.9-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1 5.7-5 13.1-8.1 21.3-8.1 17.7 0 32 14.3 32 32v112c0 17.7 14.3 32 32 32s32-14.3 32-32v-32c0-106-86-192-192-192m64 192a64 64 0 1 0-128 0 64 64 0 1 0 128 0"
})));

var _path$4, _path2, _path3;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
const SvgNeuordnung = props => /*#__PURE__*/React.createElement("svg", _extends$6({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  "aria-hidden": "true",
  viewBox: "0 0 850 850"
}, props), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h850v850H0z",
  style: {
    fill: "none"
  }
}), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
  d: "M743.23 119.24H361.02c-42.54 0-77.15 34.61-77.15 77.15v560.66c0 42.53 34.61 77.14 77.15 77.14h382.21c42.54 0 77.15-34.61 77.15-77.14V196.39c0-42.54-34.61-77.15-77.15-77.15m37.15 637.81c0 20.48-16.67 37.14-37.15 37.14H361.02c-20.48 0-37.15-16.66-37.15-37.14V196.39c0-20.48 16.67-37.15 37.15-37.15h382.21c20.48 0 37.15 16.67 37.15 37.15z",
  className: "neuordnung_svg__st4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M487.98 23.87H105.77c-42.54 0-77.15 34.61-77.15 77.15v560.65c0 42.54 34.61 77.15 77.15 77.15h218.1v-40h-218.1c-20.48 0-37.15-16.66-37.15-37.15V101.02c0-20.48 16.67-37.15 37.15-37.15h382.21c20.48 0 37.15 16.67 37.15 37.15v57.9h40v-57.9c0-42.54-34.61-77.15-77.15-77.15",
  className: "neuordnung_svg__st4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M627.85 517.36V473H473.32c-5.92 0-10.71-4.8-10.71-10.71v-29.23l-84.31 84.3 84.31 84.31v-29.23c0-5.91 4.79-10.71 10.71-10.71h165.24c5.92 0 10.71 4.8 10.71 10.71 0 5.92-4.79 10.71-10.71 10.71H484.03v44.37a10.707 10.707 0 0 1-10.71 10.71c-2.78 0-5.53-1.08-7.57-3.14L355.58 524.95a10.7 10.7 0 0 1-3.14-7.58c0-2.84 1.12-5.56 3.14-7.57l110.17-110.16c3.06-3.06 7.67-3.98 11.66-2.32 4.01 1.66 6.62 5.56 6.62 9.9v44.37h154.53c5.92 0 10.71 4.79 10.71 10.71v29.22l84.31-84.3-84.31-84.31v29.23c0 5.91-4.79 10.71-10.71 10.71H473.32c-5.92 0-10.71-4.8-10.71-10.71s4.79-10.71 10.71-10.71h154.53v-44.37c0-4.33 2.61-8.24 6.62-9.9 3.99-1.66 8.6-.74 11.66 2.32L756.3 399.63c2.01 2 3.14 4.73 3.14 7.57s-1.12 5.56-3.14 7.57L646.13 524.95a10.7 10.7 0 0 1-7.57 3.13c-1.38 0-2.77-.27-4.09-.81a10.72 10.72 0 0 1-6.62-9.91m-303.98-14.73v21.42H111.84c-5.92 0-10.71-4.8-10.71-10.71 0-5.92 4.79-10.71 10.71-10.71zm0-131.99v21.42H111.84c-5.92 0-10.71-4.8-10.71-10.71 0-5.92 4.79-10.71 10.71-10.71zm0-66v21.42H111.84c-5.92 0-10.71-4.8-10.71-10.71 0-5.92 4.79-10.71 10.71-10.71zm0 131.99v21.42H111.84c-5.92 0-10.71-4.8-10.71-10.71 0-5.92 4.79-10.71 10.71-10.71zm0-197.98v21.42H111.84c-5.92 0-10.71-4.8-10.71-10.71 0-5.92 4.79-10.71 10.71-10.71z",
  className: "neuordnung_svg__st4"
})))));

var _path$3;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
const SvgFileArrowUpSolid = props => /*#__PURE__*/React.createElement("svg", _extends$5({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 384 512"
}, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
  d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm-40 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
})));

var _path$2;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
const SvgEyeSolid = props => /*#__PURE__*/React.createElement("svg", _extends$4({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 576 512"
}, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
  d: "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32M144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0m144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3"
})));

function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
const SvgFilePdf = props => /*#__PURE__*/React.createElement("svg", _extends$3({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  "aria-hidden": "true",
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "none",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "nonzero",
    opacity: 1
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.58 54.882v31.965A3.153 3.153 0 0 0 14.733 90h60.534a3.153 3.153 0 0 0 3.153-3.153V54.882c-22.347-7.001-44.628-7.044-66.84 0",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#b83535",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.42 54.882V18.345C69.386 13.658 63.133 7.61 60.075 0H14.733a3.153 3.153 0 0 0-3.153 3.153v51.729z",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#e9e9e0",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.42 18.345H62.948a2.873 2.873 0 0 1-2.873-2.873V0z",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#d9d7ca",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.116 62.679h-5.944a1.5 1.5 0 0 0-1.5 1.5v16.602a1.5 1.5 0 1 0 3 0v-5.248h4.444a4.343 4.343 0 0 0 4.338-4.338v-4.177a4.343 4.343 0 0 0-4.338-4.339m1.338 8.515c0 .737-.6 1.338-1.338 1.338h-4.444v-6.854h4.444a1.34 1.34 0 0 1 1.338 1.339zM46.109 82.28h-5.652a1.5 1.5 0 0 1-1.5-1.5V64.179a1.5 1.5 0 0 1 1.5-1.5h5.652a4.635 4.635 0 0 1 4.63 4.63V77.65a4.635 4.635 0 0 1-4.63 4.63m-4.152-3h4.152c.898 0 1.63-.731 1.63-1.63V67.309c0-.898-.731-1.63-1.63-1.63h-4.152zM63.828 62.679h-8.782a1.5 1.5 0 0 0-1.5 1.5V80.78a1.5 1.5 0 0 0 3 0v-6.801h4.251a1.5 1.5 0 0 0 0-3h-4.251v-5.301h7.282a1.5 1.5 0 0 0 0-2.999",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#f9f9f9",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
})));

var DateFormat;
(function (DateFormat) {
    DateFormat["deDE"] = "dd.MM.yyyy";
})(DateFormat || (DateFormat = {}));
var StyledButton$1 = styled(Button$1)(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  padding: 11px 16px 10px !important;\n  background: transparent !important; // important ist OEV Fix\n  color: var(--primary) !important; // important ist OEV Fix\n  &:focus-visible,\n  &:focus {\n    border-color: var(--primary) !important;\n  }\n  &:active {\n    box-shadow: none !important;\n  }\n  svg {\n    width: 25px;\n    height: 25px;\n  }\n"], ["\n  padding: 11px 16px 10px !important;\n  background: transparent !important; // important ist OEV Fix\n  color: var(--primary) !important; // important ist OEV Fix\n  &:focus-visible,\n  &:focus {\n    border-color: var(--primary) !important;\n  }\n  &:active {\n    box-shadow: none !important;\n  }\n  svg {\n    width: 25px;\n    height: 25px;\n  }\n"])));
var StyledDatepickerDialog = styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n    background: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12);\n    z-index: 5;\n    .datepicker-dialog {\n        &-arrow,\n        &-arrow::before {\n            position: absolute;\n            width: 15px;\n            height: 15px;\n            background: inherit;\n        }\n        &-arrow {\n            visibility: hidden;\n        }\n        &-arrow::before {\n            visibility: visible;\n            content: '';\n            transform: rotate(45deg);\n            border: 1px solid #ccc;\n        }\n    }\n    &[data-popper-placement^='top'] > .datepicker-dialog-arrow {\n        bottom: -9px;\n        &::before {\n            border-width: 0 1px 1px 0;\n        }\n    }\n    &[data-popper-placement^='bottom'] > .datepicker-dialog-arrow {\n        top: -9px;\n\n        &::before {\n            border-width: 1px 0 0 1px;\n        }\n    }\n    &[data-popper-placement^='left'] > .datepicker-dialog-arrow {\n        right: -9px;\n        &::before {\n            border-width: 1px 1px 0 0;\n        }\n    }\n    &[data-popper-placement^='right'] > .datepicker-dialog-arrow {\n        left: -9px;\n        &::before {\n            border-width: 0 0 1px 1px;\n        }\n    }\n  \n  .rdp {\n    &-root {\n      --rdp-font-family: 'Sparkasse Web', Arial, sans-serif;\n      --rdp-accent-color: var(--primary);\n      --rdp-today-color: var(--primary);\n      --rdp-outline-selected: none;\n      --rdp-dropdown-gap: 1rem;\n      --rdp-weekday-opacity: 1;\n      --rdp-day-width: 2.5rem;\n      --rdp-day-height: 2.5rem;\n      --rdp-selected-font: inherit;\n      --rdp-nav_button-width: 2rem;\n      --rdp-nav_button-height: 2rem;\n    }\n    &-nav {\n      right: 10px;\n    }\n    &-month_caption {\n      border-bottom: 1px solid #ccc;\n    }\n    &-dropdowns {\n      margin-left: 20px;\n    }\n    &-caption_label{\n      color: var(--label-color);\n      font-size: 1.25rem;\n      font-weight:400;\n    }\n    &-dropdown {\n      height: auto; // OEF FIX\n      font-size: 1rem;\n      &:hover {\n        cursor: pointer;\n      }\n    }\n    &-dropdown_icon {\n      height: .5rem;\n      width: .5rem;\n    }\n    &-button_previous,\n    &-button_next{\n      border-radius: 50%;\n      border: 1px solid transparent;\n      &:focus {\n        border-color: var(--primary);\n        box-shadow: 0 0 0 0.2rem var(--primary-focus);\n      }\n    }\n    &-month_grid {\n      border: none;\n      margin: 0 10px 5px;\n      thead {\n        background-color: transparent; // OEV FIX\n      }\n    }\n    &-weekday {\n      font-size: 1rem;\n      font-weight: 400;\n    }\n    &-week {\n      background: transparent; // OEV FIX\n    }\n    &-day {\n        padding: 0;  // OEV FIX\n      &_button {\n        transition: none;\n        &:hover:not([disabled]):not(.rdp-day_selected),\n        &:active:not([disabled]):not(.rdp-day_selected){\n          background-color: var(--primary-focus);\n          color: #222 !important;\n          font-weight: bolder !important;\n          box-shadow: none !important; // OEV FIX\n        }\n      }\n      &:not(.rdp-today):not(.rdp-selected) .rdp-day_button:not([disabled]) {\n        color: var(--body-font-color);\n      }\n    }\n    &-focused .rdp-day_button {\n      border: 1px solid var(--primary);\n    }\n    &-selected .rdp-day_button {\n      background-color: var(--primary);\n      color: #fff;\n    }\n    &-today:not(.rdp-selected) {\n      .rdp-day_button {\n        font-weight: bolder !important;\n        text-decoration: underline;\n      }\n    }\n}\n"], ["\n    background: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12);\n    z-index: 5;\n    .datepicker-dialog {\n        &-arrow,\n        &-arrow::before {\n            position: absolute;\n            width: 15px;\n            height: 15px;\n            background: inherit;\n        }\n        &-arrow {\n            visibility: hidden;\n        }\n        &-arrow::before {\n            visibility: visible;\n            content: '';\n            transform: rotate(45deg);\n            border: 1px solid #ccc;\n        }\n    }\n    &[data-popper-placement^='top'] > .datepicker-dialog-arrow {\n        bottom: -9px;\n        &::before {\n            border-width: 0 1px 1px 0;\n        }\n    }\n    &[data-popper-placement^='bottom'] > .datepicker-dialog-arrow {\n        top: -9px;\n\n        &::before {\n            border-width: 1px 0 0 1px;\n        }\n    }\n    &[data-popper-placement^='left'] > .datepicker-dialog-arrow {\n        right: -9px;\n        &::before {\n            border-width: 1px 1px 0 0;\n        }\n    }\n    &[data-popper-placement^='right'] > .datepicker-dialog-arrow {\n        left: -9px;\n        &::before {\n            border-width: 0 0 1px 1px;\n        }\n    }\n  \n  .rdp {\n    &-root {\n      --rdp-font-family: 'Sparkasse Web', Arial, sans-serif;\n      --rdp-accent-color: var(--primary);\n      --rdp-today-color: var(--primary);\n      --rdp-outline-selected: none;\n      --rdp-dropdown-gap: 1rem;\n      --rdp-weekday-opacity: 1;\n      --rdp-day-width: 2.5rem;\n      --rdp-day-height: 2.5rem;\n      --rdp-selected-font: inherit;\n      --rdp-nav_button-width: 2rem;\n      --rdp-nav_button-height: 2rem;\n    }\n    &-nav {\n      right: 10px;\n    }\n    &-month_caption {\n      border-bottom: 1px solid #ccc;\n    }\n    &-dropdowns {\n      margin-left: 20px;\n    }\n    &-caption_label{\n      color: var(--label-color);\n      font-size: 1.25rem;\n      font-weight:400;\n    }\n    &-dropdown {\n      height: auto; // OEF FIX\n      font-size: 1rem;\n      &:hover {\n        cursor: pointer;\n      }\n    }\n    &-dropdown_icon {\n      height: .5rem;\n      width: .5rem;\n    }\n    &-button_previous,\n    &-button_next{\n      border-radius: 50%;\n      border: 1px solid transparent;\n      &:focus {\n        border-color: var(--primary);\n        box-shadow: 0 0 0 0.2rem var(--primary-focus);\n      }\n    }\n    &-month_grid {\n      border: none;\n      margin: 0 10px 5px;\n      thead {\n        background-color: transparent; // OEV FIX\n      }\n    }\n    &-weekday {\n      font-size: 1rem;\n      font-weight: 400;\n    }\n    &-week {\n      background: transparent; // OEV FIX\n    }\n    &-day {\n        padding: 0;  // OEV FIX\n      &_button {\n        transition: none;\n        &:hover:not([disabled]):not(.rdp-day_selected),\n        &:active:not([disabled]):not(.rdp-day_selected){\n          background-color: var(--primary-focus);\n          color: #222 !important;\n          font-weight: bolder !important;\n          box-shadow: none !important; // OEV FIX\n        }\n      }\n      &:not(.rdp-today):not(.rdp-selected) .rdp-day_button:not([disabled]) {\n        color: var(--body-font-color);\n      }\n    }\n    &-focused .rdp-day_button {\n      border: 1px solid var(--primary);\n    }\n    &-selected .rdp-day_button {\n      background-color: var(--primary);\n      color: #fff;\n    }\n    &-today:not(.rdp-selected) {\n      .rdp-day_button {\n        font-weight: bolder !important;\n        text-decoration: underline;\n      }\n    }\n}\n"])));
var DatePicker = function (_a) {
    var _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.name, name = _d === void 0 ? '' : _d, _e = _a.from, from = _e === void 0 ? 0 : _e, _f = _a.to, to = _f === void 0 ? 5 : _f, _g = _a.ueberschreibbar, ueberschreibbar = _g === void 0 ? true : _g, _h = _a.disabled, disabled = _h === void 0 ? false : _h;
    var _j = useState(), selected = _j[0], setSelected = _j[1];
    var _k = useState(false), isPopperOpen = _k[0], setIsPopperOpen = _k[1];
    var divRef = useRef(null);
    var buttonRef = useRef(null);
    var _l = useState(null), popperElement = _l[0], setPopperElement = _l[1];
    var currentYear = new Date().getFullYear();
    var fromYear = new Date(currentYear - from, 0);
    var toYear = new Date(currentYear + to, 11);
    var popper = usePopper(divRef.current, popperElement, {
        placement: 'auto',
    });
    var closePopper = function () {
        var _a;
        setIsPopperOpen(false);
        (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var handleButtonClick = function () {
        var date = parse$1(value, DateFormat.deDE, new Date());
        if (isValid(date)) {
            setSelected(date);
        }
        else {
            setSelected(undefined);
        }
        setIsPopperOpen(true);
    };
    var handleDaySelect = function (date) {
        setSelected(date);
        if (date instanceof Date) {
            onChange(name, format$1(date, DateFormat.deDE));
        }
        else {
            onChange(name, date);
        }
        closePopper();
    };
    return (jsxs(Fragment, { children: [jsx$1("div", { ref: divRef, children: jsx$1(StyledButton$1, { ref: buttonRef, variant: "outline", className: "datepicker__icon", onClick: handleButtonClick, disabled: !ueberschreibbar, type: "button", "aria-label": "Datum im Kalender ausw\u00E4hlen", title: "Datum im Kalender ausw\u00E4hlen", children: jsx$1(SvgCalendar, { "aria-hidden": "true" }) }) }), isPopperOpen && (jsx$1(FocusTrap, { active: true, focusTrapOptions: {
                    initialFocus: false,
                    allowOutsideClick: true,
                    clickOutsideDeactivates: true,
                    onDeactivate: closePopper,
                }, children: jsxs(StyledDatepickerDialog, __assign$1({ tabIndex: -1, style: popper.styles.popper, className: "datepicker-dialog" }, popper.attributes.popper, { ref: setPopperElement, role: "dialog", children: [jsx$1(DayPicker, { mode: "single", defaultMonth: selected, selected: selected, onSelect: handleDaySelect, captionLayout: "dropdown", locale: de, startMonth: new Date(fromYear.getFullYear(), 0), endMonth: new Date(toYear.getFullYear(), 11), weekStartsOn: 1, disabled: disabled, labels: {
                                labelDayButton: function (date, _a) {
                                    var today = _a.today, selected = _a.selected;
                                    var label = format$1(date, 'PPPP', { locale: de });
                                    if (today)
                                        label = "Heute, ".concat(label);
                                    if (selected)
                                        label = "Ausgew\u00E4hlt, ".concat(label);
                                    return label;
                                },
                                labelMonthDropdown: function () { return 'Monat auswählen'; },
                                labelYearDropdown: function () { return 'Jahr auswählen'; },
                                labelPrevious: function () { return 'Zum vorherigen Monat'; },
                                labelNext: function () { return 'Zum nächsten Monat'; },
                            } }), jsx$1("div", { className: "datepicker-dialog-arrow", "data-popper-arrow": true, style: popper.styles.arrow })] })) }))] }));
};
var templateObject_1$x, templateObject_2$e;

function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
      _defineProperty$3(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _arrayWithoutHoles$2(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$2(r);
}

function _iterableToArray$2(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$2(r) {
  return _arrayWithoutHoles$2(r) || _iterableToArray$2(r) || _unsupportedIterableToArray$2(r) || _nonIterableSpread$2();
}

function useEvent(callback) {
  var fnRef = React.useRef();
  fnRef.current = callback;
  var memoFn = React.useCallback(function () {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useInternalLayoutEffect = process.env.NODE_ENV !== 'test' && canUseDom() ? React.useLayoutEffect : React.useEffect;
var useLayoutEffect = function useLayoutEffect(callback, deps) {
  var firstMountRef = React.useRef(true);
  useInternalLayoutEffect(function () {
    return callback(firstMountRef.current);
  }, deps);

  // We tell react that first mount has passed
  useInternalLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  useLayoutEffect(function (firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};

/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */
function useSafeState(defaultValue) {
  var destroyRef = React.useRef(false);
  var _React$useState = React.useState(defaultValue),
    _React$useState2 = _slicedToArray$2(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  React.useEffect(function () {
    destroyRef.current = false;
    return function () {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

/** We only think `undefined` is empty */
function hasValue(value) {
  return value !== undefined;
}

/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */
function useMergedState(defaultStateValue, option) {
  var _ref = option || {},
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    postState = _ref.postState;

  // ======================= Init =======================
  var _useState = useSafeState(function () {
      if (hasValue(value)) {
        return value;
      } else if (hasValue(defaultValue)) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
      }
    }),
    _useState2 = _slicedToArray$2(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var mergedValue = value !== undefined ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;

  // ====================== Change ======================
  var onChangeFn = useEvent(onChange);
  var _useState3 = useSafeState([mergedValue]),
    _useState4 = _slicedToArray$2(_useState3, 2),
    prevValue = _useState4[0],
    setPrevValue = _useState4[1];
  useLayoutUpdateEffect(function () {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);

  // Sync value back to `undefined` when it from control to un-control
  useLayoutUpdateEffect(function () {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);

  // ====================== Update ======================
  var triggerChange = useEvent(function (updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

/* eslint-disable no-console */
var warned = {};
var preWarningFns = [];

/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */
var preMessage = function preMessage(fn) {
  preWarningFns.push(fn);
};

/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */
function warning$1(valid, message) {
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'warning');
    }, message);
    if (finalMessage) {
      console.error("Warning: ".concat(finalMessage));
    }
  }
}

/** @see Similar to {@link warning} */
function note(valid, message) {
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'note');
    }, message);
    if (finalMessage) {
      console.warn("Note: ".concat(finalMessage));
    }
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

/** @see Same as {@link warning}, but only warn once for the same message */
function warningOnce(valid, message) {
  call(warning$1, valid, message);
}

/** @see Same as {@link warning}, but only warn once for the same message */
function noteOnce(valid, message) {
  call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;

/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */
function isEqual$1(obj1, obj2) {
  var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
  var refSet = new Set();
  function deepEqual(a, b) {
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var circular = refSet.has(a);
    warningOnce(!circular, 'Warning: There may be circular references');
    if (circular) {
      return false;
    }
    if (a === b) {
      return true;
    }
    if (shallow && level > 1) {
      return false;
    }
    refSet.add(a);
    var newLevel = level + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(b) || a.length !== b.length) {
        return false;
      }
      for (var i = 0; i < a.length; i++) {
        if (!deepEqual(a[i], b[i], newLevel)) {
          return false;
        }
      }
      return true;
    }
    if (a && b && _typeof(a) === 'object' && _typeof(b) === 'object') {
      var keys = Object.keys(a);
      if (keys.length !== Object.keys(b).length) {
        return false;
      }
      return keys.every(function (key) {
        return deepEqual(a[key], b[key], newLevel);
      });
    }
    // other
    return false;
  }
  return deepEqual(obj1, obj2);
}

function getOffset(value, min, max) {
  return (value - min) / (max - min);
}
function getDirectionStyle(direction, value, min, max) {
  var offset = getOffset(value, min, max);
  var positionStyle = {};
  switch (direction) {
    case 'rtl':
      positionStyle.right = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateX(50%)';
      break;
    case 'btt':
      positionStyle.bottom = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateY(50%)';
      break;
    case 'ttb':
      positionStyle.top = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateY(-50%)';
      break;
    default:
      positionStyle.left = "".concat(offset * 100, "%");
      positionStyle.transform = 'translateX(-50%)';
      break;
  }
  return positionStyle;
}

/** Return index value if is list or return value directly */
function getIndex(value, index) {
  return Array.isArray(value) ? value[index] : value;
}

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey ||
    // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }

    // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }

    // Safari sends zero key code for non-latin characters.
    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};

var SliderContext = /*#__PURE__*/React.createContext({
  min: 0,
  max: 0,
  direction: 'ltr',
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: true,
  styles: {},
  classNames: {}
});
/** @private NOT PROMISE AVAILABLE. DO NOT USE IN PRODUCTION. */
var UnstableContext = /*#__PURE__*/React.createContext({});

var _excluded$7 = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"];
var Handle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    value = props.value,
    valueIndex = props.valueIndex,
    onStartMove = props.onStartMove,
    onDelete = props.onDelete,
    style = props.style,
    render = props.render,
    dragging = props.dragging,
    draggingDelete = props.draggingDelete,
    onOffsetChange = props.onOffsetChange,
    onChangeComplete = props.onChangeComplete,
    onFocus = props.onFocus,
    onMouseEnter = props.onMouseEnter,
    restProps = _objectWithoutProperties$1(props, _excluded$7);
  var _React$useContext = React.useContext(SliderContext),
    min = _React$useContext.min,
    max = _React$useContext.max,
    direction = _React$useContext.direction,
    disabled = _React$useContext.disabled,
    keyboard = _React$useContext.keyboard,
    range = _React$useContext.range,
    tabIndex = _React$useContext.tabIndex,
    ariaLabelForHandle = _React$useContext.ariaLabelForHandle,
    ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle,
    ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle,
    styles = _React$useContext.styles,
    classNames = _React$useContext.classNames;
  var handlePrefixCls = "".concat(prefixCls, "-handle");

  // ============================ Events ============================
  var onInternalStartMove = function onInternalStartMove(e) {
    if (!disabled) {
      onStartMove(e, valueIndex);
    }
  };
  var onInternalFocus = function onInternalFocus(e) {
    onFocus === null || onFocus === void 0 || onFocus(e, valueIndex);
  };
  var onInternalMouseEnter = function onInternalMouseEnter(e) {
    onMouseEnter(e, valueIndex);
  };

  // =========================== Keyboard ===========================
  var onKeyDown = function onKeyDown(e) {
    if (!disabled && keyboard) {
      var offset = null;

      // Change the value
      switch (e.which || e.keyCode) {
        case KeyCode.LEFT:
          offset = direction === 'ltr' || direction === 'btt' ? -1 : 1;
          break;
        case KeyCode.RIGHT:
          offset = direction === 'ltr' || direction === 'btt' ? 1 : -1;
          break;

        // Up is plus
        case KeyCode.UP:
          offset = direction !== 'ttb' ? 1 : -1;
          break;

        // Down is minus
        case KeyCode.DOWN:
          offset = direction !== 'ttb' ? -1 : 1;
          break;
        case KeyCode.HOME:
          offset = 'min';
          break;
        case KeyCode.END:
          offset = 'max';
          break;
        case KeyCode.PAGE_UP:
          offset = 2;
          break;
        case KeyCode.PAGE_DOWN:
          offset = -2;
          break;
        case KeyCode.BACKSPACE:
        case KeyCode.DELETE:
          onDelete(valueIndex);
          break;
      }
      if (offset !== null) {
        e.preventDefault();
        onOffsetChange(offset, valueIndex);
      }
    }
  };
  var handleKeyUp = function handleKeyUp(e) {
    switch (e.which || e.keyCode) {
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
      case KeyCode.UP:
      case KeyCode.DOWN:
      case KeyCode.HOME:
      case KeyCode.END:
      case KeyCode.PAGE_UP:
      case KeyCode.PAGE_DOWN:
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete();
        break;
    }
  };

  // ============================ Offset ============================
  var positionStyle = getDirectionStyle(direction, value, min, max);

  // ============================ Render ============================
  var divProps = {};
  if (valueIndex !== null) {
    var _getIndex;
    divProps = {
      tabIndex: disabled ? null : getIndex(tabIndex, valueIndex),
      role: 'slider',
      'aria-valuemin': min,
      'aria-valuemax': max,
      'aria-valuenow': value,
      'aria-disabled': disabled,
      'aria-label': getIndex(ariaLabelForHandle, valueIndex),
      'aria-labelledby': getIndex(ariaLabelledByForHandle, valueIndex),
      'aria-valuetext': (_getIndex = getIndex(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value),
      'aria-orientation': direction === 'ltr' || direction === 'rtl' ? 'horizontal' : 'vertical',
      onMouseDown: onInternalStartMove,
      onTouchStart: onInternalStartMove,
      onFocus: onInternalFocus,
      onMouseEnter: onInternalMouseEnter,
      onKeyDown: onKeyDown,
      onKeyUp: handleKeyUp
    };
  }
  var handleNode = /*#__PURE__*/React.createElement("div", _extends$G({
    ref: ref,
    className: cls(handlePrefixCls, _defineProperty$3(_defineProperty$3(_defineProperty$3({}, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), valueIndex !== null && range), "".concat(handlePrefixCls, "-dragging"), dragging), "".concat(handlePrefixCls, "-dragging-delete"), draggingDelete), classNames.handle),
    style: _objectSpread2(_objectSpread2(_objectSpread2({}, positionStyle), style), styles.handle)
  }, divProps, restProps));

  // Customize
  if (render) {
    handleNode = render(handleNode, {
      index: valueIndex,
      prefixCls: prefixCls,
      value: value,
      dragging: dragging,
      draggingDelete: draggingDelete
    });
  }
  return handleNode;
});
if (process.env.NODE_ENV !== 'production') {
  Handle.displayName = 'Handle';
}

var _excluded$6 = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"];
var Handles = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    style = props.style,
    onStartMove = props.onStartMove,
    onOffsetChange = props.onOffsetChange,
    values = props.values,
    handleRender = props.handleRender,
    activeHandleRender = props.activeHandleRender,
    draggingIndex = props.draggingIndex,
    draggingDelete = props.draggingDelete,
    onFocus = props.onFocus,
    restProps = _objectWithoutProperties$1(props, _excluded$6);
  var handlesRef = React.useRef({});

  // =========================== Active ===========================
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray$2(_React$useState, 2),
    activeVisible = _React$useState2[0],
    setActiveVisible = _React$useState2[1];
  var _React$useState3 = React.useState(-1),
    _React$useState4 = _slicedToArray$2(_React$useState3, 2),
    activeIndex = _React$useState4[0],
    setActiveIndex = _React$useState4[1];
  var onActive = function onActive(index) {
    setActiveIndex(index);
    setActiveVisible(true);
  };
  var onHandleFocus = function onHandleFocus(e, index) {
    onActive(index);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  var onHandleMouseEnter = function onHandleMouseEnter(e, index) {
    onActive(index);
  };

  // =========================== Render ===========================
  React.useImperativeHandle(ref, function () {
    return {
      focus: function focus(index) {
        var _handlesRef$current$i;
        (_handlesRef$current$i = handlesRef.current[index]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
      },
      hideHelp: function hideHelp() {
        flushSync(function () {
          setActiveVisible(false);
        });
      }
    };
  });

  // =========================== Render ===========================
  // Handle Props
  var handleProps = _objectSpread2({
    prefixCls: prefixCls,
    onStartMove: onStartMove,
    onOffsetChange: onOffsetChange,
    render: handleRender,
    onFocus: onHandleFocus,
    onMouseEnter: onHandleMouseEnter
  }, restProps);
  return /*#__PURE__*/React.createElement(React.Fragment, null, values.map(function (value, index) {
    var dragging = draggingIndex === index;
    return /*#__PURE__*/React.createElement(Handle, _extends$G({
      ref: function ref(node) {
        if (!node) {
          delete handlesRef.current[index];
        } else {
          handlesRef.current[index] = node;
        }
      },
      dragging: dragging,
      draggingDelete: dragging && draggingDelete,
      style: getIndex(style, index),
      key: index,
      value: value,
      valueIndex: index
    }, handleProps));
  }), activeHandleRender && activeVisible && /*#__PURE__*/React.createElement(Handle, _extends$G({
    key: "a11y"
  }, handleProps, {
    value: values[activeIndex],
    valueIndex: null,
    dragging: draggingIndex !== -1,
    draggingDelete: draggingDelete,
    render: activeHandleRender,
    style: {
      pointerEvents: 'none'
    },
    tabIndex: null,
    "aria-hidden": true
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Handles.displayName = 'Handles';
}

var Mark = function Mark(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    children = props.children,
    value = props.value,
    _onClick = props.onClick;
  var _React$useContext = React.useContext(SliderContext),
    min = _React$useContext.min,
    max = _React$useContext.max,
    direction = _React$useContext.direction,
    includedStart = _React$useContext.includedStart,
    includedEnd = _React$useContext.includedEnd,
    included = _React$useContext.included;
  var textCls = "".concat(prefixCls, "-text");

  // ============================ Offset ============================
  var positionStyle = getDirectionStyle(direction, value, min, max);
  return /*#__PURE__*/React.createElement("span", {
    className: cls(textCls, _defineProperty$3({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
    style: _objectSpread2(_objectSpread2({}, positionStyle), style),
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
    },
    onClick: function onClick() {
      _onClick(value);
    }
  }, children);
};

var Marks = function Marks(props) {
  var prefixCls = props.prefixCls,
    marks = props.marks,
    onClick = props.onClick;
  var markPrefixCls = "".concat(prefixCls, "-mark");

  // Not render mark if empty
  if (!marks.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: markPrefixCls
  }, marks.map(function (_ref) {
    var value = _ref.value,
      style = _ref.style,
      label = _ref.label;
    return /*#__PURE__*/React.createElement(Mark, {
      key: value,
      prefixCls: markPrefixCls,
      style: style,
      value: value,
      onClick: onClick
    }, label);
  }));
};

var Dot = function Dot(props) {
  var prefixCls = props.prefixCls,
    value = props.value,
    style = props.style,
    activeStyle = props.activeStyle;
  var _React$useContext = React.useContext(SliderContext),
    min = _React$useContext.min,
    max = _React$useContext.max,
    direction = _React$useContext.direction,
    included = _React$useContext.included,
    includedStart = _React$useContext.includedStart,
    includedEnd = _React$useContext.includedEnd;
  var dotClassName = "".concat(prefixCls, "-dot");
  var active = included && includedStart <= value && value <= includedEnd;

  // ============================ Offset ============================
  var mergedStyle = _objectSpread2(_objectSpread2({}, getDirectionStyle(direction, value, min, max)), typeof style === 'function' ? style(value) : style);
  if (active) {
    mergedStyle = _objectSpread2(_objectSpread2({}, mergedStyle), typeof activeStyle === 'function' ? activeStyle(value) : activeStyle);
  }
  return /*#__PURE__*/React.createElement("span", {
    className: cls(dotClassName, _defineProperty$3({}, "".concat(dotClassName, "-active"), active)),
    style: mergedStyle
  });
};

var Steps = function Steps(props) {
  var prefixCls = props.prefixCls,
    marks = props.marks,
    dots = props.dots,
    style = props.style,
    activeStyle = props.activeStyle;
  var _React$useContext = React.useContext(SliderContext),
    min = _React$useContext.min,
    max = _React$useContext.max,
    step = _React$useContext.step;
  var stepDots = React.useMemo(function () {
    var dotSet = new Set();

    // Add marks
    marks.forEach(function (mark) {
      dotSet.add(mark.value);
    });

    // Fill dots
    if (dots && step !== null) {
      var current = min;
      while (current <= max) {
        dotSet.add(current);
        current += step;
      }
    }
    return Array.from(dotSet);
  }, [min, max, step, dots, marks]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-step")
  }, stepDots.map(function (dotValue) {
    return /*#__PURE__*/React.createElement(Dot, {
      prefixCls: prefixCls,
      key: dotValue,
      value: dotValue,
      style: style,
      activeStyle: activeStyle
    });
  }));
};

var Track = function Track(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    start = props.start,
    end = props.end,
    index = props.index,
    onStartMove = props.onStartMove,
    replaceCls = props.replaceCls;
  var _React$useContext = React.useContext(SliderContext),
    direction = _React$useContext.direction,
    min = _React$useContext.min,
    max = _React$useContext.max,
    disabled = _React$useContext.disabled,
    range = _React$useContext.range,
    classNames = _React$useContext.classNames;
  var trackPrefixCls = "".concat(prefixCls, "-track");
  var offsetStart = getOffset(start, min, max);
  var offsetEnd = getOffset(end, min, max);

  // ============================ Events ============================
  var onInternalStartMove = function onInternalStartMove(e) {
    if (!disabled && onStartMove) {
      onStartMove(e, -1);
    }
  };

  // ============================ Render ============================
  var positionStyle = {};
  switch (direction) {
    case 'rtl':
      positionStyle.right = "".concat(offsetStart * 100, "%");
      positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    case 'btt':
      positionStyle.bottom = "".concat(offsetStart * 100, "%");
      positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    case 'ttb':
      positionStyle.top = "".concat(offsetStart * 100, "%");
      positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    default:
      positionStyle.left = "".concat(offsetStart * 100, "%");
      positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
  }
  var className = replaceCls || cls(trackPrefixCls, _defineProperty$3(_defineProperty$3({}, "".concat(trackPrefixCls, "-").concat(index + 1), index !== null && range), "".concat(prefixCls, "-track-draggable"), onStartMove), classNames.track);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: _objectSpread2(_objectSpread2({}, positionStyle), style),
    onMouseDown: onInternalStartMove,
    onTouchStart: onInternalStartMove
  });
};

var Tracks = function Tracks(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    values = props.values,
    startPoint = props.startPoint,
    onStartMove = props.onStartMove;
  var _React$useContext = React.useContext(SliderContext),
    included = _React$useContext.included,
    range = _React$useContext.range,
    min = _React$useContext.min,
    styles = _React$useContext.styles,
    classNames = _React$useContext.classNames;

  // =========================== List ===========================
  var trackList = React.useMemo(function () {
    if (!range) {
      // null value do not have track
      if (values.length === 0) {
        return [];
      }
      var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
      var endValue = values[0];
      return [{
        start: Math.min(startValue, endValue),
        end: Math.max(startValue, endValue)
      }];
    }

    // Multiple
    var list = [];
    for (var i = 0; i < values.length - 1; i += 1) {
      list.push({
        start: values[i],
        end: values[i + 1]
      });
    }
    return list;
  }, [values, range, startPoint, min]);
  if (!included) {
    return null;
  }

  // ========================== Render ==========================
  var tracksNode = classNames.tracks || styles.tracks ? /*#__PURE__*/React.createElement(Track, {
    index: null,
    prefixCls: prefixCls,
    start: trackList[0].start,
    end: trackList[trackList.length - 1].end,
    replaceCls: cls(classNames.tracks, "".concat(prefixCls, "-tracks")),
    style: styles.tracks
  }) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, tracksNode, trackList.map(function (_ref, index) {
    var start = _ref.start,
      end = _ref.end;
    return /*#__PURE__*/React.createElement(Track, {
      index: index,
      prefixCls: prefixCls,
      style: _objectSpread2(_objectSpread2({}, getIndex(style, index)), styles.track),
      start: start,
      end: end,
      key: index,
      onStartMove: onStartMove
    });
  }));
};

/** Drag to delete offset. It's a user experience number for dragging out */
var REMOVE_DIST = 130;
function getPosition(e) {
  var obj = 'targetTouches' in e ? e.targetTouches[0] : e;
  return {
    pageX: obj.pageX,
    pageY: obj.pageY
  };
}
function useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues, editable, minCount) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray$2(_React$useState, 2),
    draggingValue = _React$useState2[0],
    setDraggingValue = _React$useState2[1];
  var _React$useState3 = React.useState(-1),
    _React$useState4 = _slicedToArray$2(_React$useState3, 2),
    draggingIndex = _React$useState4[0],
    setDraggingIndex = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray$2(_React$useState5, 2),
    draggingDelete = _React$useState6[0],
    setDraggingDelete = _React$useState6[1];
  var _React$useState7 = React.useState(rawValues),
    _React$useState8 = _slicedToArray$2(_React$useState7, 2),
    cacheValues = _React$useState8[0],
    setCacheValues = _React$useState8[1];
  var _React$useState9 = React.useState(rawValues),
    _React$useState10 = _slicedToArray$2(_React$useState9, 2),
    originValues = _React$useState10[0],
    setOriginValues = _React$useState10[1];
  var mouseMoveEventRef = React.useRef(null);
  var mouseUpEventRef = React.useRef(null);
  var touchEventTargetRef = React.useRef(null);
  var _React$useContext = React.useContext(UnstableContext),
    onDragStart = _React$useContext.onDragStart,
    onDragChange = _React$useContext.onDragChange;
  useLayoutEffect(function () {
    if (draggingIndex === -1) {
      setCacheValues(rawValues);
    }
  }, [rawValues, draggingIndex]);

  // Clean up event
  React.useEffect(function () {
    return function () {
      document.removeEventListener('mousemove', mouseMoveEventRef.current);
      document.removeEventListener('mouseup', mouseUpEventRef.current);
      if (touchEventTargetRef.current) {
        touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
        touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
      }
    };
  }, []);
  var flushValues = function flushValues(nextValues, nextValue, deleteMark) {
    // Perf: Only update state when value changed
    if (nextValue !== undefined) {
      setDraggingValue(nextValue);
    }
    setCacheValues(nextValues);
    var changeValues = nextValues;
    if (deleteMark) {
      changeValues = nextValues.filter(function (_, i) {
        return i !== draggingIndex;
      });
    }
    triggerChange(changeValues);
    if (onDragChange) {
      onDragChange({
        rawValues: nextValues,
        deleteIndex: deleteMark ? draggingIndex : -1,
        draggingIndex: draggingIndex,
        draggingValue: nextValue
      });
    }
  };
  var updateCacheValue = useEvent(function (valueIndex, offsetPercent, deleteMark) {
    if (valueIndex === -1) {
      // >>>> Dragging on the track
      var startValue = originValues[0];
      var endValue = originValues[originValues.length - 1];
      var maxStartOffset = min - startValue;
      var maxEndOffset = max - endValue;

      // Get valid offset
      var offset = offsetPercent * (max - min);
      offset = Math.max(offset, maxStartOffset);
      offset = Math.min(offset, maxEndOffset);

      // Use first value to revert back of valid offset (like steps marks)
      var formatStartValue = formatValue(startValue + offset);
      offset = formatStartValue - startValue;
      var cloneCacheValues = originValues.map(function (val) {
        return val + offset;
      });
      flushValues(cloneCacheValues);
    } else {
      // >>>> Dragging on the handle
      var offsetDist = (max - min) * offsetPercent;

      // Always start with the valueIndex origin value
      var cloneValues = _toConsumableArray$2(cacheValues);
      cloneValues[valueIndex] = originValues[valueIndex];
      var next = offsetValues(cloneValues, offsetDist, valueIndex, 'dist');
      flushValues(next.values, next.value, deleteMark);
    }
  });
  var onStartMove = function onStartMove(e, valueIndex, startValues) {
    e.stopPropagation();

    // 如果是点击 track 触发的，需要传入变化后的初始值，而不能直接用 rawValues
    var initialValues = startValues || rawValues;
    var originValue = initialValues[valueIndex];
    setDraggingIndex(valueIndex);
    setDraggingValue(originValue);
    setOriginValues(initialValues);
    setCacheValues(initialValues);
    setDraggingDelete(false);
    var _getPosition = getPosition(e),
      startX = _getPosition.pageX,
      startY = _getPosition.pageY;

    // We declare it here since closure can't get outer latest value
    var deleteMark = false;

    // Internal trigger event
    if (onDragStart) {
      onDragStart({
        rawValues: initialValues,
        draggingIndex: valueIndex,
        draggingValue: originValue
      });
    }

    // Moving
    var onMouseMove = function onMouseMove(event) {
      event.preventDefault();
      var _getPosition2 = getPosition(event),
        moveX = _getPosition2.pageX,
        moveY = _getPosition2.pageY;
      var offsetX = moveX - startX;
      var offsetY = moveY - startY;
      var _containerRef$current = containerRef.current.getBoundingClientRect(),
        width = _containerRef$current.width,
        height = _containerRef$current.height;
      var offSetPercent;
      var removeDist;
      switch (direction) {
        case 'btt':
          offSetPercent = -offsetY / height;
          removeDist = offsetX;
          break;
        case 'ttb':
          offSetPercent = offsetY / height;
          removeDist = offsetX;
          break;
        case 'rtl':
          offSetPercent = -offsetX / width;
          removeDist = offsetY;
          break;
        default:
          offSetPercent = offsetX / width;
          removeDist = offsetY;
      }

      // Check if need mark remove
      deleteMark = editable ? Math.abs(removeDist) > REMOVE_DIST && minCount < cacheValues.length : false;
      setDraggingDelete(deleteMark);
      updateCacheValue(valueIndex, offSetPercent, deleteMark);
    };

    // End
    var onMouseUp = function onMouseUp(event) {
      event.preventDefault();
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
      if (touchEventTargetRef.current) {
        touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
        touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
      }
      mouseMoveEventRef.current = null;
      mouseUpEventRef.current = null;
      touchEventTargetRef.current = null;
      finishChange(deleteMark);
      setDraggingIndex(-1);
      setDraggingDelete(false);
    };
    document.addEventListener('mouseup', onMouseUp);
    document.addEventListener('mousemove', onMouseMove);
    e.currentTarget.addEventListener('touchend', onMouseUp);
    e.currentTarget.addEventListener('touchmove', onMouseMove);
    mouseMoveEventRef.current = onMouseMove;
    mouseUpEventRef.current = onMouseUp;
    touchEventTargetRef.current = e.currentTarget;
  };

  // Only return cache value when it mapping with rawValues
  var returnValues = React.useMemo(function () {
    var sourceValues = _toConsumableArray$2(rawValues).sort(function (a, b) {
      return a - b;
    });
    var targetValues = _toConsumableArray$2(cacheValues).sort(function (a, b) {
      return a - b;
    });
    var counts = {};
    targetValues.forEach(function (val) {
      counts[val] = (counts[val] || 0) + 1;
    });
    sourceValues.forEach(function (val) {
      counts[val] = (counts[val] || 0) - 1;
    });
    var maxDiffCount = editable ? 1 : 0;
    var diffCount = Object.values(counts).reduce(function (prev, next) {
      return prev + Math.abs(next);
    }, 0);
    return diffCount <= maxDiffCount ? cacheValues : rawValues;
  }, [rawValues, cacheValues, editable]);
  return [draggingIndex, draggingValue, draggingDelete, returnValues, onStartMove];
}

/** Format the value in the range of [min, max] */

/** Format value align with step */

/** Format value align with step & marks */

function useOffset(min, max, step, markList, allowCross, pushable) {
  var formatRangeValue = React.useCallback(function (val) {
    return Math.max(min, Math.min(max, val));
  }, [min, max]);
  var formatStepValue = React.useCallback(function (val) {
    if (step !== null) {
      var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;

      // Cut number in case to be like 0.30000000000000004
      var getDecimal = function getDecimal(num) {
        return (String(num).split('.')[1] || '').length;
      };
      var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
      var fixedValue = Number(stepValue.toFixed(maxDecimal));
      return min <= fixedValue && fixedValue <= max ? fixedValue : null;
    }
    return null;
  }, [step, min, max, formatRangeValue]);
  var formatValue = React.useCallback(function (val) {
    var formatNextValue = formatRangeValue(val);

    // List align values
    var alignValues = markList.map(function (mark) {
      return mark.value;
    });
    if (step !== null) {
      alignValues.push(formatStepValue(val));
    }

    // min & max
    alignValues.push(min, max);

    // Align with marks
    var closeValue = alignValues[0];
    var closeDist = max - min;
    alignValues.forEach(function (alignValue) {
      var dist = Math.abs(formatNextValue - alignValue);
      if (dist <= closeDist) {
        closeValue = alignValue;
        closeDist = dist;
      }
    });
    return closeValue;
  }, [min, max, markList, step, formatRangeValue, formatStepValue]);

  // ========================== Offset ==========================
  // Single Value
  var offsetValue = function offsetValue(values, offset, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
    if (typeof offset === 'number') {
      var nextValue;
      var originValue = values[valueIndex];

      // Only used for `dist` mode
      var targetDistValue = originValue + offset;

      // Compare next step value & mark value which is best match
      var potentialValues = [];
      markList.forEach(function (mark) {
        potentialValues.push(mark.value);
      });

      // Min & Max
      potentialValues.push(min, max);

      // In case origin value is align with mark but not with step
      potentialValues.push(formatStepValue(originValue));

      // Put offset step value also
      var sign = offset > 0 ? 1 : -1;
      if (mode === 'unit') {
        potentialValues.push(formatStepValue(originValue + sign * step));
      } else {
        potentialValues.push(formatStepValue(targetDistValue));
      }

      // Find close one
      potentialValues = potentialValues.filter(function (val) {
        return val !== null;
      })
      // Remove reverse value
      .filter(function (val) {
        return offset < 0 ? val <= originValue : val >= originValue;
      });
      if (mode === 'unit') {
        // `unit` mode can not contain itself
        potentialValues = potentialValues.filter(function (val) {
          return val !== originValue;
        });
      }
      var compareValue = mode === 'unit' ? originValue : targetDistValue;
      nextValue = potentialValues[0];
      var valueDist = Math.abs(nextValue - compareValue);
      potentialValues.forEach(function (potentialValue) {
        var dist = Math.abs(potentialValue - compareValue);
        if (dist < valueDist) {
          nextValue = potentialValue;
          valueDist = dist;
        }
      });

      // Out of range will back to range
      if (nextValue === undefined) {
        return offset < 0 ? min : max;
      }

      // `dist` mode
      if (mode === 'dist') {
        return nextValue;
      }

      // `unit` mode may need another round
      if (Math.abs(offset) > 1) {
        var cloneValues = _toConsumableArray$2(values);
        cloneValues[valueIndex] = nextValue;
        return offsetValue(cloneValues, offset - sign, valueIndex, mode);
      }
      return nextValue;
    } else if (offset === 'min') {
      return min;
    } else if (offset === 'max') {
      return max;
    }
  };

  /** Same as `offsetValue` but return `changed` mark to tell value changed */
  var offsetChangedValue = function offsetChangedValue(values, offset, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
    var originValue = values[valueIndex];
    var nextValue = offsetValue(values, offset, valueIndex, mode);
    return {
      value: nextValue,
      changed: nextValue !== originValue
    };
  };
  var needPush = function needPush(dist) {
    return pushable === null && dist === 0 || typeof pushable === 'number' && dist < pushable;
  };

  // Values
  var offsetValues = function offsetValues(values, offset, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
    var nextValues = values.map(formatValue);
    var originValue = nextValues[valueIndex];
    var nextValue = offsetValue(nextValues, offset, valueIndex, mode);
    nextValues[valueIndex] = nextValue;
    if (allowCross === false) {
      // >>>>> Allow Cross
      var pushNum = pushable || 0;

      // ============ AllowCross ===============
      if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) {
        nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
      }
      if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) {
        nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
      }
    } else if (typeof pushable === 'number' || pushable === null) {
      // >>>>> Pushable
      // =============== Push ==================

      // >>>>>> Basic push
      // End values
      for (var i = valueIndex + 1; i < nextValues.length; i += 1) {
        var changed = true;
        while (needPush(nextValues[i] - nextValues[i - 1]) && changed) {
          var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
          nextValues[i] = _offsetChangedValue.value;
          changed = _offsetChangedValue.changed;
        }
      }

      // Start values
      for (var _i = valueIndex; _i > 0; _i -= 1) {
        var _changed = true;
        while (needPush(nextValues[_i] - nextValues[_i - 1]) && _changed) {
          var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
          nextValues[_i - 1] = _offsetChangedValue2.value;
          _changed = _offsetChangedValue2.changed;
        }
      }

      // >>>>> Revert back to safe push range
      // End to Start
      for (var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1) {
        var _changed2 = true;
        while (needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2) {
          var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
          nextValues[_i2 - 1] = _offsetChangedValue3.value;
          _changed2 = _offsetChangedValue3.changed;
        }
      }

      // Start to End
      for (var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1) {
        var _changed3 = true;
        while (needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3) {
          var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
          nextValues[_i3 + 1] = _offsetChangedValue4.value;
          _changed3 = _offsetChangedValue4.changed;
        }
      }
    }
    return {
      value: nextValues[valueIndex],
      values: nextValues
    };
  };
  return [formatValue, offsetValues];
}

function useRange(range) {
  return useMemo(function () {
    if (range === true || !range) {
      return [!!range, false, false, 0];
    }
    var editable = range.editable,
      draggableTrack = range.draggableTrack,
      minCount = range.minCount,
      maxCount = range.maxCount;
    if (process.env.NODE_ENV !== 'production') {
      warning$1(!editable || !draggableTrack, '`editable` can not work with `draggableTrack`.');
    }
    return [true, editable, !editable && draggableTrack, minCount || 0, maxCount];
  }, [range]);
}

/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */

var Slider = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-slider' : _props$prefixCls,
    className = props.className,
    style = props.style,
    classNames = props.classNames,
    styles = props.styles,
    id = props.id,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$keyboard = props.keyboard,
    keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
    autoFocus = props.autoFocus,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    _props$max = props.max,
    max = _props$max === void 0 ? 100 : _props$max,
    _props$step = props.step,
    step = _props$step === void 0 ? 1 : _props$step,
    value = props.value,
    defaultValue = props.defaultValue,
    range = props.range,
    count = props.count,
    onChange = props.onChange,
    onBeforeChange = props.onBeforeChange,
    onAfterChange = props.onAfterChange,
    onChangeComplete = props.onChangeComplete,
    _props$allowCross = props.allowCross,
    allowCross = _props$allowCross === void 0 ? true : _props$allowCross,
    _props$pushable = props.pushable,
    pushable = _props$pushable === void 0 ? false : _props$pushable,
    reverse = props.reverse,
    vertical = props.vertical,
    _props$included = props.included,
    included = _props$included === void 0 ? true : _props$included,
    startPoint = props.startPoint,
    trackStyle = props.trackStyle,
    handleStyle = props.handleStyle,
    railStyle = props.railStyle,
    dotStyle = props.dotStyle,
    activeDotStyle = props.activeDotStyle,
    marks = props.marks,
    dots = props.dots,
    handleRender = props.handleRender,
    activeHandleRender = props.activeHandleRender,
    track = props.track,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    ariaLabelForHandle = props.ariaLabelForHandle,
    ariaLabelledByForHandle = props.ariaLabelledByForHandle,
    ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
  var handlesRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var direction = React.useMemo(function () {
    if (vertical) {
      return reverse ? 'ttb' : 'btt';
    }
    return reverse ? 'rtl' : 'ltr';
  }, [reverse, vertical]);

  // ============================ Range =============================
  var _useRange = useRange(range),
    _useRange2 = _slicedToArray$2(_useRange, 5),
    rangeEnabled = _useRange2[0],
    rangeEditable = _useRange2[1],
    rangeDraggableTrack = _useRange2[2],
    minCount = _useRange2[3],
    maxCount = _useRange2[4];
  var mergedMin = React.useMemo(function () {
    return isFinite(min) ? min : 0;
  }, [min]);
  var mergedMax = React.useMemo(function () {
    return isFinite(max) ? max : 100;
  }, [max]);

  // ============================= Step =============================
  var mergedStep = React.useMemo(function () {
    return step !== null && step <= 0 ? 1 : step;
  }, [step]);

  // ============================= Push =============================
  var mergedPush = React.useMemo(function () {
    if (typeof pushable === 'boolean') {
      return pushable ? mergedStep : false;
    }
    return pushable >= 0 ? pushable : false;
  }, [pushable, mergedStep]);

  // ============================ Marks =============================
  var markList = React.useMemo(function () {
    return Object.keys(marks || {}).map(function (key) {
      var mark = marks[key];
      var markObj = {
        value: Number(key)
      };
      if (mark && _typeof(mark) === 'object' && ! /*#__PURE__*/React.isValidElement(mark) && ('label' in mark || 'style' in mark)) {
        markObj.style = mark.style;
        markObj.label = mark.label;
      } else {
        markObj.label = mark;
      }
      return markObj;
    }).filter(function (_ref) {
      var label = _ref.label;
      return label || typeof label === 'number';
    }).sort(function (a, b) {
      return a.value - b.value;
    });
  }, [marks]);

  // ============================ Format ============================
  var _useOffset = useOffset(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush),
    _useOffset2 = _slicedToArray$2(_useOffset, 2),
    formatValue = _useOffset2[0],
    offsetValues = _useOffset2[1];

  // ============================ Values ============================
  var _useMergedState = useMergedState(defaultValue, {
      value: value
    }),
    _useMergedState2 = _slicedToArray$2(_useMergedState, 2),
    mergedValue = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var rawValues = React.useMemo(function () {
    var valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [mergedValue];
    var _valueList = _slicedToArray$2(valueList, 1),
      _valueList$ = _valueList[0],
      val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
    var returnValues = mergedValue === null ? [] : [val0];

    // Format as range
    if (rangeEnabled) {
      returnValues = _toConsumableArray$2(valueList);

      // When count provided or value is `undefined`, we fill values
      if (count || mergedValue === undefined) {
        var pointCount = count >= 0 ? count + 1 : 2;
        returnValues = returnValues.slice(0, pointCount);

        // Fill with count
        while (returnValues.length < pointCount) {
          var _returnValues;
          returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
        }
      }
      returnValues.sort(function (a, b) {
        return a - b;
      });
    }

    // Align in range
    returnValues.forEach(function (val, index) {
      returnValues[index] = formatValue(val);
    });
    return returnValues;
  }, [mergedValue, rangeEnabled, mergedMin, count, formatValue]);

  // =========================== onChange ===========================
  var getTriggerValue = function getTriggerValue(triggerValues) {
    return rangeEnabled ? triggerValues : triggerValues[0];
  };
  var triggerChange = useEvent(function (nextValues) {
    // Order first
    var cloneNextValues = _toConsumableArray$2(nextValues).sort(function (a, b) {
      return a - b;
    });

    // Trigger event if needed
    if (onChange && !isEqual$1(cloneNextValues, rawValues, true)) {
      onChange(getTriggerValue(cloneNextValues));
    }

    // We set this later since it will re-render component immediately
    setValue(cloneNextValues);
  });
  var finishChange = useEvent(function (draggingDelete) {
    // Trigger from `useDrag` will tell if it's a delete action
    if (draggingDelete) {
      handlesRef.current.hideHelp();
    }
    var finishValue = getTriggerValue(rawValues);
    onAfterChange === null || onAfterChange === void 0 || onAfterChange(finishValue);
    warningOnce(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
    onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(finishValue);
  });
  var onDelete = function onDelete(index) {
    if (disabled || !rangeEditable || rawValues.length <= minCount) {
      return;
    }
    var cloneNextValues = _toConsumableArray$2(rawValues);
    cloneNextValues.splice(index, 1);
    onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
    triggerChange(cloneNextValues);
    var nextFocusIndex = Math.max(0, index - 1);
    handlesRef.current.hideHelp();
    handlesRef.current.focus(nextFocusIndex);
  };
  var _useDrag = useDrag(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues, rangeEditable, minCount),
    _useDrag2 = _slicedToArray$2(_useDrag, 5),
    draggingIndex = _useDrag2[0],
    draggingValue = _useDrag2[1],
    draggingDelete = _useDrag2[2],
    cacheValues = _useDrag2[3],
    onStartDrag = _useDrag2[4];

  /**
   * When `rangeEditable` will insert a new value in the values array.
   * Else it will replace the value in the values array.
   */
  var changeToCloseValue = function changeToCloseValue(newValue, e) {
    if (!disabled) {
      // Create new values
      var cloneNextValues = _toConsumableArray$2(rawValues);
      var valueIndex = 0;
      var valueBeforeIndex = 0; // Record the index which value < newValue
      var valueDist = mergedMax - mergedMin;
      rawValues.forEach(function (val, index) {
        var dist = Math.abs(newValue - val);
        if (dist <= valueDist) {
          valueDist = dist;
          valueIndex = index;
        }
        if (val < newValue) {
          valueBeforeIndex = index;
        }
      });
      var focusIndex = valueIndex;
      if (rangeEditable && valueDist !== 0 && (!maxCount || rawValues.length < maxCount)) {
        cloneNextValues.splice(valueBeforeIndex + 1, 0, newValue);
        focusIndex = valueBeforeIndex + 1;
      } else {
        cloneNextValues[valueIndex] = newValue;
      }

      // Fill value to match default 2 (only when `rawValues` is empty)
      if (rangeEnabled && !rawValues.length && count === undefined) {
        cloneNextValues.push(newValue);
      }
      var nextValue = getTriggerValue(cloneNextValues);
      onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(nextValue);
      triggerChange(cloneNextValues);
      if (e) {
        var _document$activeEleme, _document$activeEleme2;
        (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme2 = _document$activeEleme.blur) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.call(_document$activeEleme);
        handlesRef.current.focus(focusIndex);
        onStartDrag(e, focusIndex, cloneNextValues);
      } else {
        // https://github.com/ant-design/ant-design/issues/49997
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(nextValue);
        warningOnce(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(nextValue);
      }
    }
  };

  // ============================ Click =============================
  var onSliderMouseDown = function onSliderMouseDown(e) {
    e.preventDefault();
    var _containerRef$current = containerRef.current.getBoundingClientRect(),
      width = _containerRef$current.width,
      height = _containerRef$current.height,
      left = _containerRef$current.left,
      top = _containerRef$current.top,
      bottom = _containerRef$current.bottom,
      right = _containerRef$current.right;
    var clientX = e.clientX,
      clientY = e.clientY;
    var percent;
    switch (direction) {
      case 'btt':
        percent = (bottom - clientY) / height;
        break;
      case 'ttb':
        percent = (clientY - top) / height;
        break;
      case 'rtl':
        percent = (right - clientX) / width;
        break;
      default:
        percent = (clientX - left) / width;
    }
    var nextValue = mergedMin + percent * (mergedMax - mergedMin);
    changeToCloseValue(formatValue(nextValue), e);
  };

  // =========================== Keyboard ===========================
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray$2(_React$useState, 2),
    keyboardValue = _React$useState2[0],
    setKeyboardValue = _React$useState2[1];
  var onHandleOffsetChange = function onHandleOffsetChange(offset, valueIndex) {
    if (!disabled) {
      var next = offsetValues(rawValues, offset, valueIndex);
      onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
      triggerChange(next.values);
      setKeyboardValue(next.value);
    }
  };
  React.useEffect(function () {
    if (keyboardValue !== null) {
      var valueIndex = rawValues.indexOf(keyboardValue);
      if (valueIndex >= 0) {
        handlesRef.current.focus(valueIndex);
      }
    }
    setKeyboardValue(null);
  }, [keyboardValue]);

  // ============================= Drag =============================
  var mergedDraggableTrack = React.useMemo(function () {
    if (rangeDraggableTrack && mergedStep === null) {
      if (process.env.NODE_ENV !== 'production') {
        warningOnce(false, '`draggableTrack` is not supported when `step` is `null`.');
      }
      return false;
    }
    return rangeDraggableTrack;
  }, [rangeDraggableTrack, mergedStep]);
  var onStartMove = useEvent(function (e, valueIndex) {
    onStartDrag(e, valueIndex);
    onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
  });

  // Auto focus for updated handle
  var dragging = draggingIndex !== -1;
  React.useEffect(function () {
    if (!dragging) {
      var valueIndex = rawValues.lastIndexOf(draggingValue);
      handlesRef.current.focus(valueIndex);
    }
  }, [dragging]);

  // =========================== Included ===========================
  var sortedCacheValues = React.useMemo(function () {
    return _toConsumableArray$2(cacheValues).sort(function (a, b) {
      return a - b;
    });
  }, [cacheValues]);

  // Provide a range values with included [min, max]
  // Used for Track, Mark & Dot
  var _React$useMemo = React.useMemo(function () {
      if (!rangeEnabled) {
        return [mergedMin, sortedCacheValues[0]];
      }
      return [sortedCacheValues[0], sortedCacheValues[sortedCacheValues.length - 1]];
    }, [sortedCacheValues, rangeEnabled, mergedMin]),
    _React$useMemo2 = _slicedToArray$2(_React$useMemo, 2),
    includedStart = _React$useMemo2[0],
    includedEnd = _React$useMemo2[1];

  // ============================= Refs =============================
  React.useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        handlesRef.current.focus(0);
      },
      blur: function blur() {
        var _containerRef$current2;
        var _document = document,
          activeElement = _document.activeElement;
        if ((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(activeElement)) {
          activeElement === null || activeElement === void 0 || activeElement.blur();
        }
      }
    };
  });

  // ========================== Auto Focus ==========================
  React.useEffect(function () {
    if (autoFocus) {
      handlesRef.current.focus(0);
    }
  }, []);

  // =========================== Context ============================
  var context = React.useMemo(function () {
    return {
      min: mergedMin,
      max: mergedMax,
      direction: direction,
      disabled: disabled,
      keyboard: keyboard,
      step: mergedStep,
      included: included,
      includedStart: includedStart,
      includedEnd: includedEnd,
      range: rangeEnabled,
      tabIndex: tabIndex,
      ariaLabelForHandle: ariaLabelForHandle,
      ariaLabelledByForHandle: ariaLabelledByForHandle,
      ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle,
      styles: styles || {},
      classNames: classNames || {}
    };
  }, [mergedMin, mergedMax, direction, disabled, keyboard, mergedStep, included, includedStart, includedEnd, rangeEnabled, tabIndex, ariaLabelForHandle, ariaLabelledByForHandle, ariaValueTextFormatterForHandle, styles, classNames]);

  // ============================ Render ============================
  return /*#__PURE__*/React.createElement(SliderContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: cls(prefixCls, className, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-vertical"), vertical), "".concat(prefixCls, "-horizontal"), !vertical), "".concat(prefixCls, "-with-marks"), markList.length)),
    style: style,
    onMouseDown: onSliderMouseDown,
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: cls("".concat(prefixCls, "-rail"), classNames === null || classNames === void 0 ? void 0 : classNames.rail),
    style: _objectSpread2(_objectSpread2({}, railStyle), styles === null || styles === void 0 ? void 0 : styles.rail)
  }), track !== false && /*#__PURE__*/React.createElement(Tracks, {
    prefixCls: prefixCls,
    style: trackStyle,
    values: rawValues,
    startPoint: startPoint,
    onStartMove: mergedDraggableTrack ? onStartMove : undefined
  }), /*#__PURE__*/React.createElement(Steps, {
    prefixCls: prefixCls,
    marks: markList,
    dots: dots,
    style: dotStyle,
    activeStyle: activeDotStyle
  }), /*#__PURE__*/React.createElement(Handles, {
    ref: handlesRef,
    prefixCls: prefixCls,
    style: handleStyle,
    values: cacheValues,
    draggingIndex: draggingIndex,
    draggingDelete: draggingDelete,
    onStartMove: onStartMove,
    onOffsetChange: onHandleOffsetChange,
    onFocus: onFocus,
    onBlur: onBlur,
    handleRender: handleRender,
    activeHandleRender: activeHandleRender,
    onChangeComplete: finishChange,
    onDelete: rangeEditable ? onDelete : undefined
  }), /*#__PURE__*/React.createElement(Marks, {
    prefixCls: prefixCls,
    marks: markList,
    onClick: changeToCloseValue
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Slider.displayName = 'Slider';
}

var css_248z$2 = ".rc-slider {\n  position: relative;\n  width: 100%;\n  height: 14px;\n  padding: 5px 0;\n  border-radius: 6px;\n  touch-action: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider * {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background-color: #e9e9e9;\n  border-radius: 6px;\n}\n.rc-slider-track,\n.rc-slider-tracks {\n  position: absolute;\n  height: 4px;\n  background-color: #abe2fb;\n  border-radius: 6px;\n}\n.rc-slider-track-draggable {\n  z-index: 1;\n  box-sizing: content-box;\n  background-clip: content-box;\n  border-top: 5px solid rgba(0, 0, 0, 0);\n  border-bottom: 5px solid rgba(0, 0, 0, 0);\n  transform: translateY(-5px);\n}\n.rc-slider-handle {\n  position: absolute;\n  z-index: 1;\n  width: 14px;\n  height: 14px;\n  margin-top: -5px;\n  background-color: #fff;\n  border: solid 2px #96dbfa;\n  border-radius: 50%;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  cursor: grab;\n  opacity: 0.8;\n  user-select: none;\n  touch-action: pan-x;\n}\n.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: #57c5f7;\n  box-shadow: 0 0 0 5px #96dbfa;\n}\n.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging-delete {\n  opacity: 0;\n}\n.rc-slider-handle:focus {\n  outline: none;\n  box-shadow: none;\n}\n.rc-slider-handle:focus-visible {\n  border-color: #2db7f5;\n  box-shadow: 0 0 0 3px #96dbfa;\n}\n.rc-slider-handle-click-focused:focus {\n  border-color: #96dbfa;\n  box-shadow: unset;\n}\n.rc-slider-handle:hover {\n  border-color: #57c5f7;\n}\n.rc-slider-handle:active {\n  border-color: #57c5f7;\n  box-shadow: 0 0 5px #57c5f7;\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n.rc-slider-mark {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  width: 100%;\n  font-size: 12px;\n}\n.rc-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  color: #999;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.rc-slider-mark-text-active {\n  color: #666;\n}\n.rc-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n.rc-slider-dot {\n  position: absolute;\n  bottom: -2px;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  background-color: #fff;\n  border: 2px solid #e9e9e9;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.rc-slider-dot-active {\n  border-color: #96dbfa;\n}\n.rc-slider-dot-reverse {\n  margin-right: -4px;\n}\n.rc-slider-disabled {\n  background-color: #e9e9e9;\n}\n.rc-slider-disabled .rc-slider-track {\n  background-color: #ccc;\n}\n.rc-slider-disabled .rc-slider-handle,\n.rc-slider-disabled .rc-slider-dot {\n  background-color: #fff;\n  border-color: #ccc;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.rc-slider-disabled .rc-slider-mark-text,\n.rc-slider-disabled .rc-slider-dot {\n  cursor: not-allowed !important;\n}\n.rc-slider-vertical {\n  width: 14px;\n  height: 100%;\n  padding: 0 5px;\n}\n.rc-slider-vertical .rc-slider-rail {\n  width: 4px;\n  height: 100%;\n}\n.rc-slider-vertical .rc-slider-track {\n  bottom: 0;\n  left: 5px;\n  width: 4px;\n}\n.rc-slider-vertical .rc-slider-track-draggable {\n  border-top: 0;\n  border-right: 5px solid rgba(0, 0, 0, 0);\n  border-bottom: 0;\n  border-left: 5px solid rgba(0, 0, 0, 0);\n  transform: translateX(-5px);\n}\n.rc-slider-vertical .rc-slider-handle {\n  position: absolute;\n  z-index: 1;\n  margin-top: 0;\n  margin-left: -5px;\n  touch-action: pan-y;\n}\n.rc-slider-vertical .rc-slider-mark {\n  top: 0;\n  left: 18px;\n  height: 100%;\n}\n.rc-slider-vertical .rc-slider-step {\n  width: 4px;\n  height: 100%;\n}\n.rc-slider-vertical .rc-slider-dot {\n  margin-left: -2px;\n}\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  display: block !important;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.rc-slider-tooltip-zoom-down-leave {\n  display: block !important;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n  animation-name: rcSliderTooltipZoomDownIn;\n  animation-play-state: running;\n}\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n  animation-name: rcSliderTooltipZoomDownOut;\n  animation-play-state: running;\n}\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  transform: scale(0, 0);\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.rc-slider-tooltip-zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    transform: scale(0, 0);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1, 1);\n    transform-origin: 50% 100%;\n  }\n}\n@keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    transform: scale(1, 1);\n    transform-origin: 50% 100%;\n  }\n  100% {\n    transform: scale(0, 0);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n}\n.rc-slider-tooltip {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  visibility: visible;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-tooltip * {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-tooltip-hidden {\n  display: none;\n}\n.rc-slider-tooltip-placement-top {\n  padding: 4px 0 8px 0;\n}\n.rc-slider-tooltip-inner {\n  min-width: 24px;\n  height: 24px;\n  padding: 6px 2px;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  background-color: #6c6c6c;\n  border-radius: 6px;\n  box-shadow: 0 0 4px #d9d9d9;\n}\n.rc-slider-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  bottom: 4px;\n  left: 50%;\n  margin-left: -4px;\n  border-width: 4px 4px 0;\n  border-top-color: #6c6c6c;\n}\n";
styleInject(css_248z$2);

var EnumCrypt;
(function (EnumCrypt) {
    EnumCrypt["KEY"] = "ion";
})(EnumCrypt || (EnumCrypt = {}));
var EnumTarifart;
(function (EnumTarifart) {
    EnumTarifart[EnumTarifart["NEIN"] = 0] = "NEIN";
    EnumTarifart[EnumTarifart["JA"] = 1] = "JA";
    EnumTarifart[EnumTarifart["VERBUND"] = 2] = "VERBUND";
})(EnumTarifart || (EnumTarifart = {}));
var EnumJaNein;
(function (EnumJaNein) {
    EnumJaNein[EnumJaNein["KEINE"] = -1] = "KEINE";
    EnumJaNein[EnumJaNein["JA"] = 1] = "JA";
    EnumJaNein[EnumJaNein["NEIN"] = 0] = "NEIN";
})(EnumJaNein || (EnumJaNein = {}));
var EnumZahlart;
(function (EnumZahlart) {
    EnumZahlart[EnumZahlart["LASTSCHRIFT"] = 1] = "LASTSCHRIFT";
    EnumZahlart[EnumZahlart["RECHNUNG"] = 0] = "RECHNUNG";
})(EnumZahlart || (EnumZahlart = {}));
var EnumZahlweise;
(function (EnumZahlweise) {
    EnumZahlweise[EnumZahlweise["MONATLICH"] = 0] = "MONATLICH";
    EnumZahlweise[EnumZahlweise["VIERTEL"] = 1] = "VIERTEL";
    EnumZahlweise[EnumZahlweise["HALB"] = 2] = "HALB";
    EnumZahlweise[EnumZahlweise["JAHR"] = 3] = "JAHR";
})(EnumZahlweise || (EnumZahlweise = {}));
var EnumEuBeratungKontakt;
(function (EnumEuBeratungKontakt) {
    EnumEuBeratungKontakt[EnumEuBeratungKontakt["PERSOENLICH"] = 1] = "PERSOENLICH";
    EnumEuBeratungKontakt[EnumEuBeratungKontakt["TELEFON"] = 2] = "TELEFON";
    EnumEuBeratungKontakt[EnumEuBeratungKontakt["MAIL"] = 3] = "MAIL";
})(EnumEuBeratungKontakt || (EnumEuBeratungKontakt = {}));
var EnumVersicherungsart;
(function (EnumVersicherungsart) {
    EnumVersicherungsart[EnumVersicherungsart["EINZEL"] = 0] = "EINZEL";
    EnumVersicherungsart[EnumVersicherungsart["PARTNER"] = 1] = "PARTNER";
})(EnumVersicherungsart || (EnumVersicherungsart = {}));
var EnumVkanal;
(function (EnumVkanal) {
    EnumVkanal["OSPlus"] = "osplus";
    EnumVkanal["Ifiliale"] = "ifiliale";
    EnumVkanal["Internet"] = "internet";
    EnumVkanal["InternetAD"] = "internet_ad";
})(EnumVkanal || (EnumVkanal = {}));
var EnumMandant;
(function (EnumMandant) {
    EnumMandant["VGH"] = "vgh";
    EnumMandant["OESA"] = "oesa";
    EnumMandant["OEVO"] = "oevo";
    EnumMandant["OEVB"] = "oevb";
})(EnumMandant || (EnumMandant = {}));
var EnumVorgangsart;
(function (EnumVorgangsart) {
    EnumVorgangsart[EnumVorgangsart["NEUVERTRAG"] = 0] = "NEUVERTRAG";
    EnumVorgangsart[EnumVorgangsart["NEUORDNUNG"] = 1] = "NEUORDNUNG";
})(EnumVorgangsart || (EnumVorgangsart = {}));
var EnumActions;
(function (EnumActions) {
    EnumActions["HOLEVORBELEGUNGEN"] = "holeVorbelegungen";
    EnumActions["VALIDIERE"] = "validiere";
    EnumActions["BERECHNE"] = "berechne";
    EnumActions["BEANTRAGE"] = "beantragen";
    EnumActions["VALIDIERE_EUBERATUNG"] = "validiereBeratungsdoku";
    EnumActions["OSPLUS_BEENDE"] = "beendeTarifrechner";
    EnumActions["OSPLUS_SPEICHERE"] = "speichereAngebot";
    EnumActions["OSPLUS_TERMIN"] = "erstelleTermin";
    EnumActions["VU_BERATER_VALIDIERE"] = "validiereKundenanfrage";
    EnumActions["VU_BERATER_SENDE"] = "sendeKundenanfrage";
})(EnumActions || (EnumActions = {}));
var EnumSavedState;
(function (EnumSavedState) {
    EnumSavedState["LOADED"] = "loaded";
    EnumSavedState["ERROR"] = "error";
    EnumSavedState["SAVED"] = "saved";
    EnumSavedState["CLEAR"] = "";
})(EnumSavedState || (EnumSavedState = {}));

var root = document.querySelector('#root');
var trEnv = {
    vtnr: root === null || root === void 0 ? void 0 : root.getAttribute('data-vtnr'),
    mandant: root === null || root === void 0 ? void 0 : root.getAttribute('data-mandant'),
    queryBaseUrl: root === null || root === void 0 ? void 0 : root.getAttribute('data-query-base-url'),
    ivvQueryPath: root === null || root === void 0 ? void 0 : root.getAttribute('data-ivv-query-path'),
    sessionId: root === null || root === void 0 ? void 0 : root.getAttribute('data-session-id'),
    vkanal: root === null || root === void 0 ? void 0 : root.getAttribute('data-vkanal'),
    banking: root === null || root === void 0 ? void 0 : root.getAttribute('data-banking'),
    imgPath: root === null || root === void 0 ? void 0 : root.getAttribute('data-img-path'),
    produktauswahl: root === null || root === void 0 ? void 0 : root.getAttribute('data-produktauswahl'),
    error: root === null || root === void 0 ? void 0 : root.getAttribute('data-error-text'),
};
var trEnv$1 = {
    vtnr: trEnv.vtnr || '',
    mandant: trEnv.mandant || '',
    queryBaseUrl: trEnv.queryBaseUrl || '',
    ivvQueryPath: trEnv.ivvQueryPath || '',
    sessionId: trEnv.sessionId || '',
    vkanal: trEnv.vkanal || '',
    sparkasse: (trEnv.vkanal === EnumVkanal.Ifiliale || trEnv.vkanal === EnumVkanal.OSPlus),
    stationaer: trEnv.vkanal === EnumVkanal.OSPlus,
    ifiliale: trEnv.vkanal === EnumVkanal.Ifiliale,
    medial: (trEnv.vkanal === EnumVkanal.Internet || trEnv.vkanal === EnumVkanal.InternetAD),
    banking: trEnv.banking === 'true',
    sApp: function () { var _a; return (!!((_a = window === null || window === void 0 ? void 0 : window.OSPlusNeo) === null || _a === void 0 ? void 0 : _a.isSApp) && window.OSPlusNeo.isSApp()); },
    ipad: function () { var _a; return (!!((_a = window === null || window === void 0 ? void 0 : window.OSPlusNeo) === null || _a === void 0 ? void 0 : _a.isIPadApp) && window.OSPlusNeo.isIPadApp()); },
    istOESA: trEnv.mandant === EnumMandant.OESA,
    istVGH: trEnv.mandant === EnumMandant.VGH,
    istOEVO: trEnv.mandant === EnumMandant.OEVO,
    istOEVB: trEnv.mandant === EnumMandant.OEVB,
    imgPath: trEnv.imgPath || '',
    produktauswahl: trEnv.produktauswahl || '',
    error: trEnv.error || '',
};

/**
 * generiert eine uuidv4
 * @returns {string} uuidv4
 */
var randomUUID = function () { return (String(1e7) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) { return (
// eslint-disable-next-line no-bitwise
Number(c) ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))).toString(16); }); };
var uuid = window.sessionStorage.getItem('uuid') || randomUUID();
window.sessionStorage.setItem('uuid', uuid);

var createSessionName = function () {
    var path = trEnv$1.ivvQueryPath.replace(/[./]*/, '') || 'common';
    var produktauswahl = trEnv$1.produktauswahl ? "".concat(trEnv$1.produktauswahl, "-") : '';
    return "".concat(path, "-").concat(produktauswahl).concat(trEnv$1.mandant, "-session-id");
};
var getSessionId = function () { return window.sessionStorage.getItem(createSessionName()) || trEnv$1.sessionId; };
var removeSessionId = function () { return window.sessionStorage.removeItem(createSessionName()); };
/**
 * es wird überprüft ob die session vom server gleich ist zu dem was im
 * storage steht ansonsten wird zur ersten seite gesprungen
 *
 * bei der sparkasse wird immer zur erster seite gesprungen da wir nichts im
 * storage speichern
 * @param {string} responseSessionId
 */
var handleSession = function (responseSessionId, cb) {
    if (cb === void 0) { cb = function () { return null; }; }
    var sessionName = createSessionName();
    var sessionId = window.sessionStorage.getItem(sessionName);
    if (sessionId !== responseSessionId) {
        window.location.hash = '#';
        window.sessionStorage.setItem(sessionName, responseSessionId);
        cb();
    }
};

var savedStateManager = (function () {
    var trPath = trEnv$1.ivvQueryPath.replace(/[./]*/, '') || 'common';
    var produktauswahl = trEnv$1.produktauswahl ? "".concat(trEnv$1.produktauswahl, "-") : '';
    var sessionName = "".concat(trPath, "-").concat(produktauswahl).concat(trEnv$1.mandant, "-session");
    var localStorage = window.localStorage, sessionStorage = window.sessionStorage;
    return {
        loadFromLocalStorage: function () { return JSON.parse(localStorage.getItem(sessionName) || '{}'); },
        saveToLocalStorage: function (state) {
            localStorage.setItem(sessionName, JSON.stringify(state));
        },
        deleteFromLocalStorage: function () { return localStorage.removeItem(sessionName); },
        loadFromSessionStorage: function () { return JSON.parse(sessionStorage.getItem(sessionName) || '{}'); },
        saveToSessionStorage: function (state) {
            sessionStorage.setItem(sessionName, JSON.stringify(state));
        },
        deleteFromSessionStorage: function () { return sessionStorage.removeItem(sessionName); },
    };
})();

/**
 * verschlüsselt den Text anhand eines Keys
 * @param {string} toEncode
 * @param {string} key
 * @returns {string}
 */
var crypt = function (toEncode, key) {
    if (key === void 0) { key = EnumCrypt.KEY; }
    var textToChars = function (text) { return text.split('').map(function (c) { return c.charCodeAt(0); }); };
    var byteHex = function (n) { return ("0".concat(Number(n).toString(16))).substr(-2); };
    var applySaltToChar = function (code) { return textToChars(key).reduce(function (a, b) { return a ^ b; }, code); };
    return toEncode
        .split('')
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join('');
};
/**
 * entschlüsselt den Text anhand eines Keys
 * @param {string} toDecode
 * @param {string} key
 * @returns {string}
 */
var decrypt = function (toDecode, key) {
    var _a;
    if (key === void 0) { key = EnumCrypt.KEY; }
    if (!toDecode) {
        return '';
    }
    var textToChars = function (text) { return text.split('').map(function (c) { return c.charCodeAt(0); }); };
    var applySaltToChar = function (code) { return textToChars(key).reduce(function (a, b) { return a ^ b; }, code); };
    return (_a = toDecode
        .match(/.{1,2}/g)) === null || _a === void 0 ? void 0 : _a.map(function (hex) { return parseInt(hex, 16); }).map(applySaltToChar).map(function (charCode) { return String.fromCharCode(charCode); }).join('');
};
/**
 * Float wird in dt. Format inkl. Eurozeichen angezeigt
 *
 * @example
 * // returns 3.200,00 €
 * toMoney(3200)
 *
 * @param {number|string} float
 * @returns {string}
 */
var toMoney = function (float) {
    if (float === void 0) { float = 0; }
    return (float != null ? parseFloat(float).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) : '');
};
/**
 * Float wird in dt. Format inkl. Eurozeichen angezeigt
 *
 * @example
 * // returns 3.200 €
 * toMoney(3200)
 *
 * @param {number|string} float
 * @returns {string}
 */
var toMoneyWOComma = function (float) {
    if (float === void 0) { float = 0; }
    return (float != null ? "".concat(parseFloat(float).toLocaleString('de-DE'), " \u20AC") : '');
};
/**
 * Find value in array by id
 *
 * @param {Object[]} array
 * @param {number} array.id
 * @param {string} array.bezeichnung
 * @param {number} id
 * @returns {string}
 */
var findValueById = function (array, id) {
    if (!array) {
        return '';
    }
    var found = array.find(function (elem) { return id.toString() === elem.id.toString(); });
    return found ? found.bezeichnung : '';
};
/**
 * Funktion ausführen, wenn Enter gedrückt wird,
 * hilfreich bei Eingabefeldern
 *
 * @param {Event} event
 * @param {string} event.code
 * @param {Function} callback
 */
var onEnter = function (event, callback) {
    if (callback === void 0) { callback = function () { }; }
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        callback();
    }
};
/**
 * berechnet die höhe des containers neu und setzt sie für die sparkasse
 * @param {string} selector
 */
var updateWindowHeightForIF = function (selector) {
    if (selector === void 0) { selector = '#root'; }
    if (!trEnv$1.ifiliale) {
        return;
    }
    window.setTimeout(function () {
        var element = document.querySelector(selector);
        var height = element.offsetHeight;
        if (window.ivvHeight !== height) {
            window.ivvHeight = height;
            window.OSPlusNeo.setHeight(height < 767 ? 768 : height);
        }
    }, 500);
};
/**
 * findet baustein
 * @param {Object[]} bausteine
 * @param {Object} bausteine.id
 * @param {number|string} bausteine.id.value
 * @param {Object} auswahlBaustein
 * @param {number|string} auswahlBaustein.value
 * @returns {Object}
 */
var findBaustein = function (bausteine, auswahlBaustein) {
    if (!auswahlBaustein || parseInt(auswahlBaustein.value, 10) === 0) {
        return false;
    }
    return bausteine.find(function (element) { return parseInt(element.id.value, 10) === parseInt(auswahlBaustein.value, 10); }) || {};
};
/**
 * nimmt fehler [] entgegen und tauscht einen teil gegen eine component aus
 * @param {String | String[]} error
 * @param {string} filterValue
 * @param {Object} component
 * @returns {Object}
 */
var replaceErrorWithComponent = function (error, filterValue, component) {
    if (!error) {
        return null;
    }
    var textString = error;
    if (Array.isArray(error)) {
        textString = error.join(' ');
    }
    var reg = new RegExp("(".concat(filterValue, ")"), 'gi');
    var textParts = textString.split(reg);
    return (jsx$1("span", { children: textParts.map(function (part) { return (jsx$1(React__default.Fragment, { children: (part.match(reg) ? component : part) }, part)); }) }));
};
/**
 * Tauscht das EUR in € im valueSet
 * @param {Object[]} valueSet
 * @param {number|string} valueSet.id
 * @param {string} valueSet.bezeichnung
 * @returns {Object[]}
 */
var replaceEURinValueSet = function (valueSet) {
    if (valueSet === undefined || valueSet.length <= 0) {
        return valueSet;
    }
    return valueSet.map(function (elem) { return ({
        id: elem.id,
        bezeichnung: elem.bezeichnung.replace(/EUR/g, '€').replace(/0 SB/g, '0 € SB'),
    }); });
};
/**
 * entfernt den zurückbutton
 * @param {Function} callback
 */
var neutralizeBack = function (callback) {
    if (callback === void 0) { callback = function () { return null; }; }
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = function () {
        window.history.pushState(null, '', window.location.href);
        callback();
    };
};
/**
 * prüft obj gleich ist mit number
 * @param {Object} obj
 * @param {number|string} obj.value
 * @param {Number} number
 * @return {boolean}
 */
var istEnumAuswahl = function (obj, number) { return parseInt(obj.value, 10) === number; };
/**
 * prüft obj nicht gleich ist mit number
 * @param {Object} obj
 * @param {number|string} obj.value
 * @param {Number} number
 * @return {boolean}
 */
var istNichtEnumAuswahl = function (obj, number) { return parseInt(obj.value, 10) !== number; };
/**
 * prüft ob Ja gewählt ist aus der Werteliste
 * @param {Object} obj
 * @returns {boolean}
 */
var istJaAuswahl = function (obj) { return istEnumAuswahl(obj, EnumJaNein.JA); };
/**
 * prüft ob Nein gewählt ist aus der Werteliste
 * @param {Object} obj
 * @returns {boolean}
 */
var istNeinAuswahl = function (obj) { return istEnumAuswahl(obj, EnumJaNein.NEIN); };
/**
 * prüft ob Object leer
 * @param {Object} obj
 * @returns {boolean}
 */
var isEmptyObj = function (obj) { return (obj == null || Object.keys(obj).length === 0); };
/**
 * erstellt einen Link zur beratersuche mit der plz vorbelegt
 * @param {string} i18nextKey
 * @param {Object} plz
 * @param {Object} vertreter
 * @returns {string}
 */
var setBeratersuche = function (i18nextKey, plz, vertreter) {
    var param = '';
    if (!isEmptyObj(vertreter) && vertreter.auswahl.name.value !== '') {
        param = "#query=".concat(vertreter.auswahl.name.value, ";method=BY_NAME;kanal=0,1,5");
    }
    else if (plz && (plz === null || plz === void 0 ? void 0 : plz.value)) {
        param = "#query=".concat(plz.value, ";method=BY_LOCATION;kanal=0,1,5");
    }
    return i18next.t(i18nextKey, { PARAM: param });
};
/**
 * erstellt einen Link zur beratersuche mit der plz vorbelegt (für VP/MS)
 * @param {string} i18nextKey
 * @param {Object} plz
 * @param {Object} vertreter
 * @returns {string}
 */
var setBeratersucheVpms = function (i18nextKey, plz, vertreter) {
    var _a;
    var param = '';
    var name = (_a = vertreter === null || vertreter === void 0 ? void 0 : vertreter.auswahlMetaInfo) === null || _a === void 0 ? void 0 : _a.value.nameMetaInfo.value;
    if (!isEmptyObj(vertreter) && name !== '') {
        param = "#query=".concat(name, ";method=BY_NAME;kanal=0,1,5");
    }
    else if (plz && (plz === null || plz === void 0 ? void 0 : plz.value)) {
        param = "#query=".concat(plz.value, ";method=BY_LOCATION;kanal=0,1,5");
    }
    return i18next.t(i18nextKey, { PARAM: param });
};
var inputGenerateDescribedBy = function (name, subtitle, hint, error, message) {
    var id = [];
    if (subtitle) {
        id.push("subtitle.".concat(name));
    }
    if (hint) {
        id.push("hint.".concat(name));
    }
    if (error) {
        id.push("error.".concat(name));
    }
    if (message) {
        id.push("message.".concat(name));
    }
    if (id.length > 0) {
        return id.join(' ');
    }
    return undefined;
};

// src/utils/formatProdErrorMessage.ts
function formatProdErrorMessage$1(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;

// src/utils/actionTypes.ts
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;

// src/utils/isPlainObject.ts
function isPlainObject$1(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}

// src/utils/kindOf.ts
function miniKindOf(val) {
  if (val === void 0)
    return "undefined";
  if (val === null)
    return "null";
  const type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val))
    return "array";
  if (isDate(val))
    return "date";
  if (isError(val))
    return "error";
  const constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
  if (val instanceof Date)
    return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  let typeOfVal = typeof val;
  if (process.env.NODE_ENV !== "production") {
    typeOfVal = miniKindOf(val);
  }
  return typeOfVal;
}

// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(2) : `Expected the root reducer to be a function. Instead, received: '${kindOf(reducer)}'`);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(1) : `Expected the enhancer to be a function. Instead, received: '${kindOf(enhancer)}'`);
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(4) : `Expected the listener to be a function. Instead, received: '${kindOf(listener)}'`);
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject$1(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(7) : `Actions must be plain objects. Instead, the actual type was: '${kindOf(action)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    }
    if (typeof action.type === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }
    if (typeof action.type !== "string") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(17) : `Action "type" property must be a string. Instead, the actual type was: '${kindOf(action.type)}'. Value was: '${action.type}' (stringified)`);
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(9) : "Reducers may not dispatch actions.");
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(10) : `Expected the nextReducer to be a function. Instead, received: '${kindOf(nextReducer)}`);
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(11) : `Expected the observer to be an object. Instead, received: '${kindOf(observer)}'`);
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store = {
    dispatch,
    subscribe,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store;
}

// src/utils/warning.ts
function warning(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e) {
  }
}

// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  const reducerKeys = Object.keys(reducers);
  const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (reducerKeys.length === 0) {
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  }
  if (!isPlainObject$1(inputState)) {
    return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
  }
  const unexpectedKeys = Object.keys(inputState).filter((key) => !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
  unexpectedKeys.forEach((key) => {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === actionTypes_default.REPLACE)
    return;
  if (unexpectedKeys.length > 0) {
    return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(12) : `The slice reducer for key "${key}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(13) : `The slice reducer for key "${key}" returned undefined when probed with a random type. Don't try to handle '${actionTypes_default.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i++) {
    const key = reducerKeys[i];
    if (process.env.NODE_ENV !== "production") {
      if (typeof reducers[key] === "undefined") {
        warning(`No reducer provided for key "${key}"`);
      }
    }
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let unexpectedKeyCache;
  if (process.env.NODE_ENV !== "production") {
    unexpectedKeyCache = {};
  }
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (process.env.NODE_ENV !== "production") {
      const warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalReducerKeys.length; i++) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        const actionType = action && action.type;
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(14) : `When called with an action of type ${actionType ? `"${String(actionType)}"` : "(unknown type)"}, the slice reducer for key "${key}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

// src/compose.ts
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const middlewareAPI = {
      getState: store.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose(...chain)(store.dispatch);
    return {
      ...store,
      dispatch
    };
  };
}

// src/utils/isAction.ts
function isAction(action) {
  return isPlainObject$1(action) && "type" in action && typeof action.type === "string";
}

// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");

// src/utils/errors.ts
var errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(plugin) {
    return `The plugin for '${plugin}' has not been loaded into Immer. To enable the plugin, import and call \`enable${plugin}()\` when initializing your application.`;
  },
  function(thing) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${thing}'`;
  },
  "This object has been frozen and should not be mutated",
  function(data) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + data;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(thing) {
    return `'current' expects a draft, got: ${thing}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(thing) {
    return `'original' expects a draft, got: ${thing}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(error, ...args) {
  if (process.env.NODE_ENV !== "production") {
    const e = errors[error];
    const msg = typeof e === "function" ? e.apply(null, args) : e;
    throw new Error(`[Immer] ${msg}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}

// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0 /* Object */) {
    Reflect.ownKeys(obj).forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */ : isMap(thing) ? 2 /* Map */ : isSet(thing) ? 3 /* Set */ : 0 /* Object */;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function set(thing, propOrOldValue, value) {
  const t = getArchtype(thing);
  if (t === 2 /* Map */)
    thing.set(propOrOldValue, value);
  else if (t === 3 /* Set */) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    Object.entries(obj).forEach(([key, value]) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}

// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}

// src/core/scope.ts
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */)
    state.revoke_();
  else
    state.revoked_ = true;
}

// src/core/finalize.ts
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path)
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3 /* Set */) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2)
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (process.env.NODE_ENV !== "production" && childValue === targetObject)
    die(5);
  if (isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 /* Set */ && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}

// src/core/proxy.ts
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 /* Array */ : 0 /* Object */,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek$1(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek$1(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek$1(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 /* Array */ || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (process.env.NODE_ENV !== "production" && isNaN(parseInt(prop)))
    die(13);
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (process.env.NODE_ENV !== "production" && prop !== "length" && isNaN(parseInt(prop)))
    die(14);
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek$1(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}

// src/core/immerClass.ts
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
          patchListener(p, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config?.autoFreeze === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof config?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}

// src/core/current.ts
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}

// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
immer.produceWithPatches.bind(
  immer
);
immer.setAutoFreeze.bind(immer);
immer.setUseStrictShallowCopy.bind(immer);
immer.applyPatches.bind(immer);
immer.createDraft.bind(immer);
immer.finishDraft.bind(immer);

// src/index.ts
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;

// src/index.ts
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0) return void 0;
  if (typeof arguments[0] === "object") return compose;
  return compose.apply(null, arguments);
};

// src/tsHelpers.ts
var hasMatchFunction = (v) => {
  return v && typeof v.match === "function";
};

// src/createAction.ts
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "prepareAction did not return an object");
      }
      return {
        type,
        payload: prepared.payload,
        ..."meta" in prepared && {
          meta: prepared.meta
        },
        ..."error" in prepared && {
          error: prepared.error
        }
      };
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => isAction(action) && action.type === type;
  return actionCreator;
}
function isActionCreator(action) {
  return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  hasMatchFunction(action);
}

// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
  const splitType = type ? `${type}`.split("/") : [];
  const actionName = splitType[splitType.length - 1] || "actionCreator";
  return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  }
  const {
    isActionCreator: isActionCreator2 = isActionCreator
  } = options;
  return () => (next) => (action) => {
    if (isActionCreator2(action)) {
      console.warn(getMessage(action.type));
    }
    return next(action);
  };
}
function getTimeMeasureUtils(maxDelay, fnName) {
  let elapsed = 0;
  return {
    measureTime(fn) {
      const started = Date.now();
      try {
        return fn();
      } finally {
        const finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded() {
      if (elapsed > maxDelay) {
        console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
      }
    }
  };
}
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}
function emplace(map, key, handler) {
  if (map.has(key)) {
    let value = map.get(key);
    if (handler.update) {
      value = handler.update(value, key, map);
      map.set(key, value);
    }
    return value;
  }
  if (!handler.insert) throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "No insert provided for key not already in map");
  const inserted = handler.insert(key, map);
  map.set(key, inserted);
  return inserted;
}

// src/immutableStateInvariantMiddleware.ts
function isImmutableDefault(value) {
  return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
  const trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
  return {
    detectMutations() {
      return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
    }
  };
}
function trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
  const tracked = {
    value: obj
  };
  if (!isImmutable(obj) && !checkedObjects.has(obj)) {
    checkedObjects.add(obj);
    tracked.children = {};
    for (const key in obj) {
      const childPath = path ? path + "." + key : key;
      if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
        continue;
      }
      tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
    }
  }
  return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
  const prevObj = trackedProperty ? trackedProperty.value : void 0;
  const sameRef = prevObj === obj;
  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path
    };
  }
  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  }
  const keysToDetect = {};
  for (let key in trackedProperty.children) {
    keysToDetect[key] = true;
  }
  for (let key in obj) {
    keysToDetect[key] = true;
  }
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (let key in keysToDetect) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    const result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
    if (result.wasMutated) {
      return result;
    }
  }
  return {
    wasMutated: false
  };
}
function createImmutableStateInvariantMiddleware(options = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  } else {
    let stringify2 = function(obj, serializer, indent, decycler) {
      return JSON.stringify(obj, getSerialize2(serializer, decycler), indent);
    }, getSerialize2 = function(serializer, decycler) {
      let stack = [], keys = [];
      if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
      };
      return function(key, value) {
        if (stack.length > 0) {
          var thisPos = stack.indexOf(this);
          ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
          ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
          if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
      };
    };
    let {
      isImmutable = isImmutableDefault,
      ignoredPaths,
      warnAfter = 32
    } = options;
    const track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return ({
      getState
    }) => {
      let state = getState();
      let tracker = track(state);
      let result;
      return (next) => (action) => {
        const measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
        measureUtils.measureTime(() => {
          state = getState();
          result = tracker.detectMutations();
          tracker = track(state);
          if (result.wasMutated) {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(19) : `A state mutation was detected between dispatches, in the path '${result.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
          }
        });
        const dispatchedAction = next(action);
        measureUtils.measureTime(() => {
          state = getState();
          result = tracker.detectMutations();
          tracker = track(state);
          if (result.wasMutated) {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(20) : `A state mutation was detected inside a dispatch, in the path: ${result.path || ""}. Take a look at the reducer(s) handling the action ${stringify2(action)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
          }
        });
        measureUtils.warnIfExceeded();
        return dispatchedAction;
      };
    };
  }
}
function isPlain(val) {
  const type = typeof val;
  return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject$1(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
  let foundNestedSerializable;
  if (!isSerializable(value)) {
    return {
      keyPath: path || "<root>",
      value
    };
  }
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (cache?.has(value)) return false;
  const entries = getEntries != null ? getEntries(value) : Object.entries(value);
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (const [key, nestedValue] of entries) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    if (!isSerializable(nestedValue)) {
      return {
        keyPath: nestedPath,
        value: nestedValue
      };
    }
    if (typeof nestedValue === "object") {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
      if (foundNestedSerializable) {
        return foundNestedSerializable;
      }
    }
  }
  if (cache && isNestedFrozen(value)) cache.add(value);
  return false;
}
function isNestedFrozen(value) {
  if (!Object.isFrozen(value)) return false;
  for (const nestedValue of Object.values(value)) {
    if (typeof nestedValue !== "object" || nestedValue === null) continue;
    if (!isNestedFrozen(nestedValue)) return false;
  }
  return true;
}
function createSerializableStateInvariantMiddleware(options = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  } else {
    const {
      isSerializable = isPlain,
      getEntries,
      ignoredActions = [],
      ignoredActionPaths = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths = [],
      warnAfter = 32,
      ignoreState = false,
      ignoreActions = false,
      disableCache = false
    } = options;
    const cache = !disableCache && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (storeAPI) => (next) => (action) => {
      if (!isAction(action)) {
        return next(action);
      }
      const result = next(action);
      const measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
      if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
        measureUtils.measureTime(() => {
          const foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
          if (foundActionNonSerializableValue) {
            const {
              keyPath,
              value
            } = foundActionNonSerializableValue;
            console.error(`A non-serializable value was detected in an action, in the path: \`${keyPath}\`. Value:`, value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
          }
        });
      }
      if (!ignoreState) {
        measureUtils.measureTime(() => {
          const state = storeAPI.getState();
          const foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
          if (foundStateNonSerializableValue) {
            const {
              keyPath,
              value
            } = foundStateNonSerializableValue;
            console.error(`A non-serializable value was detected in the state, in the path: \`${keyPath}\`. Value:`, value, `
Take a look at the reducer(s) handling this action type: ${action.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        });
        measureUtils.warnIfExceeded();
      }
      return result;
    };
  }
}

// src/getDefaultMiddleware.ts
function isBoolean(x) {
  return typeof x === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options) {
  const {
    thunk: thunk$1 = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options ?? {};
  let middlewareArray = new Tuple();
  if (thunk$1) {
    if (isBoolean(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk$1.extraArgument));
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (immutableCheck) {
      let immutableOptions = {};
      if (!isBoolean(immutableCheck)) {
        immutableOptions = immutableCheck;
      }
      middlewareArray.unshift(createImmutableStateInvariantMiddleware(immutableOptions));
    }
    if (serializableCheck) {
      let serializableOptions = {};
      if (!isBoolean(serializableCheck)) {
        serializableOptions = serializableCheck;
      }
      middlewareArray.push(createSerializableStateInvariantMiddleware(serializableOptions));
    }
    if (actionCreatorCheck) {
      let actionCreatorOptions = {};
      if (!isBoolean(actionCreatorCheck)) {
        actionCreatorOptions = actionCreatorCheck;
      }
      middlewareArray.unshift(createActionCreatorInvariantMiddleware(actionCreatorOptions));
    }
  }
  return middlewareArray;
};

// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = (options = {
  type: "raf"
}) => (next) => (...args) => {
  const store = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l) => l());
    }
  };
  return Object.assign({}, store, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      try {
        notifying = !action?.meta?.[SHOULD_AUTOBATCH];
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};

// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options) {
  const {
    autoBatch = true
  } = options ?? {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
  }
  return enhancerArray;
};

// src/configureStore.ts
function configureStore(options) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = void 0,
    middleware,
    devTools = true,
    preloadedState = void 0,
    enhancers = void 0
  } = options || {};
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (isPlainObject$1(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  }
  if (process.env.NODE_ENV !== "production" && middleware && typeof middleware !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "`middleware` field must be a callback");
  }
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
    if (process.env.NODE_ENV !== "production" && !Array.isArray(finalMiddleware)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "when using a middleware builder function, an array of middleware must be returned");
    }
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  if (process.env.NODE_ENV !== "production" && finalMiddleware.some((item) => typeof item !== "function")) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "each middleware provided to configureStore must be a function");
  }
  let finalCompose = compose;
  if (devTools) {
    finalCompose = composeWithDevTools({
      // Enable capture of stack traces for dispatched Redux actions
      trace: process.env.NODE_ENV !== "production",
      ...typeof devTools === "object" && devTools
    });
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  if (process.env.NODE_ENV !== "production" && enhancers && typeof enhancers !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "`enhancers` field must be a callback");
  }
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(storeEnhancers)) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "`enhancers` callback must return an array");
  }
  if (process.env.NODE_ENV !== "production" && storeEnhancers.some((item) => typeof item !== "function")) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "each enhancer provided to configureStore must be a function");
  }
  if (process.env.NODE_ENV !== "production" && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) {
    console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  }
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (actionMatchers.length > 0) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        }
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
        }
      }
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(28) : "`builder.addCase` cannot be called with an empty action type");
      }
      if (type in actionsMap) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${type}'`);
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher(matcher, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
        }
      }
      actionMatchers.push({
        matcher,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(31) : "`builder.addDefaultCase` can only be called once");
        }
      }
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}

// src/createReducer.ts
function isStateFunction(x) {
  return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof mapOrBuilderCallback === "object") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
    }
  }
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState)) {
    getInitialState = () => freezeDraftable(initialState());
  } else {
    const frozenInitialState = freezeDraftable(initialState);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher
    }) => matcher(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr) => !!cr).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (isDraft(previousState)) {
          const draft = previousState;
          const result = caseReducer(draft, action);
          if (result === void 0) {
            return previousState;
          }
          return result;
        } else if (!isDraftable(previousState)) {
          const result = caseReducer(previousState, action);
          if (result === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return result;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}

// src/matchers.ts
var matches = (matcher, action) => {
  if (hasMatchFunction(matcher)) {
    return matcher.match(action);
  } else {
    return matcher(action);
  }
};
function isAnyOf(...matchers) {
  return (action) => {
    return matchers.some((matcher) => matches(matcher, action));
  };
}

// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21) => {
  let id = "";
  let i = size;
  while (i--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};

// src/createAsyncThunk.ts
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var FulfillWithMeta = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var miniSerializeError = (value) => {
  if (typeof value === "object" && value !== null) {
    const simpleError = {};
    for (const property of commonProperties) {
      if (typeof value[property] === "string") {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var createAsyncThunk = /* @__PURE__ */ (() => {
  function createAsyncThunk2(typePrefix, payloadCreator, options) {
    const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta) => ({
      payload,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "fulfilled"
      }
    }));
    const pending = createAction(typePrefix + "/pending", (requestId, arg, meta) => ({
      payload: void 0,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "pending"
      }
    }));
    const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta) => ({
      payload,
      error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
      meta: {
        ...meta || {},
        arg,
        requestId,
        rejectedWithValue: !!payload,
        requestStatus: "rejected",
        aborted: error?.name === "AbortError",
        condition: error?.name === "ConditionError"
      }
    }));
    function actionCreator(arg) {
      return (dispatch, getState, extra) => {
        const requestId = options?.idGenerator ? options.idGenerator(arg) : nanoid();
        const abortController = new AbortController();
        let abortHandler;
        let abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        const promise = async function() {
          let finalAction;
          try {
            let conditionResult = options?.condition?.(arg, {
              getState,
              extra
            });
            if (isThenable(conditionResult)) {
              conditionResult = await conditionResult;
            }
            if (conditionResult === false || abortController.signal.aborted) {
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            }
            const abortedPromise = new Promise((_, reject) => {
              abortHandler = () => {
                reject({
                  name: "AbortError",
                  message: abortReason || "Aborted"
                });
              };
              abortController.signal.addEventListener("abort", abortHandler);
            });
            dispatch(pending(requestId, arg, options?.getPendingMeta?.({
              requestId,
              arg
            }, {
              getState,
              extra
            })));
            finalAction = await Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch,
              getState,
              extra,
              requestId,
              signal: abortController.signal,
              abort,
              rejectWithValue: (value, meta) => {
                return new RejectWithValue(value, meta);
              },
              fulfillWithValue: (value, meta) => {
                return new FulfillWithMeta(value, meta);
              }
            })).then((result) => {
              if (result instanceof RejectWithValue) {
                throw result;
              }
              if (result instanceof FulfillWithMeta) {
                return fulfilled(result.payload, requestId, arg, result.meta);
              }
              return fulfilled(result, requestId, arg);
            })]);
          } catch (err) {
            finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
          } finally {
            if (abortHandler) {
              abortController.signal.removeEventListener("abort", abortHandler);
            }
          }
          const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
          if (!skipDispatch) {
            dispatch(finalAction);
          }
          return finalAction;
        }();
        return Object.assign(promise, {
          abort,
          requestId,
          arg,
          unwrap() {
            return promise.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending,
      rejected,
      fulfilled,
      settled: isAnyOf(rejected, fulfilled),
      typePrefix
    });
  }
  createAsyncThunk2.withTypes = () => createAsyncThunk2;
  return createAsyncThunk2;
})();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}

// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function getType(slice, actionKey) {
  return `${slice}/${actionKey}`;
}
function buildCreateSlice({
  creators
} = {}) {
  const cAT = creators?.asyncThunk?.[asyncThunkSymbol];
  return function createSlice2(options) {
    const {
      name,
      reducerPath = name
    } = options;
    if (!name) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
      if (options.initialState === void 0) {
        console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
      }
    }
    const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
    const reducerNames = Object.keys(reducers);
    const context = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    };
    const contextMethods = {
      addCase(typeOrActionCreator, reducer2) {
        const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
        if (!type) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : "`context.addCase` cannot be called with an empty action type");
        }
        if (type in context.sliceCaseReducersByType) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + type);
        }
        context.sliceCaseReducersByType[type] = reducer2;
        return contextMethods;
      },
      addMatcher(matcher, reducer2) {
        context.sliceMatchers.push({
          matcher,
          reducer: reducer2
        });
        return contextMethods;
      },
      exposeAction(name2, actionCreator) {
        context.actionCreators[name2] = actionCreator;
        return contextMethods;
      },
      exposeCaseReducer(name2, reducer2) {
        context.sliceCaseReducersByName[name2] = reducer2;
        return contextMethods;
      }
    };
    reducerNames.forEach((reducerName) => {
      const reducerDefinition = reducers[reducerName];
      const reducerDetails = {
        reducerName,
        type: getType(name, reducerName),
        createNotation: typeof options.reducers === "function"
      };
      if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) {
        handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
      } else {
        handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
      }
    });
    function buildReducer() {
      if (process.env.NODE_ENV !== "production") {
        if (typeof options.extraReducers === "object") {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
        }
      }
      const [extraReducers = {}, actionMatchers = [], defaultCaseReducer = void 0] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers];
      const finalCaseReducers = {
        ...extraReducers,
        ...context.sliceCaseReducersByType
      };
      return createReducer(options.initialState, (builder) => {
        for (let key in finalCaseReducers) {
          builder.addCase(key, finalCaseReducers[key]);
        }
        for (let sM of context.sliceMatchers) {
          builder.addMatcher(sM.matcher, sM.reducer);
        }
        for (let m of actionMatchers) {
          builder.addMatcher(m.matcher, m.reducer);
        }
        if (defaultCaseReducer) {
          builder.addDefaultCase(defaultCaseReducer);
        }
      });
    }
    const selectSelf = (state) => state;
    const injectedSelectorCache = /* @__PURE__ */ new Map();
    let _reducer;
    function reducer(state, action) {
      if (!_reducer) _reducer = buildReducer();
      return _reducer(state, action);
    }
    function getInitialState() {
      if (!_reducer) _reducer = buildReducer();
      return _reducer.getInitialState();
    }
    function makeSelectorProps(reducerPath2, injected = false) {
      function selectSlice(state) {
        let sliceState = state[reducerPath2];
        if (typeof sliceState === "undefined") {
          if (injected) {
            sliceState = getInitialState();
          } else if (process.env.NODE_ENV !== "production") {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : "selectSlice returned undefined for an uninjected slice reducer");
          }
        }
        return sliceState;
      }
      function getSelectors(selectState = selectSelf) {
        const selectorCache = emplace(injectedSelectorCache, injected, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return emplace(selectorCache, selectState, {
          insert: () => {
            const map = {};
            for (const [name2, selector] of Object.entries(options.selectors ?? {})) {
              map[name2] = wrapSelector(selector, selectState, getInitialState, injected);
            }
            return map;
          }
        });
      }
      return {
        reducerPath: reducerPath2,
        getSelectors,
        get selectors() {
          return getSelectors(selectSlice);
        },
        selectSlice
      };
    }
    const slice = {
      name,
      reducer,
      actions: context.actionCreators,
      caseReducers: context.sliceCaseReducersByName,
      getInitialState,
      ...makeSelectorProps(reducerPath),
      injectInto(injectable, {
        reducerPath: pathOpt,
        ...config
      } = {}) {
        const newReducerPath = pathOpt ?? reducerPath;
        injectable.inject({
          reducerPath: newReducerPath,
          reducer
        }, config);
        return {
          ...slice,
          ...makeSelectorProps(newReducerPath, true)
        };
      }
    };
    return slice;
  };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
  function wrapper(rootState, ...args) {
    let sliceState = selectState(rootState);
    if (typeof sliceState === "undefined") {
      if (injected) {
        sliceState = getInitialState();
      } else if (process.env.NODE_ENV !== "production") {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "selectState returned undefined for an uninjected slice reducer");
      }
    }
    return selector(sliceState, ...args);
  }
  wrapper.unwrapped = selector;
  return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
  function asyncThunk(payloadCreator, config) {
    return {
      _reducerDefinitionType: "asyncThunk" /* asyncThunk */,
      payloadCreator,
      ...config
    };
  }
  asyncThunk.withTypes = () => asyncThunk;
  return {
    reducer(caseReducer) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [caseReducer.name](...args) {
          return caseReducer(...args);
        }
      }[caseReducer.name], {
        _reducerDefinitionType: "reducer" /* reducer */
      });
    },
    preparedReducer(prepare, reducer) {
      return {
        _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */,
        prepare,
        reducer
      };
    },
    asyncThunk
  };
}
function handleNormalReducerDefinition({
  type,
  reducerName,
  createNotation
}, maybeReducerWithPrepare, context) {
  let caseReducer;
  let prepareCallback;
  if ("reducer" in maybeReducerWithPrepare) {
    if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    }
    caseReducer = maybeReducerWithPrepare.reducer;
    prepareCallback = maybeReducerWithPrepare.prepare;
  } else {
    caseReducer = maybeReducerWithPrepare;
  }
  context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */;
}
function handleThunkCaseReducerDefinition({
  type,
  reducerName
}, reducerDefinition, context, cAT) {
  if (!cAT) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  }
  const {
    payloadCreator,
    fulfilled,
    pending,
    rejected,
    settled,
    options
  } = reducerDefinition;
  const thunk = cAT(type, payloadCreator, options);
  context.exposeAction(reducerName, thunk);
  if (fulfilled) {
    context.addCase(thunk.fulfilled, fulfilled);
  }
  if (pending) {
    context.addCase(thunk.pending, pending);
  }
  if (rejected) {
    context.addCase(thunk.rejected, rejected);
  }
  if (settled) {
    context.addMatcher(thunk.settled, settled);
  }
  context.exposeCaseReducer(reducerName, {
    fulfilled: fulfilled || noop$2,
    pending: pending || noop$2,
    rejected: rejected || noop$2,
    settled: settled || noop$2
  });
}
function noop$2() {
}

// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
  return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

/**
 * Set a value by a dot path.
 * @param obj The object to evaluate.
 * @param prop The path to be set.
 * @param value The value to set.
 */

var lib$2;
var hasRequiredLib$2;

function requireLib$2 () {
	if (hasRequiredLib$2) return lib$2;
	hasRequiredLib$2 = 1;
	function set(obj, prop, value) {
		prop = typeof prop === 'number' ? propToArray(prop.toString()) : typeof prop === 'string' ? propToArray(prop) : prop;

		const setPropImmutableRec = (obj, prop, value, i) => {
			let clone, head = prop[i];

			if (prop.length > i) {
				if (Array.isArray(obj)) {
					head = getArrayIndex(head, obj);
					clone = obj.slice();
				} else {
					clone = Object.assign({}, obj);
				}
				clone[head] = setPropImmutableRec(obj[head] !== undefined ? obj[head] : {}, prop, value, i + 1);
				return clone;
			}

			return typeof value === 'function' ? value(obj) : value;
		};

		return setPropImmutableRec(obj, prop, value, 0);
	}

	/**
	 * Get a value by a dot path.
	 * @param obj The object to evaluate.
	 * @param prop The path to value that should be returned.
	 * @param [value] The default value that should be returned when the target doesn't exist.
	 */
	function get(obj, prop, value) {
		prop = typeof prop === 'number' ? propToArray(prop.toString()) : typeof prop === 'string' ? propToArray(prop) : prop;

		for (var i = 0; i < prop.length; i++) {
			if (obj === null || typeof obj !== 'object') {
				return value;
			}
			let head = prop[i];
			if (Array.isArray(obj) && head === '$end') {
				head = obj.length - 1;
			}
			obj = obj[head];
		}

		if (typeof obj === 'undefined') {
			return value;
		}

		return obj;
	}

	/**
	 * Delete a property by a dot path.
	 * If target container is an object, the property is deleted.
	 * If target container is an array, the index is deleted.
	 * If target container is undefined, nothing is deleted.
	 * @param obj The object to evaluate.
	 * @param prop The path to the property or index that should be deleted.
	 */
	function _delete(obj, prop) {
		prop = typeof prop === 'number' ? propToArray(prop.toString()) : typeof prop === 'string' ? propToArray(prop) : prop;

		const deletePropImmutableRec = (obj, prop, i) => {
			let clone, head = prop[i];

			if (obj === null || typeof obj !== 'object' ||
				!Array.isArray(obj) && obj[head] === undefined) {

				return obj;
			}

			if (prop.length - 1 > i) {
				if (Array.isArray(obj)) {
					head = getArrayIndex(head, obj);
					clone = obj.slice();
				} else {
					clone = Object.assign({}, obj);
				}

				clone[head] = deletePropImmutableRec(obj[head], prop, i + 1);
				return clone;
			}

			if (Array.isArray(obj)) {
				head = getArrayIndex(head, obj);
				clone = [].concat(obj.slice(0, head), obj.slice(head + 1));
			} else {
				clone = Object.assign({}, obj);
				delete clone[head];
			}

			return clone;
		};

		return deletePropImmutableRec(obj, prop, 0);
	}

	/**
	 * Toggles a value.  The target value is evaluated using Boolean(currentValue).  The result will always be a JSON boolean.
	 * Be careful with strings as target value, as "true" and "false" will toggle to false, but "0" will toggle to true.
	 * Here is what Javascript considers false:  0, -0, null, false, NaN, undefined, and the empty string ("")
	 * @param obj The object to evaluate.
	 * @param prop The path to the value.
	 */
	function toggle(obj, prop) {
		const curVal = get(obj, prop);
		return set(obj, prop, !Boolean(curVal));
	}

	/**
	 * Merges a value.  The target value must be an object, array, null, or undefined.
	 * If target is an object, Object.assign({}, target, param) is used.
	 * If target an array, target.concat(param) is used.
	 * If target is null or undefined, the value is simply set.
	 * @param obj The object to evaluate.
	 * @param prop The path to the value.
	 * @param val The value to merge into the target value.
	 */
	function merge(obj, prop, val) {
		const curVal = get(obj, prop);
		if (typeof curVal === 'object') {
			if (Array.isArray(curVal)) {
				return set(obj, prop, curVal.concat(val));
			} else if (curVal === null) {
				return set(obj, prop, val);
			}
			else {
				let merged = Object.assign({}, curVal, val);
				return set(obj, prop, merged);
			}
		} else if (typeof curVal === 'undefined') {
			return set(obj, prop, val);
		}
		else {
			return obj;
		}
	}

	function getArrayIndex(head, obj) {
		if (head === '$end') {
			head = Math.max(obj.length - 1, 0);
		}
		if (!/^\+?\d+$/.test(head)) {
			throw new Error(`Array index '${head}' has to be an integer`);
		}
		return parseInt(head);
	}

	function propToArray(prop) {
		return prop.split('.').reduce((ret, el, index, list) => {
			const last = index > 0 && list[index - 1];
			if (last && /(?:^|[^\\])\\$/.test(last)) {
				const prev = ret.pop();
				ret.push(prev.slice(0, -1) + '.' + el);
			} else {
				ret.push(el);
			}
			return ret;
		}, []);
	}

	lib$2 = {
		set,
		get,
		delete: _delete,
		toggle,
		merge
	};
	return lib$2;
}

var libExports$1 = requireLib$2();
var dotProp = /*@__PURE__*/getDefaultExportFromCjs(libExports$1);

var isObject$1 = function (item) { return (item && typeof item === 'object' && !Array.isArray(item)); };
function mergeDeep(target, source, cleanup) {
    // target clone erstellen wegen immutable object
    var output = __assign$1({}, target);
    // nur aus dem target entfernen, in source bleiben sie erhalten (damit sie entfernt werden,
    // falls der Server z. B. keine error-Meldung mehr schickt)
    if (cleanup) {
        delete output.error;
        delete output.valueSet;
        delete output.warning;
    }
    if (!isObject$1(output) || !isObject$1(source)) {
        return output;
    }
    var sourceKeyArray = Object.keys(source);
    sourceKeyArray.forEach(function (key) {
        var _a, _b;
        if (isObject$1(source[key])) {
            if (!(key in output)) {
                Object.assign(output, (_a = {}, _a[key] = source[key], _a));
            }
            else {
                output[key] = mergeDeep(output[key], source[key], cleanup);
            }
        }
        else if (key === 'serverChanged') {
            Object.assign(output, { value: source.value === undefined ? '' : source.value });
        }
        else if (key !== 'value') {
            Object.assign(output, (_b = {}, _b[key] = source[key], _b));
        }
    });
    return output;
}
var merge$1 = function (obj, prop, val, cleanup) {
    if (cleanup === void 0) { cleanup = true; }
    var curVal = dotProp.get(obj, prop);
    if (isObject$1(curVal)) {
        var merged = mergeDeep(curVal, val, cleanup);
        return dotProp.set(obj, prop, merged);
    }
    if (Array.isArray(curVal)) {
        return dotProp.set(obj, prop, curVal.concat(val));
    }
    if (typeof curVal === 'undefined' || curVal === null) {
        return dotProp.set(obj, prop, val);
    }
    return obj;
};

var _a;
var updateSlices = createSlice({
    name: 'updates',
    initialState: {
        appDaten: {
            loading: 0,
        },
    },
    reducers: {
        setStore: function (state, action) {
            return dotProp.set(state, action.payload.name, action.payload.value);
        },
        dirtyMergeStore: function (state, action) {
            return merge$1(state, action.payload.name, action.payload.object, false);
        },
        mergeStore: function (state, action) {
            return merge$1(state, action.payload.name, action.payload.object);
        },
        noDeepMerge: function (state, action) {
            return dotProp.merge(state, action.payload.name, action.payload.object);
        },
        pending: function (state, action) {
            if (action.payload) {
                state.appDaten.loading += 1;
                return;
            }
            if (!action.payload && state.appDaten.loading > 0) {
                state.appDaten.loading -= 1;
            }
        },
    },
});
var setStore = (_a = updateSlices.actions, _a.setStore), dirtyMergeStore = _a.dirtyMergeStore, mergeStore = _a.mergeStore, pending = _a.pending, noDeepMerge = _a.noDeepMerge;
var rootReducer = updateSlices.reducer;

var updateByEvent = function (e, cb) {
    if (cb === void 0) { cb = function (state) { }; }
    var target = e.target;
    var value = target.type === 'checkbox' ? !!target.checked : target.value;
    return createAsyncThunk('action/updateByEvent', function (_, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        dispatch(setStore({ name: target.name, value: value }));
        cb(getState());
    })();
};
var updateByName = function (name, value, cb) {
    if (cb === void 0) { cb = function (state) { }; }
    return createAsyncThunk('action/updateByName', function (_, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        dispatch(setStore({ name: name, value: value }));
        cb(getState());
    })();
};
var updateByList = function (list, cb) {
    if (cb === void 0) { cb = function (state) { }; }
    return createAsyncThunk('action/updateByList', function (_, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Object.entries(list).forEach(function (_a) {
            var name = _a[0], value = _a[1];
            dispatch(setStore({ name: name, value: value }));
        });
        cb(getState());
    })();
};
var updateByApi = function (name, object, cb) {
    if (cb === void 0) { cb = function (state) { }; }
    return createAsyncThunk('action/updateByApi', function (_, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        dispatch(mergeStore({ name: name, object: object }));
        cb(getState());
    })();
};
var updateByApiHoleVorbelegung = function (name, object, cb) {
    if (cb === void 0) { cb = function (state) { }; }
    return createAsyncThunk('action/updateByApiHoleVorbelegung', function (_, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        dispatch(dirtyMergeStore({ name: name, object: object }));
        cb(getState());
    })();
};

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  updateByApi: updateByApi,
  updateByApiHoleVorbelegung: updateByApiHoleVorbelegung,
  updateByEvent: updateByEvent,
  updateByList: updateByList,
  updateByName: updateByName
});

var handleLokalSpeichern = function (_a) {
    var dispatch = _a.dispatch, appVersion = _a.appVersion, daten = _a.daten;
    var savedSession = savedStateManager.loadFromLocalStorage();
    var activeSession = savedStateManager.loadFromSessionStorage();
    var savedSessionNotEmpty = !isEmptyObj(savedSession);
    var hasActiveSession = Object.keys(activeSession === null || activeSession === void 0 ? void 0 : activeSession.daten).length > 0;
    var isSameVersion = savedSessionNotEmpty && (savedSession === null || savedSession === void 0 ? void 0 : savedSession.appDaten.version) === appVersion;
    var sameMandant = savedSessionNotEmpty && (savedSession === null || savedSession === void 0 ? void 0 : savedSession.appDaten.mandant) === trEnv$1.mandant;
    var aufrufbar = !trEnv$1.sparkasse
        && !hasActiveSession
        && savedSessionNotEmpty
        && isSameVersion
        && sameMandant;
    if (aufrufbar) {
        dispatch(updateByApiHoleVorbelegung('daten', savedSession.daten));
        dispatch(updateByApiHoleVorbelegung('appDaten', savedSession.appDaten));
        dispatch(updateByName('savedState', EnumSavedState.LOADED));
        return;
    }
    var fehler = !trEnv$1.sparkasse
        && !hasActiveSession
        && savedSessionNotEmpty
        && !isSameVersion;
    if (fehler) {
        window.localStorage.clear();
        dispatch(updateByName('savedState', EnumSavedState.ERROR));
    }
    dispatch(updateByApiHoleVorbelegung('daten', daten.container));
    dispatch(updateByName('appDaten.version', appVersion));
};

/**
 * @deprecated nicht benutzen
 * @param value
 */
var metaInfoPropTypesGenerator = function (value) { return PropTypes.shape({
    relevant: PropTypes.bool,
    ueberschreibbar: PropTypes.bool,
    valueSet: PropTypes.arrayOf(PropTypes.shape({})),
    value: value,
}); };

var axiosWrapper = function (payload, query, onSuccess, onError) {
    if (onSuccess === void 0) { onSuccess = function (data) {
        // This is intended
    }; }
    if (onError === void 0) { onError = function () {
        // This is intended
    }; }
    var formData = new URLSearchParams();
    formData.append('data', JSON.stringify(payload));
    var instance = axios.create({
        withCredentials: process.env.NODE_ENV !== 'development',
        baseURL: window.baseURL,
    });
    instance({
        method: 'POST',
        url: query,
        data: formData,
    }).then(onSuccess)
        .catch(onError);
};

var uaParser$1 = {exports: {}};

var uaParser = uaParser$1.exports;

var hasRequiredUaParser;

function requireUaParser () {
	if (hasRequiredUaParser) return uaParser$1.exports;
	hasRequiredUaParser = 1;
	(function (module, exports) {
		/////////////////////////////////////////////////////////////////////////////////
		/* UAParser.js v1.0.39
		   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
		   MIT License *//*
		   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
		   Supports browser & node.js environment. 
		   Demo   : https://faisalman.github.io/ua-parser-js
		   Source : https://github.com/faisalman/ua-parser-js */
		/////////////////////////////////////////////////////////////////////////////////

		(function (window, undefined$1) {

		    //////////////
		    // Constants
		    /////////////


		    var LIBVERSION  = '1.0.39',
		        EMPTY       = '',
		        UNKNOWN     = '?',
		        FUNC_TYPE   = 'function',
		        UNDEF_TYPE  = 'undefined',
		        OBJ_TYPE    = 'object',
		        STR_TYPE    = 'string',
		        MAJOR       = 'major',
		        MODEL       = 'model',
		        NAME        = 'name',
		        TYPE        = 'type',
		        VENDOR      = 'vendor',
		        VERSION     = 'version',
		        ARCHITECTURE= 'architecture',
		        CONSOLE     = 'console',
		        MOBILE      = 'mobile',
		        TABLET      = 'tablet',
		        SMARTTV     = 'smarttv',
		        WEARABLE    = 'wearable',
		        EMBEDDED    = 'embedded',
		        UA_MAX_LENGTH = 500;

		    var AMAZON  = 'Amazon',
		        APPLE   = 'Apple',
		        ASUS    = 'ASUS',
		        BLACKBERRY = 'BlackBerry',
		        BROWSER = 'Browser',
		        CHROME  = 'Chrome',
		        EDGE    = 'Edge',
		        FIREFOX = 'Firefox',
		        GOOGLE  = 'Google',
		        HUAWEI  = 'Huawei',
		        LG      = 'LG',
		        MICROSOFT = 'Microsoft',
		        MOTOROLA  = 'Motorola',
		        OPERA   = 'Opera',
		        SAMSUNG = 'Samsung',
		        SHARP   = 'Sharp',
		        SONY    = 'Sony',
		        XIAOMI  = 'Xiaomi',
		        ZEBRA   = 'Zebra',
		        FACEBOOK    = 'Facebook',
		        CHROMIUM_OS = 'Chromium OS',
		        MAC_OS  = 'Mac OS',
		        SUFFIX_BROWSER = ' Browser';

		    ///////////
		    // Helper
		    //////////

		    var extend = function (regexes, extensions) {
		            var mergedRegexes = {};
		            for (var i in regexes) {
		                if (extensions[i] && extensions[i].length % 2 === 0) {
		                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
		                } else {
		                    mergedRegexes[i] = regexes[i];
		                }
		            }
		            return mergedRegexes;
		        },
		        enumerize = function (arr) {
		            var enums = {};
		            for (var i=0; i<arr.length; i++) {
		                enums[arr[i].toUpperCase()] = arr[i];
		            }
		            return enums;
		        },
		        has = function (str1, str2) {
		            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
		        },
		        lowerize = function (str) {
		            return str.toLowerCase();
		        },
		        majorize = function (version) {
		            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
		        },
		        trim = function (str, len) {
		            if (typeof(str) === STR_TYPE) {
		                str = str.replace(/^\s\s*/, EMPTY);
		                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
		            }
		    };

		    ///////////////
		    // Map helper
		    //////////////

		    var rgxMapper = function (ua, arrays) {

		            var i = 0, j, k, p, q, matches, match;

		            // loop through all regexes maps
		            while (i < arrays.length && !matches) {

		                var regex = arrays[i],       // even sequence (0,2,4,..)
		                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
		                j = k = 0;

		                // try matching uastring with regexes
		                while (j < regex.length && !matches) {

		                    if (!regex[j]) { break; }
		                    matches = regex[j++].exec(ua);

		                    if (!!matches) {
		                        for (p = 0; p < props.length; p++) {
		                            match = matches[++k];
		                            q = props[p];
		                            // check if given property is actually array
		                            if (typeof q === OBJ_TYPE && q.length > 0) {
		                                if (q.length === 2) {
		                                    if (typeof q[1] == FUNC_TYPE) {
		                                        // assign modified match
		                                        this[q[0]] = q[1].call(this, match);
		                                    } else {
		                                        // assign given value, ignore regex match
		                                        this[q[0]] = q[1];
		                                    }
		                                } else if (q.length === 3) {
		                                    // check whether function or regex
		                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
		                                        // call function (usually string mapper)
		                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
		                                    } else {
		                                        // sanitize match using given regex
		                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
		                                    }
		                                } else if (q.length === 4) {
		                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
		                                }
		                            } else {
		                                this[q] = match ? match : undefined$1;
		                            }
		                        }
		                    }
		                }
		                i += 2;
		            }
		        },

		        strMapper = function (str, map) {

		            for (var i in map) {
		                // check if current value is array
		                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
		                    for (var j = 0; j < map[i].length; j++) {
		                        if (has(map[i][j], str)) {
		                            return (i === UNKNOWN) ? undefined$1 : i;
		                        }
		                    }
		                } else if (has(map[i], str)) {
		                    return (i === UNKNOWN) ? undefined$1 : i;
		                }
		            }
		            return map.hasOwnProperty('*') ? map['*'] : str;
		    };

		    ///////////////
		    // String map
		    //////////////

		    // Safari < 3.0
		    var oldSafariMap = {
		            '1.0'   : '/8',
		            '1.2'   : '/1',
		            '1.3'   : '/3',
		            '2.0'   : '/412',
		            '2.0.2' : '/416',
		            '2.0.3' : '/417',
		            '2.0.4' : '/419',
		            '?'     : '/'
		        },
		        windowsVersionMap = {
		            'ME'        : '4.90',
		            'NT 3.11'   : 'NT3.51',
		            'NT 4.0'    : 'NT4.0',
		            '2000'      : 'NT 5.0',
		            'XP'        : ['NT 5.1', 'NT 5.2'],
		            'Vista'     : 'NT 6.0',
		            '7'         : 'NT 6.1',
		            '8'         : 'NT 6.2',
		            '8.1'       : 'NT 6.3',
		            '10'        : ['NT 6.4', 'NT 10.0'],
		            'RT'        : 'ARM'
		    };

		    //////////////
		    // Regex map
		    /////////////

		    var regexes = {

		        browser : [[

		            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
		            ], [VERSION, [NAME, 'Chrome']], [
		            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
		            ], [VERSION, [NAME, 'Edge']], [

		            // Presto based
		            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
		            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
		            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
		            ], [NAME, VERSION], [
		            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
		            ], [VERSION, [NAME, OPERA+' Mini']], [
		            /\bop(?:rg)?x\/([\w\.]+)/i                                          // Opera GX
		            ], [VERSION, [NAME, OPERA+' GX']], [
		            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
		            ], [VERSION, [NAME, OPERA]], [

		            // Mixed
		            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
		            ], [VERSION, [NAME, 'Baidu']], [
		            /(kindle)\/([\w\.]+)/i,                                             // Kindle
		            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,      
		                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
		            // Trident based
		            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
		            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

		            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
		            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio)\/([-\w\.]+)/i,
		                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio
		            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // HeyTap/Ovi
		            /(weibo)__([\d\.]+)/i                                               // Weibo
		            ], [NAME, VERSION], [
		            /quark(?:pc)?\/([-\w\.]+)/i                                         // Quark
		            ], [VERSION, [NAME, 'Quark']], [
		            /\bddg\/([\w\.]+)/i                                                 // DuckDuckGo
		            ], [VERSION, [NAME, 'DuckDuckGo']], [
		            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
		            ], [VERSION, [NAME, 'UC'+BROWSER]], [
		            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
		            /\bqbcore\/([\w\.]+).+microm/i,
		            /micromessenger\/([\w\.]+)/i                                        // WeChat
		            ], [VERSION, [NAME, 'WeChat']], [
		            /konqueror\/([\w\.]+)/i                                             // Konqueror
		            ], [VERSION, [NAME, 'Konqueror']], [
		            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
		            ], [VERSION, [NAME, 'IE']], [
		            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
		            ], [VERSION, [NAME, 'Yandex']], [
		            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
		            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
		            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
		            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
		            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
		            ], [VERSION, [NAME, FIREFOX+' Focus']], [
		            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
		            ], [VERSION, [NAME, OPERA+' Touch']], [
		            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
		            ], [VERSION, [NAME, 'Coc Coc']], [
		            /dolfin\/([\w\.]+)/i                                                // Dolphin
		            ], [VERSION, [NAME, 'Dolphin']], [
		            /coast\/([\w\.]+)/i                                                 // Opera Coast
		            ], [VERSION, [NAME, OPERA+' Coast']], [
		            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
		            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
		            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
		            ], [VERSION, [NAME, FIREFOX]], [
		            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
		            ], [[NAME, '360' + SUFFIX_BROWSER]], [
		            /\b(qq)\/([\w\.]+)/i                                                // QQ
		            ], [[NAME, /(.+)/, '$1Browser'], VERSION], [
		            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
		            ], [[NAME, /(.+)/, '$1' + SUFFIX_BROWSER], VERSION], [              // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
		            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
		            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
		            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
		            ], [[NAME, /_/g, ' '], VERSION], [
		            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
		            ], [VERSION, [NAME, 'Sogou Explorer']], [
		            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
		            ], [[NAME, 'Sogou Mobile'], VERSION], [
		            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
		            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
		            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i                        // QQBrowser/2345 Browser
		            ], [NAME, VERSION], [
		            /(lbbrowser|rekonq)/i,                                              // LieBao Browser/Rekonq
		            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
		            ], [NAME], [

		            // WebView
		            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
		            ], [[NAME, FACEBOOK], VERSION], [
		            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
		            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
		            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
		            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
		            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
		            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
		            /(twitter)(?:and| f.+e\/([\w\.]+))/i,                               // Twitter
		            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
		            ], [NAME, VERSION], [
		            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
		            ], [VERSION, [NAME, 'GSA']], [
		            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
		            ], [VERSION, [NAME, 'TikTok']], [

		            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
		            ], [VERSION, [NAME, CHROME+' Headless']], [

		            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
		            ], [[NAME, CHROME+' WebView'], VERSION], [

		            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
		            ], [VERSION, [NAME, 'Android '+BROWSER]], [

		            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
		            ], [NAME, VERSION], [

		            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
		            ], [VERSION, [NAME, 'Mobile Safari']], [
		            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
		            ], [VERSION, NAME], [
		            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
		            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

		            /(webkit|khtml)\/([\w\.]+)/i
		            ], [NAME, VERSION], [

		            // Gecko based
		            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
		            ], [[NAME, 'Netscape'], VERSION], [
		            /(wolvic)\/([\w\.]+)/i                                              // Wolvic
		            ], [NAME, VERSION], [
		            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
		            ], [VERSION, [NAME, FIREFOX+' Reality']], [
		            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
		            /(swiftfox)/i,                                                      // Swiftfox
		            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
		                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
		            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
		                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
		            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
		            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

		            // Other
		            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
		                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
		            /(links) \(([\w\.]+)/i                                              // Links
		            ], [NAME, [VERSION, /_/g, '.']], [
		            
		            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
		            ], [NAME, [VERSION, /master.|lts./, ""]]
		        ],

		        cpu : [[

		            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
		            ], [[ARCHITECTURE, 'amd64']], [

		            /(ia32(?=;))/i                                                      // IA32 (quicktime)
		            ], [[ARCHITECTURE, lowerize]], [

		            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
		            ], [[ARCHITECTURE, 'ia32']], [

		            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
		            ], [[ARCHITECTURE, 'arm64']], [

		            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
		            ], [[ARCHITECTURE, 'armhf']], [

		            // PocketPC mistakenly identified as PowerPC
		            /windows (ce|mobile); ppc;/i
		            ], [[ARCHITECTURE, 'arm']], [

		            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
		            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

		            /(sun4\w)[;\)]/i                                                    // SPARC
		            ], [[ARCHITECTURE, 'sparc']], [

		            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
		                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
		            ], [[ARCHITECTURE, lowerize]]
		        ],

		        device : [[

		            //////////////////////////
		            // MOBILES & TABLETS
		            /////////////////////////

		            // Samsung
		            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
		            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
		            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
		            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
		            /sec-(sgh\w+)/i
		            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

		            // Apple
		            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
		            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
		            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
		            /applecoremedia\/[\w\.]+ \((ipad)/i,
		            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
		            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
		            /(macintosh);/i
		            ], [MODEL, [VENDOR, APPLE]], [

		            // Sharp
		            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
		            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

		            // Huawei
		            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
		            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
		            /(?:huawei|honor)([-\w ]+)[;\)]/i,
		            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
		            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

		            // Xiaomi
		            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
		            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
		            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
		            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
		            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
		            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
		            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
		            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
		            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
		            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

		            // OPPO
		            /; (\w+) bui.+ oppo/i,
		            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
		            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
		            /\b(opd2\d{3}a?) bui/i
		            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, TABLET]], [

		            // Vivo
		            /vivo (\w+)(?: bui|\))/i,
		            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
		            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

		            // Realme
		            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
		            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

		            // Motorola
		            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
		            /\bmot(?:orola)?[- ](\w*)/i,
		            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
		            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
		            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
		            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

		            // LG
		            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
		            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
		            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
		            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
		            /\blg-?([\d\w]+) bui/i
		            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

		            // Lenovo
		            /(ideatab[-\w ]+)/i,
		            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
		            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

		            // Nokia
		            /(?:maemo|nokia).*(n900|lumia \d+)/i,
		            /nokia[-_ ]?([-\w\.]*)/i
		            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

		            // Google
		            /(pixel c)\b/i                                                      // Google Pixel C
		            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
		            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
		            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

		            // Sony
		            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
		            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
		            /sony tablet [ps]/i,
		            /\b(?:sony)?sgp\w+(?: bui|\))/i
		            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

		            // OnePlus
		            / (kb2005|in20[12]5|be20[12][59])\b/i,
		            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
		            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

		            // Amazon
		            /(alexa)webm/i,
		            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,                           // Kindle Fire without Silk / Echo Show
		            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
		            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
		            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
		            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

		            // BlackBerry
		            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
		            ], [MODEL, VENDOR, [TYPE, TABLET]], [
		            /\b((?:bb[a-f]|st[hv])100-\d)/i,
		            /\(bb10; (\w+)/i                                                    // BlackBerry 10
		            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

		            // Asus
		            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
		            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
		            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
		            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

		            // HTC
		            /(nexus 9)/i                                                        // HTC Nexus 9
		            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
		            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

		            // ZTE
		            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
		            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
		            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

		            // TCL
		            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
		            ], [MODEL, [VENDOR, 'TCL'], [TYPE, TABLET]], [

		            // itel
		            /(itel) ((\w+))/i
		            ], [[VENDOR, lowerize], MODEL, [TYPE, strMapper, { 'tablet' : ['p10001l', 'w7001'], '*' : 'mobile' }]], [

		            // Acer
		            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
		            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

		            // Meizu
		            /droid.+; (m[1-5] note) bui/i,
		            /\bmz-([-\w]{2,})/i
		            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
		                
		            // Ulefone
		            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
		            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [

		            // Nothing
		            /droid.+; (a(?:015|06[35]|142p?))/i
		            ], [MODEL, [VENDOR, 'Nothing'], [TYPE, MOBILE]], [

		            // MIXED
		            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
		                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
		            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
		            /(asus)-?(\w+)/i,                                                   // Asus
		            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
		            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
		            /(jolla)/i,                                                         // Jolla
		            /(oppo) ?([\w ]+) bui/i                                             // OPPO
		            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

		            /(kobo)\s(ereader|touch)/i,                                         // Kobo
		            /(archos) (gamepad2?)/i,                                            // Archos
		            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
		            /(kindle)\/([\w\.]+)/i,                                             // Kindle
		            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
		            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
		            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
		            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
		            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
		            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
		            ], [VENDOR, MODEL, [TYPE, TABLET]], [

		            /(surface duo)/i                                                    // Surface Duo
		            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
		            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
		            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
		            /(u304aa)/i                                                         // AT&T
		            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
		            /\bsie-(\w*)/i                                                      // Siemens
		            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
		            /\b(rct\w+) b/i                                                     // RCA Tablets
		            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
		            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
		            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
		            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
		            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
		            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
		            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
		            /\b(tm\d{3}\w+) b/i
		            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
		            /\b(k88) b/i                                                        // ZTE K Series Tablet
		            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
		            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
		            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
		            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
		            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
		            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
		            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
		            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
		            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
		            /\b([yr]\d{2}) b/i,
		            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
		            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
		            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
		            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
		            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
		            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
		            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
		            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
		            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
		            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
		            /\b(ph-1) /i                                                        // Essential PH-1
		            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
		            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
		            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
		            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
		            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
		            /\btu_(1491) b/i                                                    // Rotor Tablets
		            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
		            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
		            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
		            /(sprint) (\w+)/i                                                   // Sprint Phones
		            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
		            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
		            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
		            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
		            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
		            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
		            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

		            ///////////////////
		            // SMARTTVS
		            ///////////////////

		            /smart-tv.+(samsung)/i                                              // Samsung
		            ], [VENDOR, [TYPE, SMARTTV]], [
		            /hbbtv.+maple;(\d+)/i
		            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
		            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
		            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
		            /(apple) ?tv/i                                                      // Apple TV
		            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
		            /crkey/i                                                            // Google Chromecast
		            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
		            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
		            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
		            /\(dtv[\);].+(aquos)/i,
		            /(aquos-tv[\w ]+)\)/i                                               // Sharp
		            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
		            /(bravia[\w ]+)( bui|\))/i                                              // Sony
		            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
		            /(mitv-\w{5}) bui/i                                                 // Xiaomi
		            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
		            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
		            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
		            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
		            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
		            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
		            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
		            ], [[TYPE, SMARTTV]], [

		            ///////////////////
		            // CONSOLES
		            ///////////////////

		            /(ouya)/i,                                                          // Ouya
		            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
		            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
		            /droid.+; (shield) bui/i                                            // Nvidia
		            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
		            /(playstation [345portablevi]+)/i                                   // Playstation
		            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
		            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
		            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

		            ///////////////////
		            // WEARABLES
		            ///////////////////

		            /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i                                   // Samsung Galaxy Watch
		            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, WEARABLE]], [
		            /((pebble))app/i                                                    // Pebble
		            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
		            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
		            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
		            /droid.+; (glass) \d/i                                              // Google Glass
		            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
		            /droid.+; (wt63?0{2,3})\)/i
		            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
		            /(quest( \d| pro)?)/i                                               // Oculus Quest
		            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

		            ///////////////////
		            // EMBEDDED
		            ///////////////////

		            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
		            ], [VENDOR, [TYPE, EMBEDDED]], [
		            /(aeobc)\b/i                                                        // Echo Dot
		            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

		            ////////////////////
		            // MIXED (GENERIC)
		            ///////////////////

		            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
		            ], [MODEL, [TYPE, MOBILE]], [
		            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
		            ], [MODEL, [TYPE, TABLET]], [
		            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
		            ], [[TYPE, TABLET]], [
		            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
		            ], [[TYPE, MOBILE]], [
		            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
		            ], [MODEL, [VENDOR, 'Generic']]
		        ],

		        engine : [[

		            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
		            ], [VERSION, [NAME, EDGE+'HTML']], [

		            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
		            ], [VERSION, [NAME, 'Blink']], [

		            /(presto)\/([\w\.]+)/i,                                             // Presto
		            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
		            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
		            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
		            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
		            /\b(libweb)/i
		            ], [NAME, VERSION], [

		            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
		            ], [VERSION, NAME]
		        ],

		        os : [[

		            // Windows
		            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
		            ], [NAME, VERSION], [
		            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
		            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
		            /windows nt 6\.2; (arm)/i,                                        // Windows RT
		            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
		            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
		            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [

		            // iOS/macOS
		            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
		            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
		            /cfnetwork\/.+darwin/i
		            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
		            /(mac os x) ?([\w\. ]*)/i,
		            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
		            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

		            // Mobile OSes
		            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
		            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
		            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
		            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
		            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
		            /\((series40);/i                                                    // Series 40
		            ], [NAME, VERSION], [
		            /\(bb(10);/i                                                        // BlackBerry 10
		            ], [VERSION, [NAME, BLACKBERRY]], [
		            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
		            ], [VERSION, [NAME, 'Symbian']], [
		            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
		            ], [VERSION, [NAME, FIREFOX+' OS']], [
		            /web0s;.+rt(tv)/i,
		            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
		            ], [VERSION, [NAME, 'webOS']], [
		            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
		            ], [VERSION, [NAME, 'watchOS']], [

		            // Google Chromecast
		            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
		            ], [VERSION, [NAME, CHROME+'cast']], [
		            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
		            ], [[NAME, CHROMIUM_OS], VERSION],[

		            // Smart TVs
		            /panasonic;(viera)/i,                                               // Panasonic Viera
		            /(netrange)mmh/i,                                                   // Netrange
		            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

		            // Console
		            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
		            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

		            // Other
		            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
		            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
		            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
		            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
		                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
		            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
		            /(gnu) ?([\w\.]*)/i,                                                // GNU
		            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
		            /(haiku) (\w+)/i                                                    // Haiku
		            ], [NAME, VERSION], [
		            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
		            ], [[NAME, 'Solaris'], VERSION], [
		            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
		            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
		            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
		            /(unix) ?([\w\.]*)/i                                                // UNIX
		            ], [NAME, VERSION]
		        ]
		    };

		    /////////////////
		    // Constructor
		    ////////////////

		    var UAParser = function (ua, extensions) {

		        if (typeof ua === OBJ_TYPE) {
		            extensions = ua;
		            ua = undefined$1;
		        }

		        if (!(this instanceof UAParser)) {
		            return new UAParser(ua, extensions).getResult();
		        }

		        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined$1;
		        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
		        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined$1;
		        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
		        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

		        this.getBrowser = function () {
		            var _browser = {};
		            _browser[NAME] = undefined$1;
		            _browser[VERSION] = undefined$1;
		            rgxMapper.call(_browser, _ua, _rgxmap.browser);
		            _browser[MAJOR] = majorize(_browser[VERSION]);
		            // Brave-specific detection
		            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
		                _browser[NAME] = 'Brave';
		            }
		            return _browser;
		        };
		        this.getCPU = function () {
		            var _cpu = {};
		            _cpu[ARCHITECTURE] = undefined$1;
		            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
		            return _cpu;
		        };
		        this.getDevice = function () {
		            var _device = {};
		            _device[VENDOR] = undefined$1;
		            _device[MODEL] = undefined$1;
		            _device[TYPE] = undefined$1;
		            rgxMapper.call(_device, _ua, _rgxmap.device);
		            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
		                _device[TYPE] = MOBILE;
		            }
		            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
		            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
		                _device[MODEL] = 'iPad';
		                _device[TYPE] = TABLET;
		            }
		            return _device;
		        };
		        this.getEngine = function () {
		            var _engine = {};
		            _engine[NAME] = undefined$1;
		            _engine[VERSION] = undefined$1;
		            rgxMapper.call(_engine, _ua, _rgxmap.engine);
		            return _engine;
		        };
		        this.getOS = function () {
		            var _os = {};
		            _os[NAME] = undefined$1;
		            _os[VERSION] = undefined$1;
		            rgxMapper.call(_os, _ua, _rgxmap.os);
		            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') {
		                _os[NAME] = _uach.platform  
		                                    .replace(/chrome os/i, CHROMIUM_OS)
		                                    .replace(/macos/i, MAC_OS);           // backward compatibility
		            }
		            return _os;
		        };
		        this.getResult = function () {
		            return {
		                ua      : this.getUA(),
		                browser : this.getBrowser(),
		                engine  : this.getEngine(),
		                os      : this.getOS(),
		                device  : this.getDevice(),
		                cpu     : this.getCPU()
		            };
		        };
		        this.getUA = function () {
		            return _ua;
		        };
		        this.setUA = function (ua) {
		            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
		            return this;
		        };
		        this.setUA(_ua);
		        return this;
		    };

		    UAParser.VERSION = LIBVERSION;
		    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
		    UAParser.CPU = enumerize([ARCHITECTURE]);
		    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
		    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

		    ///////////
		    // Export
		    //////////

		    // check js environment
		    {
		        // nodejs env
		        if (module.exports) {
		            exports = module.exports = UAParser;
		        }
		        exports.UAParser = UAParser;
		    }

		    // jQuery/Zepto specific (optional)
		    // Note:
		    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
		    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
		    //   and we should catch that.
		    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
		    if ($ && !$.ua) {
		        var parser = new UAParser();
		        $.ua = parser.getResult();
		        $.ua.get = function () {
		            return parser.getUA();
		        };
		        $.ua.set = function (ua) {
		            parser.setUA(ua);
		            var result = parser.getResult();
		            for (var prop in result) {
		                $.ua[prop] = result[prop];
		            }
		        };
		    }

		})(typeof window === 'object' ? window : uaParser); 
	} (uaParser$1, uaParser$1.exports));
	return uaParser$1.exports;
}

var uaParserExports = requireUaParser();
var UAParser = /*@__PURE__*/getDefaultExportFromCjs(uaParserExports);

var parseUA = function (userAgent) {
    if (userAgent === void 0) { userAgent = window.navigator.userAgent; }
    var parser = new UAParser(userAgent);
    return ({
        fullName: parser.getUA(),
        name: parser.getBrowser().name,
        version: parser.getBrowser().version,
        os: "".concat(parser.getOS().name, " ").concat(parser.getOS().version),
        device: parser.getDevice().type,
    });
};

var tracker = function (appName, field, content) {
    var parsedUA = parseUA();
    var vkanal = trEnv$1.vkanal;
    var searchParams = new URLSearchParams(window.location.search);
    var vtnr = searchParams.get('vtnr') || trEnv$1.vtnr;
    if (!trEnv$1.sparkasse && vtnr) {
        vkanal = 'internet_ad';
    }
    axiosWrapper([{
            product: appName,
            client: "".concat(parsedUA.device || 'desktop', " ").concat(parsedUA.name, " ").concat(parsedUA.version),
            tstamp: Date.now().toString(),
            uuid: uuid,
            field: field,
            content: content,
            mandant: trEnv$1.mandant,
            vkanal: vkanal,
        }], '/track');
};

var logger = function (appName, message, details) {
    var parsedUA = parseUA();
    if (message.includes('500')) {
        return;
    }
    axiosWrapper({
        anwendung: appName,
        client: parsedUA.device || 'desktop',
        fehlerStelle: 'Error',
        errorTextList: [message],
        additionalData: {
            ua: "".concat(parsedUA.name, " ").concat(parsedUA.version, ", ").concat(parsedUA.device || 'desktop'),
            uaFull: parsedUA.fullName,
            os: parsedUA.os,
            message: message,
            details: details,
            location: window.location.href,
        },
    }, '/error', function (response) { return console.warn(response.data.fehlerid); });
};

var FileSaver_min$1 = {exports: {}};

var FileSaver_min = FileSaver_min$1.exports;

var hasRequiredFileSaver_min;

function requireFileSaver_min () {
	if (hasRequiredFileSaver_min) return FileSaver_min$1.exports;
	hasRequiredFileSaver_min = 1;
	(function (module, exports) {
		(function(a,b){b();})(FileSaver_min,function(){function b(a,b){return "undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c);},d.onerror=function(){console.error("could not download file");},d.send();}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send();}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"));}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b);}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof commonjsGlobal&&commonjsGlobal.global===commonjsGlobal?commonjsGlobal:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href);},4E4),setTimeout(function(){e(j);},0));}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else {var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i);});}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null;},k.readAsDataURL(b);}else {var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m);},4E4);}});f.saveAs=g.saveAs=g,(module.exports=g);});

		
	} (FileSaver_min$1));
	return FileSaver_min$1.exports;
}

var FileSaver_minExports = requireFileSaver_min();
var fileSaver = /*@__PURE__*/getDefaultExportFromCjs(FileSaver_minExports);

/**
 * nimmt einen response blob entgegen und wandelt es in eine PDF um
 * @param {ArrayBuffer} response
 * @param {string} name
 * @return {void}
 */
var blobToPDF = function (response, name) {
    if (name === void 0) { name = 'dokument.pdf'; }
    if (response == null || (response === null || response === void 0 ? void 0 : response.type) === 'application/json') {
        return;
    }
    // workaround für sapp iOS & Android
    if (trEnv$1.sApp()) {
        var pdfBlob = new Blob([response], { type: 'application/pdf' });
        var reader_1 = new FileReader();
        reader_1.readAsDataURL(pdfBlob);
        reader_1.onloadend = function () {
            window.open(reader_1.result, '_blank', 'fullscreen=yes');
        };
        return;
    }
    // workaround für Berater IPad & sapp android
    if (trEnv$1.ipad()) {
        var pdfBlob = new Blob([response], { type: 'application/pdf' });
        var pdfUrl_1 = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl_1, '_blank', 'fullscreen=yes');
        window.setTimeout(function () {
            URL.revokeObjectURL(pdfUrl_1);
        }, 4e4);
        return;
    }
    // workaround für sparkasse
    if (trEnv$1.sparkasse) {
        var pdfBlob = new Blob([response], { type: 'application/pdf' });
        fileSaver.saveAs(pdfBlob, name);
        return;
    }
    // zum herunterladen auf iOS notwendig
    var octectBlob = new Blob([response], { type: 'application/octet-stream' });
    var octectUrl = URL.createObjectURL(octectBlob);
    var downloadLink = document.createElement('a');
    downloadLink.href = octectUrl;
    downloadLink.download = name;
    downloadLink.click();
    downloadLink.remove();
    window.setTimeout(function () {
        URL.revokeObjectURL(octectUrl);
    }, 4e4);
};

/**
 * scrolls to html element
 *
 * @param {HTMLElement} element
 */
/**
 * Scroll to element innerhalb der spk
 * @param {number} position
 */
var spkScrollTo = function (position) {
    if (position === void 0) { position = 0; }
    if (window.OSPlusNeo) {
        window.OSPlusNeo.scrollTo(position);
    }
};
/**
 * scrolls to error
 * @returns {void}
 */
var scrollToError = function (topOffset) {
    if (topOffset === void 0) { topOffset = 0; }
    window.setTimeout(function () {
        var _a;
        var error = document.getElementsByClassName('invalid-feedback')[0];
        var errorTopPosition = (_a = error.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top;
        if (error && errorTopPosition) {
            var scrollTop = window.scrollY || document.documentElement.scrollTop;
            var stickyHeader = document.querySelectorAll('#header_container .sticky')[0];
            var hasModal_1 = error.closest('.modal');
            var position_1 = errorTopPosition + scrollTop - 100;
            if (stickyHeader) {
                position_1 -= stickyHeader.offsetHeight;
            }
            if (topOffset) {
                position_1 -= topOffset;
            }
            window.setTimeout(function () {
                if (hasModal_1) {
                    hasModal_1.scrollTo({
                        top: position_1,
                        behavior: 'smooth',
                    });
                    return;
                }
                window.scrollTo({
                    top: position_1,
                    behavior: 'smooth',
                });
                spkScrollTo(position_1);
            }, 100);
            var input = error.getElementsByTagName('input')[0];
            if (input) {
                input.focus();
            }
        }
    }, 100);
};
/**
 * checks for errors
 *
 * @param {Object[]} array
 * @param {Function} [onSuccess]
 * @param {Function} [onError]
 */
var checkError = function (array, onSuccess, onError) {
    if (onSuccess === void 0) { onSuccess = function () { }; }
    if (onError === void 0) { onError = scrollToError; }
    var error = array.find(function (elem) { return (elem.error); });
    if (!error) {
        onSuccess();
    }
    else {
        onError();
    }
};

/**
 * checks string in form of dd.mm.yyyy if correct
 *
 * @param {string} date
 * @returns {boolean}
 */
var isValidDate = function (date) {
    // If string includes underscore return early
    if (!date || date.indexOf('_') >= 0) {
        return false;
    }
    var bits = date.split('.');
    var y = parseInt(bits[2], 10);
    var m = parseInt(bits[1], 10) - 1;
    var d = parseInt(bits[0], 10);
    // Check the ranges of month and year
    if (y < 1000 || y > 3000 || m < 0 || m > 12) {
        return false;
    }
    // Assume not leap year by default (note zero index for Jan)
    var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    // If evenly divisible by 4 and not evenly divisible by 100,
    // or is evenly divisible by 400, then a leap year
    if ((!(y % 4) && y % 100) || !(y % 400)) {
        daysInMonth[1] = 29;
    }
    return !(/\D/.test(String(d))) && d > 0 && d <= daysInMonth[m];
};
var dateToISO = function (date) {
    var sliced = date.split('.');
    var reversed = __spreadArray$1([], sliced, true).reverse();
    return reversed.join('-');
};
/**
 * Returns the age of a given birthdate
 *
 * @param {string} dateString - ISO 8601 Date Time String Format
 * @returns {number}
 */
var getAge = function (dateString) {
    var age = null;
    if (isValidDate(dateString)) {
        var today = new Date();
        var birthDate = new Date(dateToISO(dateString));
        age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age -= 1;
        }
    }
    return age;
};

var lodash_merge = {exports: {}};

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash_merge.exports;

var hasRequiredLodash_merge;

function requireLodash_merge () {
	if (hasRequiredLodash_merge) return lodash_merge.exports;
	hasRequiredLodash_merge = 1;
	(function (module, exports) {
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;

		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';

		/** Used to detect hot functions by number of calls within a span of milliseconds. */
		var HOT_COUNT = 800,
		    HOT_SPAN = 16;

		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;

		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    asyncTag = '[object AsyncFunction]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    nullTag = '[object Null]',
		    objectTag = '[object Object]',
		    proxyTag = '[object Proxy]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    undefinedTag = '[object Undefined]',
		    weakMapTag = '[object WeakMap]';

		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';

		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;

		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;

		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;

		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;

		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    // Use `util.types` for Node.js 10+.
		    var types = freeModule && freeModule.require && freeModule.require('util').types;

		    if (types) {
		      return types;
		    }

		    // Legacy `process.binding('util')` for Node.js < 10.
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}());

		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

		/**
		 * A faster alternative to `Function#apply`, this function invokes `func`
		 * with the `this` binding of `thisArg` and the arguments of `args`.
		 *
		 * @private
		 * @param {Function} func The function to invoke.
		 * @param {*} thisArg The `this` binding of `func`.
		 * @param {Array} args The arguments to invoke `func` with.
		 * @returns {*} Returns the result of `func`.
		 */
		function apply(func, thisArg, args) {
		  switch (args.length) {
		    case 0: return func.call(thisArg);
		    case 1: return func.call(thisArg, args[0]);
		    case 2: return func.call(thisArg, args[0], args[1]);
		    case 3: return func.call(thisArg, args[0], args[1], args[2]);
		  }
		  return func.apply(thisArg, args);
		}

		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);

		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}

		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}

		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}

		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}

		/** Used for built-in method references. */
		var arrayProto = Array.prototype,
		    funcProto = Function.prototype,
		    objectProto = Object.prototype;

		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];

		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;

		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;

		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());

		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;

		/** Used to infer the `Object` constructor. */
		var objectCtorString = funcToString.call(Object);

		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);

		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined,
		    Symbol = root.Symbol,
		    Uint8Array = root.Uint8Array;
		    Buffer ? Buffer.allocUnsafe : undefined;
		    var getPrototype = overArg(Object.getPrototypeOf, Object),
		    objectCreate = Object.create,
		    propertyIsEnumerable = objectProto.propertyIsEnumerable,
		    splice = arrayProto.splice,
		    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

		var defineProperty = (function() {
		  try {
		    var func = getNative(Object, 'defineProperty');
		    func({}, '', {});
		    return func;
		  } catch (e) {}
		}());

		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
		    nativeMax = Math.max,
		    nativeNow = Date.now;

		/* Built-in method references that are verified to be native. */
		var Map = getNative(root, 'Map'),
		    nativeCreate = getNative(Object, 'create');

		/**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} proto The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */
		var baseCreate = (function() {
		  function object() {}
		  return function(proto) {
		    if (!isObject(proto)) {
		      return {};
		    }
		    if (objectCreate) {
		      return objectCreate(proto);
		    }
		    object.prototype = proto;
		    var result = new object;
		    object.prototype = undefined;
		    return result;
		  };
		}());

		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  var result = this.has(key) && delete this.__data__[key];
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}

		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
		}

		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  this.size += this.has(key) ? 0 : 1;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}

		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;

		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  --this.size;
		  return true;
		}

		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  return index < 0 ? undefined : data[index][1];
		}

		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}

		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    ++this.size;
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}

		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;

		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.size = 0;
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}

		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  var result = getMapData(this, key)['delete'](key);
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}

		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}

		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  var data = getMapData(this, key),
		      size = data.size;

		  data.set(key, value);
		  this.size += data.size == size ? 0 : 1;
		  return this;
		}

		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;

		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  var data = this.__data__ = new ListCache(entries);
		  this.size = data.size;
		}

		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  var data = this.__data__,
		      result = data['delete'](key);

		  this.size = data.size;
		  return result;
		}

		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}

		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}

		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var data = this.__data__;
		  if (data instanceof ListCache) {
		    var pairs = data.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      this.size = ++data.size;
		      return this;
		    }
		    data = this.__data__ = new MapCache(pairs);
		  }
		  data.set(key, value);
		  this.size = data.size;
		  return this;
		}

		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;

		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  var isArr = isArray(value),
		      isArg = !isArr && isArguments(value),
		      isBuff = !isArr && !isArg && isBuffer(value),
		      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
		      skipIndexes = isArr || isArg || isBuff || isType,
		      result = skipIndexes ? baseTimes(value.length, String) : [],
		      length = result.length;

		  for (var key in value) {
		    if (!(skipIndexes && (
		           // Safari 9 has enumerable `arguments.length` in strict mode.
		           key == 'length' ||
		           // Node.js 0.10 has enumerable non-index properties on buffers.
		           (isBuff && (key == 'offset' || key == 'parent')) ||
		           // PhantomJS 2 has enumerable non-index properties on typed arrays.
		           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
		           // Skip index properties.
		           isIndex(key, length)
		        ))) {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * This function is like `assignValue` except that it doesn't assign
		 * `undefined` values.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignMergeValue(object, key, value) {
		  if ((value !== undefined && !eq(object[key], value)) ||
		      (value === undefined && !(key in object))) {
		    baseAssignValue(object, key, value);
		  }
		}

		/**
		 * Assigns `value` to `key` of `object` if the existing value is not equivalent
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignValue(object, key, value) {
		  var objValue = object[key];
		  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
		      (value === undefined && !(key in object))) {
		    baseAssignValue(object, key, value);
		  }
		}

		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}

		/**
		 * The base implementation of `assignValue` and `assignMergeValue` without
		 * value checks.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function baseAssignValue(object, key, value) {
		  if (key == '__proto__' && defineProperty) {
		    defineProperty(object, key, {
		      'configurable': true,
		      'enumerable': true,
		      'value': value,
		      'writable': true
		    });
		  } else {
		    object[key] = value;
		  }
		}

		/**
		 * The base implementation of `baseForOwn` which iterates over `object`
		 * properties returned by `keysFunc` and invokes `iteratee` for each property.
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @returns {Object} Returns `object`.
		 */
		var baseFor = createBaseFor();

		/**
		 * The base implementation of `getTag` without fallbacks for buggy environments.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  if (value == null) {
		    return value === undefined ? undefinedTag : nullTag;
		  }
		  return (symToStringTag && symToStringTag in Object(value))
		    ? getRawTag(value)
		    : objectToString(value);
		}

		/**
		 * The base implementation of `_.isArguments`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 */
		function baseIsArguments(value) {
		  return isObjectLike(value) && baseGetTag(value) == argsTag;
		}

		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}

		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
		}

		/**
		 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeysIn(object) {
		  if (!isObject(object)) {
		    return nativeKeysIn(object);
		  }
		  var isProto = isPrototype(object),
		      result = [];

		  for (var key in object) {
		    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * The base implementation of `_.merge` without support for multiple sources.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} [customizer] The function to customize merged values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMerge(object, source, srcIndex, customizer, stack) {
		  if (object === source) {
		    return;
		  }
		  baseFor(source, function(srcValue, key) {
		    stack || (stack = new Stack);
		    if (isObject(srcValue)) {
		      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
		    }
		    else {
		      var newValue = customizer
		        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
		        : undefined;

		      if (newValue === undefined) {
		        newValue = srcValue;
		      }
		      assignMergeValue(object, key, newValue);
		    }
		  }, keysIn);
		}

		/**
		 * A specialized version of `baseMerge` for arrays and objects which performs
		 * deep merges and tracks traversed objects enabling objects with circular
		 * references to be merged.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {string} key The key of the value to merge.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} mergeFunc The function to merge values.
		 * @param {Function} [customizer] The function to customize assigned values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
		  var objValue = safeGet(object, key),
		      srcValue = safeGet(source, key),
		      stacked = stack.get(srcValue);

		  if (stacked) {
		    assignMergeValue(object, key, stacked);
		    return;
		  }
		  var newValue = customizer
		    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
		    : undefined;

		  var isCommon = newValue === undefined;

		  if (isCommon) {
		    var isArr = isArray(srcValue),
		        isBuff = !isArr && isBuffer(srcValue),
		        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

		    newValue = srcValue;
		    if (isArr || isBuff || isTyped) {
		      if (isArray(objValue)) {
		        newValue = objValue;
		      }
		      else if (isArrayLikeObject(objValue)) {
		        newValue = copyArray(objValue);
		      }
		      else if (isBuff) {
		        isCommon = false;
		        newValue = cloneBuffer(srcValue);
		      }
		      else if (isTyped) {
		        isCommon = false;
		        newValue = cloneTypedArray(srcValue);
		      }
		      else {
		        newValue = [];
		      }
		    }
		    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
		      newValue = objValue;
		      if (isArguments(objValue)) {
		        newValue = toPlainObject(objValue);
		      }
		      else if (!isObject(objValue) || isFunction(objValue)) {
		        newValue = initCloneObject(srcValue);
		      }
		    }
		    else {
		      isCommon = false;
		    }
		  }
		  if (isCommon) {
		    // Recursively merge objects and arrays (susceptible to call stack limits).
		    stack.set(srcValue, newValue);
		    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
		    stack['delete'](srcValue);
		  }
		  assignMergeValue(object, key, newValue);
		}

		/**
		 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @returns {Function} Returns the new function.
		 */
		function baseRest(func, start) {
		  return setToString(overRest(func, start, identity), func + '');
		}

		/**
		 * The base implementation of `setToString` without support for hot loop shorting.
		 *
		 * @private
		 * @param {Function} func The function to modify.
		 * @param {Function} string The `toString` result.
		 * @returns {Function} Returns `func`.
		 */
		var baseSetToString = !defineProperty ? identity : function(func, string) {
		  return defineProperty(func, 'toString', {
		    'configurable': true,
		    'enumerable': false,
		    'value': constant(string),
		    'writable': true
		  });
		};

		/**
		 * Creates a clone of  `buffer`.
		 *
		 * @private
		 * @param {Buffer} buffer The buffer to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Buffer} Returns the cloned buffer.
		 */
		function cloneBuffer(buffer, isDeep) {
		  {
		    return buffer.slice();
		  }
		}

		/**
		 * Creates a clone of `arrayBuffer`.
		 *
		 * @private
		 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
		 * @returns {ArrayBuffer} Returns the cloned array buffer.
		 */
		function cloneArrayBuffer(arrayBuffer) {
		  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
		  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
		  return result;
		}

		/**
		 * Creates a clone of `typedArray`.
		 *
		 * @private
		 * @param {Object} typedArray The typed array to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned typed array.
		 */
		function cloneTypedArray(typedArray, isDeep) {
		  var buffer = cloneArrayBuffer(typedArray.buffer) ;
		  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
		}

		/**
		 * Copies the values of `source` to `array`.
		 *
		 * @private
		 * @param {Array} source The array to copy values from.
		 * @param {Array} [array=[]] The array to copy values to.
		 * @returns {Array} Returns `array`.
		 */
		function copyArray(source, array) {
		  var index = -1,
		      length = source.length;

		  array || (array = Array(length));
		  while (++index < length) {
		    array[index] = source[index];
		  }
		  return array;
		}

		/**
		 * Copies properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy properties from.
		 * @param {Array} props The property identifiers to copy.
		 * @param {Object} [object={}] The object to copy properties to.
		 * @param {Function} [customizer] The function to customize copied values.
		 * @returns {Object} Returns `object`.
		 */
		function copyObject(source, props, object, customizer) {
		  var isNew = !object;
		  object || (object = {});

		  var index = -1,
		      length = props.length;

		  while (++index < length) {
		    var key = props[index];

		    var newValue = undefined;

		    if (newValue === undefined) {
		      newValue = source[key];
		    }
		    if (isNew) {
		      baseAssignValue(object, key, newValue);
		    } else {
		      assignValue(object, key, newValue);
		    }
		  }
		  return object;
		}

		/**
		 * Creates a function like `_.assign`.
		 *
		 * @private
		 * @param {Function} assigner The function to assign values.
		 * @returns {Function} Returns the new assigner function.
		 */
		function createAssigner(assigner) {
		  return baseRest(function(object, sources) {
		    var index = -1,
		        length = sources.length,
		        customizer = length > 1 ? sources[length - 1] : undefined,
		        guard = length > 2 ? sources[2] : undefined;

		    customizer = (assigner.length > 3 && typeof customizer == 'function')
		      ? (length--, customizer)
		      : undefined;

		    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
		      customizer = length < 3 ? undefined : customizer;
		      length = 1;
		    }
		    object = Object(object);
		    while (++index < length) {
		      var source = sources[index];
		      if (source) {
		        assigner(object, source, index, customizer);
		      }
		    }
		    return object;
		  });
		}

		/**
		 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseFor(fromRight) {
		  return function(object, iteratee, keysFunc) {
		    var index = -1,
		        iterable = Object(object),
		        props = keysFunc(object),
		        length = props.length;

		    while (length--) {
		      var key = props[++index];
		      if (iteratee(iterable[key], key, iterable) === false) {
		        break;
		      }
		    }
		    return object;
		  };
		}

		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}

		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}

		/**
		 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the raw `toStringTag`.
		 */
		function getRawTag(value) {
		  var isOwn = hasOwnProperty.call(value, symToStringTag),
		      tag = value[symToStringTag];

		  try {
		    value[symToStringTag] = undefined;
		    var unmasked = true;
		  } catch (e) {}

		  var result = nativeObjectToString.call(value);
		  if (unmasked) {
		    if (isOwn) {
		      value[symToStringTag] = tag;
		    } else {
		      delete value[symToStringTag];
		    }
		  }
		  return result;
		}

		/**
		 * Initializes an object clone.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneObject(object) {
		  return (typeof object.constructor == 'function' && !isPrototype(object))
		    ? baseCreate(getPrototype(object))
		    : {};
		}

		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  var type = typeof value;
		  length = length == null ? MAX_SAFE_INTEGER : length;

		  return !!length &&
		    (type == 'number' ||
		      (type != 'symbol' && reIsUint.test(value))) &&
		        (value > -1 && value % 1 == 0 && value < length);
		}

		/**
		 * Checks if the given arguments are from an iteratee call.
		 *
		 * @private
		 * @param {*} value The potential iteratee value argument.
		 * @param {*} index The potential iteratee index or key argument.
		 * @param {*} object The potential iteratee object argument.
		 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
		 *  else `false`.
		 */
		function isIterateeCall(value, index, object) {
		  if (!isObject(object)) {
		    return false;
		  }
		  var type = typeof index;
		  if (type == 'number'
		        ? (isArrayLike(object) && isIndex(index, object.length))
		        : (type == 'string' && index in object)
		      ) {
		    return eq(object[index], value);
		  }
		  return false;
		}

		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}

		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}

		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

		  return value === proto;
		}

		/**
		 * This function is like
		 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * except that it includes inherited enumerable properties.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function nativeKeysIn(object) {
		  var result = [];
		  if (object != null) {
		    for (var key in Object(object)) {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * Converts `value` to a string using `Object.prototype.toString`.
		 *
		 * @private
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 */
		function objectToString(value) {
		  return nativeObjectToString.call(value);
		}

		/**
		 * A specialized version of `baseRest` which transforms the rest array.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @param {Function} transform The rest array transform.
		 * @returns {Function} Returns the new function.
		 */
		function overRest(func, start, transform) {
		  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
		  return function() {
		    var args = arguments,
		        index = -1,
		        length = nativeMax(args.length - start, 0),
		        array = Array(length);

		    while (++index < length) {
		      array[index] = args[start + index];
		    }
		    index = -1;
		    var otherArgs = Array(start + 1);
		    while (++index < start) {
		      otherArgs[index] = args[index];
		    }
		    otherArgs[start] = transform(array);
		    return apply(func, this, otherArgs);
		  };
		}

		/**
		 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function safeGet(object, key) {
		  if (key === 'constructor' && typeof object[key] === 'function') {
		    return;
		  }

		  if (key == '__proto__') {
		    return;
		  }

		  return object[key];
		}

		/**
		 * Sets the `toString` method of `func` to return `string`.
		 *
		 * @private
		 * @param {Function} func The function to modify.
		 * @param {Function} string The `toString` result.
		 * @returns {Function} Returns `func`.
		 */
		var setToString = shortOut(baseSetToString);

		/**
		 * Creates a function that'll short out and invoke `identity` instead
		 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
		 * milliseconds.
		 *
		 * @private
		 * @param {Function} func The function to restrict.
		 * @returns {Function} Returns the new shortable function.
		 */
		function shortOut(func) {
		  var count = 0,
		      lastCalled = 0;

		  return function() {
		    var stamp = nativeNow(),
		        remaining = HOT_SPAN - (stamp - lastCalled);

		    lastCalled = stamp;
		    if (remaining > 0) {
		      if (++count >= HOT_COUNT) {
		        return arguments[0];
		      }
		    } else {
		      count = 0;
		    }
		    return func.apply(undefined, arguments);
		  };
		}

		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to convert.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}

		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}

		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
		  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
		    !propertyIsEnumerable.call(value, 'callee');
		};

		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;

		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}

		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}

		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;

		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  if (!isObject(value)) {
		    return false;
		  }
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 9 which returns 'object' for typed arrays and other constructors.
		  var tag = baseGetTag(value);
		  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
		}

		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}

		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return value != null && (type == 'object' || type == 'function');
		}

		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return value != null && typeof value == 'object';
		}

		/**
		 * Checks if `value` is a plain object, that is, an object created by the
		 * `Object` constructor or one with a `[[Prototype]]` of `null`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.8.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * _.isPlainObject(new Foo);
		 * // => false
		 *
		 * _.isPlainObject([1, 2, 3]);
		 * // => false
		 *
		 * _.isPlainObject({ 'x': 0, 'y': 0 });
		 * // => true
		 *
		 * _.isPlainObject(Object.create(null));
		 * // => true
		 */
		function isPlainObject(value) {
		  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
		    return false;
		  }
		  var proto = getPrototype(value);
		  if (proto === null) {
		    return true;
		  }
		  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
		  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
		    funcToString.call(Ctor) == objectCtorString;
		}

		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

		/**
		 * Converts `value` to a plain object flattening inherited enumerable string
		 * keyed properties of `value` to own properties of the plain object.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {Object} Returns the converted plain object.
		 * @example
		 *
		 * function Foo() {
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.assign({ 'a': 1 }, new Foo);
		 * // => { 'a': 1, 'b': 2 }
		 *
		 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
		 * // => { 'a': 1, 'b': 2, 'c': 3 }
		 */
		function toPlainObject(value) {
		  return copyObject(value, keysIn(value));
		}

		/**
		 * Creates an array of the own and inherited enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keysIn(new Foo);
		 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
		 */
		function keysIn(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeysIn(object);
		}

		/**
		 * This method is like `_.assign` except that it recursively merges own and
		 * inherited enumerable string keyed properties of source objects into the
		 * destination object. Source properties that resolve to `undefined` are
		 * skipped if a destination value exists. Array and plain object properties
		 * are merged recursively. Other objects and value types are overridden by
		 * assignment. Source objects are applied from left to right. Subsequent
		 * sources overwrite property assignments of previous sources.
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.5.0
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} [sources] The source objects.
		 * @returns {Object} Returns `object`.
		 * @example
		 *
		 * var object = {
		 *   'a': [{ 'b': 2 }, { 'd': 4 }]
		 * };
		 *
		 * var other = {
		 *   'a': [{ 'c': 3 }, { 'e': 5 }]
		 * };
		 *
		 * _.merge(object, other);
		 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
		 */
		var merge = createAssigner(function(object, source, srcIndex) {
		  baseMerge(object, source, srcIndex);
		});

		/**
		 * Creates a function that returns `value`.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {*} value The value to return from the new function.
		 * @returns {Function} Returns the new constant function.
		 * @example
		 *
		 * var objects = _.times(2, _.constant({ 'a': 1 }));
		 *
		 * console.log(objects);
		 * // => [{ 'a': 1 }, { 'a': 1 }]
		 *
		 * console.log(objects[0] === objects[1]);
		 * // => true
		 */
		function constant(value) {
		  return function() {
		    return value;
		  };
		}

		/**
		 * This method returns the first argument it receives.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Util
		 * @param {*} value Any value.
		 * @returns {*} Returns `value`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 *
		 * console.log(_.identity(object) === object);
		 * // => true
		 */
		function identity(value) {
		  return value;
		}

		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}

		module.exports = merge; 
	} (lodash_merge, lodash_merge.exports));
	return lodash_merge.exports;
}

var lodash_mergeExports = requireLodash_merge();
var merge = /*@__PURE__*/getDefaultExportFromCjs(lodash_mergeExports);

var i18nInitGenerator = function (baseLocale, appLocale, config) {
    var mandant = trEnv$1.mandant;
    // i18n-Struktur mit Standard-Locales aufbauen
    var resources = {
        vgh: {
            translation: __assign$1({}, baseLocale.vgh),
        },
        oesa: {
            translation: __assign$1({}, baseLocale.oesa),
        },
        oevb: {
            translation: __assign$1({}, baseLocale.oevb),
        },
        oevo: {
            translation: __assign$1({}, baseLocale.oevo),
        },
        spkIfiliale: {
            translation: __assign$1({}, baseLocale.spkIfiliale),
        },
        spkIfAnonym: {
            translation: __assign$1({}, baseLocale.spkIfAnonym),
        },
        spkStationaer: {
            translation: __assign$1({}, baseLocale.spkStationaer),
        },
    };
    // App-spezifische Locales durchgehen und die Standard-Locales ergänzen
    Object.keys(appLocale).forEach(function (name) {
        var locale = appLocale[name];
        if (resources[name]) {
            resources[name].translation = merge(resources[name].translation, locale);
        }
        else {
            resources[name] = {
                translation: locale,
            };
        }
    });
    var language;
    if (trEnv$1.stationaer) {
        language = 'spkStationaer';
    }
    else if (trEnv$1.ifiliale && trEnv$1.banking) {
        language = 'spkIfiliale';
    }
    else if (trEnv$1.ifiliale && !trEnv$1.banking) {
        language = 'spkIfAnonym';
    }
    else {
        language = mandant;
    }
    return {
        resources: resources,
        lng: language,
        fallbackLng: __assign$1(__assign$1({}, config), { spkStationaer: ['spkIfiliale', mandant, EnumMandant.VGH], spkIfiliale: [mandant, EnumMandant.VGH], spkIfAnonym: ['spkIfiliale', mandant, EnumMandant.VGH], default: [EnumMandant.VGH] }),
        interpolation: {
            escapeValue: false,
        },
    };
};

var oesa = {
    mandant: 'ÖSA',
    ort: 'Sachsen-Anhalt',
    anschrift: {
        head: 'Öffentliche Versicherungen',
        subhead: 'Öffentliche Feuerversicherung Sachsen-Anhalt',
        strasseHausnr: 'Am Alten Theater 7',
        plzOrt: '39104 Magdeburg',
        handelsregister: 'Registergericht Stendal HRA 22247',
        rechtsform: 'Rechtsform: Anstalt des öffentlichen Rechts',
        fax: '0391 7367 169',
        email: 'service.magdeburg@oesa.de',
        gruss: 'Ihre ÖSA Versicherungen',
        page: 'https://www.oesa.de',
    },
    footer: {
        kontaktformular: 'https://www.oesa.de/content/privat/service/kontakt/',
        telefonnummer: '0391 7367 367',
        beratersuche: 'https://www.oesa.de/beratersuche',
        vertragspartner: 'https://www.oesa.de/vertragspartner_oesa',
        vertragspartnerText: 'Ihr Vertragspartner sind die ÖSA Versicherungen',
        datenschutz: 'https://www.oesa.de/datenschutz',
        datenschutzText: 'Datenschutzhinweise der ÖSA Versicherungen',
        anrufen: 'Anrufen',
    },
    vorversicherung: {
        schaeden: 'Wie viele Vorschäden haben Sie in den letzten fünf Jahren bei Ihrer'
            + ' bisherigen'
            + ' Versicherung gemeldet?',
    },
    sepa: {
        sepa: 'Ich ermächtige die ÖSA Versicherungen (Öffentliche Feuer&shy;versicherung'
            + ' Sachsen-Anhalt,'
            + ' Gläubiger-Identifikationsnummer: DE20ZZZ00000034141), die Beiträge von meinem Konto'
            + ' mittels Lastschrift einzuziehen.',
    },
    datenschutz: {
        berater: 'https://www.oesa.de/datenschutz',
        textEnde: '-Produkte zu informieren. Sie können der Verwendung Ihrer Daten – z.'
            + ' B. für Werbung – jederzeit per E-Mail an $t(datenschutz.mail) widersprechen.',
        link: '<a target="_blank" data-tracking-name="link-datenschutzhinweise" href=$t(footer.datenschutz)>Datenschutzhinweise</a>',
        modal: "<p>Die \u00D6SA Versicherungen sind ein Zusammenschluss der folgenden Anstalten des \u00F6ffentlichen Rechts, \u00FCber deren Angebote wir Sie informieren:</p>\n        <ul>\n            <li>\u00D6ffentliche Feuerversicherung Sachsen-Anhalt</li>\n            <li>\u00D6ffentliche Lebensversicherung Sachsen-Anhalt</li>\n        </ul>",
        verhaltenskodex: 'https://www.gdv.de/gdv/service/verhaltenskodex-pruefberichte?letter=O',
        pdfLink: 'https://www.oesa.de/datenschutzinformation',
    },
    widerrufkontakt: ' die ÖSA Versicherungen, Öffentliche Feuerversicherung Sachsen-Anhalt, Postfach 39 11 43, 39135 Magdeburg,'
        + ' Telefax: 0391 7367-490, E-Mail: <a href="mailto:service.magdeburg@oesa.de">service.magdeburg@oesa.de</a>',
    error: {
        telefon: '0391 / 7367-556',
        email: 'Anwenderservice@oesa.de',
        service: 'den Bereich VTS der ÖSA',
    },
    abschluss: {
        telefon: '$t(footer.telefonnummer)',
    },
    footertext: "<h2 class=\"h5\">Beitragsberechnung zur Wohngeb\u00E4udeversicherung</h2>\n    <p>Mit dem <strong>Beitragsrechner</strong> zur <strong> Wohngeb\u00E4udeversicherung der $t(mandant) berechnen Sie in wenigen Minuten,\n    was die Versicherung f\u00FCr Ihr Haus kostet</strong>. Nach der Beantwortung weniger Fragen erfahren Sie sofort die Versicherungskosten und k\u00F6nnen direkt online abschlie\u00DFen.</p>\n    <p>Die Wohngeb\u00E4udeversicherung der <strong>$t(mandant)</strong> ist die richtige Wahl f\u00FCr alle, die ihr Haus und Grundst\u00FCck in $t(ort) absichern wollen. Mit unserer langj\u00E4hrigen \n    Erfahrung wissen wir, worauf es ankommt. Ihr Haus und Grundst\u00FCck sind bei uns in den besten H\u00E4nden. Mit den starken Leistungen der $t(footerProdukt) ist Ihr Heim bestens gesch\u00FCtzt.</p>\n    <p>Mit unseren Zusatzbausteinen k\u00F6nnen Sie den Versicherungsschutz f\u00FCr die eigenen vier W\u00E4nde individuell gestalten und zum Beispiel den Schutz vor Naturgefahren (Elementarsch\u00E4den) einschlie\u00DFen.</p>\n    <p>Profitieren Sie von der Wiederherstellung Ihrer Immobilie zum Neuwert unter Ber\u00FCcksichtigung von Preissteigerungen und Folgekosten. Bauliche Grundst\u00FCcks&shy;bestandteile wie Z\u00E4une sind in der \n    $t(footerProdukt) mitversichert. Nebengeb\u00E4ude wie Garten&shy;h\u00E4user oder Ger\u00E4teschuppen sind im Tarif WohnhausPlus mit Deckungserweiterung kostenfrei eingeschlossen (bis 20 m\u00B2, maximal 20.000 \u20AC je Schadenfall).</p>",
    schweigepflicht: {
        einleitung: "Ich willige ein, dass die \u00D6ffentliche Lebensversicherung Sachsen-Anhalt die von mir in diesem Antrag und k\u00FCnftig mitgeteilten Gesundheitsdaten erhebt, speichert und nutzt, soweit\n       dies zur Antragspr\u00FCfung sowie zur Begr\u00FCndung, Durchf\u00FChrung oder Beendigung dieses Versicherungsvertrages erforderlich ist.",
        gesundheitsdatenLink: 'https://www.oesa.de/schweigepflichtentbindung',
    },
    bedingungsvergleich: 'https://prod-osp.vgh.crednet.de/bedingungsvergleich/html/index.html?mandant=oesa',
    dokumenteFileUpload_tt: "<p>Bitte f\u00FCgen Sie vom Versicherungsnehmer immer eine Ausweiskopie bei. Wird auf Veranlassung von jemand anderem gehandelt, muss zur Identifikation der benannten Person ebenfalls eine \n    Ausweiskopie beigef\u00FCgt werden. Handelt es sich um eine juristische Person, muss immer ein amtlicher Nachweis in Form eines Handelsregisterauszuges oder \u00E4hnliches eingereicht werden (nicht \u00E4lter als ein Jahr).</p>",
    fileUploadCheckbox_label_link: '<a href="mailto:lu-kdc@oesa.de">lu-kdc@oesa.de</a>',
};

var oevb = {
    mandant: 'ÖVB',
    ort: 'Bremen',
    anschrift: {
        head: 'ÖVB Versicherungen',
        subhead: 'Landschaftliche Brandkasse Hannover',
        strasseHausnr: 'Schiffgraben 4',
        plzOrt: '30159 Hannover',
        handelsregister: 'HRA: Hannover 26227',
        rechstsform: 'Rechtsform: Anstalt des öffentlichen Rechts',
        fax: '0421 3043 4733',
        email: 'service@oevb.de',
        gruss: 'Ihre ÖVB Versicherungen',
        page: 'https://www.oevb.de',
    },
    footer: {
        kontaktformular: 'https://www.oevb.de/content/privat/service/kontakt/#kontaktmoeglichkeiten',
        telefonnummer: '0800 3043 600',
        beratersuche: 'https://www.oevb.de/beratersuche',
        vertragspartner: 'https://www.oevb.de/vertragspartner_lh',
        vertragspartnerText: 'Ihr Vertragspartner sind die ÖVB Versicherungen',
        datenschutz: 'https://www.oevb.de/datenschutzinformation',
        datenschutzText: 'Datenschutzhinweise der ÖVB Versicherungen',
    },
    sepa: {
        sepa: 'Ich ermächtige die ÖVB Versicherungen (Landschaftliche Brandkasse Hannover,'
            + ' Gläubiger-Identifikationsnummer: DE30ZZZ00000025716), die Beiträge von meinem Konto mittels Lastschrift einzuziehen.',
    },
    datenschutz: {
        berater: 'https://www.oevb.de/datenschutz',
        link: '<a target="_blank" data-tracking-name="link-datenschutzhinweise"'
            + ' href="$t(footer.datenschutz)">Datenschutzhinweise</a>',
        verhaltenskodex: 'https://www.gdv.de/gdv/service/verhaltenskodex-pruefberichte?letter=O',
        pdfLink: 'https://www.oevb.de/export/sites/oevb/datenschutz/pdf/Informationen-zum-Datenschutz_PH_VN.pdf',
    },
    widerrufkontakt: ': ÖVB Landschaftliche Brandkasse Hannover, 30140 Hannover, Telefax 0511 362-2960, E-Mail:'
        + ' <a href="mailto:service@vgh.de">service@vgh.de</a>',
    bedingungsvergleich: 'https://prod-osp.vgh.crednet.de/bedingungsvergleich/html/index.html?mandant=oevb',
};

var oevo = {
    mandant: 'ÖVO',
    mandantLang: 'Öffentliche Oldenburg',
    ort: 'Oldenburg',
    anschrift: {
        head: 'Öffentliche Versicherungen Oldenburg',
        subhead: 'Oldenburgische Landesbrandkasse',
        strasseHausnr: 'Staugraben 11',
        plzOrt: '26122 Oldenburg',
        handelsregister: 'HRA: Oldenburg 3663 Sitz: Oldenburg',
        rechtsform: 'Rechtsform: Anstalt des öffentlichen Rechts',
        fax: '0441 2228 444',
        email: 'info@oeffentlicheoldenburg.de',
        gruss: 'Ihre Öffentliche Oldenburg',
        page: 'https://www.offentlicheoldenburg.de',
    },
    footer: {
        telefonnummer: '0441 2228 120',
        anrufen: 'Anrufen (zum üblichen Ortstarif)',
        kontaktformular: 'https://www.oeffentlicheoldenburg.de/content/privat/service/kontakt/',
        beratersuche: 'https://www.oeffentlicheoldenburg.de/beratersuche',
        vertragspartner: 'https://www.oeffentlicheoldenburg.de/vertragspartner_olbk',
        vertragspartnerText: 'Ihr Vertragspartner sind die Öffentliche Versicherungen Oldenburg',
        datenschutz: 'https://www.oeffentlicheoldenburg.de/datenschutz',
        datenschutzText: 'Datenschutzhinweise der Öffentliche Versicherungen Oldenburg',
    },
    sepa: {
        sepa: 'Ich ermächtige die Öffentlichen Versicherungen Oldenburg (Oldenburgische'
            + ' Landesbrandkasse, Gläubiger-Identifikationsnummer: DE25ZZZ00000096810), die Beiträge von meinem Konto mittels Lastschrift einzuziehen.',
    },
    datenschutz: {
        berater: 'https://www.offentlicheoldenburg.de/datenschutz',
        checkboxTitle: 'Ich habe die folgenden Informationen zur Verwendung meiner Daten zur Kenntnis genommen und bin damit einverstanden, dass diese an meinen Ansprechpartner bei der Öffentlichen'
            + ' Oldenburg weitergegeben werden:',
        link: '<a target="_blank" data-tracking-name="link-datenschutzhinweise" href=$t(footer.datenschutz)>Datenschutzhinweise</a>',
        modal: "<p>Die \u00D6ffentlichen Versicherungen Oldenburg sind ein Zusammenschluss der folgenden Anstalten des \u00F6ffentlichen Rechts, \u00FCber deren Angebote wir Sie informieren:</p>\n        <ul class=\"list-icn-bar\">\n            <li>Oldenburgische Landesbrandkasse</li>\n            <li>\u00D6ffentliche Lebensversicherungsanstalt Oldenburg</li>\n        </ul>",
        modalLinkText: 'Öffentlichen Oldenburg',
        textAnfang: 'Wir nutzen Ihre Daten ausschließlich im Rahmen unserer'
            + ' $t(datenschutz.link), etwa zur Beratung oder um Sie per Post über Produkte der',
        textEnde: ' zu informieren. Sie können der Verwendung Ihrer Daten – z.'
            + ' B. für Werbung – jederzeit per E-Mail an $t(datenschutz.mail) widersprechen.',
        verhaltenskodex: 'https://www.gdv.de/gdv/service/verhaltenskodex-pruefberichte?letter=O',
        pdfLink: 'https://www.oeffentlicheoldenburg.de/datenschutzinformation',
    },
    widerrufkontakt: ': Öffentliche Versicherungen Oldenburg, Oldenburgische Landesbrandkasse, Staugraben 11, 26122 Oldenburg,'
        + ' Telefax 0441 2228-444, E-Mail: <a href="mailto:info@oeffentlicheoldenburg.de">info@oeffentlicheoldenburg.de</a>',
    error: {
        telefon: '0511 362-3333',
        email: 'service@ivv.de',
    },
    abschluss: {
        telefon: '$t(footer.telefonnummer) (zum üblichen Ortstarif)',
        grussformel: 'Ihre Öffentliche Oldenburg',
    },
    schweigepflicht: {
        einleitung: 'Ich willige ein, dass die Öffentliche Lebensversicherungsanstalt Oldenburg die von mir in diesem Antrag und künftig mitgeteilten Gesundheitsdaten erhebt, speichert und nutzt, '
            + 'soweit dies zur Antragsprüfung sowie zur Begründung, Durchführung oder Beendigung dieses Versicherungsvertrages erforderlich ist.',
        gesundheitsdatenLink: 'https://www.oeffentlicheoldenburg.de/schweigepflichtentbindung',
    },
    fondsComboBox_subtitle: 'Bitte beachten Sie, dass die Aufteilung ausschließlich in {{minValue}} % - Schritten möglich ist.',
    bedingungsvergleich: 'https://prod-osp.vgh.crednet.de/bedingungsvergleich/html/index.html?mandant=oevo',
    dokumenteFileUpload_tt: "<p>Bitte f\u00FCgen Sie vom Versicherungsnehmer immer eine Ausweiskopie bei. Wird auf Veranlassung von jemand anderem gehandelt, muss zur Identifikation der benannten Person \n    ebenfalls eine Ausweiskopie beigef\u00FCgt werden.</p><p>Sofern der Versicherungsnehmer und/oder die versicherte Personen die Staatsangeh\u00F6rigkeit eines nicht EU-Landes besitzt, reichen Sie uns bitte eine Kopie der Niederlassungs&shy;erlaubnis \n    sowie des amtlichen Lichtbildausweises zusammen mit dem Antrag ein.</p>",
    fileUploadCheckbox_label_link: '<a href="mailto:lebenantrag@oevo.de">lebenantrag@oevo.de</a>',
};

var vgh = {
    mandant: 'VGH',
    ort: 'Niedersachsen',
    beratersuche: '$t(footer.beratersuche){{PARAM}}',
    anschrift: {
        head: 'VGH Versicherungen',
        subhead: 'Landschaftliche Brandkasse Hannover',
        strasseHausnr: 'Schiffgraben 4',
        plzOrt: '30159 Hannover',
        handelsregister: 'HRA: Hannover 26227',
        rechtsform: 'Rechtsform: Anstalt des öffentlichen Rechts',
        fax: '0511 362 2960',
        email: 'service@vgh.de',
        gruss: 'Ihre VGH Versicherungen',
        page: 'https://www.vgh.de',
    },
    footer: {
        telefonnummer: '0800 1750 844',
        anrufen: 'Anrufen (kostenfrei)',
        kontaktformular: 'https://www.vgh.de/content/privat/service/kontakt/#kontaktmoeglichkeiten',
        beratersuche: 'https://www.vgh.de/beratersuche',
        vertragspartner: 'https://www.vgh.de/vertragspartner_lh',
        vertragspartnerText: 'Ihr Vertragspartner sind die VGH Versicherungen',
        datenschutz: 'https://www.vgh.de/datenschutzinformation',
        datenschutzText: 'Datenschutzhinweise der VGH Versicherungen',
    },
    speicherpunkt: {
        ladenErfolg: "<h4>Sch\u00F6n, dass Sie wieder da sind!</h4>\n      <p>Ihre Eingaben wurden wiederhergestellt. Machen Sie da weiter, wo Sie aufgeh\u00F6rt haben.</p>\n      <p>Sie m\u00F6chten neu starten? <a href=\"#\">Dann klicken Sie bitte hier ></a></p>",
        ladenFehler: "<h4>Leider konnten Ihre Daten nicht wiederhergestellt werden</h4>\n      <p>Wir haben unseren Rechner aktualisiert. Darum konnten Ihre Eingaben leider nicht wiederhergestellt werden. Sorry!</p>",
        speichernErfolg: "<h4>Eingaben gespeichert</h4>\n      <p>Alle Eingaben wurden in Ihrem Browser gespeichert.</p>\n      <p>Sie k\u00F6nnen jetzt weitermachen oder den Rechner sp\u00E4ter neu aurufen. Wenn Sie die Berechnung sp\u00E4ter fortsetzen wollen, nutzen Sie bitte diesen Browser.</p>",
    },
    vorversicherung: {
        schaeden: 'Wie viele Vorschäden haben Sie bei Ihrer bisherigen Versicherung gemeldet?',
    },
    person: {
        partner: {
            mitversichern: 'Ehe-/Lebenspartner',
            ehepartner: 'Ehepartner und eingetragene Lebenspartner sind automatisch beitragsfrei'
                + ' mitversichert.',
        },
    },
    drohne: {
        hersteller_tt: '<h4>Hersteller</h4>Bitte geben Sie den Hersteller an.',
        seriennummer_tt: '<h4>Seriennummer</h4>Bitte geben Sie die Seriennummer an. Diese finden Sie in der Regel auf dem Gehäuse der Drohne, im Akkufach oder auf der Verpackung.',
        abfluggewicht_tt: '<h4>Abfluggewicht</h4>Das Abfluggewicht versteht sich inklusive Zubehör wie Kameras etc.',
    },
    iban: {
        titel: 'Wie lautet Ihre IBAN?',
    },
    sepa: {
        sepa: "\n    Ich erm\u00E4chtige die VGH Versicherungen (Landschaftliche Brandkasse Hannover, \n    Gl\u00E4ubiger-Identifikationsnummer: DE30ZZZ00000025716), die Beitr\u00E4ge von meinem Konto mittels Lastschrift einzuziehen.",
        text: "SEPA Lastschriftmandat: $t(sepa.sepa) Zugleich weise ich meinen im Antrag\n      genannten Zahlungs&shy;dienst&shy;leister an, die von dieser Gesellschaft auf mein Konto\n      gezogenen Lastschriften einzul\u00F6sen. Ich kann innerhalb von 8 Wochen, beginnend mit dem\n      Belastungs&shy;datum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei\n      die mit meinem Kreditinstitut vereinbarten Bedingungen. Ich erhalte sp\u00E4testens 5 Tage vor Abbuchung gesondert Nachricht \u00FCber die bestehende Abbuchung.",
    },
    datenschutz: {
        berater: 'https://www.vgh.de/datenschutz',
        checkboxTitle: 'Ich habe die folgenden Informationen zur Verwendung meiner Daten zur Kenntnis genommen und bin damit einverstanden, dass diese an meinen $t(mandant) Ansprechpartner'
            + ' weitergegeben werden:',
        link: '<a target="_blank" data-tracking-name="link-datenschutzhinweise" href="$t(footer.datenschutz)">Datenschutzhinweise</a>',
        kodex: '<a target="_blank" data-tracking-name="link-datenschutzkodex" href="$t(datenschutz.datenschutzkodex)">Datenschutzkodex</a>',
        mail: '<a data-tracking-name="link-datenschutz-mail" href="mailto:$t(anschrift.email)">$t(anschrift.email)</a>',
        modal: "<p>Die $t(mandant) Versicherungen sind ein Zusammenschluss der folgenden Anstalten des \u00F6ffentlichen Rechts, \u00FCber deren Angebote wir Sie informieren:</p>\n     <ul class=\"list-icn-bar\">\n      <li>Landschaftliche Brandkasse Hannover</li>\n      <li>Provinzial Lebensversicherung Hannover</li>\n      <li>Provinzial Krankenversicherung Hannover AG</li>\n      <li>Provinzial Pensionskasse Hannover AG</li>\n     </ul>",
        modalLinkText: '$t(mandant)',
        textAnfang: 'Wir nutzen Ihre Daten im Rahmen unserer'
            + ' $t(datenschutz.link) unter anderem zur Angebotserstellung und Durchführung Ihres'
            + ' Vertrages oder - in Einzelfällen - für Anfragen bei Ihrem Vorversicherer. Außerdem'
            + ' informieren wir Sie gelegentlich zu Produkten der',
        textEnde: ' per Post. Dieser Nutzung Ihrer Daten können Sie jederzeit per E-Mail an $t(datenschutz.mail) widersprechen.',
        datenschutzkodex: 'https://www.gdv.de/gdv/service/datenschutzkodex',
        verhaltenskodex: 'https://www.gdv.de/gdv/service/verhaltenskodex-pruefberichte?letter=V',
        pdfLink: 'https://www.vgh.de/export/sites/vgh/datenschutz/pdf/Informationen-zum-Datenschutz_PH_VN.pdf',
    },
    beratungsverzicht_tt: "<h4>Beratungsverzicht</h4>\n    <p>Laut Gesetz sind wir \u2013 wie alle Versicherer \u2013 verpflichtet, Sie\n    pers\u00F6nlich zu beraten und die Beratung zu doku&shy;men&shy;tieren. Sie m\u00F6chten jedoch\n    schnell und bequem im Internet abschlie\u00DFen. Darum k\u00F6nnen wir Sie nicht genauso ausf\u00FChrlich beraten,\n    wie wir es pers\u00F6nlich tun w\u00FCrden.</p>\n    <p>Wenn Sie hier auf eine Beratung und deren Doku&shy;men&shy;tation verzichten, k\u00F6nnen\n    Sie uns nicht bzw. nur einge&shy;schr\u00E4nkt f\u00FCr eine Verletzung der Beratungs- und\n    Dokumentationspflichten (\u00A7 6 Abs. 5 VVG) haftbar machen. Aber keine Sorge: Ihre weiteren\n    Verbraucher&shy;rechte sind davon nicht betroffen.</p>",
    widerrufsrecht: "<h4>Widerrufsrecht</h4>\n    Sie k\u00F6nnen Ihre Vertragserkl\u00E4rung, bei Vertr\u00E4gen mit einer Laufzeit von mehr als\n    einem Monat, innerhalb von 14 Tagen ohne Angabe von Gr\u00FCnden in Textform (zum Beispiel Brief,\n    Fax, E-Mail) widerrufen. Die Frist beginnt, nachdem Sie den Versicherungsschein, die\n    Vertrags&shy;informationen einschlie\u00DFlich der Allgemeinen Versiche&shy;rungsbedingungen, die\n    Belehrung \u00FCber das Widerrufs&shy;recht, sowie, sofern Sie Verbraucher sind, das Informationsblatt\n    zu Versicherungsprodukten jeweils in Textform erhalten haben. Zur Wahrung der Widerrufs&shy;frist\n    gen\u00FCgt die rechtzeitige Absendung des Widerrufs. Der Widerruf ist zu richten an\n    $t(widerrufkontakt)\n    <br /><br />\n    Die weiteren Informationen zu Ihrem Widerrufsrecht insbesondere den Widerrufsfolgen entnehmen\n    Sie bitte den Ihnen vorliegenden Vertragsinformationen.",
    widerrufkontakt: ': VGH Versicherungen, Landschaftliche Brandkasse Hannover, 30140 Hannover, Telefax 0511 362-2960, E-Mail:'
        + ' <a href="mailto:service@vgh.de">service@vgh.de</a>',
    error: {
        headline: 'Ein Problem ist aufgetreten',
        inhalt: "Es tut uns leid. In der Anwendung ist ein Fehler aufgetreten.<br/>\n      Bitte versuchen Sie es zu einem sp\u00E4teren Zeitpunkt erneut oder wenden Sie sich an einen Berater vor Ort.",
        telefon: '0800 844 0900 (kostenfrei) oder 0511 362-3333',
        email: 'service@ivv.de',
        service: 'das ivv-Service-Center',
    },
    beraterLink: '<a target="_blank" rel="noopener noreferrer" data-tracking-name="link-beratersuche" href="$t(beratersuche)">Berater vor Ort.',
    abschluss: {
        telefon: '$t(footer.telefonnummer) (kostenfrei)',
        grussformel: 'Ihre $t(mandant) Versicherungen',
    },
    vlHoehe_tt: '<h4>Höhe der vermögenswirksamen Leistungen</h4>Wenn Ihr Arbeitgeber Ihnen die VL'
        + ' nicht in voller Höhe der 40&nbsp;€ zahlt, können Sie die VL auf höchstens 40&nbsp;€ monatlich'
        + '  aufstocken.',
    schweigepflicht: {
        einwilligung_tt: "<h4>Warum eine Einwilligungs- und Schweigepflichtenbindungserkl\u00E4rung?</h4>\n        <p>Der rechtssichere Umgang mit personenbezogenen Daten besch\u00E4ftigt die Versicherungswirtschaft bereits seit vielen Jahren. Der GDV hat im Jahr 2012 \n        mit den Datenschutz&shy;beh\u00F6rden und dem Verbraucherverband neue Musterklauseln erarbeitet, die nun die informationelle Selbstbestimmung der Kunden und die \n        begr\u00FCndeten Auskunftsinteressen der Versicherer ausgewogen ber\u00FCcksichtigen.<br />\n        F\u00FCr alle Personenversicherungen ab dem 21.12.2012 gilt, dass die Einwilligungs- und Schweigepflichtentbindungserkl\u00E4rung zwingend bei Antragstellung \n        angegeben werden muss - unabh\u00E4ngig von der Beantwortung von Gesundheitsangaben.</p>\n        <p>F\u00FCr n\u00E4here Informationen klicken Sie bitte den Link \"Abfrage von Gesundheitsdaten bei Dritten\" an.</p>",
        einleitung: 'Ich willige ein, dass die Provinzial Lebensversicherung Hannover die von mir in diesem Antrag und künftig mitgeteilten Gesundheitsdaten erhebt, speichert und nutzt, soweit dies zur '
            + 'Antragsprüfung sowie zur Begründung, Durchführung oder Beendigung dieses Versicherungsvertrages erforderlich ist.',
        gesundheitsdatenLink: 'https://www.vgh.de/see_ph',
        title_tt: 'Für nähere Informationen klicken Sie bitte den Link "Abfrage von Gesundheitsdaten bei Dritten" an.',
    },
    fondsComboBox_subtitle: 'Bitte beachten Sie, dass die Mindestaufteilung je Fonds {{minValue}} % beträgt.',
    bedingungsvergleich: 'https://prod-osp.vgh.crednet.de/bedingungsvergleich/html/index.html?mandant=vgh',
    dokumenteFileUpload_tt: "<p>Bitte f\u00FCgen Sie vom Versicherungsnehmer immer eine Ausweiskopie bei. Wird auf Veranlassung von jemand anderem gehandelt, muss zur Identifikation der benannten Person ebenfalls \n    eine Ausweiskopie beigef\u00FCgt werden. Sofern der Versicherungsnehmer und/oder die versicherte Personen die Staatsangeh\u00F6rigkeit eines nicht EU-Landes besitzt, reichen Sie uns bitte den ausgef\u00FCllten \n    Fragenbogen sowie eine Ausweiskopie des unbefristeten Aufenthaltstitels ein. Den entsprechend Fragebogen finden Sie <a href=\"https://www.vgh.de/aufenthalt\" target=\"_blank\" rel=\"noopener noreferrer\">hier</a>.</p>",
    fileUploadCheckbox_label_link: '<a href="mailto:service-leben@vgh.de">service-leben@vgh.de</a>',
    fileUploadCheckbox_label: 'Ich bestätige, dass ich die geforderten Dokumente nach dem verbindlichen Abschluss unter Angabe der VSNR im Betreff an $t(fileUploadCheckbox_label_link) sende.',
};

var spkIfiliale = {
    iban: {
        titel: 'IBAN',
    },
    error: {
        inhalt: "Es tut uns leid. In der Anwendung ist ein Fehler aufgetreten.<br/>\n        Bitte versuchen Sie es zu einem sp\u00E4teren Zeitpunkt erneut oder wenden Sie sich an Ihren Sparkassenberater.",
    },
};

var spkStationaer = {
    person: {
        partner: {
            mitversichern: 'Mitversicherung eines Lebenspartners',
            ehepartner: 'Ehepartner und eingetragene Lebenspartner sind automatisch beitragsfrei mitversichert.',
        },
    },
    error: {
        inhalt: "Es tut uns leid. In der Anwendung ist ein Fehler aufgetreten.<br />\n        Bitte versuchen Sie es zu einem sp\u00E4teren Zeitpunkt erneut und oder wenden Sie sich bitte an $t(error.service).<br />\n        Telefon: $t(error.telefon)<br />\n        E-Mail: $t(error.email)",
    },
};

var index$e = {
    oesa: oesa,
    oevb: oevb,
    oevo: oevo,
    vgh: vgh,
    spkIfiliale: spkIfiliale,
    spkStationaer: spkStationaer,
};

var EnumDisplaySize;
(function (EnumDisplaySize) {
    EnumDisplaySize[EnumDisplaySize["sm"] = 320] = "sm";
    EnumDisplaySize[EnumDisplaySize["md"] = 720] = "md";
    EnumDisplaySize[EnumDisplaySize["lg"] = 1024] = "lg";
})(EnumDisplaySize || (EnumDisplaySize = {}));
var breakpoints = {
    sm: "".concat(EnumDisplaySize.sm, "px"),
    md: "".concat(EnumDisplaySize.md, "px"),
    lg: "".concat(EnumDisplaySize.lg, "px"),
};
var getDeviceConfig = function (width) {
    if (width > EnumDisplaySize.lg) {
        return 'lg';
    }
    if (width >= EnumDisplaySize.md) {
        return 'md';
    }
    if (width >= EnumDisplaySize.sm) {
        return 'sm';
    }
    return 'xs';
};
/**
 * überprüft ob element sichtbar ist
 * @param {React.RefObject} ref
 * @returns {boolean}
 */
var useOnScreen = function (ref) {
    var _a = useState(false), isIntersecting = _a[0], setIntersecting = _a[1];
    var observer = new IntersectionObserver(function (_a) {
        var entry = _a[0];
        return setIntersecting(entry.isIntersecting);
    });
    useEffect(function () {
        observer.observe(ref.current);
        // Remove the observer as soon as the component is unmounted
        return function () { observer.disconnect(); };
    }, []);
    return isIntersecting;
};
var throttle = function (callback, limit) {
    var waiting = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!waiting) {
            callback.apply(this, args);
            waiting = true;
            window.setTimeout(function () {
                waiting = false;
            }, limit);
        }
    };
};
/**
 * gibt den aktuellen breakpoint zurück
 * @returns {string}
 */
var useBreakpoint = function () {
    var _a = useState(function () { return getDeviceConfig(window.innerWidth); }), brkPnt = _a[0], setBrkPnt = _a[1];
    useEffect(function () {
        var calcInnerWidth = throttle(function () {
            setBrkPnt(getDeviceConfig(window.innerWidth));
        }, 200);
        window.addEventListener('resize', calcInnerWidth);
        return function () { return window.removeEventListener('resize', calcInnerWidth); };
    }, []);
    return brkPnt;
};
var useProduktBausteinHoehe = function () {
    var _a = useState(0), cardsHeight = _a[0], setCardsHeight = _a[1];
    var _b = useState(0), bausteinHeight = _b[0], setBausteinHeight = _b[1];
    var _c = useState(0), konfigurierenHeight = _c[0], setkonfigurierenHeight = _c[1];
    var _d = useState(0), headerHeight = _d[0], setHeaderHeight = _d[1];
    var _e = useState(0), cardContentHeight = _e[0], setCardContentHeight = _e[1];
    var _f = useState(0), bausteinHeadHeight = _f[0], setBausteinHeadHeight = _f[1];
    /* Alle Karten gleiche Höhe */
    useLayoutEffect$1(function () {
        window.setTimeout(function () {
            var bausteineCard = Array.from(document.querySelectorAll('.carousel-item'
                + ' .products__bausteine'));
            var bausteineHeight = bausteineCard.map(function (item) { return item.clientHeight; });
            setBausteinHeight(Math.max.apply(Math, bausteineHeight));
            var konfigurierenCard = Array.from(document.querySelectorAll('.carousel-item'
                + ' .products__individual'));
            var konfigurierenCardsHeight = konfigurierenCard.map(function (item) { return item.getBoundingClientRect().height; });
            setkonfigurierenHeight(Math.max.apply(Math, konfigurierenCardsHeight));
            var cards = Array.from(document.querySelectorAll('.carousel-item > .card'));
            var cardHeight = cards.map(function (item) { return item.clientHeight; });
            setCardsHeight(Math.max.apply(Math, cardHeight));
            var cardContent = Array.from(document.querySelectorAll('.card-content'));
            var contentHeight = cardContent.map(function (item) { return item.clientHeight; });
            setCardContentHeight(Math.max.apply(Math, contentHeight));
            var bausteineHeadCard = Array.from(document.querySelectorAll('.carousel-item'
                + ' .card-headline'));
            var bausteineHeadHeight = bausteineHeadCard.map(function (item) { return item.clientHeight; });
            setBausteinHeadHeight(Math.max.apply(Math, bausteineHeadHeight));
            // Top offset of the sticky website header
            var headerContainer = document.getElementById('header_container');
            if (headerContainer !== null) {
                setHeaderHeight(headerContainer.clientHeight);
            }
        }, 200);
    }, [bausteinHeight]);
    return {
        cardsHeight: cardsHeight,
        bausteinHeight: bausteinHeight,
        konfigurierenHeight: konfigurierenHeight,
        headerHeight: headerHeight,
        cardContentHeight: cardContentHeight,
        bausteinHeadHeight: bausteinHeadHeight,
    };
};

/**
 * findet den aktiven Path anhand vom Seitennamen
 * @param {string} name
 * @param {Object[]} pages
 * @returns {string} path
 */
var findPath = function (name, pages) {
    var arr = pages.find(function (route) { return route.name === name && route.active; });
    return (arr === null || arr === void 0 ? void 0 : arr.path) || '/';
};
/**
 * damit lassen sich die pages modifizieren
 * @return {(function(*): void)|*}
 */
var useModifyPages = function () {
    var pages = useSelector(function (state) { return state.appDaten.pages; });
    var dispatch = useDispatch();
    return function (obj) {
        var modifier = Object.keys(obj);
        var newPages = pages.map(function (elem) {
            var newElem = __assign$1({}, elem);
            modifier.forEach(function (item) {
                if (newElem.name === item) {
                    newElem = __assign$1(__assign$1({}, newElem), obj[item]);
                }
            });
            return newElem;
        });
        dispatch(updateByName('appDaten.pages', newPages));
    };
};
/**
 * setzt den Status einer Seite auf aktiv
 * @returns {(function(pagename, bedingung): void)|*}
 */
var useSetActivePage = function () {
    var pages = useSelector(function (state) { return state.appDaten; }).pages;
    var dispatch = useDispatch();
    return function (name, activate) {
        var newPages = pages.map(function (elem) {
            var newElem = __assign$1({}, elem);
            if (newElem.name === name) {
                newElem.active = activate;
            }
            return newElem;
        });
        dispatch(updateByName('appDaten.pages', newPages));
    };
};
var useGetPageinfo = function () {
    var pages = useSelector(function (state) { return state.appDaten; }).pages;
    return function (pagename) { return pages.filter(function (route) { return route.active && route.name === pagename; }); };
};
/**
 * setzt den gleichen Breadcrumb von einer Seite auf die andere
 * @return {(function(fromPageName, toPageName): void)|*}
 */
var useSetBreadcrumb = function () {
    var pages = useSelector(function (state) { return state.appDaten; }).pages;
    var dispatch = useDispatch();
    return function (fromPage, toPage) {
        var allActivePages = pages.filter(function (route) { return route.active; });
        var allRoutes = allActivePages.filter(function (route) { return route.breadcrumb; });
        var index = allRoutes.findIndex(function (route) { return route.name === fromPage; });
        var newPages = pages.map(function (elem) {
            var newElem = __assign$1({}, elem);
            toPage.forEach(function (item) {
                if (newElem.name === item) {
                    newElem.breadcrumbIndex = index;
                }
            });
            return newElem;
        });
        dispatch(updateByName('appDaten.pages', newPages));
    };
};
/**
 * gibt den Index der aktiven Seite zurück
 * @return {Number}
 */
var usePageIndex = function () {
    var pages = useSelector(function (state) { return state.appDaten; }).pages;
    var location = useLocation();
    return pages.findIndex(function (item) { return (item.path === location.pathname && item.active); });
};
/**
 * zu einer bestimmten Seite springen
 * @return {(function(pagename): void)|*}
 */
var useGotoPage = function () {
    var pages = useSelector(function (state) { return state.appDaten; }).pages;
    var navigate = useNavigate();
    return function (name, overridePath) {
        if (typeof overridePath === 'string') {
            return navigate(overridePath);
        }
        var path = findPath(name, pages);
        return navigate(path);
    };
};
/**
 * geht zur nächsten aktiven Seite
 * @return {function(): *}
 */
var useNextPage = function () {
    var pages = useSelector(function (state) { return state.appDaten; }).pages;
    var navigate = useNavigate();
    var location = useLocation();
    var newProgress = usePageIndex();
    var path;
    return function () {
        while (newProgress < pages.length - 1) {
            if (pages[newProgress + 1].active
                && pages[newProgress + 1].path !== location.pathname) {
                path = pages[newProgress + 1].path;
                break;
            }
            newProgress += 1;
        }
        return navigate(path);
    };
};
/**
 * geht zur vorherigen aktiven Seite
 * @return {function(): *}
 */
var usePrevPage = function () {
    var pages = useSelector(function (state) { return state.appDaten; }).pages;
    var navigate = useNavigate();
    var location = useLocation();
    var newProgress = usePageIndex();
    var path;
    return function () {
        while (newProgress > 0) {
            if (pages[newProgress - 1].active
                && pages[newProgress - 1].path !== location.pathname) {
                path = pages[newProgress - 1].path;
                break;
            }
            newProgress -= 1;
        }
        return navigate(path);
    };
};
/**
 * hol die page config
 * @return {
 *  {routes: (Object[]), allActive: (Object[]), active: ({breadcrumbIndex}|*), index: (Number)}
 * }
 */
var useBreadcrumb = function () {
    var pages = useSelector(function (state) { return state.appDaten; }).pages;
    var location = useLocation();
    var activePage = pages.find(function (page) { return (page.path === location.pathname && page.active); });
    var allActivePages = pages.filter(function (route) { return route.active; });
    var allRoutes = allActivePages.filter(function (route) { return route.breadcrumb; });
    var pageIndex = allRoutes.findIndex(function (route) { return route.path === location.pathname; });
    if (pageIndex === -1 && (activePage === null || activePage === void 0 ? void 0 : activePage.breadcrumbIndex) != null) {
        pageIndex = activePage.breadcrumbIndex;
    }
    return {
        active: activePage, allActive: allActivePages, routes: allRoutes, index: pageIndex,
    };
};

var dotObject;
var hasRequiredDotObject;

function requireDotObject () {
	if (hasRequiredDotObject) return dotObject;
	hasRequiredDotObject = 1;

	function _process (v, mod) {
	  var i;
	  var r;

	  if (typeof mod === 'function') {
	    r = mod(v);
	    if (r !== undefined) {
	      v = r;
	    }
	  } else if (Array.isArray(mod)) {
	    for (i = 0; i < mod.length; i++) {
	      r = mod[i](v);
	      if (r !== undefined) {
	        v = r;
	      }
	    }
	  }

	  return v
	}

	function parseKey (key, val) {
	  // detect negative index notation
	  if (key[0] === '-' && Array.isArray(val) && /^-\d+$/.test(key)) {
	    return val.length + parseInt(key, 10)
	  }
	  return key
	}

	function isIndex (k) {
	  return /^\d+$/.test(k)
	}

	function isObject (val) {
	  return Object.prototype.toString.call(val) === '[object Object]'
	}

	function isArrayOrObject (val) {
	  return Object(val) === val
	}

	function isEmptyObject (val) {
	  return Object.keys(val).length === 0
	}

	var blacklist = ['__proto__', 'prototype', 'constructor'];
	var blacklistFilter = function (part) { return blacklist.indexOf(part) === -1 };

	function parsePath (path, sep) {
	  if (path.indexOf('[') >= 0) {
	    path = path.replace(/\[/g, sep).replace(/]/g, '');
	  }

	  var parts = path.split(sep);

	  var check = parts.filter(blacklistFilter);

	  if (check.length !== parts.length) {
	    throw Error('Refusing to update blacklisted property ' + path)
	  }

	  return parts
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	function DotObject (separator, override, useArray, useBrackets) {
	  if (!(this instanceof DotObject)) {
	    return new DotObject(separator, override, useArray, useBrackets)
	  }

	  if (typeof override === 'undefined') override = false;
	  if (typeof useArray === 'undefined') useArray = true;
	  if (typeof useBrackets === 'undefined') useBrackets = true;
	  this.separator = separator || '.';
	  this.override = override;
	  this.useArray = useArray;
	  this.useBrackets = useBrackets;
	  this.keepArray = false;

	  // contains touched arrays
	  this.cleanup = [];
	}

	var dotDefault = new DotObject('.', false, true, true);
	function wrap (method) {
	  return function () {
	    return dotDefault[method].apply(dotDefault, arguments)
	  }
	}

	DotObject.prototype._fill = function (a, obj, v, mod) {
	  var k = a.shift();

	  if (a.length > 0) {
	    obj[k] = obj[k] || (this.useArray && isIndex(a[0]) ? [] : {});

	    if (!isArrayOrObject(obj[k])) {
	      if (this.override) {
	        obj[k] = {};
	      } else {
	        if (!(isArrayOrObject(v) && isEmptyObject(v))) {
	          throw new Error(
	            'Trying to redefine `' + k + '` which is a ' + typeof obj[k]
	          )
	        }

	        return
	      }
	    }

	    this._fill(a, obj[k], v, mod);
	  } else {
	    if (!this.override && isArrayOrObject(obj[k]) && !isEmptyObject(obj[k])) {
	      if (!(isArrayOrObject(v) && isEmptyObject(v))) {
	        throw new Error("Trying to redefine non-empty obj['" + k + "']")
	      }

	      return
	    }

	    obj[k] = _process(v, mod);
	  }
	};

	/**
	 *
	 * Converts an object with dotted-key/value pairs to it's expanded version
	 *
	 * Optionally transformed by a set of modifiers.
	 *
	 * Usage:
	 *
	 *   var row = {
	 *     'nr': 200,
	 *     'doc.name': '  My Document  '
	 *   }
	 *
	 *   var mods = {
	 *     'doc.name': [_s.trim, _s.underscored]
	 *   }
	 *
	 *   dot.object(row, mods)
	 *
	 * @param {Object} obj
	 * @param {Object} mods
	 */
	DotObject.prototype.object = function (obj, mods) {
	  var self = this;

	  Object.keys(obj).forEach(function (k) {
	    var mod = mods === undefined ? null : mods[k];
	    // normalize array notation.
	    var ok = parsePath(k, self.separator).join(self.separator);

	    if (ok.indexOf(self.separator) !== -1) {
	      self._fill(ok.split(self.separator), obj, obj[k], mod);
	      delete obj[k];
	    } else {
	      obj[k] = _process(obj[k], mod);
	    }
	  });

	  return obj
	};

	/**
	 * @param {String} path dotted path
	 * @param {String} v value to be set
	 * @param {Object} obj object to be modified
	 * @param {Function|Array} mod optional modifier
	 */
	DotObject.prototype.str = function (path, v, obj, mod) {
	  var ok = parsePath(path, this.separator).join(this.separator);

	  if (path.indexOf(this.separator) !== -1) {
	    this._fill(ok.split(this.separator), obj, v, mod);
	  } else {
	    obj[path] = _process(v, mod);
	  }

	  return obj
	};

	/**
	 *
	 * Pick a value from an object using dot notation.
	 *
	 * Optionally remove the value
	 *
	 * @param {String} path
	 * @param {Object} obj
	 * @param {Boolean} remove
	 */
	DotObject.prototype.pick = function (path, obj, remove, reindexArray) {
	  var i;
	  var keys;
	  var val;
	  var key;
	  var cp;

	  keys = parsePath(path, this.separator);
	  for (i = 0; i < keys.length; i++) {
	    key = parseKey(keys[i], obj);
	    if (obj && typeof obj === 'object' && key in obj) {
	      if (i === keys.length - 1) {
	        if (remove) {
	          val = obj[key];
	          if (reindexArray && Array.isArray(obj)) {
	            obj.splice(key, 1);
	          } else {
	            delete obj[key];
	          }
	          if (Array.isArray(obj)) {
	            cp = keys.slice(0, -1).join('.');
	            if (this.cleanup.indexOf(cp) === -1) {
	              this.cleanup.push(cp);
	            }
	          }
	          return val
	        } else {
	          return obj[key]
	        }
	      } else {
	        obj = obj[key];
	      }
	    } else {
	      return undefined
	    }
	  }
	  if (remove && Array.isArray(obj)) {
	    obj = obj.filter(function (n) {
	      return n !== undefined
	    });
	  }
	  return obj
	};
	/**
	 *
	 * Delete value from an object using dot notation.
	 *
	 * @param {String} path
	 * @param {Object} obj
	 * @return {any} The removed value
	 */
	DotObject.prototype.delete = function (path, obj) {
	  return this.remove(path, obj, true)
	};

	/**
	 *
	 * Remove value from an object using dot notation.
	 *
	 * Will remove multiple items if path is an array.
	 * In this case array indexes will be retained until all
	 * removals have been processed.
	 *
	 * Use dot.delete() to automatically  re-index arrays.
	 *
	 * @param {String|Array<String>} path
	 * @param {Object} obj
	 * @param {Boolean} reindexArray
	 * @return {any} The removed value
	 */
	DotObject.prototype.remove = function (path, obj, reindexArray) {
	  var i;

	  this.cleanup = [];
	  if (Array.isArray(path)) {
	    for (i = 0; i < path.length; i++) {
	      this.pick(path[i], obj, true, reindexArray);
	    }
	    if (!reindexArray) {
	      this._cleanup(obj);
	    }
	    return obj
	  } else {
	    return this.pick(path, obj, true, reindexArray)
	  }
	};

	DotObject.prototype._cleanup = function (obj) {
	  var ret;
	  var i;
	  var keys;
	  var root;
	  if (this.cleanup.length) {
	    for (i = 0; i < this.cleanup.length; i++) {
	      keys = this.cleanup[i].split('.');
	      root = keys.splice(0, -1).join('.');
	      ret = root ? this.pick(root, obj) : obj;
	      ret = ret[keys[0]].filter(function (v) {
	        return v !== undefined
	      });
	      this.set(this.cleanup[i], ret, obj);
	    }
	    this.cleanup = [];
	  }
	};

	/**
	 * Alias method  for `dot.remove`
	 *
	 * Note: this is not an alias for dot.delete()
	 *
	 * @param {String|Array<String>} path
	 * @param {Object} obj
	 * @param {Boolean} reindexArray
	 * @return {any} The removed value
	 */
	DotObject.prototype.del = DotObject.prototype.remove;

	/**
	 *
	 * Move a property from one place to the other.
	 *
	 * If the source path does not exist (undefined)
	 * the target property will not be set.
	 *
	 * @param {String} source
	 * @param {String} target
	 * @param {Object} obj
	 * @param {Function|Array} mods
	 * @param {Boolean} merge
	 */
	DotObject.prototype.move = function (source, target, obj, mods, merge) {
	  if (typeof mods === 'function' || Array.isArray(mods)) {
	    this.set(target, _process(this.pick(source, obj, true), mods), obj, merge);
	  } else {
	    merge = mods;
	    this.set(target, this.pick(source, obj, true), obj, merge);
	  }

	  return obj
	};

	/**
	 *
	 * Transfer a property from one object to another object.
	 *
	 * If the source path does not exist (undefined)
	 * the property on the other object will not be set.
	 *
	 * @param {String} source
	 * @param {String} target
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @param {Function|Array} mods
	 * @param {Boolean} merge
	 */
	DotObject.prototype.transfer = function (
	  source,
	  target,
	  obj1,
	  obj2,
	  mods,
	  merge
	) {
	  if (typeof mods === 'function' || Array.isArray(mods)) {
	    this.set(
	      target,
	      _process(this.pick(source, obj1, true), mods),
	      obj2,
	      merge
	    );
	  } else {
	    merge = mods;
	    this.set(target, this.pick(source, obj1, true), obj2, merge);
	  }

	  return obj2
	};

	/**
	 *
	 * Copy a property from one object to another object.
	 *
	 * If the source path does not exist (undefined)
	 * the property on the other object will not be set.
	 *
	 * @param {String} source
	 * @param {String} target
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @param {Function|Array} mods
	 * @param {Boolean} merge
	 */
	DotObject.prototype.copy = function (source, target, obj1, obj2, mods, merge) {
	  if (typeof mods === 'function' || Array.isArray(mods)) {
	    this.set(
	      target,
	      _process(
	        // clone what is picked
	        JSON.parse(JSON.stringify(this.pick(source, obj1, false))),
	        mods
	      ),
	      obj2,
	      merge
	    );
	  } else {
	    merge = mods;
	    this.set(target, this.pick(source, obj1, false), obj2, merge);
	  }

	  return obj2
	};

	/**
	 *
	 * Set a property on an object using dot notation.
	 *
	 * @param {String} path
	 * @param {any} val
	 * @param {Object} obj
	 * @param {Boolean} merge
	 */
	DotObject.prototype.set = function (path, val, obj, merge) {
	  var i;
	  var k;
	  var keys;
	  var key;

	  // Do not operate if the value is undefined.
	  if (typeof val === 'undefined') {
	    return obj
	  }
	  keys = parsePath(path, this.separator);

	  for (i = 0; i < keys.length; i++) {
	    key = keys[i];
	    if (i === keys.length - 1) {
	      if (merge && isObject(val) && isObject(obj[key])) {
	        for (k in val) {
	          if (hasOwnProperty.call(val, k)) {
	            obj[key][k] = val[k];
	          }
	        }
	      } else if (merge && Array.isArray(obj[key]) && Array.isArray(val)) {
	        for (var j = 0; j < val.length; j++) {
	          obj[keys[i]].push(val[j]);
	        }
	      } else {
	        obj[key] = val;
	      }
	    } else if (
	      // force the value to be an object
	      !hasOwnProperty.call(obj, key) ||
	      (!isObject(obj[key]) && !Array.isArray(obj[key]))
	    ) {
	      // initialize as array if next key is numeric
	      if (/^\d+$/.test(keys[i + 1])) {
	        obj[key] = [];
	      } else {
	        obj[key] = {};
	      }
	    }
	    obj = obj[key];
	  }
	  return obj
	};

	/**
	 *
	 * Transform an object
	 *
	 * Usage:
	 *
	 *   var obj = {
	 *     "id": 1,
	 *    "some": {
	 *      "thing": "else"
	 *    }
	 *   }
	 *
	 *   var transform = {
	 *     "id": "nr",
	 *    "some.thing": "name"
	 *   }
	 *
	 *   var tgt = dot.transform(transform, obj)
	 *
	 * @param {Object} recipe Transform recipe
	 * @param {Object} obj Object to be transformed
	 * @param {Array} mods modifiers for the target
	 */
	DotObject.prototype.transform = function (recipe, obj, tgt) {
	  obj = obj || {};
	  tgt = tgt || {};
	  Object.keys(recipe).forEach(
	    function (key) {
	      this.set(recipe[key], this.pick(key, obj), tgt);
	    }.bind(this)
	  );
	  return tgt
	};

	/**
	 *
	 * Convert object to dotted-key/value pair
	 *
	 * Usage:
	 *
	 *   var tgt = dot.dot(obj)
	 *
	 *   or
	 *
	 *   var tgt = {}
	 *   dot.dot(obj, tgt)
	 *
	 * @param {Object} obj source object
	 * @param {Object} tgt target object
	 * @param {Array} path path array (internal)
	 */
	DotObject.prototype.dot = function (obj, tgt, path) {
	  tgt = tgt || {};
	  path = path || [];
	  var isArray = Array.isArray(obj);

	  Object.keys(obj).forEach(
	    function (key) {
	      var index = isArray && this.useBrackets ? '[' + key + ']' : key;
	      if (
	        isArrayOrObject(obj[key]) &&
	        ((isObject(obj[key]) && !isEmptyObject(obj[key])) ||
	          (Array.isArray(obj[key]) && !this.keepArray && obj[key].length !== 0))
	      ) {
	        if (isArray && this.useBrackets) {
	          var previousKey = path[path.length - 1] || '';
	          return this.dot(
	            obj[key],
	            tgt,
	            path.slice(0, -1).concat(previousKey + index)
	          )
	        } else {
	          return this.dot(obj[key], tgt, path.concat(index))
	        }
	      } else {
	        if (isArray && this.useBrackets) {
	          tgt[path.join(this.separator).concat('[' + key + ']')] = obj[key];
	        } else {
	          tgt[path.concat(index).join(this.separator)] = obj[key];
	        }
	      }
	    }.bind(this)
	  );
	  return tgt
	};

	DotObject.pick = wrap('pick');
	DotObject.move = wrap('move');
	DotObject.transfer = wrap('transfer');
	DotObject.transform = wrap('transform');
	DotObject.copy = wrap('copy');
	DotObject.object = wrap('object');
	DotObject.str = wrap('str');
	DotObject.set = wrap('set');
	DotObject.delete = wrap('delete');
	DotObject.del = DotObject.remove = wrap('remove');
	DotObject.dot = wrap('dot');
	['override', 'overwrite'].forEach(function (prop) {
	  Object.defineProperty(DotObject, prop, {
	    get: function () {
	      return dotDefault.override
	    },
	    set: function (val) {
	      dotDefault.override = !!val;
	    }
	  });
	});
	['useArray', 'keepArray', 'useBrackets'].forEach(function (prop) {
	  Object.defineProperty(DotObject, prop, {
	    get: function () {
	      return dotDefault[prop]
	    },
	    set: function (val) {
	      dotDefault[prop] = val;
	    }
	  });
	});

	DotObject._process = _process;

	dotObject = DotObject;
	return dotObject;
}

var dotObjectExports = requireDotObject();
var DotObject = /*@__PURE__*/getDefaultExportFromCjs(dotObjectExports);

var CODE;
(function (CODE) {
    CODE[CODE["SUCCESS"] = 0] = "SUCCESS";
    CODE[CODE["ERROR"] = 1] = "ERROR";
})(CODE || (CODE = {}));
/**
 * Api-Aufruf
 */
var Api = /** @class */ (function () {
    function Api() {
    }
    var _a;
    _a = Api;
    Api.actionLocks = {};
    Api.searchParams = new URLSearchParams(window.location.search);
    /**
     * Gibt Wert vom wls Parameter zurück, falls vorhanden
     */
    Api.checkWLS = function (action) {
        if (action === void 0) { action = 'query'; }
        var wls = _a.searchParams.get('wls') || '';
        if (action !== 'query') {
            wls === null || wls === void 0 ? void 0 : wls.replace('/query;', "/".concat(action, ";"));
        }
        return wls;
    };
    /**
     * erstellt eine URI für den API Aufruf
     */
    Api.createURI = function (action) {
        if (action === void 0) { action = 'query'; }
        if (_a.searchParams.get('wls')) {
            return _a.checkWLS(action);
        }
        var sessionId;
        if (trEnv$1.sparkasse) {
            sessionId = trEnv$1.sessionId || _a.searchParams.get('jsessionid');
        }
        else {
            sessionId = getSessionId() || _a.searchParams.get('jsessionid');
        }
        var uri = "./".concat(action);
        if (sessionId) {
            uri += ";jsessionid=".concat(sessionId, "?");
        }
        return uri;
    };
    /**
     * Die send Methode der API Class
     */
    Api.send = function (action, payload, onSuccess, onError, options, dispatch) {
        var settings = {
            method: options.method || 'POST',
            timeout: options.timeout || 1000,
            responseType: options.responseType || 'json',
        };
        var formData = new URLSearchParams();
        formData.append('action', action);
        formData.append('data', JSON.stringify(payload));
        var params;
        var data;
        if (settings.method === 'GET') {
            params = formData;
        }
        else {
            data = formData;
        }
        var instance = axios.create({
            withCredentials: process.env.NODE_ENV !== 'development',
            baseURL: window.baseURL,
        });
        _a.actionLocks[action] = window.setTimeout(function () { return dispatch(pending(true)); }, settings.timeout || 1000);
        return instance({
            method: settings.method || 'GET',
            url: _a.createURI(),
            params: params,
            data: data,
            responseType: settings.responseType,
        }).then(function (response) {
            // Bei PDF requests gibt es keinen data code, daher fallstrick
            if (response.data && response.data.code === CODE.ERROR) {
                onError(response.data.fehlermeldungen.map(function (current) { return current.nachricht; }).join('<br'
                    + ' />'));
            }
            else if (response.data
                && (response.data.code === undefined || response.data.code === CODE.SUCCESS)) {
                onSuccess(response.data);
            }
            else {
                onSuccess(response);
            }
        }).catch(function (message) {
            onError(message.toString());
        }).finally(function () {
            dispatch(pending(false));
            window.clearTimeout(_a.actionLocks[action]);
            delete _a.actionLocks[action];
        });
    };
    /**
     * Send File to Server
     *
     * @param {string} action
     * @param {Object} payload
     * @param {Function} onUploadProgress
     * @param {Function} onSuccess
     * @param {Function} onError
     * @param {Object} options
     * @param {string} dispatch
     * @returns {boolean} TODO
     */
    Api.sendFile = function (action, payload, onUploadProgress, onSuccess, onError, options, dispatch) {
        var settings = {
            method: options.method || 'GET',
            timeout: options.timeout || 1000,
            responseType: options.responseType || 'json',
            headers: options.headers,
            showPending: options.showPending,
        };
        var params;
        var data;
        if (settings.method === 'GET') {
            var formData_1 = new URLSearchParams();
            Object.entries(payload).forEach(function (e) { return formData_1.append(e[0], e[1]); });
            params = formData_1;
        }
        else {
            data = payload;
        }
        var instance = axios.create({
            withCredentials: process.env.NODE_ENV !== 'development',
            baseURL: window.baseURL,
        });
        if (settings.showPending) {
            _a.actionLocks[action] = window.setTimeout(function () {
                dispatch(pending(true));
            }, settings.timeout || 1000);
        }
        return instance({
            method: settings.method,
            url: _a.createURI(action),
            headers: settings.headers,
            params: params,
            data: data,
            responseType: settings.responseType,
            onUploadProgress: onUploadProgress,
        }).then(function (response) {
            if (response.data) {
                onSuccess(response.data);
            }
            else {
                onSuccess(response);
            }
        }).catch(function (message) {
            onError(message.toString());
        }).finally(function () {
            if (settings.showPending) {
                dispatch(pending(false));
                window.clearTimeout(_a.actionLocks[action]);
                delete _a.actionLocks[action];
            }
        });
    };
    return Api;
}());

var Queue = /** @class */ (function () {
    function Queue() {
    }
    var _a;
    _a = Queue;
    Queue.queue = [];
    Queue.workingOnPromise = false;
    Queue.enqueue = function (promise) { return new Promise(function (resolve, reject) {
        _a.queue.push({
            promise: promise,
            resolve: resolve,
            reject: reject,
        });
        _a.dequeue();
    }); };
    Queue.dequeue = function () {
        if (_a.workingOnPromise) {
            return false;
        }
        var item = _a.queue.shift();
        if (!item) {
            return false;
        }
        try {
            _a.workingOnPromise = true;
            item.promise()
                .then(function (value) {
                _a.workingOnPromise = false;
                item.resolve(value);
                _a.dequeue();
            })
                .catch(function (err) {
                _a.workingOnPromise = false;
                item.reject(err);
                _a.dequeue();
            });
        }
        catch (err) {
            _a.workingOnPromise = false;
            item.reject(err);
            _a.dequeue();
        }
        return true;
    };
    return Queue;
}());

/**
 * reduziert den store für das request auf id und value
 * @param obj
 */
var objReducer = function (obj) {
    var clonedObj = obj;
    // eslint-disable-next-line consistent-return
    Object.keys(clonedObj).forEach(function (key) {
        if (typeof clonedObj[key] === 'object'
            && (['valueSet', 'value', 'error', 'warning'].indexOf(key) < 0)
            && clonedObj[key] !== null) {
            return objReducer(clonedObj[key]);
        }
        switch (clonedObj.dataType) {
            case 'java.lang.Integer':
                clonedObj.value = parseInt(clonedObj.value, 10);
                break;
            case 'java.lang.Double':
                clonedObj.value = parseFloat(clonedObj.value);
                break;
            case 'java.lang.Boolean':
                clonedObj.value = !!clonedObj.value;
                break;
        }
        // id, value und name mitschicken wenn vorhanden
        if (['id', 'value', 'name'].indexOf(key) < 0) {
            delete clonedObj[key];
        }
    });
};
var reduceObj = function (obj) {
    var copy = JSON.parse(JSON.stringify(obj));
    objReducer(copy);
    return copy;
};
var metaInfoloop = function (obj) {
    var target = {};
    /**
     * sollte mal verbessert werden...
     */
    Object.keys(obj).forEach(function (key) {
        if (key === 'versicherungsProduktStruktur') {
            var vs_1 = [];
            obj[key].forEach(function (elem, vsIndex) {
                vs_1[vsIndex] = {};
                Object.keys(obj[key][vsIndex]).forEach(function (struktur) {
                    if ((typeof obj[key][vsIndex][struktur] === 'object' && obj[key][vsIndex][struktur].name) || Array.isArray(obj[key][vsIndex][struktur])) {
                        vs_1[vsIndex][struktur] = obj[key][vsIndex][struktur];
                    }
                    else if (typeof obj[key][vsIndex][struktur] === 'object') {
                        if (obj[key][vsIndex][struktur].value == null && obj[key][vsIndex][struktur].valueSet) {
                            vs_1[vsIndex][struktur] = {
                                id: null,
                                name: 'de.ivv.au.euberatung.services.structures.EnumEmpfehlung',
                            };
                        }
                        else if (obj[key][vsIndex][struktur].value == null || obj[key][vsIndex][struktur].value === '') {
                            vs_1[vsIndex][struktur] = '';
                        }
                        else if (typeof obj[key][vsIndex][struktur].value === 'object') {
                            vs_1[vsIndex][struktur] = {
                                name: obj[key][vsIndex][struktur].value.name == null ? 'de.ivv.au.euberatung.services.structures.EnumEmpfehlung' : obj[key][vsIndex][struktur].value.name,
                                id: parseInt(obj[key][vsIndex][struktur].value.id, 10),
                            };
                        }
                        else if (obj[key][vsIndex][struktur].value) {
                            vs_1[vsIndex][struktur] = obj[key][vsIndex][struktur].value;
                        }
                    }
                    else {
                        vs_1[vsIndex][struktur] = obj[key][vsIndex][struktur];
                    }
                });
            });
            target[key] = vs_1;
        }
        else if (typeof obj[key] === 'object' && obj[key].name && obj[key].id) {
            target[key] = obj[key];
        }
        else if (typeof obj[key].value === 'object' && obj[key].value.name && obj[key].value.id) {
            target[key] = {
                name: obj[key].value.name,
                id: parseInt(obj[key].value.id, 10),
            };
        }
        else {
            target[key] = obj[key].value || '';
        }
    });
    return target;
};
var reduceOldStructure = function (obj) {
    var copy = JSON.parse(JSON.stringify(obj));
    return metaInfoloop(copy);
};
var druckloop = function (obj) {
    var target = {};
    /**
     * sollte mal verbessert werden...
     */
    Object.keys(obj).forEach(function (key) {
        var druck = {};
        Object.keys(obj[key]).forEach(function (elem) {
            druck[elem] = obj[key][elem].value;
        });
        target[key] = druck;
    });
    return target;
};
var reduceDruck = function (obj) {
    var copy = JSON.parse(JSON.stringify(obj));
    return druckloop(copy);
};

var removeMetaInfo = function (item) {
    var newItem = item;
    var toTrash = 'MetaInfo';
    var cleanedArray = Object.keys(newItem).map(function (name) { return name.replace(new RegExp("".concat(toTrash, "$")), ''); });
    // eslint-disable-next-line consistent-return
    cleanedArray.forEach(function (name) {
        if (newItem[name + toTrash]) {
            newItem[name] = newItem[name + toTrash];
            delete newItem[name + toTrash];
        }
        if (newItem[name] instanceof Object) {
            return removeMetaInfo(newItem[name]);
        }
    });
    return newItem;
};

var setErrorBoundary = function (error, cb) {
    if (cb === void 0) { cb = function (state) { }; }
    return createAsyncThunk('setErrorBoundary', function (_, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        dispatch(setStore({ name: 'appDaten.errorBoundary', value: error }));
        cb(getState());
    })();
};
var holeVorbelegungenProdukt = function (cbSuccess, localSave) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    if (localSave === void 0) { localSave = false; }
    return createAsyncThunk(EnumActions.HOLEVORBELEGUNGEN, function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var options = {
                method: 'GET',
            };
            var appDaten = getState().appDaten;
            var payload = {
                vtnr: appDaten.vtnr,
                vkanal: appDaten.vkanal,
                mandant: appDaten.mandant,
                produktauswahl: trEnv$1.produktauswahl,
            };
            if (appDaten.produktauswahl !== trEnv$1.produktauswahl) {
                window.sessionStorage.removeItem("sessionId-".concat(trEnv$1.mandant));
            }
            return Api.send(EnumActions.HOLEVORBELEGUNGEN, payload, function (response) {
                if (!localSave) {
                    dispatch(mergeStore({ name: 'daten', object: response.daten.container }));
                }
                dispatch(setStore({ name: 'appDaten.message', value: response.nachrichten }));
                dispatch(setStore({ name: 'appDaten.produktauswahl', value: trEnv$1.produktauswahl }));
                cbSuccess(response);
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
var holeCaptcha = function (cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('holeCaptcha', function (arg, _a) {
        var dispatch = _a.dispatch; _a.getState;
        Queue.enqueue(function () {
            var options = {
                method: 'GET',
                timeout: 0,
            };
            return Api.send('holeCaptcha', {}, function (response) {
                dispatch(setStore({ name: 'appDaten.captcha', value: response.daten }));
                cbSuccess(response);
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
var holeBeratersuche = function (cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('holeBeratersuche', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var options = {
                timeout: 10000,
            };
            var daten = getState().daten;
            return Api.send('holeBeratersuche', reduceObj(daten), function (response) {
                dispatch(mergeStore({ name: 'daten', object: response.daten }));
                cbSuccess(response);
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
var holeBerufeliste = function (name, cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('holeBerufeliste', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var options = {
                timeout: 1000,
            };
            var daten = getState().daten;
            var currentState = reduceObj(daten);
            var elem = DotObject.pick(name.replace(/(^daten.)|(.value$)/g, ''), currentState);
            if (elem) {
                elem.userChanged = true;
            }
            return Api.send('holeBerufeliste', currentState, function (response) {
                dispatch(setStore({ name: "".concat(name.replace('.value', '.valueSet')), value: response.daten.valueSet }));
                dispatch(setStore({ name: "".concat(name.replace('.value', '.error')), value: response.daten.error }));
                cbSuccess(response);
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
/**
 * sendet ein request und updated den store
 *
 * bisher bekannte actions:
 *  validiereAntrag
 *  validiereAngebot
 *  validiereBank
 *  erstelleAngebot
 *  holeBeratungDok
 *  erstelleAntragDok
 *  beantragen
 *  erstelleIban
 *  berechne
 *  beendeTarifrechner
 *  aktualisiereMetainfos
 *  uploadFile
 *  deleteFile
 *  updateFile
 */
var request = function (action, cbSuccess, cbError, timeout) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    if (cbError === void 0) { cbError = function () { }; }
    if (timeout === void 0) { timeout = 1000; }
    return createAsyncThunk("request_".concat(action), function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var options = {
                timeout: timeout,
            };
            var daten = getState().daten;
            return Api.send(action, reduceObj(daten), function (response) {
                dispatch(mergeStore({ name: 'daten', object: response === null || response === void 0 ? void 0 : response.daten }));
                dispatch(setStore({ name: 'appDaten.message', value: response.nachrichten }));
                updateWindowHeightForIF();
                cbSuccess(getState());
            }, function (response) {
                cbError();
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
/**
 * @deprecated serverValidationRequest stattdessen nutzen
 */
var validationRequest = function (action, list, cbSuccess, timeout) {
    if (list === void 0) { list = []; }
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    if (timeout === void 0) { timeout = 1000; }
    return createAsyncThunk('validationRequest', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var options = {
                timeout: timeout,
            };
            var daten = getState().daten;
            var currentState = reduceObj(daten);
            list.forEach(function (name) {
                var elem = DotObject.pick(name, currentState);
                if (elem) {
                    elem.userChanged = true;
                }
            });
            return Api.send(action, currentState, function (response) {
                dispatch(mergeStore({ name: 'daten', object: response === null || response === void 0 ? void 0 : response.daten }));
                dispatch(setStore({ name: 'appDaten.message', value: response.nachrichten }));
                updateWindowHeightForIF();
                cbSuccess(getState());
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
var serverValidationRequest = function (action, list, cbSuccess, timeout) {
    if (list === void 0) { list = []; }
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    if (timeout === void 0) { timeout = 1000; }
    return createAsyncThunk('validationRequest', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var options = {
                timeout: timeout,
            };
            var daten = getState().daten;
            var currentState = reduceObj(daten);
            list.forEach(function (name) {
                var elem = DotObject.pick(name, currentState);
                if (elem) {
                    elem.userChanged = true;
                }
            });
            return Api.send(action, currentState, function (response) {
                dispatch(mergeStore({ name: 'daten', object: response.daten }));
                dispatch(setStore({ name: 'appDaten.message', value: response.nachrichten }));
                updateWindowHeightForIF();
                var neueListe = [];
                list.forEach(function (name) {
                    var data = DotObject.pick(name, response.daten);
                    if (data) {
                        neueListe.push(data);
                    }
                });
                checkError(neueListe, function () { cbSuccess(response.daten); });
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
var pdfRequest = function (action, name, cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('pdfRequest', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var options = {
                method: 'GET',
                timeout: 0,
                responseType: 'arraybuffer',
            };
            return Api.send(action, {}, function (response) {
                blobToPDF(response, name);
                cbSuccess(getState());
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
var holeVorbelegungenBeratungsdoku = function (cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('holeVorbelegungenBeratungsdoku', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var options = {
                timeout: 500,
            };
            var daten = getState().daten;
            return Api.send('holeVorbelegungenBeratungsdoku', reduceObj(daten), function (response) {
                dispatch(noDeepMerge({ name: 'euBeratung', object: removeMetaInfo(response.daten) }));
                cbSuccess(getState());
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
/**
 * validiereBeratungsdoku
 * aktualisiereMetainfosEuberatung
 */
var beratungRequest = function (action, cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('beratungRequest', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var _a;
            var options = {
                timeout: 0,
            };
            var _b = getState(), daten = _b.daten, euBeratung = _b.euBeratung;
            var payload = {
                euBeratung: reduceOldStructure(euBeratung),
                mdt: (_a = daten === null || daten === void 0 ? void 0 : daten.mdt) === null || _a === void 0 ? void 0 : _a.value,
            };
            return Api.send(action, payload, function (response) {
                dispatch(noDeepMerge({ name: 'euBeratung', object: removeMetaInfo(response.daten) }));
                cbSuccess(getState());
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
var holeVorbelegungDruckmatrix = function (cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('holeVorbelegungDruckmatrix', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        Queue.enqueue(function () {
            var _a;
            var options = {
                timeout: 500,
            };
            var _b = getState(), daten = _b.daten, euBeratung = _b.euBeratung;
            var payload = {
                euBeratung: reduceOldStructure(euBeratung),
                mdt: (_a = daten === null || daten === void 0 ? void 0 : daten.mdt) === null || _a === void 0 ? void 0 : _a.value,
            };
            return Api.send('holeVorbelegungDruckmatrix', payload, function (response) {
                dispatch(noDeepMerge({ name: 'druckmatrix', object: removeMetaInfo(response.daten) }));
                cbSuccess(getState());
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
var ospPDFRequest = function (cbSuccess, nachname) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('ospPDFRequest', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        var dokumentname = nachname;
        Queue.enqueue(function () {
            var options = {
                method: 'GET',
                timeout: 0,
                responseType: 'blob',
            };
            var _a = getState(), daten = _a.daten, druckmatrix = _a.druckmatrix;
            var payload = {
                druckMatrix: reduceDruck(druckmatrix),
            };
            if (dokumentname === undefined) {
                dokumentname = "".concat(daten.vn.nachname.value, "_Dokumente.pdf");
            }
            return Api.send('erstelleDokumenteOsp', payload, function (response) {
                blobToPDF(response, dokumentname);
                cbSuccess(getState());
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
var toggleModal = function (content, size, cb) {
    if (cb === void 0) { cb = function (state) { }; }
    return createAsyncThunk('toggleModal', function (arg, _a) {
        var dispatch = _a.dispatch, getState = _a.getState;
        var tooltip = getState().appDaten.tooltip;
        dispatch(setStore({
            name: 'appDaten.tooltip',
            value: __assign$1(__assign$1({}, tooltip), { status: true, text: content, size: size }),
        }));
        cb(getState());
    })();
};
/**
 * Send file to server
 *
 * @param {FormData} formData - Form data send to server
 * @param {Function} onUploadProgress - Tracking file upload progress
 * @param {Function} cbSuccess - Callback function
 * @returns {boolean} TODO
 */
var uploadFile = function (formData, onUploadProgress, cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('uploadFile', function (arg, _a) {
        var dispatch = _a.dispatch;
        Queue.enqueue(function () {
            var options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            };
            return Api.sendFile('uploadFile', formData, onUploadProgress, function (response) {
                updateWindowHeightForIF();
                cbSuccess(response);
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
/**
 * Delete file from server
 *
 * @param {string} id
 * @param {Function} cbSuccess
 * @returns {boolean} TODO
 */
var deleteFile = function (id, cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('deleteFile', function (arg, _a) {
        var dispatch = _a.dispatch;
        Queue.enqueue(function () {
            var params = { id: id };
            var options = {
                method: 'GET',
                showPending: true,
            };
            return Api.sendFile('deleteFile', params, function () { }, function (response) {
                updateWindowHeightForIF();
                cbSuccess(response);
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};
/**
 * Update file from server
 *
 * @param {string} id
 * @param {string} klassifizierung
 * @param {Function} cbSuccess
 * @returns {boolean} TODO
 */
var updateFile = function (id, klassifizierung, cbSuccess) {
    if (cbSuccess === void 0) { cbSuccess = function (state) { }; }
    return createAsyncThunk('updateFile', function (arg, _a) {
        var dispatch = _a.dispatch;
        Queue.enqueue(function () {
            var params = {
                id: id,
                klassifizierung: klassifizierung,
            };
            var options = {
                methode: 'GET',
                showPending: true,
            };
            return Api.sendFile('updateFile', params, function () { }, function (response) {
                updateWindowHeightForIF();
                cbSuccess(response);
            }, function (response) {
                dispatch(setErrorBoundary(response));
            }, options, dispatch);
        });
    })();
};

var requests = /*#__PURE__*/Object.freeze({
  __proto__: null,
  beratungRequest: beratungRequest,
  deleteFile: deleteFile,
  holeBeratersuche: holeBeratersuche,
  holeBerufeliste: holeBerufeliste,
  holeCaptcha: holeCaptcha,
  holeVorbelegungDruckmatrix: holeVorbelegungDruckmatrix,
  holeVorbelegungenBeratungsdoku: holeVorbelegungenBeratungsdoku,
  holeVorbelegungenProdukt: holeVorbelegungenProdukt,
  ospPDFRequest: ospPDFRequest,
  pdfRequest: pdfRequest,
  request: request,
  serverValidationRequest: serverValidationRequest,
  setErrorBoundary: setErrorBoundary,
  toggleModal: toggleModal,
  updateFile: updateFile,
  uploadFile: uploadFile,
  validationRequest: validationRequest
});

var stripJSONBoundaries = function (list) { return list.map(function (name) { return name.replace(/(^daten.)|(.value$)/g, ''); }); };
var onChangeTimeout = 1000;
/**
 * Nach einem bestimmten Timeout wird der Request erst ausgeführt
 * @param {string} name
 * @param {Number} timeout
 * @param {Function} cb
 */
var handleTimeout = function (name, timeout, cb) {
    if (cb === void 0) { cb = function () { }; }
    if (!window.appValidateTimeout) {
        window.appValidateTimeout = {};
    }
    if (window.appValidateTimeout[name]) {
        window.clearTimeout(window.appValidateTimeout[name]);
        delete window.appValidateTimeout[name];
    }
    window.appValidateTimeout[name] = window.setTimeout(function () {
        cb();
        delete window.appValidateTimeout[name];
    }, timeout);
};
var useUpdateAndValidateOnChangeByList = function (list, timeout, callService) {
    if (timeout === void 0) { timeout = onChangeTimeout; }
    if (callService === void 0) { callService = true; }
    var dispatch = useDispatch();
    return (function (e, onSuccess) {
        if (onSuccess === void 0) { onSuccess = function () { return null; }; }
        var _a = e.target, name = _a.name, value = _a.value;
        dispatch(updateByName(name, value));
        if (!callService) {
            return;
        }
        handleTimeout(name, timeout, function () { return dispatch(serverValidationRequest(EnumActions.VALIDIERE, stripJSONBoundaries(list), onSuccess)); });
    });
};
/**
 * Validiere Hook für updateByEvent
 * @param {Number} timeout
 * @param {boolean} callService
 * @param {Function} checkLength
 * @return {(function(Event, onSucces): void)|*}
 */
var useUpdateAndValidateOnChange = function (timeout, callService, checkLength) {
    if (timeout === void 0) { timeout = onChangeTimeout; }
    if (callService === void 0) { callService = true; }
    if (checkLength === void 0) { checkLength = function (arg) { return true; }; }
    var dispatch = useDispatch();
    var store = useStore().getState();
    return (function (e, onSuccess) {
        if (onSuccess === void 0) { onSuccess = function () { return null; }; }
        var _a = e.target, name = _a.name, value = _a.value, type = _a.type, checked = _a.checked;
        var oldValue = dotProp.get(store, name);
        if (oldValue === value) {
            return;
        }
        var updateValue = type === 'checkbox' ? !!checked : value;
        dispatch(updateByName(name, updateValue));
        if (!checkLength(updateValue) || !callService) {
            return;
        }
        handleTimeout(name, timeout, function () { return dispatch(serverValidationRequest(EnumActions.VALIDIERE, stripJSONBoundaries([name]), onSuccess)); });
    });
};
/**
 * Berechne Hook für updateByEvent
 * @param {Number} timeout
 * @param {boolean} callService
 * @param {Function} checkLength
 * @return {(function(Event, onSucces): void)|*}
 */
var useUpdateAndBerechneOnChange = function (timeout, callService, checkLength) {
    if (timeout === void 0) { timeout = onChangeTimeout; }
    if (callService === void 0) { callService = true; }
    if (checkLength === void 0) { checkLength = function (arg) { return true; }; }
    var dispatch = useDispatch();
    var store = useStore().getState();
    return (function (e, onSuccess) {
        if (onSuccess === void 0) { onSuccess = function () { return null; }; }
        var _a = e.target, name = _a.name, value = _a.value, type = _a.type, checked = _a.checked;
        var oldValue = dotProp.get(store, name);
        if (oldValue === value) {
            return;
        }
        var updateValue = type === 'checkbox' ? !!checked : value;
        dispatch(updateByName(name, updateValue));
        if (!checkLength(updateValue) || !callService) {
            return;
        }
        handleTimeout(name, timeout, function () { return dispatch(serverValidationRequest(EnumActions.BERECHNE, stripJSONBoundaries([name]), onSuccess)); });
    });
};
var useUpdateByEventAndValidateOnChangeByList = function (list, timeout, callService, checkLength) {
    if (timeout === void 0) { timeout = onChangeTimeout; }
    if (callService === void 0) { callService = true; }
    if (checkLength === void 0) { checkLength = function (arg) { return true; }; }
    var dispatch = useDispatch();
    return (function (e, onSuccess) {
        if (onSuccess === void 0) { onSuccess = function () { return null; }; }
        var _a = e.target, name = _a.name, value = _a.value;
        dispatch(updateByName(name, value));
        if (!checkLength(value) || !callService) {
            return;
        }
        handleTimeout(name, timeout, function () { return dispatch(serverValidationRequest(EnumActions.VALIDIERE, stripJSONBoundaries(list), onSuccess)); });
    });
};
var useUpdateByNameAndValidateOnChangeByList = function (list, timeout, callService) {
    if (timeout === void 0) { timeout = onChangeTimeout; }
    if (callService === void 0) { callService = true; }
    var dispatch = useDispatch();
    return (function (name, value, onSuccess) {
        if (onSuccess === void 0) { onSuccess = function () { return null; }; }
        dispatch(updateByName(name, value));
        if (!callService) {
            return;
        }
        handleTimeout(name, timeout, function () { return dispatch(serverValidationRequest(EnumActions.VALIDIERE, stripJSONBoundaries(list), onSuccess)); });
    });
};
var useUpdateAndValidateDateOnChange = function (timeout, callService) {
    if (timeout === void 0) { timeout = 0; }
    if (callService === void 0) { callService = true; }
    return useUpdateAndValidateOnChange(timeout, callService, function (value) { return typeof value !== 'string' || value.replace('_', '').length === 10; });
};
var useUpdateAndValidateDateOnChangeByList = function (list, timeout, callService) {
    if (timeout === void 0) { timeout = 0; }
    if (callService === void 0) { callService = true; }
    return useUpdateByEventAndValidateOnChangeByList(list, timeout, callService, function (value) { return typeof value !== 'string' || value.replace('_', '').length === 10; });
};
var useUpdateAndValidatePlzOnChange = function (timeout, callService) {
    if (timeout === void 0) { timeout = 0; }
    if (callService === void 0) { callService = true; }
    return useUpdateAndValidateOnChange(timeout, callService, function (value) { return typeof value !== 'string' || value.length === 5; });
};
var useUpdateAndValidateIBANOnChange = function (timeout, callService) {
    if (timeout === void 0) { timeout = 0; }
    if (callService === void 0) { callService = true; }
    return useUpdateAndValidateOnChange(timeout, callService, function (value) { return typeof value !== 'string' || value.replace('_', '').length === 0 || value.replace('_', '').length === 27; });
};
/**
 * Validiere Hook für updateByName
 * @param {Number} timeout
 * @param {boolean} callService
 * @param {Function} checkLength
 * @return {(function(name, value, onSucces): void)|*}
 */
var useUpdateByNameAndValidateOnChange = function (timeout, callService, sameValue) {
    if (timeout === void 0) { timeout = onChangeTimeout; }
    if (callService === void 0) { callService = true; }
    if (sameValue === void 0) { sameValue = true; }
    var dispatch = useDispatch();
    var store = useStore().getState();
    return (function (name, value, onSuccess) {
        if (onSuccess === void 0) { onSuccess = function () { return null; }; }
        var oldValue = dotProp.get(store, name);
        if (sameValue && oldValue === value) {
            return;
        }
        dispatch(updateByName(name, value));
        if (!callService) {
            return;
        }
        handleTimeout(name, timeout, function () { return dispatch(serverValidationRequest(EnumActions.VALIDIERE, stripJSONBoundaries([name]), onSuccess)); });
    });
};
/**
 * Berechne Hook für updateByName
 * @param {Number} timeout
 * @param {boolean} callService
 * @param {Function} checkLength
 * @return {(function(name, value, onSucces): void)|*}
 */
var useUpdateByNameAndBerechneOnChange = function (timeout, callService) {
    if (timeout === void 0) { timeout = onChangeTimeout; }
    if (callService === void 0) { callService = true; }
    var dispatch = useDispatch();
    var store = useStore().getState();
    return (function (name, value, onSuccess) {
        if (onSuccess === void 0) { onSuccess = function () { return null; }; }
        var oldValue = dotProp.get(store, name);
        if (oldValue === value) {
            return;
        }
        dispatch(updateByName(name, value));
        if (!callService) {
            return;
        }
        handleTimeout(name, timeout, function () { return dispatch(serverValidationRequest(EnumActions.BERECHNE, stripJSONBoundaries([name]), onSuccess)); });
    });
};
var useValidateOnBlur = function (timeout, callService) {
    if (timeout === void 0) { timeout = 0; }
    if (callService === void 0) { callService = true; }
    var dispatch = useDispatch();
    return (function (e, onSuccess) {
        if (onSuccess === void 0) { onSuccess = function () { return null; }; }
        var name = e.target.name;
        if (!callService) {
            return;
        }
        handleTimeout(name, timeout, function () { return dispatch(serverValidationRequest(EnumActions.VALIDIERE, stripJSONBoundaries([name]), onSuccess)); });
    });
};

var TooltipInhalt = React__default.forwardRef(function (props, ref) {
    useEffect(function () {
        var _a, _b;
        (_b = (_a = props.popper).scheduleUpdate) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [props.text, props.popper]);
    return (jsx$1(Tooltip$1, __assign$1({}, props, { style: __assign$1(__assign$1(__assign$1({}, props.style), props.tooltipStyle), { minWidth: '55px' }), ref: ref, children: jsx$1("span", { dangerouslySetInnerHTML: { __html: props.text } }) })));
});
var HandleTooltip = function (_a) {
    var value = _a.value, children = _a.children, _b = _a.sliderTooltip, sliderTooltip = _b === void 0 ? true : _b, tooltipText = _a.tooltipText, addToTooltip = _a.addToTooltip, inputGroup = _a.inputGroup, addMarkLabel = _a.addMarkLabel, icon = _a.icon, minSelectedValue = _a.minSelectedValue, tooltipStyle = _a.tooltipStyle;
    if (!sliderTooltip) {
        return (children);
    }
    var target = useRef(null);
    var isVisible = useOnScreen(target);
    var setTooltipText = function () {
        if (minSelectedValue) {
            if (value < minSelectedValue || value < 0) {
                return 'Bitte wählen';
            }
        }
        if (value < 0) {
            return 'Bitte wählen';
        }
        if (tooltipText) {
            return tooltipText;
        }
        if (addToTooltip) {
            return "".concat(value, "&nbsp;").concat(addToTooltip);
        }
        if (inputGroup) {
            return "".concat(value, "&nbsp;").concat(inputGroup);
        }
        if (addMarkLabel) {
            return "".concat(value, "&nbsp;").concat(addMarkLabel);
        }
        return value;
    };
    var sliderIconStyle = __assign$1({ border: 'none' }, children.props.style);
    return (jsxs(Fragment, { children: [icon ? (jsx$1("div", __assign$1({}, children.props, { ref: target, style: sliderIconStyle, children: icon }))) : React__default.cloneElement(children, { ref: function (ref) { return (target.current = ref); } }), isVisible && (jsx$1(Overlay$1, { container: target.current, target: target.current, show: true, popperConfig: {
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 5],
                            },
                        },
                    ],
                }, placement: "top", children: function (overlayProps) { return (jsx$1(TooltipInhalt, __assign$1({}, overlayProps, { text: setTooltipText(), tooltipStyle: tooltipStyle }))); } }))] }));
};
var handleRender = function (node, props, tooltipText, sliderTooltip, addToTooltip, inputGroup, addMarkLabel, icon, minSelectedValue, tooltipStyle) { return (jsx$1(HandleTooltip, { value: props.value, tooltipText: tooltipText, sliderTooltip: sliderTooltip, addToTooltip: addToTooltip, inputGroup: inputGroup, addMarkLabel: addMarkLabel, icon: icon, minSelectedValue: minSelectedValue, tooltipStyle: tooltipStyle, children: node })); };

var StyledSlider = styled(Slider)(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  margin: 3rem 10px 0 10px;\n  ", "\n  .rc-slider {\n    &-dot {\n      display: ", ";\n      ", "\n    }\n    &-step {\n      pointer-events: initial;\n      cursor: pointer;\n    }\n    &-handle {\n      &:focus,\n      &-dragging {\n        border-color: var(--primary);\n        box-shadow: 0 0 0 5px var(--primary-focus) !important;\n      }\n      &.notranslate {\n        transform: none !important;\n      }\n      .tooltip {\n        font-size: .875rem;\n        z-index: 1040;\n      }\n      svg {\n        height: 100%;\n        width: 100%;\n      }\n    }\n    &-mark {\n      display: ", ";\n      font-size: 14px;\n      margin-top: 3px;\n      &-text {\n        display: ", ";\n        white-space: nowrap;\n        ", "\n        ", "\n      }\n    }\n  }\n  + .input-group-text {\n    align-self: flex-end;\n    margin-left: 10px !important;\n    padding: 0;\n  }\n"], ["\n  margin: 3rem 10px 0 10px;\n  ", "\n  .rc-slider {\n    &-dot {\n      display: ", ";\n      ", "\n    }\n    &-step {\n      pointer-events: initial;\n      cursor: pointer;\n    }\n    &-handle {\n      &:focus,\n      &-dragging {\n        border-color: var(--primary);\n        box-shadow: 0 0 0 5px var(--primary-focus) !important;\n      }\n      &.notranslate {\n        transform: none !important;\n      }\n      .tooltip {\n        font-size: .875rem;\n        z-index: 1040;\n      }\n      svg {\n        height: 100%;\n        width: 100%;\n      }\n    }\n    &-mark {\n      display: ", ";\n      font-size: 14px;\n      margin-top: 3px;\n      &-text {\n        display: ", ";\n        white-space: nowrap;\n        ", "\n        ", "\n      }\n    }\n  }\n  + .input-group-text {\n    align-self: flex-end;\n    margin-left: 10px !important;\n    padding: 0;\n  }\n"])), function (_a) {
    var showFirstLastMarks = _a.showFirstLastMarks, showMarks = _a.showMarks;
    return (showFirstLastMarks || showMarks) && css$3(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n    + .invalid-feedback {\n      margin-top: 2rem;\n    }\n  "], ["\n    + .invalid-feedback {\n      margin-top: 2rem;\n    }\n  "])));
}, function (_a) {
    var showDots = _a.showDots;
    return (showDots ? 'block' : 'none');
}, function (_a) {
    var showFirstLastDots = _a.showFirstLastDots;
    return showFirstLastDots && css$3(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n        &:first-child,\n        &:last-child {\n          display: block;\n        }\n      "], ["\n        &:first-child,\n        &:last-child {\n          display: block;\n        }\n      "])));
}, function (_a) {
    var showFirstLastMarks = _a.showFirstLastMarks, showMarks = _a.showMarks;
    return (showFirstLastMarks || showMarks ? 'block' : 'none');
}, function (_a) {
    var showMarks = _a.showMarks;
    return (showMarks ? 'block' : 'none');
}, function (_a) {
    var showFirstLastMarks = _a.showFirstLastMarks;
    return showFirstLastMarks && css$3(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n          &:first-child,\n          &:last-child {\n            display: inline-block;\n          }\n        "], ["\n          &:first-child,\n          &:last-child {\n            display: inline-block;\n          }\n        "])));
}, function (_a) {
    var addMarkLabel = _a.addMarkLabel;
    return addMarkLabel && css$3(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n          &::after {\n            content: '\\00a0", "';\n            display: inline-block;\n          }\n        "], ["\n          &::after {\n            content: '\\\\00a0", "';\n            display: inline-block;\n          }\n        "])), addMarkLabel);
});
var RCSlider = function (_a) {
    var _b;
    var _c = _a.valueSet, valueSet = _c === void 0 ? [] : _c, _d = _a.onChange, onChange = _d === void 0 ? function () { } : _d, name = _a.name, _e = _a.value, value = _e === void 0 ? 0 : _e, disabled = _a.disabled, _f = _a.min, min = _f === void 0 ? 0 : _f, _g = _a.max, max = _g === void 0 ? 0 : _g, _h = _a.step, step = _h === void 0 ? 1 : _h, marks = _a.marks, markMin = _a.markMin, handleStyle = _a.handleStyle, trackStyle = _a.trackStyle, _j = _a.railStyle, railStyle = _j === void 0 ? {
        backgroundColor: '#ccc',
    } : _j, _k = _a.showMarks, showMarks = _k === void 0 ? false : _k, _l = _a.showFirstLastMarks, showFirstLastMarks = _l === void 0 ? false : _l, addMarkLabel = _a.addMarkLabel, tooltipText = _a.tooltipText, handleRender$1 = _a.handleRender, _m = _a.sliderClassName, sliderClassName = _m === void 0 ? 'mt-5' : _m, _o = _a.sliderTooltip, sliderTooltip = _o === void 0 ? true : _o, showFirstLastDots = _a.showFirstLastDots, _p = _a.showDots, showDots = _p === void 0 ? false : _p, _q = _a.generateMarks, generateMarks = _q === void 0 ? false : _q, ariaLabelledByForHandle = _a.ariaLabelledByForHandle, addToTooltip = _a.addToTooltip, inputGroup = _a.inputGroup, icon = _a.icon, minSelectedValue = _a.minSelectedValue, tooltipStyle = _a.tooltipStyle;
    var genMarks;
    if (valueSet.length !== 0) {
        genMarks = {};
        valueSet.forEach(function (element, i) {
            if (genMarks) {
                genMarks[i + 1] = element.bezeichnung;
            }
        });
    }
    if (Number.isInteger(markMin)) {
        genMarks = (_b = {},
            _b[min] = min,
            _b);
        for (var i = markMin || 0; i <= max; i += 1) {
            genMarks[i] = i;
        }
    }
    /* Props for min, max and step mus be defined */
    if (generateMarks && min !== max) {
        genMarks = {};
        for (var i = min; i <= max; i += step) {
            genMarks[i] = i;
        }
    }
    var setAriaValueText = function (val) {
        if (minSelectedValue) {
            if (value < minSelectedValue || value <= minSelectedValue) {
                return 'Bitte wählen';
            }
        }
        if (value < 0) {
            return 'Bitte wählen';
        }
        if (tooltipText) {
            return tooltipText;
        }
        if (addToTooltip) {
            return "".concat(val, " ").concat(addToTooltip);
        }
        if (inputGroup) {
            return "".concat(value, " ").concat(inputGroup);
        }
        if (addMarkLabel) {
            return "".concat(value, " ").concat(addMarkLabel);
        }
        return null;
    };
    return (jsx$1(StyledSlider, { className: "flex-grow-1 w-auto ".concat(sliderClassName), marks: marks || genMarks, min: min, max: max || valueSet.length - 1, step: (marks || genMarks) ? null : step, onChange: function (sliderValue) {
            if (Array.isArray(sliderValue)) {
                return;
            }
            if (sliderValue < max) {
                onChange(name, sliderValue);
            }
            else if (value >= max) {
                onChange(name, value);
            }
            else {
                onChange(name, sliderValue);
            }
        }, disabled: disabled, value: value, handleRender: function (node, props) { return (handleRender$1
            ? handleRender$1(node, props, valueSet)
            : handleRender(node, props, tooltipText, sliderTooltip, addToTooltip, inputGroup, addMarkLabel, icon, minSelectedValue, tooltipStyle)); }, styles: {
            handle: __assign$1({ width: '24px', height: '24px', borderWidth: 2, borderColor: 'var(--primary)', color: 'var(--primary)', marginTop: -10, opacity: 1 }, handleStyle),
            track: __assign$1({ backgroundColor: 'var(--primary)' }, trackStyle),
            rail: isEmptyObj(railStyle) ? trackStyle : railStyle,
        }, dotStyle: {
            borderColor: '#ccc',
            width: 12,
            height: 12,
            bottom: -4,
        }, activeDotStyle: {
            borderColor: 'var(--primary)',
        }, showMarks: showMarks, showFirstLastMarks: showFirstLastMarks, addMarkLabel: addMarkLabel, showFirstLastDots: showFirstLastDots, showDots: showDots, ariaLabelledByForHandle: ariaLabelledByForHandle, ariaValueTextFormatterForHandle: function (val) { return setAriaValueText(val); } }));
};
var templateObject_1$w, templateObject_2$d, templateObject_3$8, templateObject_4$3, templateObject_5$2;

var StyledExclamation = styled(SvgExclamation)(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  width: 100px !important;\n  height: 10rem !important;\n"], ["\n  width: 100px !important;\n  height: 10rem !important;\n"])));
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.refreshPage = function () {
            _this.clearErrorMessage(function () { return window.location.reload(); });
        };
        _this.createErrorMessage = function () {
            var tarifrechner = _this.props.tarifrechner;
            var error = _this.state.error;
            var seite = window.location.hash || 'keine Seite geladen';
            var timestamp = Date.now();
            var date = new Date().toLocaleString();
            return "".concat(timestamp, ", ").concat(date, ", ").concat(tarifrechner, ", ").concat(seite, ", ").concat(error);
        };
        _this.saveStore = function () {
            var _a = _this.props, tarifrechner = _a.tarifrechner, version = _a.version, alleDaten = _a.alleDaten;
            var store = crypt(JSON.stringify(alleDaten));
            var fileToSave = new Blob([store], {
                type: 'application/json',
            });
            fileSaver.saveAs(fileToSave, "".concat(tarifrechner, "-").concat(version));
        };
        _this.state = {
            error: null,
            errorInfo: null,
            hasError: false,
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var _this = this;
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
        var log = this.props.log;
        log(error.toString(), errorInfo.componentStack);
        window.onpagehide = function () {
            _this.clearErrorMessage();
        };
    };
    ErrorBoundary.prototype.clearErrorMessage = function (callback) {
        if (callback === void 0) { callback = function () { }; }
        var _a = this.props, updateByName = _a.updateByName, path = _a.path;
        updateByName(path, null, callback);
    };
    ErrorBoundary.prototype.render = function () {
        var errorInfo = this.state.errorInfo;
        var children = this.props.children;
        var errorMessage = this.createErrorMessage();
        if (errorInfo) {
            return (jsx$1("div", { className: "bs-iso", children: jsx$1(Container, { children: jsx$1(Row, { children: jsxs(Col, { children: [jsx$1(StyledExclamation, {}), jsx$1("h2", { children: i18next.t('error.headline') }), jsx$1("p", { dangerouslySetInnerHTML: { __html: i18next.t('error.inhalt') } }), !trEnv$1.sparkasse
                                    && jsx$1(Button$1, { className: "mt-3", onClick: this.refreshPage, children: "Erneut versuchen" }), jsx$1("p", { className: "mt-3 text--small fw-bold", children: errorMessage }), trEnv$1.stationaer
                                    && jsx$1(Button$1, { className: "mt-3", onClick: this.saveStore, children: "Log speichern" })] }) }) }) }));
        }
        return children;
    };
    return ErrorBoundary;
}(React__default.Component));
var mapStateToProps = function (state) { return ({
    tarifrechner: state.appDaten.tarifrechner,
    version: state.appDaten.version,
    alleDaten: state.daten,
}); };
var index$d = connect(mapStateToProps, actions)(ErrorBoundary);
var templateObject_1$v;

var If = function (_a) {
    var _b = _a.predicate, predicate = _b === void 0 ? false : _b, children = _a.children;
    return (predicate ? children : null);
};
var If$1 = React__default.memo(If);

var CollapsibleButton = styled(Button$1)(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  font-weight: 100 !important;\n  &:active, &:focus {\n    text-decoration: underline !important;\n  }\n  &:hover {\n    text-decoration: underline !important;\n  }\n"], ["\n  font-weight: 100 !important;\n  &:active, &:focus {\n    text-decoration: underline !important;\n  }\n  &:hover {\n    text-decoration: underline !important;\n  }\n"])));
var CollapsibleArrowTop = styled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  border: solid #000;\n  border-width: 0 1px 1px 0;\n  display: inline-block;\n  margin-right: 6px;\n  height: 9px;\n  width: 9px;\n  position: relative;\n  top: 1px;\n  transition: transform 550ms ease;\n  transform: ", ";\n"], ["\n  border: solid #000;\n  border-width: 0 1px 1px 0;\n  display: inline-block;\n  margin-right: 6px;\n  height: 9px;\n  width: 9px;\n  position: relative;\n  top: 1px;\n  transition: transform 550ms ease;\n  transform: ", ";\n"])), function (_a) {
    var expanded = _a.expanded;
    return (expanded ? 'rotate(-45deg)' : 'rotate(45deg)');
});
var CollapsibleArrowBottom = styled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  border: solid #000;\n  border-width: 0 1px 1px 0;\n  display: inline-block;\n  margin-right: 6px;\n  height: 9px;\n  width: 9px;\n  position: relative;\n  top: -2px;\n  transition: transform 550ms ease;\n  transform: ", ";\n"], ["\n  border: solid #000;\n  border-width: 0 1px 1px 0;\n  display: inline-block;\n  margin-right: 6px;\n  height: 9px;\n  width: 9px;\n  position: relative;\n  top: -2px;\n  transition: transform 550ms ease;\n  transform: ", ";\n"])), function (_a) {
    var expanded = _a.expanded;
    return (expanded ? 'rotate(-135deg)' : 'rotate(-45deg)');
});
var CollapsibleContent = styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  margin-bottom: 0;\n"], ["\n  margin-bottom: 0;\n"])));
/**
 * Ersetzt Leerzeichen mit Bindetsrichen und setzt den String auf Kleinbuchstaben
 *
 * @param {string} string
 * @returns {string}
 */
var generateName = function (name) { return name.replace(/ /g, '-').toLowerCase(); };
var Collapsible = function (_a) {
    var _b = _a.textClose, textClose = _b === void 0 ? '' : _b, _c = _a.textOpen, textOpen = _c === void 0 ? '' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.children, children = _e === void 0 ? null : _e, _f = _a.expand, expand = _f === void 0 ? false : _f, _g = _a.position, position = _g === void 0 ? 'bottom' : _g, _h = _a.name, name = _h === void 0 ? '' : _h;
    var _j = useState(expand), expanded = _j[0], setExpanded = _j[1];
    if (!children) {
        return null;
    }
    return (jsxs("div", { className: "collapsible ".concat(className), children: [position === 'top' && (jsxs(CollapsibleButton, { type: "button", variant: "link", className: "collapsible__button link", onClick: function () {
                    setExpanded(!expanded);
                }, "aria-expanded": !expanded, name: "".concat(name, " ").concat(textClose || textOpen), children: [jsx$1(CollapsibleArrowTop, { expanded: !expanded, className: "collapsible__arrow" }), expanded && textClose ? textClose : textOpen] })), jsx$1(Collapse, { in: expanded, children: jsx$1(CollapsibleContent, { className: "collapsible__content flex-column", children: children }) }), position === 'bottom' && (jsxs(CollapsibleButton, { type: "button", variant: "link", className: "collapsible__button link", onClick: function () {
                    setExpanded(!expanded);
                }, "aria-expanded": expanded, name: "".concat(name, "-").concat(expanded && textClose ? generateName(textClose) : generateName(textOpen)), children: [jsx$1(CollapsibleArrowBottom, { expanded: expanded, className: "collapsible__arrow" }), expanded && textClose ? textClose : textOpen] }))] }));
};
var index$c = React__default.memo(Collapsible);
var templateObject_1$u, templateObject_2$c, templateObject_3$7, templateObject_4$2;

/**
 * Bootstrap 5 Accordion
 *
 * @param {Array} data
 * @param {Boolean} alwaysOpen
 * @param {string} className
 * @returns {React.Component}
 */
var Accordion = function (_a) {
    var data = _a.data, _b = _a.alwaysOpen, alwaysOpen = _b === void 0 ? true : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    var openItems = data.filter(function (el) { return el.isExpanded && el.visible; }).map(function (el) { return el.id; });
    useEffect(function () {
        updateWindowHeightForIF();
    });
    return (jsx$1(Accordion$1, { defaultActiveKey: openItems, alwaysOpen: alwaysOpen, className: className, children: data.map(function (item) { return (item.visible && (jsxs(Accordion$1.Item, { eventKey: item.id, children: [jsx$1(Accordion$1.Header, { "data-tracking-name": "accordion-".concat(item.id), children: item.header }), jsxs(Accordion$1.Body, { children: [item.content, item.edit && (jsx$1(Button$1, { className: "mt-2", variant: "link", size: "sm", onClick: item.edit, "data-tracking-name": "accordion-".concat(item.id, "-daten-bearbeiten"), children: "Daten bearbeiten" }))] })] }, item.id))); }) }));
};
var index$b = React__default.memo(Accordion);

var Ivvfooter = styled.footer(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  padding: 30px 20px;\n  margin-top: 50px;\n  background-color: #edf0f4;\n  color: #6b7171;\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"], ["\n  padding: 30px 20px;\n  margin-top: 50px;\n  background-color: #edf0f4;\n  color: #6b7171;\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"])));
var Header = styled.h2(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  line-height: 1.3;\n  margin: 0;\n  color: #6b7171 !important; //important ist OEV fix\n  text-decoration: none;\n  border-bottom: none;\n"], ["\n  line-height: 1.3;\n  margin: 0;\n  color: #6b7171 !important; //important ist OEV fix\n  text-decoration: none;\n  border-bottom: none;\n"])));
var Wrapper$1 = styled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  display: inline-block;\n  height: 25px;\n  width: 25px;\n  color: inherit;\n  @media (min-width: 768px) {\n    height: 35px;\n    width: 35px;\n  }\n"], ["\n  display: inline-block;\n  height: 25px;\n  width: 25px;\n  color: inherit;\n  @media (min-width: 768px) {\n    height: 35px;\n    width: 35px;\n  }\n"])));
var Link = styled.a(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  color: #6b7171 !important;\n  text-decoration: none;\n  line-height: 3em;\n  border-bottom: none !important;\n  margin-bottom: 0 !important;\n  &:hover{\n    div + div{\n      text-decoration: underline;\n    }\n  }\n"], ["\n  color: #6b7171 !important;\n  text-decoration: none;\n  line-height: 3em;\n  border-bottom: none !important;\n  margin-bottom: 0 !important;\n  &:hover{\n    div + div{\n      text-decoration: underline;\n    }\n  }\n"])));
var Label$1 = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  color: #6b7171;\n  display: inline-block;\n  &:before{\n    content: '';\n    width: 8px;\n    height: 8px;\n    display: inline-block;\n    border: solid currentColor;\n    border-width: 0 1px 1px 0;\n    transform: rotate(-45deg);\n    margin-right: 5px;\n    position: relative;\n    top: -2px;\n  }\n"], ["\n  color: #6b7171;\n  display: inline-block;\n  &:before{\n    content: '';\n    width: 8px;\n    height: 8px;\n    display: inline-block;\n    border: solid currentColor;\n    border-width: 0 1px 1px 0;\n    transform: rotate(-45deg);\n    margin-right: 5px;\n    position: relative;\n    top: -2px;\n  }\n"])));
var OEVFooter = function (_a) {
    var beraterHref = _a.beraterHref, _b = _a.hasBeraterModal, hasBeraterModal = _b === void 0 ? false : _b;
    var dispatch = useDispatch();
    var vtnr = useSelector(function (state) { return state.appDaten.vtnr; });
    if (trEnv$1.sparkasse) {
        return null;
    }
    var handleOpenModal = function (e) {
        if (vtnr && hasBeraterModal) {
            e.preventDefault();
            dispatch(updateByName('appDaten.showBeraterModal', true));
        }
    };
    return (jsxs(Ivvfooter, { className: "d-md-flex justify-content-between align-items-center", children: [jsx$1(Header, { className: "h5 mb-4", children: "Haben Sie noch Fragen?" }), jsxs("div", { className: "mb-3 mb-sm-0", children: [jsxs(Link, { href: i18next.t('footer.kontaktformular'), target: "_blank", title: "Kontakt", "data-tracking-name": "footer-link-kontakt", rel: "noopener noreferrer", className: "align-items-center d-none d-md-block", children: [jsx$1(Wrapper$1, { className: "d-md-block mx-md-auto", children: jsx$1(SvgTelefon, {}) }), jsx$1(Label$1, { children: "Kontakt" })] }), jsxs(Link, { href: "tel:".concat(i18next.t('footer.telefonnummer')), "data-tracking-name": "footer-link-anrufen", className: "align-items-center d-flex d-sm-block d-md-none", children: [jsx$1(Wrapper$1, { className: "d-md-block me-sm-2", children: jsx$1(SvgTelefon, {}) }), jsx$1(Label$1, { children: i18next.t('footer.anrufen') })] })] }), jsx$1("div", { className: "mb-3 mb-sm-0", children: jsxs(Link, { href: beraterHref || i18next.t('footer.beratersuche'), target: "_blank", title: "Berater finden", "data-tracking-name": "footer-link-beratersuche", rel: "noopener noreferrer", className: "d-flex d-md-block align-items-center", onClick: handleOpenModal, children: [jsx$1(Wrapper$1, { className: "d-md-block mx-md-auto me-sm-2", children: jsx$1(SvgBerater, {}) }), jsx$1(Label$1, { children: "Berater finden" })] }) }), jsx$1("div", { children: jsxs(Link, { href: i18next.t('footer.vertragspartner'), target: "_blank", title: "Vertragspartnerangaben", "data-tracking-name": "footer-link-vertragspartner", rel: "noopener noreferrer", className: "d-flex d-md-block align-items-center", children: [jsx$1(Wrapper$1, { className: "d-md-block mx-md-auto me-sm-2", children: jsx$1(SvgPartner, {}) }), jsx$1(Label$1, { children: "Vertragspartner" })] }) })] }));
};
var index$a = React__default.memo(OEVFooter);
var templateObject_1$t, templateObject_2$b, templateObject_3$6, templateObject_4$1, templateObject_5$1;

var TooltipButton = styled(Button$1)(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  &&& {\n      background-color: transparent;\n      border: none;\n      color: #6b7171;\n      margin-left: 5px;\n      padding: 0;\n      min-height: auto;\n      line-height: 1rem;\n      border-radius: 50%;\n      svg {\n          border: 1px solid currentColor;\n          border-radius: 50%;\n          width: 20px !important;\n          height: 20px !important;\n          transition: all 0.1s ease-in;\n      }\n      &:hover svg {\n          background: var(--primary);\n          fill: #fff;\n          border-color: var(--primary);\n          transform: scale(1.2);\n      }\n    &:focus svg {\n      border-color: var(--primary);\n      color: var(--primary);\n    }\n      .tooltip-hilfe {\n          --bs-tooltip-zindex: 2;\n      }\n  }\n"], ["\n  &&& {\n      background-color: transparent;\n      border: none;\n      color: #6b7171;\n      margin-left: 5px;\n      padding: 0;\n      min-height: auto;\n      line-height: 1rem;\n      border-radius: 50%;\n      svg {\n          border: 1px solid currentColor;\n          border-radius: 50%;\n          width: 20px !important;\n          height: 20px !important;\n          transition: all 0.1s ease-in;\n      }\n      &:hover svg {\n          background: var(--primary);\n          fill: #fff;\n          border-color: var(--primary);\n          transform: scale(1.2);\n      }\n    &:focus svg {\n      border-color: var(--primary);\n      color: var(--primary);\n    }\n      .tooltip-hilfe {\n          --bs-tooltip-zindex: 2;\n      }\n  }\n"])));
var BootstrapTooltip = styled(Tooltip$1)(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  min-width: 140px;\n"], ["\n  min-width: 140px;\n"])));
var Tooltip = function (_a) {
    var _b = _a.handleTooltip, handleTooltip = _b === void 0 ? function () { } : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, _e = _a.id, id = _e === void 0 ? '' : _e, overlay = _a.overlay, rest = __rest$1(_a, ["handleTooltip", "className", "tabIndex", "id", "overlay"]);
    var dispatch = useDispatch();
    var target = useRef(null);
    var timeout = 0;
    var _f = useState(false), overlayshow = _f[0], setOverlayshow = _f[1];
    var handleOnClick = function () {
        var _a;
        if (trEnv$1.sparkasse) {
            dispatch(updateByName('appDaten.tooltip_offset', (_a = target === null || target === void 0 ? void 0 : target.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().y));
        }
        handleTooltip();
    };
    useEffect(function () { return function () {
        window.clearTimeout(timeout);
    }; }, []);
    if (overlay) {
        timeout = window.setTimeout(function () { return setOverlayshow(true); }, 100);
    }
    return (jsxs(Fragment, { children: [jsx$1(TooltipButton, __assign$1({ className: "btn-tooltip ".concat(className), tabIndex: tabIndex, id: id, onClick: handleOnClick, "data-tracking-name": id, ref: target, "aria-label": "Hilfe zum Feld", title: "Hilfe zum Feld" }, rest, { children: jsx$1(SvgInfoIconI, {}) })), overlay && (jsx$1(Overlay$1, { container: target, target: target.current, show: overlayshow, placement: "right", popperConfig: {
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: ['top', 'top-start'],
                            },
                        },
                    ],
                }, children: function (props) { return (jsx$1(BootstrapTooltip, __assign$1({ className: "tooltip-hilfe" }, props, { children: overlay }))); } }))] }));
};
var templateObject_1$s, templateObject_2$a;

var Message = function (_a) {
    var _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.show, show = _c === void 0 ? false : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.variant, variant = _e === void 0 ? 'gray' : _e, _f = _a.dismissible, dismissible = _f === void 0 ? true : _f, _g = _a.onAfterClose, onAfterClose = _g === void 0 ? function () { } : _g, _h = _a.arrow, arrow = _h === void 0 ? 'top' : _h, _j = _a.dangerouslySetHTML, dangerouslySetHTML = _j === void 0 ? true : _j, _k = _a.id, id = _k === void 0 ? '' : _k;
    var _l = useState(show), visible = _l[0], setVisible = _l[1];
    var handleDismiss = function () {
        setVisible(false);
        onAfterClose();
    };
    return (visible && (jsx$1(Alert, { variant: variant, className: "alert--message border arrow-alert arrow-alert-".concat(arrow, "-left ").concat(className), onClose: handleDismiss, dismissible: dismissible, children: jsx$1("div", { className: "alert__body", children: dangerouslySetHTML
                ? (jsx$1("div", { className: "alert__text", id: id, dangerouslySetInnerHTML: { __html: text } }))
                : (jsx$1("div", { className: "alert__text", id: id, children: text })) }) })));
};
var Message$1 = React__default.memo(Message);

/**
 * Zeigt den Namen der Anwendung und die Versionsnummer an.
 * Die Environment Variablen 'process.env.REACT_APP_NAME' und 'process.env.REACT_APP_VERSION'
 * werden in der .env Datei im hauptprojekt gesetzt.
 */
var Version = styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  color: transparent;\n  margin-top: 5px;\n  font-size: 14px;\n"], ["\n  color: transparent;\n  margin-top: 5px;\n  font-size: 14px;\n"])));
var VersionInfo = function (_a) {
    var _b = _a.date, date = _b === void 0 ? new Date().toLocaleString() : _b;
    var dispatch = useDispatch();
    var dev = useSelector(function (state) { return state.appDaten.dev; });
    var devClick = function () {
        dispatch(updateByName('appDaten.dev', dev + 1));
    };
    var handleChange = function (inputEvent) {
        if (!inputEvent.target.files) {
            return;
        }
        var fileReader = new FileReader();
        fileReader.readAsText(inputEvent.target.files[0], 'UTF-8');
        fileReader.onload = function (progEvent) {
            var _a;
            if (!((_a = progEvent.target) === null || _a === void 0 ? void 0 : _a.result)) {
                return;
            }
            dispatch(updateByName('daten', JSON.parse(decrypt(progEvent.target.result.toString()) || '{}')));
        };
    };
    return (jsxs(Fragment, { children: [jsx$1(Version, { onClick: devClick, children: "Name: ".concat(process.env.REACT_APP_NAME, " / Version: ").concat(process.env.REACT_APP_VERSION, " / ivvVersion: ").concat(process.env.REACT_APP_IVVVERSION, " / Date: ").concat(date) }), dev >= 10 && (jsx$1("input", { type: "file", onChange: handleChange }))] }));
};
var index$9 = React__default.memo(VersionInfo);
var templateObject_1$r;

var ModalWrapper$1 = styled(Modal$1)(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  z-index: 2090 !important;\n  overflow: hidden;\n  .modal-content {\n    background-color: transparent !important;\n    outline: 0 !important;\n  }\n"], ["\n  z-index: 2090 !important;\n  overflow: hidden;\n  .modal-content {\n    background-color: transparent !important;\n    outline: 0 !important;\n  }\n"])));
var ModalSpinner = styled(Spinner)(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  color: #fff !important;\n  border-width: 0.35em !important;\n  height: 4rem !important;\n  width: 4rem !important;\n  margin: 0 auto;\n"], ["\n  color: #fff !important;\n  border-width: 0.35em !important;\n  height: 4rem !important;\n  width: 4rem !important;\n  margin: 0 auto;\n"])));
var LoadingIndicator$1 = function (_a) {
    var _b = _a.show, show = _b === void 0 ? false : _b;
    useEffect(function () {
        var _a, _b;
        var body = document.querySelector('body');
        if (show) {
            (_a = body.classList) === null || _a === void 0 ? void 0 : _a.add('modal-open');
        }
        else {
            (_b = body.classList) === null || _b === void 0 ? void 0 : _b.remove('modal-open');
        }
    }, [show]);
    return (jsx$1(ModalWrapper$1, { dialogClassName: "loadingmodal", show: show, centered: true, backdrop: "static", backdropClassName: "loadingspinner", size: "sm", container: function () { return document.querySelector('.bs-iso'); }, children: jsx$1(ModalSpinner, { animation: "border", role: "status", children: jsx$1("span", { className: "visually-hidden", children: "Loading..." }) }) }));
};
var index$8 = React__default.memo(LoadingIndicator$1);
var templateObject_1$q, templateObject_2$9;

var VVGModal = function (_a) {
    var container = _a.container, _b = _a.text, text = _b === void 0 ? 'Bitte beantworten Sie unsere Fragen wahrheitsgemäß und vollständig, da Sie sonst Ihren Versicherungsschutz gefährden.' : _b, _c = _a.linkText, linkText = _c === void 0 ? "Detaillierte Informationen zu Ihrer &quot;Anzeigepflicht nach \u00A7 19\n            Versicherungs&shy;vertragsgesetz&quot; finden Sie hier." : _c, _d = _a.textClassName, textClassName = _d === void 0 ? 'mt-5' : _d, _e = _a.buttonClassName, buttonClassName = _e === void 0 ? 'mt-2' : _e;
    var _f = useState(false), show = _f[0], setShow = _f[1];
    var body = document.querySelector('body');
    var handleClose = function () {
        if (!container) {
            body.classList.remove('modal-open');
        }
        setShow(false);
        updateWindowHeightForIF();
    };
    var handleShow = function () {
        if (!container) {
            body.classList.add('modal-open');
        }
        setShow(true);
        updateWindowHeightForIF('.modal.show');
    };
    return (!trEnv$1.stationaer && (jsxs(Fragment, { children: [jsxs("p", { className: textClassName, children: [jsx$1("span", { className: "span-fix", dangerouslySetInnerHTML: { __html: text } }), jsx$1(Button$1, { variant: "link", className: buttonClassName, onClick: handleShow, "data-tracking-name": "vvg-modal-opener", dangerouslySetInnerHTML: { __html: linkText } })] }), jsxs(Modal$1, { show: show, container: container ? container.current : function () { return document.querySelector('.bs-iso'); }, size: "lg", onHide: handleClose, children: [jsx$1(Modal$1.Header, { closeButton: true, className: "p-0" }), jsxs(Modal$1.Body, { as: "article", children: [jsx$1(Card, { className: "legaltext mb-4", children: jsxs(Card.Body, { children: [jsx$1("h2", { className: "h5", children: "Mitteilung nach \u00A7 19 Abs. 5 Versicherungsvertragsgesetz (VVG) \u00FCber die Folgen einer Verletzung der gesetzlichen Anzeigepflicht" }), jsxs("p", { children: ["Sehr geehrte Interessenten,", jsx$1("br", {}), "der folgende Text informiert Sie \u00FCber:"] }), jsxs("ul", { className: "list-icn-bar", children: [jsx$1("li", { children: "Ihre Pflichten: Sie m\u00FCssen unsere Fragen wahrheitsgem\u00E4\u00DF und vollst\u00E4ndig beantworten." }), jsx$1("li", { children: "die Folgen einer Verletzung dieser sogenannten Anzeigepflicht: Diese kann zum Verlust des Versicherungsschutzes f\u00FChren." })] })] }) }), jsx$1("section", { children: jsx$1("p", { children: "Damit wir Ihren Versicherungsantrag ordnungsgem\u00E4\u00DF pr\u00FCfen k\u00F6nnen, ist es notwendig, dass Sie die beiliegenden Fragen im Antrag wahrheitsgem\u00E4\u00DF und vollst\u00E4ndig beantworten. Es sind auch solche Umst\u00E4nde anzugeben, denen Sie nur geringe Bedeutung beimessen. Bitte beachten Sie, dass Sie Ihren Versicherungsschutz gef\u00E4hrden, wenn Sie unrichtige oder unvollst\u00E4ndige Angaben machen. N\u00E4here Einzelheiten zu den Folgen einer Verletzung der Anzeigepflicht k\u00F6nnen Sie der nachstehenden Information entnehmen." }) }), jsxs("section", { className: "mt-4", children: [jsx$1("h3", { className: "h5 mb-2", children: "Welche vorvertraglichen Anzeigepflichten bestehen?" }), jsx$1("p", { children: "Sie sind bis zur Abgabe Ihrer Vertragserkl\u00E4rung verpflichtet, alle Ihnen bekannten gefahrerheblichen Umst\u00E4nde, nach denen wir in Textform (z. B. E-Mail, Telefax oder Brief) gefragt haben, wahrheitsgem\u00E4\u00DF und vollst\u00E4ndig anzuzeigen. Wenn wir nach Ihrer Vertragserkl\u00E4rung, aber vor Vertragsannahme in Textform nach gefahrerheblichen Umst\u00E4nden fragen, sind Sie auch insoweit zur Anzeige verpflichtet." })] }), jsxs("section", { className: "mt-4", children: [jsx$1("h3", { className: "h5 mb-2", children: "Welche Folgen k\u00F6nnen eintreten, wenn eine vorvertragliche Anzeigepflicht verletzt wird?" }), jsxs("div", { className: "mt-3", children: [jsx$1("h4", { className: "h5 mb-2", children: "1. R\u00FCcktritt und Wegfall des Versicherungsschutzes" }), jsx$1("p", { children: "Verletzen Sie die vorvertragliche Anzeigepflicht, k\u00F6nnen wir vom Vertrag zur\u00FCcktreten. Dies gilt nicht, wenn Sie nachweisen, dass weder Vorsatz noch grobe Fahrl\u00E4ssigkeit vorliegt." }), jsx$1("p", { children: "Bei grob fahrl\u00E4ssiger Verletzung der Anzeigepflicht haben wir kein R\u00FCcktrittsrecht, wenn Sie nachweisen, dass wir den Vertrag auch bei Kenntnis der nicht angezeigten Umst\u00E4nde, wenn auch zu anderen Bedingungen, geschlossen h\u00E4tten." }), jsx$1("p", { children: "Im Fall des R\u00FCcktritts besteht auch f\u00FCr die Vergangenheit kein Versicherungsschutz. Erkl\u00E4ren wir den R\u00FCcktritt nach Eintritt des Versicherungsfalles, bleiben wir dennoch zur Leistung verpflichtet, wenn Sie nachweisen, dass der nicht oder nicht richtig angegebene Umstand" }), jsxs("ul", { className: "list-icn-bar", children: [jsx$1("li", { children: "weder f\u00FCr den Eintritt oder die Feststellung des Versicherungsfalles," }), jsx$1("li", { children: "noch f\u00FCr die Feststellung oder den Umfang unserer Leistungspflicht" })] }), jsx$1("p", { children: "urs\u00E4chlich war. Unsere Leistungspflicht entf\u00E4llt jedoch, wenn Sie die Anzeigepflicht arglistig verletzt haben." }), jsx$1("p", { children: "Bei einem R\u00FCcktritt steht uns der Teil des Beitrages zu, welcher der bis zum Wirksamwerden der R\u00FCcktrittserkl\u00E4rung abgelaufenen Vertragszeit entspricht." })] }), jsxs("div", { children: [jsx$1("h4", { className: "h5 mb-2", children: "2. K\u00FCndigung" }), jsx$1("p", { children: "K\u00F6nnen wir nicht vom Vertrag zur\u00FCcktreten, weil Sie die vorvertragliche Anzeigepflicht lediglich einfach fahrl\u00E4ssig oder schuldlos verletzt haben, k\u00F6nnen wir den Vertrag unter Einhaltung einer Frist von einem Monat k\u00FCndigen. Unser K\u00FCndigungsrecht ist ausgeschlossen, wenn Sie nachweisen, dass wir den Vertrag auch bei Kenntnis der nicht angezeigten Umst\u00E4nde, wenn auch zu anderen Bedingungen, geschlossen h\u00E4tten." })] }), jsxs("div", { children: [jsx$1("h4", { className: "h5 mb-2", children: "3. Vertrags\u00E4nderung" }), jsx$1("p", { children: "K\u00F6nnen wir nicht zur\u00FCcktreten oder k\u00FCndigen, weil wir den Vertrag auch bei Kenntnis der nicht angezeigten Gefahrumst\u00E4nde, wenn auch zu anderen Bedingungen, geschlossen h\u00E4tten, werden die anderen Bedingungen auf unser Verlangen Vertragsbestandteil. Haben Sie die Anzeigepflicht fahrl\u00E4ssig verletzt, werden die anderen Bedingungen r\u00FCckwirkend Vertragsbestandteil. Haben Sie die Anzeigepflicht schuldlos verletzt, werden die anderen Bedingungen erst ab der laufenden Versicherungsperiode Vertragsbestandteil." }), jsx$1("p", { children: "Erh\u00F6ht sich durch die Vertrags\u00E4nderung der Beitrag um mehr als 10 % oder schlie\u00DFen wir die Gefahrabsicherung f\u00FCr den nicht angezeigten Umstand aus, k\u00F6nnen Sie den Vertrag innerhalb eines Monats nach Zugang unserer Mitteilung \u00FCber die Vertrags\u00E4nderung fristlos k\u00FCndigen. Auf dieses Recht werden wir Sie in unserer Mitteilung hinweisen." })] }), jsxs("div", { children: [jsx$1("h4", { className: "h5 mb-2", children: "4. Aus\u00FCbung unserer Rechte" }), jsx$1("p", { children: "Wir k\u00F6nnen unsere Rechte zum R\u00FCcktritt, zur K\u00FCndigung oder zur Vertrags\u00E4nderung nur innerhalb eines Monats schriftlich geltend machen. Die Frist beginnt mit dem Zeitpunkt, zu dem wir von der Verletzung der Anzeigepflicht, die das von uns geltend gemachte Recht begr\u00FCndet, Kenntnis erlangen. Bei der Aus\u00FCbung unserer Rechte haben wir die Umst\u00E4nde anzugeben, auf die wir unsere Erkl\u00E4rung st\u00FCtzen. Zur Begr\u00FCndung k\u00F6nnen wir nachtr\u00E4glich weitere Umst\u00E4nde angeben, wenn f\u00FCr diese die Frist nach Satz 1 nicht verstrichen ist." }), jsx$1("p", { children: "Wir k\u00F6nnen uns auf die Rechte zum R\u00FCcktritt, zur K\u00FCndigung oder zur Vertrags\u00E4nderung nicht berufen, wenn wir den nicht angezeigten Gefahrumstand oder die Unrichtigkeit der Anzeige kannten." }), jsx$1("p", { children: "Unsere Rechte zum R\u00FCcktritt, zur K\u00FCndigung und zur Vertrags\u00E4nderung erl\u00F6schen mit Ablauf von f\u00FCnf Jahren nach Vertragsschluss. Dies gilt nicht f\u00FCr Versicherungsf\u00E4lle, die vor Ablauf dieser Frist eingetreten sind. Die Frist betr\u00E4gt zehn Jahre, wenn Sie die Anzeigepflicht vors\u00E4tzlich oder arglistig verletzt haben." })] }), jsxs("div", { children: [jsx$1("h4", { className: "h5 mb-2", children: "5. Stellvertretung durch eine andere Person" }), jsx$1("p", { children: "Lassen Sie sich bei Abschluss des Vertrages durch eine andere Person vertreten, so sind bez\u00FCglich der Anzeigepflicht, des R\u00FCcktritts, der K\u00FCndigung, der Vertrags\u00E4nderung und der Ausschlussfrist f\u00FCr die Aus\u00FCbung unserer Rechte die Kenntnis und Arglist Ihres Stellvertreters als auch Ihre eigene Kenntnis und Arglist zu ber\u00FCcksichtigen. Sie k\u00F6nnen sich darauf, dass die Anzeigepflicht nicht vors\u00E4tzlich oder grob fahrl\u00E4ssig verletzt worden ist, nur berufen, wenn weder Ihrem Stellvertreter noch Ihnen Vorsatz oder grobe Fahrl\u00E4ssigkeit zur Last f\u00E4llt." })] })] })] }), jsx$1(Modal$1.Footer, { children: jsx$1(Button$1, { variant: "primary", onClick: handleClose, children: "OK" }) })] })] })));
};
var index$7 = React__default.memo(VVGModal);

var Routing = function (_a) {
    var container = _a.container, pages = _a.pages, components = _a.components, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b;
    var location = useLocation();
    var pathname = location.pathname;
    useEffect(function () {
        window.scrollTo(0, 0);
        spkScrollTo();
        updateWindowHeightForIF();
        onChange(location);
    }, [pathname]);
    var activePages = pages.filter(function (elem) { return elem.active; });
    return (jsx$1(Routes, { children: activePages.map(function (page) { return (jsx$1(Route, { path: page.path, element: React__default.createElement(components[page.name], { container: container }) }, page.name)); }) }));
};

var RibbonWrapper = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  position: absolute;\n  overflow: hidden;\n  width: 110px;\n  height: 110px;\n  right: -5px;\n  top: -5px;\n  z-index: 1;\n  .ribbon__icon {\n    border: 1px solid #fff;\n    border-radius: 10px;\n    margin-left: 2px;\n    margin-top: -2px;\n  }\n  .ribbon__content {\n    font-size: 11px;\n    font-weight: bold;\n    color: #fff;\n    text-transform: uppercase;\n    text-align: center;\n    line-height: 24px;\n    transform: rotate(45deg);\n    width: 140px;\n    display: block;\n    background: var(--primary);\n    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.5);\n    position: absolute;\n    top: 30px;\n    right: -28px;\n    &:before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 100%;\n      z-index: -1;\n      border-left: 3px solid var(--primary);\n      border-right: 3px solid transparent;\n      border-bottom: 3px solid transparent;\n      border-top: 3px solid var(--primary);\n      filter: brightness(0.7);\n    }\n    &:after {\n      content: \"\";\n      position: absolute;\n      right: 0;\n      top: 100%;\n      z-index: -1;\n      border-left: 3px solid transparent;\n      border-right: 3px solid var(--primary);\n      border-bottom: 3px solid transparent;\n      border-top: 3px solid var(--primary);\n      filter: brightness(0.7);\n    }\n  }\n"], ["\n  position: absolute;\n  overflow: hidden;\n  width: 110px;\n  height: 110px;\n  right: -5px;\n  top: -5px;\n  z-index: 1;\n  .ribbon__icon {\n    border: 1px solid #fff;\n    border-radius: 10px;\n    margin-left: 2px;\n    margin-top: -2px;\n  }\n  .ribbon__content {\n    font-size: 11px;\n    font-weight: bold;\n    color: #fff;\n    text-transform: uppercase;\n    text-align: center;\n    line-height: 24px;\n    transform: rotate(45deg);\n    width: 140px;\n    display: block;\n    background: var(--primary);\n    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.5);\n    position: absolute;\n    top: 30px;\n    right: -28px;\n    &:before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 100%;\n      z-index: -1;\n      border-left: 3px solid var(--primary);\n      border-right: 3px solid transparent;\n      border-bottom: 3px solid transparent;\n      border-top: 3px solid var(--primary);\n      filter: brightness(0.7);\n    }\n    &:after {\n      content: \"\";\n      position: absolute;\n      right: 0;\n      top: 100%;\n      z-index: -1;\n      border-left: 3px solid transparent;\n      border-right: 3px solid var(--primary);\n      border-bottom: 3px solid transparent;\n      border-top: 3px solid var(--primary);\n      filter: brightness(0.7);\n    }\n  }\n"])));
var Ribbon = function (_a) {
    var children = _a.children, _b = _a.titleText, titleText = _b === void 0 ? '' : _b, onClick = _a.onClick;
    return (jsx$1(RibbonWrapper, { className: "ribbon", children: jsxs("span", { className: "ribbon__content", title: onClick ? titleText : '', onClick: onClick, onKeyDown: function () { return null; }, style: { cursor: onClick ? 'pointer' : '' }, role: "button", tabIndex: 0, children: [children, ' ', onClick && jsx$1(SvgInfoIconI, { className: "ribbon__icon" })] }) }));
};
var Ribbon$1 = React__default.memo(Ribbon);
var templateObject_1$p;

var TabNavigation = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  position: relative;\n  margin-left: 2px;\n  margin-right: 7px;\n  display: flex;\n  height: 75px;\n  z-index: 1;\n  @media (min-width: 952px) {\n    ", "\n  }\n"], ["\n  position: relative;\n  margin-left: 2px;\n  margin-right: 7px;\n  display: flex;\n  height: 75px;\n  z-index: 1;\n  @media (min-width: 952px) {\n    ", "\n  }\n"])), function (_a) {
    var $mobileView = _a.$mobileView;
    return (!$mobileView ? css$3(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n      display: none !important;\n    "], ["\n      display: none !important;\n    "]))) : '');
});
var TabWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: 1;\n  ", "\n  &.active {\n    height: inherit;\n  }\n  &:hover {\n    height: inherit;\n  }\n"], ["\n  flex: 1;\n  ", "\n  &.active {\n    height: inherit;\n  }\n  &:hover {\n    height: inherit;\n  }\n"])), function (_a) {
    var $showRibbon = _a.$showRibbon;
    return (!$showRibbon ? css$3(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n    height: 60px;\n    margin-top: auto;\n    transition: height 0.3s ease-out;\n  "], ["\n    height: 60px;\n    margin-top: auto;\n    transition: height 0.3s ease-out;\n  "]))) : '');
});
var TabButton = styled(function (props) { return jsx$1(Button$1, __assign$1({}, props)); })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border-radius: .25rem .25rem 0 0 !important;\n  ", "\n  background-color: transparent !important;\n  border-color: #ccc !important;\n  padding: .5rem !important;\n  color: #000 !important;\n  line-height: 1rem !important;\n  height: 100%;\n  text-align: left !important;\n  ", "\n  width: 100%;\n  &.active{\n    background-color: #edf0f4 !important;\n    border-color: rgba(0, 0, 0, 0.125) !important;\n    box-shadow: none;\n    height: inherit;\n  }\n  &:hover {\n    height: inherit;\n  }\n  &:focus {\n    box-shadow: none !important;\n  }\n  &:focus {\n    box-shadow: none !important;\n  }\n  @media (max-width: 360px) {\n    padding-left: .3rem !important;\n    padding-right: .3rem !important;\n  }\n  @media (max-width: 640px) {\n    font-weight: 100 !important;\n  }\n  svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .ribbon {\n    width: 80px;\n    height: 80px;\n    &__content {\n      text-transform: unset !important;\n      top: 17px !important;\n      right: -24px !important;\n      width: 106px !important;\n    }\n  }\n"], ["\n  border-radius: .25rem .25rem 0 0 !important;\n  ", "\n  background-color: transparent !important;\n  border-color: #ccc !important;\n  padding: .5rem !important;\n  color: #000 !important;\n  line-height: 1rem !important;\n  height: 100%;\n  text-align: left !important;\n  ", "\n  width: 100%;\n  &.active{\n    background-color: #edf0f4 !important;\n    border-color: rgba(0, 0, 0, 0.125) !important;\n    box-shadow: none;\n    height: inherit;\n  }\n  &:hover {\n    height: inherit;\n  }\n  &:focus {\n    box-shadow: none !important;\n  }\n  &:focus {\n    box-shadow: none !important;\n  }\n  @media (max-width: 360px) {\n    padding-left: .3rem !important;\n    padding-right: .3rem !important;\n  }\n  @media (max-width: 640px) {\n    font-weight: 100 !important;\n  }\n  svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .ribbon {\n    width: 80px;\n    height: 80px;\n    &__content {\n      text-transform: unset !important;\n      top: 17px !important;\n      right: -24px !important;\n      width: 106px !important;\n    }\n  }\n"])), function (props) { return !props.$border && css$3(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border-bottom: none !important;\n  "], ["\n    border-bottom: none !important;\n  "]))); }, function (_a) {
    var $showRibbon = _a.$showRibbon;
    return ($showRibbon ? 'overflow: visible;' : 'overflow: hidden;');
});
var Empfehlung = styled.p(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  text-align: center;\n  font-size: 0.85rem;\n  color: white;\n"], ["\n  text-align: center;\n  font-size: 0.85rem;\n  color: white;\n"])));
var Tab = function (_a) {
    var _b = _a.tarife, tarife = _b === void 0 ? [{
            id: {
                value: '',
            },
            bezeichnung: {
                value: '',
            },
            label: {
                value: '',
            },
        }] : _b, _c = _a.label, label = _c === void 0 ? [] : _c, _d = _a.currentSlide, currentSlide = _d === void 0 ? 0 : _d, _e = _a.onClick, onClick = _e === void 0 ? function (arg) { } : _e, _f = _a.sterne, sterne = _f === void 0 ? function (arg) { return null; } : _f, _g = _a.empfehlung, empfehlung = _g === void 0 ? -1 : _g, _h = _a.border, border = _h === void 0 ? false : _h, _j = _a.className, className = _j === void 0 ? '' : _j, _k = _a.nurSterne, nurSterne = _k === void 0 ? false : _k, _l = _a.mobileView, mobileView = _l === void 0 ? false : _l, _m = _a.showRibbon, showRibbon = _m === void 0 ? false : _m, _o = _a.showEmpfehlung, showEmpfehlung = _o === void 0 ? true : _o, _p = _a.selectedSlide, selectedSlide = _p === void 0 ? -1 : _p;
    return (jsx$1(TabNavigation, { className: "produktvergleich__navigation ".concat(className), "$mobileView": mobileView, children: tarife.map(function (element, index) { return (jsxs(TabWrapper, { className: "".concat(currentSlide == index ? 'active' : ''), "$showRibbon": showRibbon, children: [jsxs(TabButton, { variant: "light", "$border": border, className: "sp-font-normal produktvergleich__button ".concat(currentSlide == index ? 'active' : '', " ").concat(selectedSlide == index ? 'selected' : ''), onClick: function () { return onClick(index); }, "data-tracking-name": i18next.t("produktvergleich.".concat(element.bezeichnung.value, ".tab")), "$showRibbon": showRibbon, children: [sterne && sterne(Number.isNaN(+(element.id.value))
                            ? element.id.value : parseInt(element.id.value, 10)), !nurSterne && ((label === null || label === void 0 ? void 0 : label[index]) || element.label.value), (showRibbon && empfehlung == element.id.value) && (jsx$1(Ribbon$1, { children: "Empfehlung" }))] }), (showEmpfehlung && empfehlung == element.id.value) && (jsx$1(Empfehlung, { className: "produtkvergleich__empfehlung", children: "Empfehlung" }))] }, "tab-".concat(element.bezeichnung.value))); }) }));
};
var Tab$1 = React__default.memo(Tab);
var templateObject_1$o, templateObject_2$8, templateObject_3$5, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

var BootstrapCarousel = styled(Carousel$1)(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  margin-top: -6px;\n  .sticky {\n    background: #edf0f4;\n    z-index: 1;\n    &::after {\n      content: '';\n      display: block;\n      height: 5px;\n      margin-top: -6px;\n      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.5);\n    }\n  }\n  .carousel-inner {\n    padding-bottom: 5px;\n    overflow: visible;\n    ", "\n    .carousel-item > .card {\n      border-width: 2px;\n      margin-right: 5px;\n      &.selected {\n        box-shadow: 0 0 5px 0 rgba(0,0,0,0.75);\n        border-color: var(--primary);\n      }\n    }\n    @media (max-width: 952px) {\n      .carousel-item .card {\n        border-top-left-radius: 0 !important;\n        border-top-right-radius: 0 !important\n      }\n    }\n    @media (min-width: 952px) {\n      ", "\n    }\n  }\n    \n  ", "; \n  \n  .tooltip--right {\n    margin-top: 2px;\n  }\n"], ["\n  margin-top: -6px;\n  .sticky {\n    background: #edf0f4;\n    z-index: 1;\n    &::after {\n      content: '';\n      display: block;\n      height: 5px;\n      margin-top: -6px;\n      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.5);\n    }\n  }\n  .carousel-inner {\n    padding-bottom: 5px;\n    overflow: visible;\n    ", "\n    .carousel-item > .card {\n      border-width: 2px;\n      margin-right: 5px;\n      &.selected {\n        box-shadow: 0 0 5px 0 rgba(0,0,0,0.75);\n        border-color: var(--primary);\n      }\n    }\n    @media (max-width: 952px) {\n      .carousel-item .card {\n        border-top-left-radius: 0 !important;\n        border-top-right-radius: 0 !important\n      }\n    }\n    @media (min-width: 952px) {\n      ", "\n    }\n  }\n    \n  ", "; \n  \n  .tooltip--right {\n    margin-top: 2px;\n  }\n"])), function (_a) {
    var $mobileView = _a.$mobileView;
    return ($mobileView ? 'margin-top: -3px;' : 'margin-top: -1px;');
}, function (_a) {
    var $mobileView = _a.$mobileView;
    return (!$mobileView ? css$3(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n        display: flex;\n        .carousel-item {\n          display: block;\n          flex-grow: ", ";\n          flex-basis: ", ";\n          margin-right: 0;\n          margin-left: 1px;\n          + .carousel-item{\n            margin-left: 10px;\n          }\n        }\n      "], ["\n        display: flex;\n        .carousel-item {\n          display: block;\n          flex-grow: ", ";\n          flex-basis: ", ";\n          margin-right: 0;\n          margin-left: 1px;\n          + .carousel-item{\n            margin-left: 10px;\n          }\n        }\n      "])), function (_a) {
        var $singleSlide = _a.$singleSlide, $singleSlideFullWidth = _a.$singleSlideFullWidth;
        return ($singleSlide && !$singleSlideFullWidth ? '0' : '1');
    }, function (_a) {
        var $singleSlide = _a.$singleSlide;
        return ($singleSlide ? '50%' : '0');
    }) : '');
}, function (_a) {
    var $singleSlide = _a.$singleSlide;
    return (!$singleSlide && css$3(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n    .carousel-indicators {\n      margin: 0;\n      @media (min-width: 952px) {\n        display: none !important;\n      }\n      button[data-bs-target] {\n        border: 1px solid #6a7071;\n        width: 15px;\n        height: 15px;\n        border-radius: 50%;\n        box-shadow: none;\n        &.active {\n          background-color: var(--primary);\n          border-color:var(--primary);\n        }\n      }\n    }\n  "], ["\n    .carousel-indicators {\n      margin: 0;\n      @media (min-width: 952px) {\n        display: none !important;\n      }\n      button[data-bs-target] {\n        border: 1px solid #6a7071;\n        width: 15px;\n        height: 15px;\n        border-radius: 50%;\n        box-shadow: none;\n        &.active {\n          background-color: var(--primary);\n          border-color:var(--primary);\n        }\n      }\n    }\n  "]))));
});
var ProductCarousel = function (_a) {
    var label = _a.label, children = _a.children, _b = _a.tarife, tarife = _b === void 0 ? [] : _b, _c = _a.singleSlide, singleSlide = _c === void 0 ? false : _c, _d = _a.singleSlideFullWidth, singleSlideFullWidth = _d === void 0 ? false : _d, _e = _a.mobileView, mobileView = _e === void 0 ? false : _e, _f = _a.touch, touch = _f === void 0 ? false : _f, _g = _a.activeSlide, activeSlide = _g === void 0 ? 0 : _g, sterne = _a.sterne, tabclick = _a.tabclick, nurSterne = _a.nurSterne, _h = _a.className, className = _h === void 0 ? '' : _h, _j = _a.slide, slide = _j === void 0 ? true : _j, empfehlung = _a.empfehlung, _k = _a.showRibbon, showRibbon = _k === void 0 ? false : _k, _l = _a.showEmpfehlung, showEmpfehlung = _l === void 0 ? true : _l, selectedSlide = _a.selectedSlide, _m = _a.hideIndicators, hideIndicators = _m === void 0 ? false : _m;
    var _o = useState(activeSlide < 0 ? 1 : activeSlide), currentSlide = _o[0], setCurrentSlide = _o[1];
    var _p = useState(false), isSliding = _p[0], setIsSliding = _p[1];
    var handleTabClick = function (index, cb) {
        if (cb === void 0) { cb = function (param) {
            // This is intentional
        }; }
        if (!isSliding && index !== currentSlide) {
            setIsSliding(true);
            setCurrentSlide(index);
            cb(index);
        }
    };
    useEffect(function () {
        if (tarife.length < (currentSlide + 1)) {
            setCurrentSlide(currentSlide - 1);
        }
    }, [tarife.length]);
    return (jsxs("section", { className: "produktvergleich sp-mb-0 ".concat(className), children: [!singleSlide && (jsx$1(Tab$1, { tarife: tarife, label: label, currentSlide: currentSlide, selectedSlide: selectedSlide, onClick: function (index) { return handleTabClick(index, tabclick); }, sterne: sterne, nurSterne: nurSterne, mobileView: mobileView, empfehlung: empfehlung, showRibbon: showRibbon, showEmpfehlung: showEmpfehlung })), children && (jsx$1(BootstrapCarousel, { interval: null, wrap: false, activeIndex: currentSlide, onSelect: setCurrentSlide, onSlid: function () { return setIsSliding(false); }, className: "produktvergleich__carousel pb-4", controls: false, indicators: !hideIndicators && (!singleSlide && React__default.Children.count(children) > 1), touch: touch, slide: slide, "$mobileView": mobileView, "$singleSlide": singleSlide, "$singleSlideFullWidth": singleSlideFullWidth, children: children }))] }));
};
var index$6 = React__default.memo(ProductCarousel);
var templateObject_1$n, templateObject_2$7, templateObject_3$4;

var reactSwitch = {exports: {}};

var index_prod = {};

var hasRequiredIndex_prod;

function requireIndex_prod () {
	if (hasRequiredIndex_prod) return index_prod;
	hasRequiredIndex_prod = 1;
	Object.defineProperty(index_prod,"__esModule",{value:!0});var t=React__default;function i(){return i=Object.assign?Object.assign.bind():function(t){for(var i=1;i<arguments.length;i++){var s=arguments[i];for(var n in s)Object.prototype.hasOwnProperty.call(s,n)&&(t[n]=s[n]);}return t},i.apply(this,arguments)}var s=t.createElement("svg",{viewBox:"-2 -5 14 20",height:"100%",width:"100%",style:{position:"absolute",top:0}},t.createElement("path",{d:"M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",fill:"#fff",fillRule:"evenodd"})),n=t.createElement("svg",{height:"100%",width:"100%",viewBox:"-2 -5 17 21",style:{position:"absolute",top:0}},t.createElement("path",{d:"M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",fill:"#fff",fillRule:"evenodd"}));function o(t){if(7===t.length)return t;for(var i="#",s=1;s<4;s+=1)i+=t[s]+t[s];return i}function h(t,i,s,n,h){return function(t,i,s,n,o){var h=(t-s)/(i-s);if(0===h)return n;if(1===h)return o;for(var e="#",a=1;a<6;a+=2){var r=parseInt(n.substr(a,2),16),l=parseInt(o.substr(a,2),16),u=Math.round((1-h)*r+h*l).toString(16);1===u.length&&(u="0"+u),e+=u;}return e}(t,i,s,o(n),o(h))}var e=function(s){function n(t){s.call(this,t);var i=t.height,n=t.width,o=t.checked;this.t=t.handleDiameter||i-2,this.i=Math.max(n-i,n-(i+this.t)/2),this.o=Math.max(0,(i-this.t)/2),this.state={h:o?this.i:this.o},this.l=0,this.u=0,this.p=this.p.bind(this),this.v=this.v.bind(this),this.g=this.g.bind(this),this.k=this.k.bind(this),this.M=this.M.bind(this),this.m=this.m.bind(this),this.T=this.T.bind(this),this.$=this.$.bind(this),this.C=this.C.bind(this),this.O=this.O.bind(this),this.D=this.D.bind(this),this.S=this.S.bind(this);}return s&&(n.__proto__=s),(n.prototype=Object.create(s&&s.prototype)).constructor=n,n.prototype.componentDidMount=function(){this.W=!0;},n.prototype.componentDidUpdate=function(t){t.checked!==this.props.checked&&this.setState({h:this.props.checked?this.i:this.o});},n.prototype.componentWillUnmount=function(){this.W=!1;},n.prototype.I=function(t){this.H.focus(),this.setState({j:t,R:!0,B:Date.now()});},n.prototype.L=function(t){var i=this.state,s=i.j,n=i.h,o=(this.props.checked?this.i:this.o)+t-s;i.N||t===s||this.setState({N:!0});var h=Math.min(this.i,Math.max(this.o,o));h!==n&&this.setState({h:h});},n.prototype.U=function(t){var i=this.state,s=i.h,n=i.N,o=i.B,h=this.props.checked,e=(this.i+this.o)/2;this.setState({h:this.props.checked?this.i:this.o});var a=Date.now()-o;(!n||a<250||(h&&s<=e||!h&&s>=e))&&this.A(t),this.W&&this.setState({N:!1,R:!1}),this.l=Date.now();},n.prototype.p=function(t){t.preventDefault(),"number"==typeof t.button&&0!==t.button||(this.I(t.clientX),window.addEventListener("mousemove",this.v),window.addEventListener("mouseup",this.g));},n.prototype.v=function(t){t.preventDefault(),this.L(t.clientX);},n.prototype.g=function(t){this.U(t),window.removeEventListener("mousemove",this.v),window.removeEventListener("mouseup",this.g);},n.prototype.k=function(t){this.X=null,this.I(t.touches[0].clientX);},n.prototype.M=function(t){this.L(t.touches[0].clientX);},n.prototype.m=function(t){t.preventDefault(),this.U(t);},n.prototype.$=function(t){Date.now()-this.l>50&&(this.A(t),Date.now()-this.u>50&&this.W&&this.setState({R:!1}));},n.prototype.C=function(){this.u=Date.now();},n.prototype.O=function(){this.setState({R:!0});},n.prototype.D=function(){this.setState({R:!1});},n.prototype.S=function(t){this.H=t;},n.prototype.T=function(t){t.preventDefault(),this.H.focus(),this.A(t),this.W&&this.setState({R:!1});},n.prototype.A=function(t){var i=this.props;(0, i.onChange)(!i.checked,t,i.id);},n.prototype.render=function(){var s=this.props,n=s.checked,o=s.disabled,e=s.className,a=s.offColor,r=s.onColor,l=s.offHandleColor,u=s.onHandleColor,c=s.checkedIcon,d=s.uncheckedIcon,f=s.checkedHandleIcon,p=s.uncheckedHandleIcon,b=s.boxShadow,v=s.activeBoxShadow,g=s.height,y=s.width,w=s.borderRadius,k=function(t,i){var s={};for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&-1===i.indexOf(n)&&(s[n]=t[n]);return s}(s,["checked","disabled","className","offColor","onColor","offHandleColor","onHandleColor","checkedIcon","uncheckedIcon","checkedHandleIcon","uncheckedHandleIcon","boxShadow","activeBoxShadow","height","width","borderRadius","handleDiameter"]),M=this.state,m=M.h,T=M.N,x=M.R,$={position:"relative",display:"inline-block",textAlign:"left",opacity:o?.5:1,direction:"ltr",borderRadius:g/2,WebkitTransition:"opacity 0.25s",MozTransition:"opacity 0.25s",transition:"opacity 0.25s",touchAction:"none",WebkitTapHighlightColor:"rgba(0, 0, 0, 0)",WebkitUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",userSelect:"none"},C={height:g,width:y,margin:Math.max(0,(this.t-g)/2),position:"relative",background:h(m,this.i,this.o,a,r),borderRadius:"number"==typeof w?w:g/2,cursor:o?"default":"pointer",WebkitTransition:T?null:"background 0.25s",MozTransition:T?null:"background 0.25s",transition:T?null:"background 0.25s"},O={height:g,width:Math.min(1.5*g,y-(this.t+g)/2+1),position:"relative",opacity:(m-this.o)/(this.i-this.o),pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},D={height:g,width:Math.min(1.5*g,y-(this.t+g)/2+1),position:"absolute",opacity:1-(m-this.o)/(this.i-this.o),right:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},S={height:this.t,width:this.t,background:h(m,this.i,this.o,l,u),display:"inline-block",cursor:o?"default":"pointer",borderRadius:"number"==typeof w?w-1:"50%",position:"absolute",transform:"translateX("+m+"px)",top:Math.max(0,(g-this.t)/2),outline:0,boxShadow:x?v:b,border:0,WebkitTransition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",MozTransition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",transition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s"},W={height:this.t,width:this.t,opacity:Math.max(2*(1-(m-this.o)/(this.i-this.o)-.5),0),position:"absolute",left:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},z={height:this.t,width:this.t,opacity:Math.max(2*((m-this.o)/(this.i-this.o)-.5),0),position:"absolute",left:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"};return t.createElement("div",{className:e,style:$},t.createElement("div",{className:"react-switch-bg",style:C,onClick:o?null:this.T,onMouseDown:function(t){return t.preventDefault()}},c&&t.createElement("div",{style:O},c),d&&t.createElement("div",{style:D},d)),t.createElement("div",{className:"react-switch-handle",style:S,onClick:function(t){return t.preventDefault()},onMouseDown:o?null:this.p,onTouchStart:o?null:this.k,onTouchMove:o?null:this.M,onTouchEnd:o?null:this.m,onTouchCancel:o?null:this.D},p&&t.createElement("div",{style:W},p),f&&t.createElement("div",{style:z},f)),t.createElement("input",i({},{type:"checkbox",role:"switch","aria-checked":n,checked:n,disabled:o,style:{border:0,clip:"rect(0 0 0 0)",height:1,margin:-1,overflow:"hidden",padding:0,position:"absolute",width:1}},k,{ref:this.S,onFocus:this.O,onBlur:this.D,onKeyUp:this.C,onChange:this.$})))},n}(t.Component);e.defaultProps={disabled:!1,offColor:"#888",onColor:"#080",offHandleColor:"#fff",onHandleColor:"#fff",uncheckedIcon:s,checkedIcon:n,boxShadow:null,activeBoxShadow:"0 0 2px 3px #3bf",height:28,width:56},index_prod.default=e;
	return index_prod;
}

var index_dev = {};

var hasRequiredIndex_dev;

function requireIndex_dev () {
	if (hasRequiredIndex_dev) return index_dev;
	hasRequiredIndex_dev = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });

		var React = React__default;
		var PropTypes$1 = PropTypes;

		function _extends() {
		  _extends = Object.assign ? Object.assign.bind() : function (target) {
		    for (var i = 1; i < arguments.length; i++) {
		      var source = arguments[i];

		      for (var key in source) {
		        if (Object.prototype.hasOwnProperty.call(source, key)) {
		          target[key] = source[key];
		        }
		      }
		    }

		    return target;
		  };
		  return _extends.apply(this, arguments);
		}

		/*
		The MIT License (MIT)

		Copyright (c) 2015 instructure-react

		Permission is hereby granted, free of charge, to any person obtaining a copy
		of this software and associated documentation files (the "Software"), to deal
		in the Software without restriction, including without limitation the rights
		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		copies of the Software, and to permit persons to whom the Software is
		furnished to do so, subject to the following conditions:

		The above copyright notice and this permission notice shall be included in all
		copies or substantial portions of the Software.

		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
		SOFTWARE.
		*/
		var uncheckedIcon = React.createElement('svg', {
		  viewBox: "-2 -5 14 20",
		  height: "100%",
		  width: "100%",
		  style: {
		    position: "absolute",
		    top: 0
		  }
		}, React.createElement('path', {
		  d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
		  fill: "#fff",
		  fillRule: "evenodd"
		}));
		var checkedIcon = React.createElement('svg', {
		  height: "100%",
		  width: "100%",
		  viewBox: "-2 -5 17 21",
		  style: {
		    position: "absolute",
		    top: 0
		  }
		}, React.createElement('path', {
		  d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
		  fill: "#fff",
		  fillRule: "evenodd"
		}));

		function createBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
		  var relativePos = (pos - uncheckedPos) / (checkedPos - uncheckedPos);

		  if (relativePos === 0) {
		    return offColor;
		  }

		  if (relativePos === 1) {
		    return onColor;
		  }

		  var newColor = "#";

		  for (var i = 1; i < 6; i += 2) {
		    var offComponent = parseInt(offColor.substr(i, 2), 16);
		    var onComponent = parseInt(onColor.substr(i, 2), 16);
		    var weightedValue = Math.round((1 - relativePos) * offComponent + relativePos * onComponent);
		    var newComponent = weightedValue.toString(16);

		    if (newComponent.length === 1) {
		      newComponent = "0" + newComponent;
		    }

		    newColor += newComponent;
		  }

		  return newColor;
		}

		function convertShorthandColor(color) {
		  if (color.length === 7) {
		    return color;
		  }

		  var sixDigitColor = "#";

		  for (var i = 1; i < 4; i += 1) {
		    sixDigitColor += color[i] + color[i];
		  }

		  return sixDigitColor;
		}

		function getBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
		  var sixDigitOffColor = convertShorthandColor(offColor);
		  var sixDigitOnColor = convertShorthandColor(onColor);
		  return createBackgroundColor(pos, checkedPos, uncheckedPos, sixDigitOffColor, sixDigitOnColor);
		}

		// Make sure color props are strings that start with "#" since other ways to write colors are not supported.
		var hexColorPropType = function (props, propName, componentName) {
		  var prop = props[propName];

		  if (typeof prop !== "string" || prop[0] !== "#" || prop.length !== 4 && prop.length !== 7) {
		    return new Error("Invalid prop '" + propName + "' supplied to '" + componentName + "'. '" + propName + "' has to be either a 3-digit or 6-digit hex-color string. Valid examples: '#abc', '#123456'");
		  }

		  return null;
		};

		function objectWithoutProperties(obj, exclude) {
		  var target = {};

		  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];

		  return target;
		}

		var ReactSwitch = /*@__PURE__*/function (Component) {
		  function ReactSwitch(props) {
		    Component.call(this, props);
		    var height = props.height;
		    var width = props.width;
		    var handleDiameter = props.handleDiameter;
		    var checked = props.checked;
		    this.$handleDiameter = handleDiameter || height - 2;
		    this.$checkedPos = Math.max(width - height, width - (height + this.$handleDiameter) / 2);
		    this.$uncheckedPos = Math.max(0, (height - this.$handleDiameter) / 2);
		    this.state = {
		      $pos: checked ? this.$checkedPos : this.$uncheckedPos
		    };
		    this.$lastDragAt = 0;
		    this.$lastKeyUpAt = 0;
		    this.$onMouseDown = this.$onMouseDown.bind(this);
		    this.$onMouseMove = this.$onMouseMove.bind(this);
		    this.$onMouseUp = this.$onMouseUp.bind(this);
		    this.$onTouchStart = this.$onTouchStart.bind(this);
		    this.$onTouchMove = this.$onTouchMove.bind(this);
		    this.$onTouchEnd = this.$onTouchEnd.bind(this);
		    this.$onClick = this.$onClick.bind(this);
		    this.$onInputChange = this.$onInputChange.bind(this);
		    this.$onKeyUp = this.$onKeyUp.bind(this);
		    this.$setHasOutline = this.$setHasOutline.bind(this);
		    this.$unsetHasOutline = this.$unsetHasOutline.bind(this);
		    this.$getInputRef = this.$getInputRef.bind(this);
		  }

		  if (Component) ReactSwitch.__proto__ = Component;
		  ReactSwitch.prototype = Object.create(Component && Component.prototype);
		  ReactSwitch.prototype.constructor = ReactSwitch;

		  ReactSwitch.prototype.componentDidMount = function componentDidMount() {
		    this.$isMounted = true;
		  };

		  ReactSwitch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
		    if (prevProps.checked === this.props.checked) {
		      return;
		    }

		    var $pos = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
		    this.setState({
		      $pos: $pos
		    });
		  };

		  ReactSwitch.prototype.componentWillUnmount = function componentWillUnmount() {
		    this.$isMounted = false;
		  };

		  ReactSwitch.prototype.$onDragStart = function $onDragStart(clientX) {
		    this.$inputRef.focus();
		    this.setState({
		      $startX: clientX,
		      $hasOutline: true,
		      $dragStartingTime: Date.now()
		    });
		  };

		  ReactSwitch.prototype.$onDrag = function $onDrag(clientX) {
		    var ref = this.state;
		    var $startX = ref.$startX;
		    var $isDragging = ref.$isDragging;
		    var $pos = ref.$pos;
		    var ref$1 = this.props;
		    var checked = ref$1.checked;
		    var startPos = checked ? this.$checkedPos : this.$uncheckedPos;
		    var mousePos = startPos + clientX - $startX; // We need this check to fix a windows glitch where onDrag is triggered onMouseDown in some cases

		    if (!$isDragging && clientX !== $startX) {
		      this.setState({
		        $isDragging: true
		      });
		    }

		    var newPos = Math.min(this.$checkedPos, Math.max(this.$uncheckedPos, mousePos)); // Prevent unnecessary rerenders

		    if (newPos !== $pos) {
		      this.setState({
		        $pos: newPos
		      });
		    }
		  };

		  ReactSwitch.prototype.$onDragStop = function $onDragStop(event) {
		    var ref = this.state;
		    var $pos = ref.$pos;
		    var $isDragging = ref.$isDragging;
		    var $dragStartingTime = ref.$dragStartingTime;
		    var ref$1 = this.props;
		    var checked = ref$1.checked;
		    var halfwayCheckpoint = (this.$checkedPos + this.$uncheckedPos) / 2;
		    /*
		      Set position state back to the previous position even if user drags the switch with intention to change the state.
		      This is to prevent the switch from getting stuck in the middle if the event isn't handled in the onChange callback.
		    */

		    var prevPos = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
		    this.setState({
		      $pos: prevPos
		    }); // Act as if the user clicked the handle if they didn't drag it _or_ the dragged it for less than 250ms

		    var timeSinceStart = Date.now() - $dragStartingTime;
		    var isSimulatedClick = !$isDragging || timeSinceStart < 250; // Handle when the user has dragged the switch more than halfway from either side

		    var isDraggedHalfway = checked && $pos <= halfwayCheckpoint || !checked && $pos >= halfwayCheckpoint;

		    if (isSimulatedClick || isDraggedHalfway) {
		      this.$onChange(event);
		    }

		    if (this.$isMounted) {
		      this.setState({
		        $isDragging: false,
		        $hasOutline: false
		      });
		    }

		    this.$lastDragAt = Date.now();
		  };

		  ReactSwitch.prototype.$onMouseDown = function $onMouseDown(event) {
		    event.preventDefault(); // Ignore right click and scroll

		    if (typeof event.button === "number" && event.button !== 0) {
		      return;
		    }

		    this.$onDragStart(event.clientX);
		    window.addEventListener("mousemove", this.$onMouseMove);
		    window.addEventListener("mouseup", this.$onMouseUp);
		  };

		  ReactSwitch.prototype.$onMouseMove = function $onMouseMove(event) {
		    event.preventDefault();
		    this.$onDrag(event.clientX);
		  };

		  ReactSwitch.prototype.$onMouseUp = function $onMouseUp(event) {
		    this.$onDragStop(event);
		    window.removeEventListener("mousemove", this.$onMouseMove);
		    window.removeEventListener("mouseup", this.$onMouseUp);
		  };

		  ReactSwitch.prototype.$onTouchStart = function $onTouchStart(event) {
		    this.$checkedStateFromDragging = null;
		    this.$onDragStart(event.touches[0].clientX);
		  };

		  ReactSwitch.prototype.$onTouchMove = function $onTouchMove(event) {
		    this.$onDrag(event.touches[0].clientX);
		  };

		  ReactSwitch.prototype.$onTouchEnd = function $onTouchEnd(event) {
		    event.preventDefault();
		    this.$onDragStop(event);
		  };

		  ReactSwitch.prototype.$onInputChange = function $onInputChange(event) {
		    // This condition is unfortunately needed in some browsers where the input's change event might get triggered
		    // right after the dragstop event is triggered (occurs when dropping over a label element)
		    if (Date.now() - this.$lastDragAt > 50) {
		      this.$onChange(event); // Prevent clicking label, but not key activation from setting outline to true - yes, this is absurd

		      if (Date.now() - this.$lastKeyUpAt > 50) {
		        if (this.$isMounted) {
		          this.setState({
		            $hasOutline: false
		          });
		        }
		      }
		    }
		  };

		  ReactSwitch.prototype.$onKeyUp = function $onKeyUp() {
		    this.$lastKeyUpAt = Date.now();
		  };

		  ReactSwitch.prototype.$setHasOutline = function $setHasOutline() {
		    this.setState({
		      $hasOutline: true
		    });
		  };

		  ReactSwitch.prototype.$unsetHasOutline = function $unsetHasOutline() {
		    this.setState({
		      $hasOutline: false
		    });
		  };

		  ReactSwitch.prototype.$getInputRef = function $getInputRef(el) {
		    this.$inputRef = el;
		  };

		  ReactSwitch.prototype.$onClick = function $onClick(event) {
		    event.preventDefault();
		    this.$inputRef.focus();
		    this.$onChange(event);

		    if (this.$isMounted) {
		      this.setState({
		        $hasOutline: false
		      });
		    }
		  };

		  ReactSwitch.prototype.$onChange = function $onChange(event) {
		    var ref = this.props;
		    var checked = ref.checked;
		    var onChange = ref.onChange;
		    var id = ref.id;
		    onChange(!checked, event, id);
		  };

		  ReactSwitch.prototype.render = function render() {
		    var ref = this.props;
		    var checked = ref.checked;
		    var disabled = ref.disabled;
		    var className = ref.className;
		    var offColor = ref.offColor;
		    var onColor = ref.onColor;
		    var offHandleColor = ref.offHandleColor;
		    var onHandleColor = ref.onHandleColor;
		    var checkedIcon = ref.checkedIcon;
		    var uncheckedIcon = ref.uncheckedIcon;
		    var checkedHandleIcon = ref.checkedHandleIcon;
		    var uncheckedHandleIcon = ref.uncheckedHandleIcon;
		    var boxShadow = ref.boxShadow;
		    var activeBoxShadow = ref.activeBoxShadow;
		    var height = ref.height;
		    var width = ref.width;
		    var borderRadius = ref.borderRadius;
		    ref.handleDiameter;
		    var rest$1 = objectWithoutProperties(ref, ["checked", "disabled", "className", "offColor", "onColor", "offHandleColor", "onHandleColor", "checkedIcon", "uncheckedIcon", "checkedHandleIcon", "uncheckedHandleIcon", "boxShadow", "activeBoxShadow", "height", "width", "borderRadius", "handleDiameter"]);
		    var rest = rest$1;
		    var ref$1 = this.state;
		    var $pos = ref$1.$pos;
		    var $isDragging = ref$1.$isDragging;
		    var $hasOutline = ref$1.$hasOutline;
		    var rootStyle = {
		      position: "relative",
		      display: "inline-block",
		      textAlign: "left",
		      opacity: disabled ? 0.5 : 1,
		      direction: "ltr",
		      borderRadius: height / 2,
		      WebkitTransition: "opacity 0.25s",
		      MozTransition: "opacity 0.25s",
		      transition: "opacity 0.25s",
		      touchAction: "none",
		      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
		      WebkitUserSelect: "none",
		      MozUserSelect: "none",
		      msUserSelect: "none",
		      userSelect: "none"
		    };
		    var backgroundStyle = {
		      height: height,
		      width: width,
		      margin: Math.max(0, (this.$handleDiameter - height) / 2),
		      position: "relative",
		      background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offColor, onColor),
		      borderRadius: typeof borderRadius === "number" ? borderRadius : height / 2,
		      cursor: disabled ? "default" : "pointer",
		      WebkitTransition: $isDragging ? null : "background 0.25s",
		      MozTransition: $isDragging ? null : "background 0.25s",
		      transition: $isDragging ? null : "background 0.25s"
		    };
		    var checkedIconStyle = {
		      height: height,
		      width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
		      position: "relative",
		      opacity: ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
		      pointerEvents: "none",
		      WebkitTransition: $isDragging ? null : "opacity 0.25s",
		      MozTransition: $isDragging ? null : "opacity 0.25s",
		      transition: $isDragging ? null : "opacity 0.25s"
		    };
		    var uncheckedIconStyle = {
		      height: height,
		      width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
		      position: "absolute",
		      opacity: 1 - ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
		      right: 0,
		      top: 0,
		      pointerEvents: "none",
		      WebkitTransition: $isDragging ? null : "opacity 0.25s",
		      MozTransition: $isDragging ? null : "opacity 0.25s",
		      transition: $isDragging ? null : "opacity 0.25s"
		    };
		    var handleStyle = {
		      height: this.$handleDiameter,
		      width: this.$handleDiameter,
		      background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offHandleColor, onHandleColor),
		      display: "inline-block",
		      cursor: disabled ? "default" : "pointer",
		      borderRadius: typeof borderRadius === "number" ? borderRadius - 1 : "50%",
		      position: "absolute",
		      transform: "translateX(" + $pos + "px)",
		      top: Math.max(0, (height - this.$handleDiameter) / 2),
		      outline: 0,
		      boxShadow: $hasOutline ? activeBoxShadow : boxShadow,
		      border: 0,
		      WebkitTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
		      MozTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
		      transition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
		    };
		    var uncheckedHandleIconStyle = {
		      height: this.$handleDiameter,
		      width: this.$handleDiameter,
		      opacity: Math.max((1 - ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - 0.5) * 2, 0),
		      position: "absolute",
		      left: 0,
		      top: 0,
		      pointerEvents: "none",
		      WebkitTransition: $isDragging ? null : "opacity 0.25s",
		      MozTransition: $isDragging ? null : "opacity 0.25s",
		      transition: $isDragging ? null : "opacity 0.25s"
		    };
		    var checkedHandleIconStyle = {
		      height: this.$handleDiameter,
		      width: this.$handleDiameter,
		      opacity: Math.max((($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - 0.5) * 2, 0),
		      position: "absolute",
		      left: 0,
		      top: 0,
		      pointerEvents: "none",
		      WebkitTransition: $isDragging ? null : "opacity 0.25s",
		      MozTransition: $isDragging ? null : "opacity 0.25s",
		      transition: $isDragging ? null : "opacity 0.25s"
		    };
		    var inputStyle = {
		      border: 0,
		      clip: "rect(0 0 0 0)",
		      height: 1,
		      margin: -1,
		      overflow: "hidden",
		      padding: 0,
		      position: "absolute",
		      width: 1
		    };
		    return React.createElement('div', {
		      className: className,
		      style: rootStyle
		    }, React.createElement('div', {
		      className: "react-switch-bg",
		      style: backgroundStyle,
		      onClick: disabled ? null : this.$onClick,
		      onMouseDown: function (e) {
		        return e.preventDefault();
		      }
		    }, checkedIcon && React.createElement('div', {
		      style: checkedIconStyle
		    }, checkedIcon), uncheckedIcon && React.createElement('div', {
		      style: uncheckedIconStyle
		    }, uncheckedIcon)), React.createElement('div', {
		      className: "react-switch-handle",
		      style: handleStyle,
		      onClick: function (e) {
		        return e.preventDefault();
		      },
		      onMouseDown: disabled ? null : this.$onMouseDown,
		      onTouchStart: disabled ? null : this.$onTouchStart,
		      onTouchMove: disabled ? null : this.$onTouchMove,
		      onTouchEnd: disabled ? null : this.$onTouchEnd,
		      onTouchCancel: disabled ? null : this.$unsetHasOutline
		    }, uncheckedHandleIcon && React.createElement('div', {
		      style: uncheckedHandleIconStyle
		    }, uncheckedHandleIcon), checkedHandleIcon && React.createElement('div', {
		      style: checkedHandleIconStyle
		    }, checkedHandleIcon)), React.createElement('input', _extends({}, {
		      type: "checkbox",
		      role: "switch",
		      'aria-checked': checked,
		      checked: checked,
		      disabled: disabled,
		      style: inputStyle
		    }, rest, {
		      ref: this.$getInputRef,
		      onFocus: this.$setHasOutline,
		      onBlur: this.$unsetHasOutline,
		      onKeyUp: this.$onKeyUp,
		      onChange: this.$onInputChange
		    })));
		  };

		  return ReactSwitch;
		}(React.Component);

		ReactSwitch.propTypes = {
		  checked: PropTypes$1.bool.isRequired,
		  onChange: PropTypes$1.func.isRequired,
		  disabled: PropTypes$1.bool,
		  offColor: hexColorPropType,
		  onColor: hexColorPropType,
		  offHandleColor: hexColorPropType,
		  onHandleColor: hexColorPropType,
		  handleDiameter: PropTypes$1.number,
		  uncheckedIcon: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.element]),
		  checkedIcon: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.element]),
		  boxShadow: PropTypes$1.string,
		  borderRadius: PropTypes$1.number,
		  activeBoxShadow: PropTypes$1.string,
		  uncheckedHandleIcon: PropTypes$1.element,
		  checkedHandleIcon: PropTypes$1.element,
		  height: PropTypes$1.number,
		  width: PropTypes$1.number,
		  id: PropTypes$1.string,
		  className: PropTypes$1.string
		};
		ReactSwitch.defaultProps = {
		  disabled: false,
		  offColor: "#888",
		  onColor: "#080",
		  offHandleColor: "#fff",
		  onHandleColor: "#fff",
		  uncheckedIcon: uncheckedIcon,
		  checkedIcon: checkedIcon,
		  boxShadow: null,
		  activeBoxShadow: "0 0 2px 3px #3bf",
		  height: 28,
		  width: 56
		};

		exports["default"] = ReactSwitch; 
	} (index_dev));
	return index_dev;
}

var hasRequiredReactSwitch;

function requireReactSwitch () {
	if (hasRequiredReactSwitch) return reactSwitch.exports;
	hasRequiredReactSwitch = 1;
	if (process.env.NODE_ENV === "production") {
	  reactSwitch.exports = requireIndex_prod();
	} else {
	  reactSwitch.exports = requireIndex_dev();
	}
	return reactSwitch.exports;
}

var reactSwitchExports = requireReactSwitch();
var Switch = /*@__PURE__*/getDefaultExportFromCjs(reactSwitchExports);

var StyledSwitch = styled(function (props) { return jsx$1(Switch, __assign$1({}, props)); })(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  svg {\n    height: 80% !important;\n    width: 80% !important;\n    top: 3px !important;\n    left: 3px;\n  }\n"], ["\n  svg {\n    height: 80% !important;\n    width: 80% !important;\n    top: 3px !important;\n    left: 3px;\n  }\n"])));
var FormSwitch = function (_a) {
    var name = _a.name, value = _a.value, onChange = _a.onChange, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.ueberschreibbar, ueberschreibbar = _c === void 0 ? true : _c, subtitle = _a.subtitle, hint = _a.hint, message = _a.message, error = _a.error;
    return (jsx$1(StyledSwitch, { className: "react-switch ".concat(className, " ").concat(!value ? '' : 'react-switch--checked', " ").concat(!ueberschreibbar ? 'react-switch--disabled' : ''), onChange: onChange, checked: !!value, disabled: !ueberschreibbar, handleDiameter: 20, height: 26, width: 55, name: name, id: name, "aria-describedby": inputGenerateDescribedBy(name, subtitle, hint, error, message) }));
};
var templateObject_1$m;

var Wrapper = styled.span(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  white-space: nowrap;\n  &:before {\n    content: none;\n  }\n"], ["\n  white-space: nowrap;\n  &:before {\n    content: none;\n  }\n"])));
var Nowrap = function (_a) {
    var children = _a.children;
    return (jsxs(Wrapper, { className: "no-wrap", children: ["\u00A0", children] }));
};
var templateObject_1$l;

var BlockTrackable = function (_a) {
    var _b = _a.trackingName, trackingName = _b === void 0 ? '' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.children, children = _d === void 0 ? null : _d;
    return (jsx$1("div", { "data-tracking-name": trackingName, className: "trackable ".concat(className), children: children }));
};

var Baustein = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  &.disabled {\n    opacity: 0.4;\n  }\n  &.special {\n    background: #e2e2e2;\n    padding: 1rem 1.25rem 0.25rem 1.25rem;\n    margin: 1rem -1rem;\n  }\n  .invalid-feedback {\n    display: block;\n  }\n"], ["\n  &.disabled {\n    opacity: 0.4;\n  }\n  &.special {\n    background: #e2e2e2;\n    padding: 1rem 1.25rem 0.25rem 1.25rem;\n    margin: 1rem -1rem;\n  }\n  .invalid-feedback {\n    display: block;\n  }\n"])));
var BausteinLabel = styled.label(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  padding: 0;\n  cursor: pointer;\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: var(--label-color);\n"], ["\n  padding: 0;\n  cursor: pointer;\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: var(--label-color);\n"])));
var BausteinTooltip = styled(Tooltip)(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  margin-top: -2px;\n"], ["\n  margin-top: -2px;\n"])));
var Produktbaustein = function (_a) {
    var _b = _a.special, special = _b === void 0 ? false : _b, _c = _a.checkbox, checkbox = _c === void 0 ? {
        value: false,
    } : _c, _d = _a.messageOptions, messageOptions = _d === void 0 ? {
        dismissible: true,
        dangerouslySetHTML: true,
        onAfterClose: function () { },
        className: '',
        messageVariant: 'gray',
    } : _d, messageVariant = _a.messageVariant, _e = _a.messageClassName, messageClassName = _e === void 0 ? '' : _e, title = _a.title, tooltip = _a.tooltip, name = _a.name, children = _a.children, onChange = _a.onChange, onClick = _a.onClick, component = _a.component, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.swapElements, swapElements = _g === void 0 ? false : _g, message = _a.message, subtitle = _a.subtitle;
    return (jsxs(Baustein, { className: "".concat(special ? 'special ' : ' ', "produktbaustein ").concat(className), onClick: onClick, children: [jsxs("div", { className: "d-flex align-items-start gap-3", children: [jsxs(BausteinLabel, { htmlFor: name, className: "produktbaustein__title ".concat(swapElements ? 'order-2' : ''), children: [title, tooltip && (jsx$1(Nowrap, { children: jsx$1(BausteinTooltip, { handleTooltip: tooltip, className: "produktbaustein__tooltip me-1", id: "tooltip-".concat(name.toLowerCase()) }) }))] }), checkbox && (jsx$1(BlockTrackable, { trackingName: name, className: swapElements ? 'order-1' : 'ms-auto', children: jsx$1(FormSwitch, __assign$1({}, checkbox, { onChange: onChange, name: name, message: message, subtitle: subtitle })) })), component] }), jsxs("div", { className: "card-text", children: [subtitle && (jsx$1("div", { id: "subtitle.".concat(name), children: subtitle })), children] }), checkbox.error && jsx$1(Form.Control.Feedback, { type: "invalid", id: "error.".concat(name), children: checkbox.error }), message && (jsx$1(Message$1, { show: true, dismissible: messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.dismissible, dangerouslySetHTML: messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.dangerouslySetHTML, onAfterClose: messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.onAfterClose, className: messageClassName || (messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.className), variant: messageVariant || (messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.messageVariant), text: message, id: "message.".concat(name) }))] }));
};
var index$5 = React__default.memo(Produktbaustein);
var templateObject_1$k, templateObject_2$6, templateObject_3$3;

var StyledIcon = styled(SvgStar)(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n"])), function (_a) {
    var size = _a.size;
    return "".concat(size, "rem !important");
}, function (_a) {
    var size = _a.size;
    return "".concat(size, "rem !important");
});
var ProduktStern = function (_a) {
    var _b = _a.anzahl, anzahl = _b === void 0 ? 0 : _b, _c = _a.size, size = _c === void 0 ? '1.5' : _c;
    return (jsx$1("div", { className: "product__icons mb-2", children: __spreadArray$1([], Array(anzahl), true).map(function (item, index) { return jsx$1(StyledIcon, { size: size }, index); }) }));
};
var templateObject_1$j;

var initState = function (tarifrechner) {
    var searchParams = new URLSearchParams(window.location.search);
    var vtnr = searchParams.get('vtnr') || trEnv$1.vtnr;
    var mandant = searchParams.get('mandant') || trEnv$1.mandant;
    var vkanal = trEnv$1.vkanal;
    // wenn vtnr im html dann vkanal wechseln
    if (!trEnv$1.sparkasse && vtnr) {
        vkanal = 'internet_ad';
        // ist vtnr nicht als url param, dann als url param hinzufügen
        if (!searchParams.get('vtnr')) {
            searchParams.set('vtnr', trEnv$1.vtnr);
            var newRelativePathQuery = "".concat(window.location.pathname, "?").concat(searchParams.toString());
            window.history.pushState(null, '', newRelativePathQuery);
        }
    }
    return {
        daten: {},
        appDaten: {
            errorBoundary: null,
            initTracking: false,
            produktauswahl: '',
            vtnr: vtnr,
            vkanal: vkanal,
            mandant: mandant,
            druckmodal: false,
            loading: 0,
            dokumente: {
                beratung: false,
                antrag: false,
                geladen: false,
            },
            antragsfragen: false,
            datenschutz: false,
            tooltip: {
                status: false,
                text: undefined,
                offset: 0,
            },
            message: [],
            neuesKonto: false,
            tarifrechner: tarifrechner,
            preset: '',
            dev: 0,
            pages: [],
            showBeraterModal: false,
            files: [],
            filesCheckbox: false,
            qesUnterschreiben: null,
            showNeuordnungModal: false,
            version: '0.0.0',
        },
        savedState: '',
        euBeratung: {},
        druckmatrix: {},
    };
};

/**
 * erstellt einen Store für Redux und gibt ihn dann zurück
 * @param {string} appName
 * @param {Object} extraReducer
 * @returns {EnhancedStore<{}, UnknownAction, Tuple<[StoreEnhancer<{dispatch: ExtractDispatchExtensions<Tuple<[ThunkMiddlewareFor<S>]>>}>, StoreEnhancer]>>}
 */
var store = function (appName) {
    var preloadedState = __assign$1({}, initState(appName));
    if (!trEnv$1.sparkasse) {
        preloadedState = __assign$1(__assign$1({}, preloadedState), savedStateManager.loadFromSessionStorage());
    }
    var reduxStore = configureStore({
        reducer: rootReducer,
        preloadedState: preloadedState,
    });
    reduxStore.subscribe(function () {
        savedStateManager.saveToSessionStorage(reduxStore.getState());
    });
    return reduxStore;
};

var FehlerModal = function () {
    var dispatch = useDispatch();
    var message = useSelector(function (state) { return state.appDaten.message || []; });
    useEffect(function () {
        dispatch(updateByName('appDaten.tempMessage', message));
    }, []);
    var handleClose = function () {
        if (trEnv$1.sparkasse) {
            window.OSPlusNeo.reportError();
            return;
        }
        removeSessionId();
        dispatch(updateByName('appDaten.message', []));
        window.location.hash = '/';
        window.location.reload();
    };
    var handleFortsetzen = function () {
        dispatch(updateByName('appDaten.message', []));
    };
    var getErrorText = trEnv$1.error && trEnv$1.error !== '%ERROR_TEXT%';
    var error = message.length > 0 ? (message.map(function (fehler) { return (fehler.exception ? fehler.exception.message : fehler.nachricht); })) : trEnv$1.error;
    var nichtFortsetzen = message.length > 0 ? message.some(function (fehler) { return fehler.fortsetzen === false; }) : true;
    return (jsxs(Modal$1, { dialogClassName: "tooltip-dialog", show: message.length > 0 || getErrorText, onHide: handleClose, container: function () { return document.querySelector('.bs-iso'); }, centered: true, animation: false, children: [jsx$1(Modal$1.Body, { className: "mt-2 text-center", children: error }), jsxs(Modal$1.Footer, { className: !nichtFortsetzen ? 'justify-content-between' : '', children: [jsx$1(Button$1, { variant: "primary", onClick: handleClose, className: "text-center", "data-tracking-name": "close-tooltip-modal", children: trEnv$1.sparkasse ? 'Beenden' : 'Neu beginnen' }), !nichtFortsetzen && (jsx$1(Button$1, { variant: "primary", onClick: handleFortsetzen, className: "text-center", children: trEnv$1.stationaer && 'Fortsetzen' }))] })] }));
};

var LibModal = function (_a) {
    var _b = _a.buttonText, buttonText = _b === void 0 ? 'Button' : _b, _c = _a.buttonClass, buttonClass = _c === void 0 ? '' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.children, children = _e === void 0 ? null : _e, size = _a.size, _f = _a.tracking, tracking = _f === void 0 ? 'modal' : _f, _g = _a.open, open = _g === void 0 ? false : _g, _h = _a.centered, centered = _h === void 0 ? true : _h, _j = _a.scrollable, scrollable = _j === void 0 ? false : _j, _k = _a.title, title = _k === void 0 ? '' : _k, _l = _a.backdrop, backdrop = _l === void 0 ? true : _l, _m = _a.showFooter, showFooter = _m === void 0 ? true : _m, _o = _a.onClose, onClose = _o === void 0 ? function () { } : _o, _p = _a.wrapperClassName, wrapperClassName = _p === void 0 ? '' : _p, _q = _a.backdropCloseAnimation, backdropCloseAnimation = _q === void 0 ? false : _q;
    var _r = useState(open), show = _r[0], setShow = _r[1];
    var body = document.querySelector('body');
    var handleClose = function () {
        onClose();
        body.classList.remove('modal-open');
        setShow(false);
    };
    var handleShow = function () {
        body.classList.add('modal-open');
        setShow(true);
    };
    return (jsxs(Fragment, { children: [jsx$1(Button$1, { variant: "link", className: "mt-2 ".concat(buttonClass), onClick: handleShow, "data-tracking-name": "".concat(tracking, "-modal-opener"), children: buttonText }), jsxs(Modal$1, { dialogClassName: className, className: "".concat(backdropCloseAnimation ? 'backdrop-close-animation' : '', " ").concat(wrapperClassName || ''), show: show, container: function () { return document.querySelector('.bs-iso'); }, size: size, centered: centered, onHide: handleClose, animation: false, scrollable: scrollable, backdrop: backdrop, children: [jsx$1(Modal$1.Header, { closeButton: true, className: title ? 'modal-has-title' : 'p-0', children: title && (jsx$1(Modal$1.Title, { children: title })) }), jsx$1(Modal$1.Body, { children: children }), showFooter && (jsx$1(Modal$1.Footer, { children: jsx$1(Button$1, { variant: "primary", onClick: handleClose, children: "OK" }) }))] })] }));
};
var Modal = React__default.memo(LibModal);

var _path$1;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  "aria-label": "Warning:",
  viewBox: "0 0 16 16"
}, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
  d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
})));

var _path;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
const SvgCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends$1({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  className: "circle-fill_svg__bi circle-fill_svg__bi-x-circle-fill",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"
})));

var StyledDiv$1 = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  ", "\n  ul {\n    font-weight: 400 !important;\n    li:only-child {\n      list-style-type: none;\n    }\n  }\n"], ["\n  ", "\n  ul {\n    font-weight: 400 !important;\n    li:only-child {\n      list-style-type: none;\n    }\n  }\n"])), function (_a) {
    var isError = _a.isError;
    return isError && css$3(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["color: red;"], ["color: red;"])));
});
var Icon = styled.div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  margin: 0 auto;\n  svg {\n    height: 60px;\n    width: 60px;\n  }\n"], ["\n  margin: 0 auto;\n  svg {\n    height: 60px;\n    width: 60px;\n  }\n"])));
var GlobalMsgModal = function () {
    var _a, _b;
    var _c = useState(false), show = _c[0], setShow = _c[1];
    var globalMsg = useSelector(function (state) { return state.daten.globalMsg; });
    var isError = (globalMsg === null || globalMsg === void 0 ? void 0 : globalMsg.value) === 'error';
    var bodyTag = document.querySelector('body');
    useEffect(function () {
        setShow(globalMsg.relevant);
        if (globalMsg.relevant) {
            bodyTag.classList.add('modal-open');
        }
    }, [globalMsg.relevant]);
    var handleClose = function () {
        setShow(false);
        bodyTag.classList.remove('modal-open');
    };
    return (jsxs(Modal$1, { show: show, onHide: handleClose, container: function () { return document.querySelector('.bs-iso'); }, backdrop: "static", backdropCloseAnimation: true, children: [jsx$1(Modal$1.Body, { className: "mt-4 text-center", children: jsxs(StyledDiv$1, { isError: isError, className: "d-flex flex-column", children: [jsx$1(Icon, { children: isError ? jsx$1(SvgCircleFill, {}) : jsx$1(SvgWarning, {}) }), jsx$1("ul", { className: "mt-4 ms-0 text-center", children: isError
                                ? (_a = globalMsg.error) === null || _a === void 0 ? void 0 : _a.map(function (fehler, index) { return jsx$1("li", { children: fehler }, index); })
                                : (_b = globalMsg.warning) === null || _b === void 0 ? void 0 : _b.map(function (warning, index) { return jsx$1("li", { children: warning }, index); }) })] }) }), jsx$1(Modal$1.Footer, { children: jsx$1(Button$1, { variant: "primary", onClick: handleClose, className: "w-100", "data-tracking-name": "close-tooltip-modal", children: "Ok, verstanden" }) })] }));
};
var templateObject_1$i, templateObject_2$5, templateObject_3$2;

var ConfirmationModal = function (_a) {
    var _b = _a.handleYes, handleYes = _b === void 0 ? function () { } : _b, _c = _a.handleNo, handleNo = _c === void 0 ? function (e) { } : _c, _d = _a.text, text = _d === void 0 ? '' : _d, _e = _a.show, show = _e === void 0 ? false : _e, _f = _a.labelJa, labelJa = _f === void 0 ? 'Ja' : _f, _g = _a.labelNein, labelNein = _g === void 0 ? 'Nein' : _g, _h = _a.buttonYesVariant, buttonYesVariant = _h === void 0 ? 'secondary' : _h, _j = _a.buttonNoVariant, buttonNoVariant = _j === void 0 ? 'primary' : _j;
    var tooltipOffset = useSelector(function (state) { return state.appDaten.tooltip_offset; });
    var body = document.querySelector('body');
    var handleBack = function (e) {
        handleNo(e);
        body.classList.remove('modal-open');
    };
    if (show) {
        body.classList.add('modal-open');
    }
    var handleShow = function () {
        body.classList.add('modal-open');
        if (tooltipOffset != null) {
            var modalDialog = document.querySelector('.modal-dialog-centered');
            if (modalDialog) {
                modalDialog.setAttribute('style', "margin-top: ".concat(tooltipOffset - 350, "px"));
            }
        }
    };
    return (jsxs(Modal$1, { dialogClassName: "druckmodal", show: show, container: function () { return document.querySelector('.bs-iso'); }, centered: true, onShow: handleShow, onHide: handleBack, animation: false, children: [jsx$1(Modal$1.Header, { className: "p-0" }), jsx$1(Modal$1.Body, { children: text }), jsxs(Modal$1.Footer, { children: [jsx$1(Button$1, { variant: buttonYesVariant, onClick: function (e) { return handleYes(e); }, children: labelJa }), jsx$1(Button$1, { variant: buttonNoVariant, onClick: function (e) { return handleBack(e); }, children: labelNein })] })] }));
};

var InlineTrackable = function (_a) {
    var _b = _a.trackingName, trackingName = _b === void 0 ? '' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.children, children = _d === void 0 ? null : _d;
    return (jsx$1("span", { "data-tracking-name": trackingName, className: "trackable ".concat(className), children: children }));
};

/**
 * nimmt ein object
 * warenkorbInhalt = {
 *  inhalte: [{name: '', inhalt: ''}],
 *  beitrag: {name: '', inhalt: ''}
 * }
 * @param inhalte
 * @param beitrag
 * @return {*}
 * @constructor
 */
var Beitrag = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  color: var(--label-color);\n"], ["\n  color: var(--label-color);\n"])));
var Warenkorb = function (_a) {
    var _b = _a.warenkorbInhalt, inhalte = _b.inhalte, beitrag = _b.beitrag;
    return !trEnv$1.sparkasse && (jsxs("div", { className: "mt-5 mb-2", children: [jsxs("h4", { className: "d-flex align-items-center", children: ["Ihre Auswahl", jsx$1(SvgShoppingCart, { style: { height: '20px', width: '20px' }, className: "basket-icon ms-auto" })] }), jsx$1("hr", { className: "hr--light-gray my-2" }), jsxs("ul", { className: "list-unstyled m-0", children: [inhalte.map(function (elem) { return (elem.visible && (jsxs("li", { className: "d-sm-flex justify-content-between py-1", children: [jsx$1("div", { children: elem.name }), jsx$1("div", { children: elem.inhalt })] }, elem.name))); }), jsx$1("hr", { className: "hr--light-gray my-2" }), beitrag && (jsxs("li", { className: "d-sm-flex justify-content-between pb-1", children: [jsx$1(Beitrag, { className: "fw-normal", children: beitrag.name }), jsx$1(Beitrag, { className: "fw-normal", children: beitrag.inhalt })] }))] })] }));
};
var index$4 = React__default.memo(Warenkorb);
var templateObject_1$h;

var TooltipModal = function (_a) {
    var _b = _a.container, container = _b === void 0 ? {
        current: null,
    } : _b, _c = _a.closeOnClick, closeOnClick = _c === void 0 ? true : _c;
    var dispatch = useDispatch();
    var tooltip = useSelector(function (state) { return state.appDaten.tooltip; });
    var tooltipOffset = useSelector(function (state) { return state.appDaten.tooltip_offset; });
    var body = document.querySelector('body');
    useEffect(function () {
        if (tooltip.status && trEnv$1.stationaer) {
            var modal = document.querySelector('.modal');
            var height = modal.offsetHeight;
            window.OSPlusNeo.setHeight(height);
        }
    }, [tooltip.status]);
    var handleClose = function () {
        body.classList.remove('modal-open');
        dispatch(updateByName('appDaten.tooltip.status', false));
        if (trEnv$1.stationaer) {
            window.OSPlusNeo.setHeight();
        }
    };
    var handleShow = function () {
        body.classList.add('modal-open');
        if (trEnv$1.sparkasse && tooltipOffset != null) {
            var margin = tooltipOffset - 120;
            var modalDialog = document.querySelector('.modal-dialog-centered');
            if (modalDialog) {
                modalDialog.setAttribute('style', "margin-top: ".concat(margin, "px"));
            }
        }
    };
    return (jsxs(Modal$1, { dialogClassName: "tooltip-dialog", show: tooltip.status, onHide: handleClose, onClick: closeOnClick ? handleClose : null, onShow: handleShow, container: container.current, centered: true, animation: false, size: tooltip.size, children: [jsx$1(Modal$1.Body, { dangerouslySetInnerHTML: { __html: tooltip.text } }), jsx$1(Modal$1.Footer, { children: jsx$1(Button$1, { variant: "primary", onClick: handleClose, "data-tracking-name": "close-tooltip-modal", children: "OK" }) })] }));
};

var Anchor = styled.a(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  text-decoration: none;\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  text-decoration: none;\n  &:hover {\n    text-decoration: underline;\n  }\n"])));
var ArrowBefore = styled(SvgArrow)(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  border: 1px solid grey;\n  border-radius: 30px;\n  margin-right: 5px;\n  &:hover {\n  background: grey;\n    color: white;\n  }\n"], ["\n  border: 1px solid grey;\n  border-radius: 30px;\n  margin-right: 5px;\n  &:hover {\n  background: grey;\n    color: white;\n  }\n"])));
var Links = styled.div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  a {\n    text-decoration: none !important;\n  }\n  .links__arrow {\n    border: 1px solid grey;\n    border-radius: 30px;\n    margin-right: 5px;\n  }\n  &:hover {\n    .links__arrow {\n      background: grey;\n      color: white;\n    }\n    a {\n      text-decoration: underline !important;\n    }\n  }\n"], ["\n  a {\n    text-decoration: none !important;\n  }\n  .links__arrow {\n    border: 1px solid grey;\n    border-radius: 30px;\n    margin-right: 5px;\n  }\n  &:hover {\n    .links__arrow {\n      background: grey;\n      color: white;\n    }\n    a {\n      text-decoration: underline !important;\n    }\n  }\n"])));
var IfilialePartnerDatenschutz = function (_a) {
    var _b = _a.show, show = _b === void 0 ? trEnv$1.ifiliale : _b;
    return show && (jsxs("div", { className: "mt-4", children: [jsxs(Links, { className: "mb-3", children: [jsx$1(ArrowBefore, { className: "links__arrow" }), jsx$1(Anchor, { href: i18next.t('footer.vertragspartner'), target: "_blank", rel: "noopener noreferrer", children: i18next.t('footer.vertragspartnerText') })] }), jsxs(Links, { children: [jsx$1(ArrowBefore, { className: "links__arrow" }), jsx$1(Anchor, { href: i18next.t('footer.datenschutz'), target: "_blank", rel: "noopener noreferrer", children: i18next.t('footer.datenschutzText') })] })] }));
};
var templateObject_1$g, templateObject_2$4, templateObject_3$1;

var StyledButton = styled(Button$1)(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  &:after{\n    content: '';\n    width: 8px;\n    height: 8px;\n    display: inline-block;\n    border: solid currentColor;\n    border-width: 0 1px 1px 0;\n    transform: rotate(-45deg);\n    margin-right: 5px;\n    position: relative;\n    top: 0;\n    left: 0;\n  }\n"], ["\n  &:after{\n    content: '';\n    width: 8px;\n    height: 8px;\n    display: inline-block;\n    border: solid currentColor;\n    border-width: 0 1px 1px 0;\n    transform: rotate(-45deg);\n    margin-right: 5px;\n    position: relative;\n    top: 0;\n    left: 0;\n  }\n"])));
var TextLinkButton = function (_a) {
    var _b = _a.goToLink, goToLink = _b === void 0 ? null : _b, text = _a.text, linkTo = _a.linkTo, _c = _a.size, size = _c === void 0 ? 'sm' : _c;
    if (!goToLink) {
        return null;
    }
    return (jsx$1(StyledButton, { variant: "link", size: size, onClick: function () { return goToLink(linkTo); }, children: text }));
};
var TextLinkButton$1 = React__default.memo(TextLinkButton);
var templateObject_1$f;

var Img = styled.img(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  height: 120px;\n  @media (max-width: 450px) {\n    height: 80px;\n  }\n"], ["\n  height: 120px;\n  @media (max-width: 450px) {\n    height: 80px;\n  }\n"])));
var Additional = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  img + img {\n    margin-left: 1rem;\n  }\n  @media (max-width: 450px) {\n    img + img {\n      margin-left: 0.5rem;\n    }\n  }\n"], ["\n  img + img {\n    margin-left: 1rem;\n  }\n  @media (max-width: 450px) {\n    img + img {\n      margin-left: 0.5rem;\n    }\n  }\n"])));
var Siegel = function () {
    if (trEnv$1.stationaer || !i18next.exists('siegel')) {
        return null;
    }
    var siegelLinks = i18next.t('siegel', { returnObjects: true });
    return siegelLinks.length > 0
        && (jsxs(Additional, { className: "mt-5", children: [jsx$1("h4", { children: "Ausgezeichneter Schutz" }), siegelLinks
                    .map(function (siegel) { return (jsx$1(Img, { className: "footer-siegel", src: siegel, alt: "Siegel" }, siegel)); })] }));
};
var index$3 = React__default.memo(Siegel);
var templateObject_1$e, templateObject_2$3;

var Headline = function (_a) {
    var _b = _a.as, as = _b === void 0 ? 'h2' : _b, _c = _a.variant, variant = _c === void 0 ? 'h4' : _c, _d = _a.children, children = _d === void 0 ? null : _d, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.headlineClassName, headlineClassName = _f === void 0 ? '' : _f;
    var As = as;
    return (jsx$1(Row, { className: className, children: jsx$1(Col, { children: jsx$1(As, { className: "".concat(variant, " headline ").concat(headlineClassName), children: children }) }) }));
};
var Headline$1 = React__default.memo(Headline);

var PflichtfelderWrapper = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  font-size: 1rem;\n"], ["\n  font-size: 1rem;\n"])));
var Pflichtfelder = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return (jsx$1(PflichtfelderWrapper, { className: className, children: "* Sternchen = Pflichtfelder" }));
};
var templateObject_1$d;

var svg = {
    height: 'auto',
    width: '80px',
};
var SepaLogo = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return (jsxs("div", { className: "sp-bg-white mt-5 sp-mt-0 ".concat(className), children: [jsx$1("div", { className: "h5 mb-2", children: "Zahlen Sie bequem per Lastschrift" }), jsx$1(SvgSepaLogo, { style: svg })] }));
};
var index$2 = React__default.memo(SepaLogo);

var Label = function (_a) {
    var title = _a.title, label = _a.label, tooltip = _a.tooltip, subtitle = _a.subtitle, _b = _a.labelClassName, labelClassName = _b === void 0 ? '' : _b, overlay = _a.overlay, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.tooltipRight, tooltipRight = _d === void 0 ? false : _d, _e = _a.subtitleClassName, subtitleClassName = _e === void 0 ? '' : _e, _f = _a.labelDangerouslySetHTML, labelDangerouslySetHTML = _f === void 0 ? false : _f, formLabelAs = _a.formLabelAs, name = _a.name;
    var hasLabel = title || label;
    var tooltipId = "tooltip-".concat(name);
    return ((hasLabel || tooltip || subtitle)
        && (jsxs(Form.Label, { className: labelClassName, as: formLabelAs, children: [labelDangerouslySetHTML
                    ? jsx$1("span", { dangerouslySetInnerHTML: { __html: hasLabel } })
                    : hasLabel, required && '*', (hasLabel) && tooltip && !tooltipRight && (jsx$1(Nowrap, { children: jsx$1(Tooltip, { overlay: overlay, handleTooltip: tooltip, id: tooltipId }) })), subtitle && (jsxs("p", { className: "form-subtitle ".concat(subtitleClassName), children: [subtitle, !title && !label && tooltip && (jsx$1(Nowrap, { children: jsx$1(Tooltip, { overlay: overlay, handleTooltip: tooltip, id: tooltipId }) }))] }))] })));
};

var FormWrapper = function (_a) {
    var label = _a.label, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.labelClassName, labelClassName = _e === void 0 ? '' : _e, _f = _a.messageClassName, messageClassName = _f === void 0 ? '' : _f, _g = _a.errorClassName, errorClassName = _g === void 0 ? '' : _g, _h = _a.hintClassName, hintClassName = _h === void 0 ? '' : _h, tooltip = _a.tooltip, error = _a.error, message = _a.message, hint = _a.hint, subtitle = _a.subtitle, required = _a.required, _j = _a.children, children = _j === void 0 ? null : _j, overlay = _a.overlay, tooltipRight = _a.tooltipRight, _k = _a.messageOptions, messageOptions = _k === void 0 ? {
        dismissible: true,
        dangerouslySetHTML: true,
        onAfterClose: function () { },
        className: '',
        messageVariant: 'gray',
    } : _k, hintDangerouslySetHTML = _a.hintDangerouslySetHTML, _l = _a.showErrorMessage, showErrorMessage = _l === void 0 ? true : _l, _m = _a.subtitleClassName, subtitleClassName = _m === void 0 ? '' : _m, messageVariant = _a.messageVariant, labelDangerouslySetHTML = _a.labelDangerouslySetHTML, formGroupAs = _a.formGroupAs, ariaDescribedBy = _a.ariaDescribedBy;
    var errorText = Array.isArray(error) ? error.join(' ') : error;
    return (jsxs(Form.Group, { controlId: formGroupAs === 'fieldset' ? undefined : name, className: "form-group ".concat(required ? 'required' : '', " ").concat(className), as: formGroupAs, "aria-describedby": ariaDescribedBy, children: [jsx$1(Label, { label: label, title: title, name: name, labelClassName: labelClassName, tooltip: tooltip, tooltipRight: tooltipRight, overlay: overlay, subtitle: subtitle, required: required, subtitleClassName: subtitleClassName, labelDangerouslySetHTML: labelDangerouslySetHTML, formLabelAs: (formGroupAs === 'fieldset' ? 'legend' : 'label') }), children, hint && (hintDangerouslySetHTML
                ? jsx$1(Form.Text, { as: "p", id: "hint.".concat(name), className: hintClassName, dangerouslySetInnerHTML: { __html: hint } })
                : jsx$1(Form.Text, { as: "p", id: "hint.".concat(name), className: hintClassName, children: hint })), (error && showErrorMessage) && React__default.isValidElement(error) && (jsx$1(Form.Control.Feedback, { as: "p", type: "invalid", className: "".concat(errorClassName), id: "error.".concat(name), children: errorText })), (error && showErrorMessage) && !React__default.isValidElement(error) && (jsx$1(Form.Control.Feedback, { as: "p", type: "invalid", className: "".concat(errorClassName), id: "error.".concat(name), dangerouslySetInnerHTML: { __html: errorText } })), message && (jsx$1(Message$1, { show: true, dismissible: messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.dismissible, dangerouslySetHTML: messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.dangerouslySetHTML, onAfterClose: messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.onAfterClose, className: messageClassName || (messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.className), variant: messageVariant || (messageOptions === null || messageOptions === void 0 ? void 0 : messageOptions.messageVariant), text: message, id: "message.".concat(name) }))] }));
};
var FormWrapper$1 = React__default.memo(FormWrapper);

var FormInput = function (props) {
    var value = props.value, name = props.name, onChange = props.onChange, onBlur = props.onBlur, ueberschreibbar = props.ueberschreibbar, _a = props.inputClassName, inputClassName = _a === void 0 ? '' : _a, maxLenght = props.maxLenght, placeholder = props.placeholder, error = props.error, _b = props.validation, validation = _b === void 0 ? true : _b, _c = props.userChanged, userChanged = _c === void 0 ? false : _c, _d = props.autocomplete, autocomplete = _d === void 0 ? '' : _d, _e = props.type, type = _e === void 0 ? 'text' : _e, _f = props.autoFocus, autoFocus = _f === void 0 ? false : _f, subtitle = props.subtitle, hint = props.hint, message = props.message, muss = props.muss;
    return (jsx$1(FormWrapper$1, __assign$1({}, props, { children: jsx$1(Form.Control, { value: value, name: name, onChange: onChange, onBlur: onBlur, disabled: !ueberschreibbar, className: inputClassName, maxLength: maxLenght, placeholder: placeholder, isInvalid: Array.isArray(error), isValid: validation && ((!error && userChanged && value !== '') || (!error && value !== '')), autoComplete: autocomplete, type: type, autoFocus: autoFocus, "aria-describedby": inputGenerateDescribedBy(name, subtitle, hint, error, message), required: muss }) })));
};

var InputGroupWrapper = function (_a) {
    var inputGroup = _a.inputGroup, _b = _a.className, className = _b === void 0 ? '' : _b, id = _a.id, children = _a.children;
    var isStringInputGroup = typeof inputGroup === 'string';
    var addonId = (id && isStringInputGroup) ? "addon.".concat(id) : undefined;
    return (inputGroup ? (jsxs(InputGroup, { className: className, as: "div", children: [React__default.cloneElement(children, { 'aria-describedby': "".concat(addonId || '', " ").concat(children.props['aria-describedby'] || '') }), isStringInputGroup ? (jsx$1(InputGroup.Text, { id: addonId, children: inputGroup })) : inputGroup] })) : children);
};

var FormMask = function (props) {
    var error = props.error, _a = props.validation, validation = _a === void 0 ? true : _a, userChanged = props.userChanged, _b = props.value, value = _b === void 0 ? '' : _b, formGroupAs = props.formGroupAs, inputGroup = props.inputGroup, name = props.name, onChange = props.onChange, onKeyDown = props.onKeyDown, onBlur = props.onBlur, ueberschreibbar = props.ueberschreibbar, _c = props.inputClassName, inputClassName = _c === void 0 ? '' : _c, _d = props.type, type = _d === void 0 ? 'text' : _d, placeholder = props.placeholder, autocomplete = props.autocomplete, inputmask = props.inputmask, _e = props.inputMode, inputMode = _e === void 0 ? 'numeric' : _e;
    var isInvalid = error ? 'is-invalid' : '';
    var isValid = validation && ((!error && userChanged && value != '') || (!error && value != '')) ? 'is-valid' : '';
    return (jsx$1(FormWrapper$1, __assign$1({ formGroupAs: formGroupAs }, props, { children: jsx$1(InputGroupWrapper, { inputGroup: inputGroup, id: name, children: jsx$1(InputMask, __assign$1({ name: name, onChange: onChange, onKeyDown: onKeyDown, onBlur: onBlur, value: value.toString(), id: name, disabled: !ueberschreibbar, className: "form-control ".concat(isInvalid, " ").concat(isValid, " ").concat(inputClassName), type: type, placeholder: placeholder, autoComplete: autocomplete, inputMode: inputMode }, inputmask)) }) })));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Escape regex char
 *
 * See: https://stackoverflow.com/questions/17885855/use-dynamic-variable-string-as-regex-pattern-in-javascript
 */
var escapeRegExp = function (stringToGoIntoTheRegex) {
    return stringToGoIntoTheRegex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
};

var abbrMap = { k: 1000, m: 1000000, b: 1000000000 };
/**
 * Parse a value with abbreviation e.g 1k = 1000
 */
var parseAbbrValue = function (value, decimalSeparator) {
    if (decimalSeparator === void 0) { decimalSeparator = '.'; }
    var reg = new RegExp("(\\d+(".concat(escapeRegExp(decimalSeparator), "\\d*)?)([kmb])$"), 'i');
    var match = value.match(reg);
    if (match) {
        var digits = match[1], abbr = match[3];
        var multiplier = abbrMap[abbr.toLowerCase()];
        return Number(digits.replace(decimalSeparator, '.')) * multiplier;
    }
    return undefined;
};

/**
 * Remove group separator from value eg. 1,000 > 1000
 */
var removeSeparators = function (value, separator) {
    if (separator === void 0) { separator = ','; }
    var reg = new RegExp(escapeRegExp(separator), 'g');
    return value.replace(reg, '');
};

/**
 * Remove invalid characters
 */
var removeInvalidChars = function (value, validChars) {
    var chars = escapeRegExp(validChars.join(''));
    var reg = new RegExp("[^\\d".concat(chars, "]"), 'gi');
    return value.replace(reg, '');
};

/**
 * Remove prefix, separators and extra decimals from value
 */
var cleanValue$1 = function (_a) {
    var value = _a.value, _b = _a.groupSeparator, groupSeparator = _b === void 0 ? ',' : _b, _c = _a.decimalSeparator, decimalSeparator = _c === void 0 ? '.' : _c, _d = _a.allowDecimals, allowDecimals = _d === void 0 ? true : _d, _e = _a.decimalsLimit, decimalsLimit = _e === void 0 ? 2 : _e, _f = _a.allowNegativeValue, allowNegativeValue = _f === void 0 ? true : _f, _g = _a.disableAbbreviations, disableAbbreviations = _g === void 0 ? false : _g, _h = _a.prefix, prefix = _h === void 0 ? '' : _h, _j = _a.transformRawValue, transformRawValue = _j === void 0 ? function (rawValue) { return rawValue; } : _j;
    var transformedValue = transformRawValue(value);
    if (transformedValue === '-') {
        return transformedValue;
    }
    var abbreviations = disableAbbreviations ? [] : ['k', 'm', 'b'];
    var reg = new RegExp("((^|\\D)-\\d)|(-".concat(escapeRegExp(prefix), ")"));
    var isNegative = reg.test(transformedValue);
    // Is there a digit before the prefix? eg. 1$
    var _k = RegExp("(\\d+)-?".concat(escapeRegExp(prefix))).exec(value) || [], prefixWithValue = _k[0], preValue = _k[1];
    var withoutPrefix = prefix
        ? prefixWithValue
            ? transformedValue.replace(prefixWithValue, '').concat(preValue)
            : transformedValue.replace(prefix, '')
        : transformedValue;
    var withoutSeparators = removeSeparators(withoutPrefix, groupSeparator);
    var withoutInvalidChars = removeInvalidChars(withoutSeparators, __spreadArray([
        groupSeparator,
        decimalSeparator
    ], abbreviations, true));
    var valueOnly = withoutInvalidChars;
    if (!disableAbbreviations) {
        // disallow letter without number
        if (abbreviations.some(function (letter) { return letter === withoutInvalidChars.toLowerCase().replace(decimalSeparator, ''); })) {
            return '';
        }
        var parsed = parseAbbrValue(withoutInvalidChars, decimalSeparator);
        if (parsed) {
            valueOnly = String(parsed);
        }
    }
    var includeNegative = isNegative && allowNegativeValue ? '-' : '';
    if (decimalSeparator && valueOnly.includes(decimalSeparator)) {
        var _l = withoutInvalidChars.split(decimalSeparator), int = _l[0], decimals = _l[1];
        var trimmedDecimals = decimalsLimit && decimals ? decimals.slice(0, decimalsLimit) : decimals;
        var includeDecimals = allowDecimals ? "".concat(decimalSeparator).concat(trimmedDecimals) : '';
        return "".concat(includeNegative).concat(int).concat(includeDecimals);
    }
    return "".concat(includeNegative).concat(valueOnly);
};

var fixedDecimalValue = function (value, decimalSeparator, fixedDecimalLength) {
    if (fixedDecimalLength !== undefined && value.length > 1) {
        if (fixedDecimalLength === 0) {
            return value.replace(decimalSeparator, '');
        }
        if (value.includes(decimalSeparator)) {
            var _a = value.split(decimalSeparator), int = _a[0], decimals = _a[1];
            if (decimals.length === fixedDecimalLength) {
                return value;
            }
            if (decimals.length > fixedDecimalLength) {
                return "".concat(int).concat(decimalSeparator).concat(decimals.slice(0, fixedDecimalLength));
            }
        }
        var reg = value.length > fixedDecimalLength
            ? new RegExp("(\\d+)(\\d{".concat(fixedDecimalLength, "})"))
            : new RegExp("(\\d)(\\d+)");
        var match = value.match(reg);
        if (match) {
            var int = match[1], decimals = match[2];
            return "".concat(int).concat(decimalSeparator).concat(decimals);
        }
    }
    return value;
};

var getSuffix = function (value, _a) {
    var _b = _a.groupSeparator, groupSeparator = _b === void 0 ? ',' : _b, _c = _a.decimalSeparator, decimalSeparator = _c === void 0 ? '.' : _c;
    var suffixReg = new RegExp("\\d([^".concat(escapeRegExp(groupSeparator)).concat(escapeRegExp(decimalSeparator), "0-9]+)"));
    var suffixMatch = value.match(suffixReg);
    return suffixMatch ? suffixMatch[1] : undefined;
};

/**
 * Format value with decimal separator, group separator and prefix
 */
var formatValue = function (options) {
    var _value = options.value, decimalSeparator = options.decimalSeparator, intlConfig = options.intlConfig, decimalScale = options.decimalScale, _a = options.prefix, prefix = _a === void 0 ? '' : _a, _b = options.suffix, suffix = _b === void 0 ? '' : _b;
    if (_value === '' || _value === undefined) {
        return '';
    }
    if (_value === '-') {
        return '-';
    }
    var isNegative = new RegExp("^\\d?-".concat(prefix ? "".concat(escapeRegExp(prefix), "?") : '', "\\d")).test(_value);
    var value = decimalSeparator !== '.'
        ? replaceDecimalSeparator(_value, decimalSeparator, isNegative)
        : _value;
    if (decimalSeparator && decimalSeparator !== '-' && value.startsWith(decimalSeparator)) {
        value = '0' + value;
    }
    var defaultNumberFormatOptions = {
        minimumFractionDigits: decimalScale || 0,
        maximumFractionDigits: 20,
    };
    var numberFormatter = intlConfig
        ? new Intl.NumberFormat(intlConfig.locale, intlConfig.currency
            ? __assign(__assign({}, defaultNumberFormatOptions), { style: 'currency', currency: intlConfig.currency }) : defaultNumberFormatOptions)
        : new Intl.NumberFormat(undefined, defaultNumberFormatOptions);
    var parts = numberFormatter.formatToParts(Number(value));
    var formatted = replaceParts(parts, options);
    // Does intl formatting add a suffix?
    var intlSuffix = getSuffix(formatted, __assign({}, options));
    // Include decimal separator if user input ends with decimal separator
    var includeDecimalSeparator = _value.slice(-1) === decimalSeparator ? decimalSeparator : '';
    var _c = value.match(RegExp('\\d+\\.(\\d+)')) || [], decimals = _c[1];
    // Keep original decimal padding if no decimalScale
    if (decimalScale === undefined && decimals && decimalSeparator) {
        if (formatted.includes(decimalSeparator)) {
            formatted = formatted.replace(RegExp("(\\d+)(".concat(escapeRegExp(decimalSeparator), ")(\\d+)"), 'g'), "$1$2".concat(decimals));
        }
        else {
            if (intlSuffix && !suffix) {
                formatted = formatted.replace(intlSuffix, "".concat(decimalSeparator).concat(decimals).concat(intlSuffix));
            }
            else {
                formatted = "".concat(formatted).concat(decimalSeparator).concat(decimals);
            }
        }
    }
    if (suffix && includeDecimalSeparator) {
        return "".concat(formatted).concat(includeDecimalSeparator).concat(suffix);
    }
    if (intlSuffix && includeDecimalSeparator) {
        return formatted.replace(intlSuffix, "".concat(includeDecimalSeparator).concat(intlSuffix));
    }
    if (intlSuffix && suffix) {
        return formatted.replace(intlSuffix, "".concat(includeDecimalSeparator).concat(suffix));
    }
    return [formatted, includeDecimalSeparator, suffix].join('');
};
/**
 * Before converting to Number, decimal separator has to be .
 */
var replaceDecimalSeparator = function (value, decimalSeparator, isNegative) {
    var newValue = value;
    if (decimalSeparator && decimalSeparator !== '.') {
        newValue = newValue.replace(RegExp(escapeRegExp(decimalSeparator), 'g'), '.');
        if (isNegative && decimalSeparator === '-') {
            newValue = "-".concat(newValue.slice(1));
        }
    }
    return newValue;
};
var replaceParts = function (parts, _a) {
    var prefix = _a.prefix, groupSeparator = _a.groupSeparator, decimalSeparator = _a.decimalSeparator, decimalScale = _a.decimalScale, _b = _a.disableGroupSeparators, disableGroupSeparators = _b === void 0 ? false : _b;
    return parts
        .reduce(function (prev, _a, i) {
        var type = _a.type, value = _a.value;
        if (i === 0 && prefix) {
            if (type === 'minusSign') {
                return [value, prefix];
            }
            if (type === 'currency') {
                return __spreadArray(__spreadArray([], prev, true), [prefix], false);
            }
            return [prefix, value];
        }
        if (type === 'currency') {
            return prefix ? prev : __spreadArray(__spreadArray([], prev, true), [value], false);
        }
        if (type === 'group') {
            return !disableGroupSeparators
                ? __spreadArray(__spreadArray([], prev, true), [groupSeparator !== undefined ? groupSeparator : value], false) : prev;
        }
        if (type === 'decimal') {
            if (decimalScale !== undefined && decimalScale === 0) {
                return prev;
            }
            return __spreadArray(__spreadArray([], prev, true), [decimalSeparator !== undefined ? decimalSeparator : value], false);
        }
        if (type === 'fraction') {
            return __spreadArray(__spreadArray([], prev, true), [decimalScale !== undefined ? value.slice(0, decimalScale) : value], false);
        }
        return __spreadArray(__spreadArray([], prev, true), [value], false);
    }, [''])
        .join('');
};

var defaultConfig = {
    currencySymbol: '',
    groupSeparator: '',
    decimalSeparator: '',
    prefix: '',
    suffix: '',
};
/**
 * Get locale config from input or default
 */
var getLocaleConfig = function (intlConfig) {
    var _a = intlConfig || {}, locale = _a.locale, currency = _a.currency;
    var numberFormatter = locale
        ? new Intl.NumberFormat(locale, currency ? { currency: currency, style: 'currency' } : undefined)
        : new Intl.NumberFormat();
    return numberFormatter.formatToParts(1000.1).reduce(function (prev, curr, i) {
        if (curr.type === 'currency') {
            if (i === 0) {
                return __assign(__assign({}, prev), { currencySymbol: curr.value, prefix: curr.value });
            }
            else {
                return __assign(__assign({}, prev), { currencySymbol: curr.value, suffix: curr.value });
            }
        }
        if (curr.type === 'group') {
            return __assign(__assign({}, prev), { groupSeparator: curr.value });
        }
        if (curr.type === 'decimal') {
            return __assign(__assign({}, prev), { decimalSeparator: curr.value });
        }
        return prev;
    }, defaultConfig);
};

var isNumber = function (input) { return RegExp(/\d/, 'gi').test(input); };

var padTrimValue = function (value, decimalSeparator, decimalScale) {
    if (decimalSeparator === void 0) { decimalSeparator = '.'; }
    if (decimalScale === undefined || value === '' || value === undefined) {
        return value;
    }
    if (!value.match(/\d/g)) {
        return '';
    }
    var _a = value.split(decimalSeparator), int = _a[0], decimals = _a[1];
    if (decimalScale === 0) {
        return int;
    }
    var newValue = decimals || '';
    if (newValue.length < decimalScale) {
        while (newValue.length < decimalScale) {
            newValue += '0';
        }
    }
    else {
        newValue = newValue.slice(0, decimalScale);
    }
    return "".concat(int).concat(decimalSeparator).concat(newValue);
};

/**
 * Based on the last key stroke and the cursor position, update the value
 * and reposition the cursor to the right place
 */
var repositionCursor = function (_a) {
    var selectionStart = _a.selectionStart, value = _a.value, lastKeyStroke = _a.lastKeyStroke, stateValue = _a.stateValue, groupSeparator = _a.groupSeparator;
    var cursorPosition = selectionStart;
    var modifiedValue = value;
    if (stateValue && cursorPosition) {
        var splitValue = value.split('');
        // if cursor is to right of groupSeparator and backspace pressed, delete the character to the left of the separator and reposition the cursor
        if (lastKeyStroke === 'Backspace' && stateValue[cursorPosition] === groupSeparator) {
            splitValue.splice(cursorPosition - 1, 1);
            cursorPosition -= 1;
        }
        // if cursor is to left of groupSeparator and delete pressed, delete the character to the right of the separator and reposition the cursor
        if (lastKeyStroke === 'Delete' && stateValue[cursorPosition] === groupSeparator) {
            splitValue.splice(cursorPosition, 1);
            cursorPosition += 1;
        }
        modifiedValue = splitValue.join('');
        return { modifiedValue: modifiedValue, cursorPosition: cursorPosition };
    }
    return { modifiedValue: modifiedValue, cursorPosition: selectionStart };
};

var CurrencyInput = forwardRef(function (_a, ref) {
    var _b = _a.allowDecimals, allowDecimals = _b === void 0 ? true : _b, _c = _a.allowNegativeValue, allowNegativeValue = _c === void 0 ? true : _c, id = _a.id, name = _a.name, className = _a.className, customInput = _a.customInput, decimalsLimit = _a.decimalsLimit, defaultValue = _a.defaultValue, _d = _a.disabled, disabled = _d === void 0 ? false : _d, userMaxLength = _a.maxLength, userValue = _a.value, onValueChange = _a.onValueChange, fixedDecimalLength = _a.fixedDecimalLength, placeholder = _a.placeholder, decimalScale = _a.decimalScale, prefix = _a.prefix, suffix = _a.suffix, intlConfig = _a.intlConfig, step = _a.step, min = _a.min, max = _a.max, _e = _a.disableGroupSeparators, disableGroupSeparators = _e === void 0 ? false : _e, _f = _a.disableAbbreviations, disableAbbreviations = _f === void 0 ? false : _f, _decimalSeparator = _a.decimalSeparator, _groupSeparator = _a.groupSeparator, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, transformRawValue = _a.transformRawValue, _g = _a.formatValueOnBlur, formatValueOnBlur = _g === void 0 ? true : _g, props = __rest(_a, ["allowDecimals", "allowNegativeValue", "id", "name", "className", "customInput", "decimalsLimit", "defaultValue", "disabled", "maxLength", "value", "onValueChange", "fixedDecimalLength", "placeholder", "decimalScale", "prefix", "suffix", "intlConfig", "step", "min", "max", "disableGroupSeparators", "disableAbbreviations", "decimalSeparator", "groupSeparator", "onChange", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "transformRawValue", "formatValueOnBlur"]);
    if (_decimalSeparator && isNumber(_decimalSeparator)) {
        throw new Error('decimalSeparator cannot be a number');
    }
    if (_groupSeparator && isNumber(_groupSeparator)) {
        throw new Error('groupSeparator cannot be a number');
    }
    var localeConfig = useMemo(function () { return getLocaleConfig(intlConfig); }, [intlConfig]);
    var decimalSeparator = _decimalSeparator || localeConfig.decimalSeparator || '';
    var groupSeparator = _groupSeparator || localeConfig.groupSeparator || '';
    if (decimalSeparator &&
        groupSeparator &&
        decimalSeparator === groupSeparator &&
        disableGroupSeparators === false) {
        throw new Error('decimalSeparator cannot be the same as groupSeparator');
    }
    var formatValueOptions = {
        decimalSeparator: decimalSeparator,
        groupSeparator: groupSeparator,
        disableGroupSeparators: disableGroupSeparators,
        intlConfig: intlConfig,
        prefix: prefix || localeConfig.prefix,
        suffix: suffix,
    };
    var cleanValueOptions = {
        decimalSeparator: decimalSeparator,
        groupSeparator: groupSeparator,
        allowDecimals: allowDecimals,
        decimalsLimit: decimalsLimit || fixedDecimalLength || 2,
        allowNegativeValue: allowNegativeValue,
        disableAbbreviations: disableAbbreviations,
        prefix: prefix || localeConfig.prefix,
        transformRawValue: transformRawValue,
    };
    var _h = useState(function () {
        return defaultValue != null
            ? formatValue(__assign(__assign({}, formatValueOptions), { decimalScale: decimalScale, value: String(defaultValue) }))
            : userValue != null
                ? formatValue(__assign(__assign({}, formatValueOptions), { decimalScale: decimalScale, value: String(userValue) }))
                : '';
    }), stateValue = _h[0], setStateValue = _h[1];
    var _j = useState(false), dirty = _j[0], setDirty = _j[1];
    var _k = useState(0), cursor = _k[0], setCursor = _k[1];
    var _l = useState(0), changeCount = _l[0], setChangeCount = _l[1];
    var _m = useState(null), lastKeyStroke = _m[0], setLastKeyStroke = _m[1];
    var inputRef = useRef(null);
    useImperativeHandle(ref, function () { return inputRef.current; });
    /**
     * Process change in value
     */
    var processChange = function (value, selectionStart) {
        setDirty(true);
        var _a = repositionCursor({
            selectionStart: selectionStart,
            value: value,
            lastKeyStroke: lastKeyStroke,
            stateValue: stateValue,
            groupSeparator: groupSeparator,
        }), modifiedValue = _a.modifiedValue, cursorPosition = _a.cursorPosition;
        var stringValue = cleanValue$1(__assign({ value: modifiedValue }, cleanValueOptions));
        if (userMaxLength && stringValue.replace(/-/g, '').length > userMaxLength) {
            return;
        }
        if (stringValue === '' || stringValue === '-' || stringValue === decimalSeparator) {
            onValueChange && onValueChange(undefined, name, { float: null, formatted: '', value: '' });
            setStateValue(stringValue);
            // Always sets cursor after '-' or decimalSeparator input
            setCursor(1);
            return;
        }
        var stringValueWithoutSeparator = decimalSeparator
            ? stringValue.replace(decimalSeparator, '.')
            : stringValue;
        var numberValue = parseFloat(stringValueWithoutSeparator);
        var formattedValue = formatValue(__assign({ value: stringValue }, formatValueOptions));
        if (cursorPosition != null) {
            // Prevent cursor jumping
            var newCursor = cursorPosition + (formattedValue.length - value.length);
            newCursor = newCursor <= 0 ? (prefix ? prefix.length : 0) : newCursor;
            setCursor(newCursor);
            setChangeCount(changeCount + 1);
        }
        setStateValue(formattedValue);
        if (onValueChange) {
            var values = {
                float: numberValue,
                formatted: formattedValue,
                value: stringValue,
            };
            onValueChange(stringValue, name, values);
        }
    };
    /**
     * Handle change event
     */
    var handleOnChange = function (event) {
        var _a = event.target, value = _a.value, selectionStart = _a.selectionStart;
        processChange(value, selectionStart);
        onChange && onChange(event);
    };
    /**
     * Handle focus event
     */
    var handleOnFocus = function (event) {
        onFocus && onFocus(event);
        return stateValue ? stateValue.length : 0;
    };
    /**
     * Handle blur event
     *
     * Format value by padding/trimming decimals if required by
     */
    var handleOnBlur = function (event) {
        var value = event.target.value;
        var valueOnly = cleanValue$1(__assign({ value: value }, cleanValueOptions));
        if (valueOnly === '-' || valueOnly === decimalSeparator || !valueOnly) {
            setStateValue('');
            onBlur && onBlur(event);
            return;
        }
        var fixedDecimals = fixedDecimalValue(valueOnly, decimalSeparator, fixedDecimalLength);
        var newValue = padTrimValue(fixedDecimals, decimalSeparator, decimalScale !== undefined ? decimalScale : fixedDecimalLength);
        var numberValue = parseFloat(newValue.replace(decimalSeparator, '.'));
        var formattedValue = formatValue(__assign(__assign({}, formatValueOptions), { value: newValue }));
        if (onValueChange && formatValueOnBlur) {
            onValueChange(newValue, name, {
                float: numberValue,
                formatted: formattedValue,
                value: newValue,
            });
        }
        setStateValue(formattedValue);
        onBlur && onBlur(event);
    };
    /**
     * Handle key down event
     *
     * Increase or decrease value by step
     */
    var handleOnKeyDown = function (event) {
        var key = event.key;
        setLastKeyStroke(key);
        if (step && (key === 'ArrowUp' || key === 'ArrowDown')) {
            event.preventDefault();
            setCursor(stateValue.length);
            var currentValue = parseFloat(userValue != null
                ? String(userValue).replace(decimalSeparator, '.')
                : cleanValue$1(__assign({ value: stateValue }, cleanValueOptions))) || 0;
            var newValue = key === 'ArrowUp' ? currentValue + step : currentValue - step;
            if (min !== undefined && newValue < Number(min)) {
                return;
            }
            if (max !== undefined && newValue > Number(max)) {
                return;
            }
            var fixedLength = String(step).includes('.')
                ? Number(String(step).split('.')[1].length)
                : undefined;
            processChange(String(fixedLength ? newValue.toFixed(fixedLength) : newValue).replace('.', decimalSeparator));
        }
        onKeyDown && onKeyDown(event);
    };
    /**
     * Handle key up event
     *
     * Move cursor if there is a suffix to prevent user typing past suffix
     */
    var handleOnKeyUp = function (event) {
        var key = event.key, selectionStart = event.currentTarget.selectionStart;
        if (key !== 'ArrowUp' && key !== 'ArrowDown' && stateValue !== '-') {
            var suffix_1 = getSuffix(stateValue, { groupSeparator: groupSeparator, decimalSeparator: decimalSeparator });
            if (suffix_1 && selectionStart && selectionStart > stateValue.length - suffix_1.length) {
                /* istanbul ignore else */
                if (inputRef.current) {
                    var newCursor = stateValue.length - suffix_1.length;
                    inputRef.current.setSelectionRange(newCursor, newCursor);
                }
            }
        }
        onKeyUp && onKeyUp(event);
    };
    // Update state if userValue changes to undefined
    useEffect(function () {
        if (userValue == null && defaultValue == null) {
            setStateValue('');
        }
    }, [defaultValue, userValue]);
    useEffect(function () {
        // prevent cursor jumping if editing value
        if (dirty &&
            stateValue !== '-' &&
            inputRef.current &&
            document.activeElement === inputRef.current) {
            inputRef.current.setSelectionRange(cursor, cursor);
        }
    }, [stateValue, cursor, inputRef, dirty, changeCount]);
    /**
     * If user has only entered "-" or decimal separator,
     * keep the char to allow them to enter next value
     */
    var getRenderValue = function () {
        if (userValue != null &&
            stateValue !== '-' &&
            (!decimalSeparator || stateValue !== decimalSeparator)) {
            return formatValue(__assign(__assign({}, formatValueOptions), { decimalScale: dirty ? undefined : decimalScale, value: String(userValue) }));
        }
        return stateValue;
    };
    var inputProps = __assign({ type: 'text', inputMode: 'decimal', id: id, name: name, className: className, onChange: handleOnChange, onBlur: handleOnBlur, onFocus: handleOnFocus, onKeyDown: handleOnKeyDown, onKeyUp: handleOnKeyUp, placeholder: placeholder, disabled: disabled, value: getRenderValue(), ref: inputRef }, props);
    if (customInput) {
        var CustomInput = customInput;
        return React__default.createElement(CustomInput, __assign({}, inputProps));
    }
    return React__default.createElement("input", __assign({}, inputProps));
});
CurrencyInput.displayName = 'CurrencyInput';

var FormMoney = function (props) {
    var onChange = props.onChange, error = props.error, value = props.value, placeholder = props.placeholder, name = props.name, onKeyDown = props.onKeyDown, _a = props.inputClassName, inputClassName = _a === void 0 ? '' : _a, onBlur = props.onBlur, ueberschreibbar = props.ueberschreibbar, _b = props.validation, validation = _b === void 0 ? true : _b, _c = props.userChanged, userChanged = _c === void 0 ? false : _c, maxLenght = props.maxLenght, _d = props.decimalsLimit, decimalsLimit = _d === void 0 ? 2 : _d, _e = props.decimalScale, decimalScale = _e === void 0 ? 2 : _e, _f = props.allowDecimals, allowDecimals = _f === void 0 ? true : _f, _g = props.inputMode, inputMode = _g === void 0 ? 'numeric' : _g, inputGroup = props.inputGroup, subtitle = props.subtitle, hint = props.hint, message = props.message, muss = props.muss;
    var isInvalid = error ? 'is-invalid' : '';
    var isValid = validation && ((!error && userChanged && value != '') || (!error && value != '')) ? 'is-valid' : '';
    return (jsx$1(FormWrapper$1, __assign$1({}, props, { children: jsx$1(InputGroupWrapper, { inputGroup: inputGroup, id: name, children: jsx$1(CurrencyInput, { name: name, id: name, className: "form-control ".concat(isInvalid, " ").concat(isValid, " ").concat(inputClassName), decimalsLimit: decimalsLimit, decimalScale: decimalScale, disabled: !ueberschreibbar, placeholder: placeholder, maxLength: maxLenght, onKeyDown: onKeyDown, onBlur: onBlur, onValueChange: function (val, nam) { return onChange(nam, val == null ? '' : val); }, value: value, decimalSeparator: ",", groupSeparator: ".", allowDecimals: allowDecimals, inputMode: inputMode, "aria-describedby": inputGenerateDescribedBy(name, subtitle, hint, error, message), required: muss }) }) })));
};

var FormRadio = function (props) {
    var _a = props.valueSet, valueSet = _a === void 0 ? [] : _a, name = props.name, error = props.error, ueberschreibbar = props.ueberschreibbar, value = props.value, _b = props.inline, inline = _b === void 0 ? false : _b, _c = props.inputClassName, inputClassName = _c === void 0 ? '' : _c, customText = props.customText, _d = props.tooltips, tooltips = _d === void 0 ? {} : _d, checkChild = props.checkChild, onChange = props.onChange, subtitle = props.subtitle, hint = props.hint, message = props.message, muss = props.muss;
    return (jsx$1(FormWrapper$1, __assign$1({ formGroupAs: 'fieldset', ariaDescribedBy: inputGenerateDescribedBy(name, subtitle, hint, error, message) }, props, { children: jsx$1("div", { className: "custom-control-wrapper", children: valueSet.map(function (element) { return (jsxs(Form.Check, { type: "radio", id: "".concat(name, "-").concat(element.id), inline: inline, disabled: !ueberschreibbar, className: "radio ".concat(element.id.toString() === value.toString() ? 'checked' : '', " ").concat(inputClassName), children: [jsx$1(Form.Check.Input, { name: name, onChange: onChange, type: "radio", value: element.id, isInvalid: Array.isArray(error), checked: element.id.toString() === value.toString(), disabled: !ueberschreibbar, required: muss }), jsxs(Form.Check.Label, { children: [jsx$1("span", { dangerouslySetInnerHTML: {
                                    __html: customText ? customText[element.id] : element.bezeichnung,
                                } }), (tooltips === null || tooltips === void 0 ? void 0 : tooltips[element.id]) && jsx$1(Tooltip, { className: "ms-2", handleTooltip: tooltips[element.id] })] }), checkChild && checkChild[element.id]] }, element.id)); }) }) })));
};

var FormCheck = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, rest = __rest$1(_a, ["className"]);
    var rightCB = rest.right ? 'pullcbright' : '';
    var label = rest.title || rest.label;
    delete rest.title;
    delete rest.label;
    return (jsxs(FormWrapper$1, __assign$1({ className: "".concat(className, " ").concat(rest.value ? 'checked ' : '') }, rest, { children: [jsxs(Form.Check, { className: "checkbox ".concat(rest.value ? 'checked ' : '', " ").concat(rightCB, " ").concat(rest.customClass), inline: rest.inline, children: [jsx$1(Form.Check.Input, { type: "checkbox", onChange: rest.onChange, checked: !!rest.value, name: rest.name, id: rest.name, disabled: !rest.ueberschreibbar, isInvalid: Array.isArray(rest.error), className: rest.inputClassName, required: rest.muss }), jsxs(Form.Check.Label, { htmlFor: rest.name, className: rest.labelClassName, children: [label, rest.required && '*', ' ', rest.titleZusatz] })] }), rest.children] })));
};

var FormCheckGroup = function (props) {
    var _a = props.valueSet, valueSet = _a === void 0 ? [] : _a, name = props.name, error = props.error, _b = props.value, value = _b === void 0 ? [] : _b, _c = props.inline, inline = _c === void 0 ? false : _c, _d = props.inputClassName, inputClassName = _d === void 0 ? '' : _d, onChange = props.onChange, _e = props.disabledValues, disabledValues = _e === void 0 ? [] : _e, subtitle = props.subtitle, hint = props.hint, message = props.message;
    return (jsx$1(FormWrapper$1, __assign$1({ formGroupAs: 'fieldset', ariaDescribedBy: inputGenerateDescribedBy(name, subtitle, hint, error, message) }, props, { children: jsx$1("div", { className: "custom-control-wrapper", children: valueSet.map(function (element) { return (jsx$1(Form.Check, { type: "checkbox", name: name, checked: value.some(function (v) { return v.toString() === element.id.toString(); }), disabled: disabledValues.some(function (v) { return v.toString() === element.id.toString(); }), label: element.bezeichnung, onChange: function (_a) {
                    var target = _a.target;
                    var valueList = value.filter(function (elem) { return elem.toString() !== target.value.toString(); });
                    if (target.checked) {
                        valueList.push(target.value);
                    }
                    onChange(target.name, valueList);
                }, value: element.id, id: "".concat(name, "-").concat(element.id), className: "".concat(value.some(function (v) { return v.toString() === element.id.toString(); }) ? 'checked' : '', " ").concat(inputClassName), inline: inline, isInvalid: Array.isArray(error) }, element.id)); }) }) })));
};

var FormRadioGroup = function (_a) {
    var label = _a.label, _b = _a.inline, inline = _b === void 0 ? false : _b, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.value, value = _d === void 0 ? [] : _d, name = _a.name, onChange = _a.onChange, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.inputClassName, inputClassName = _f === void 0 ? '' : _f, ueberschreibbar = _a.ueberschreibbar, _g = _a.valueSet, valueSet = _g === void 0 ? [] : _g, _h = _a.tooltip, tooltip = _h === void 0 ? undefined : _h, error = _a.error, _j = _a.required, required = _j === void 0 ? false : _j, _k = _a.subtitle, subtitle = _k === void 0 ? undefined : _k;
    var tooltipId = (name || '').toLowerCase();
    return (jsxs(Form.Group, { className: "form-group ".concat(required ? 'required' : '', " ").concat(className), as: "fieldset", children: [jsxs(Form.Label, { as: "legend", children: [title || label, required && '*', (title || label) && tooltip && (jsx$1(Nowrap, { children: jsx$1(Tooltip, { handleTooltip: tooltip, id: "tooltip-".concat(tooltipId) }) })), subtitle && (jsxs("p", { className: "form-subtitle", children: [subtitle, !title && !label && tooltip && (jsx$1(Nowrap, { children: jsx$1(Tooltip, { handleTooltip: tooltip, id: "tooltip-".concat(tooltipId) }) }))] }))] }), jsx$1("div", { className: "custom-control-wrapper", children: valueSet.map(function (element) { return (jsx$1(Form.Check, { type: "radio", name: name, checked: value.includes(element.id), label: element.bezeichnung, onChange: function (_a) {
                        var target = _a.target;
                        var valueList = value.filter(function (elem) { return elem.toString() !== target.value.toString(); });
                        if (target.checked) {
                            valueList.push(target.value);
                        }
                        onChange(target.name, valueList);
                    }, value: element.id, id: "".concat(name, "-").concat(element.id), className: inputClassName, disabled: !ueberschreibbar, inline: inline, isInvalid: Array.isArray(error) }, element.id)); }) }), error && (jsx$1(Form.Control.Feedback, { type: "invalid", children: error }))] }));
};

var FormSelect = function (props) {
    var id = props.id, name = props.name, valueSet = props.valueSet, _a = props.reverse, reverse = _a === void 0 ? false : _a, error = props.error, value = props.value, _b = props.dataType, dataType = _b === void 0 ? 'java.lang.Integer' : _b, _c = props.inputParentClass, inputParentClass = _c === void 0 ? '' : _c, _d = props.tooltipRight, tooltipRight = _d === void 0 ? false : _d, placeholder = props.placeholder, _e = props.placeholderDisabled, placeholderDisabled = _e === void 0 ? true : _e, _f = props.firstEmpty, firstEmpty = _f === void 0 ? false : _f, _g = props.inputClassName, inputClassName = _g === void 0 ? '' : _g, _h = props.flex, flex = _h === void 0 ? false : _h, _j = props.tooltip, tooltip = _j === void 0 ? function () { } : _j, ueberschreibbar = props.ueberschreibbar, onChange = props.onChange, onBlur = props.onBlur, subtitle = props.subtitle, hint = props.hint, message = props.message;
    var tooltipId = (id || name || '').toLowerCase();
    if (reverse) {
        valueSet.reverse();
    }
    var isInteger = dataType.includes('Integer');
    var placeholderValue = isInteger ? '-1' : '';
    return (jsx$1(FormWrapper$1, __assign$1({}, props, { children: jsxs("div", { className: flex ? 'd-flex w-100 align-items-center' : inputParentClass, children: [jsxs(Form.Control, { onChange: onChange, onBlur: onBlur, name: name, disabled: !ueberschreibbar, value: value, isInvalid: Array.isArray(error), className: inputClassName, as: "select", "aria-describedby": inputGenerateDescribedBy(name, subtitle, hint, error, message), children: [firstEmpty && jsx$1("option", {}), placeholder && jsx$1("option", { value: placeholderValue, disabled: placeholderDisabled, children: placeholder }), valueSet.map(function (element) { return (jsx$1("option", { value: element.id, children: element.bezeichnung }, element.id)); })] }), tooltipRight && (jsx$1(Tooltip, { handleTooltip: tooltip, id: "tooltip-".concat(tooltipId) }))] }) })));
};

var FormDatePicker = function (props) {
    var _a = props.validation, validation = _a === void 0 ? true : _a, _b = props.error, error = _b === void 0 ? undefined : _b, userChanged = props.userChanged, _c = props.value, value = _c === void 0 ? '' : _c, name = props.name, ueberschreibbar = props.ueberschreibbar, to = props.to, from = props.from, inputmask = props.inputmask, onChange = props.onChange, onInputKeyDown = props.onInputKeyDown, onInputChange = props.onInputChange, onInputBlur = props.onInputBlur, _d = props.inputDateClassName, inputDateClassName = _d === void 0 ? '' : _d, _e = props.inputClassName, inputClassName = _e === void 0 ? '' : _e, disabledDates = props.disabledDates, subtitle = props.subtitle, hint = props.hint, message = props.message;
    var ref = useRef(undefined);
    var isInvalid = error ? 'is-invalid' : '';
    var isValid = validation && ((!error && userChanged && value !== '') || (!error && value !== '')) ? 'is-valid' : '';
    return (jsx$1(FormWrapper$1, __assign$1({}, props, { children: jsx$1(InputGroupWrapper, { className: "input-date-icon ".concat(inputDateClassName), id: name, inputGroup: ueberschreibbar && (jsx$1(DatePicker, __assign$1({ value: value, name: name, ueberschreibbar: ueberschreibbar, onChange: onChange, from: from, to: to }, disabledDates))), children: jsx$1(InputMask, __assign$1({ className: "form-control input-date ".concat(isInvalid, " ").concat(isValid, " ").concat(inputClassName), placeholder: "TT.MM.JJJJ", name: name, onChange: onInputChange, onKeyDown: onInputKeyDown, onBlur: onInputBlur, value: value, onFocus: function () { var _a; return (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.select(); }, id: name, disabled: !ueberschreibbar, type: "text", inputMode: "numeric", "aria-describedby": inputGenerateDescribedBy(name, subtitle, hint, error, message) }, inputmask)) }) })));
};

var FormSlider = function (props) {
    var inputGroup = props.inputGroup, name = props.name, value = props.value, _a = props.valueSet, valueSet = _a === void 0 ? [] : _a, onChange = props.onChange, ueberschreibbar = props.ueberschreibbar, showMarks = props.showMarks, showFirstLastMarks = props.showFirstLastMarks, addMarkLabel = props.addMarkLabel, tooltipText = props.tooltipText, _b = props.sliderClassName, sliderClassName = _b === void 0 ? '' : _b, showFirstLastDots = props.showFirstLastDots, showDots = props.showDots, marks = props.marks, generateMarks = props.generateMarks, _c = props.slider, slider = _c === void 0 ? null : _c, addToTooltip = props.addToTooltip, icon = props.icon, subtitle = props.subtitle, hint = props.hint, error = props.error, message = props.message, minSelectedValue = props.minSelectedValue, tooltipStyle = props.tooltipStyle;
    return (jsx$1(FormWrapper$1, __assign$1({ formGroupAs: 'fieldset', ariaDescribedBy: inputGenerateDescribedBy(name, subtitle, hint, error, message) }, props, { children: jsx$1(InputGroupWrapper, { inputGroup: inputGroup, id: name, children: jsx$1(RCSlider, __assign$1({ name: name, value: value, valueSet: valueSet, onChange: onChange, showMarks: showMarks, showFirstLastMarks: showFirstLastMarks, addMarkLabel: addMarkLabel, tooltipText: tooltipText, sliderClassName: sliderClassName, showFirstLastDots: showFirstLastDots, showDots: showDots, marks: marks, generateMarks: generateMarks, addToTooltip: addToTooltip, inputGroup: inputGroup, icon: icon, minSelectedValue: minSelectedValue, tooltipStyle: tooltipStyle }, slider, { disabled: !ueberschreibbar, ariaLabelledByForHandle: "label.".concat(name) })) }) })));
};

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}

var isDevelopment$2 = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment$2 : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var isBrowser$3 = typeof document !== 'undefined';

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

/* import type { StylisPlugin } from './types' */

/*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/

var getServerStylisCache = isBrowser$3 ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function
  /*: EmotionCache */
createCache(options
/*: Options */
) {
  var key = options.key;

  if (isBrowser$3 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node
    /*: HTMLStyleElement */
    ) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  /* : Node */

  var nodesToHydrate = [];

  if (isBrowser$3) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node
    /*: HTMLStyleElement */
    ) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;
  /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */


  var omnipresentPlugins = [compat, removeLabel];

  if (isBrowser$3) {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function
      /*: void */
    insert(selector
    /*: string */
    , serialized
    /*: SerializedStyles */
    , sheet
    /*: StyleSheet */
    , shouldCache
    /*: boolean */
    ) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    };

    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function
      /*: string */
    getRules(selector
    /*: string */
    , serialized
    /*: SerializedStyles */
    ) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function
      /*: string | void */
    _insert(selector
    /*: string */
    , serialized
    /*: SerializedStyles */
    , sheet
    /*: StyleSheet */
    , shouldCache
    /*: boolean */
    ) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache
  /*: EmotionCache */
  = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;

function requireHoistNonReactStatics_cjs () {
	if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
	hasRequiredHoistNonReactStatics_cjs = 1;

	var reactIs = requireReactIs();

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above


	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}

	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);

	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }

	    var keys = getOwnPropertyNames(sourceComponent);

	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }

	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);

	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];

	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }

	  return targetComponent;
	}

	hoistNonReactStatics_cjs = hoistNonReactStatics;
	return hoistNonReactStatics_cjs;
}

requireHoistNonReactStatics_cjs();

var isBrowser$2 = typeof document !== 'undefined';

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$2 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$2 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var isDevelopment$1 = false;

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  {
    return asString;
  }
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment$1) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  }


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

var isBrowser$1 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$1 ? syncFallback : useInsertionEffect || syncFallback;

var isDevelopment = false;

var isBrowser = typeof document !== 'undefined';

/* import { type EmotionCache } from '@emotion/utils' */
var EmotionCacheContext
/*: React.Context<EmotionCache | null> */
= /* #__PURE__ */React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache
/* <Props, Ref: React.Ref<*>> */
(func
/*: (props: Props, cache: EmotionCache, ref: Ref) => React.Node */
)
/*: React.AbstractComponent<Props> */
{
  return /*#__PURE__*/forwardRef(function (props
  /*: Props */
  , ref
  /*: Ref */
  ) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache
  /* <Props> */
  (func
  /*: (props: Props, cache: EmotionCache) => React.Node */
  )
  /*: React.StatelessFunctionalComponent<Props> */
  {
    return function (props
    /*: Props */
    ) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */React.createContext({});

var hasOwn = {}.hasOwnProperty;

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type
/*: React.ElementType */
, props
/*: Object */
) {

  var newProps
  /*: any */
  = {};

  for (var key in props) {
    if (hasOwn.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(
/* <any, any> */
function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, React.useContext(ThemeContext));

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwn.call(props, key) && key !== 'css' && key !== typePropName && (!isDevelopment )) {
      newProps[key] = props[key];
    }
  }

  newProps.className = className;

  if (ref) {
    newProps.ref = ref;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React.createElement(WrappedComponent, newProps));
});

var Emotion$1 = Emotion;

var jsx
/*: typeof React.createElement */
= function jsx
/*: typeof React.createElement */
(type
/*: React.ElementType */
, props
/*: Object */
) {
  var args = arguments;

  if (props == null || !hasOwn.call(props, 'css')) {
    return React.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }

  return React.createElement.apply(null, createElementArgArray);
};

/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */

function css$2()
/*: SerializedStyles */
{
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/

var keyframes = function
  /*: Keyframes */
keyframes() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  {
    return false;
  }
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets() ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

var index$1 = typeof document !== 'undefined' ? useLayoutEffect$1 : useEffect;

var _excluded$4 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================

var noop$1 = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}
function classNames(prefix, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = _objectWithoutProperties$1(props, _excluded$4);
  return _objectSpread2({}, innerProps);
};

// ==============================
// Get Style Props
// ==============================

var getStyleProps = function getStyleProps(props, name, classNamesState) {
  var cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    className = props.className;
  return {
    css: getStyles(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop$1;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

// ==============================
// Passive Event Detector
// ==============================

// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop$1, options);
  w.removeEventListener('p', noop$1, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = _slicedToArray$2(_ref, 1),
      key = _ref2[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = _slicedToArray$2(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};

var _excluded$3$1 = ["children", "innerProps"],
  _excluded2$1 = ["children", "innerProps"];
function getMenuPlacement(_ref) {
  var preferredMaxHeight = _ref.maxHeight,
    menuEl = _ref.menuEl,
    minHeight = _ref.minHeight,
    preferredPlacement = _ref.placement,
    shouldScroll = _ref.shouldScroll,
    isFixedPosition = _ref.isFixedPosition,
    controlHeight = _ref.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: preferredMaxHeight
  };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (preferredPlacement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (preferredPlacement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
  }
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
  var _objectSpread2$1;
  var placement = _ref2.placement,
    _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    spacing = _ref2$theme.spacing,
    colors = _ref2$theme.colors;
  return _objectSpread2((_objectSpread2$1 = {
    label: 'menu'
  }, _defineProperty$3(_objectSpread2$1, alignToControl(placement), '100%'), _defineProperty$3(_objectSpread2$1, "position", 'absolute'), _defineProperty$3(_objectSpread2$1, "width", '100%'), _defineProperty$3(_objectSpread2$1, "zIndex", 1), _objectSpread2$1), unstyled ? {} : {
    backgroundColor: colors.neutral0,
    borderRadius: borderRadius,
    boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
    marginBottom: spacing.menuGutter,
    marginTop: spacing.menuGutter
  });
};
var PortalPlacementContext = /*#__PURE__*/createContext(null);

// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
  var children = props.children,
    minMenuHeight = props.minMenuHeight,
    maxMenuHeight = props.maxMenuHeight,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition,
    menuShouldScrollIntoView = props.menuShouldScrollIntoView,
    theme = props.theme;
  var _ref3 = useContext(PortalPlacementContext) || {},
    setPortalPlacement = _ref3.setPortalPlacement;
  var ref = useRef(null);
  var _useState = useState(maxMenuHeight),
    _useState2 = _slicedToArray$2(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray$2(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  var controlHeight = theme.spacing.controlHeight;
  index$1(function () {
    var menuEl = ref.current;
    if (!menuEl) return;

    // DO NOT scroll if position is fixed
    var isFixedPosition = menuPosition === 'fixed';
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl: menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll: shouldScroll,
      isFixedPosition: isFixedPosition,
      controlHeight: controlHeight
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight]);
  return children({
    ref: ref,
    placerProps: _objectSpread2(_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight: maxHeight
    })
  });
};
var Menu = function Menu(props) {
  var children = props.children,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends$G({}, getStyleProps(props, 'menu', {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var Menu$1 = Menu;

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight,
    baseUnit = _ref4.theme.spacing.baseUnit;
  return _objectSpread2({
    maxHeight: maxHeight,
    overflowY: 'auto',
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  }, unstyled ? {} : {
    paddingBottom: baseUnit,
    paddingTop: baseUnit
  });
};
var MenuList = function MenuList(props) {
  var children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return jsx("div", _extends$G({}, getStyleProps(props, 'menuList', {
    'menu-list': true,
    'menu-list--is-multi': isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme,
    baseUnit = _ref5$theme.spacing.baseUnit,
    colors = _ref5$theme.colors;
  return _objectSpread2({
    textAlign: 'center'
  }, unstyled ? {} : {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
  var _ref6$children = _ref6.children,
    children = _ref6$children === void 0 ? 'No options' : _ref6$children,
    innerProps = _ref6.innerProps,
    restProps = _objectWithoutProperties$1(_ref6, _excluded$3$1);
  return jsx("div", _extends$G({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'noOptionsMessage', {
    'menu-notice': true,
    'menu-notice--no-options': true
  }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
  var _ref7$children = _ref7.children,
    children = _ref7$children === void 0 ? 'Loading...' : _ref7$children,
    innerProps = _ref7.innerProps,
    restProps = _objectWithoutProperties$1(_ref7, _excluded2$1);
  return jsx("div", _extends$G({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'loadingMessage', {
    'menu-notice': true,
    'menu-notice--loading': true
  }), innerProps), children);
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref8) {
  var rect = _ref8.rect,
    offset = _ref8.offset,
    position = _ref8.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal(props) {
  var appendTo = props.appendTo,
    children = props.children,
    controlElement = props.controlElement,
    innerProps = props.innerProps,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition;
  var menuPortalRef = useRef(null);
  var cleanupRef = useRef(null);
  var _useState5 = useState(coercePlacement(menuPlacement)),
    _useState6 = _slicedToArray$2(_useState5, 2),
    placement = _useState6[0],
    setPortalPlacement = _useState6[1];
  var portalPlacementContext = useMemo(function () {
    return {
      setPortalPlacement: setPortalPlacement
    };
  }, []);
  var _useState7 = useState(null),
    _useState8 = _slicedToArray$2(_useState7, 2),
    computedPosition = _useState8[0],
    setComputedPosition = _useState8[1];
  var updateComputedPosition = useCallback(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
    var offset = rect[placement] + scrollDistance;
    if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset,
        rect: rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  index$1(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = useCallback(function () {
    if (typeof cleanupRef.current === 'function') {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: 'ResizeObserver' in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  index$1(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = useCallback(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);

  // bail early if required elements aren't present
  if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;

  // same wrapper element whether fixed or portalled
  var menuWrapper = jsx("div", _extends$G({
    ref: setMenuPortalElement
  }, getStyleProps(_objectSpread2(_objectSpread2({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), 'menuPortal', {
    'menu-portal': true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /*#__PURE__*/createPortal(menuWrapper, appendTo) : menuWrapper);
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return jsx("div", _extends$G({}, getStyleProps(props, 'container', {
    '--is-disabled': isDisabled,
    '--is-rtl': isRtl
  }), innerProps), children);
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
  var spacing = _ref2.theme.spacing,
    isMulti = _ref2.isMulti,
    hasValue = _ref2.hasValue,
    controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return _objectSpread2({
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  }, unstyled ? {} : {
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    hasValue = props.hasValue;
  return jsx("div", _extends$G({}, getStyleProps(props, 'valueContainer', {
    'value-container': true,
    'value-container--is-multi': isMulti,
    'value-container--has-value': hasValue
  }), innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", _extends$G({}, getStyleProps(props, 'indicatorsContainer', {
    indicators: true
  }), innerProps), children);
};

var _templateObject;
var _excluded$2$1 = ["size"],
  _excluded2$2 = ["innerProps", "isRtl", "size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2$2 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var Svg = function Svg(_ref) {
  var size = _ref.size,
    props = _objectWithoutProperties$1(_ref, _excluded$2$1);
  return jsx("svg", _extends$G({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, props));
};
var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, _extends$G({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, _extends$G({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3, unstyled) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit = _ref3$theme.spacing.baseUnit,
    colors = _ref3$theme.colors;
  return _objectSpread2({
    label: 'indicatorContainer',
    display: 'flex',
    transition: 'color 150ms'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2,
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", _extends$G({}, getStyleProps(props, 'dropdownIndicator', {
    indicator: true,
    'dropdown-indicator': true
  }), innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", _extends$G({}, getStyleProps(props, 'clearIndicator', {
    indicator: true,
    'clear-indicator': true
  }), innerProps), children || jsx(CrossIcon, null));
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit = _ref4$theme.spacing.baseUnit,
    colors = _ref4$theme.colors;
  return _objectSpread2({
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var innerProps = props.innerProps;
  return jsx("span", _extends$G({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
    'indicator-separator': true
  })));
};

// ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors = _ref5$theme.colors,
    baseUnit = _ref5$theme.spacing.baseUnit;
  return _objectSpread2({
    label: 'loadingIndicator',
    display: 'flex',
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2
  });
};
var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
    offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
  var innerProps = _ref7.innerProps,
    isRtl = _ref7.isRtl,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? 4 : _ref7$size,
    restProps = _objectWithoutProperties$1(_ref7, _excluded2$2);
  return jsx("div", _extends$G({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    innerProps: innerProps,
    isRtl: isRtl,
    size: size
  }), 'loadingIndicator', {
    indicator: true,
    'loading-indicator': true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};

var css$1 = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    borderRadius = _ref$theme.borderRadius,
    spacing = _ref$theme.spacing;
  return _objectSpread2({
    label: 'control',
    alignItems: 'center',
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms'
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  });
};
var Control = function Control(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$G({
    ref: innerRef
  }, getStyleProps(props, 'control', {
    control: true,
    'control--is-disabled': isDisabled,
    'control--is-focused': isFocused,
    'control--menu-is-open': menuIsOpen
  }), innerProps, {
    "aria-disabled": isDisabled || undefined
  }), children);
};
var Control$1 = Control;

var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS(_ref, unstyled) {
  var spacing = _ref.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};
var Group = function Group(props) {
  var children = props.children,
    cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme = props.theme,
    selectProps = props.selectProps;
  return jsx("div", _extends$G({}, getStyleProps(props, 'group', {
    group: true
  }), innerProps), jsx(Heading, _extends$G({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    colors = _ref2$theme.colors,
    spacing = _ref2$theme.spacing;
  return _objectSpread2({
    label: 'group',
    cursor: 'default',
    display: 'block'
  }, unstyled ? {} : {
    color: colors.neutral40,
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  });
};
var GroupHeading = function GroupHeading(props) {
  var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = _objectWithoutProperties$1(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends$G({}, getStyleProps(props, 'groupHeading', {
    'group-heading': true
  }), innerProps));
};
var Group$1 = Group;

var _excluded$5 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2(_objectSpread2({
    visibility: isDisabled ? 'hidden' : 'visible',
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle), unstyled ? {} : {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    color: colors.neutral80
  });
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
  return _objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};
var Input$1 = function Input(props) {
  var cx = props.cx,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = _objectWithoutProperties$1(_cleanCommonProps, _excluded$5);
  return jsx("div", _extends$G({}, getStyleProps(props, 'input', {
    'input-container': true
  }), {
    "data-value": value || ''
  }), jsx("input", _extends$G({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var Input$1$1 = Input$1;

var multiValueCSS = function multiValueCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    borderRadius = _ref$theme.borderRadius,
    colors = _ref$theme.colors;
  return _objectSpread2({
    label: 'multiValue',
    display: 'flex',
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    margin: spacing.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    colors = _ref2$theme.colors,
    cropWithEllipsis = _ref2.cropWithEllipsis;
  return _objectSpread2({
    overflow: 'hidden',
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    borderRadius = _ref3$theme.borderRadius,
    colors = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return _objectSpread2({
    alignItems: 'center',
    display: 'flex'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return jsx("div", _extends$G({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    components = props.components,
    data = props.data,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps = props.removeProps,
    selectProps = props.selectProps;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  return jsx(Container, {
    data: data,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, 'multiValue', {
      'multi-value': true,
      'multi-value--is-disabled': isDisabled
    })), innerProps),
    selectProps: selectProps
  }, jsx(Label, {
    data: data,
    innerProps: _objectSpread2({}, getStyleProps(props, 'multiValueLabel', {
      'multi-value__label': true
    })),
    selectProps: selectProps
  }, children), jsx(Remove, {
    data: data,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, 'multiValueRemove', {
      'multi-value__remove': true
    })), {}, {
      'aria-label': "Remove ".concat(children || 'option')
    }, removeProps),
    selectProps: selectProps
  }));
};
var MultiValue$1 = MultiValue;

var optionCSS = function optionCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2({
    label: 'option',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  });
};
var Option = function Option(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends$G({}, getStyleProps(props, 'option', {
    option: true,
    'option--is-disabled': isDisabled,
    'option--is-focused': isFocused,
    'option--is-selected': isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var Option$1 = Option;

var placeholderCSS = function placeholderCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2({
    label: 'placeholder',
    gridArea: '1 / 1 / 2 / 3'
  }, unstyled ? {} : {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", _extends$G({}, getStyleProps(props, 'placeholder', {
    placeholder: true
  }), innerProps), children);
};
var Placeholder$1 = Placeholder;

var css = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2({
    label: 'singleValue',
    gridArea: '1 / 1 / 2 / 3',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var SingleValue = function SingleValue(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return jsx("div", _extends$G({}, getStyleProps(props, 'singleValue', {
    'single-value': true,
    'single-value--is-disabled': isDisabled
  }), innerProps), children);
};
var SingleValue$1 = SingleValue;

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control$1,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group$1,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$1$1,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu$1,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue$1,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option$1,
  Placeholder: Placeholder$1,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue$1,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var cache = null;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) {
            return cache.lastResult;
        }
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this,
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// Assistive text to describe visual elements. Hidden for sighted users.
var _ref = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var A11yText = function A11yText(props) {
  return jsx("span", _extends$G({
    css: _ref
  }, props));
};
var A11yText$1 = A11yText;

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
      isMulti = props.isMulti,
      tabSelectsValue = props.tabSelectsValue,
      context = props.context,
      isInitialFocus = props.isInitialFocus;
    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
      case 'input':
        return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      labels = props.labels,
      isDisabled = props.isDisabled;
    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");
      case 'clear':
        return 'All selected options have been cleared.';
      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
      focused = props.focused,
      options = props.options,
      _props$label2 = props.label,
      label = _props$label2 === void 0 ? '' : _props$label2,
      selectValue = props.selectValue,
      isDisabled = props.isDisabled,
      isSelected = props.isSelected,
      isAppleDevice = props.isAppleDevice;
    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };
    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === 'menu' && isAppleDevice) {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
      return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
    focusedOption = props.focusedOption,
    focusedValue = props.focusedValue,
    focusableOptions = props.focusableOptions,
    isFocused = props.isFocused,
    selectValue = props.selectValue,
    selectProps = props.selectProps,
    id = props.id,
    isAppleDevice = props.isAppleDevice;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
    getOptionLabel = selectProps.getOptionLabel,
    inputValue = selectProps.inputValue,
    isMulti = selectProps.isMulti,
    isOptionDisabled = selectProps.isOptionDisabled,
    isSearchable = selectProps.isSearchable,
    menuIsOpen = selectProps.menuIsOpen,
    options = selectProps.options,
    screenReaderStatus = selectProps.screenReaderStatus,
    tabSelectsValue = selectProps.tabSelectsValue,
    isLoading = selectProps.isLoading;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live'];

  // Update aria live message configuration when prop changes
  var messages = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);

  // Update aria live selected option when prop changes
  var ariaSelected = useMemo(function () {
    var message = '';
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
        selectedOptions = ariaSelection.options,
        removedValue = ariaSelection.removedValue,
        removedValues = ariaSelection.removedValues,
        value = ariaSelection.value;
      // select-option when !isMulti does not return option so we assume selected option is value
      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      };

      // If there is just one item from the action then get its label
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : '';

      // If there are multiple items from the action then return an array of labels
      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
      var onChangeProps = _objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = useMemo(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue,
        isAppleDevice: isAppleDevice
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, focusableOptions, selectValue, isAppleDevice]);
  var ariaResults = useMemo(function () {
    var resultsMsg = '';
    if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus, isLoading]);
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  var ariaGuidance = useMemo(function () {
    var guidanceMsg = '';
    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue,
        isInitialFocus: isInitialFocus
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue, isInitialFocus]);
  var ScreenReaderText = jsx(Fragment$1, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-focused"
  }, ariaFocused), jsx("span", {
    id: "aria-results"
  }, ariaResults), jsx("span", {
    id: "aria-guidance"
  }, ariaGuidance));
  return jsx(Fragment$1, null, jsx(A11yText$1, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText$1, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
      ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
      ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
      stringify = _ignoreCase$ignoreAcc.stringify,
      trim = _ignoreCase$ignoreAcc.trim,
      matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _excluded$3 = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
    props = _objectWithoutProperties$1(_ref, _excluded$3);
  // Remove animation props not meant for HTML elements
  var filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
  return jsx("input", _extends$G({
    ref: innerRef
  }, filteredProps, {
    css: /*#__PURE__*/css$2({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}

var cancelScroll = function cancelScroll(event) {
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
      scrollTop = _scrollTarget$current.scrollTop,
      scrollHeight = _scrollTarget$current.scrollHeight,
      clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;

    // reset bottom/top flags
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }

    // bottom limit
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;

      // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }

    // cancel scroll
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};
function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
    _ref$accountForScroll = _ref.accountForScrollbars,
    accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }

    // apply the lock styles and padding if this is the first scroll lock
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }

    // account for touch devices
    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions);

      // Allow scroll on provided target
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }

    // increment active scroll locks
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    // safely decrement active scroll locks
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

    // reapply original body styles, if any
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }

    // remove touch listeners
    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var blurSelectInput = function blurSelectInput(event) {
  var element = event.target;
  return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function ScrollManager(_ref) {
  var children = _ref.children,
    lockEnabled = _ref.lockEnabled,
    _ref$captureEnabled = _ref.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment$1, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var RequiredInput = function RequiredInput(_ref) {
  var name = _ref.name,
    onFocus = _ref.onFocus;
  return jsx("input", {
    required: true,
    name: name,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus,
    css: _ref2
    // Prevent `Switching from uncontrolled to controlled` error
    ,
    value: "",
    onChange: function onChange() {}
  });
};
var RequiredInput$1 = RequiredInput;

/// <reference types="user-agent-data-types" />

function testPlatform(re) {
  var _window$navigator$use;
  return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
  return testPlatform(/^iPhone/i);
}
function isMac() {
  return testPlatform(/^Mac/i);
}
function isIPad() {
  return testPlatform(/^iPad/i) ||
  // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
  return isIPhone() || isIPad();
}
function isAppleDevice() {
  return isMac() || isIOS();
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css,
  valueContainer: valueContainerCSS
};

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps$1 = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray$2(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray$2(categorizedOption.options.map(function (option) {
        return {
          data: option.data,
          id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
        };
      })));
    } else {
      optionsAccumulator.push({
        data: categorizedOption.data,
        id: "".concat(optionId, "-").concat(categorizedOption.index)
      });
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
    isSelected = categorizedOption.isSelected,
    label = categorizedOption.label,
    value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
    lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
  var _focusableOptionsWith;
  var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function (option) {
    return option.data === focusedOption;
  })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
  return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
    isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select$1 = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);
  // Misc. Instance Properties
  // ------------------------------

  // TODO

  // Refs
  // ------------------------------

  // Lifecycle
  // ------------------------------

  function Select(_props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined,
      instancePrefix: ''
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.isAppleDevice = isAppleDevice();
    _this.controlRef = null;
    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange(newValue, actionMeta);
    };
    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
        closeMenuOnSelect = _this$props2.closeMenuOnSelect,
        isMulti = _this$props2.isMulti,
        inputValue = _this$props2.inputValue;
      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      // when the select value should change, we should reset focusedValue
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };
    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
        blurInputOnSelect = _this$props3.blurInputOnSelect,
        isMulti = _this$props3.isMulti,
        name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray$2(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };
    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      if (lastSelectedValue) {
        _this.onChange(newValue, {
          action: 'pop-value',
          removedValue: lastSelectedValue
        });
      }
    };
    _this.getFocusedOptionId = function (focusedOption) {
      return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
    };
    _this.getFocusableOptionsWithIds = function () {
      return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
    };
    _this.getValue = function () {
      return _this.state.selectValue;
    };
    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };
    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };
    _this.getStyles = function (key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function (key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function (element) {
      return "".concat(_this.state.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value: value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function (event) {
      // Event captured by dropdown indicator
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
        isMulti = _this$props4.isMulti,
        menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };
    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }

      // reset move vars
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      var options = _this.getFocusableOptions();
      var focusedOptionIndex = options.indexOf(focusedOption);
      _this.setState({
        focusedOption: focusedOption,
        focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
      });
    };
    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
        isMulti = _this$props5.isMulti,
        backspaceRemovesValue = _this$props5.backspaceRemovesValue,
        escapeClearsValue = _this$props5.escapeClearsValue,
        inputValue = _this$props5.inputValue,
        isClearable = _this$props5.isClearable,
        isDisabled = _this$props5.isDisabled,
        menuIsOpen = _this$props5.menuIsOpen,
        onKeyDown = _this$props5.onKeyDown,
        tabSelectsValue = _this$props5.tabSelectsValue,
        openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
        focusedOption = _this$state.focusedOption,
        focusedValue = _this$state.focusedValue,
        selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === 'function') {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }

      // Block option hover events when the user has just pressed a key
      _this.blockOptionHover = true;
      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;
          _this.focusValue('previous');
          break;
        case 'ArrowRight':
          if (!isMulti || inputValue) return;
          _this.focusValue('next');
          break;
        case 'Delete':
        case 'Backspace':
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case 'Tab':
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
          // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case ' ':
          // space
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu('first');
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }
          break;
        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }
          break;
        case 'PageUp':
          if (!menuIsOpen) return;
          _this.focusOption('pageup');
          break;
        case 'PageDown':
          if (!menuIsOpen) return;
          _this.focusOption('pagedown');
          break;
        case 'Home':
          if (!menuIsOpen) return;
          _this.focusOption('first');
          break;
        case 'End':
          if (!menuIsOpen) return;
          _this.focusOption('last');
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
      _this.state.focusedOption = focusableOptions[optionIndex];
      _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
    }
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }

      // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        isDisabled = _this$props6.isDisabled,
        menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: true
        });
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }

    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectValue = _this$state2.selectValue,
        isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      // only scroll if the menu isn't already open
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex],
        focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        focusedValue = _this$state3.focusedValue;

      // Only multiselects support value focusing
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null,
        focusedOptionId: this.getFocusedOptionId(options[nextFocus])
      });
    }
  }, {
    key: "getTheme",
    value:
    // ==============================
    // Getters
    // ==============================

    function getTheme() {
      // Use the default theme if there are no customisations.
      if (!this.props.theme) {
        return defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
        cx = this.cx,
        getStyles = this.getStyles,
        getClassNames = this.getClassNames,
        getValue = this.getValue,
        selectOption = this.selectOption,
        setValue = this.setValue,
        props = this.props;
      var isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getClassNames: getClassNames,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
        isClearable = _this$props7.isClearable,
        isMulti = _this$props7.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable
      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value:
    // ==============================
    // Composition Handlers
    // ==============================

    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value:
    // ==============================
    // Touch Handlers
    // ==============================

    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value:
    // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
        isDisabled = _this$props8.isDisabled,
        isSearchable = _this$props8.isSearchable,
        inputId = _this$props8.inputId,
        inputValue = _this$props8.inputValue,
        tabIndex = _this$props8.tabIndex,
        form = _this$props8.form,
        menuIsOpen = _this$props8.menuIsOpen,
        required = _this$props8.required;
      var _this$getComponents = this.getComponents(),
        Input = _this$getComponents.Input;
      var _this$state4 = this.state,
        inputIsHidden = _this$state4.inputIsHidden,
        ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input');

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        'aria-required': required,
        role: 'combobox',
        'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
      }, menuIsOpen && {
        'aria-controls': this.getElementId('listbox')
      }), !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });
      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/React.createElement(DummyInput, _extends$G({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop$1,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }
      return /*#__PURE__*/React.createElement(Input, _extends$G({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(),
        MultiValue = _this$getComponents2.MultiValue,
        MultiValueContainer = _this$getComponents2.MultiValueContainer,
        MultiValueLabel = _this$getComponents2.MultiValueLabel,
        MultiValueRemove = _this$getComponents2.MultiValueRemove,
        SingleValue = _this$getComponents2.SingleValue,
        Placeholder = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props,
        controlShouldRenderValue = _this$props9.controlShouldRenderValue,
        isDisabled = _this$props9.isDisabled,
        isMulti = _this$props9.isMulti,
        inputValue = _this$props9.inputValue,
        placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
        selectValue = _this$state5.selectValue,
        focusedValue = _this$state5.focusedValue,
        isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/React.createElement(Placeholder, _extends$G({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/React.createElement(MultiValue, _extends$G({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /*#__PURE__*/React.createElement(SingleValue, _extends$G({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
        ClearIndicator = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props,
        isDisabled = _this$props10.isDisabled,
        isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(ClearIndicator, _extends$G({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
        LoadingIndicator = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props,
        isDisabled = _this$props11.isDisabled,
        isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(LoadingIndicator, _extends$G({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
        DropdownIndicator = _this$getComponents5.DropdownIndicator,
        IndicatorSeparator = _this$getComponents5.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator
      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React.createElement(IndicatorSeparator, _extends$G({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
        DropdownIndicator = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(DropdownIndicator, _extends$G({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(),
        Group = _this$getComponents7.Group,
        GroupHeading = _this$getComponents7.GroupHeading,
        Menu = _this$getComponents7.Menu,
        MenuList = _this$getComponents7.MenuList,
        MenuPortal = _this$getComponents7.MenuPortal,
        LoadingMessage = _this$getComponents7.LoadingMessage,
        NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
        Option = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
        captureMenuScroll = _this$props12.captureMenuScroll,
        inputValue = _this$props12.inputValue,
        isLoading = _this$props12.isLoading,
        loadingMessage = _this$props12.loadingMessage,
        minMenuHeight = _this$props12.minMenuHeight,
        maxMenuHeight = _this$props12.maxMenuHeight,
        menuIsOpen = _this$props12.menuIsOpen,
        menuPlacement = _this$props12.menuPlacement,
        menuPosition = _this$props12.menuPosition,
        menuPortalTarget = _this$props12.menuPortalTarget,
        menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
        noOptionsMessage = _this$props12.noOptionsMessage,
        onMenuScrollToTop = _this$props12.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props, id) {
        var type = props.type,
          data = props.data,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected,
          label = props.label,
          value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1,
          role: 'option',
          'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
        };

        return /*#__PURE__*/React.createElement(Option, _extends$G({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
              options = item.options,
              groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/React.createElement(Group, _extends$G({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });
        if (_message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(NoOptionsMessage, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/React.createElement(MenuPlacer, _extends$G({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
          _ref4$placerProps = _ref4.placerProps,
          placement = _ref4$placerProps.placement,
          maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/React.createElement(Menu, _extends$G({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/React.createElement(MenuList, _extends$G({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            innerProps: {
              role: 'listbox',
              'aria-multiselectable': commonProps.isMulti,
              id: _this4.getElementId('listbox')
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      });

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React.createElement(MenuPortal, _extends$G({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props,
        delimiter = _this$props13.delimiter,
        isDisabled = _this$props13.isDisabled,
        isMulti = _this$props13.isMulti,
        name = _this$props13.name,
        required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (required && !this.hasValue() && !isDisabled) {
        return /*#__PURE__*/React.createElement(RequiredInput$1, {
          name: name,
          onFocus: this.onValueInputFocus
        });
      }
      if (!name || isDisabled) return;
      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/React.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden",
            value: ""
          });
          return /*#__PURE__*/React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return /*#__PURE__*/React.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
        ariaSelection = _this$state6.ariaSelection,
        focusedOption = _this$state6.focusedOption,
        focusedValue = _this$state6.focusedValue,
        isFocused = _this$state6.isFocused,
        selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/React.createElement(LiveRegion$1, _extends$G({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
        Control = _this$getComponents8.Control,
        IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
        SelectContainer = _this$getComponents8.SelectContainer,
        ValueContainer = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props,
        className = _this$props14.className,
        id = _this$props14.id,
        isDisabled = _this$props14.isDisabled,
        menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/React.createElement(SelectContainer, _extends$G({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/React.createElement(Control, _extends$G({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/React.createElement(ValueContainer, _extends$G({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React.createElement(IndicatorsContainer, _extends$G({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
        clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
        inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
        ariaSelection = state.ariaSelection,
        isFocused = state.isFocused,
        prevWasFocused = state.prevWasFocused,
        instancePrefix = state.instancePrefix;
      var options = props.options,
        value = props.value,
        menuIsOpen = props.menuIsOpen,
        inputValue = props.inputValue,
        isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedOptionId: focusedOptionId,
          focusableOptionsWithIds: focusableOptionsWithIds,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      // some updates should toggle the state of the input visibility
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      }

      // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select;
}(Component);
Select$1.defaultProps = defaultProps$1;

var _excluded$2 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
    defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
    _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
    defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    propsInputValue = _ref.inputValue,
    propsMenuIsOpen = _ref.menuIsOpen,
    propsOnChange = _ref.onChange,
    propsOnInputChange = _ref.onInputChange,
    propsOnMenuClose = _ref.onMenuClose,
    propsOnMenuOpen = _ref.onMenuOpen,
    propsValue = _ref.value,
    restSelectProps = _objectWithoutProperties$1(_ref, _excluded$2);
  var _useState = useState(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
    _useState2 = _slicedToArray$2(_useState, 2),
    stateInputValue = _useState2[0],
    setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
    _useState4 = _slicedToArray$2(_useState3, 2),
    stateMenuIsOpen = _useState4[0],
    setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== undefined ? propsValue : defaultValue),
    _useState6 = _slicedToArray$2(_useState5, 2),
    stateValue = _useState6[0],
    setStateValue = _useState6[1];
  var onChange = useCallback(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }
    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = useCallback(function (value, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }
    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}

var _excluded$1 = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];
var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var accessors = arguments.length > 2 ? arguments[2] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref) {
  var _ref$allowCreateWhile = _ref.allowCreateWhileLoading,
    allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile,
    _ref$createOptionPosi = _ref.createOptionPosition,
    createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi,
    _ref$formatCreateLabe = _ref.formatCreateLabel,
    formatCreateLabel = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe,
    _ref$isValidNewOption = _ref.isValidNewOption,
    isValidNewOption = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption,
    _ref$getNewOptionData = _ref.getNewOptionData,
    getNewOptionData = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData,
    onCreateOption = _ref.onCreateOption,
    _ref$options = _ref.options,
    propsOptions = _ref$options === void 0 ? [] : _ref$options,
    propsOnChange = _ref.onChange,
    restSelectProps = _objectWithoutProperties$1(_ref, _excluded$1);
  var _restSelectProps$getO = restSelectProps.getOptionValue,
    getOptionValue$1$1 = _restSelectProps$getO === void 0 ? getOptionValue$1 : _restSelectProps$getO,
    _restSelectProps$getO2 = restSelectProps.getOptionLabel,
    getOptionLabel$1$1 = _restSelectProps$getO2 === void 0 ? getOptionLabel$1 : _restSelectProps$getO2,
    inputValue = restSelectProps.inputValue,
    isLoading = restSelectProps.isLoading,
    isMulti = restSelectProps.isMulti,
    value = restSelectProps.value,
    name = restSelectProps.name;
  var newOption = useMemo(function () {
    return isValidNewOption(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1$1,
      getOptionLabel: getOptionLabel$1$1
    }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
  }, [formatCreateLabel, getNewOptionData, getOptionLabel$1$1, getOptionValue$1$1, inputValue, isValidNewOption, propsOptions, value]);
  var options = useMemo(function () {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray$2(propsOptions)) : [].concat(_toConsumableArray$2(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange = useCallback(function (newValue, actionMeta) {
    if (actionMeta.action !== 'select-option') {
      return propsOnChange(newValue, actionMeta);
    }
    var valueArray = Array.isArray(newValue) ? newValue : [newValue];
    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption) onCreateOption(inputValue);else {
        var newOptionData = getNewOptionData(inputValue, inputValue);
        var newActionMeta = {
          action: 'create-option',
          name: name,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray$2(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }
    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options,
    onChange: onChange
  });
}

var CreatableSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /*#__PURE__*/React.createElement(Select$1, _extends$G({
    ref: ref
  }, selectProps));
});
var CreatableSelect$1 = CreatableSelect;

var customStyles = {
    control: function (styles, state) { return (__assign$1(__assign$1({}, styles), { backgroundColor: state.isDisabled ? '#e9ecef' : '#fff', borderRadius: 0, minHeight: '48px', fontWeight: 100, borderColor: state.isFocused ? 'var(--primary)' : '#ccc', boxShadow: state.isFocused ? '0 0 0 .2rem var(--primary-focus)' : 'none', '&:hover': {
            borderColor: '',
        } })); },
    input: function (styles) { return (__assign$1(__assign$1({}, styles), { height: 'auto', margin: 0, input: {
            border: 'none !important',
            height: 'auto',
        } })); },
    placeholder: function (styles) { return (__assign$1(__assign$1({}, styles), { fontWeight: 300, color: 'darkgrey' })); },
    menu: function (styles) { return (__assign$1(__assign$1({}, styles), { borderRadius: 0, marginTop: 0, border: '1px solid #ccc', boxShadow: '0 0', fontWeight: 100, zIndex: 3 })); },
    singleValue: function (styles) { return (__assign$1(__assign$1({}, styles), { color: '#000000bf', lineHeight: '1.5rem' })); },
    valueContainer: function (styles) { return (__assign$1(__assign$1({}, styles), { cursor: 'pointer', backgroundRepeat: 'no-repeat', backgroundSize: '17.5px 17.5px' })); },
    dropdownIndicator: function (styles, state) { return (__assign$1(__assign$1({}, styles), { display: state.isDisabled ? 'none' : 'flex', color: 'var(--primary)', '&:hover': {
            color: 'var(--primary)',
        } })); },
    indicatorSeparator: function (styles) { return (__assign$1(__assign$1({}, styles), { backgroundColor: 'hsl(0, 0%, 92%)', marginTop: 0, marginBottom: 0 })); },
};
var Input = function (_a) {
    var _b;
    var props = __rest$1(_a, []);
    return (
    // @ts-ignore
    jsx$1(components.Input, __assign$1({}, props, { maxLength: (_b = props === null || props === void 0 ? void 0 : props.selectProps) === null || _b === void 0 ? void 0 : _b.maxLength })));
};
var Select = function (props) {
    var options = props.options, onChange = props.onChange, name = props.name, value = props.value, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.isMulti, isMulti = _c === void 0 ? false : _c, _d = props.placeholder, placeholder = _d === void 0 ? '' : _d, _e = props.createable, createable = _e === void 0 ? false : _e, _f = props.onInputChange, onInputChange = _f === void 0 ? function () { } : _f, _g = props.isSearchable, isSearchable = _g === void 0 ? true : _g, maxLength = props.maxLength, ariaDescribedby = props.ariaDescribedby, required = props.required;
    return (jsx$1(CreatableSelect$1, { inputId: name, name: name, placeholder: placeholder, isMulti: isMulti, isDisabled: disabled, value: value, className: "".concat(className, " ").concat(isSearchable ? 'is-searchable' : ''), classNamePrefix: "react-select", options: options, onChange: onChange, onInputChange: onInputChange, isValidNewOption: function () { return createable; }, formatCreateLabel: function (input) { return "\"".concat(input, "\" hinzuf\u00FCgen"); }, noOptionsMessage: function () { return 'Nichts gefunden'; }, filterOption: createFilter({
            ignoreCase: true,
            matchFrom: (createable || isMulti) ? 'any' : 'start',
        }), isClearable: createable || isMulti, styles: customStyles, isSearchable: isSearchable, components: { Input: Input }, 
        // @ts-ignore
        maxLength: maxLength, "aria-describedby": ariaDescribedby, required: required }));
};

var FormCombobox = function (props) {
    var error = props.error, name = props.name, maxLenght = props.maxLenght, ueberschreibbar = props.ueberschreibbar, _a = props.inputClassName, inputClassName = _a === void 0 ? '' : _a, _b = props.createable, createable = _b === void 0 ? false : _b, _c = props.isSearchable, isSearchable = _c === void 0 ? true : _c, _d = props.placeholder, placeholder = _d === void 0 ? '' : _d, _e = props.dataType, dataType = _e === void 0 ? 'Integer' : _e, value = props.value, _f = props.valueSet, valueSet = _f === void 0 ? [] : _f, _g = props.isMulti, isMulti = _g === void 0 ? false : _g, _h = props.isArrayValue, isArrayValue = _h === void 0 ? false : _h, onChange = props.onChange, _j = props.onInputChange, onInputChange = _j === void 0 ? function () { } : _j, subtitle = props.subtitle, hint = props.hint, message = props.message, muss = props.muss;
    var isInvalid = error ? 'is-invalid' : '';
    var isInteger = dataType === null || dataType === void 0 ? void 0 : dataType.includes('Integer');
    var options = valueSet.map(function (val) { return (__assign$1({ value: isInteger ? val.id : val.bezeichnung, label: val.bezeichnung }, val)); });
    var selected;
    // wenn string valuesets
    if (!isInteger && !!value) {
        selected = {
            value: value,
            label: value,
        };
    }
    // wenn integer valuesets
    if (isInteger && value != null && (parseInt(value, 10) >= 0)) {
        selected = {
            value: value,
            label: findValueById(valueSet, parseInt(value, 10)),
        };
    }
    var multiSelect = isMulti || isArrayValue ? valueSet.map(function (val) {
        if (val.ausgewaehlt) {
            return __assign$1({ value: val.id, label: val.bezeichnung }, val);
        }
    }) : undefined;
    return (jsx$1(FormWrapper$1, __assign$1({}, props, { children: jsx$1(Select, { className: "combobox ".concat(isInvalid, " ").concat(inputClassName), options: options, name: name, value: isMulti || isArrayValue ? multiSelect : selected, onInputChange: onInputChange, onChange: isMulti || isArrayValue ? onChange : function (select) { return onChange(name, select === null || select === void 0 ? void 0 : select.value); }, disabled: !ueberschreibbar, isMulti: isMulti, placeholder: placeholder, createable: createable, isSearchable: isSearchable, maxLength: maxLenght, ariaDescribedby: inputGenerateDescribedBy(name, subtitle, hint, error, message), required: muss }) })));
};

var StyledTextarea = styled.textarea(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  resize: ", ";\n"], ["\n  resize: ", ";\n"])), function (_a) {
    var resize = _a.resize;
    return resize;
});
var FormText = function (props) {
    var value = props.value, _a = props.resize, resize = _a === void 0 ? 'both' : _a, name = props.name, ueberschreibbar = props.ueberschreibbar, rows = props.rows, _b = props.inputClassName, inputClassName = _b === void 0 ? '' : _b, autocomplete = props.autocomplete, placeholder = props.placeholder, onChange = props.onChange, onBlur = props.onBlur, maxLenght = props.maxLenght, subtitle = props.subtitle, hint = props.hint, message = props.message, error = props.error, muss = props.muss;
    return (jsx$1(FormWrapper$1, __assign$1({}, props, { children: jsx$1(Form.Control, { as: StyledTextarea, value: value, name: name, onChange: onChange, onBlur: onBlur, disabled: !ueberschreibbar, className: inputClassName, maxLength: maxLenght, placeholder: placeholder, autoComplete: autocomplete, rows: rows, resize: resize, "aria-describedby": inputGenerateDescribedBy(name, subtitle, hint, error, message), required: muss }) })));
};
var templateObject_1$c;

var FormKonto = function (props) {
    var _a = props.firstEmpty, firstEmpty = _a === void 0 ? false : _a, _b = props.tooltip, tooltip = _b === void 0 ? function () { } : _b, _c = props.liste, liste = _c === void 0 ? [] : _c, _d = props.tooltipRight, tooltipRight = _d === void 0 ? false : _d, _e = props.inputClassName, inputClassName = _e === void 0 ? '' : _e, _f = props.flex, flex = _f === void 0 ? false : _f, _g = props.inputParentClass, inputParentClass = _g === void 0 ? '' : _g, error = props.error, name = props.name, value = props.value, onChange = props.onChange, ueberschreibbar = props.ueberschreibbar;
    var tooltipId = (name || '').toLowerCase();
    var wert = liste.find(function (elem) { return elem.iban.value === value; }) || { iban: { value: 'neu' } };
    return (jsx$1(FormWrapper$1, __assign$1({}, props, { children: jsxs("div", { className: flex ? 'd-flex w-100 align-items-center' : inputParentClass, children: [jsxs(Form.Control, { onChange: onChange, name: name, disabled: !ueberschreibbar, value: wert.iban.value, isInvalid: Array.isArray(error), className: inputClassName, as: "select", children: [firstEmpty && jsx$1("option", {}), liste.map(function (element) { return (jsx$1("option", { value: element.iban.value, children: element.iban.value }, element.iban.value)); }), jsx$1("option", { value: "neu", children: "Neues Konto erfassen" })] }), tooltipRight && (jsx$1(Tooltip, { handleTooltip: tooltip, id: "tooltip-".concat(tooltipId) }))] }) })));
};
var FormKonto$1 = React__default.memo(FormKonto);

var css_248z$1 = ".rbt .rbt-input-main::-ms-clear {\n  display: none;\n}\n\n/**\n * Menu\n */\n.rbt-menu {\n  margin-bottom: 2px;\n}\n.rbt-menu > .dropdown-item {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rbt-menu > .dropdown-item:focus {\n  outline: none;\n}\n.rbt-menu-pagination-option {\n  text-align: center;\n}\n\n/**\n * Multi-select Input\n */\n.rbt-input-multi {\n  cursor: text;\n  overflow: hidden;\n  position: relative;\n}\n.rbt-input-multi.focus {\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  color: #495057;\n  outline: 0;\n}\n.rbt-input-multi.form-control {\n  height: auto;\n}\n.rbt-input-multi.disabled {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.rbt-input-multi.is-invalid.focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.rbt-input-multi.is-valid.focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n.rbt-input-multi input::-moz-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.rbt-input-multi input:-ms-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi input::-webkit-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi .rbt-input-wrapper {\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: -4px;\n  margin-top: -1px;\n  overflow: hidden;\n}\n.rbt-input-multi .rbt-input-main {\n  margin: 1px 0 4px;\n}\n\n/**\n * Close Button\n */\n.rbt-close {\n  z-index: 1;\n}\n.rbt-close-lg {\n  font-size: 1.5rem;\n}\n\n/**\n * Token\n */\n.rbt-token {\n  background-color: #e7f4ff;\n  border: 0;\n  border-radius: 0.25rem;\n  color: #007bff;\n  display: inline-flex;\n  line-height: 1rem;\n  margin: 1px 3px 2px 0;\n}\n.rbt-token .rbt-token-label {\n  padding: 0.25rem 0.5rem;\n}\n.rbt-token .rbt-token-label:not(:last-child) {\n  padding-right: 0.25rem;\n}\n.rbt-token-disabled {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #495057;\n  pointer-events: none;\n}\n.rbt-token-removeable {\n  cursor: pointer;\n}\n.rbt-token-active {\n  background-color: #007bff;\n  color: #fff;\n  outline: none;\n  text-decoration: none;\n}\n.rbt-token .rbt-token-remove-button {\n  background-image: none;\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  box-shadow: none;\n  color: inherit;\n  display: flex;\n  justify-content: center;\n  font-size: inherit;\n  font-weight: normal;\n  opacity: 1;\n  outline: none;\n  padding: 0.25rem 0.5rem;\n  padding-left: 0;\n  text-shadow: none;\n}\n.rbt-token .rbt-token-remove-button .rbt-close-content {\n  display: block;\n}\n\n/**\n * Loader + CloseButton container\n */\n.rbt-aux {\n  align-items: center;\n  display: flex;\n  bottom: 0;\n  justify-content: center;\n  pointer-events: none; /* Don't block clicks on the input */\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 2rem;\n}\n.rbt-aux-lg {\n  width: 3rem;\n}\n.rbt-aux .rbt-close {\n  margin-top: -0.25rem;\n  pointer-events: auto; /* Override pointer-events: none; above */\n}\n\n.has-aux .form-control {\n  padding-right: 2rem;\n}\n.has-aux .form-control.is-valid, .has-aux .form-control.is-invalid {\n  background-position: right 2rem center;\n  padding-right: 4rem;\n}\n\n.rbt-highlight-text {\n  background-color: inherit;\n  color: inherit;\n  font-weight: bold;\n  padding: 0;\n}\n\n/**\n * Input Groups\n */\n.input-group > .rbt {\n  flex: 1;\n}\n.input-group > .rbt .rbt-input-hint, .input-group > .rbt .rbt-aux {\n  z-index: 5;\n}\n.input-group > .rbt:not(:first-child) .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .rbt:not(:last-child) .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}";
styleInject(css_248z$1);

var StyledTypeahead = styled(AsyncTypeahead)(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  &&&& {\n    .rbt {\n      &-input-main {\n        border-top-right-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n      }\n      &-input-hint {\n        display: none;\n      }\n      &-highlight-text {\n        color: var(--label-color);\n        font-weight: 500;\n        background-color: transparent;\n        padding: 0;\n      }\n      &-loader {\n        position: relative;\n        right: 25px;\n      }\n      &-close {\n        position: static;\n        background-color: transparent;\n        color: #5e5e5e;\n        top: auto;\n        font-size: 1.5rem;\n        border: none;\n        margin-top: 0;\n\n        span {\n          display: none;\n        }\n      }\n    }\n\n    .dropdown-item {\n      text-decoration: none;\n      color: inherit;\n      font-weight: 100;\n      padding-top: .5rem;\n      padding-bottom: .5rem;\n      small {\n        display: block;\n      }\n    }\n  }\n"], ["\n  &&&& {\n    .rbt {\n      &-input-main {\n        border-top-right-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n      }\n      &-input-hint {\n        display: none;\n      }\n      &-highlight-text {\n        color: var(--label-color);\n        font-weight: 500;\n        background-color: transparent;\n        padding: 0;\n      }\n      &-loader {\n        position: relative;\n        right: 25px;\n      }\n      &-close {\n        position: static;\n        background-color: transparent;\n        color: #5e5e5e;\n        top: auto;\n        font-size: 1.5rem;\n        border: none;\n        margin-top: 0;\n\n        span {\n          display: none;\n        }\n      }\n    }\n\n    .dropdown-item {\n      text-decoration: none;\n      color: inherit;\n      font-weight: 100;\n      padding-top: .5rem;\n      padding-bottom: .5rem;\n      small {\n        display: block;\n      }\n    }\n  }\n"])));
var TypeaheadInput = function (props) {
    var _a = props.value, value = _a === void 0 ? '' : _a, _b = props.valueSet, valueSet = _b === void 0 ? [] : _b, _c = props.selected, selected = _c === void 0 ? {} : _c, _d = props.isLoading, isLoading = _d === void 0 ? false : _d, error = props.error, placeholder = props.placeholder, name = props.name, ueberschreibbar = props.ueberschreibbar, delay = props.delay, _e = props.minLength, minLength = _e === void 0 ? 3 : _e, _f = props.allowNew, allowNew = _f === void 0 ? false : _f, _g = props.allowNewText, allowNewText = _g === void 0 ? '' : _g, _h = props.filterBy, filterBy = _h === void 0 ? [] : _h, _j = props.labelKey, labelKey = _j === void 0 ? 'bezeichnung' : _j, _k = props.clearInput, clearInput = _k === void 0 ? function () { } : _k, _l = props.options, options = _l === void 0 ? [] : _l, paginationText = props.paginationText, emptyLabel = props.emptyLabel, renderMenuItemChildren = props.renderMenuItemChildren, onSearch = props.onSearch, onInputChange = props.onInputChange, onChange = props.onChange, _m = props.inputType, inputType = _m === void 0 ? 'text' : _m, _o = props.searchButtonLabel, searchButtonLabel = _o === void 0 ? 'Suchen' : _o, subtitle = props.subtitle, hint = props.hint, message = props.message, muss = props.muss;
    var ref = useRef(null);
    var selectedValue = (value !== '' && valueSet && selected) ? [{ bezeichnung: value }] : [];
    return (jsx$1(FormWrapper$1, __assign$1({}, props, { children: jsx$1(InputGroupWrapper, { inputGroup: (jsx$1(Button$1, { style: { zIndex: 1 }, onClick: function () { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus(); }, disabled: !ueberschreibbar, type: "button", "aria-label": searchButtonLabel, title: searchButtonLabel, children: jsx$1(SvgSearch, {}) })), children: jsx$1(StyledTypeahead, { selected: selectedValue, isLoading: isLoading, onSearch: onSearch, onChange: onChange, onInputChange: onInputChange, placeholder: placeholder, id: "".concat(name, "-list"), options: options, disabled: !ueberschreibbar, emptyLabel: emptyLabel, paginationText: paginationText, searchText: "Suche...", promptText: "Suchbegriffe eingeben", delay: delay, minLength: minLength, ref: ref, labelKey: labelKey, renderMenuItemChildren: renderMenuItemChildren, inputProps: {
                    id: name,
                    type: inputType,
                    'aria-describedby': inputGenerateDescribedBy(name, subtitle, hint, error, message),
                    required: muss,
                }, filterBy: filterBy, useCache: false, isInvalid: Array.isArray(error), allowNew: allowNew, newSelectionPrefix: allowNewText, children: function (_a) {
                    var onClear = _a.onClear, text = _a.text;
                    return ueberschreibbar && (jsx$1("div", { className: "rbt-aux", children: !!text && (jsx$1(ClearButton, { label: "Eingabe l\u00F6schen", title: "Eingabe l\u00F6schen", onClick: function () {
                                clearInput();
                                onClear();
                            } })) }));
                } }) }) })));
};
var TypeaheadInput$1 = React__default.memo(TypeaheadInput);
var templateObject_1$b;

var FormRadioIcons = function (props) {
    var _a = props.stack, stack = _a === void 0 ? 'hstack' : _a, _b = props.valueSet, valueSet = _b === void 0 ? [] : _b, _c = props.inputClassName, inputClassName = _c === void 0 ? '' : _c, name = props.name, _d = props.ueberschreibbar, ueberschreibbar = _d === void 0 ? true : _d, value = props.value, onChange = props.onChange, error = props.error, customIcon = props.customIcon, customElement = props.customElement, customText = props.customText;
    return (jsx$1(FormWrapper$1, __assign$1({ labelClassName: "mb-2", formGroupAs: 'fieldset' }, props, { children: jsx$1(ButtonGroup, { className: "form-check-icons ".concat(stack, " gap-3 align-items-stretch"), children: valueSet.map(function (element) {
                var _a, _b;
                return (jsxs(ToggleButton, { type: "radio", variant: "none", id: "".concat(name, "-").concat(element.id), name: name, value: element.id, disabled: !ueberschreibbar, checked: element.id == value, onChange: onChange, className: "".concat(error ? 'is-invalid ' : '').concat(inputClassName), children: [(customIcon === null || customIcon === void 0 ? void 0 : customIcon[element.id]) && (jsx$1("div", { className: "form-check-icon", children: customIcon[element.id] })), ((_a = customElement === null || customElement === void 0 ? void 0 : customElement[element.id]) === null || _a === void 0 ? void 0 : _a.icon) && (jsx$1("div", { className: "form-check-icon", children: customElement[element.id].icon })), jsx$1("span", { className: "text-nowrap", dangerouslySetInnerHTML: {
                                __html: customText
                                    ? customText[element.id]
                                    : element.bezeichnung,
                            } }), ((_b = customElement === null || customElement === void 0 ? void 0 : customElement[element.id]) === null || _b === void 0 ? void 0 : _b.tooltip) && (jsx$1(Nowrap, { children: jsx$1(Tooltip, { handleTooltip: customElement[element.id].tooltip }) }))] }, element.id));
            }) }) })));
};

var FormRadioButtonGroup = function (_a) {
    var name = _a.name, valueSet = _a.valueSet, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.forceBlock, forceBlock = _e === void 0 ? false : _e, props = __rest$1(_a, ["name", "valueSet", "onChange", "value", "className", "forceBlock"]);
    var checked = function (val) {
        return parseInt(val.id, 10) === parseInt(value, 10);
    };
    return (jsx$1(FormWrapper$1, __assign$1({}, props, { name: name, className: "form-radio-button-group ".concat(className), children: jsx$1(ButtonGroup, { className: forceBlock ? 'force-block' : '', children: valueSet.map(function (element) { return (jsx$1(ToggleButton, { id: "radio-".concat(name, "-").concat(element.id), name: name, onChange: onChange, value: element.id, type: "radio", checked: checked(element), variant: checked(element) ? 'primary' : 'outline-secondary', children: element.bezeichnung }, element.id)); }) }) })));
};

var ErrorToast = function (_a) {
    var _b = _a.show, show = _b === void 0 ? false : _b, _c = _a.message, message = _c === void 0 ? '' : _c, _d = _a.onClose, onClose = _d === void 0 ? function () { } : _d;
    return (jsxs(Toast, { onClose: onClose, show: show, className: "error", children: [jsx$1(Toast.Header, { children: jsx$1("strong", { className: "me-auto", children: "\uD83D\uDED1 Es ist ein Fehler aufgetreten" }) }), jsx$1(Toast.Body, { children: message })] }));
};

var Bootstrap = function (_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b;
    if (navigator.cookieEnabled) {
        return children;
    }
    return (jsxs(Fragment, { children: [jsx$1("h3", { children: "Unser Rechner funktioniert nur mit Keksen" }), jsx$1("p", { children: jsx$1(SvgCookie, { style: { width: '150px' } }) }), jsx$1("p", { children: "Bitte erlauben Sie dieser Website die Nutzung von funktionalen Cookies, um den Rechner zu nutzen." })] }));
};
var index = React__default.memo(Bootstrap);

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const BankBemerkungFormText = _ref => {
  let {
    ...rest
  } = _ref;
  const bemerkung = useSelector(state => state.daten.bemerkung);
  const dispatch = useDispatch();
  if (!bemerkung.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormText, _extends({}, bemerkung, {
    name: "daten.bemerkung.value",
    title: "Bemerkungen",
    onChange: e => dispatch(updateByEvent(e)),
    maxLength: bemerkung.maxLenght,
    rows: "10",
    resize: "vertical"
  }, rest));
};

const BankDatenschutzFormCheck = _ref => {
  let {
    ...rest
  } = _ref;
  const datenschutz = useSelector(state => state.daten.datenschutz);
  const dispatch = useDispatch();
  if (!datenschutz.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h4", null, "Datenschutzhinweis"), /*#__PURE__*/React__default.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React__default.createElement(FormCheck, _extends({}, datenschutz, {
    name: "daten.datenschutz.value",
    title: "Ich habe die folgenden Informationen zur Verwendung meiner Daten zur Kenntnis genommen:",
    onChange: e => dispatch(updateByEvent(e)),
    className: "fw-light sp-child-w-100 mb-4"
  }, rest)), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("span", {
    className: "span-fix",
    dangerouslySetInnerHTML: {
      __html: i18next.t('datenschutz.textAnfang')
    }
  }), ' ', /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "link",
    onClick: () => dispatch(toggleModal(i18next.t('datenschutz.modal')))
  }, i18next.t('datenschutz.modalLinkText')), ' ', /*#__PURE__*/React__default.createElement("span", {
    className: "span-fix",
    dangerouslySetInnerHTML: {
      __html: i18next.t('datenschutz.textEnde')
    }
  }))));
};

const BankIbanFormKonto = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const kontoListe = useSelector(state => state.daten.kontoListe || null);
  const iban = useSelector(state => state.daten.bankVerbindung.iban);
  return iban.relevant && kontoListe && kontoListe.length > 0 && /*#__PURE__*/React__default.createElement(FormKonto$1, _extends({}, iban, {
    liste: kontoListe,
    title: "Konto",
    name: "daten.bankVerbindung.iban.value",
    onChange: e => {
      const neuesKonto = e.target.value === 'neu';
      dispatch(updateByName('daten.bankVerbindung.iban.value', neuesKonto ? '' : e.target.value));
      dispatch(updateByName('appDaten.neuesKonto', neuesKonto));
    }
  }, rest));
};

const BankIbanFormMask = _ref => {
  let {
    ...props
  } = _ref;
  const dispatch = useDispatch();
  const iban = useSelector(state => state.daten.bankVerbindung.iban);
  const kontoListe = useSelector(state => state.daten.kontoListe);
  const neuesKonto = useSelector(state => state.appDaten.neuesKonto);
  if (!iban.relevant) {
    return null;
  }
  return (neuesKonto || kontoListe?.length === 0 || trEnv$1.medial) && /*#__PURE__*/React__default.createElement(FormMask, _extends({}, iban, {
    name: "daten.bankVerbindung.iban.value",
    title: i18next.t('iban.titel'),
    onChange: e => dispatch(updateByEvent(e)),
    inputmask: {
      mask: 'DE99 9999 9999 9999 9999 99'
    },
    type: "text",
    inputMode: "numeric"
  }, props));
};

const BankInhaberFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const inhaber = useSelector(state => state.daten.bankVerbindung.inhaber);
  if (!inhaber.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormInput, _extends({}, inhaber, {
    title: "Kontoinhaber",
    name: "daten.bankVerbindung.inhaber.value",
    onChange: e => dispatch(updateByEvent(e)),
    labelClassName: "colon"
  }, rest));
};

var BankSepaFormCheck = function (_a) {
    var rest = __rest$1(_a, []);
    var dispatch = useDispatch();
    var sepa = useSelector(function (state) { return state.daten.bankVerbindung.sepa; });
    if (!sepa.relevant) {
        return null;
    }
    return (jsx$1(FormCheck, __assign$1({}, sepa, { name: "daten.bankVerbindung.sepa.value", title: "Hiermit erteile ich ein SEPA-Lastschriftmandat zum Einzug meiner Versicherungsbeitr\u00E4ge.", onChange: function (e) { return dispatch(updateByEvent(e)); }, className: "fw-light header-label mt-4 sp-child-w-100" }, rest, { children: jsx$1("p", { className: "mt-2", children: jsx$1("small", { dangerouslySetInnerHTML: { __html: i18next.t('sepa.text') } }) }) })));
};

const BankZahlartFormRadio = _ref => {
  let {
    onChange = () => {},
    ...rest
  } = _ref;
  const zahlart = useSelector(state => state.daten.bankVerbindung.zahlart);
  if (!zahlart.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormRadio, _extends({}, zahlart, {
    title: " ",
    name: "daten.bankVerbindung.zahlart.value",
    onChange: onChange
  }, rest));
};

const VpmsBankInhaberFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const vorname = useSelector(state => state.daten.bankverbindung.ktoVornameMetaInfo);
  const nachname = useSelector(state => state.daten.bankverbindung.ktoNachnameMetaInfo);
  if (!vorname.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormInput, _extends({}, vorname, {
    title: "Kontoinhaber",
    value: `${vorname.value} ${nachname.value}`,
    name: "daten.bankVerbindung.inhaberMetaInfo.value",
    ueberschreibbar: false,
    relevant: true,
    labelClassName: "colon",
    onChange: () => {}
  }, rest));
};

const VpmsBankSepaFormCheck = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const sepa = useSelector(state => state.daten.bankverbindung.sepaMetaInfo);
  if (!sepa.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormCheck, _extends({}, sepa, {
    name: "daten.bankverbindung.sepaMetaInfo.value",
    title: "Hiermit erteile ich ein SEPA-Lastschriftmandat zum Einzug meiner Versicherungsbeitr\xE4ge.",
    onChange: e => dispatch(updateByEvent(e)),
    className: "fw-light header-label mt-4 sp-child-w-100"
  }, rest), /*#__PURE__*/React__default.createElement("p", {
    className: "mt-2"
  }, /*#__PURE__*/React__default.createElement("small", {
    dangerouslySetInnerHTML: {
      __html: i18next.t('sepa.text')
    }
  })));
};

const VpmsBankIbanFormMask = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const iban = useSelector(state => state.daten.bankverbindung.ibanMetaInfo);
  const kontoListe = useSelector(state => state.daten.bankverbindung.kontolisteMetaInfo.value);
  const neuesKonto = useSelector(state => state.appDaten.neuesKonto);
  if (!iban.relevant) {
    return null;
  }
  return (neuesKonto || (kontoListe == null || kontoListe.length === 0) && iban.relevant) && /*#__PURE__*/React__default.createElement(FormMask, _extends({}, iban, {
    name: "daten.bankverbindung.ibanMetaInfo.value",
    title: i18next.t('iban.titel'),
    onChange: e => dispatch(updateByEvent(e)),
    inputmask: {
      mask: 'DE99 9999 9999 9999 9999 99'
    },
    type: "text",
    inputMode: "numeric"
  }, rest));
};

const PersonAnredeFormRadio = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const anrede = useSelector(state => state.daten.vn.anrede);
  if (!anrede.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormRadio, _extends({}, anrede, {
    id: "vn.anrede",
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.anrede.value",
    inline: true
  }, rest));
};

const PersonEmailFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const email = useSelector(state => state.daten.vn.email);
  if (!email.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormInput, _extends({}, email, {
    title: "E-Mail f\xFCr R\xFCckfragen und Best\xE4tigungsmail",
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.email.value",
    type: "email",
    autocomplete: "email",
    inputMode: "email"
  }, rest));
};

const PersonGeburtsdatumFormMask = _ref => {
  let {
    goToLink = null,
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const geburtsdatum = useSelector(state => state.daten.vn.geburtsdatum);
  if (!geburtsdatum.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormMask, _extends({}, geburtsdatum, {
    ueberschreibbar: false,
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.geburtsdatum.value",
    autocomplete: "bday",
    hint: /*#__PURE__*/React__default.createElement(If$1, {
      predicate: geburtsdatum.ueberschreibbar
    }, /*#__PURE__*/React__default.createElement(TextLinkButton$1, {
      goToLink: goToLink,
      text: "\xC4ndern",
      linkTo: "ErsteDaten"
    })),
    inputClassName: "input-date text-center"
  }, rest));
};

const PersonHausnummerFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const hausnummer = useSelector(state => state.daten.vn.hausnummer);
  if (!hausnummer.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormInput, _extends({}, hausnummer, {
    title: "Nr.",
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.hausnummer.value",
    className: `input-hausnr col-auto ${hausnummer.error ? 'error' : ''}`,
    autocomplete: "house-number"
  }, rest));
};

const PersonNachnameFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const nachname = useSelector(state => state.daten.vn.nachname);
  if (!nachname.relevant) {
    return null;
  }
  return nachname.relevant && /*#__PURE__*/React__default.createElement(FormInput, _extends({}, nachname, {
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.nachname.value",
    autocomplete: "family-name"
  }, rest));
};

const PersonOrtFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const ort = useSelector(state => state.daten.vn.ort);
  if (!ort.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormInput, _extends({}, ort, {
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.ort.value",
    className: `input-ort col ${ort.error ? 'error' : ''}`,
    autocomplete: "address-level2"
  }, rest));
};

var PersonPlzFormMask = function (_a) {
    var goToLink = _a.goToLink, rest = __rest$1(_a, ["goToLink"]);
    var dispatch = useDispatch();
    var postleitzahl = useSelector(function (state) { return state.daten.vn.postleitzahl; });
    if (!postleitzahl.relevant) {
        return null;
    }
    return (jsx$1(FormMask, __assign$1({}, postleitzahl, { ueberschreibbar: false, onChange: function (e) { return dispatch(updateByEvent(e)); }, name: "daten.vn.postleitzahl.value", className: "input-plz col-auto ".concat(postleitzahl.error ? 'error' : ''), inputmask: {
            mask: '99999',
            maskChar: '',
        }, autocomplete: "postal-code", hint: (jsx$1(If$1, { predicate: postleitzahl.ueberschreibbar, children: jsx$1(TextLinkButton$1, { goToLink: goToLink, text: "PLZ \u00E4ndern", linkTo: "ErsteDaten" }) })) }, rest)));
};

const PersonStrasseFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const strasse = useSelector(state => state.daten.vn.strasse);
  if (!strasse.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormInput, _extends({}, strasse, {
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.strasse.value",
    className: `input-strasse col ${strasse.error ? 'error' : ''}`,
    autocomplete: "street-address"
  }, rest));
};

const PersonTelefonFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const telefonNummer = useSelector(state => state.daten.vn.telefonNummer);
  if (!telefonNummer.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormInput, _extends({}, telefonNummer, {
    title: "Telefonnummer (freiwillig)",
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.telefonNummer.value",
    autocomplete: "tel",
    type: "tel",
    inputMode: "tel"
  }, rest));
};

const PersonTitelFormSelect = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const titel = useSelector(state => state.daten.vn.titel);
  if (!titel.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormSelect, _extends({}, titel, {
    onChange: e => dispatch(updateByEvent(e)),
    inputClassName: "input-date",
    name: "daten.vn.titel.value"
  }, rest));
};

var PersonStaatsangehoerigkeitFormSelect = function (_a) {
    var rest = __rest$1(_a, []);
    var dispatch = useDispatch();
    var staatsangehoerigkeit = useSelector(function (state) { return state.daten.vn.staatsangehoerigkeit; });
    if (!staatsangehoerigkeit.relevant) {
        return null;
    }
    return (jsx$1(FormCombobox, __assign$1({}, staatsangehoerigkeit, { onChange: function (select) { return dispatch(updateByName('daten.vn.staatsangehoerigkeit.value', select === null || select === void 0 ? void 0 : select.value)); }, name: "daten.vn.staatsangehoerigkeit.value" }, rest)));
};

const PersonVornameFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const vorname = useSelector(state => state.daten.vn.vorname);
  if (!vorname.relevant) {
    return null;
  }
  return vorname.relevant && /*#__PURE__*/React__default.createElement(FormInput, _extends({}, vorname, {
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.vorname.value",
    autocomplete: "given-name"
  }, rest));
};

const PersonZustellvermerkFormInput = _ref => {
  let {
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const zustellvermerk = useSelector(state => state.daten.vn.zustellvermerk);
  if (!zustellvermerk.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormInput, _extends({}, zustellvermerk, {
    onChange: e => dispatch(updateByEvent(e)),
    name: "daten.vn.zustellvermerk.value"
  }, rest));
};

var RechnungsempfaengerRadio = function (_a) {
    var rest = __rest$1(_a, []);
    var vorhanden = useSelector(function (state) { return state.daten.abwRechnungsempfaenger.vorhanden; });
    var dispatch = useDispatch();
    if (vorhanden.relevant) {
        return null;
    }
    return (jsx$1(FormRadio, __assign$1({}, vorhanden, { title: "", name: "daten.abwRechnungsempfaenger.vorhanden.value", onChange: function (e) { return dispatch(updateByEvent(e, function () { return dispatch(request('aktualisiereMetainfos')); })); }, className: "" }, rest)));
};

var ErsteDatenPlzFormMask = function (_a) {
    var rest = __rest$1(_a, []);
    var dispatch = useDispatch();
    var postleitzahl = useSelector(function (state) { return state.daten.vn.postleitzahl; });
    if (!postleitzahl.relevant) {
        return null;
    }
    return (jsx$1(FormMask, __assign$1({}, postleitzahl, { title: "Wie lautet Ihre Postleitzahl?", name: "daten.vn.postleitzahl.value", onChange: function (e) { return dispatch(updateByEvent(e)); }, inputmask: {
            mask: '99999',
            maskChar: '',
        }, placeholder: "PLZ", inputClassName: "input-plz text-center sp-me-30", type: "text", inputMode: "numeric", autocomplete: "postal-code" }, rest)));
};

var ErsteDatenGeburtsdatumFormMask = function (_a) {
    var _b = _a.relevant, relevant = _b === void 0 ? true : _b, rest = __rest$1(_a, ["relevant"]);
    var geburtsdatum = useSelector(function (state) { return state.daten.vn.geburtsdatum; });
    var dispatch = useDispatch();
    if (!geburtsdatum.relevant || !relevant) {
        return null;
    }
    return (jsx$1(FormMask, __assign$1({}, geburtsdatum, { title: "Wann wurden Sie geboren?", name: "daten.vn.geburtsdatum.value", onChange: function (e) { return dispatch(updateByEvent(e)); }, inputClassName: "input-date text-center sp-me-30", type: "text", inputMode: "numeric", placeholder: "TT.MM.JJJJ", autocomplete: "bday" }, rest)));
};

var ErsteDatenVersBeginnFormDatepicker = function (_a) {
    var _b = _a.minDate, minDate = _b === void 0 ? new Date(new Date().setDate(new Date().getDate() + 1)) : _b, _c = _a.maxDate, maxDate = _c === void 0 ? new Date(new Date().setFullYear(new Date().getFullYear() + 1)) : _c, rest = __rest$1(_a, ["minDate", "maxDate"]);
    var dispatch = useDispatch();
    var versBeginn = useSelector(function (state) { return state.daten.versBeginn; });
    if (!versBeginn.relevant) {
        return null;
    }
    return (jsx$1(FormDatePicker, __assign$1({}, versBeginn, { title: "Ab wann w\u00FCnschen Sie Versicherungs\u00ADschutz?", name: "daten.versBeginn.value", onChange: function (nam, val) { return dispatch(updateByName(nam, val)); }, onInputChange: function (e) { return dispatch(updateByEvent(e)); }, modifier: [
            { before: minDate },
            { after: maxDate },
        ], to: 1 }, rest)));
};

const PersonAdresseBlock = _ref => {
  let {
    strasse,
    hausnummer,
    plz,
    ort,
    zustellvermerk
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "g-3 position-relative"
  }, /*#__PURE__*/React__default.createElement(PersonStrasseFormInput, strasse), /*#__PURE__*/React__default.createElement(PersonHausnummerFormInput, hausnummer)), /*#__PURE__*/React__default.createElement(PersonZustellvermerkFormInput, zustellvermerk), /*#__PURE__*/React__default.createElement(Row, {
    className: "g-3 position-relative"
  }, /*#__PURE__*/React__default.createElement(PersonPlzFormMask, plz), /*#__PURE__*/React__default.createElement(PersonOrtFormInput, ort)));
};

var VorversicherungVSNRFormInput = function (_a) {
    var rest = __rest$1(_a, []);
    var dispatch = useDispatch();
    var vsnr = useSelector(function (state) { return state.daten.vorversicherung.vsnr; });
    if (!vsnr.relevant) {
        return null;
    }
    return (jsx$1(FormMask, __assign$1({}, vsnr, { name: "daten.vorversicherung.vsnr.value", onChange: function (e) { return dispatch(updateByEvent(e)); }, inputmask: {
            mask: '********************',
            maskChar: '',
        }, className: "mb-5" }, rest)));
};

var VorversicherungAuswahlFormRadio = function (_a) {
    var rest = __rest$1(_a, []);
    var dispatch = useDispatch();
    var auswahl = useSelector(function (state) { return state.daten.vorversicherung.auswahl; });
    if (!auswahl.relevant) {
        return null;
    }
    return (jsx$1(FormRadio, __assign$1({}, auswahl, { title: "Hatten oder haben Sie bereits eine Versicherung?", onChange: function (e) { return dispatch(updateByEvent(e)); }, name: "daten.vorversicherung.auswahl.value", className: "mb-5" }, rest)));
};

var ZusammenfassungErklaerung = function () { return (jsxs("div", { className: "angaben", children: [jsxs(If$1, { predicate: !trEnv$1.stationaer, children: [jsx$1("h4", { children: "Beratungsverzicht" }), jsx$1("p", { className: "text--small", children: "Sie m\u00F6chten online abschlie\u00DFen und verzichten auf eine pers\u00F6nliche Beratung und deren Dokumentation. Das kann sich nachteilig auf die M\u00F6glichkeit auswirken, Schaden\u00ADersatz\u00ADanspr\u00FCche wegen einer Verletzung der Beratungs- und Dokumen\u00ADtations\u00ADpflichten (\u00A7 6 Abs. 5 VVG) gegen uns geltend zu machen." })] }), jsx$1("h4", { children: "Information zur Verwendung Ihrer Daten" }), jsxs("p", { className: "text--small", children: ["Wir nutzen Ihre Daten ausschlie\u00DFlich im Rahmen unserer Datenschutzhinweise und unseres Datenschutzkodex \u2013 unter anderem zur Angebotserstellung und Durchf\u00FChrung Ihres Vertrages oder \u2013 in Einzelf\u00E4llen \u2013 f\u00FCr Anfragen bei Ihrem Vorversicherer. Au\u00DFerdem informieren wir Sie gelegentlich zu unseren Produkten per Post. Dieser Nutzung Ihrer Daten k\u00F6nnen Sie jederzeit per E-Mail an", ' ', i18next.t('anschrift.email'), ' ', "widersprechen."] }), jsx$1(If$1, { predicate: !trEnv$1.stationaer, children: jsx$1("p", { className: "text--small", children: "Sie haben die Information zur Verwendung Ihrer Daten auf der vorhergehenden Seite zur Kenntnis genommen." }) }), jsx$1("h4", { children: "Folgenden Verhaltenskodizes haben wir uns als Versicherer unterworfen" }), jsx$1("div", { className: "text--small", children: jsxs("ul", { className: "list-icn-square", children: [jsx$1("li", { children: jsx$1("a", { target: "_blank", rel: "noopener noreferrer", "data-tracking-name": "link-verhaltensregeln", href: i18next.t('datenschutz.datenschutzkodex'), children: "Verhaltensregeln f\u00FCr den Umgang mit personenbezogenen Daten durch die deutsche Versicherungswirtschaft" }) }), jsx$1("li", { children: jsx$1("a", { target: "_blank", rel: "noopener noreferrer", "data-tracking-name": "link-verhaltenskodex", href: i18next.t('datenschutz.verhaltenskodex'), children: "Verhaltenskodex des Gesamtverbandes der Deutschen Versicherungswirtschaft f\u00FCr den Vertrieb von Versicherungsprodukten" }) })] }) })] })); };

var ZusammenfassungPartner = function () { return (jsx$1(Card, { className: "mb-4 border-0", children: jsxs(Card.Body, { className: "card-body--padding", children: [jsx$1(Card.Title, { className: "mb-4", children: "Vertragspartner und Risiko\u00ADtr\u00E4ger" }), jsxs("p", { children: [i18next.t('anschrift.head'), jsx$1("br", {}), i18next.t('anschrift.subhead'), jsx$1("br", {}), i18next.t('anschrift.strasseHausnr'), jsx$1("br", {}), i18next.t('anschrift.plzOrt')] }), jsxs("p", { children: [i18next.t('anschrift.handelsregister'), jsx$1("br", {}), i18next.t('anschrift.rechtsform')] })] }) })); };

var ProduktvergleichZahlweiseFormSelect = function (_a) {
    var handleSelect = _a.handleSelect, rest = __rest$1(_a, ["handleSelect"]);
    var zahlweise = useSelector(function (state) { return state.daten.zahlweise; });
    if (!zahlweise.relevant) {
        return null;
    }
    return (jsx$1(FormSelect, __assign$1({}, zahlweise, { label: "Zahlweise", labelClassName: "fb-100 text-start", onChange: handleSelect, name: "daten.zahlweise.value", value: zahlweise.value, tooltipRight: true, flex: true }, rest)));
};

var ProduktvergleichProduktblaetter = function (_a) {
    var _b = _a.locale, locale = _b === void 0 ? 'produktvergleich.links' : _b;
    return (jsxs("div", { className: "sp-bg-white", children: [jsx$1("h4", { children: "Sie wollen es ganz genau wissen?" }), jsxs("p", { children: ["Hier finden Sie unsere detaillierte", ' ', jsx$1("span", { className: "inline-fix", dangerouslySetInnerHTML: {
                            __html: i18next.t("".concat(locale, ".leistungsuebersicht")),
                        } }), ", das\u00A0", jsx$1("span", { className: "inline-fix", dangerouslySetInnerHTML: {
                            __html: i18next.t("".concat(locale, ".infoBlatt")),
                        } }), ' ', "und die\u00A0", jsx$1("span", { className: "inline-fix", dangerouslySetInnerHTML: {
                            __html: i18next.t("".concat(locale, ".versBedingungen")),
                        } }), "."] })] }));
};
var ProduktvergleichProduktblaetter$1 = React__default.memo(ProduktvergleichProduktblaetter);

var ProduktvergleichBeratersuche = function (_a) {
    var deck = _a.deck, href = _a.href, _b = _a.buttonText, buttonText = _b === void 0 ? 'Mit persönlicher Beratung vor Ort abschließen' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? 'secondary' : _d, _e = _a.hasBeraterModal, hasBeraterModal = _e === void 0 ? false : _e;
    var dispatch = useDispatch();
    var vtnr = useSelector(function (state) { return state.appDaten.vtnr; });
    var handleOpenModal = function (e) {
        if (vtnr && hasBeraterModal) {
            e.preventDefault();
            dispatch(updateByName('appDaten.showBeraterModal', true));
        }
    };
    return (!trEnv$1.sparkasse && (jsxs(Button$1, { variant: variant, "data-tracking-name": "auswahlbutton-".concat(deck, "-beratersuche"), className: "produkt--beratung btn--animate btn-block mt-4 p-3 ".concat(className), target: "_blank", rel: "noopener noreferrer", href: href || i18next.t('footer.beratersuche'), onClick: handleOpenModal, children: [jsx$1("small", { children: buttonText }), ' ', jsx$1(SvgArrow, {})] })));
};
var ProduktvergleichBeratersuche$1 = React__default.memo(ProduktvergleichBeratersuche);

var Vertreter = function (_a) {
    var _b, _c;
    var vertreter = _a.vertreter, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (jsxs("div", { className: "lh-15 ".concat(className), children: [jsx$1("div", { className: "fw-normal", children: vertreter.name.value }), jsxs("div", { className: "fw-light", children: [vertreter.strasse.value, jsx$1("br", {}), vertreter.plz.value, ' ', vertreter.ort.value, jsx$1("br", {}), (_b = vertreter.telefon) === null || _b === void 0 ? void 0 : _b.value, jsx$1("br", {}), (_c = vertreter.email) === null || _c === void 0 ? void 0 : _c.value] })] }));
};
var Vertreter$1 = React__default.memo(Vertreter);

/**
 * Rendert eine IonForm und die Vertreterauswahl als Radiobutton
 *
 * @param onChange
 * @returns {React.Component}
 */
var StyledRadioButton$1 = styled(Form.Check)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  &&& {\n    ", "\n  }\n"], ["\n  &&& {\n    ", "\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n      .form-check-input {\n        display: none;\n      }\n      .form-check-label {\n        border: none !important;\n        padding: 0 !important;\n        color: inherit !important;\n        background-color: transparent !important;\n      }\n    ";
});
var Vertreterauswahl = function (_a) {
    var onRemove = _a.onRemove, onChange = _a.onChange, rest = __rest$1(_a, ["onRemove", "onChange"]);
    var amNaechsten = useSelector(function (state) { return state.daten.vertretersuche.amNaechsten; });
    var auswahl = useSelector(function (state) { return state.daten.vertretersuche.auswahl; });
    var suchfeld = useSelector(function (state) { return state.daten.vertretersuche.suchfeld; });
    if (trEnv$1.stationaer) {
        return null;
    }
    var isChecked = function (vertreterID) { return parseInt(vertreterID, 10) === parseInt(auswahl.id.value, 10); };
    return (jsx$1(FormWrapper$1, __assign$1({ error: auswahl.name.error, name: "Vertretersuche" }, rest, { children: jsx$1("div", { className: "vertreterauswahl", children: amNaechsten.map(function (vertreter) { return (jsxs("div", { style: {
                    position: 'relative',
                }, children: [jsx$1(StyledRadioButton$1, { type: "radio", name: "daten.vertretersuche.auswahl.value", id: vertreter.id.value, value: vertreter.id.value, "data-name": vertreter.name.value, "data-strasse": vertreter.strasse.value, "data-plz": vertreter.plz.value, "data-ort": vertreter.ort.value, "data-typ": vertreter.typ.value, label: jsx$1(Vertreter$1, { vertreter: vertreter }), checked: isChecked(vertreter.id.value), disabled: !suchfeld.relevant, onChange: onChange, className: isChecked(vertreter.id.value) ? 'checked ' : '', isInvalid: auswahl.name.error }), (suchfeld.relevant && isChecked(vertreter.id.value)) && (jsx$1(CloseButton, { style: {
                            position: 'absolute',
                            top: '5px',
                            right: '5px',
                        }, onClick: onRemove }))] }, vertreter.id.value)); }) }) })));
};
var templateObject_1$a;

var Vertretersuchform = function (_a) {
    var onChange = _a.onChange, rest = __rest$1(_a, ["onChange"]);
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var auswahl = useSelector(function (state) { return state.daten.vertretersuche.auswahl; });
    var suchfeld = useSelector(function (state) { return state.daten.vertretersuche.suchfeld; });
    var suchergebnisse = useSelector(function (state) { return state.daten.vertretersuche.suchergebnisse; });
    var dispatch = useDispatch();
    var handleSearch = function (query) {
        setIsLoading(true);
        dispatch(updateByName('daten.vertretersuche.suchfeld.value', query, function () {
            dispatch(holeBeratersuche(function () { return setIsLoading(false); }));
        }));
    };
    var clearInput = function () {
        dispatch(updateByName('daten.vertretersuche.suchfeld.value', '', function () {
            dispatch(holeBeratersuche());
        }));
    };
    return (suchfeld.relevant && (jsx$1(TypeaheadInput$1, __assign$1({}, suchfeld, { title: "Anderen Ansprechpartner suchen", searchButtonLabel: "Name suchen", labelClassName: "visually-hidden", value: auswahl.value, name: "daten.vertretersuche.suchfeld.value", onSearch: handleSearch, onChange: function (selected) { return onChange(selected); }, options: suchergebnisse, isLoading: isLoading, delay: 400, className: "mb-5", placeholder: "Anderen Ansprechpartner suchen", emptyLabel: "Kein Ansprechpartner gefunden", paginationText: "Mehr Ansprechpartner anzeigen", clearInput: clearInput, labelKey: function (option) { return "".concat(option.name.value); }, minLenght: 4, inputType: "search", renderMenuItemChildren: function (option, _a) {
            var text = _a.text;
            return (jsxs("div", { children: [jsx$1(Highlighter, { search: text, children: option.name.value }), jsxs("small", { children: [jsx$1(Highlighter, { search: text, children: option.ort.value }), ",", ' ', jsx$1(Highlighter, { search: text, children: option.strasse.value }), ",", ' ', option.plz.value] })] }, option.name.value));
        } }, rest))));
};

var ButtonMehrErfahren = function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'Mehr erfahren' : _b, _c = _a.tooltip, tooltip = _c === void 0 ? function () { } : _c, _d = _a.className, className = _d === void 0 ? '' : _d, size = _a.size, rest = __rest$1(_a, ["label", "tooltip", "className", "size"]);
    var dispatch = useDispatch();
    var target = useRef(null);
    var handleOnClick = function () {
        var _a;
        if (trEnv$1.sparkasse) {
            dispatch(updateByName('appDaten.tooltip_offset', (_a = target.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().y));
        }
        tooltip();
    };
    return (jsxs(Button$1, __assign$1({ variant: "link", size: size, className: "btn--animate ".concat(className), onClick: handleOnClick, ref: target }, rest, { children: [label, ' ', jsx$1(SvgArrow, {})] })));
};

var ArrowButton = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, _f = _a.size, size = _f === void 0 ? undefined : _f, _g = _a.dataTrackingName, dataTrackingName = _g === void 0 ? '' : _g, _h = _a.icon, icon = _h === void 0 ? null : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j, rest = __rest$1(_a, ["className", "label", "variant", "onClick", "size", "dataTrackingName", "icon", "disabled"]);
    return (jsxs(Button$1, __assign$1({ variant: variant, className: "btn--animate ".concat(className), onClick: onClick, size: size, "data-tracking-name": dataTrackingName, disabled: disabled }, rest, { children: [icon, label, ' ', jsx$1(SvgArrow, {})] })));
};
var ArrowButton$1 = React__default.memo(ArrowButton);

var OrtFormCombobox = function (_a) {
    var data = _a.data, name = _a.name, ueberschreibbar = _a.ueberschreibbar;
    // Wenn ueberschreibbar nicht gesetzt, dann das Attribut vom Objekt benutzen
    var edit = ueberschreibbar === undefined ? data.ueberschreibbar : ueberschreibbar;
    return (jsx$1(FormCombobox, __assign$1({}, data, { onChange: useUpdateByNameAndValidateOnChange(), title: "Ort", name: name, className: "input-ort col ".concat(data.error ? 'error' : ''), createable: true, ueberschreibbar: edit })));
};
var OrtFormCombobox$1 = React__default.memo(OrtFormCombobox);

var PostleitzahlFormMask = function (_a) {
    var data = _a.data, name = _a.name, ueberschreibbar = _a.ueberschreibbar, _b = _a.linkTo, linkTo = _b === void 0 ? '' : _b;
    // Wenn ueberschreibbar nicht gesetzt, dann das Attribut vom Objekt benutzen
    var edit = ueberschreibbar === undefined ? data.ueberschreibbar : ueberschreibbar;
    return (jsx$1(FormMask, __assign$1({}, data, { onChange: useUpdateAndValidatePlzOnChange(), title: "PLZ", name: name, className: "input-plz col-auto ".concat(data.error ? 'error' : ''), inputmask: {
            mask: '99999',
            maskChar: '',
        }, autocomplete: "postal-code", ueberschreibbar: edit, hint: (jsx$1(If$1, { predicate: linkTo !== '', children: jsx$1(TextLinkButton$1, { goToLink: useGotoPage(), text: "\u00C4ndern", linkTo: linkTo }) })) })));
};
var PostleitzahlFormMask$1 = React__default.memo(PostleitzahlFormMask);

var HausnummerformInput = function (_a) {
    var data = _a.data, name = _a.name, ueberschreibbar = _a.ueberschreibbar;
    // Wenn ueberschreibbar nicht gesetzt, dann das Attribut vom Objekt benutzen
    var edit = ueberschreibbar === undefined ? data.ueberschreibbar : ueberschreibbar;
    return (jsx$1(FormInput, __assign$1({}, data, { title: "Nr.", onChange: useUpdateAndValidateOnChange(), name: name, className: "input-hausnr col-auto ".concat(data.error ? 'error' : ''), autocomplete: "house-number", ueberschreibbar: edit })));
};
var HausnummerFormInput = React__default.memo(HausnummerformInput);

var StrasseFormCombobox = function (_a) {
    var data = _a.data, name = _a.name, ueberschreibbar = _a.ueberschreibbar;
    var dispatch = useDispatch();
    // Alles vor dem ersten Punkt (daten.) und nach dem letzten Punkt (.value) entfernen
    // Angepasster Name wird für die Validierung benötigt
    var validierung = name.substring(name.indexOf('.') + 1, name.lastIndexOf('.'));
    var inputChange = function (val) {
        if (val !== '') {
            dispatch(updateByName(name, val));
            dispatch(serverValidationRequest('validiere', [validierung], function () { }));
        }
    };
    // Wenn ueberschreibbar nicht gesetzt, dann das Attribut vom Objekt benutzen
    var edit = ueberschreibbar === undefined ? data.ueberschreibbar : ueberschreibbar;
    return (jsx$1(FormCombobox, __assign$1({}, data, { onInputChange: inputChange, onChange: useUpdateByNameAndValidateOnChange(), title: "Stra\u00DFe", name: name, className: "input-strasse col ".concat(data.error ? 'error' : ''), createable: true, ueberschreibbar: edit })));
};
var StrasseFormCombobox$1 = React__default.memo(StrasseFormCombobox);

var AdresseForm = function (_a) {
    var postleitzahl = _a.postleitzahl, postleitzahlName = _a.postleitzahlName, postleitzahlUeberschreibbar = _a.postleitzahlUeberschreibbar, _b = _a.postleitzahlLinkTo, postleitzahlLinkTo = _b === void 0 ? '' : _b, ort = _a.ort, ortName = _a.ortName, ortUeberschreibbar = _a.ortUeberschreibbar, strasse = _a.strasse, strasseName = _a.strasseName, strasseUeberschreibbar = _a.strasseUeberschreibbar, hausnummer = _a.hausnummer, hausnummerName = _a.hausnummerName, hausnummerUeberschreibbar = _a.hausnummerUeberschreibbar, children = _a.children;
    return (jsxs(Fragment, { children: [jsxs(Row, { className: "g-3 position-relative", children: [jsx$1(PostleitzahlFormMask$1, { data: postleitzahl, name: postleitzahlName, ueberschreibbar: postleitzahlUeberschreibbar, linkTo: postleitzahlLinkTo }), jsx$1(OrtFormCombobox$1, { data: ort, name: ortName, ueberschreibbar: ortUeberschreibbar })] }), jsx$1(If$1, { predicate: Array.isArray(postleitzahl.warning), children: jsx$1(Message$1, { show: true, text: "<p>".concat(postleitzahl.warning, "</p>"), dismissible: false, className: "mt-n1" }) }), jsxs(Row, { className: "g-3 position-relative", children: [jsx$1(StrasseFormCombobox$1, { data: strasse, name: strasseName, ueberschreibbar: strasseUeberschreibbar }), jsx$1(HausnummerFormInput, { data: hausnummer, name: hausnummerName, ueberschreibbar: hausnummerUeberschreibbar }), children] })] }));
};
var AdresseForm$1 = React__default.memo(AdresseForm);

var BeraterIcon = styled(SvgBerater)(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  && {\n    height: 100px;\n    width: 100px;\n    margin: 0 auto .5rem auto;\n    display: block;\n    .qmark {\n      fill: #ffffff;\n    }\n  }\n"], ["\n  && {\n    height: 100px;\n    width: 100px;\n    margin: 0 auto .5rem auto;\n    display: block;\n    .qmark {\n      fill: #ffffff;\n    }\n  }\n"])));
var Seite;
(function (Seite) {
    Seite[Seite["EINS"] = 1] = "EINS";
    Seite[Seite["ZWEI"] = 2] = "ZWEI";
    Seite[Seite["DREI"] = 3] = "DREI";
})(Seite || (Seite = {}));
var BeraterModalWindow = function (_a) {
    var container = _a.container, _b = _a.show, show = _b === void 0 ? false : _b, setShow = _a.setShow;
    var dispatch = useDispatch();
    var kontakt = useSelector(function (state) { return state.daten.kontakt; });
    var suchfeld = useSelector(function (state) { return state.daten.vertretersuche.suchfeld; });
    var kundenstatus = useSelector(function (state) { return state.daten.kundenstatus; });
    var auswahl = useSelector(function (state) { return state.daten.vertretersuche.auswahl; });
    var vtnr = useSelector(function (state) { return state.appDaten.vtnr; });
    var _c = useState(Seite.EINS), page = _c[0], setPage = _c[1];
    var istVertreter = trEnv$1.vtnr || vtnr;
    var handleClose = function () {
        setShow(false);
        setPage(Seite.EINS);
    };
    var handleKundenstatus = function (e) {
        dispatch(updateByEvent(e, function () {
            dispatch(serverValidationRequest(EnumActions.VU_BERATER_VALIDIERE, [
                'kundenstatus',
            ]));
        }));
    };
    var handleNext = function () {
        dispatch(serverValidationRequest(EnumActions.VU_BERATER_VALIDIERE, [
            'kontakt.name',
            'kontakt.freitext',
            'kontakt.postleitzahl',
        ], function () {
            setPage(Seite.ZWEI);
        }));
    };
    var vertreterSave = function () {
        dispatch(serverValidationRequest(EnumActions.VU_BERATER_VALIDIERE, [
            'vertretersuche.auswahl.id',
            'vertretersuche.auswahl.name',
            'vertretersuche.auswahl.strasse',
            'vertretersuche.auswahl.plz',
            'vertretersuche.auswahl.typ',
            'vertretersuche.auswahl.ort',
        ]));
    };
    var handleSend = function () {
        dispatch(serverValidationRequest(EnumActions.VU_BERATER_SENDE, [
            'kontakt.datenschutz',
            'vertretersuche.auswahl.id',
            'vertretersuche.auswahl.name',
            'vertretersuche.auswahl.strasse',
            'vertretersuche.auswahl.plz',
            'vertretersuche.auswahl.typ',
            'vertretersuche.auswahl.ort',
        ], function () {
            setPage(Seite.DREI);
        }));
    };
    return (jsxs(Modal$1, { dialogClassName: "tooltip-dialog", show: show, container: container ? container.current : function () { return document.querySelector('.bs-iso'); }, onHide: handleClose, centered: true, animation: false, backdrop: "static", className: "backdrop-close-animation", children: [jsx$1(Modal$1.Header, { closeButton: true }), jsxs(Modal$1.Body, { children: [page !== Seite.DREI && (jsx$1(BeraterIcon, { className: "berater-icon" })), page === Seite.EINS && (jsxs(Fragment, { children: [jsx$1("h4", { children: "Fragen zum Produkt oder noch unsicher? Lassen Sie sich beraten!" }), jsx$1(FormInput, __assign$1({}, kontakt.name, { label: "Wie ist ihr Name?", required: true, name: "daten.kontakt.name.value", onChange: function (e) { return dispatch(updateByEvent(e)); } })), jsx$1(FormInput, __assign$1({}, kontakt.freitext, { label: "Wie k\u00F6nnen wir Sie erreichen?", subtitle: "Telefonnummer, E-Mail oder beides.", required: true, name: "daten.kontakt.freitext.value", onChange: function (e) { return dispatch(updateByEvent(e)); } })), jsxs(If$1, { predicate: kontakt.postleitzahl.relevant, children: [jsx$1("h4", { children: "Wo suchen Sie einen Ansprechpartner?" }), jsx$1("p", { children: "Die folgenden Angaben werden nicht gespeichert. Sie dienen nur zur Auswahl eines Ansprechpartners in Ihrer N\u00E4he:" }), jsx$1(AdresseForm$1, { postleitzahl: kontakt.postleitzahl, postleitzahlName: "daten.kontakt.postleitzahl.value", ort: kontakt.ort, ortName: "daten.kontakt.ort.value", strasse: kontakt.strasse, strasseName: "daten.kontakt.strasse.value", hausnummer: kontakt.hausnummer, hausnummerName: "daten.kontakt.hausnummer.value" })] }), jsx$1("p", { children: jsx$1("strong", { children: "* Pflichtfeld" }) }), jsx$1(ArrowButton$1, { label: istVertreter ? 'Weiter' : 'Ansprechpartner suchen', onClick: handleNext })] })), page === Seite.ZWEI && (jsxs(Fragment, { children: [jsx$1(If$1, { predicate: kundenstatus.relevant, children: jsx$1(FormRadio, __assign$1({}, kundenstatus, { label: "Sind Sie bereits unser Kunde?", name: "daten.kundenstatus.value", className: "mb-5", onChange: handleKundenstatus })) }), jsxs(If$1, { predicate: auswahl.id.relevant, children: [jsx$1(Vertreterauswahl, { label: !suchfeld.relevant
                                            ? 'Ich berate Sie gerne persönlich:'
                                            : 'Von wem möchten Sie beraten werden?', className: "mb-5", labelClassName: "mb-3 sp-pt-3", onChange: function (_a) {
                                            var target = _a.target;
                                            dispatch(updateByList({
                                                'daten.vertretersuche.auswahl.name.value': target.dataset.name,
                                                'daten.vertretersuche.auswahl.strasse.value': target.dataset.strasse,
                                                'daten.vertretersuche.auswahl.plz.value': target.dataset.plz,
                                                'daten.vertretersuche.auswahl.ort.value': target.dataset.ort,
                                                'daten.vertretersuche.auswahl.typ.value': target.dataset.typ,
                                                'daten.vertretersuche.auswahl.id.value': target.value,
                                            }, function () {
                                                vertreterSave();
                                                dispatch(request(EnumActions.VU_BERATER_VALIDIERE));
                                            }));
                                        }, onRemove: function () {
                                            dispatch(updateByList({
                                                'daten.vertretersuche.auswahl.name.value': '',
                                                'daten.vertretersuche.auswahl.strasse.value': '',
                                                'daten.vertretersuche.auswahl.plz.value': '',
                                                'daten.vertretersuche.auswahl.ort.value': '',
                                                'daten.vertretersuche.auswahl.typ.value': '',
                                                'daten.vertretersuche.auswahl.id.value': '',
                                                'daten.vertretersuche.suchfeld.value': '',
                                            }, function () {
                                                dispatch(request(EnumActions.VU_BERATER_VALIDIERE));
                                            }));
                                        } }), jsx$1(Vertretersuchform, { onChange: function (val) { return dispatch(updateByList({
                                            'daten.vertretersuche.auswahl.name.value': val.length ? val[0].name.value : '',
                                            'daten.vertretersuche.auswahl.strasse.value': val.length ? val[0].strasse.value : '',
                                            'daten.vertretersuche.auswahl.plz.value': val.length ? val[0].plz.value : '',
                                            'daten.vertretersuche.auswahl.ort.value': val.length ? val[0].ort.value : '',
                                            'daten.vertretersuche.auswahl.typ.value': val.length ? val[0].typ.value : '',
                                            'daten.vertretersuche.auswahl.id.value': val.length ? val[0].id.value : '',
                                        }, function () {
                                            dispatch(request(EnumActions.VU_BERATER_VALIDIERE));
                                        })); } })] }), jsx$1(If$1, { predicate: kontakt.datenschutz.relevant, children: jsx$1(FormCheck, __assign$1({}, kontakt.datenschutz, { title: "Ich willige ein, dass meine angegebenen Kontaktdaten sowie die von mir\n                bisher eingegebenen Daten zum Versicherungsprodukt an den von mir\n                ausgew\u00E4hlten Vertriebspartner der ".concat(i18next.t('datenschutz.modalLinkText'), " weitergeleitet werden, damit dieser\n                mich im Zusammenhang mit dem betreffenden Versicherungsprodukt kontaktiert\n                und zum Zweck der Angebotserstellung beraten kann. Die Einwilligung kann\n                jederzeit ohne Angabe von Gr\u00FCnden gegen\u00FCber dem von mir ausgew\u00E4hlten\n                Vertriebspartner mit Wirkung f\u00FCr die Zukunft widerrufen werden.\n                Verarbeitungen, die bis zum Zeitpunkt des Widerrufs erfolgt sind,\n                bleiben rechtm\u00E4\u00DFig und davon unber\u00FChrt."), name: "daten.kontakt.datenschutz.value", onChange: function (e) { return dispatch(updateByEvent(e)); }, className: "mb-5", children: jsx$1(ButtonMehrErfahren, { label: "Mehr Informationen", href: i18next.t('datenschutz.berater'), target: "_blank", className: "mt-2 text-decoration-underline", "data-tracking-name": "berater-modal-link-mehr-erfahren" }) })) }), jsx$1("div", { children: jsx$1(ArrowButton$1, { label: "Daten absenden", onClick: handleSend }) })] })), page === Seite.DREI && (jsxs(Fragment, { children: [jsx$1("h4", { children: "Vielen Dank!" }), jsx$1("p", { children: "Sie erhalten in K\u00FCrze eine R\u00FCckmeldung." }), jsx$1("div", { children: jsx$1(ArrowButton$1, { label: "Schlie\u00DFen", onClick: handleClose }) })] }))] })] }));
};
var templateObject_1$9;

var ProduktvergleichBeratersucheModal = function (_a) {
    var _b = _a.buttonText, buttonText = _b === void 0 ? 'Mit persönlicher Beratung vor Ort abschließen' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? 'secondary' : _d, size = _a.size;
    var _e = useState(false), show = _e[0], setShow = _e[1];
    var handleShow = function () {
        setShow(true);
    };
    if (trEnv$1.sparkasse) {
        return null;
    }
    return (jsxs(Fragment, { children: [jsxs(Button$1, { variant: variant, "data-tracking-name": "auswahlbutton-vertreterabsprung", className: "btn--animate btn-block mt-4 p-3 ".concat(className), onClick: handleShow, size: size, children: [buttonText, ' ', jsx$1(SvgArrow, {})] }), jsx$1(BeraterModalWindow, { show: show, setShow: setShow })] }));
};
var ProduktvergleichBeratersucheModal$1 = React__default.memo(ProduktvergleichBeratersucheModal);

var ProduktvergleichAngebotsdruck = function (_a) {
    var deck = _a.deck, size = _a.size, _b = _a.labelMedial, labelMedial = _b === void 0 ? 'Angebot herunterladen' : _b, _c = _a.labelStationaer, labelStationaer = _c === void 0 ? 'Angebotsdruck' : _c, handleClick = _a.handleClick, _d = _a.className, className = _d === void 0 ? '' : _d;
    var _e = useState(false), disabled = _e[0], setDisabled = _e[1];
    var disableClick = function (e) {
        handleClick(e);
        setDisabled(true);
        window.setTimeout(function () { return setDisabled(false); }, 2000);
    };
    return (jsxs(Button$1, { size: size, variant: "link", "data-tracking-name": "auswahlbutton-".concat(deck, "-angebotsdruck"), className: "produkt--angebotsdruck btn--animate mt-3 ".concat(className), disabled: disabled, onClick: disableClick, children: [trEnv$1.sparkasse ? labelStationaer : labelMedial, ' ', jsx$1(SvgArrow, {})] }));
};
var ProduktvergleichAngebotsdruck$1 = React__default.memo(ProduktvergleichAngebotsdruck);

var StyledAuflistung = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  && {\n    font-weight: 300;\n    line-height: 1.5rem;\n    &.mark {\n      background-color: var(--primary);\n      color: #fff;\n      margin-left: -1rem;\n      margin-right: -1rem;\n      padding-left: 1rem;\n      padding-right: 1rem;\n      .btn-primary {\n        color: #fff !important;\n        &:hover svg {\n          border-color: #fff !important;\n        }\n      }\n    }\n    &.seperator > div {\n      flex-grow: 1;\n    }\n    @media (max-width: 767px) {\n      .no-wrap {\n        margin-left: auto;\n      }\n      .fw-sm-bolder {\n        color: var(--label-color);\n      }\n    }\n    @media (min-width: 768px) {\n      &:not(.seperator) {\n        padding-right: 1.5rem;\n      }\n      &.mark {\n        padding-right: 2.5rem;\n      }\n      .has-hint {\n        margin-right: -10px;\n      }\n      .has-tooltip {\n        margin-right: -3px;\n        .btn-tooltip {\n          position: absolute;\n          margin-top: 2px;\n        }\n      }\n      .colon::after {\n        content: \":\";\n        display: inline !important;\n      }\n    }\n  }\n"], ["\n  && {\n    font-weight: 300;\n    line-height: 1.5rem;\n    &.mark {\n      background-color: var(--primary);\n      color: #fff;\n      margin-left: -1rem;\n      margin-right: -1rem;\n      padding-left: 1rem;\n      padding-right: 1rem;\n      .btn-primary {\n        color: #fff !important;\n        &:hover svg {\n          border-color: #fff !important;\n        }\n      }\n    }\n    &.seperator > div {\n      flex-grow: 1;\n    }\n    @media (max-width: 767px) {\n      .no-wrap {\n        margin-left: auto;\n      }\n      .fw-sm-bolder {\n        color: var(--label-color);\n      }\n    }\n    @media (min-width: 768px) {\n      &:not(.seperator) {\n        padding-right: 1.5rem;\n      }\n      &.mark {\n        padding-right: 2.5rem;\n      }\n      .has-hint {\n        margin-right: -10px;\n      }\n      .has-tooltip {\n        margin-right: -3px;\n        .btn-tooltip {\n          position: absolute;\n          margin-top: 2px;\n        }\n      }\n      .colon::after {\n        content: \":\";\n        display: inline !important;\n      }\n    }\n  }\n"])));
var ProduktAuflistung = function (_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.inhalt, inhalt = _c === void 0 ? '' : _c, tooltip = _a.tooltip, _d = _a.relevant, relevant = _d === void 0 ? true : _d, _e = _a.strong, strong = _e === void 0 ? false : _e, _f = _a.messageShow, messageShow = _f === void 0 ? false : _f, message = _a.message, _g = _a.mark, mark = _g === void 0 ? false : _g, _h = _a.className, className = _h === void 0 ? '' : _h, _j = _a.labelClassName, labelClassName = _j === void 0 ? '' : _j, _k = _a.contentClassName, contentClassName = _k === void 0 ? '' : _k, _l = _a.dangerouslySetInnerHTML, dangerouslySetInnerHTML = _l === void 0 ? true : _l, _m = _a.alignItems, alignItems = _m === void 0 ? 'end' : _m;
    var strongLabel = strong ? "<strong>".concat(label, "</strong>") : label;
    var strongInhalt = strong ? "<strong>".concat(inhalt, "</strong>") : inhalt;
    return (relevant
        && (jsxs(Fragment, { children: [jsxs(StyledAuflistung, { className: "auflistung d-md-flex justify-content-between gap-1 gap-md-0 align-items-".concat(alignItems, " ").concat(className, " ").concat(mark ? 'mark' : ''), children: [jsxs("div", { className: "d-flex", children: [dangerouslySetInnerHTML ? jsx$1("span", { className: "d-before-after-none ".concat(strong ? '' : 'fw-sm-bolder', " ").concat(labelClassName), dangerouslySetInnerHTML: { __html: strongLabel } }) : strongLabel, tooltip && (jsx$1(Nowrap, { children: jsx$1(Tooltip, { className: "ms-2 d-md-none", handleTooltip: tooltip }) }))] }), strongInhalt && (jsxs("div", { className: "text-md-end ".concat(contentClassName), children: [dangerouslySetInnerHTML ? jsx$1("span", { className: "d-before-after-none", dangerouslySetInnerHTML: { __html: strongInhalt } }) : strongInhalt, tooltip && (jsx$1(Nowrap, { children: jsx$1(Tooltip, { className: "ms-2 d-none d-sm-none d-md-inline-block", handleTooltip: tooltip }) }))] }))] }), message
                    && (jsx$1(Message$1, { show: messageShow, text: message, dismissible: false, className: "text--small p-3" }))] })));
};
var templateObject_1$8;

var ProduktAuflistungWrapper = function (_a) {
    var children = _a.children, _b = _a.hasTooltips, hasTooltips = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return (jsx$1("div", { className: "produktvergleich__leistungen d-flex flex-column gap-3 gap-md-2 ".concat(hasTooltips ? 'hasTooltips' : '', " ").concat(className), children: children }));
};

var BeantragenWiderrufsbelehrung = function () {
    var dispatch = useDispatch();
    return (jsxs("div", { className: "mt-6", children: [jsx$1("h4", { children: "3. Klicken Sie unten auf den Button, um Ihren Antrag an uns abzusenden:" }), jsxs("p", { children: ["Sie k\u00F6nnen Ihren Vertrag innerhalb von 14 Tagen widerrufen. Die Widerrufsbelehrung finden Sie im Versicherungsschein.", ' ', jsxs(Button$1, { variant: "link", className: "btn--animate", "data-tracking-name": "modal-widerrufsrecht", onClick: function () { return dispatch(toggleModal(i18next.t('widerrufsrecht'))); }, children: ["Mehr erfahren", ' ', jsx$1(SvgArrow, {})] })] }), jsx$1("p", { children: "Bei Klick auf den Button werden Ihre Daten an uns \u00FCbermittelt. Sie geben eine rechts\u00ADverbindliche Erkl\u00E4rung ab, welche Sie bei Annahme Ihres Antrages durch den Versicherer zur Zahlung des Versicherungsbeitrages verpflichtet." }), jsx$1("p", { children: "Das Antragsdokument wird Ihnen nach Abschluss des Prozesses zur Verf\u00FCgung gestellt. S\u00E4mtliche vertragsrelevanten Dokumente werden auch durch den Versicherer gespeichert und Ihnen bei Bedarf zur Verf\u00FCgung gestellt." })] }));
};

var Beratungsverzicht = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, rest = __rest$1(_a, ["className"]);
    var beratungsverzicht = useSelector(function (state) { return state.daten.beratungsverzicht; });
    var dispatch = useDispatch();
    if (!beratungsverzicht.relevant) {
        return null;
    }
    return (jsx$1(Card, { className: "mb-4 mt-4 mandant-border bg-transparent ".concat(className), children: jsxs(Card.Body, { className: "sp-p-0", children: [jsx$1(Card.Title, { className: "fw-normal mb-1", children: jsxs("h2", { className: "h4 headline", children: ["Beratungsverzicht", ' ', jsx$1(Tooltip, { handleTooltip: function () { return dispatch(toggleModal(i18next.t('beratungsverzicht_tt'))); }, id: "tooltip-beratungsverzicht" })] }) }), jsxs("div", { className: "beratungsverzicht", children: [jsxs("p", { className: "mini mb-4", children: ["Nach dem Versicherungsvertragsgesetz (VVG) \u00A7 6 Absatz 1 und 2 sind wir verpflichtet, Sie zu beraten und dies zu dokumentieren. Wenn Sie jedoch hier schnell und bequem online abschlie\u00DFen m\u00F6chten, verzichten Sie darauf. Wir weisen Sie darum darauf hin, dass sich ein Verzicht nachteilig auf Ihre M\u00F6glichkeit auswirken kann, gegen uns als Ihren Versicherer einen Schadensersatzanspruch nach \u00A7 6 Absatz 5 VVG geltend zu machen \u2013 und zwar wegen der Verletzung einer Pflicht aus einer sonst angebotenen Beratung.", ' ', trEnv$1.sparkasse ? 'Sprechen Sie Ihren Sparkassenberater vor Ort an.' : (jsx$1("a", { "data-tracking-name": "beratungsverzicht-link-kontaktformular", rel: "noreferrer noopener", href: i18next.t('footer.kontaktformular'), target: "_blank", className: "arrow-icon", children: "Sprechen Sie uns an" }))] }), jsx$1(FormCheck, __assign$1({}, beratungsverzicht, { name: "daten.beratungsverzicht.value", title: "Ich m\u00F6chte online abschlie\u00DFen und verzichte auf eine pers\u00F6nliche Beratung.", onChange: function (e) { return dispatch(updateByEvent(e)); }, className: "mw-100 sp-child-w-100 checkbox-button" }, rest))] })] }) }));
};

var ProduktauswahlButton = function (_a) {
    var _b = _a.tracking, tracking = _b === void 0 ? '' : _b, handleClick = _a.handleClick, _c = _a.ohneBeratung, ohneBeratung = _c === void 0 ? true : _c, _d = _a.subtext, subtext = _d === void 0 ? 'ohne persönliche Beratung' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.buttonText, buttonText = _f === void 0 ? 'Auswählen und weiter' : _f, _g = _a.className, className = _g === void 0 ? '' : _g;
    return (jsxs(Button$1, { className: "btn--produktauswahl btn--animate btn-block p-3 ".concat(className), onClick: handleClick, "data-tracking-name": "auswahlbutton-".concat(tracking), disabled: disabled, children: [buttonText, (!trEnv$1.stationaer && ohneBeratung) && (jsxs(Fragment, { children: [jsx$1("br", {}), jsx$1("small", { children: subtext })] })), ' ', jsx$1(SvgArrow, {})] }));
};
var ProduktauswahlButton$1 = React__default.memo(ProduktauswahlButton);

var TooltipList = function (_a) {
    var _b = _a.listType, listType = _b === void 0 ? 'checkbullet' : _b, listElements = _a.listElements, _c = _a.className, className = _c === void 0 ? '' : _c, size = _a.size;
    var dispatch = useDispatch();
    return listElements.length > 0 && (jsx$1("ul", { className: "list-icn-".concat(listType, " ").concat(className, " overflow-li-hidden tooltip-list mb-0"), children: listElements.map(function (element) { return (jsxs("li", { className: "d-flex align-items-start", children: [jsx$1("div", { className: "me-1", dangerouslySetInnerHTML: { __html: element.bezeichnung } }), element.tooltipText && (jsx$1(Tooltip, { className: "tooltip--right ms-auto", handleTooltip: function () { return dispatch(toggleModal(element.tooltipText, size)); }, id: "tooltip-".concat(element.bezeichnung.toLowerCase()) }))] }, element.bezeichnung)); }) }));
};
var TooltipList$1 = React__default.memo(TooltipList);

var ProduktvergleichBeitragHeadline = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children;
    return (jsx$1("h3", { className: "card-headline mb-1 sp-font-normal ".concat(className), children: children }));
};

var ProduktvergleichBeitragBetrag = function (_a) {
    var beitrag = _a.beitrag;
    var zahlweise = useSelector(function (state) { return state.daten.zahlweise; });
    return (jsxs(Fragment, { children: [jsx$1("span", { className: "text-nowrap", children: beitrag && toMoney(beitrag.value) }), ' ', jsx$1("small", { children: findValueById(zahlweise.valueSet, zahlweise.value) })] }));
};

var ProduktvergleichBeitrag = function (_a) {
    var beitrag = _a.beitrag, _b = _a.inline, inline = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return (trEnv$1.sparkasse && (jsxs(ProduktvergleichBeitragHeadline, { className: "sp-font-size-18 mb-2 ".concat(className), children: ["Ihr Beitrag", !inline ? jsx$1("br", {}) : ':', ' ', jsx$1(ProduktvergleichBeitragBetrag, { beitrag: beitrag })] })));
};

var StyledSummingUp = styled(Col)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  .card {\n    background: transparent;\n\n    &-img-top {\n      border-top-left-radius: 4px;\n      border-top-right-radius: 4px;\n      & + .card-body {\n        margin-top: -6px;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n      }\n    }\n\n    &-body {\n      background: #edf0f4;\n      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);\n      h4 {\n        color: #151217;\n        font-size: 1.125rem;\n        font-weight: normal;\n        border-bottom: 1px solid lightgrey;\n        margin-bottom: 0.7rem;\n        padding-bottom: 0.7rem;\n      }\n      .text-dark {\n        color: #151217 !important;\n      }\n      .btn-link {\n        width: 100%;\n      }\n    }\n\n    .summingup-list {\n      margin-left: 0;\n      list-style: none;\n      margin-bottom: 0;\n\n      span,\n      small{\n        display: block;\n        font-size: 14px;\n        color: #A4A6AB;\n        line-height: 1.5rem;\n      }\n\n      li {\n        line-height: 1.5rem;\n        list-style-type: none;\n        padding-left: 2.5rem;\n        padding-top: 14px;\n        padding-bottom: 7px;\n        position: relative;\n        font-size: 17px;\n        color: #151217;\n        &:first-child {\n          padding-top: 0;\n        }\n        &:last-child {\n          padding-bottom: 0;\n        }\n        &:before {\n          content: '';\n          left: 0;\n          position: absolute;\n          height: 1.5rem;\n          width: 1.5rem;\n          background-color: transparent !important;\n          border: 2px solid #666666;\n          border-radius: 30px;\n        }\n        &.checked{\n          color: #FF0000;\n          &:before {\n            background-color: #FF0000 !important;\n            border: 0;\n          }\n        }\n        &:not(:last-child) {\n          border-bottom: 1px solid lightgrey;\n        }\n      }\n    }\n  }\n"], ["\n  .card {\n    background: transparent;\n\n    &-img-top {\n      border-top-left-radius: 4px;\n      border-top-right-radius: 4px;\n      & + .card-body {\n        margin-top: -6px;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n      }\n    }\n\n    &-body {\n      background: #edf0f4;\n      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);\n      h4 {\n        color: #151217;\n        font-size: 1.125rem;\n        font-weight: normal;\n        border-bottom: 1px solid lightgrey;\n        margin-bottom: 0.7rem;\n        padding-bottom: 0.7rem;\n      }\n      .text-dark {\n        color: #151217 !important;\n      }\n      .btn-link {\n        width: 100%;\n      }\n    }\n\n    .summingup-list {\n      margin-left: 0;\n      list-style: none;\n      margin-bottom: 0;\n\n      span,\n      small{\n        display: block;\n        font-size: 14px;\n        color: #A4A6AB;\n        line-height: 1.5rem;\n      }\n\n      li {\n        line-height: 1.5rem;\n        list-style-type: none;\n        padding-left: 2.5rem;\n        padding-top: 14px;\n        padding-bottom: 7px;\n        position: relative;\n        font-size: 17px;\n        color: #151217;\n        &:first-child {\n          padding-top: 0;\n        }\n        &:last-child {\n          padding-bottom: 0;\n        }\n        &:before {\n          content: '';\n          left: 0;\n          position: absolute;\n          height: 1.5rem;\n          width: 1.5rem;\n          background-color: transparent !important;\n          border: 2px solid #666666;\n          border-radius: 30px;\n        }\n        &.checked{\n          color: #FF0000;\n          &:before {\n            background-color: #FF0000 !important;\n            border: 0;\n          }\n        }\n        &:not(:last-child) {\n          border-bottom: 1px solid lightgrey;\n        }\n      }\n    }\n  }\n"])));
var SummingUp = function (_a) {
    var children = _a.children, _b = _a.nobanner, nobanner = _b === void 0 ? false : _b, buttons = _a.buttons, bannerImg = _a.bannerImg;
    return (jsx$1(StyledSummingUp, { lg: { span: 9 }, className: "summingup d-none d-md-block oev-hide spk-show", children: jsxs(Card, { className: "border-0 mb-4", children: [jsxs("div", { className: "d-none d-lg-block", children: [(!nobanner && bannerImg) && jsx$1(Card.Img, { variant: "top", src: bannerImg() }), jsx$1(Card.Body, { children: children })] }), buttons] }) }));
};
var SummingUp$1 = React__default.memo(SummingUp);
var templateObject_1$7;

var SummingUpKundendaten = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Daten des Versicherungsnehmers' : _b;
    var vn = useSelector(function (state) { return state.daten.vn; });
    return (jsxs(Fragment, { children: [jsx$1("h4", { className: "text-center", children: title }), jsxs("ul", { className: "list-unstyled", children: [jsxs("li", { children: [jsxs("span", { className: "text-dark", children: [vn.vorname.relevant && 'Vorname', (vn.vorname.relevant && vn.nachname.relevant) && ', ', vn.nachname.relevant && 'Name', ":", ' '] }), "".concat(vn.vorname.value, " ").concat(vn.nachname.value)] }), jsxs("li", { children: [jsx$1("span", { className: "text-dark", children: "Stra\u00DFe und Hausnr.: " }), "".concat(vn.strasse.value, " ").concat(vn.hausnummer.value)] }), jsxs("li", { children: [jsx$1("span", { className: "text-dark", children: "PLZ und Ort: " }), "".concat(vn.postleitzahl.value, " ").concat(vn.ort.value)] }), jsx$1(If$1, { predicate: vn.geburtsdatum.relevant, children: jsxs("li", { children: [jsx$1("span", { className: "text-dark", children: "Geburtsdatum: " }), vn.geburtsdatum.value] }) })] })] }));
};

var SummingUpButtonLink = function (_a) {
    var href = _a.href, onClick = _a.onClick, title = _a.title, icon = _a.icon, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return (jsxs(Fragment, { children: [jsx$1("hr", { className: "my-3" }), jsxs(Button$1, { href: href, onClick: onClick, className: "btn--animate ".concat(className), target: href ? '_blank' : undefined, disabled: disabled, rel: href ? 'noopener noreferrer' : undefined, variant: "link", children: [icon, title, ' ', jsx$1(SvgArrow, {})] })] }));
};
var SummingUpButtonLink$1 = React__default.memo(SummingUpButtonLink);

var SummingUpVersichertePerson = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Daten der versicherten Person' : _b;
    var vp = useSelector(function (state) { return state.daten.versichertePerson; });
    return (jsxs(Fragment, { children: [jsx$1("h4", { className: "text-center", children: title }), jsxs("ul", { className: "list-unstyled", children: [jsxs("li", { children: [jsx$1("span", { className: "text-dark", children: "Vorname, Name: " }), "".concat(vp.vorname.value, " ").concat(vp.nachname.value)] }), jsxs("li", { children: [jsx$1("span", { className: "text-dark", children: "Stra\u00DFe und Hausnr.: " }), "".concat(vp.strasse.value, " ").concat(vp.hausnummer.value)] }), jsxs("li", { children: [jsx$1("span", { className: "text-dark", children: "PLZ und Ort: " }), "".concat(vp.postleitzahl.value, " ").concat(vp.ort.value)] }), jsxs("li", { children: [jsx$1("span", { className: "text-dark", children: "Geburtsdatum: " }), vp.geburtsdatum.value] })] })] }));
};

var NeuordnungModal = function (_a) {
    var container = _a.container, _b = _a.getUKZ, getUKZ = _b === void 0 ? function () { return '0102-***.***.***'; } : _b, _c = _a.buttonLabel, buttonLabel = _c === void 0 ? 'Neuordnung' : _c;
    var vsnrAltvertrag = useSelector(function (state) { return state.daten.vsnrAltvertrag; });
    var vorgangsart = useSelector(function (state) { return state.daten.vorgangsart; });
    var hauptfaelligkeit = useSelector(function (state) { return state.daten.hauptfaelligkeitVorvertrag; });
    var dispatch = useDispatch();
    var validateOnChange = useUpdateAndValidateOnChange();
    var _d = useState(false), show = _d[0], setShow = _d[1];
    var onButtonClick = function () {
        dispatch(serverValidationRequest(EnumActions.VALIDIERE, ['vsnrAltvertrag'], function () {
            setShow(false);
        }));
    };
    var handleClose = function () {
        setShow(false);
    };
    var handleShow = function () {
        setShow(true);
    };
    var disabled = istEnumAuswahl(vorgangsart, EnumVorgangsart.NEUORDNUNG);
    if (!trEnv$1.stationaer) {
        return null;
    }
    return (jsxs(Fragment, { children: [jsx$1(SummingUpButtonLink$1, { onClick: handleShow, title: buttonLabel, icon: jsx$1(SvgNeuordnung, { style: { height: '2rem', width: '2rem', marginRight: '5px' } }), disabled: disabled, className: "text-primary" }), jsxs(Modal$1, { show: show, container: container.current, centered: false, onHide: handleClose, size: "lg", backdrop: "static", backdropCloseAnimation: true, children: [jsx$1(Modal$1.Header, { closeButton: true, className: "modal-has-title", children: jsx$1(Modal$1.Title, { children: "Bestehenden Vertrag neuordnen." }) }), jsxs(Modal$1.Body, { children: [jsx$1(FormMask, __assign$1({}, vsnrAltvertrag, { title: "Bitte geben Sie die Vertragsnummer des neuzuordnenden Vertrages ein:", name: "daten.vsnrAltvertrag.value", onChange: function (e) { return dispatch(updateByEvent(e)); }, onKeyDown: function (e) {
                                    onEnter(e, function () { return onButtonClick(); });
                                }, inputmask: {
                                    mask: getUKZ(),
                                } })), jsx$1(If$1, { predicate: hauptfaelligkeit === null || hauptfaelligkeit === void 0 ? void 0 : hauptfaelligkeit.relevant, children: jsx$1(FormRadio, __assign$1({}, hauptfaelligkeit, { title: "Soll die Hauptf\u00E4lligkeit des Vorvertrages beibehalten werden?", name: "daten.hauptfaelligkeitVorvertrag.value", onChange: validateOnChange, className: "mb-5" })) }), jsx$1("hr", { className: "mb-0 mx-n3" }), jsxs("div", { className: "mt-3 d-flex justify-content-between", children: [jsx$1(Button$1, { variant: "secondary", onClick: function () { return setShow(false); }, children: "Zur\u00FCck" }), jsx$1(Button$1, { onClick: onButtonClick, children: "Weiter" })] })] })] })] }));
};

var padTime = function (time) { return (String(time).length === 1 ? "0".concat(time) : "".concat(time)); };
var format = function (time) {
    var minutes = Math.floor(time / 60);
    var seconds = time % 60;
    return "".concat(minutes, ":").concat(padTime(seconds), " min");
};
var AutomatischSpeichernModal = function (_a) {
    var _b = _a.speichern, speichern = _b === void 0 ? function () { } : _b;
    var _c = useState(false), show = _c[0], setShow = _c[1];
    var _d = useState(15 * 60), counter = _d[0], setCounter = _d[1];
    var style = {
        color: 'var(--primary)',
    };
    /** Modal nach 10 Minuten öffnen */
    useEffect(function () {
        window.setTimeout(function () {
            setShow(true);
        }, 10 * 60 * 1000);
        window.setTimeout(function () {
            speichern();
        }, 15 * 60 * 1000);
    }, []);
    /** Countdown aktualisieren */
    useEffect(function () {
        var timer;
        if (counter > 0) {
            timer = window.setTimeout(function () { return setCounter(function (c) { return c - 1; }); }, 1000);
        }
        return function () {
            if (timer) {
                window.clearTimeout(timer);
            }
        };
    }, [counter]);
    return (jsx$1(Modal$1, { show: show, container: function () { return document.querySelector('.bs-iso'); }, centered: false, onHide: function () { return setShow(false); }, size: "lg", backdrop: "static", backdropCloseAnimation: true, children: jsxs(Modal$1.Body, { className: "text-center", children: [jsx$1("h4", { style: style, children: "Bitte denken Sie daran, den Antrag nach der Unterschrift freizugeben oder den Vorgang zu speichern." }), jsx$1("p", { className: "mb-0 mt-4", style: style, children: "Die Anwendung wird in" }), jsx$1("strong", { style: style, children: format(counter) }), jsx$1("p", { style: style, children: "automatisch gespeichert und beendet." }), jsx$1("div", { className: "mt-4 d-flex justify-content-center", children: jsx$1(Button$1, { onClick: function () { return setShow(false); }, children: "Meldung schlie\u00DFen" }) })] }) }));
};

var QesButton = function (_a) {
    var _b = _a.buttonJalabel, buttonJalabel = _b === void 0 ? 'Ja, weiter zur eUnterschrift' : _b, _c = _a.buttonNeinlabel, buttonNeinlabel = _c === void 0 ? 'Nein' : _c, _d = _a.className, className = _d === void 0 ? 'mb-5' : _d;
    var dispatch = useDispatch();
    var qes = useSelector(function (state) { return state.daten.qes; });
    var gesperrt = useSelector(function (state) { return state.daten.gesperrt; });
    var gespeichertAm = useSelector(function (state) { return state.daten.gespeichertAm; });
    if (((gesperrt === null || gesperrt === void 0 ? void 0 : gesperrt.value) && (gespeichertAm === null || gespeichertAm === void 0 ? void 0 : gespeichertAm.value)) || isEmptyObj(qes) || !(qes === null || qes === void 0 ? void 0 : qes.relevant) || !(qes === null || qes === void 0 ? void 0 : qes.value)) {
        return null;
    }
    var signieren = function () {
        dispatch(request('signiereDokumente', function () { return window.OSPlusNeo.reportSuccess(); }));
    };
    return (jsxs(Fragment, { children: [jsx$1("h2", { className: "h4 headline", children: "Wollen Sie den Antrag elektronisch unterschreiben?" }), jsxs(FormWrapper$1, { error: qes.error, className: className, name: "QES", children: [jsx$1(ArrowButton$1, { label: buttonJalabel, onClick: signieren, disabled: !qes.ueberschreibbar }), jsx$1(Button$1, { onClick: function () { return dispatch(updateByName('appDaten.qesUnterschreiben', false)); }, disabled: !qes.ueberschreibbar, variant: "secondary", className: "ms-3", children: buttonNeinlabel })] })] }));
};

var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spreadArray$1(__spreadArray$1([], __read(acc), false), __read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var es = {};

var hasRequiredEs;

function requireEs () {
	if (hasRequiredEs) return es;
	hasRequiredEs = 1;

	es.__esModule = true;

	es.default = function (file, acceptedFiles) {
	  if (file && acceptedFiles) {
	    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');

	    if (acceptedFilesArray.length === 0) {
	      return true;
	    }

	    var fileName = file.name || '';
	    var mimeType = (file.type || '').toLowerCase();
	    var baseMimeType = mimeType.replace(/\/.*$/, '');
	    return acceptedFilesArray.some(function (type) {
	      var validType = type.trim().toLowerCase();

	      if (validType.charAt(0) === '.') {
	        return fileName.toLowerCase().endsWith(validType);
	      } else if (validType.endsWith('/*')) {
	        // This is something like a image/* mime type
	        return baseMimeType === validType.replace(/\/.*$/, '');
	      }

	      return mimeType === validType;
	    });
	  }

	  return true;
	};
	return es;
}

var esExports = requireEs();
var _accepts = /*@__PURE__*/getDefaultExportFromCjs(esExports);

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
var accepts = typeof _accepts === "function" ? _accepts : _accepts.default; // Error codes

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || accepts(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone$1 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React__default.createElement(Fragment$1, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone$1.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false,
  autoFocus: false
};
Dropzone$1.defaultProps = defaultProps;
Dropzone$1.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}

var getColor = function (props) {
    if (props.isDragAccept) {
        return '#00e676';
    }
    if (props.isDragReject) {
        return '#ff1744';
    }
    if (props.isFocused) {
        return '#2196f3';
    }
    return '#eeeeee';
};
var Dropzone = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  border-width: 2px;\n  border-radius: 2px;\n  border-color: ", ";\n  border-style: dashed;\n  background-color: #fafafa;\n  color: #bdbdbd;\n  outline: none;\n  transition: border .24s ease-in-out;\n  flex-shrink: 0;\n  \n   svg,\n  .spinner-border{\n    height: 50px;\n    width: 50px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  border-width: 2px;\n  border-radius: 2px;\n  border-color: ", ";\n  border-style: dashed;\n  background-color: #fafafa;\n  color: #bdbdbd;\n  outline: none;\n  transition: border .24s ease-in-out;\n  flex-shrink: 0;\n  \n   svg,\n  .spinner-border{\n    height: 50px;\n    width: 50px;\n  }\n"])), function (props) { return getColor(props); });
var Files = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  --bs-progress-height: .5rem;\n  \n  .list-group-item {\n    --bs-list-group-item-padding-y: 1rem;\n    --bs-list-group-item-padding-x: .25rem;\n  }\n  \n  .filetype {\n    height: 40px;\n    width: 40px;\n  }\n  \n  .file-label {\n    margin-top: 2px;\n  }\n\n  small {\n    font-size: 0.875rem !important;\n  }\n  \n  .filesize {\n    font-size: .75rem;\n    line-height: 1rem;\n    margin: 0 5px;\n  }\n  \n  .file-actions {\n    .btn {\n      width: 25px;\n      height: 25px;\n      padding: 0;\n    }\n    \n    .klassifizierung {\n      width: 165px;\n      .form-control {\n        height: 25px;\n        padding-top:0;\n        padding-bottom: 0;\n        width: 100% !important;\n      }\n    }\n  }\n"], ["\n  --bs-progress-height: .5rem;\n  \n  .list-group-item {\n    --bs-list-group-item-padding-y: 1rem;\n    --bs-list-group-item-padding-x: .25rem;\n  }\n  \n  .filetype {\n    height: 40px;\n    width: 40px;\n  }\n  \n  .file-label {\n    margin-top: 2px;\n  }\n\n  small {\n    font-size: 0.875rem !important;\n  }\n  \n  .filesize {\n    font-size: .75rem;\n    line-height: 1rem;\n    margin: 0 5px;\n  }\n  \n  .file-actions {\n    .btn {\n      width: 25px;\n      height: 25px;\n      padding: 0;\n    }\n    \n    .klassifizierung {\n      width: 165px;\n      .form-control {\n        height: 25px;\n        padding-top:0;\n        padding-bottom: 0;\n        width: 100% !important;\n      }\n    }\n  }\n"])));
var FileUpload = function (_a) {
    var _b = _a.direktUpload, direktUpload = _b === void 0 ? false : _b, _c = _a.hasFileError, hasFileError = _c === void 0 ? false : _c, _d = _a.setFileErrorCallback, setFileErrorCallback = _d === void 0 ? function () { } : _d;
    var dispatch = useDispatch();
    var _e = useState([]), filesToUpload = _e[0], setFilesToUpload = _e[1];
    var _f = useState([]), progress = _f[0], setProgress = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var _h = useState(false), showError = _h[0], setShowError = _h[1];
    var uploadedFiles = useSelector(function (state) { return state.appDaten.files; });
    var hasFilesToUpload = filesToUpload.length > 0;
    var hasUploadedFiles = uploadedFiles.length > 0;
    /*
    const handleUpload = () => {
      setLoading(true);
      const progressInfo = progress;
      filesToUpload.forEach((file: any, index) => {
        const formData = new FormData();
        formData.append('file', file);
  
        const onUploadProgress = (progressEvent: any) => {
          const { loaded, total } = progressEvent;
          const percentage = Math.floor((loaded * 100) / total);
          progress[index] = { ...progress[index], percentage };
          setProgress([...progressInfo]);
        };
  
        dispatch(appActions.uploadFile(formData, onUploadProgress, (response) => {
          //setLoading(false);
          console.log("callback");
          dispatch(updateByName('appDaten.files', response.files));
        }));
      });
    };
  
     */
    var handleUpload = useCallback(function () {
        setLoading(true);
        var progressInfo = progress;
        filesToUpload.forEach(function (file, index) {
            var formData = new FormData();
            formData.append('file', file);
            var onUploadProgress = function (progressEvent) {
                console.log(progressEvent);
                var loaded = progressEvent.loaded, total = progressEvent.total;
                var percentage = Math.floor((loaded * 100) / total);
                progress[index] = __assign$1(__assign$1({}, progress[index]), { percentage: percentage });
                setProgress(__spreadArray$1([], progressInfo, true));
            };
            dispatch(uploadFile(formData, onUploadProgress, function (response) {
                setLoading(false);
                console.log('callback');
                dispatch(updateByName('appDaten.files', response.files));
            }));
        });
    }, [filesToUpload]);
    useEffect(function () {
        setShowError(hasFileError);
    }, [hasFileError]);
    useEffect(function () {
        if (direktUpload && filesToUpload.length > 0) {
            handleUpload();
        }
    }, [filesToUpload]);
    // Wenn alle Dateien 100% erreichen, loading auf false setzen
    useEffect(function () {
        console.log('useEffect progress', progress);
        if (progress.length > 0 && progress.every(function (obj) { return obj.percentage === 100; })) {
            console.log('alle 100%');
            setLoading(false);
            // setFilesToUpload([]);
            // setProgress([]);
        }
    }, [progress]);
    // Wenn alle Dateien hochgeladen wurden, Arrays files und progress leeren
    useEffect(function () {
        if (!loading) {
            setFilesToUpload([]);
            setProgress([]);
        }
    }, [loading]);
    var onDrop = useCallback(function (acceptedFiles) {
        if (acceptedFiles.length > 0) {
            setFilesToUpload(acceptedFiles);
            var progressInfo = acceptedFiles.map(function (file) { return ({
                percentage: 0,
                fileName: file.name,
            }); });
            setProgress(progressInfo);
        }
    }, [filesToUpload]);
    var _j = useDropzone({
        accept: { 'application/pdf': ['.pdf'] },
        maxFiles: 1,
        disabled: loading,
        onDrop: onDrop,
        noClick: true,
    }), getRootProps = _j.getRootProps, getInputProps = _j.getInputProps, isFocused = _j.isFocused, isDragAccept = _j.isDragAccept, isDragReject = _j.isDragReject, open = _j.open;
    var deleteFile$1 = function (id) { return function () {
        dispatch(deleteFile(id, function (response) {
            dispatch(updateByName('appDaten.files', response.files));
        }));
    }; };
    var updateFile$1 = function (id, e) {
        dispatch(updateFile(id, e.target.value, function (response) {
            dispatch(updateByName('appDaten.files', response.files));
            if (showError) {
                setShowError(false);
                setFileErrorCallback(false);
            }
        }));
    };
    var getResponseFiles = function () {
        if (hasUploadedFiles) {
            return uploadedFiles.map(function (file) { return ({
                name: file.fileName.value,
                size: file.fileSize.value,
                id: file.id,
                klassifizierung: __assign$1({}, file.klassifizierung),
            }); }).reverse();
        }
        return [];
    };
    var openFileDialog = function () {
        if (uploadedFiles.some(function (obj) { var _a; return ((_a = obj.klassifizierung) === null || _a === void 0 ? void 0 : _a.value) === -1; })) {
            setShowError(true);
            return;
        }
        open();
    };
    var getListItem = function (file, index) {
        var _a, _b, _c;
        return (jsxs(ListGroup.Item, { className: "d-flex gap-2", children: [jsx$1(SvgFilePdf, { className: "filetype flex-shrink-0" }), jsxs("div", { className: "flex-fill", children: [jsxs("div", { className: "d-md-flex", children: [jsxs("div", { children: [jsx$1("div", { className: "file-label text-break sp-label-color", children: file.name }), jsx$1(If$1, { predicate: file.id != null, children: jsx$1("small", { className: "mt-1", children: "".concat(Math.round(file.size / 1000), " KB") }) })] }), jsxs("div", { className: "d-flex gap-2 ms-auto file-actions", children: [jsx$1(If$1, { predicate: !file.id, children: jsx$1("small", { children: "".concat((_a = progress[index]) === null || _a === void 0 ? void 0 : _a.percentage, " % von ").concat(Math.round(file.size / 1000), " KB") }) }), jsx$1(If$1, { predicate: file.id != null, children: jsxs(Fragment, { children: [jsx$1(Button$1, { variant: "icon", title: "L\u00F6schen", size: "sm", className: "rounded-circle", onClick: deleteFile$1(file.id), disabled: loading, children: jsx$1(SvgTrashSolid, { "aria-hidden": "true" }) }), jsx$1(FormSelect, __assign$1({}, file.klassifizierung, { onChange: function (e) { return updateFile$1(file.id, e); }, className: "klassifizierung mb-0", inputClassName: "input-date", name: "appDaten.files.".concat(index, ".klassifizierung.value"), placeholder: "Bitte ausw\u00E4hlen...", ueberschreibbar: !loading, error: (showError && ((_b = file.klassifizierung) === null || _b === void 0 ? void 0 : _b.value) === -1) ? 'Angabe der Dokumenten&shy;klasse fehlt!' : '' }))] }) })] })] }), jsx$1(If$1, { predicate: !file.id, children: jsx$1("div", { className: "d-flex", children: jsx$1(ProgressBar, { className: "w-100 mt-1", animated: true, variant: "primary", now: (_c = progress[index]) === null || _c === void 0 ? void 0 : _c.percentage }) }) })] })] }, file.id ? file.id : "".concat(file.name, "-").concat(index)));
    };
    return (jsxs("div", { className: "d-flex align-items-start mb-5 gap-3", children: [jsxs(Dropzone, __assign$1({}, getRootProps({ isFocused: isFocused, isDragAccept: isDragAccept, isDragReject: isDragReject }), { children: [jsx$1("input", __assign$1({}, getInputProps())), loading ? (jsx$1(Spinner, { as: "span", animation: "border", role: "status", "aria-hidden": "true", className: "mb-2" })) : (jsx$1(SvgFileArrowUpSolid, { className: "mb-2", "aria-hidden": "true" })), jsx$1(Button$1, { disabled: loading, onClick: openFileDialog, children: direktUpload ? 'Datei hochladen' : 'Datei auswählen' }), jsx$1("small", { className: "mt-2 mini", children: "(Oder PDF hier ablegen)" })] })), jsxs(Files, { className: "flex-fill", children: [hasFilesToUpload && (jsx$1(ListGroup, { variant: "flush", className: "".concat(uploadedFiles.length > 0 ? 'border-bottom' : ''), children: filesToUpload.map(function (file, index) { return getListItem(file, index); }) })), hasUploadedFiles && (jsx$1(ListGroup, { variant: "flush", children: getResponseFiles().map(function (file, index) { return getListItem(file, index); }) })), (!direktUpload && hasFilesToUpload) && (jsxs(Button$1, { className: "mt-2", onClick: handleUpload, disabled: loading, children: ["Datei hochladen", ' ', loading ? (jsx$1(Spinner, { as: "span", animation: "border", size: "sm", role: "status", "aria-hidden": "true" })) : ''] }))] })] }));
};
var templateObject_1$6, templateObject_2$2;

var DokumenteFileUpload = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'my-5' : _b, _c = _a.hasFileError, hasFileError = _c === void 0 ? false : _c, _d = _a.setFileErrorCallback, setFileErrorCallback = _d === void 0 ? function () { } : _d;
    var dispatch = useDispatch();
    var qes = useSelector(function (state) { return state.daten.qes; });
    var files = useSelector(function (state) { return state.appDaten.files; });
    var filesCheckbox = useSelector(function (state) { return state.appDaten.filesCheckbox; });
    return (jsxs(Fragment, { children: [jsxs("p", { className: className, children: [jsx$1("strong", { children: "Einfach und schnell:" }), ' ', "Laden Sie hier die notwendigen Dokumente hoch, um sie direkt an die", ' ', trEnv$1.istOEVO ? i18next.t('mandantLang') : i18next.t('mandant'), ' ', "weiterzuleiten. Eine \u00DCbersicht der", ' ', (qes === null || qes === void 0 ? void 0 : qes.ueberschreibbar) ? 'zusätzlich zum Antrag' : '', ' ', "erforderlichen Dokumente finden Sie", ' ', jsx$1(Button$1, { variant: "link", onClick: function () { return dispatch(toggleModal(i18next.t('dokumenteFileUpload_tt'))); }, children: "hier" }), "."] }), jsx$1(FileUpload, { direktUpload: true, hasFileError: hasFileError, setFileErrorCallback: setFileErrorCallback }), jsx$1(If$1, { predicate: !(files.length > 0), children: jsx$1(FormCheck, { name: "appDaten.filesCheckbox", label: jsx$1("span", { dangerouslySetInnerHTML: { __html: i18next.t('fileUploadCheckbox_label') } }), onChange: function (e) { return dispatch(updateByEvent(e)); }, value: filesCheckbox, className: "header-label fw-light sp-child-w-100", ueberschreibbar: true }) })] }));
};

var BedingungsvergleichButton = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b;
    if (!trEnv$1.stationaer) {
        return null;
    }
    var btnClassName = variant === 'link' ? 'link me-4' : 'btn-animate float-end';
    return (jsxs(Button$1, { className: btnClassName, href: i18next.t('bedingungsvergleich'), target: "_blank", rel: "noreferrer", variant: variant, children: [variant === 'link' ? jsx$1(SvgDokumentensuche, {}) : null, ' ', "Bedingungsvergleich"] }));
};

var SpkButtons = function (_a) {
    var _b, _c, _d;
    var _e = _a.bedingungsvergleich, bedingungsvergleich = _e === void 0 ? true : _e, _f = _a.showBtnZwischenspeichern, showBtnZwischenspeichern = _f === void 0 ? true : _f;
    var dispatch = useDispatch();
    var obj = useBreadcrumb();
    var callOSPlusNeoAndExit = function (serviceName) {
        dispatch(request(serviceName, function () {
            window.OSPlusNeo.reportSuccess();
        }, function () {
            window.OSPlusNeo.reportError();
        }));
    };
    var speichern = function (e) {
        e.preventDefault();
        callOSPlusNeoAndExit(EnumActions.OSPLUS_SPEICHERE);
    };
    var termin = function (e) {
        e.preventDefault();
        callOSPlusNeoAndExit(EnumActions.OSPLUS_TERMIN);
    };
    return (jsxs("div", { className: "spkbutton", children: [((_b = obj.active) === null || _b === void 0 ? void 0 : _b.buttons.save) && trEnv$1.ifiliale && (jsxs(Button$1, { variant: "link", className: "link me-4", onClick: termin, children: [jsx$1(SvgCalendar, {}), ' ', "Termin vereinbaren"] })), (((_c = obj.active) === null || _c === void 0 ? void 0 : _c.buttons.save) && trEnv$1.stationaer && bedingungsvergleich) && jsx$1(BedingungsvergleichButton, { variant: "link" }), ((_d = obj.active) === null || _d === void 0 ? void 0 : _d.buttons.save)
                && (trEnv$1.stationaer || trEnv$1.banking)
                && showBtnZwischenspeichern && (jsxs(Button$1, { variant: "link", className: "link", onClick: speichern, children: [jsx$1(SvgSave, {}), ' ', "Zwischenspeichern"] }))] }));
};

var BegleitdatenModalNeuesModell = function (_a) {
    var _b, _c, _d;
    var onChange = _a.onChange;
    var dispatch = useDispatch();
    var spkBegleitdaten = useSelector(function (state) { return state.daten.spkBegleitdaten; });
    if (!trEnv$1.stationaer) {
        return null;
    }
    return (jsxs(Fragment, { children: [jsx$1("hr", { className: "my-3" }), jsxs(Modal, { buttonText: (jsxs(Fragment, { children: ["Begleitdaten", jsx$1(SvgArrow, { className: "float-end" }), (((_b = spkBegleitdaten === null || spkBegleitdaten === void 0 ? void 0 : spkBegleitdaten.vertragsabschliessendeOE) === null || _b === void 0 ? void 0 : _b.error)
                            || ((_c = spkBegleitdaten === null || spkBegleitdaten === void 0 ? void 0 : spkBegleitdaten.mitarbeiterOE) === null || _c === void 0 ? void 0 : _c.error)
                            || ((_d = spkBegleitdaten === null || spkBegleitdaten === void 0 ? void 0 : spkBegleitdaten.personalnummerBerater) === null || _d === void 0 ? void 0 : _d.error))
                            && (jsx$1("div", { className: "invalid-feedback", style: { display: 'block' }, children: "Bei den Begleitdaten fehlen Pflichtangaben. Bitte pr\u00FCfen Sie die Angaben." }))] })), buttonClass: "btn--animate", children: [jsx$1("h4", { children: "Begleitdaten" }), jsx$1(FormInput, __assign$1({}, spkBegleitdaten === null || spkBegleitdaten === void 0 ? void 0 : spkBegleitdaten.vertragsabschliessendeOE, { title: "Abschlie\u00DFende OE", onChange: function (e) { return (onChange ? onChange(e) : dispatch(updateByEvent(e))); }, name: "daten.spkBegleitdaten.vertragsabschliessendeOE.value", labelClassName: "colon" })), jsx$1(FormInput, __assign$1({}, spkBegleitdaten === null || spkBegleitdaten === void 0 ? void 0 : spkBegleitdaten.mitarbeiterOE, { title: "Mitarbeiter-Erfolgs-OE", onChange: function (e) { return (onChange ? onChange(e) : dispatch(updateByEvent(e))); }, name: "daten.spkBegleitdaten.mitarbeiterOE.value", labelClassName: "colon" })), jsx$1(FormInput, __assign$1({}, spkBegleitdaten === null || spkBegleitdaten === void 0 ? void 0 : spkBegleitdaten.personalnummerBerater, { title: "Personal-Nummer", onChange: function (e) { return (onChange ? onChange(e) : dispatch(updateByEvent(e))); }, name: "daten.spkBegleitdaten.personalnummerBerater.value", labelClassName: "colon" }))] })] }));
};

var StyledAntragsunterlagen = styled(Card)(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  .card-body {\n    padding: 1.25rem !important;\n  }\n  .card-title {\n    font-size: 1.25rem !important;\n  }\n  .antragsunterlagen__pdf {\n    height: 100px;\n    width: auto;\n    margin: 0 auto 10px;\n    display: block;\n  }\n"], ["\n  .card-body {\n    padding: 1.25rem !important;\n  }\n  .card-title {\n    font-size: 1.25rem !important;\n  }\n  .antragsunterlagen__pdf {\n    height: 100px;\n    width: auto;\n    margin: 0 auto 10px;\n    display: block;\n  }\n"])));
var Antragsunterlagen = function (_a) {
    var _b = _a.handleAntragDownload, handleAntragDownload = _b === void 0 ? function () { } : _b;
    return (jsx$1(StyledAntragsunterlagen, { className: "antragsunterlagen mb-4 text-center border-0", children: jsxs(Card.Body, { children: [jsx$1(Card.Title, { children: "Ihre Antragsunterlagen" }), jsxs("div", { className: "position-relative", children: [jsx$1(SvgPdf, { className: "antragsunterlagen__pdf" }), jsxs(Button$1, { className: "antragsunterlagen__link mt-2 link stretched-link", "data-tracking-name": "button-antragsunterlagen-herunterladen", onClick: handleAntragDownload, children: [jsx$1(SvgArrow, {}), "Noch einmal herunterladen"] })] })] }) }));
};
var Antragsunterlagen$1 = React__default.memo(Antragsunterlagen);
var templateObject_1$5;

var VersicherungspaketeAngaben = function (_a) {
    var _b = _a.show, show = _b === void 0 ? true : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.auswahl, auswahl = _d === void 0 ? 'nicht angegeben' : _d, _e = _a.rowClassName, rowClassName = _e === void 0 ? '' : _e, _f = _a.labelClassName, labelClassName = _f === void 0 ? '' : _f, _g = _a.contentClassName, contentClassName = _g === void 0 ? '' : _g, _h = _a.noContent, noContent = _h === void 0 ? false : _h, _j = _a.alignSelf, alignSelf = _j === void 0 ? 'end' : _j, _k = _a.colon, colon = _k === void 0 ? true : _k, _l = _a.noPadding, noPadding = _l === void 0 ? false : _l, _m = _a.dangerouslySetInnerHTML, dangerouslySetInnerHTML = _m === void 0 ? false : _m, middleColumn = _a.middleColumn, _o = _a.middleColumnClassName, middleColumnClassName = _o === void 0 ? '' : _o, _p = _a.showMiddleColumn, showMiddleColumn = _p === void 0 ? true : _p, _q = _a.spaceBetween, spaceBetween = _q === void 0 ? true : _q;
    if (!show) {
        return null;
    }
    var dangerHTML = dangerouslySetInnerHTML ? jsx$1("div", { dangerouslySetInnerHTML: { __html: auswahl } }) : auswahl;
    return (jsxs("div", { className: "d-md-flex ".concat(spaceBetween ? 'justify-content-between' : '', " ").concat(!noPadding ? 'py-1' : '', " ").concat(middleColumn ? 'three-col-layout' : '', " ").concat(rowClassName), children: [jsx$1("div", { className: "content-table__head ".concat(colon ? 'colon' : '', " ").concat(labelClassName), children: label }), (middleColumn && showMiddleColumn) && (jsx$1("div", { className: "content-table__middle text-md-end ".concat(middleColumnClassName), children: jsx$1("span", { dangerouslySetInnerHTML: { __html: middleColumn } }) })), !noContent && (jsx$1("div", { className: "content-table__data truncate text-md-end align-self-".concat(alignSelf, " ").concat(contentClassName), children: auswahl ? dangerHTML : 'nicht angegeben' }))] }));
};

var AnimationWrapper = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var GrafikWrapper = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  width: ", "px;\n  max-width: 65px;\n  transition: transform 0.8s; \n  transform: translateX(", "px);\n   svg{\n    width: auto !important;\n    height: auto !important;\n    fill: var(--primary);\n  }\n"], ["\n  width: ", "px;\n  max-width: 65px;\n  transition: transform 0.8s; \n  transform: translateX(", "px);\n   svg{\n    width: auto !important;\n    height: auto !important;\n    fill: var(--primary);\n  }\n"])), function (_a) {
    var stepwidth = _a.stepwidth;
    return stepwidth;
}, function (_a) {
    var stepwidth = _a.stepwidth, position = _a.position;
    return (stepwidth > 65 ? (stepwidth * position) + (stepwidth - 65) : stepwidth * position);
});
var ProgressbarAnimation = function (_a) {
    var children = _a.children, step = _a.step;
    var _b = useState(0), stepWidth = _b[0], setStepWidth = _b[1];
    useEffect(function () {
        function handleStepWidth() {
            var progressStep = document.querySelector('.progressbar-navigation-item');
            if (progressStep) {
                var progressStepWidth = progressStep.clientWidth;
                if (stepWidth !== progressStepWidth) {
                    setStepWidth(progressStepWidth);
                }
            }
        }
        handleStepWidth();
        window.addEventListener('resize', debounce$1(handleStepWidth, 200));
        return function () { return window.removeEventListener('resize', handleStepWidth); };
    }, []);
    return ((step !== -1) && (jsx$1(AnimationWrapper, { className: "progressbar-animation", children: jsx$1(GrafikWrapper, { stepwidth: stepWidth, position: step, className: "\n          progressbar-animation__grafik\n          progressbarstep-".concat(step, "\n        "), children: children }) })));
};
var ProgressbarAnimation$1 = React__default.memo(ProgressbarAnimation);
var templateObject_1$4, templateObject_2$1;

var AbweichenderREFormRadio = function () {
    var dispatch = useDispatch();
    var abweichenderRE = useSelector(function (state) { return state.daten.abweichenderRE; });
    var updateAndValidate = useUpdateAndValidateOnChange(0);
    useEffect(function () {
        if (istJaAuswahl(abweichenderRE)) {
            dispatch(updateByName('appDaten.neuesKonto', false));
        }
    }, [abweichenderRE.value]);
    return (jsx$1(If$1, { predicate: abweichenderRE.relevant, children: jsx$1(FormRadio, __assign$1({}, abweichenderRE, { title: "Ist ein abweichender Rechnungsempf\u00E4nger gew\u00FCnscht?", name: "daten.abweichenderRE.value", onChange: updateAndValidate, className: "pt-3" })) }));
};

var CheckMark = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  position: relative;\n  border: 4px solid #5cb85c;\n  height: 86px;\n  width: 86px;\n  border-radius: 46px;\n\n  &.draw:after {\n    animation-duration: 800ms;\n    animation-timing-function: ease;\n    animation-name: checkmark;\n    transform: scaleX(-1) rotate(135deg);\n  }\n\n  &:after {\n    opacity: 1;\n    height: 2em;\n    width: 1em;\n    transform-origin: left top;\n    border-right: 4px solid #5cb85c;\n    border-top: 4px solid #5cb85c;\n    content: '';\n    left: 1em;\n    top: 2.25em;\n    position: absolute;\n  }\n"], ["\n  position: relative;\n  border: 4px solid #5cb85c;\n  height: 86px;\n  width: 86px;\n  border-radius: 46px;\n\n  &.draw:after {\n    animation-duration: 800ms;\n    animation-timing-function: ease;\n    animation-name: checkmark;\n    transform: scaleX(-1) rotate(135deg);\n  }\n\n  &:after {\n    opacity: 1;\n    height: 2em;\n    width: 1em;\n    transform-origin: left top;\n    border-right: 4px solid #5cb85c;\n    border-top: 4px solid #5cb85c;\n    content: '';\n    left: 1em;\n    top: 2.25em;\n    position: absolute;\n  }\n"])));
var CaptchaFormInput = function (_a) {
    var validateCaptcha = _a.validateCaptcha, tooltip = _a.tooltip;
    var dispatch = useDispatch();
    var captchaText = useSelector(function (state) { return state.daten.captchaText; });
    var captchaImg = useSelector(function (state) { return state.appDaten.captcha; });
    var captchaSolved = useSelector(function (state) { return state.daten.captchaSolved; });
    var getCaptcha = function () {
        dispatch(holeCaptcha());
    };
    useEffect(function () {
        getCaptcha();
    }, []);
    return captchaText.relevant && (jsxs("div", { className: "mb-5 mt-5", children: [captchaSolved && (jsx$1(CheckMark, { className: "draw" })), !captchaSolved
                && (jsxs(Fragment, { children: [jsxs("h4", { children: ["Bitte tragen Sie die Zeichenfolge in das Eingabefeld ein und dr\u00FCcken Sie den Button:", ' ', jsx$1(Nowrap, { children: jsx$1(Tooltip, { handleTooltip: tooltip, id: "tooltip-captcha}" }) })] }), jsx$1("img", { alt: "Captcha", src: "data:image/".concat(captchaImg === null || captchaImg === void 0 ? void 0 : captchaImg.type, ";base64,").concat(captchaImg === null || captchaImg === void 0 ? void 0 : captchaImg.img) }), jsxs(InputGroup, { style: { height: '48px', cursor: 'pointer' }, children: [jsx$1(InputGroup.Text, { title: "Captcha neuladen", role: "button", onClick: getCaptcha, style: { padding: '0.75rem' }, children: jsx$1(SvgSyncSolid, {}) }), jsx$1(Form.Control, { value: captchaText.value, name: "daten.captchaText.value", onChange: function (e) { return dispatch(updateByEvent(e)); }, onKeyDown: function (e) {
                                        if (e.key === 'Enter') {
                                            validateCaptcha();
                                        }
                                    }, style: { width: '200px', flexGrow: '0' }, disabled: !captchaText.ueberschreibbar, className: "captcha-form-input", isInvalid: captchaText.error, type: "text" }), jsx$1(Button$1, { onClick: validateCaptcha, children: "Eingabe pr\u00FCfen" })] }), captchaText.error && (jsx$1("p", { children: jsx$1(Form.Control.Feedback, { type: "invalid", style: { display: 'block' }, children: captchaText.error }) }))] }))] }));
};
var templateObject_1$3;

var SaveStateModal = function () {
    var status = useSelector(function (state) { return state.savedState; });
    var dispatch = useDispatch();
    if (status === 'loaded') {
        var handleReset = function (e) {
            e.preventDefault();
            window.localStorage.clear();
            window.sessionStorage.clear();
            window.location.reload();
        };
        var handleClose = function () {
            dispatch(request(EnumActions.VALIDIERE));
            dispatch(updateByName('savedState', EnumSavedState.CLEAR));
        };
        return (jsxs(Modal, { open: true, onClose: handleClose, children: [jsx$1("h4", { children: "Sch\u00F6n, dass Sie wieder da sind!" }), jsx$1("p", { children: "Ihre Eingaben wurden wiederhergestellt. Machen Sie da weiter, wo Sie aufgeh\u00F6rt haben." }), jsxs("p", { children: ["Sie m\u00F6chten neu starten?", ' ', jsxs(Button$1, { variant: "link", "data-tracking-name": "auswahlbutton-speichern-modal-reset", onClick: handleReset, children: ["Dann klicken Sie bitte hier", ' ', jsx$1(SvgArrow, {})] })] })] }));
    }
    if (status === 'error') {
        var handleClose = function () {
            dispatch(updateByName('savedState', EnumSavedState.CLEAR));
        };
        return (jsxs(Modal, { open: true, onClose: handleClose, children: [jsx$1("h4", { children: "Leider konnten Ihre Daten nicht wiederhergestellt werden" }), jsx$1("p", { children: "Wir haben unseren Rechner aktualisiert. Darum konnten Ihre Eingaben leider nicht wiederhergestellt werden. Sorry!" })] }));
    }
    if (status === 'saved') {
        var handleClose = function () {
            dispatch(updateByName('savedState', EnumSavedState.CLEAR));
        };
        return (jsxs(Modal, { open: true, onClose: handleClose, children: [jsx$1("h4", { children: "Eingaben gespeichert" }), jsx$1("p", { children: "Alle Eingaben wurden in Ihrem Browser gespeichert." }), jsx$1("p", { children: "Sie k\u00F6nnen jetzt weitermachen oder den Rechner sp\u00E4ter neu aufrufen. Wenn Sie die Berechnung sp\u00E4ter fortsetzen wollen, nutzen Sie bitte diesen Browser." })] }));
    }
    return null;
};

var SpeicherButton = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, size = _a.size;
    var store = useStore().getState();
    var dispatch = useDispatch();
    var handleSpeichern = function (e) {
        e.preventDefault();
        savedStateManager.saveToLocalStorage(store);
        dispatch(updateByName('savedState', EnumSavedState.SAVED));
    };
    return (!trEnv$1.sparkasse && (jsxs(Button$1, { size: size, variant: "link", "data-tracking-name": "auswahlbutton-speichern", className: "".concat(className, " mt-3 d-inline-block btn--animate"), onClick: handleSpeichern, children: ["Speichern und sp\u00E4ter weitermachen", ' ', jsx$1(SvgArrow, {})] })));
};

var DruckenModal = function (_a) {
    var handleDruck = _a.handleDruck, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, _c = _a.text, text = _c === void 0 ? jsx$1("h4", { children: "Nach dem Drucken sind keine \u00C4nderungen am Antrag mehr m\u00F6glich!" }) : _c, _d = _a.buttonWeiterLabel, buttonWeiterLabel = _d === void 0 ? 'Drucken' : _d;
    var dispatch = useDispatch();
    var show = useSelector(function (state) { return state.appDaten.druckmodal; });
    var tooltipOffset = useSelector(function (state) { return state.appDaten.tooltip_offset; });
    var body = document.querySelector('body');
    var handleBack = function () {
        onClose();
        dispatch(updateByName('appDaten.druckmodal', false));
        body.classList.remove('modal-open');
    };
    if (show) {
        body.classList.add('modal-open');
    }
    var handleShow = function () {
        body.classList.add('modal-open');
        if (tooltipOffset != null) {
            var margin = tooltipOffset - 350;
            var modalDialog = document.querySelector('.modal-dialog-centered');
            if (modalDialog) {
                modalDialog.setAttribute('style', "margin-top: ".concat(margin, "px"));
            }
        }
    };
    return (jsxs(Modal$1, { dialogClassName: "druckmodal", show: show, container: function () { return document.querySelector('.bs-iso'); }, centered: true, onShow: handleShow, onHide: handleBack, animation: false, children: [jsx$1(Modal$1.Header, { className: "p-0" }), jsx$1(Modal$1.Body, { children: text }), jsxs(Modal$1.Footer, { children: [jsx$1(Button$1, { variant: "secondary", onClick: handleBack, children: "Zur\u00FCck" }), jsx$1(Button$1, { variant: "primary", onClick: handleDruck, children: buttonWeiterLabel })] })] }));
};

var DatenschutzFormCheck = function (_a) {
    var rest = __rest$1(_a, []);
    var datenschutz = useSelector(function (state) { return state.daten.datenschutz; });
    var dispatch = useDispatch();
    if (!datenschutz.relevant || trEnv$1.stationaer) {
        return null;
    }
    return (jsx$1(FormCheck, __assign$1({}, datenschutz, { name: "daten.datenschutz.value", title: i18next.t('datenschutz.checkboxTitle'), onChange: function (e) { return dispatch(updateByEvent(e)); }, className: "header-label fw-light sp-child-w-100 mb-4" }, rest, { children: jsx$1("p", { className: "mt-2 mb-4", children: jsxs("small", { children: ["Wir nutzen Ihre Daten ausschlie\u00DFlich im Rahmen unserer", ' ', jsx$1("span", { className: "span-fix", role: "link", dangerouslySetInnerHTML: { __html: i18next.t('datenschutz.link') } }), ' ', "und unseres", ' ', jsx$1("span", { className: "span-fix", role: "link", dangerouslySetInnerHTML: { __html: i18next.t('datenschutz.kodex') } }), ' ', "- unter anderem zur Angebotserstellung und Durchf\u00FChrung Ihres Vertrages oder - in Einzelf\u00E4llen - f\u00FCr Anfragen bei Ihrem Vorversicherer. Au\u00DFerdem informieren wir Sie gelegentlich zu Produkten der", ' ', jsx$1(Button$1, { variant: "link", onClick: function () { return dispatch(toggleModal(i18next.t('datenschutz.modal'))); }, "data-tracking-name": "datenschutz.modal", children: i18next.t('datenschutz.modalLinkText') }), ' ', "per Post. Dieser Nutzung Ihrer Daten k\u00F6nnen Sie jederzeit per E-Mail an", ' ', jsx$1("span", { className: "span-fix", role: "link", dangerouslySetInnerHTML: { __html: i18next.t('datenschutz.mail') } }), ' ', "widersprechen."] }) }) })));
};

var Berufesuche = function (_a) {
    var beruf = _a.beruf, name = _a.name, onChange = _a.onChange, rest = __rest$1(_a, ["beruf", "name", "onChange"]);
    var dispatch = useDispatch();
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var handleSearch = function (query) {
        setIsLoading(true);
        dispatch(updateByName(name, query, function () {
            dispatch(holeBerufeliste(name, function () { return setIsLoading(false); }));
        }));
    };
    var clearInput = function () {
        dispatch(updateByName(name, '', function () {
            dispatch(holeBerufeliste(name));
        }));
    };
    var inputChange = function (query) {
        dispatch(updateByName(name, query, function () {
            handleTimeout(name, 1000, function () {
                setIsLoading(true);
                dispatch(holeBerufeliste(name, function () { return setIsLoading(false); }));
            });
        }));
    };
    var handleSelect = function (selected) {
        if ((selected === null || selected === void 0 ? void 0 : selected.length) > 0) {
            onChange(name, selected[0].bezeichnung);
        }
    };
    return (beruf.relevant && (jsxs(Fragment, { children: [beruf.warning && (jsx$1(Message$1, { text: beruf.warning, show: true, arrow: "bottom" })), jsx$1(TypeaheadInput$1, __assign$1({}, beruf, { name: name, label: "Beruf", onSearch: handleSearch, onChange: handleSelect, onInputChange: inputChange, options: beruf.valueSet, labelKey: "bezeichnung", isLoading: isLoading, delay: 400, placeholder: "Beruf suchen", emptyLabel: "Zu Ihrem Suchbegriff wurden keine Berufe gefunden. Bitte \u00E4ndern Sie Ihre Eingabe.", paginationText: "Mehr Berufe anzeigen.", clearInput: clearInput }, rest))] })));
};
var BerufesucheV2 = React__default.memo(Berufesuche);

var css_248z = ".carousel .control-arrow,.carousel.carousel-slider .control-arrow{-webkit-transition:all .25s ease-in;-moz-transition:all .25s ease-in;-ms-transition:all .25s ease-in;-o-transition:all .25s ease-in;transition:all .25s ease-in;opacity:.4;filter:alpha(opacity=40);position:absolute;z-index:2;top:20px;background:none;border:0;font-size:32px;cursor:pointer}.carousel .control-arrow:focus,.carousel .control-arrow:hover{opacity:1;filter:alpha(opacity=100)}.carousel .control-arrow:before,.carousel.carousel-slider .control-arrow:before{margin:0 5px;display:inline-block;border-top:8px solid transparent;border-bottom:8px solid transparent;content:''}.carousel .control-disabled.control-arrow{opacity:0;filter:alpha(opacity=0);cursor:inherit;display:none}.carousel .control-prev.control-arrow{left:0}.carousel .control-prev.control-arrow:before{border-right:8px solid #fff}.carousel .control-next.control-arrow{right:0}.carousel .control-next.control-arrow:before{border-left:8px solid #fff}.carousel-root{outline:none}.carousel{position:relative;width:100%}.carousel *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.carousel img{width:100%;display:inline-block;pointer-events:none}.carousel .carousel{position:relative}.carousel .control-arrow{outline:0;border:0;background:none;top:50%;margin-top:-13px;font-size:18px}.carousel .thumbs-wrapper{margin:20px;overflow:hidden}.carousel .thumbs{-webkit-transition:all .15s ease-in;-moz-transition:all .15s ease-in;-ms-transition:all .15s ease-in;-o-transition:all .15s ease-in;transition:all .15s ease-in;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);position:relative;list-style:none;white-space:nowrap}.carousel .thumb{-webkit-transition:border .15s ease-in;-moz-transition:border .15s ease-in;-ms-transition:border .15s ease-in;-o-transition:border .15s ease-in;transition:border .15s ease-in;display:inline-block;margin-right:6px;white-space:nowrap;overflow:hidden;border:3px solid #fff;padding:2px}.carousel .thumb:focus{border:3px solid #ccc;outline:none}.carousel .thumb.selected,.carousel .thumb:hover{border:3px solid #333}.carousel .thumb img{vertical-align:top}.carousel.carousel-slider{position:relative;margin:0;overflow:hidden}.carousel.carousel-slider .control-arrow{top:0;color:#fff;font-size:26px;bottom:0;margin-top:0;padding:5px}.carousel.carousel-slider .control-arrow:hover{background:rgba(0,0,0,0.2)}.carousel .slider-wrapper{overflow:hidden;margin:auto;width:100%;-webkit-transition:height .15s ease-in;-moz-transition:height .15s ease-in;-ms-transition:height .15s ease-in;-o-transition:height .15s ease-in;transition:height .15s ease-in}.carousel .slider-wrapper.axis-horizontal .slider{-ms-box-orient:horizontal;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-moz-flex;display:-webkit-flex;display:flex}.carousel .slider-wrapper.axis-horizontal .slider .slide{flex-direction:column;flex-flow:column}.carousel .slider-wrapper.axis-vertical{-ms-box-orient:horizontal;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-moz-flex;display:-webkit-flex;display:flex}.carousel .slider-wrapper.axis-vertical .slider{-webkit-flex-direction:column;flex-direction:column}.carousel .slider{margin:0;padding:0;position:relative;list-style:none;width:100%}.carousel .slider.animated{-webkit-transition:all .35s ease-in-out;-moz-transition:all .35s ease-in-out;-ms-transition:all .35s ease-in-out;-o-transition:all .35s ease-in-out;transition:all .35s ease-in-out}.carousel .slide{min-width:100%;margin:0;position:relative;text-align:center}.carousel .slide img{width:100%;vertical-align:top;border:0}.carousel .slide iframe{display:inline-block;width:calc(100% - 80px);margin:0 40px 40px;border:0}.carousel .slide .legend{-webkit-transition:all .5s ease-in-out;-moz-transition:all .5s ease-in-out;-ms-transition:all .5s ease-in-out;-o-transition:all .5s ease-in-out;transition:all .5s ease-in-out;position:absolute;bottom:40px;left:50%;margin-left:-45%;width:90%;border-radius:10px;background:#000;color:#fff;padding:10px;font-size:12px;text-align:center;opacity:0.25;-webkit-transition:opacity .35s ease-in-out;-moz-transition:opacity .35s ease-in-out;-ms-transition:opacity .35s ease-in-out;-o-transition:opacity .35s ease-in-out;transition:opacity .35s ease-in-out}.carousel .control-dots{position:absolute;bottom:0;margin:10px 0;padding:0;text-align:center;width:100%;z-index:1}@media (min-width: 960px){.carousel .control-dots{bottom:0}}.carousel .control-dots .dot{-webkit-transition:opacity .25s ease-in;-moz-transition:opacity .25s ease-in;-ms-transition:opacity .25s ease-in;-o-transition:opacity .25s ease-in;transition:opacity .25s ease-in;opacity:.3;filter:alpha(opacity=30);box-shadow:1px 1px 2px rgba(0,0,0,0.9);background:#fff;border-radius:50%;width:8px;height:8px;cursor:pointer;display:inline-block;margin:0 8px}.carousel .control-dots .dot.selected,.carousel .control-dots .dot:hover{opacity:1;filter:alpha(opacity=100)}.carousel .carousel-status{position:absolute;top:0;right:0;padding:5px;font-size:10px;text-shadow:1px 1px 1px rgba(0,0,0,0.9);color:#fff}.carousel:hover .slide .legend{opacity:1}\n";
styleInject(css_248z);

var js = {};

var Carousel = {};

var lib$1 = {};

var reactSwipe = {};

var hasRequiredReactSwipe;

function requireReactSwipe () {
	if (hasRequiredReactSwipe) return reactSwipe;
	hasRequiredReactSwipe = 1;
	(function (exports) {
		(function (global, factory) {
		  {
		    factory(exports, React__default, PropTypes);
		  }
		})(reactSwipe, function (exports, _react, _propTypes) {

		  Object.defineProperty(exports, "__esModule", {
		    value: true
		  });
		  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;

		  var _react2 = _interopRequireDefault(_react);

		  var _propTypes2 = _interopRequireDefault(_propTypes);

		  function _interopRequireDefault(obj) {
		    return obj && obj.__esModule ? obj : {
		      default: obj
		    };
		  }

		  var _extends = Object.assign || function (target) {
		    for (var i = 1; i < arguments.length; i++) {
		      var source = arguments[i];

		      for (var key in source) {
		        if (Object.prototype.hasOwnProperty.call(source, key)) {
		          target[key] = source[key];
		        }
		      }
		    }

		    return target;
		  };

		  function _objectWithoutProperties(obj, keys) {
		    var target = {};

		    for (var i in obj) {
		      if (keys.indexOf(i) >= 0) continue;
		      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
		      target[i] = obj[i];
		    }

		    return target;
		  }

		  function _classCallCheck(instance, Constructor) {
		    if (!(instance instanceof Constructor)) {
		      throw new TypeError("Cannot call a class as a function");
		    }
		  }

		  var _createClass = function () {
		    function defineProperties(target, props) {
		      for (var i = 0; i < props.length; i++) {
		        var descriptor = props[i];
		        descriptor.enumerable = descriptor.enumerable || false;
		        descriptor.configurable = true;
		        if ("value" in descriptor) descriptor.writable = true;
		        Object.defineProperty(target, descriptor.key, descriptor);
		      }
		    }

		    return function (Constructor, protoProps, staticProps) {
		      if (protoProps) defineProperties(Constructor.prototype, protoProps);
		      if (staticProps) defineProperties(Constructor, staticProps);
		      return Constructor;
		    };
		  }();

		  function _possibleConstructorReturn(self, call) {
		    if (!self) {
		      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		    }

		    return call && (typeof call === "object" || typeof call === "function") ? call : self;
		  }

		  function _inherits(subClass, superClass) {
		    if (typeof superClass !== "function" && superClass !== null) {
		      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		    }

		    subClass.prototype = Object.create(superClass && superClass.prototype, {
		      constructor: {
		        value: subClass,
		        enumerable: false,
		        writable: true,
		        configurable: true
		      }
		    });
		    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		  }

		  var supportsCaptureOption = false;
		  function setHasSupportToCaptureOption(hasSupport) {
		    supportsCaptureOption = hasSupport;
		  }

		  try {
		    addEventListener('test', null, Object.defineProperty({}, 'capture', { get: function get() {
		        setHasSupportToCaptureOption(true);
		      } }));
		  } catch (e) {} // eslint-disable-line no-empty

		  function getSafeEventHandlerOpts() {
		    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };

		    return supportsCaptureOption ? options : options.capture;
		  }

		  /**
		   * [getPosition returns a position element that works for mouse or touch events]
		   * @param  {[Event]} event [the received event]
		   * @return {[Object]}      [x and y coords]
		   */
		  function getPosition(event) {
		    if ('touches' in event) {
		      var _event$touches$ = event.touches[0],
		          pageX = _event$touches$.pageX,
		          pageY = _event$touches$.pageY;

		      return { x: pageX, y: pageY };
		    }

		    var screenX = event.screenX,
		        screenY = event.screenY;

		    return { x: screenX, y: screenY };
		  }

		  var ReactSwipe = function (_Component) {
		    _inherits(ReactSwipe, _Component);

		    function ReactSwipe() {
		      var _ref;

		      _classCallCheck(this, ReactSwipe);

		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }

		      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));

		      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
		      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
		      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);

		      _this._onMouseDown = _this._onMouseDown.bind(_this);
		      _this._onMouseMove = _this._onMouseMove.bind(_this);
		      _this._onMouseUp = _this._onMouseUp.bind(_this);

		      _this._setSwiperRef = _this._setSwiperRef.bind(_this);
		      return _this;
		    }

		    _createClass(ReactSwipe, [{
		      key: 'componentDidMount',
		      value: function componentDidMount() {
		        if (this.swiper) {
		          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
		            capture: true,
		            passive: false
		          }));
		        }
		      }
		    }, {
		      key: 'componentWillUnmount',
		      value: function componentWillUnmount() {
		        if (this.swiper) {
		          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
		            capture: true,
		            passive: false
		          }));
		        }
		      }
		    }, {
		      key: '_onMouseDown',
		      value: function _onMouseDown(event) {
		        if (!this.props.allowMouseEvents) {
		          return;
		        }

		        this.mouseDown = true;

		        document.addEventListener('mouseup', this._onMouseUp);
		        document.addEventListener('mousemove', this._onMouseMove);

		        this._handleSwipeStart(event);
		      }
		    }, {
		      key: '_onMouseMove',
		      value: function _onMouseMove(event) {
		        if (!this.mouseDown) {
		          return;
		        }

		        this._handleSwipeMove(event);
		      }
		    }, {
		      key: '_onMouseUp',
		      value: function _onMouseUp(event) {
		        this.mouseDown = false;

		        document.removeEventListener('mouseup', this._onMouseUp);
		        document.removeEventListener('mousemove', this._onMouseMove);

		        this._handleSwipeEnd(event);
		      }
		    }, {
		      key: '_handleSwipeStart',
		      value: function _handleSwipeStart(event) {
		        var _getPosition = getPosition(event),
		            x = _getPosition.x,
		            y = _getPosition.y;

		        this.moveStart = { x: x, y: y };
		        this.props.onSwipeStart(event);
		      }
		    }, {
		      key: '_handleSwipeMove',
		      value: function _handleSwipeMove(event) {
		        if (!this.moveStart) {
		          return;
		        }

		        var _getPosition2 = getPosition(event),
		            x = _getPosition2.x,
		            y = _getPosition2.y;

		        var deltaX = x - this.moveStart.x;
		        var deltaY = y - this.moveStart.y;
		        this.moving = true;

		        // handling the responsability of cancelling the scroll to
		        // the component handling the event
		        var shouldPreventDefault = this.props.onSwipeMove({
		          x: deltaX,
		          y: deltaY
		        }, event);

		        if (shouldPreventDefault && event.cancelable) {
		          event.preventDefault();
		        }

		        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
		      }
		    }, {
		      key: '_handleSwipeEnd',
		      value: function _handleSwipeEnd(event) {
		        this.props.onSwipeEnd(event);

		        var tolerance = this.props.tolerance;


		        if (this.moving && this.movePosition) {
		          if (this.movePosition.deltaX < -tolerance) {
		            this.props.onSwipeLeft(1, event);
		          } else if (this.movePosition.deltaX > tolerance) {
		            this.props.onSwipeRight(1, event);
		          }
		          if (this.movePosition.deltaY < -tolerance) {
		            this.props.onSwipeUp(1, event);
		          } else if (this.movePosition.deltaY > tolerance) {
		            this.props.onSwipeDown(1, event);
		          }
		        }

		        this.moveStart = null;
		        this.moving = false;
		        this.movePosition = null;
		      }
		    }, {
		      key: '_setSwiperRef',
		      value: function _setSwiperRef(node) {
		        this.swiper = node;
		        this.props.innerRef(node);
		      }
		    }, {
		      key: 'render',
		      value: function render() {
		        var _props = this.props;
		            _props.tagName;
		            var className = _props.className,
		            style = _props.style,
		            children = _props.children;
		            _props.allowMouseEvents;
		            _props.onSwipeUp;
		            _props.onSwipeDown;
		            _props.onSwipeLeft;
		            _props.onSwipeRight;
		            _props.onSwipeStart;
		            _props.onSwipeMove;
		            _props.onSwipeEnd;
		            _props.innerRef;
		            _props.tolerance;
		            var props = _objectWithoutProperties(_props, ['tagName', 'className', 'style', 'children', 'allowMouseEvents', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight', 'onSwipeStart', 'onSwipeMove', 'onSwipeEnd', 'innerRef', 'tolerance']);

		        return _react2.default.createElement(
		          this.props.tagName,
		          _extends({
		            ref: this._setSwiperRef,
		            onMouseDown: this._onMouseDown,
		            onTouchStart: this._handleSwipeStart,
		            onTouchEnd: this._handleSwipeEnd,
		            className: className,
		            style: style
		          }, props),
		          children
		        );
		      }
		    }]);

		    return ReactSwipe;
		  }(_react.Component);

		  ReactSwipe.displayName = 'ReactSwipe';
		  ReactSwipe.propTypes = {
		    tagName: _propTypes2.default.string,
		    className: _propTypes2.default.string,
		    style: _propTypes2.default.object,
		    children: _propTypes2.default.node,
		    allowMouseEvents: _propTypes2.default.bool,
		    onSwipeUp: _propTypes2.default.func,
		    onSwipeDown: _propTypes2.default.func,
		    onSwipeLeft: _propTypes2.default.func,
		    onSwipeRight: _propTypes2.default.func,
		    onSwipeStart: _propTypes2.default.func,
		    onSwipeMove: _propTypes2.default.func,
		    onSwipeEnd: _propTypes2.default.func,
		    innerRef: _propTypes2.default.func,
		    tolerance: _propTypes2.default.number.isRequired
		  };
		  ReactSwipe.defaultProps = {
		    tagName: 'div',
		    allowMouseEvents: false,
		    onSwipeUp: function onSwipeUp() {},
		    onSwipeDown: function onSwipeDown() {},
		    onSwipeLeft: function onSwipeLeft() {},
		    onSwipeRight: function onSwipeRight() {},
		    onSwipeStart: function onSwipeStart() {},
		    onSwipeMove: function onSwipeMove() {},
		    onSwipeEnd: function onSwipeEnd() {},
		    innerRef: function innerRef() {},

		    tolerance: 0
		  };
		  exports.default = ReactSwipe;
		}); 
	} (reactSwipe));
	return reactSwipe;
}

var hasRequiredLib$1;

function requireLib$1 () {
	if (hasRequiredLib$1) return lib$1;
	hasRequiredLib$1 = 1;
	(function (exports) {
		(function (global, factory) {
		  {
		    factory(exports, requireReactSwipe());
		  }
		})(lib$1, function (exports, _reactSwipe) {

		  Object.defineProperty(exports, "__esModule", {
		    value: true
		  });

		  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

		  function _interopRequireDefault(obj) {
		    return obj && obj.__esModule ? obj : {
		      default: obj
		    };
		  }

		  exports.default = _reactSwipe2.default;
		}); 
	} (lib$1));
	return lib$1;
}

var cssClasses = {};

var hasRequiredCssClasses;

function requireCssClasses () {
	if (hasRequiredCssClasses) return cssClasses;
	hasRequiredCssClasses = 1;

	Object.defineProperty(cssClasses, "__esModule", {
	  value: true
	});
	cssClasses.default = void 0;

	var _classnames = _interopRequireDefault(requireClassnames());

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var _default = {
	  ROOT: function ROOT(customClassName) {
	    return (0, _classnames.default)(_defineProperty({
	      'carousel-root': true
	    }, customClassName || '', !!customClassName));
	  },
	  CAROUSEL: function CAROUSEL(isSlider) {
	    return (0, _classnames.default)({
	      carousel: true,
	      'carousel-slider': isSlider
	    });
	  },
	  WRAPPER: function WRAPPER(isSlider, axis) {
	    return (0, _classnames.default)({
	      'thumbs-wrapper': !isSlider,
	      'slider-wrapper': isSlider,
	      'axis-horizontal': axis === 'horizontal',
	      'axis-vertical': axis !== 'horizontal'
	    });
	  },
	  SLIDER: function SLIDER(isSlider, isSwiping) {
	    return (0, _classnames.default)({
	      thumbs: !isSlider,
	      slider: isSlider,
	      animated: !isSwiping
	    });
	  },
	  ITEM: function ITEM(isSlider, selected, previous) {
	    return (0, _classnames.default)({
	      thumb: !isSlider,
	      slide: isSlider,
	      selected: selected,
	      previous: previous
	    });
	  },
	  ARROW_PREV: function ARROW_PREV(disabled) {
	    return (0, _classnames.default)({
	      'control-arrow control-prev': true,
	      'control-disabled': disabled
	    });
	  },
	  ARROW_NEXT: function ARROW_NEXT(disabled) {
	    return (0, _classnames.default)({
	      'control-arrow control-next': true,
	      'control-disabled': disabled
	    });
	  },
	  DOT: function DOT(selected) {
	    return (0, _classnames.default)({
	      dot: true,
	      selected: selected
	    });
	  }
	};
	cssClasses.default = _default;
	return cssClasses;
}

var Thumbs = {};

var dimensions = {};

var hasRequiredDimensions;

function requireDimensions () {
	if (hasRequiredDimensions) return dimensions;
	hasRequiredDimensions = 1;

	Object.defineProperty(dimensions, "__esModule", {
	  value: true
	});
	dimensions.outerWidth = void 0;

	var outerWidth = function outerWidth(el) {
	  var width = el.offsetWidth;
	  var style = getComputedStyle(el);
	  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
	  return width;
	};

	dimensions.outerWidth = outerWidth;
	return dimensions;
}

var CSSTranslate = {};

var hasRequiredCSSTranslate;

function requireCSSTranslate () {
	if (hasRequiredCSSTranslate) return CSSTranslate;
	hasRequiredCSSTranslate = 1;

	Object.defineProperty(CSSTranslate, "__esModule", {
	  value: true
	});
	CSSTranslate.default = void 0;

	var _default = function _default(position, metric, axis) {
	  var positionPercent = position === 0 ? position : position + metric;
	  var positionCss = axis === 'horizontal' ? [positionPercent, 0, 0] : [0, positionPercent, 0];
	  var transitionProp = 'translate3d';
	  var translatedPosition = '(' + positionCss.join(',') + ')';
	  return transitionProp + translatedPosition;
	};

	CSSTranslate.default = _default;
	return CSSTranslate;
}

var window$1 = {};

var hasRequiredWindow;

function requireWindow () {
	if (hasRequiredWindow) return window$1;
	hasRequiredWindow = 1;

	Object.defineProperty(window$1, "__esModule", {
	  value: true
	});
	window$1.default = void 0;

	var _default = function _default() {
	  return window;
	};

	window$1.default = _default;
	return window$1;
}

var hasRequiredThumbs;

function requireThumbs () {
	if (hasRequiredThumbs) return Thumbs;
	hasRequiredThumbs = 1;

	Object.defineProperty(Thumbs, "__esModule", {
	  value: true
	});
	Thumbs.default = void 0;

	var _react = _interopRequireWildcard(React__default);

	var _cssClasses = _interopRequireDefault(requireCssClasses());

	var _dimensions = requireDimensions();

	var _CSSTranslate = _interopRequireDefault(requireCSSTranslate());

	var _reactEasySwipe = _interopRequireDefault(requireLib$1());

	var _window = _interopRequireDefault(requireWindow());

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); return Constructor; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var isKeyboardEvent = function isKeyboardEvent(e) {
	  return e.hasOwnProperty('key');
	};

	var Thumbs$1 = /*#__PURE__*/function (_Component) {
	  _inherits(Thumbs, _Component);

	  var _super = _createSuper(Thumbs);

	  function Thumbs(_props) {
	    var _this;

	    _classCallCheck(this, Thumbs);

	    _this = _super.call(this, _props);

	    _defineProperty(_assertThisInitialized(_this), "itemsWrapperRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "itemsListRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "setItemsWrapperRef", function (node) {
	      _this.itemsWrapperRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setItemsListRef", function (node) {
	      _this.itemsListRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node, index) {
	      if (!_this.thumbsRef) {
	        _this.thumbsRef = [];
	      }

	      _this.thumbsRef[index] = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
	      if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) {
	        return;
	      }

	      var total = _react.Children.count(_this.props.children);

	      var wrapperSize = _this.itemsWrapperRef.clientWidth;
	      var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
	      var visibleItems = Math.floor(wrapperSize / itemSize);
	      var showArrows = visibleItems < total;
	      var lastPosition = showArrows ? total - visibleItems : 0;

	      _this.setState(function (_state, props) {
	        return {
	          itemSize: itemSize,
	          visibleItems: visibleItems,
	          firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
	          lastPosition: lastPosition,
	          showArrows: showArrows
	        };
	      });
	    });

	    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item, e) {
	      if (!isKeyboardEvent(e) || e.key === 'Enter') {
	        var handler = _this.props.onSelectItem;

	        if (typeof handler === 'function') {
	          handler(index, item);
	        }
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function () {
	      _this.setState({
	        swiping: true
	      });
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function () {
	      _this.setState({
	        swiping: false
	      });
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta) {
	      var deltaX = delta.x;

	      if (!_this.state.itemSize || !_this.itemsWrapperRef || !_this.state.visibleItems) {
	        return false;
	      }

	      var leftBoundary = 0;

	      var childrenLength = _react.Children.count(_this.props.children);

	      var currentPosition = -(_this.state.firstItem * 100) / _this.state.visibleItems;
	      var lastLeftItem = Math.max(childrenLength - _this.state.visibleItems, 0);
	      var lastLeftBoundary = -lastLeftItem * 100 / _this.state.visibleItems; // prevent user from swiping left out of boundaries

	      if (currentPosition === leftBoundary && deltaX > 0) {
	        deltaX = 0;
	      } // prevent user from swiping right out of boundaries


	      if (currentPosition === lastLeftBoundary && deltaX < 0) {
	        deltaX = 0;
	      }

	      var wrapperSize = _this.itemsWrapperRef.clientWidth;
	      var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move

	      if (_this.itemsListRef) {
	        ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	          _this.itemsListRef.style[prop] = (0, _CSSTranslate.default)(position, '%', _this.props.axis);
	        });
	      }

	      return true;
	    });

	    _defineProperty(_assertThisInitialized(_this), "slideRight", function (positions) {
	      _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
	    });

	    _defineProperty(_assertThisInitialized(_this), "slideLeft", function (positions) {
	      _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
	    });

	    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
	      // position can't be lower than 0
	      position = position < 0 ? 0 : position; // position can't be higher than last postion

	      position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;

	      _this.setState({
	        firstItem: position
	      });
	    });

	    _this.state = {
	      selectedItem: _props.selectedItem,
	      swiping: false,
	      showArrows: false,
	      firstItem: 0,
	      visibleItems: 0,
	      lastPosition: 0
	    };
	    return _this;
	  }

	  _createClass(Thumbs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setupThumbs();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.selectedItem !== this.state.selectedItem) {
	        this.setState({
	          selectedItem: this.props.selectedItem,
	          firstItem: this.getFirstItem(this.props.selectedItem)
	        });
	      }

	      if (this.props.children === prevProps.children) {
	        return;
	      } // This will capture any size changes for arrow adjustments etc.
	      // usually in the same render cycle so we don't see any flickers


	      this.updateSizes();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyThumbs();
	    }
	  }, {
	    key: "setupThumbs",
	    value: function setupThumbs() {
	      // as the widths are calculated, we need to resize
	      // the carousel when the window is resized
	      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

	      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes); // when the component is rendered we need to calculate
	      // the container size to adjust the responsive behaviour

	      this.updateSizes();
	    }
	  }, {
	    key: "destroyThumbs",
	    value: function destroyThumbs() {
	      // removing listeners
	      (0, _window.default)().removeEventListener('resize', this.updateSizes);
	      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
	    }
	  }, {
	    key: "getFirstItem",
	    value: function getFirstItem(selectedItem) {
	      var firstItem = selectedItem;

	      if (selectedItem >= this.state.lastPosition) {
	        firstItem = this.state.lastPosition;
	      }

	      if (selectedItem < this.state.firstItem + this.state.visibleItems) {
	        firstItem = this.state.firstItem;
	      }

	      if (selectedItem < this.state.firstItem) {
	        firstItem = selectedItem;
	      }

	      return firstItem;
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this2 = this;

	      return this.props.children.map(function (img, index) {
	        var itemClass = _cssClasses.default.ITEM(false, index === _this2.state.selectedItem);

	        var thumbProps = {
	          key: index,
	          ref: function ref(e) {
	            return _this2.setThumbsRef(e, index);
	          },
	          className: itemClass,
	          onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
	          onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
	          'aria-label': "".concat(_this2.props.labels.item, " ").concat(index + 1),
	          style: {
	            width: _this2.props.thumbWidth
	          }
	        };
	        return /*#__PURE__*/_react.default.createElement("li", _extends({}, thumbProps, {
	          role: "button",
	          tabIndex: 0
	        }), img);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;

	      if (!this.props.children) {
	        return null;
	      }

	      var isSwipeable = _react.Children.count(this.props.children) > 1; // show left arrow?

	      var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow

	      var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles

	      var itemListStyles = {};
	      var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
	      var transformProp = (0, _CSSTranslate.default)(currentPosition, 'px', this.props.axis);
	      var transitionTime = this.props.transitionTime + 'ms';
	      itemListStyles = {
	        WebkitTransform: transformProp,
	        MozTransform: transformProp,
	        MsTransform: transformProp,
	        OTransform: transformProp,
	        transform: transformProp,
	        msTransform: transformProp,
	        WebkitTransitionDuration: transitionTime,
	        MozTransitionDuration: transitionTime,
	        MsTransitionDuration: transitionTime,
	        OTransitionDuration: transitionTime,
	        transitionDuration: transitionTime,
	        msTransitionDuration: transitionTime
	      };
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.CAROUSEL(false)
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.WRAPPER(false),
	        ref: this.setItemsWrapperRef
	      }, /*#__PURE__*/_react.default.createElement("button", {
	        type: "button",
	        className: _cssClasses.default.ARROW_PREV(!hasPrev),
	        onClick: function onClick() {
	          return _this3.slideRight();
	        },
	        "aria-label": this.props.labels.leftArrow
	      }), isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, {
	        tagName: "ul",
	        className: _cssClasses.default.SLIDER(false, this.state.swiping),
	        onSwipeLeft: this.slideLeft,
	        onSwipeRight: this.slideRight,
	        onSwipeMove: this.onSwipeMove,
	        onSwipeStart: this.onSwipeStart,
	        onSwipeEnd: this.onSwipeEnd,
	        style: itemListStyles,
	        innerRef: this.setItemsListRef,
	        allowMouseEvents: this.props.emulateTouch
	      }, this.renderItems()) : /*#__PURE__*/_react.default.createElement("ul", {
	        className: _cssClasses.default.SLIDER(false, this.state.swiping),
	        ref: function ref(node) {
	          return _this3.setItemsListRef(node);
	        },
	        style: itemListStyles
	      }, this.renderItems()), /*#__PURE__*/_react.default.createElement("button", {
	        type: "button",
	        className: _cssClasses.default.ARROW_NEXT(!hasNext),
	        onClick: function onClick() {
	          return _this3.slideLeft();
	        },
	        "aria-label": this.props.labels.rightArrow
	      })));
	    }
	  }]);

	  return Thumbs;
	}(_react.Component);

	Thumbs.default = Thumbs$1;

	_defineProperty(Thumbs$1, "displayName", 'Thumbs');

	_defineProperty(Thumbs$1, "defaultProps", {
	  axis: 'horizontal',
	  labels: {
	    leftArrow: 'previous slide / item',
	    rightArrow: 'next slide / item',
	    item: 'slide item'
	  },
	  selectedItem: 0,
	  thumbWidth: 80,
	  transitionTime: 350
	});
	return Thumbs;
}

var document$1 = {};

var hasRequiredDocument;

function requireDocument () {
	if (hasRequiredDocument) return document$1;
	hasRequiredDocument = 1;

	Object.defineProperty(document$1, "__esModule", {
	  value: true
	});
	document$1.default = void 0;

	var _default = function _default() {
	  return document;
	};

	document$1.default = _default;
	return document$1;
}

var utils = {};

var hasRequiredUtils;

function requireUtils () {
	if (hasRequiredUtils) return utils;
	hasRequiredUtils = 1;

	Object.defineProperty(utils, "__esModule", {
	  value: true
	});
	utils.setPosition = utils.getPosition = utils.isKeyboardEvent = utils.defaultStatusFormatter = utils.noop = void 0;

	var _react = React__default;

	var _CSSTranslate = _interopRequireDefault(requireCSSTranslate());

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var noop = function noop() {};

	utils.noop = noop;

	var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
	  return "".concat(current, " of ").concat(total);
	};

	utils.defaultStatusFormatter = defaultStatusFormatter;

	var isKeyboardEvent = function isKeyboardEvent(e) {
	  return e ? e.hasOwnProperty('key') : false;
	};
	/**
	 * Gets the list 'position' relative to a current index
	 * @param index
	 */


	utils.isKeyboardEvent = isKeyboardEvent;

	var getPosition = function getPosition(index, props) {
	  if (props.infiniteLoop) {
	    // index has to be added by 1 because of the first cloned slide
	    ++index;
	  }

	  if (index === 0) {
	    return 0;
	  }

	  var childrenLength = _react.Children.count(props.children);

	  if (props.centerMode && props.axis === 'horizontal') {
	    var currentPosition = -index * props.centerSlidePercentage;
	    var lastPosition = childrenLength - 1;

	    if (index && (index !== lastPosition || props.infiniteLoop)) {
	      currentPosition += (100 - props.centerSlidePercentage) / 2;
	    } else if (index === lastPosition) {
	      currentPosition += 100 - props.centerSlidePercentage;
	    }

	    return currentPosition;
	  }

	  return -index * 100;
	};
	/**
	 * Sets the 'position' transform for sliding animations
	 * @param position
	 * @param forceReflow
	 */


	utils.getPosition = getPosition;

	var setPosition = function setPosition(position, axis) {
	  var style = {};
	  ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	    // @ts-ignore
	    style[prop] = (0, _CSSTranslate.default)(position, '%', axis);
	  });
	  return style;
	};

	utils.setPosition = setPosition;
	return utils;
}

var animations = {};

var hasRequiredAnimations;

function requireAnimations () {
	if (hasRequiredAnimations) return animations;
	hasRequiredAnimations = 1;

	Object.defineProperty(animations, "__esModule", {
	  value: true
	});
	animations.fadeAnimationHandler = animations.slideStopSwipingHandler = animations.slideSwipeAnimationHandler = animations.slideAnimationHandler = void 0;

	var _react = React__default;

	var _CSSTranslate = _interopRequireDefault(requireCSSTranslate());

	var _utils = requireUtils();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	/**
	 * Main animation handler for the default 'sliding' style animation
	 * @param props
	 * @param state
	 */
	var slideAnimationHandler = function slideAnimationHandler(props, state) {
	  var returnStyles = {};
	  var selectedItem = state.selectedItem;
	  var previousItem = selectedItem;
	  var lastPosition = _react.Children.count(props.children) - 1;
	  var needClonedSlide = props.infiniteLoop && (selectedItem < 0 || selectedItem > lastPosition); // Handle list position if it needs a clone

	  if (needClonedSlide) {
	    if (previousItem < 0) {
	      if (props.centerMode && props.centerSlidePercentage && props.axis === 'horizontal') {
	        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * props.centerSlidePercentage - (100 - props.centerSlidePercentage) / 2, props.axis);
	      } else {
	        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * 100, props.axis);
	      }
	    } else if (previousItem > lastPosition) {
	      returnStyles.itemListStyle = (0, _utils.setPosition)(0, props.axis);
	    }

	    return returnStyles;
	  }

	  var currentPosition = (0, _utils.getPosition)(selectedItem, props); // if 3d is available, let's take advantage of the performance of transform

	  var transformProp = (0, _CSSTranslate.default)(currentPosition, '%', props.axis);
	  var transitionTime = props.transitionTime + 'ms';
	  returnStyles.itemListStyle = {
	    WebkitTransform: transformProp,
	    msTransform: transformProp,
	    OTransform: transformProp,
	    transform: transformProp
	  };

	  if (!state.swiping) {
	    returnStyles.itemListStyle = _objectSpread(_objectSpread({}, returnStyles.itemListStyle), {}, {
	      WebkitTransitionDuration: transitionTime,
	      MozTransitionDuration: transitionTime,
	      OTransitionDuration: transitionTime,
	      transitionDuration: transitionTime,
	      msTransitionDuration: transitionTime
	    });
	  }

	  return returnStyles;
	};
	/**
	 * Swiping animation handler for the default 'sliding' style animation
	 * @param delta
	 * @param props
	 * @param state
	 * @param setState
	 */


	animations.slideAnimationHandler = slideAnimationHandler;

	var slideSwipeAnimationHandler = function slideSwipeAnimationHandler(delta, props, state, setState) {
	  var returnStyles = {};
	  var isHorizontal = props.axis === 'horizontal';

	  var childrenLength = _react.Children.count(props.children);

	  var initialBoundry = 0;
	  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
	  var finalBoundry = props.infiniteLoop ? (0, _utils.getPosition)(childrenLength - 1, props) - 100 : (0, _utils.getPosition)(childrenLength - 1, props);
	  var axisDelta = isHorizontal ? delta.x : delta.y;
	  var handledDelta = axisDelta; // prevent user from swiping left out of boundaries

	  if (currentPosition === initialBoundry && axisDelta > 0) {
	    handledDelta = 0;
	  } // prevent user from swiping right out of boundaries


	  if (currentPosition === finalBoundry && axisDelta < 0) {
	    handledDelta = 0;
	  }

	  var position = currentPosition + 100 / (state.itemSize / handledDelta);
	  var hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;

	  if (props.infiniteLoop && hasMoved) {
	    // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
	    // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
	    if (state.selectedItem === 0 && position > -100) {
	      position -= childrenLength * 100;
	    } else if (state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) {
	      position += childrenLength * 100;
	    }
	  }

	  if (!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
	    if (!state.swipeMovementStarted) {
	      setState({
	        swipeMovementStarted: true
	      });
	    }

	    returnStyles.itemListStyle = (0, _utils.setPosition)(position, props.axis);
	  } //allows scroll if the swipe was within the tolerance


	  if (hasMoved && !state.cancelClick) {
	    setState({
	      cancelClick: true
	    });
	  }

	  return returnStyles;
	};
	/**
	 * Default 'sliding' style animination handler for when a swipe action stops.
	 * @param props
	 * @param state
	 */


	animations.slideSwipeAnimationHandler = slideSwipeAnimationHandler;

	var slideStopSwipingHandler = function slideStopSwipingHandler(props, state) {
	  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
	  var itemListStyle = (0, _utils.setPosition)(currentPosition, props.axis);
	  return {
	    itemListStyle: itemListStyle
	  };
	};
	/**
	 * Main animation handler for the default 'fade' style animation
	 * @param props
	 * @param state
	 */


	animations.slideStopSwipingHandler = slideStopSwipingHandler;

	var fadeAnimationHandler = function fadeAnimationHandler(props, state) {
	  var transitionTime = props.transitionTime + 'ms';
	  var transitionTimingFunction = 'ease-in-out';
	  var slideStyle = {
	    position: 'absolute',
	    display: 'block',
	    zIndex: -2,
	    minHeight: '100%',
	    opacity: 0,
	    top: 0,
	    right: 0,
	    left: 0,
	    bottom: 0,
	    transitionTimingFunction: transitionTimingFunction,
	    msTransitionTimingFunction: transitionTimingFunction,
	    MozTransitionTimingFunction: transitionTimingFunction,
	    WebkitTransitionTimingFunction: transitionTimingFunction,
	    OTransitionTimingFunction: transitionTimingFunction
	  };

	  if (!state.swiping) {
	    slideStyle = _objectSpread(_objectSpread({}, slideStyle), {}, {
	      WebkitTransitionDuration: transitionTime,
	      MozTransitionDuration: transitionTime,
	      OTransitionDuration: transitionTime,
	      transitionDuration: transitionTime,
	      msTransitionDuration: transitionTime
	    });
	  }

	  return {
	    slideStyle: slideStyle,
	    selectedStyle: _objectSpread(_objectSpread({}, slideStyle), {}, {
	      opacity: 1,
	      position: 'relative'
	    }),
	    prevStyle: _objectSpread({}, slideStyle)
	  };
	};

	animations.fadeAnimationHandler = fadeAnimationHandler;
	return animations;
}

var hasRequiredCarousel;

function requireCarousel () {
	if (hasRequiredCarousel) return Carousel;
	hasRequiredCarousel = 1;

	Object.defineProperty(Carousel, "__esModule", {
	  value: true
	});
	Carousel.default = void 0;

	var _react = _interopRequireWildcard(React__default);

	var _reactEasySwipe = _interopRequireDefault(requireLib$1());

	var _cssClasses = _interopRequireDefault(requireCssClasses());

	var _Thumbs = _interopRequireDefault(requireThumbs());

	var _document = _interopRequireDefault(requireDocument());

	var _window = _interopRequireDefault(requireWindow());

	var _utils = requireUtils();

	var _animations = requireAnimations();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); return Constructor; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var Carousel$1 = /*#__PURE__*/function (_React$Component) {
	  _inherits(Carousel, _React$Component);

	  var _super = _createSuper(Carousel);

	  // @ts-ignore
	  function Carousel(props) {
	    var _this;

	    _classCallCheck(this, Carousel);

	    _this = _super.call(this, props);

	    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "carouselWrapperRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "listRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "itemsRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "timer", void 0);

	    _defineProperty(_assertThisInitialized(_this), "animationHandler", void 0);

	    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node) {
	      _this.thumbsRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setCarouselWrapperRef", function (node) {
	      _this.carouselWrapperRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setListRef", function (node) {
	      _this.listRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setItemsRef", function (node, index) {
	      if (!_this.itemsRef) {
	        _this.itemsRef = [];
	      }

	      _this.itemsRef[index] = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function () {
	      if (_react.Children.count(_this.props.children) <= 1) {
	        return;
	      }

	      _this.clearAutoPlay();

	      if (!_this.props.autoPlay) {
	        return;
	      }

	      _this.timer = setTimeout(function () {
	        _this.increment();
	      }, _this.props.interval);
	    });

	    _defineProperty(_assertThisInitialized(_this), "clearAutoPlay", function () {
	      if (_this.timer) clearTimeout(_this.timer);
	    });

	    _defineProperty(_assertThisInitialized(_this), "resetAutoPlay", function () {
	      _this.clearAutoPlay();

	      _this.autoPlay();
	    });

	    _defineProperty(_assertThisInitialized(_this), "stopOnHover", function () {
	      _this.setState({
	        isMouseEntered: true
	      }, _this.clearAutoPlay);
	    });

	    _defineProperty(_assertThisInitialized(_this), "startOnLeave", function () {
	      _this.setState({
	        isMouseEntered: false
	      }, _this.autoPlay);
	    });

	    _defineProperty(_assertThisInitialized(_this), "isFocusWithinTheCarousel", function () {
	      if (!_this.carouselWrapperRef) {
	        return false;
	      }

	      if ((0, _document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, _document.default)().activeElement)) {
	        return true;
	      }

	      return false;
	    });

	    _defineProperty(_assertThisInitialized(_this), "navigateWithKeyboard", function (e) {
	      if (!_this.isFocusWithinTheCarousel()) {
	        return;
	      }

	      var axis = _this.props.axis;
	      var isHorizontal = axis === 'horizontal';
	      var keyNames = {
	        ArrowUp: 38,
	        ArrowRight: 39,
	        ArrowDown: 40,
	        ArrowLeft: 37
	      };
	      var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
	      var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;

	      if (nextKey === e.keyCode) {
	        _this.increment();
	      } else if (prevKey === e.keyCode) {
	        _this.decrement();
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
	      if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) {
	        return;
	      }

	      var isHorizontal = _this.props.axis === 'horizontal';
	      var firstItem = _this.itemsRef[0];

	      if (!firstItem) {
	        return;
	      }

	      var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;

	      _this.setState({
	        itemSize: itemSize
	      });

	      if (_this.thumbsRef) {
	        _this.thumbsRef.updateSizes();
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "setMountState", function () {
	      _this.setState({
	        hasMount: true
	      });

	      _this.updateSizes();
	    });

	    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item) {
	      if (_react.Children.count(_this.props.children) === 0) {
	        return;
	      }

	      if (_this.state.cancelClick) {
	        _this.setState({
	          cancelClick: false
	        });

	        return;
	      }

	      _this.props.onClickItem(index, item);

	      if (index !== _this.state.selectedItem) {
	        _this.setState({
	          selectedItem: index
	        });
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (index, item) {
	      if (_react.Children.count(_this.props.children) <= 1) {
	        return;
	      }

	      _this.props.onChange(index, item);
	    });

	    _defineProperty(_assertThisInitialized(_this), "handleClickThumb", function (index, item) {
	      _this.props.onClickThumb(index, item);

	      _this.moveTo(index);
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function (event) {
	      _this.setState({
	        swiping: true
	      });

	      _this.props.onSwipeStart(event);
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function (event) {
	      _this.setState({
	        swiping: false,
	        cancelClick: false,
	        swipeMovementStarted: false
	      });

	      _this.props.onSwipeEnd(event);

	      _this.clearAutoPlay();

	      if (_this.state.autoPlay) {
	        _this.autoPlay();
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta, event) {
	      _this.props.onSwipeMove(event);

	      var animationHandlerResponse = _this.props.swipeAnimationHandler(delta, _this.props, _this.state, _this.setState.bind(_assertThisInitialized(_this)));

	      _this.setState(_objectSpread({}, animationHandlerResponse)); // If we have not moved, we should have an empty object returned
	      // Return false to allow scrolling when not swiping


	      return !!Object.keys(animationHandlerResponse).length;
	    });

	    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
	      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	      _this.moveTo(_this.state.selectedItem - (typeof positions === 'number' ? positions : 1));
	    });

	    _defineProperty(_assertThisInitialized(_this), "increment", function () {
	      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	      _this.moveTo(_this.state.selectedItem + (typeof positions === 'number' ? positions : 1));
	    });

	    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
	      if (typeof position !== 'number') {
	        return;
	      }

	      var lastPosition = _react.Children.count(_this.props.children) - 1;

	      if (position < 0) {
	        position = _this.props.infiniteLoop ? lastPosition : 0;
	      }

	      if (position > lastPosition) {
	        position = _this.props.infiniteLoop ? 0 : lastPosition;
	      }

	      _this.selectItem({
	        // if it's not a slider, we don't need to set position here
	        selectedItem: position
	      }); // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
	      // and will result in the interval function not being cleared correctly.


	      if (_this.state.autoPlay && _this.state.isMouseEntered === false) {
	        _this.resetAutoPlay();
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "onClickNext", function () {
	      _this.increment(1);
	    });

	    _defineProperty(_assertThisInitialized(_this), "onClickPrev", function () {
	      _this.decrement(1);
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeForward", function () {
	      _this.increment(1);

	      if (_this.props.emulateTouch) {
	        _this.setState({
	          cancelClick: true
	        });
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeBackwards", function () {
	      _this.decrement(1);

	      if (_this.props.emulateTouch) {
	        _this.setState({
	          cancelClick: true
	        });
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "changeItem", function (newIndex) {
	      return function (e) {
	        if (!(0, _utils.isKeyboardEvent)(e) || e.key === 'Enter') {
	          _this.moveTo(newIndex);
	        }
	      };
	    });

	    _defineProperty(_assertThisInitialized(_this), "selectItem", function (state) {
	      // Merge in the new state while updating updating previous item
	      _this.setState(_objectSpread({
	        previousItem: _this.state.selectedItem
	      }, state), function () {
	        // Run animation handler and update styles based on it
	        _this.setState(_this.animationHandler(_this.props, _this.state));
	      });

	      _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
	    });

	    _defineProperty(_assertThisInitialized(_this), "getInitialImage", function () {
	      var selectedItem = _this.props.selectedItem;
	      var item = _this.itemsRef && _this.itemsRef[selectedItem];
	      var images = item && item.getElementsByTagName('img') || [];
	      return images[0];
	    });

	    _defineProperty(_assertThisInitialized(_this), "getVariableItemHeight", function (position) {
	      var item = _this.itemsRef && _this.itemsRef[position];

	      if (_this.state.hasMount && item && item.children.length) {
	        var slideImages = item.children[0].getElementsByTagName('img') || [];

	        if (slideImages.length > 0) {
	          var image = slideImages[0];

	          if (!image.complete) {
	            // if the image is still loading, the size won't be available so we trigger a new render after it's done
	            var onImageLoad = function onImageLoad() {
	              _this.forceUpdate();

	              image.removeEventListener('load', onImageLoad);
	            };

	            image.addEventListener('load', onImageLoad);
	          }
	        } // try to get img first, if img not there find first display tag


	        var displayItem = slideImages[0] || item.children[0];
	        var height = displayItem.clientHeight;
	        return height > 0 ? height : null;
	      }

	      return null;
	    });

	    var initState = {
	      initialized: false,
	      previousItem: props.selectedItem,
	      selectedItem: props.selectedItem,
	      hasMount: false,
	      isMouseEntered: false,
	      autoPlay: props.autoPlay,
	      swiping: false,
	      swipeMovementStarted: false,
	      cancelClick: false,
	      itemSize: 1,
	      itemListStyle: {},
	      slideStyle: {},
	      selectedStyle: {},
	      prevStyle: {}
	    };
	    _this.animationHandler = typeof props.animationHandler === 'function' && props.animationHandler || props.animationHandler === 'fade' && _animations.fadeAnimationHandler || _animations.slideAnimationHandler;
	    _this.state = _objectSpread(_objectSpread({}, initState), _this.animationHandler(props, initState));
	    return _this;
	  }

	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!this.props.children) {
	        return;
	      }

	      this.setupCarousel();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!prevProps.children && this.props.children && !this.state.initialized) {
	        this.setupCarousel();
	      }

	      if (!prevProps.autoFocus && this.props.autoFocus) {
	        this.forceFocus();
	      }

	      if (prevState.swiping && !this.state.swiping) {
	        // We stopped swiping, ensure we are heading to the new/current slide and not stuck
	        this.setState(_objectSpread({}, this.props.stopSwipingHandler(this.props, this.state)));
	      }

	      if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
	        this.updateSizes();
	        this.moveTo(this.props.selectedItem);
	      }

	      if (prevProps.autoPlay !== this.props.autoPlay) {
	        if (this.props.autoPlay) {
	          this.setupAutoPlay();
	        } else {
	          this.destroyAutoPlay();
	        }

	        this.setState({
	          autoPlay: this.props.autoPlay
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyCarousel();
	    }
	  }, {
	    key: "setupCarousel",
	    value: function setupCarousel() {
	      var _this2 = this;

	      this.bindEvents();

	      if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) {
	        this.setupAutoPlay();
	      }

	      if (this.props.autoFocus) {
	        this.forceFocus();
	      }

	      this.setState({
	        initialized: true
	      }, function () {
	        var initialImage = _this2.getInitialImage();

	        if (initialImage && !initialImage.complete) {
	          // if it's a carousel of images, we set the mount state after the first image is loaded
	          initialImage.addEventListener('load', _this2.setMountState);
	        } else {
	          _this2.setMountState();
	        }
	      });
	    }
	  }, {
	    key: "destroyCarousel",
	    value: function destroyCarousel() {
	      if (this.state.initialized) {
	        this.unbindEvents();
	        this.destroyAutoPlay();
	      }
	    }
	  }, {
	    key: "setupAutoPlay",
	    value: function setupAutoPlay() {
	      this.autoPlay();
	      var carouselWrapper = this.carouselWrapperRef;

	      if (this.props.stopOnHover && carouselWrapper) {
	        carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
	        carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
	      }
	    }
	  }, {
	    key: "destroyAutoPlay",
	    value: function destroyAutoPlay() {
	      this.clearAutoPlay();
	      var carouselWrapper = this.carouselWrapperRef;

	      if (this.props.stopOnHover && carouselWrapper) {
	        carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
	        carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
	      }
	    }
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      // as the widths are calculated, we need to resize
	      // the carousel when the window is resized
	      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

	      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes);

	      if (this.props.useKeyboardArrows) {
	        (0, _document.default)().addEventListener('keydown', this.navigateWithKeyboard);
	      }
	    }
	  }, {
	    key: "unbindEvents",
	    value: function unbindEvents() {
	      // removing listeners
	      (0, _window.default)().removeEventListener('resize', this.updateSizes);
	      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
	      var initialImage = this.getInitialImage();

	      if (initialImage) {
	        initialImage.removeEventListener('load', this.setMountState);
	      }

	      if (this.props.useKeyboardArrows) {
	        (0, _document.default)().removeEventListener('keydown', this.navigateWithKeyboard);
	      }
	    }
	  }, {
	    key: "forceFocus",
	    value: function forceFocus() {
	      var _this$carouselWrapper;

	      (_this$carouselWrapper = this.carouselWrapperRef) === null || _this$carouselWrapper === void 0 ? void 0 : _this$carouselWrapper.focus();
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems(isClone) {
	      var _this3 = this;

	      if (!this.props.children) {
	        return [];
	      }

	      return _react.Children.map(this.props.children, function (item, index) {
	        var isSelected = index === _this3.state.selectedItem;
	        var isPrevious = index === _this3.state.previousItem;
	        var style = isSelected && _this3.state.selectedStyle || isPrevious && _this3.state.prevStyle || _this3.state.slideStyle || {};

	        if (_this3.props.centerMode && _this3.props.axis === 'horizontal') {
	          style = _objectSpread(_objectSpread({}, style), {}, {
	            minWidth: _this3.props.centerSlidePercentage + '%'
	          });
	        }

	        if (_this3.state.swiping && _this3.state.swipeMovementStarted) {
	          style = _objectSpread(_objectSpread({}, style), {}, {
	            pointerEvents: 'none'
	          });
	        }

	        var slideProps = {
	          ref: function ref(e) {
	            return _this3.setItemsRef(e, index);
	          },
	          key: 'itemKey' + index + (isClone ? 'clone' : ''),
	          className: _cssClasses.default.ITEM(true, index === _this3.state.selectedItem, index === _this3.state.previousItem),
	          onClick: _this3.handleClickItem.bind(_this3, index, item),
	          style: style
	        };
	        return /*#__PURE__*/_react.default.createElement("li", slideProps, _this3.props.renderItem(item, {
	          isSelected: index === _this3.state.selectedItem,
	          isPrevious: index === _this3.state.previousItem
	        }));
	      });
	    }
	  }, {
	    key: "renderControls",
	    value: function renderControls() {
	      var _this4 = this;

	      var _this$props = this.props,
	          showIndicators = _this$props.showIndicators,
	          labels = _this$props.labels,
	          renderIndicator = _this$props.renderIndicator,
	          children = _this$props.children;

	      if (!showIndicators) {
	        return null;
	      }

	      return /*#__PURE__*/_react.default.createElement("ul", {
	        className: "control-dots"
	      }, _react.Children.map(children, function (_, index) {
	        return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
	      }));
	    }
	  }, {
	    key: "renderStatus",
	    value: function renderStatus() {
	      if (!this.props.showStatus) {
	        return null;
	      }

	      return /*#__PURE__*/_react.default.createElement("p", {
	        className: "carousel-status"
	      }, this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children)));
	    }
	  }, {
	    key: "renderThumbs",
	    value: function renderThumbs() {
	      if (!this.props.showThumbs || !this.props.children || _react.Children.count(this.props.children) === 0) {
	        return null;
	      }

	      return /*#__PURE__*/_react.default.createElement(_Thumbs.default, {
	        ref: this.setThumbsRef,
	        onSelectItem: this.handleClickThumb,
	        selectedItem: this.state.selectedItem,
	        transitionTime: this.props.transitionTime,
	        thumbWidth: this.props.thumbWidth,
	        labels: this.props.labels,
	        emulateTouch: this.props.emulateTouch
	      }, this.props.renderThumbs(this.props.children));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;

	      if (!this.props.children || _react.Children.count(this.props.children) === 0) {
	        return null;
	      }

	      var isSwipeable = this.props.swipeable && _react.Children.count(this.props.children) > 1;
	      var isHorizontal = this.props.axis === 'horizontal';
	      var canShowArrows = this.props.showArrows && _react.Children.count(this.props.children) > 1; // show left arrow?

	      var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow

	      var hasNext = canShowArrows && (this.state.selectedItem < _react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false;
	      var itemsClone = this.renderItems(true);
	      var firstClone = itemsClone.shift();
	      var lastClone = itemsClone.pop();
	      var swiperProps = {
	        className: _cssClasses.default.SLIDER(true, this.state.swiping),
	        onSwipeMove: this.onSwipeMove,
	        onSwipeStart: this.onSwipeStart,
	        onSwipeEnd: this.onSwipeEnd,
	        style: this.state.itemListStyle,
	        tolerance: this.props.swipeScrollTolerance
	      };
	      var containerStyles = {};

	      if (isHorizontal) {
	        swiperProps.onSwipeLeft = this.onSwipeForward;
	        swiperProps.onSwipeRight = this.onSwipeBackwards;

	        if (this.props.dynamicHeight) {
	          var itemHeight = this.getVariableItemHeight(this.state.selectedItem); // swiperProps.style.height = itemHeight || 'auto';

	          containerStyles.height = itemHeight || 'auto';
	        }
	      } else {
	        swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.onSwipeBackwards : this.onSwipeForward;
	        swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.onSwipeForward : this.onSwipeBackwards;
	        swiperProps.style = _objectSpread(_objectSpread({}, swiperProps.style), {}, {
	          height: this.state.itemSize
	        });
	        containerStyles.height = this.state.itemSize;
	      }

	      return /*#__PURE__*/_react.default.createElement("div", {
	        "aria-label": this.props.ariaLabel,
	        className: _cssClasses.default.ROOT(this.props.className),
	        ref: this.setCarouselWrapperRef,
	        tabIndex: this.props.useKeyboardArrows ? 0 : undefined
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.CAROUSEL(true),
	        style: {
	          width: this.props.width
	        }
	      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.WRAPPER(true, this.props.axis),
	        style: containerStyles
	      }, isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, _extends({
	        tagName: "ul",
	        innerRef: this.setListRef
	      }, swiperProps, {
	        allowMouseEvents: this.props.emulateTouch
	      }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/_react.default.createElement("ul", {
	        className: _cssClasses.default.SLIDER(true, this.state.swiping),
	        ref: function ref(node) {
	          return _this5.setListRef(node);
	        },
	        style: this.state.itemListStyle || {}
	      }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
	    }
	  }]);

	  return Carousel;
	}(_react.default.Component);

	Carousel.default = Carousel$1;

	_defineProperty(Carousel$1, "displayName", 'Carousel');

	_defineProperty(Carousel$1, "defaultProps", {
	  ariaLabel: undefined,
	  axis: 'horizontal',
	  centerSlidePercentage: 80,
	  interval: 3000,
	  labels: {
	    leftArrow: 'previous slide / item',
	    rightArrow: 'next slide / item',
	    item: 'slide item'
	  },
	  onClickItem: _utils.noop,
	  onClickThumb: _utils.noop,
	  onChange: _utils.noop,
	  onSwipeStart: function onSwipeStart() {},
	  onSwipeEnd: function onSwipeEnd() {},
	  onSwipeMove: function onSwipeMove() {
	    return false;
	  },
	  preventMovementUntilSwipeScrollTolerance: false,
	  renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
	    return /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      "aria-label": label,
	      className: _cssClasses.default.ARROW_PREV(!hasPrev),
	      onClick: onClickHandler
	    });
	  },
	  renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
	    return /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      "aria-label": label,
	      className: _cssClasses.default.ARROW_NEXT(!hasNext),
	      onClick: onClickHandler
	    });
	  },
	  renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
	    return /*#__PURE__*/_react.default.createElement("li", {
	      className: _cssClasses.default.DOT(isSelected),
	      onClick: onClickHandler,
	      onKeyDown: onClickHandler,
	      value: index,
	      key: index,
	      role: "button",
	      tabIndex: 0,
	      "aria-label": "".concat(label, " ").concat(index + 1)
	    });
	  },
	  renderItem: function renderItem(item) {
	    return item;
	  },
	  renderThumbs: function renderThumbs(children) {
	    var images = _react.Children.map(children, function (item) {
	      var img = item; // if the item is not an image, try to find the first image in the item's children.

	      if (item.type !== 'img') {
	        img = _react.Children.toArray(item.props.children).find(function (children) {
	          return children.type === 'img';
	        });
	      }

	      if (!img) {
	        return undefined;
	      }

	      return img;
	    });

	    if (images.filter(function (image) {
	      return image;
	    }).length === 0) {
	      console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
	      return [];
	    }

	    return images;
	  },
	  statusFormatter: _utils.defaultStatusFormatter,
	  selectedItem: 0,
	  showArrows: true,
	  showIndicators: true,
	  showStatus: true,
	  showThumbs: true,
	  stopOnHover: true,
	  swipeScrollTolerance: 5,
	  swipeable: true,
	  transitionTime: 350,
	  verticalSwipe: 'standard',
	  width: '100%',
	  animationHandler: 'slide',
	  swipeAnimationHandler: _animations.slideSwipeAnimationHandler,
	  stopSwipingHandler: _animations.slideStopSwipingHandler
	});
	return Carousel;
}

var types = {};

var hasRequiredTypes;

function requireTypes () {
	if (hasRequiredTypes) return types;
	hasRequiredTypes = 1;
	return types;
}

var hasRequiredJs;

function requireJs () {
	if (hasRequiredJs) return js;
	hasRequiredJs = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		Object.defineProperty(exports, "Carousel", {
		  enumerable: true,
		  get: function get() {
		    return _Carousel.default;
		  }
		});
		Object.defineProperty(exports, "CarouselProps", {
		  enumerable: true,
		  get: function get() {
		    return _types.CarouselProps;
		  }
		});
		Object.defineProperty(exports, "Thumbs", {
		  enumerable: true,
		  get: function get() {
		    return _Thumbs.default;
		  }
		});

		var _Carousel = _interopRequireDefault(requireCarousel());

		var _types = requireTypes();

		var _Thumbs = _interopRequireDefault(requireThumbs());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } 
	} (js));
	return js;
}

var jsExports = requireJs();

var StyledCarousel = styled(jsExports.Carousel)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  .carousel-slider {\n    padding-bottom: 30px;\n    @media (min-width: ", ") {\n      padding-bottom: 0;\n    }\n    .slider {\n      gap: 1rem;\n      width: calc(100% - 1rem);\n      @media (min-width: ", ") {\n        transform: none !important;\n        width: 100%;\n      }\n    }\n    .slide {\n      text-align: left;\n      flex-grow: 1;\n      flex-basis: 0;\n      list-style-type: none !important;\n      height: 100%;\n      @media (min-width: ", ") {\n        min-width: 50px !important;\n      }\n      .card {\n        height: 100%;\n      }\n    }\n    li.slide {\n      padding-top: 3px;\n    }\n    .control-dots{\n      margin: 0;\n      .dot{\n        border: 1px solid #6a7071;\n        box-shadow: none;\n        width: 17px;\n        height: 17px;\n        opacity: .5;\n        margin: 0 3px;\n        &.selected{\n          opacity: 1;\n          background-color: var(--primary);\n          border-color: var(--primary);\n        }\n      }\n    }\n    .sticky {\n      background: #edf0f4;\n      z-index: 1;\n      &::after {\n        content: '';\n        display: block;\n        height: 5px;\n        margin-top: -6px;\n        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.5);\n      }\n    }\n  }\n"], ["\n  .carousel-slider {\n    padding-bottom: 30px;\n    @media (min-width: ", ") {\n      padding-bottom: 0;\n    }\n    .slider {\n      gap: 1rem;\n      width: calc(100% - 1rem);\n      @media (min-width: ", ") {\n        transform: none !important;\n        width: 100%;\n      }\n    }\n    .slide {\n      text-align: left;\n      flex-grow: 1;\n      flex-basis: 0;\n      list-style-type: none !important;\n      height: 100%;\n      @media (min-width: ", ") {\n        min-width: 50px !important;\n      }\n      .card {\n        height: 100%;\n      }\n    }\n    li.slide {\n      padding-top: 3px;\n    }\n    .control-dots{\n      margin: 0;\n      .dot{\n        border: 1px solid #6a7071;\n        box-shadow: none;\n        width: 17px;\n        height: 17px;\n        opacity: .5;\n        margin: 0 3px;\n        &.selected{\n          opacity: 1;\n          background-color: var(--primary);\n          border-color: var(--primary);\n        }\n      }\n    }\n    .sticky {\n      background: #edf0f4;\n      z-index: 1;\n      &::after {\n        content: '';\n        display: block;\n        height: 5px;\n        margin-top: -6px;\n        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.5);\n      }\n    }\n  }\n"])), trEnv$1.stationaer ? breakpoints.sm : breakpoints.lg, trEnv$1.stationaer ? breakpoints.sm : breakpoints.lg, trEnv$1.stationaer ? breakpoints.sm : breakpoints.lg);
var ResponsiveCarousel = function (_a) {
    var _b = _a.children, children = _b === void 0 ? jsx$1("div", {}) : _b, _c = _a.selectedItem, selectedItem = _c === void 0 ? 0 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.showThumbs, showThumbs = _e === void 0 ? false : _e, _f = _a.showArrows, showArrows = _f === void 0 ? false : _f, _g = _a.showStatus, showStatus = _g === void 0 ? false : _g, _h = _a.onChange, onChange = _h === void 0 ? function (arg1, arg2) { } : _h, _j = _a.onClickItem, onClickItem = _j === void 0 ? function (arg1, arg2) { } : _j;
    var brkp = useBreakpoint();
    var brkpMode = trEnv$1.stationaer ? 'sm' : 'lg';
    var filteredChildren = React__default.Children.toArray(children);
    return (jsx$1(StyledCarousel, { selectedItem: selectedItem, onChange: function (index, item) { return onChange(index, item); }, onClickItem: function (index, item) { return onClickItem(index, item); }, centerMode: brkp !== brkpMode, emulateTouch: brkp !== brkpMode, showIndicators: trEnv$1.stationaer ? false : brkp !== 'lg' && React__default.Children.toArray(children).length > 1, showThumbs: showThumbs, showArrows: showArrows, showStatus: showStatus, preventMovementUntilSwipeScrollTolerance: true, swipeScrollTolerance: 30, className: className, children: filteredChildren }));
};
var ResponsiveCarousel$1 = React__default.memo(ResponsiveCarousel);
var templateObject_1$2;

var FondsTable = function (_a) {
    var _b = _a.plaintext, plaintext = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    var fondsListe = useSelector(function (state) { return state.daten.bausteinRente.fondsListe; });
    var updateAndValidateOnChange = useUpdateAndValidateOnChange();
    var minValue = parseInt(fondsListe.minValue, 10);
    if (fondsListe.value.length <= 0) {
        return null;
    }
    return (jsxs(Table, { className: "mx-n2 ".concat(className), children: [jsx$1("thead", { children: jsxs("tr", { children: [jsx$1("th", { children: "Gew\u00E4hlte Dach- bzw. Einzelfonds" }), jsx$1("th", { children: "ISIN" }), jsx$1("th", { children: "Anteil" })] }) }), jsx$1("tbody", { children: fondsListe.value.map(function (elem, index) {
                    var _a, _b, _c, _d, _e;
                    return (elem.bezeichnung && elem.isin) && (jsxs("tr", { children: [jsx$1("td", { children: (_a = elem.bezeichnung) === null || _a === void 0 ? void 0 : _a.value }), jsx$1("td", { children: (_b = elem.isin) === null || _b === void 0 ? void 0 : _b.value }), jsx$1("td", { children: plaintext || minValue === 100 ? "".concat((_c = elem.anteil) === null || _c === void 0 ? void 0 : _c.value, " %") : (jsx$1(FormMask, __assign$1({}, elem.anteil, { label: "Anteil f\u00FCr ".concat((_d = elem.bezeichnung) === null || _d === void 0 ? void 0 : _d.value), className: "fonds-anteil m-0", labelClassName: "visually-hidden", name: "daten.bausteinRente.fondsListe.value.".concat(index, ".anteil.value"), onChange: updateAndValidateOnChange, inputmask: {
                                        mask: '999',
                                        maskChar: '',
                                    }, ueberschreibbar: minValue !== 100, inputGroup: "%", inputMode: "numeric" }))) })] }, "".concat((_e = elem.isin) === null || _e === void 0 ? void 0 : _e.value, "-").concat(index)));
                }) })] }));
};

var FondsCombobox = function (_a) {
    var _b = _a.fondshilfe, fondshilfe = _b === void 0 ? '' : _b;
    var dispatch = useDispatch();
    var fondsListe = useSelector(function (state) { return state.daten.bausteinRente.fondsListe; });
    var fondsHilfetexte = useSelector(function (state) { return state.daten.bausteinRente.fondsHilfetexte; });
    var updateByNameAndValidateOnChange = useUpdateByNameAndValidateOnChange(0);
    var minValue = parseInt(fondsListe.minValue, 10);
    var isMultiSelect = minValue !== 100;
    var fondsValueSet = fondsListe.valueSet.map(function (fonds) { return ({
        id: fonds.id,
        bezeichnung: fonds.bezeichnung,
        ausgewaehlt: fondsListe.value.some(function (elem) { return elem.id.value === fonds.id; }),
    }); });
    var tooltipHoleFondshilfe = function () {
        if (fondshilfe !== '') {
            FileSaver_minExports.saveAs(fondshilfe, 'Fondsinformation');
            return;
        }
        if (!Array.isArray(fondsHilfetexte.valueSet) || fondsListe.valueSet.length === 0) {
            return;
        }
        // fondsHilfetexte in zwei Teile für die Tabelle mit zwei Spalten teilen
        var middleIndex = Math.ceil(fondsHilfetexte.valueSet.length / 2);
        var firstHalf = fondsHilfetexte.valueSet.slice(0, middleIndex);
        var secondHalf = fondsHilfetexte.valueSet.slice(middleIndex);
        var tooltiptext = __spreadArray$1(__spreadArray$1([
            '<h4>Aktuelle Fondspalette</h4>',
            '<p>Nachstehend sehen Sie, welche Investmentfonds aktuell verfügbar sind.</p>',
            '<table>'
        ], firstHalf.map(function (hilfe, index) { return "\n          <tr><td><h4>".concat(hilfe.id, "</h4><p>").concat(hilfe.bezeichnung, "</p></td>\n          ").concat(secondHalf.length - 1 >= index ? "<td><h4>".concat(secondHalf[index].id, "</h4><p>").concat(secondHalf[index].bezeichnung, "</p></td>") : '<td></td>', "</tr>"); }), true), [
            '</table>',
        ], false);
        dispatch(toggleModal(tooltiptext.join(''), 'lg'));
    };
    var displayHilfetext = ((isEmptyObj(fondsHilfetexte)
        || !Array.isArray(fondsHilfetexte === null || fondsHilfetexte === void 0 ? void 0 : fondsHilfetexte.valueSet))
        || fondsHilfetexte.valueSet.length === 0) && fondshilfe === ''
        ? null : tooltipHoleFondshilfe;
    return (fondsListe.relevant && (jsx$1(FormCombobox, __assign$1({}, fondsListe, { title: "Bitte w\u00E4hlen Sie Ihre Anlagestrategie.", subtitle: isMultiSelect
            ? i18next.t('fondsComboBox_subtitle', { minValue: minValue })
            : 'Bitte beachten Sie, dass ein Fonds nur zu 100 % ausgewählt werden kann.', dataType: "Integer", className: "mb-5", name: "daten.bausteinRente.fondsListe.value", isSearchable: false, isMulti: isMultiSelect, isArrayValue: true, value: fondsValueSet, valueSet: fondsValueSet, onChange: function (selected, type) {
            if (type.action === 'select-option') {
                if (fondsListe.value.length === fondsListe.maxLenght) {
                    return;
                }
                var neuerFonds = __assign$1(__assign$1({}, (fondsListe.value[0])), { anteil: {
                        value: minValue,
                    }, id: {
                        value: isMultiSelect ? type.option.id : selected.id,
                    } });
                updateByNameAndValidateOnChange('daten.bausteinRente.fondsListe.value', isMultiSelect ? __spreadArray$1(__spreadArray$1([], fondsListe.value, true), [neuerFonds], false) : [neuerFonds]);
            }
            if (type.action === 'remove-value') {
                updateByNameAndValidateOnChange('daten.bausteinRente.fondsListe.value', fondsListe.value.filter(function (e) { return e.id.value !== type.removedValue.id; }));
            }
            if (type.action === 'clear') {
                updateByNameAndValidateOnChange('daten.bausteinRente.fondsListe.value', []);
            }
        }, tooltip: displayHilfetext }))));
};

var IconButton = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, icon = _a.icon, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, _f = _a.bgWhite, bgWhite = _f === void 0 ? false : _f, _g = _a.size, size = _g === void 0 ? 'sm' : _g, rest = __rest$1(_a, ["className", "icon", "label", "variant", "onClick", "bgWhite", "size"]);
    return (jsxs("div", { className: "position-relative ".concat(bgWhite ? 'bg-white p-3 rounded-1' : '', " ").concat(className), children: [icon, jsxs(Button$1, __assign$1({ variant: variant, className: "btn--animate stretched-link", onClick: onClick, size: size }, rest, { children: [label, jsx$1(SvgArrow, {})] }))] }));
};
var IconButton$1 = React__default.memo(IconButton);

/**
 * Rendert einen einzelnen Vertreter mit Name und Adresse
 *
 * @param vertreter - iON-Feld mit Name, Strasse, Plz und Ort
 * @returns {React.Component}
 */
const VpmsVertreter = _ref => {
  let {
    vertreter,
    className = ''
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: `lh-15 ${className}`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "fw-normal mb-1"
  }, vertreter.nameMetaInfo.value), /*#__PURE__*/React__default.createElement("div", {
    className: "fw-light"
  }, /*#__PURE__*/React__default.createElement("div", null, vertreter.strasseMetaInfo.value), /*#__PURE__*/React__default.createElement("div", null, vertreter.plzMetaInfo.value, ' ', vertreter.ortMetaInfo.value), /*#__PURE__*/React__default.createElement(If$1, {
    predicate: vertreter.telefonMetaInfo?.value
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SvgTelefon, {
    className: "me-2"
  }), /*#__PURE__*/React__default.createElement("a", {
    className: "text-decoration-dotted color-inherit",
    href: `tel:${vertreter.telefonMetaInfo?.value}`
  }, vertreter.telefonMetaInfo?.value))), /*#__PURE__*/React__default.createElement(If$1, {
    predicate: vertreter.emailMetaInfo?.value
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SvgEmail, {
    className: "me-2"
  }), /*#__PURE__*/React__default.createElement("a", {
    className: "text-decoration-dotted color-inherit",
    href: `mailto:${vertreter.emailMetaInfo?.value}`
  }, vertreter.emailMetaInfo?.value)))));
};
var VpmsVertreter$1 = /*#__PURE__*/React__default.memo(VpmsVertreter);

/**
 * Rendert eine IonForm und die Vertreterauswahl als Radiobutton
 *
 * @param onChange
 * @returns {React.Component}
 */

const vertreterWrapperStyle = {
  position: 'relative'
};
const StyledRadioButton = styled(Form.Check)`
  &&& {
    ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled && `
      .form-check-input {
        display: none;
      }
      .form-check-label {
        border: none !important;
        padding: 0 !important;
        color: inherit !important;
        background-color: transparent !important;
      }
    `;
}}
  }
`;
const closeBtnStyle = {
  position: 'absolute',
  top: '5px',
  right: '5px'
};
const VpmsVertreterauswahl = _ref2 => {
  let {
    onRemove = null,
    onChange,
    ...rest
  } = _ref2;
  const amNaechsten = useSelector(state => state.daten.vertretersuche.amNaechstenMetaInfo.value);
  const auswahl = useSelector(state => state.daten.vertretersuche.auswahlMetaInfo.value);
  const suchfeld = useSelector(state => state.daten.vertretersuche.suchfeldMetaInfo);
  if (trEnv$1.stationaer) {
    return null;
  }
  const isChecked = vertreterID => parseInt(vertreterID, 10) === parseInt(auswahl.idMetaInfo.value, 10);
  return /*#__PURE__*/React__default.createElement(FormWrapper$1, _extends({
    error: auswahl.nameMetaInfo.error
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: "vertreterauswahl"
  }, amNaechsten.map(vertreter => /*#__PURE__*/React__default.createElement("div", {
    style: vertreterWrapperStyle,
    key: vertreter.idMetaInfo.value
  }, /*#__PURE__*/React__default.createElement(StyledRadioButton, {
    type: "radio",
    name: "daten.vertretersuche.auswahlMetaInfo.value",
    id: vertreter.idMetaInfo.value,
    value: vertreter.idMetaInfo.value,
    "data-name": vertreter.nameMetaInfo.value,
    "data-strasse": vertreter.strasseMetaInfo.value,
    "data-plz": vertreter.plzMetaInfo.value,
    "data-ort": vertreter.ortMetaInfo.value,
    "data-typ": vertreter.typMetaInfo.value,
    "data-id": vertreter.idMetaInfo.value,
    label: /*#__PURE__*/React__default.createElement(VpmsVertreter$1, {
      vertreter: vertreter
    }),
    checked: isChecked(vertreter.idMetaInfo.value),
    disabled: !suchfeld.relevant,
    onChange: onChange,
    className: isChecked(vertreter.idMetaInfo.value) ? 'checked ' : '',
    isInvalid: rest.error || auswahl.nameMetaInfo.error
  }), suchfeld.relevant && isChecked(vertreter.idMetaInfo.value) && /*#__PURE__*/React__default.createElement(CloseButton, {
    style: closeBtnStyle,
    onClick: onRemove
  })))));
};

/**
 * Rendert eine Vertretersuche mit Typeahead-Funktion
 *
 * @param {Function} onChange
 * @param {Object} rest
 * @returns {React.Component}
 */
const VpmsVertretersuchform = _ref => {
  let {
    onChange,
    onSearch,
    clearInput,
    ...rest
  } = _ref;
  const auswahl = useSelector(state => state.daten.vertretersuche.auswahlMetaInfo.value);
  const suchfeld = useSelector(state => state.daten.vertretersuche.suchfeldMetaInfo);
  const suchergebnisse = useSelector(state => state.daten.vertretersuche.suchergebnisseMetaInfo.value);
  if (!suchfeld.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(TypeaheadInput$1, _extends({}, suchfeld, {
    value: auswahl.value,
    name: "daten.vertretersuche.suchfeldMetaInfo.value",
    onSearch: onSearch,
    onChange: selected => onChange(selected),
    options: suchergebnisse,
    delay: 400,
    className: "mb-5",
    placeholder: "Anderen Ansprechpartner suchen",
    emptyLabel: "Kein Ansprechpartner gefunden",
    paginationText: "Mehr Ansprechpartner anzeigen",
    clearInput: clearInput,
    labelKey: option => `${option.nameMetaInfo.value}`,
    minLenght: 4,
    renderMenuItemChildren: (option, _ref2) => {
      let {
        text
      } = _ref2;
      return /*#__PURE__*/React__default.createElement("div", {
        key: option.nameMetaInfo.value
      }, /*#__PURE__*/React__default.createElement(Highlighter, {
        search: text
      }, option.nameMetaInfo.value), /*#__PURE__*/React__default.createElement("small", null, /*#__PURE__*/React__default.createElement(Highlighter, {
        search: text
      }, option.ortMetaInfo.value), ",", ' ', /*#__PURE__*/React__default.createElement(Highlighter, {
        search: text
      }, option.strasseMetaInfo.value), ",", ' ', option.plzMetaInfo.value));
    }
  }, rest));
};

var VpmsDatenschutzFormCheck = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'mb-4' : _b, rest = __rest$1(_a, ["className"]);
    var datenschutz = useSelector(function (state) { return state.daten.ionKranken.datenschutzVermittlerMetaInfo; });
    var dispatch = useDispatch();
    if (!datenschutz.relevant || trEnv$1.stationaer) {
        return null;
    }
    return (jsx$1(FormCheck, __assign$1({}, datenschutz, { name: "daten.ionKranken.datenschutzVermittlerMetaInfo.value", title: i18next.t('datenschutz.checkboxTitle'), onChange: function (e) { return dispatch(updateByEvent(e)); }, className: "header-label fw-light sp-child-w-100 ".concat(className) }, rest, { children: jsx$1("p", { className: "mt-2", children: jsxs("small", { children: ["Wir nutzen Ihre Daten ausschlie\u00DFlich im Rahmen unserer", ' ', jsx$1("span", { className: "span-fix", dangerouslySetInnerHTML: { __html: i18next.t('datenschutz.link') } }), ' ', "und unseres", ' ', jsx$1("span", { className: "span-fix", dangerouslySetInnerHTML: { __html: i18next.t('datenschutz.kodex') } }), ' ', "- unter anderem zur Angebotserstellung und Durchf\u00FChrung Ihres Vertrages oder - in Einzelf\u00E4llen - f\u00FCr Anfragen bei Ihrem Vorversicherer. Au\u00DFerdem informieren wir Sie gelegentlich zu Produkten der", ' ', jsx$1(Button$1, { variant: "link", onClick: function () { return dispatch(toggleModal(i18next.t('datenschutz.modal'))); }, "data-tracking-name": "datenschutz.modal", children: i18next.t('datenschutz.modalLinkText') }), ' ', "per Post. Dieser Nutzung Ihrer Daten k\u00F6nnen Sie jederzeit per E-Mail an", ' ', jsx$1("span", { className: "span-fix", dangerouslySetInnerHTML: { __html: i18next.t('datenschutz.mail') } }), ' ', "widersprechen."] }) }) })));
};

var Zwischenspeichern = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'mt-5' : _b;
    var dispatch = useDispatch();
    var files = useSelector(function (state) { return state.appDaten.files; });
    var _c = useState(false), showConfirmationDialog = _c[0], setShowConfirmationDialog = _c[1];
    var speichern = function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        dispatch(request(EnumActions.OSPLUS_SPEICHERE, function () {
            window.OSPlusNeo.reportSuccess();
            setShowConfirmationDialog(false);
        }, function () {
            window.OSPlusNeo.reportError();
        }));
    };
    return (jsxs(Fragment, { children: [jsx$1("p", { className: className, children: jsxs(Button$1, { variant: "link", className: "link", onClick: function (e) { return ((files === null || files === void 0 ? void 0 : files.length) > 0 ? setShowConfirmationDialog(true) : speichern(e)); }, children: [jsx$1(SvgSave, {}), ' ', "Zwischenspeichern und dem Kunden die Unterlagen zur Unterschrift mitgeben."] }) }), jsx$1(ConfirmationModal, { text: (jsxs(Fragment, { children: [jsx$1("h4", { children: "M\u00F6chten Sie wirklich Zwischen\u00ADspeichern?" }), jsx$1("p", { children: "Bitte beachten Sie, dass dann alle hochgeladenen Dokumente gel\u00F6scht werden." })] })), labelJa: "Ja, trotzdem speichern", buttonYesVariant: "primary", buttonNoVariant: "secondary", show: showConfirmationDialog, handleYes: function (e) { return speichern(e); }, handleNo: function (e) {
                    e.stopPropagation();
                    setShowConfirmationDialog(false);
                } })] }));
};
var Zwischenspeichern$1 = React__default.memo(Zwischenspeichern);

var UnterschriftHeadline = function () {
    var vsnr = useSelector(function (state) { return state.daten.vsnr; });
    return (jsxs(Headline$1, { children: ["Sind alle Unterschriften f\u00FCr den Antrag zur VSNR", ' ', vsnr.value, ' ', "vorhanden?"] }));
};
var UnterschriftHeadline$1 = React__default.memo(UnterschriftHeadline);

var UnterschriebenAmDatepicker = function () {
    var unterschriebenAm = useSelector(function (state) { return state.daten.unterschriebenAm; });
    var updateValidateDateOnChange = useUpdateAndValidateDateOnChange();
    var validateOnChangeByName = useUpdateByNameAndValidateOnChange();
    if (!unterschriebenAm.relevant) {
        return null;
    }
    return (jsx$1(FormDatePicker, __assign$1({}, unterschriebenAm, { className: "mt-5", onInputChange: updateValidateDateOnChange, onChange: validateOnChangeByName, label: "Der Antrag wurde von dem Kunden am folgenden Tag unterschrieben.", name: "daten.unterschriebenAm.value" })));
};
var UnterschriebenAmDatepicker$1 = React__default.memo(UnterschriebenAmDatepicker);

var UnterschriebenCheckbox = function () {
    var updateAndValidateOnChange = useUpdateAndValidateOnChange();
    var qes = useSelector(function (state) { return state.daten.qes; });
    var qesUnterschreiben = useSelector(function (state) { return state.appDaten.qesUnterschreiben; });
    var unterschrieben = useSelector(function (state) { return state.daten.unterschrieben; });
    var gesperrt = useSelector(function (state) { return state.daten.gesperrt; });
    var gespeichertAm = useSelector(function (state) { return state.daten.gespeichertAm; });
    return (((!!(gesperrt === null || gesperrt === void 0 ? void 0 : gesperrt.value) && !!(gespeichertAm === null || gespeichertAm === void 0 ? void 0 : gespeichertAm.value)) || (!(qes === null || qes === void 0 ? void 0 : qes.relevant) || !(qes === null || qes === void 0 ? void 0 : qes.value) || qesUnterschreiben === false)) && (jsxs(Fragment, { children: [jsx$1(UnterschriftHeadline$1, {}), jsx$1(If$1, { predicate: unterschrieben.relevant, children: jsx$1(FormCheck, __assign$1({}, unterschrieben, { title: "Ja, ich best\u00E4tige, dass mir alle im Antrag geforderten Unterschriften vorliegen und dem \n              Kunden vor dem verbindlichen Abschluss s\u00E4mtliche gesetzlich geforderten Unterlagen zur Verf\u00FCgung standen.", onChange: updateAndValidateOnChange, name: "daten.unterschrieben.value", labelClassName: "sp-w-100", inline: true })) })] })));
};

var lib = {};

var uaParser_min$1 = {exports: {}};

/* UAParser.js v1.0.39
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */
var uaParser_min = uaParser_min$1.exports;

var hasRequiredUaParser_min;

function requireUaParser_min () {
	if (hasRequiredUaParser_min) return uaParser_min$1.exports;
	hasRequiredUaParser_min = 1;
	(function (module, exports) {
		(function(window,undefined$1){var LIBVERSION="1.0.39",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS",SUFFIX_BROWSER=" Browser";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i]);}else {mergedRegexes[i]=regexes[i];}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i];}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined$1},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match);}else {this[q[0]]=q[1];}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined$1;}else {this[q[0]]=match?match.replace(q[1],q[2]):undefined$1;}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined$1;}}else {this[q]=match?match:undefined$1;}}}}i+=2;}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined$1:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined$1:i}}return map.hasOwnProperty("*")?map["*"]:str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" GX"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio)\/([-\w\.]+)/i,/(heytap|ovi)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/quark(?:pc)?\/([-\w\.]+)/i],[VERSION,[NAME,"Quark"]],[/\bddg\/([\w\.]+)/i],[VERSION,[NAME,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360"+SUFFIX_BROWSER]],[/\b(qq)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1Browser"],VERSION],[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1"+SUFFIX_BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser|rekonq)/i,/\[(linkedin)app\]/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/(wolvic)\/([\w\.]+)/i],[NAME,VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i],[NAME,[VERSION,/_/g,"."]],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]((?!sm-[lr])[-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/\b(opd2\d{3}a?) bui/i],[MODEL,[VENDOR,"OPPO"],[TYPE,TABLET]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i],[MODEL,[VENDOR,"TCL"],[TYPE,TABLET]],[/(itel) ((\w+))/i],[[VENDOR,lowerize],MODEL,[TYPE,strMapper,{tablet:["p10001l","w7001"],"*":"mobile"}]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/droid.+; (a(?:015|06[35]|142p?))/i],[MODEL,[VENDOR,"Nothing"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,WEARABLE]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( \d| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined$1;}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined$1;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined$1;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined$1;_browser[VERSION]=undefined$1;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave";}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined$1;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined$1;_device[MODEL]=undefined$1;_device[TYPE]=undefined$1;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE;}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET;}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined$1;_engine[VERSION]=undefined$1;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined$1;_os[VERSION]=undefined$1;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS);}return _os};this.getResult=function(){return {ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);{if(module.exports){exports=module.exports=UAParser;}exports.UAParser=UAParser;}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop];}};}})(typeof window==="object"?window:uaParser_min); 
	} (uaParser_min$1, uaParser_min$1.exports));
	return uaParser_min$1.exports;
}

var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib;
	hasRequiredLib = 1;

	Object.defineProperty(lib, '__esModule', { value: true });

	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

	var React = React__default;
	var React__default$1 = _interopDefault(React);

	var UAParser = requireUaParser_min();

	var ClientUAInstance = new UAParser();
	var browser = ClientUAInstance.getBrowser();
	var cpu = ClientUAInstance.getCPU();
	var device = ClientUAInstance.getDevice();
	var engine = ClientUAInstance.getEngine();
	var os = ClientUAInstance.getOS();
	var ua = ClientUAInstance.getUA();
	var setUa = function setUa(userAgentString) {
	  return ClientUAInstance.setUA(userAgentString);
	};
	var parseUserAgent = function parseUserAgent(userAgent) {
	  if (!userAgent) {
	    console.error('No userAgent string was provided');
	    return;
	  }

	  var UserAgentInstance = new UAParser(userAgent);
	  return {
	    UA: UserAgentInstance,
	    browser: UserAgentInstance.getBrowser(),
	    cpu: UserAgentInstance.getCPU(),
	    device: UserAgentInstance.getDevice(),
	    engine: UserAgentInstance.getEngine(),
	    os: UserAgentInstance.getOS(),
	    ua: UserAgentInstance.getUA(),
	    setUserAgent: function setUserAgent(userAgentString) {
	      return UserAgentInstance.setUA(userAgentString);
	    }
	  };
	};

	var UAHelper = /*#__PURE__*/Object.freeze({
	  ClientUAInstance: ClientUAInstance,
	  browser: browser,
	  cpu: cpu,
	  device: device,
	  engine: engine,
	  os: os,
	  ua: ua,
	  setUa: setUa,
	  parseUserAgent: parseUserAgent
	});

	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);

	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }

	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  return Constructor;
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];

	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }

	    return target;
	  };

	  return _extends.apply(this, arguments);
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}

	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}

	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };

	  return _setPrototypeOf(o, p);
	}

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;

	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }

	  return target;
	}

	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};

	  var target = _objectWithoutPropertiesLoose(source, excluded);

	  var key, i;

	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }

	  return target;
	}

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return self;
	}

	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }

	  return _assertThisInitialized(self);
	}

	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}

	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;

	  var _s, _e;

	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);

	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }

	  return _arr;
	}

	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;

	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

	  return arr2;
	}

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	var DeviceTypes = {
	  Mobile: 'mobile',
	  Tablet: 'tablet',
	  SmartTv: 'smarttv',
	  Console: 'console',
	  Wearable: 'wearable',
	  Embedded: 'embedded',
	  Browser: undefined
	};
	var BrowserTypes = {
	  Chrome: 'Chrome',
	  Firefox: 'Firefox',
	  Opera: 'Opera',
	  Yandex: 'Yandex',
	  Safari: 'Safari',
	  InternetExplorer: 'Internet Explorer',
	  Edge: 'Edge',
	  Chromium: 'Chromium',
	  Ie: 'IE',
	  MobileSafari: 'Mobile Safari',
	  EdgeChromium: 'Edge Chromium',
	  MIUI: 'MIUI Browser',
	  SamsungBrowser: 'Samsung Browser'
	};
	var OsTypes = {
	  IOS: 'iOS',
	  Android: 'Android',
	  WindowsPhone: 'Windows Phone',
	  Windows: 'Windows',
	  MAC_OS: 'Mac OS'
	};
	var InitialDeviceTypes = {
	  isMobile: false,
	  isTablet: false,
	  isBrowser: false,
	  isSmartTV: false,
	  isConsole: false,
	  isWearable: false
	};

	var checkDeviceType = function checkDeviceType(type) {
	  switch (type) {
	    case DeviceTypes.Mobile:
	      return {
	        isMobile: true
	      };

	    case DeviceTypes.Tablet:
	      return {
	        isTablet: true
	      };

	    case DeviceTypes.SmartTv:
	      return {
	        isSmartTV: true
	      };

	    case DeviceTypes.Console:
	      return {
	        isConsole: true
	      };

	    case DeviceTypes.Wearable:
	      return {
	        isWearable: true
	      };

	    case DeviceTypes.Browser:
	      return {
	        isBrowser: true
	      };

	    case DeviceTypes.Embedded:
	      return {
	        isEmbedded: true
	      };

	    default:
	      return InitialDeviceTypes;
	  }
	};
	var setUserAgent = function setUserAgent(userAgent) {
	  return setUa(userAgent);
	};
	var setDefaults = function setDefaults(p) {
	  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
	  return p ? p : d;
	};
	var getNavigatorInstance = function getNavigatorInstance() {
	  if (typeof window !== 'undefined') {
	    if (window.navigator || navigator) {
	      return window.navigator || navigator;
	    }
	  }

	  return false;
	};
	var isIOS13Check = function isIOS13Check(type) {
	  var nav = getNavigatorInstance();
	  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
	};

	var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
	  return {
	    isBrowser: isBrowser,
	    browserMajorVersion: setDefaults(browser.major),
	    browserFullVersion: setDefaults(browser.version),
	    browserName: setDefaults(browser.name),
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var mobilePayload = function mobilePayload(type, device, os, ua) {
	  return _objectSpread2({}, type, {
	    vendor: setDefaults(device.vendor),
	    model: setDefaults(device.model),
	    os: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    ua: setDefaults(ua)
	  });
	};
	var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
	  return {
	    isSmartTV: isSmartTV,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var consolePayload = function consolePayload(isConsole, engine, os, ua) {
	  return {
	    isConsole: isConsole,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
	  return {
	    isWearable: isWearable,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
	  return {
	    isEmbedded: isEmbedded,
	    vendor: setDefaults(device.vendor),
	    model: setDefaults(device.model),
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};

	function deviceDetect(userAgent) {
	  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
	      device = _ref.device,
	      browser = _ref.browser,
	      engine = _ref.engine,
	      os = _ref.os,
	      ua = _ref.ua;

	  var type = checkDeviceType(device.type);
	  var isBrowser = type.isBrowser,
	      isMobile = type.isMobile,
	      isTablet = type.isTablet,
	      isSmartTV = type.isSmartTV,
	      isConsole = type.isConsole,
	      isWearable = type.isWearable,
	      isEmbedded = type.isEmbedded;

	  if (isBrowser) {
	    return browserPayload(isBrowser, browser, engine, os, ua);
	  }

	  if (isSmartTV) {
	    return smartTvPayload(isSmartTV, engine, os, ua);
	  }

	  if (isConsole) {
	    return consolePayload(isConsole, engine, os, ua);
	  }

	  if (isMobile) {
	    return mobilePayload(type, device, os, ua);
	  }

	  if (isTablet) {
	    return mobilePayload(type, device, os, ua);
	  }

	  if (isWearable) {
	    return wearablePayload(isWearable, engine, os, ua);
	  }

	  if (isEmbedded) {
	    return embeddedPayload(isEmbedded, device, engine, os, ua);
	  }
	}

	var isMobileType = function isMobileType(_ref) {
	  var type = _ref.type;
	  return type === DeviceTypes.Mobile;
	};
	var isTabletType = function isTabletType(_ref2) {
	  var type = _ref2.type;
	  return type === DeviceTypes.Tablet;
	};
	var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
	  var type = _ref3.type;
	  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
	};
	var isSmartTVType = function isSmartTVType(_ref4) {
	  var type = _ref4.type;
	  return type === DeviceTypes.SmartTv;
	};
	var isBrowserType = function isBrowserType(_ref5) {
	  var type = _ref5.type;
	  return type === DeviceTypes.Browser;
	};
	var isWearableType = function isWearableType(_ref6) {
	  var type = _ref6.type;
	  return type === DeviceTypes.Wearable;
	};
	var isConsoleType = function isConsoleType(_ref7) {
	  var type = _ref7.type;
	  return type === DeviceTypes.Console;
	};
	var isEmbeddedType = function isEmbeddedType(_ref8) {
	  var type = _ref8.type;
	  return type === DeviceTypes.Embedded;
	};
	var getMobileVendor = function getMobileVendor(_ref9) {
	  var vendor = _ref9.vendor;
	  return setDefaults(vendor);
	};
	var getMobileModel = function getMobileModel(_ref10) {
	  var model = _ref10.model;
	  return setDefaults(model);
	};
	var getDeviceType = function getDeviceType(_ref11) {
	  var type = _ref11.type;
	  return setDefaults(type, 'browser');
	}; // os types

	var isAndroidType = function isAndroidType(_ref12) {
	  var name = _ref12.name;
	  return name === OsTypes.Android;
	};
	var isWindowsType = function isWindowsType(_ref13) {
	  var name = _ref13.name;
	  return name === OsTypes.Windows;
	};
	var isMacOsType = function isMacOsType(_ref14) {
	  var name = _ref14.name;
	  return name === OsTypes.MAC_OS;
	};
	var isWinPhoneType = function isWinPhoneType(_ref15) {
	  var name = _ref15.name;
	  return name === OsTypes.WindowsPhone;
	};
	var isIOSType = function isIOSType(_ref16) {
	  var name = _ref16.name;
	  return name === OsTypes.IOS;
	};
	var getOsVersion = function getOsVersion(_ref17) {
	  var version = _ref17.version;
	  return setDefaults(version);
	};
	var getOsName = function getOsName(_ref18) {
	  var name = _ref18.name;
	  return setDefaults(name);
	}; // browser types

	var isChromeType = function isChromeType(_ref19) {
	  var name = _ref19.name;
	  return name === BrowserTypes.Chrome;
	};
	var isFirefoxType = function isFirefoxType(_ref20) {
	  var name = _ref20.name;
	  return name === BrowserTypes.Firefox;
	};
	var isChromiumType = function isChromiumType(_ref21) {
	  var name = _ref21.name;
	  return name === BrowserTypes.Chromium;
	};
	var isEdgeType = function isEdgeType(_ref22) {
	  var name = _ref22.name;
	  return name === BrowserTypes.Edge;
	};
	var isYandexType = function isYandexType(_ref23) {
	  var name = _ref23.name;
	  return name === BrowserTypes.Yandex;
	};
	var isSafariType = function isSafariType(_ref24) {
	  var name = _ref24.name;
	  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
	};
	var isMobileSafariType = function isMobileSafariType(_ref25) {
	  var name = _ref25.name;
	  return name === BrowserTypes.MobileSafari;
	};
	var isOperaType = function isOperaType(_ref26) {
	  var name = _ref26.name;
	  return name === BrowserTypes.Opera;
	};
	var isIEType = function isIEType(_ref27) {
	  var name = _ref27.name;
	  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
	};
	var isMIUIType = function isMIUIType(_ref28) {
	  var name = _ref28.name;
	  return name === BrowserTypes.MIUI;
	};
	var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
	  var name = _ref29.name;
	  return name === BrowserTypes.SamsungBrowser;
	};
	var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
	  var version = _ref30.version;
	  return setDefaults(version);
	};
	var getBrowserVersion = function getBrowserVersion(_ref31) {
	  var major = _ref31.major;
	  return setDefaults(major);
	};
	var getBrowserName = function getBrowserName(_ref32) {
	  var name = _ref32.name;
	  return setDefaults(name);
	}; // engine types

	var getEngineName = function getEngineName(_ref33) {
	  var name = _ref33.name;
	  return setDefaults(name);
	};
	var getEngineVersion = function getEngineVersion(_ref34) {
	  var version = _ref34.version;
	  return setDefaults(version);
	};
	var isElectronType = function isElectronType() {
	  var nav = getNavigatorInstance();
	  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
	  return typeof ua === 'string' ? /electron/.test(ua) : false;
	};
	var isEdgeChromiumType = function isEdgeChromiumType(ua) {
	  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
	};
	var getIOS13 = function getIOS13() {
	  var nav = getNavigatorInstance();
	  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
	};
	var getIPad13 = function getIPad13() {
	  return isIOS13Check('iPad');
	};
	var getIphone13 = function getIphone13() {
	  return isIOS13Check('iPhone');
	};
	var getIPod13 = function getIPod13() {
	  return isIOS13Check('iPod');
	};
	var getUseragent = function getUseragent(userAg) {
	  return setDefaults(userAg);
	};

	function buildSelectorsObject(options) {
	  var _ref = options ? options : UAHelper,
	      device = _ref.device,
	      browser = _ref.browser,
	      os = _ref.os,
	      engine = _ref.engine,
	      ua = _ref.ua;

	  return {
	    isSmartTV: isSmartTVType(device),
	    isConsole: isConsoleType(device),
	    isWearable: isWearableType(device),
	    isEmbedded: isEmbeddedType(device),
	    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
	    isChromium: isChromiumType(browser),
	    isMobile: isMobileAndTabletType(device) || getIPad13(),
	    isMobileOnly: isMobileType(device),
	    isTablet: isTabletType(device) || getIPad13(),
	    isBrowser: isBrowserType(device),
	    isDesktop: isBrowserType(device),
	    isAndroid: isAndroidType(os),
	    isWinPhone: isWinPhoneType(os),
	    isIOS: isIOSType(os) || getIPad13(),
	    isChrome: isChromeType(browser),
	    isFirefox: isFirefoxType(browser),
	    isSafari: isSafariType(browser),
	    isOpera: isOperaType(browser),
	    isIE: isIEType(browser),
	    osVersion: getOsVersion(os),
	    osName: getOsName(os),
	    fullBrowserVersion: getBrowserFullVersion(browser),
	    browserVersion: getBrowserVersion(browser),
	    browserName: getBrowserName(browser),
	    mobileVendor: getMobileVendor(device),
	    mobileModel: getMobileModel(device),
	    engineName: getEngineName(engine),
	    engineVersion: getEngineVersion(engine),
	    getUA: getUseragent(ua),
	    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
	    isYandex: isYandexType(browser),
	    deviceType: getDeviceType(device),
	    isIOS13: getIOS13(),
	    isIPad13: getIPad13(),
	    isIPhone13: getIphone13(),
	    isIPod13: getIPod13(),
	    isElectron: isElectronType(),
	    isEdgeChromium: isEdgeChromiumType(ua),
	    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
	    isWindows: isWindowsType(os),
	    isMacOs: isMacOsType(os),
	    isMIUI: isMIUIType(browser),
	    isSamsungBrowser: isSamsungBrowserType(browser)
	  };
	}

	var isSmartTV = isSmartTVType(device);
	var isConsole = isConsoleType(device);
	var isWearable = isWearableType(device);
	var isEmbedded = isEmbeddedType(device);
	var isMobileSafari = isMobileSafariType(browser) || getIPad13();
	var isChromium = isChromiumType(browser);
	var isMobile = isMobileAndTabletType(device) || getIPad13();
	var isMobileOnly = isMobileType(device);
	var isTablet = isTabletType(device) || getIPad13();
	var isBrowser = isBrowserType(device);
	var isDesktop = isBrowserType(device);
	var isAndroid = isAndroidType(os);
	var isWinPhone = isWinPhoneType(os);
	var isIOS = isIOSType(os) || getIPad13();
	var isChrome = isChromeType(browser);
	var isFirefox = isFirefoxType(browser);
	var isSafari = isSafariType(browser);
	var isOpera = isOperaType(browser);
	var isIE = isIEType(browser);
	var osVersion = getOsVersion(os);
	var osName = getOsName(os);
	var fullBrowserVersion = getBrowserFullVersion(browser);
	var browserVersion = getBrowserVersion(browser);
	var browserName = getBrowserName(browser);
	var mobileVendor = getMobileVendor(device);
	var mobileModel = getMobileModel(device);
	var engineName = getEngineName(engine);
	var engineVersion = getEngineVersion(engine);
	var getUA = getUseragent(ua);
	var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
	var isYandex = isYandexType(browser);
	var deviceType = getDeviceType(device);
	var isIOS13 = getIOS13();
	var isIPad13 = getIPad13();
	var isIPhone13 = getIphone13();
	var isIPod13 = getIPod13();
	var isElectron = isElectronType();
	var isEdgeChromium = isEdgeChromiumType(ua);
	var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
	var isWindows = isWindowsType(os);
	var isMacOs = isMacOsType(os);
	var isMIUI = isMIUIType(browser);
	var isSamsungBrowser = isSamsungBrowserType(browser);
	var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
	  if (!userAgent || typeof userAgent !== 'string') {
	    console.error('No valid user agent string was provided');
	    return;
	  }

	  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
	      device = _UAHelper$parseUserAg.device,
	      browser = _UAHelper$parseUserAg.browser,
	      os = _UAHelper$parseUserAg.os,
	      engine = _UAHelper$parseUserAg.engine,
	      ua = _UAHelper$parseUserAg.ua;

	  return buildSelectorsObject({
	    device: device,
	    browser: browser,
	    os: os,
	    engine: engine,
	    ua: ua
	  });
	};

	var AndroidView = function AndroidView(_ref) {
	  var renderWithFragment = _ref.renderWithFragment,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

	  return isAndroid ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var BrowserView = function BrowserView(_ref2) {
	  var renderWithFragment = _ref2.renderWithFragment,
	      children = _ref2.children,
	      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

	  return isBrowser ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var IEView = function IEView(_ref3) {
	  var renderWithFragment = _ref3.renderWithFragment,
	      children = _ref3.children,
	      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

	  return isIE ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var IOSView = function IOSView(_ref4) {
	  var renderWithFragment = _ref4.renderWithFragment,
	      children = _ref4.children,
	      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

	  return isIOS ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var MobileView = function MobileView(_ref5) {
	  var renderWithFragment = _ref5.renderWithFragment,
	      children = _ref5.children,
	      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

	  return isMobile ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var TabletView = function TabletView(_ref6) {
	  var renderWithFragment = _ref6.renderWithFragment,
	      children = _ref6.children,
	      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

	  return isTablet ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var WinPhoneView = function WinPhoneView(_ref7) {
	  var renderWithFragment = _ref7.renderWithFragment,
	      children = _ref7.children,
	      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

	  return isWinPhone ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var MobileOnlyView = function MobileOnlyView(_ref8) {
	  var renderWithFragment = _ref8.renderWithFragment,
	      children = _ref8.children;
	      _ref8.viewClassName;
	      _ref8.style;
	      var props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

	  return isMobileOnly ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var SmartTVView = function SmartTVView(_ref9) {
	  var renderWithFragment = _ref9.renderWithFragment,
	      children = _ref9.children,
	      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

	  return isSmartTV ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var ConsoleView = function ConsoleView(_ref10) {
	  var renderWithFragment = _ref10.renderWithFragment,
	      children = _ref10.children,
	      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

	  return isConsole ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var WearableView = function WearableView(_ref11) {
	  var renderWithFragment = _ref11.renderWithFragment,
	      children = _ref11.children,
	      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

	  return isWearable ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};
	var CustomView = function CustomView(_ref12) {
	  var renderWithFragment = _ref12.renderWithFragment,
	      children = _ref12.children;
	      _ref12.viewClassName;
	      _ref12.style;
	      var condition = _ref12.condition,
	      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

	  return condition ? renderWithFragment ? React__default$1.createElement(React.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
	};

	function withOrientationChange(WrappedComponent) {
	  return /*#__PURE__*/function (_React$Component) {
	    _inherits(_class, _React$Component);

	    function _class(props) {
	      var _this;

	      _classCallCheck(this, _class);

	      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
	      _this.isEventListenerAdded = false;
	      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
	      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
	      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
	      _this.state = {
	        isLandscape: false,
	        isPortrait: false
	      };
	      return _this;
	    }

	    _createClass(_class, [{
	      key: "handleOrientationChange",
	      value: function handleOrientationChange() {
	        if (!this.isEventListenerAdded) {
	          this.isEventListenerAdded = true;
	        }

	        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
	        this.setState({
	          isPortrait: orientation === 0,
	          isLandscape: orientation === 90
	        });
	      }
	    }, {
	      key: "onOrientationChange",
	      value: function onOrientationChange() {
	        this.handleOrientationChange();
	      }
	    }, {
	      key: "onPageLoad",
	      value: function onPageLoad() {
	        this.handleOrientationChange();
	      }
	    }, {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
	          if (!this.isEventListenerAdded) {
	            this.handleOrientationChange();
	            window.addEventListener("load", this.onPageLoad, false);
	          } else {
	            window.removeEventListener("load", this.onPageLoad, false);
	          }

	          window.addEventListener("resize", this.onOrientationChange, false);
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        window.removeEventListener("resize", this.onOrientationChange, false);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return React__default$1.createElement(WrappedComponent, _extends({}, this.props, {
	          isLandscape: this.state.isLandscape,
	          isPortrait: this.state.isPortrait
	        }));
	      }
	    }]);

	    return _class;
	  }(React__default$1.Component);
	}

	function useMobileOrientation() {
	  var _useState = React.useState(function () {
	    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
	    return {
	      isPortrait: orientation === 0,
	      isLandscape: orientation === 90,
	      orientation: orientation === 0 ? 'portrait' : 'landscape'
	    };
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      state = _useState2[0],
	      setState = _useState2[1];

	  var handleOrientationChange = React.useCallback(function () {
	    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
	    var next = {
	      isPortrait: orientation === 0,
	      isLandscape: orientation === 90,
	      orientation: orientation === 0 ? 'portrait' : 'landscape'
	    };
	    state.orientation !== next.orientation && setState(next);
	  }, [state.orientation]);
	  React.useEffect(function () {
	    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
	      handleOrientationChange();
	      window.addEventListener("load", handleOrientationChange, false);
	      window.addEventListener("resize", handleOrientationChange, false);
	    }

	    return function () {
	      window.removeEventListener("resize", handleOrientationChange, false);
	      window.removeEventListener("load", handleOrientationChange, false);
	    };
	  }, [handleOrientationChange]);
	  return state;
	}

	function useDeviceData(userAgent) {
	  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
	  return parseUserAgent(hookUserAgent);
	}

	function useDeviceSelectors(userAgent) {
	  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
	  var deviceData = useDeviceData(hookUserAgent);
	  var selectors = buildSelectorsObject(deviceData);
	  return [selectors, deviceData];
	}

	lib.AndroidView = AndroidView;
	lib.BrowserTypes = BrowserTypes;
	lib.BrowserView = BrowserView;
	lib.ConsoleView = ConsoleView;
	lib.CustomView = CustomView;
	lib.IEView = IEView;
	lib.IOSView = IOSView;
	lib.MobileOnlyView = MobileOnlyView;
	lib.MobileView = MobileView;
	lib.OsTypes = OsTypes;
	lib.SmartTVView = SmartTVView;
	lib.TabletView = TabletView;
	lib.WearableView = WearableView;
	lib.WinPhoneView = WinPhoneView;
	lib.browserName = browserName;
	lib.browserVersion = browserVersion;
	lib.deviceDetect = deviceDetect;
	lib.deviceType = deviceType;
	lib.engineName = engineName;
	lib.engineVersion = engineVersion;
	lib.fullBrowserVersion = fullBrowserVersion;
	lib.getSelectorsByUserAgent = getSelectorsByUserAgent;
	lib.getUA = getUA;
	lib.isAndroid = isAndroid;
	lib.isBrowser = isBrowser;
	lib.isChrome = isChrome;
	lib.isChromium = isChromium;
	lib.isConsole = isConsole;
	lib.isDesktop = isDesktop;
	lib.isEdge = isEdge;
	lib.isEdgeChromium = isEdgeChromium;
	lib.isElectron = isElectron;
	lib.isEmbedded = isEmbedded;
	lib.isFirefox = isFirefox;
	lib.isIE = isIE;
	lib.isIOS = isIOS;
	lib.isIOS13 = isIOS13;
	lib.isIPad13 = isIPad13;
	lib.isIPhone13 = isIPhone13;
	lib.isIPod13 = isIPod13;
	lib.isLegacyEdge = isLegacyEdge;
	lib.isMIUI = isMIUI;
	lib.isMacOs = isMacOs;
	lib.isMobile = isMobile;
	lib.isMobileOnly = isMobileOnly;
	lib.isMobileSafari = isMobileSafari;
	lib.isOpera = isOpera;
	lib.isSafari = isSafari;
	lib.isSamsungBrowser = isSamsungBrowser;
	lib.isSmartTV = isSmartTV;
	lib.isTablet = isTablet;
	lib.isWearable = isWearable;
	lib.isWinPhone = isWinPhone;
	lib.isWindows = isWindows;
	lib.isYandex = isYandex;
	lib.mobileModel = mobileModel;
	lib.mobileVendor = mobileVendor;
	lib.osName = osName;
	lib.osVersion = osVersion;
	lib.parseUserAgent = parseUserAgent;
	lib.setUserAgent = setUserAgent;
	lib.useDeviceData = useDeviceData;
	lib.useDeviceSelectors = useDeviceSelectors;
	lib.useMobileOrientation = useMobileOrientation;
	lib.withOrientationChange = withOrientationChange;
	return lib;
}

var libExports = requireLib();

var ModalWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 40%;\n  float: right;\n  .berater--modal--btn {\n    width: 3.5em;\n    height: 3.5em;\n    top: 100px;\n    left: 50%;\n    transform: translate(-50%);\n    ", ";\n\n    &.mobile {\n      width: 2.75em;\n      height: 2.75em;\n      position: fixed;\n      bottom: 1rem;\n      top: auto;\n      left: 50%;\n      transform: translate(-50%);\n      right: auto;\n    }\n\n    padding: 10px;\n    border-radius: 60px;\n    box-shadow: rgba(0, 0, 0, 0.15) 0px 0.5rem 1rem;\n    opacity: 0.7;\n    z-index: 1;\n    &:hover {\n      opacity: 1;\n    }\n  }\n"], ["\n  width: 40%;\n  float: right;\n  .berater--modal--btn {\n    width: 3.5em;\n    height: 3.5em;\n    top: 100px;\n    left: 50%;\n    transform: translate(-50%);\n    ", ";\n\n    &.mobile {\n      width: 2.75em;\n      height: 2.75em;\n      position: fixed;\n      bottom: 1rem;\n      top: auto;\n      left: 50%;\n      transform: translate(-50%);\n      right: auto;\n    }\n\n    padding: 10px;\n    border-radius: 60px;\n    box-shadow: rgba(0, 0, 0, 0.15) 0px 0.5rem 1rem;\n    opacity: 0.7;\n    z-index: 1;\n    &:hover {\n      opacity: 1;\n    }\n  }\n"])), function (_a) {
    var $outOfBound = _a.$outOfBound;
    return ($outOfBound ? css$3(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n      left: auto;\n      transform: none;\n      top: 20em;\n      right: 10rem;\n      position: fixed;\n    "], ["\n      left: auto;\n      transform: none;\n      top: 20em;\n      right: 10rem;\n      position: fixed;\n    "]))) : '');
});
var BeraterIconButton = styled(SvgBerater)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  && {\n    width: 100%;\n    height: 100%;\n    .qmark {\n      fill: var(--primary);\n    }\n  }\n"], ["\n  && {\n    width: 100%;\n    height: 100%;\n    .qmark {\n      fill: var(--primary);\n    }\n  }\n"])));
var BeraterModal = function (_a) {
    var container = _a.container, _b = _a.outOfBound, outOfBound = _b === void 0 ? false : _b, _c = _a.visible, visible = _c === void 0 ? true : _c, _d = _a.mobile, mobile = _d === void 0 ? false : _d, overlay = _a.overlay;
    var ref = useRef(null);
    var dispatch = useDispatch();
    var timeout = 0;
    var _e = useState(false), overlayshow = _e[0], setOverlayshow = _e[1];
    var show = useSelector(function (state) { return state.appDaten.showBeraterModal; });
    useEffect(function () { return function () {
        window.clearTimeout(timeout);
    }; }, []);
    timeout = window.setTimeout(function () { return setOverlayshow(true); }, 100);
    var istMobile = mobile || libExports.isMobile;
    var handleShow = function () {
        dispatch(updateByName('appDaten.showBeraterModal', true));
    };
    return ((!trEnv$1.sparkasse && visible) && (jsx$1(ModalWrapper, { "$outOfBound": outOfBound, children: jsxs(Sticky, { disabled: istMobile || outOfBound, children: [(!istMobile && overlay) && (jsx$1(Overlay$1, { container: ref, target: ref.current, show: overlayshow, placement: "bottom", children: function (overlayProps) {
                        var newProps = __assign$1(__assign$1({}, overlayProps), { style: __assign$1(__assign$1({}, overlayProps.style), { width: '130px', minWidth: '130px' }) });
                        return (jsx$1(Tooltip$1, __assign$1({}, newProps, { children: overlay })));
                    } })), jsx$1(Button$1, { ref: ref, onClick: handleShow, className: "berater--modal--btn ".concat(istMobile ? 'mobile' : ''), "aria-label": "Baraten lassen", children: jsx$1(BeraterIconButton, { className: "blue" }) }), jsx$1(BeraterModalWindow, { show: show, setShow: function (v) { return dispatch(updateByName('appDaten.showBeraterModal', v)); }, container: container })] }) })));
};
var templateObject_1$1, templateObject_2, templateObject_3;

var PrevNextButton = function (_a) {
    var onNextClick = _a.onNextClick, _b = _a.nextProps, nextProps = _b === void 0 ? {
        block: false,
        text: 'Weiter',
        className: '',
        disabled: false,
    } : _b, onPrevClick = _a.onPrevClick, _c = _a.prevProps, prevProps = _c === void 0 ? {
        block: false,
        text: 'Zurück',
        disabled: false,
    } : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var _e = useState(false), nextDisabled = _e[0], setNextDisabled = _e[1];
    var timeout = 0;
    var pages = useSelector(function (state) { return state.appDaten.pages; });
    var progress = usePageIndex();
    var prevPage = usePrevPage();
    var nextPage = useNextPage();
    /**
     * useEffect cleanup, der den Timeout löscht, wenn Component umounted
     */
    useEffect(function () { return function () {
        window.clearTimeout(timeout);
    }; }, []);
    return (jsxs("div", { className: "mt-3 bg-transparent prevnext-buttons ".concat(className), children: [pages[progress].buttons.prev
                && (jsx$1(Button$1, { variant: "secondary", className: "btn-prev ".concat(prevProps.disabled ? 'disabled' : '', " ").concat(prevProps.block ? 'w-100' : ''), "data-tracking-name": "prevpage-".concat(pages[progress].name), onClick: onPrevClick || (function () { return prevPage(); }), id: "prev-".concat(pages[progress].name), size: prevProps.size, disabled: prevProps.disabled, children: prevProps.text })), pages[progress].buttons.next
                && (jsxs(Button$1, { className: "btn--animate ".concat(nextProps.disabled ? 'disabled' : '', " ").concat(nextProps.block ? 'w-100' : '', " ").concat(nextProps.className), "data-tracking-name": "nextpage-".concat(pages[progress].name), onClick: onNextClick
                        ? (function (e) {
                            setNextDisabled(true);
                            onNextClick(e);
                            timeout = window.setTimeout(function () { return setNextDisabled(false); }, 1000);
                        }) : (function () { return nextPage(); }), id: "next-".concat(pages[progress].name), size: nextProps.size, disabled: nextProps.disabled || nextDisabled, children: [nextProps.text, ' ', jsx$1(SvgArrow, {})] }))] }));
};
var PrevNextButtons = React__default.memo(PrevNextButton);

var ProgressbarNavigation = function (_a) {
    var _b;
    var _c = _a.warpzone, warpzone = _c === void 0 ? false : _c, _d = _a.trackByEvent, trackByEvent = _d === void 0 ? function () { } : _d, _e = _a.disableClickOnPage, disableClickOnPage = _e === void 0 ? [] : _e;
    var gotoPage = useGotoPage();
    var ref = useRef(null);
    var obj = useBreadcrumb();
    var items = warpzone ? obj.allActive : obj.routes;
    var handleClick = function (e, route) {
        e.preventDefault();
        trackByEvent(e);
        gotoPage(route.name);
    };
    if (((_b = obj.active) === null || _b === void 0 ? void 0 : _b.name) === 'Abschluss') {
        return null;
    }
    return (jsx$1(Breadcrumb, { label: "Fortschritt-Navigation", className: "progressbar-navigation", listProps: {
            className: 'progressbar-navigation-list',
        }, ref: ref, children: items.map(function (route, index) { return (jsx$1(OverlayTrigger, { placement: "top", container: ref.current, overlay: (jsx$1(Tooltip$1, { id: route.name, children: warpzone ? route.path : route.title })), children: jsx$1(Breadcrumb.Item, { className: "progressbar-navigation-item ".concat(!warpzone && obj.index >= index ? 'done' : 'todo'), linkAs: Button$1, linkProps: {
                    onClick: function (e) {
                        var _a, _b;
                        if (warpzone) {
                            handleClick(e, route);
                            return;
                        }
                        if (disableClickOnPage.includes((_a = obj.active) === null || _a === void 0 ? void 0 : _a.name)) {
                            return;
                        }
                        if (((_b = obj.active) === null || _b === void 0 ? void 0 : _b.name) === 'Unterschrift') {
                            return;
                        }
                        if (obj.index >= index) {
                            handleClick(e, route);
                        }
                    },
                    'data-tracking-name': "navigation.".concat(route.name),
                    disabled: !warpzone && obj.index < index,
                }, children: jsxs("span", { className: "visually-hidden", children: [obj.index > index && 'Fertig: ', obj.index === index && 'Wird ausgefüllt: ', route.title] }) }) }, route.name)); }) }));
};

var HeadNavigation = function (_a) {
    var _b, _c;
    var _d = _a.warpzone, warpzone = _d === void 0 ? false : _d, _e = _a.bedingungsvergleich, bedingungsvergleich = _e === void 0 ? true : _e;
    var vn = useSelector(function (state) { return state.daten.vn; });
    var obj = useBreadcrumb();
    return (jsxs(Row, { className: "pb-0", children: [jsxs(Col, { children: [jsx$1(If$1, { predicate: trEnv$1.sparkasse, children: jsx$1("h1", { className: "main-heading", children: ((_b = obj.active) === null || _b === void 0 ? void 0 : _b.title) || i18next.t("".concat((_c = obj.active) === null || _c === void 0 ? void 0 : _c.path.replace('/', ''), ".pageTitle")) }) }), jsx$1(If$1, { predicate: !trEnv$1.sparkasse, children: jsx$1("h1", { className: "main-heading", children: i18next.t('sparkasse.produkt') }) }), jsx$1(ProgressbarNavigation, { warpzone: warpzone })] }), jsx$1(If$1, { predicate: trEnv$1.sparkasse, children: jsx$1(Col, { children: jsxs("div", { className: "pt-3 text-end", children: [jsx$1(If$1, { predicate: vn.vorname.value && vn.nachname.value && trEnv$1.sparkasse, children: jsxs("div", { className: "mb-2", children: [vn.vorname.value, ' ', vn.nachname.value, ",", ' ', i18next.t('sparkasse.produkt')] }) }), jsx$1(SpkButtons, { bedingungsvergleich: bedingungsvergleich })] }) }) })] }));
};

var PdfActionButtons = function (_a) {
    var children = _a.children, _b = _a.showFonds, showFonds = _b === void 0 ? true : _b, childOne = _a.childOne, childTwo = _a.childTwo;
    var dispatch = useDispatch();
    var handleFondshilfe = function () {
        dispatch(pdfRequest('holeFondshilfe', 'Fondsinformationen'));
    };
    var handleBeispielrechnung = function () {
        dispatch(pdfRequest('holeBeispielrechnung', 'Angebotsdruck'));
    };
    var handleProduktinfo = function () {
        dispatch(pdfRequest('holeProduktinformation', 'Produktinformation'));
    };
    return (jsx$1("div", { className: "w-md mt-4", children: jsxs("div", { className: "d-md-flex gap-4 rente-btn", children: [jsx$1(IconButton$1, { className: "d-flex flex-md-column gap-3 flex-even position-relative", icon: jsx$1(SvgPdf, { className: "mx-md-auto wh-50 text-primary" }), label: "Produktinformation", onClick: handleProduktinfo, bgWhite: true }), childOne, jsx$1(IconButton$1, { className: "d-flex flex-md-column gap-3 flex-even", icon: jsx$1(SvgAngebot, { className: "mx-md-auto wh-50 text-primary" }), label: "Angebotsdruck", onClick: handleBeispielrechnung, bgWhite: true }), childTwo, jsx$1(If$1, { predicate: showFonds, children: jsx$1(IconButton$1, { className: "d-flex flex-md-column gap-3 flex-even", icon: jsx$1(SvgFondsinformation, { className: "mx-md-auto wh-50 text-primary" }), label: "Fondsinformationen", onClick: handleFondshilfe, bgWhite: true }) }), children] }) }));
};

var Vorgangsanlage = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (jsx$1("div", { className: "vorgangsanlage ".concat(className), children: children }));
};

var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background: #fff;\n  padding: .5rem;\n  border-radius: var(--bs-border-radius);\n  text-align: center;\n  ", "\n  &.empfehlung {\n    border-color: #ff0000;\n    box-shadow: 0 0 5px #ff0000;\n  }\n  svg {\n    width: 5rem;\n    height: 5rem;\n    color: var(--primary) !important;\n  }\n  p {\n    color: #666;\n  }\n  &:hover {\n    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.5);\n    background: var(--primary);\n    h4, p, p * {\n      color: #fff;\n    }\n    svg {\n      color: #fff !important;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background: #fff;\n  padding: .5rem;\n  border-radius: var(--bs-border-radius);\n  text-align: center;\n  ", "\n  &.empfehlung {\n    border-color: #ff0000;\n    box-shadow: 0 0 5px #ff0000;\n  }\n  svg {\n    width: 5rem;\n    height: 5rem;\n    color: var(--primary) !important;\n  }\n  p {\n    color: #666;\n  }\n  &:hover {\n    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.5);\n    background: var(--primary);\n    h4, p, p * {\n      color: #fff;\n    }\n    svg {\n      color: #fff !important;\n    }\n  }\n"])), function (_a) {
    var selected = _a.selected;
    return selected && "\n    border: 2px solid var(--primary);\n    box-shadow: 0 0 3px var(--primary);\n  ";
});
var VorgangsanlageButtonContent = function (_a) {
    var label = _a.label, _b = _a.subtitle, subtitle = _b === void 0 ? '' : _b, icon = _a.icon, _c = _a.selected, selected = _c === void 0 ? false : _c;
    return (jsxs(StyledDiv, { selected: selected, children: [icon, jsxs("div", { className: "pt-2 px-2", children: [jsx$1("h4", { className: "mb-2", children: label }), jsx$1("p", { className: "mb-0", dangerouslySetInnerHTML: { __html: subtitle } })] })] }));
};
var templateObject_1;

var VorgangsanlageButton = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, onClick = _a.onClick, dataValue = _a.dataValue, rest = __rest$1(_a, ["children", "className", "onClick", "dataValue"]);
    return (jsxs(Button$1, { className: "vorgangsanlage-button ".concat(className), onClick: onClick, "data-value": dataValue, variant: "link", children: [jsx$1(VorgangsanlageButtonContent, __assign$1({}, rest)), children] }));
};

var VorgangsanlageButtonDownload = function (_a) {
    var link = _a.link, _b = _a.label, label = _b === void 0 ? 'Produktübersicht' : _b;
    return (jsxs("div", { className: "produktinformation position-relative mt-3", children: [jsx$1(SvgPdf, {}), jsx$1("a", { className: "btn btn-primary d-block stretched-link mt-2", target: "_blank", href: link, rel: "noreferrer", onClick: function (e) { return e.stopPropagation(); }, children: label })] }));
};

var Schweigepflichtentbindungserklaerung = function (_a) {
    var alert = _a.alert;
    var versicherungsart = useSelector(function (state) { return state.daten.versicherungsart || {}; });
    var dispatch = useDispatch();
    return (jsxs(Fragment, { children: [jsxs(Headline$1, { children: ["Einwilligung in die Erhebung und Verwendung von Gesund\u00ADheits\u00ADdaten und Schweigepflicht\u00ADent\u00ADbindungs\u00ADerkl\u00E4rung", jsx$1(Tooltip, { handleTooltip: function () { return dispatch(toggleModal(i18next.t('schweigepflicht.einwilligung_tt'))); }, id: "tooltip-einwilligung-schweigepflicht" })] }), i18next.exists('schweigepflicht.einleitung') && jsx$1("p", { children: i18next.t('schweigepflicht.einleitung') }), jsx$1(Message$1, { show: istEnumAuswahl(versicherungsart, EnumVersicherungsart.PARTNER) || (alert !== undefined && alert !== ''), dismissible: false, text: istEnumAuswahl(versicherungsart, EnumVersicherungsart.PARTNER)
                    ? 'Die folgenden Entscheidungen gelten für <strong>beide</strong> versicherten Personen.'
                    : alert, arrow: "top", className: "mb-4 mt-n2" })] }));
};

var ErklaerungTodesfall = function (_a) {
    var onChange = _a.onChange;
    var erklaerungTodesfall = useSelector(function (state) { return state.daten.erklaerungTodesfall || {}; });
    if (!erklaerungTodesfall.relevant) {
        return null;
    }
    return erklaerungTodesfall.relevant && (jsx$1(FormWrapper$1, { title: "Sie stimmen der Abfrage von Gesundheitsdaten bei Dritten auch im Todesfall zu", name: "daten.erklaerungTodesfall.label", className: "mb-5", children: jsx$1(FormCheck, __assign$1({}, erklaerungTodesfall, { title: "Jetzt zustimmen", name: "daten.erklaerungTodesfall.value", onChange: onChange })) }));
};

var EinwilligungAbfrageGesundheitsdaten = function (_a) {
    var onChange = _a.onChange;
    var dispatch = useDispatch();
    var einwilligungAbfrageGesundheitsdaten = useSelector(function (state) { return state.daten.einwilligungAbfrageGesundheitsdaten; });
    if (!einwilligungAbfrageGesundheitsdaten.relevant) {
        return null;
    }
    return (jsx$1(FormSelect, __assign$1({}, einwilligungAbfrageGesundheitsdaten, { title: "Entscheiden Sie sich f\u00FCr eine Pauschal- oder Einzelfall\u00ADeinwilligung f\u00FCr die Abfrage der Gesundheitsdaten bei Dritten zur Pr\u00FCfung der Leistungspflicht", name: "daten.einwilligungAbfrageGesundheitsdaten.value", placeholder: "Bitte ausw\u00E4hlen", tooltip: function () { return dispatch(toggleModal(i18next.t('schweigepflicht.title_tt'))); }, onChange: onChange, className: "my-5" })));
};

const VpmsEinwilligungAbfrageGesundheitsdaten = _ref => {
  let {
    onChange,
    error
  } = _ref;
  const dispatch = useDispatch();
  const einwilligungAbfrageGesundheitsdaten = useSelector(state => state.daten.einwilligungAbfrageGesundheitsdatenMetaInfo);
  if (!einwilligungAbfrageGesundheitsdaten.relevant) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(FormSelect, _extends({}, einwilligungAbfrageGesundheitsdaten, {
    title: "Entscheiden Sie sich f\xFCr eine Pauschal- oder Einzelfall\xADeinwilligung f\xFCr die Abfrage der Gesundheitsdaten bei Dritten zur Pr\xFCfung der Leistungspflicht",
    name: "daten.einwilligungAbfrageGesundheitsdatenMetaInfo.value",
    placeholder: "Bitte ausw\xE4hlen",
    tooltip: () => dispatch(toggleModal(i18next.t('schweigepflicht.title_tt'))),
    onChange: onChange,
    className: "my-5",
    error: error
  }));
};

const VpmsErklaerungTodesfall = _ref => {
  let {
    onChange,
    error
  } = _ref;
  const erklaerungTodesfall = useSelector(state => state.daten.erklaerungTodesfallMetaInfo || {});
  if (!erklaerungTodesfall.relevant) {
    return null;
  }
  return erklaerungTodesfall.relevant && /*#__PURE__*/React__default.createElement(FormWrapper$1, {
    title: "Sie stimmen der Abfrage von Gesundheitsdaten bei Dritten auch im Todesfall zu",
    name: "daten.erklaerungTodesfallMetaInfo.label"
  }, /*#__PURE__*/React__default.createElement(FormCheck, _extends({}, erklaerungTodesfall, {
    title: "Jetzt zustimmen",
    name: "daten.erklaerungTodesfallMetaInfo.value",
    onChange: onChange,
    error: error
  })));
};

var AbfrageGesundheitsdatenLink = function () { return (jsx$1(SummingUpButtonLink$1, { href: i18next.t('schweigepflicht.gesundheitsdatenLink'), title: "Abfrage von Gesundheitsdaten bei Dritten", icon: (jsx$1(SvgPdf, { style: { height: '2rem', width: '2rem', marginRight: '5px' } })) })); };

export { AbfrageGesundheitsdatenLink, AbweichenderREFormRadio, index$b as Accordion, AdresseForm$1 as AdresseForm, VersicherungspaketeAngaben as Angaben, SvgAngebot as Angebot, Antragsunterlagen$1 as Antragsunterlagen, Api, SvgArrow as Arrow, ArrowButton$1 as ArrowButton, SvgArrowLeft as ArrowLeft, SvgAtSolid as At, AutomatischSpeichernModal, BankBemerkungFormText, BankDatenschutzFormCheck, BankIbanFormKonto, BankIbanFormMask, BankInhaberFormInput, BankSepaFormCheck, BankZahlartFormRadio, BeantragenWiderrufsbelehrung, BedingungsvergleichButton, BegleitdatenModalNeuesModell, SvgBeispielrechnung as Beispielrechnung, SvgBerater as Berater, BeraterModal, BeraterModalWindow, Beratungsverzicht, BerufesucheV2, SvgBike as Bike, BlockTrackable, SvgBook as Book, index as Bootstrap, ButtonMehrErfahren, SvgCalendar as Calendar, CaptchaFormInput, SvgCar as Car, index$c as Collapsible, ConfirmationModal, SvgCookie as Cookie, DatenschutzFormCheck, DatePicker as Datepicker, DokumenteFileUpload, SvgDokumentensuche as Dokumentensuche, DruckenModal, EinwilligungAbfrageGesundheitsdaten, SvgEmail as Email, EnumActions, EnumEuBeratungKontakt, EnumJaNein, EnumMandant, EnumTarifart, EnumVersicherungsart, EnumVkanal, EnumVorgangsart, EnumZahlart, EnumZahlweise, ErklaerungTodesfall, index$d as ErrorBoundary, ErrorToast, ErsteDatenGeburtsdatumFormMask, ErsteDatenPlzFormMask, ErsteDatenVersBeginnFormDatepicker, SvgExclamation as Exclamation, SvgEyeSolid as Eye, FehlerModal, SvgFileArrowUpSolid as FileArrowUp, SvgFilePdf as FileTypePDF, FileUpload, SvgFilter as Filter, FondsCombobox, FondsTable, SvgFondsinformation as Fondsinformation, FormCheck, FormCheckGroup, FormCombobox, FormDatePicker, FormInput, FormKonto$1 as FormKonto, FormMask, FormMoney, FormRadio, FormRadioButtonGroup, FormRadioGroup, FormRadioIcons, FormSelect, FormSlider, FormSwitch, FormText, FormWrapper$1 as FormWrapper, GlobalMsgModal, HeadNavigation, Headline$1 as Headline, Highlighter, IconButton$1 as IconButton, If$1 as If, IfilialePartnerDatenschutz, SvgInfoIconI as InfoI, SvgInfoIcon as InfoQ, InlineTrackable, InputMask, index$8 as LoadingIndicator, SvgMapMarker as MapMarker, Message$1 as Message, Modal, SvgNeuordnung as Neuordnung, NeuordnungModal, Nowrap, index$a as OEVFooter, SvgPdf as PDF, SvgPartner as Partner, PdfActionButtons, SvgPenToSquareSolid as PenToSquare, PersonAdresseBlock, PersonAnredeFormRadio, PersonEmailFormInput, PersonGeburtsdatumFormMask, PersonHausnummerFormInput, PersonNachnameFormInput, PersonOrtFormInput, PersonPlzFormMask, PersonStaatsangehoerigkeitFormSelect, PersonStrasseFormInput, PersonTelefonFormInput, PersonTitelFormSelect, PersonVornameFormInput, PersonZustellvermerkFormInput, Pflichtfelder, PrevNextButtons as PrevNextButton, SvgPrint as Print, index$6 as ProductCarousel, ProduktAuflistung, ProduktAuflistungWrapper, ProduktStern, ProduktauswahlButton$1 as ProduktauswahlButton, index$5 as Produktbaustein, ProduktvergleichAngebotsdruck$1 as ProduktvergleichAngebotsdruck, ProduktvergleichBeitrag, ProduktvergleichBeitragBetrag, ProduktvergleichBeitragHeadline, ProduktvergleichBeratersuche$1 as ProduktvergleichBeratersuche, ProduktvergleichBeratersucheModal$1 as ProduktvergleichBeratersucheModal, ProduktvergleichProduktblaetter$1 as ProduktvergleichProduktblaetter, ProduktvergleichZahlweiseFormSelect, ProgressbarAnimation$1 as ProgressbarAnimation, ProgressbarNavigation, QesButton, Queue, RechnungsempfaengerRadio, ResponsiveCarousel$1 as ResponsiveCarousel, Ribbon$1 as Ribbon, Routing, SvgSave as Save, SaveStateModal, Schweigepflichtentbindungserklaerung, SvgSearch as Search, SvgSepaLogo as Sepa, index$2 as SepaLogo, SvgShield as Shield, SvgShoppingCart as Shopping, index$3 as Siegel, RCSlider as Slider, SpeicherButton, SpkButtons, SvgStar as Star, SummingUp$1 as SummingUp, SummingUpButtonLink$1 as SummingUpButtonLink, SummingUpKundendaten, SummingUpVersichertePerson, SvgSyncSolid as Sync, Tab$1 as Tab, SvgTelefon as Telefon, TextLinkButton$1 as TextLinkButton, Tooltip, TooltipList$1 as TooltipList, TooltipModal, SvgTrashSolid as Trash, TypeaheadInput$1 as TypeaheadInput, UnterschriebenAmDatepicker$1 as UnterschriebenAmDatepicker, UnterschriebenCheckbox, UnterschriftHeadline$1 as UnterschriftHeadline, SvgUserSolid as User, SvgUserMinusSolid as UserMinus, SvgUserPlusSolid as UserPlus, index$7 as VVGModal, index$9 as VersionInfo, Vertreter$1 as Vertreter, Vertreterauswahl, Vertretersuchform, Vorgangsanlage, VorgangsanlageButton, VorgangsanlageButtonContent, VorgangsanlageButtonDownload, VorversicherungAuswahlFormRadio, VorversicherungVSNRFormInput, VpmsBankIbanFormMask, VpmsBankInhaberFormInput, VpmsBankSepaFormCheck, VpmsDatenschutzFormCheck, VpmsEinwilligungAbfrageGesundheitsdaten, VpmsErklaerungTodesfall, VpmsVertreterauswahl, VpmsVertretersuchform, index$4 as Warenkorb, ZusammenfassungErklaerung, ZusammenfassungPartner, Zwischenspeichern$1 as Zwischenspeichern, actions, requests as appActions, blobToPDF, breakpoints, checkError, DotObject as dotObject, dotProp, findBaustein, findValueById, getAge, getSessionId, handleLokalSpeichern, handleSession, handleTimeout, i18nInitGenerator, initState, isEmptyObj, istEnumAuswahl, istJaAuswahl, istNeinAuswahl, istNichtEnumAuswahl, index$e as locale, logger, metaInfoPropTypesGenerator, neutralizeBack, onEnter, reduceObj, removeMetaInfo, replaceEURinValueSet, replaceErrorWithComponent, savedStateManager, scrollToError, setBeratersuche, setBeratersucheVpms, spkScrollTo, store, toMoney, toMoneyWOComma, trEnv$1 as trEnv, tracker, updateWindowHeightForIF, useBreadcrumb, useBreakpoint, useGetPageinfo, useGotoPage, useModifyPages, useNextPage, useOnScreen, usePageIndex, usePrevPage, useProduktBausteinHoehe, useSetActivePage, useSetBreadcrumb, useUpdateAndBerechneOnChange, useUpdateAndValidateDateOnChange, useUpdateAndValidateDateOnChangeByList, useUpdateAndValidateIBANOnChange, useUpdateAndValidateOnChange, useUpdateAndValidateOnChangeByList, useUpdateAndValidatePlzOnChange, useUpdateByEventAndValidateOnChangeByList, useUpdateByNameAndBerechneOnChange, useUpdateByNameAndValidateOnChange, useUpdateByNameAndValidateOnChangeByList, useValidateOnBlur, uuid };
//# sourceMappingURL=index.js.map
